import "./module.css";
import {jsx as $hopDi$jsx, jsxs as $hopDi$jsxs, Fragment as $hopDi$Fragment} from "react/jsx-runtime";
import $hopDi$react, {useEffect as $hopDi$useEffect, Suspense as $hopDi$Suspense, useState as $hopDi$useState, useRef as $hopDi$useRef, useCallback as $hopDi$useCallback, createElement as $hopDi$createElement, forwardRef as $hopDi$forwardRef, useImperativeHandle as $hopDi$useImperativeHandle} from "react";
import {BrowserRouter as $hopDi$BrowserRouter, Switch as $hopDi$Switch, Route as $hopDi$Route, useLocation as $hopDi$useLocation, useHistory as $hopDi$useHistory} from "react-router-dom";
import {removeClassesForHidingElements as $hopDi$removeClassesForHidingElements, Route404 as $hopDi$Route404, Global404Certs as $hopDi$Global404Certs, hideElementsFromHostApp as $hopDi$hideElementsFromHostApp, usePendo as $hopDi$usePendo, useIsTouchDevice as $hopDi$useIsTouchDevice, useResponsiveValueRedux as $hopDi$useResponsiveValueRedux, Logger as $hopDi$Logger, getRandomString as $hopDi$getRandomString, useOutsideClickEffect as $hopDi$useOutsideClickEffect, useHorizontalSwipe as $hopDi$useHorizontalSwipe, useAvoidFirstRender as $hopDi$useAvoidFirstRender, localize as $hopDi$localize, debounce as $hopDi$debounce, DEFAULT_INPUT_DEBOUNCE_DELAY as $hopDi$DEFAULT_INPUT_DEBOUNCE_DELAY, useLocalize as $hopDi$useLocalize, isInViewport as $hopDi$isInViewport, getCookie as $hopDi$getCookie, setCookieDaysTillExpired as $hopDi$setCookieDaysTillExpired, pluralizeString as $hopDi$pluralizeString, useDetectScroll as $hopDi$useDetectScroll} from "@saviynt/common";
import {OverlayProviderWrapper as $hopDi$OverlayProviderWrapper, AlertBannerProvider as $hopDi$AlertBannerProvider, ModalIsland as $hopDi$ModalIsland, Button as $hopDi$Button, Box as $hopDi$Box, Typography as $hopDi$Typography, SidePanel as $hopDi$SidePanel, useScrollbarWidth as $hopDi$useScrollbarWidth, Loader as $hopDi$Loader, ApplicationIcon as $hopDi$ApplicationIcon, ButtonIcon as $hopDi$ButtonIcon, Icon as $hopDi$Icon, Avatar as $hopDi$Avatar, MobileDrawer as $hopDi$MobileDrawer, TabContent as $hopDi$TabContent, TabGroup as $hopDi$TabGroup, TabItem as $hopDi$TabItem, ButtonSelect as $hopDi$ButtonSelect, Badge as $hopDi$Badge, Link as $hopDi$Link, ButtonCore as $hopDi$ButtonCore, Menu as $hopDi$Menu, Checkbox as $hopDi$Checkbox, InlineMessage as $hopDi$InlineMessage, InputField as $hopDi$InputField, MobileDrawerItem as $hopDi$MobileDrawerItem, MenuMulti as $hopDi$MenuMulti, RadioButton as $hopDi$RadioButton, MenuNested as $hopDi$MenuNested, MenuNestedItem as $hopDi$MenuNestedItem, Tooltip as $hopDi$Tooltip, Popover as $hopDi$Popover, Chip as $hopDi$Chip, FooterActionBar as $hopDi$FooterActionBar, StackingAlertBanner as $hopDi$StackingAlertBanner, DateAndTimePicker as $hopDi$DateAndTimePicker, AlertBanner as $hopDi$AlertBanner, MenuInput as $hopDi$MenuInput, Color as $hopDi$Color, ToggleButtonGroup as $hopDi$ToggleButtonGroup, ToggleButton as $hopDi$ToggleButton, useUploadFile as $hopDi$useUploadFile, Upload as $hopDi$Upload} from "@saviynt/design-system";
import {IntlProvider as $hopDi$IntlProvider, useIntl as $hopDi$useIntl} from "react-intl";
import $hopDi$proptypes from "prop-types";
import {Cookies as $hopDi$Cookies} from "react-cookie";
import {useDispatch as $hopDi$useDispatch, useSelector as $hopDi$useSelector} from "react-redux";
import $hopDi$classnames from "classnames";
import $hopDi$lottiereact from "lottie-react";
import $hopDi$momenttimezone from "moment-timezone";
import $hopDi$reactdom from "react-dom";
import $hopDi$axios from "axios";
import $hopDi$moment from "moment";
import {Draggable as $hopDi$Draggable, DragDropContext as $hopDi$DragDropContext, Droppable as $hopDi$Droppable} from "react-beautiful-dnd";
import $hopDi$reactsignaturecanvas from "react-signature-canvas";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}









function $4b5d3b67c109436c$var$LocalizedWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$IntlProvider), {
        locale: "en",
        children: children
    });
}
$4b5d3b67c109436c$var$LocalizedWrapper.propTypes = {
    children: (0, $hopDi$proptypes).node.isRequired
};
var $4b5d3b67c109436c$export$2e2bcd8739ae039 = $4b5d3b67c109436c$var$LocalizedWrapper;


/**
 * Function wraps the hideHostElements function from common.
 * If anything changes (flag, etc), only this file needs to be updated.
 *
 * @function hideHostElementsWrapper
 * @returns {void}
 */ 
const $8420256091f3759b$var$hideHostElementsWrapper = ()=>{
    (0, $hopDi$hideElementsFromHostApp)(false, "certGen2Flag", "1");
};
var $8420256091f3759b$export$2e2bcd8739ae039 = $8420256091f3759b$var$hideHostElementsWrapper;
const $8420256091f3759b$export$9bc070677037150b = ()=>{
    const dynamicbody = document.getElementsByClassName("dynamicModules")[0];
    if (dynamicbody) dynamicbody.classList.remove("d-block");
};


/* eslint-disable indent */ 









var $f8655c22d1282573$exports = {};
$f8655c22d1282573$exports = JSON.parse('{"nm":"Flow 1","ddd":0,"h":192,"w":192,"meta":{"g":"LottieFiles Figma v67"},"layers":[{"ty":4,"nm":"Green check","sr":1,"st":0,"op":170.97,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[18,18],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[18,18],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[18,18],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[18,18],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[18,18],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[18,18],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[18,18],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[18,18],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[18,18],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[18,18],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[18,18],"t":170},{"s":[18,18],"t":182}]},"s":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100,100],"t":170},{"s":[100,100],"t":182}]},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,119],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,119],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,119],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,119],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,119],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,119],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,119],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,101.55],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,103.09],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,103],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,103],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,103],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,120.45],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,118.91],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,119],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[96,119],"t":170},{"s":[96,119],"t":182}]},"r":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[0],"t":170},{"s":[0],"t":182}]},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[99.46],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0.54],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[0],"t":170},{"s":[0],"t":182}]}},"shapes":[{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.93938],[9.9394,0],[0,9.9394],[-9.93938,0]],"o":[[9.9394,0],[0,9.9394],[-9.93938,0],[0,-9.93938],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-9.94],[9.94,0],[0,9.94],[-9.94,0]],"o":[[9.94,0],[0,9.94],[-9.94,0],[0,-9.94],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[0,-9.94],[9.94,0],[0,9.94],[-9.94,0]],"o":[[9.94,0],[0,9.94],[-9.94,0],[0,-9.94],[0,0]],"v":[[18,0],[36,18],[18,36],[0,18],[18,0]]}],"t":182}]}},{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.7509200000000007,0.751100000000001],[-0.7455999999999996,-0.7462],[0,0],[0,0],[-0.7508999999999979,-0.7510999999999992],[0.75,-0.75],[0,0],[0.7508999999999997,0.7510999999999974],[0.019899999999999807,0.02190000000000225]],"o":[[0,0],[-0.750770000000001,-0.7512000000000008],[0.7510699999999986,-0.7508999999999997],[0,0],[0,0],[0.751100000000001,-0.7510999999999992],[0.751100000000001,0.7508999999999997],[0,0],[-0.75,0.75],[-0.021099999999998786,-0.021100000000000563],[0,0]],"v":[[14.2621,23.8465],[9.85523,19.436],[9.85523,16.7087],[12.5824,16.7087],[15.6892,19.818],[23.4179,12.0893],[26.145,12.0893],[26.145,14.8165],[17.0506,23.9109],[14.3234,23.9109],[14.2621,23.8465]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[-0.75,0.75],[-0.75,-0.75],[0,0],[0,0],[-0.75,-0.75],[0.75,-0.75],[0,0],[0.75,0.75],[0.02,0.02]],"o":[[0,0],[-0.75,-0.75],[0.75,-0.75],[0,0],[0,0],[0.75,-0.75],[0.75,0.75],[0,0],[-0.75,0.75],[-0.02,-0.02],[0,0]],"v":[[14.26,23.85],[9.86,19.44],[9.86,16.71],[12.58,16.71],[15.69,19.82],[23.42,12.09],[26.15,12.09],[26.15,14.82],[17.05,23.91],[14.32,23.91],[14.26,23.85]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[0,0],[-0.75,0.75],[-0.75,-0.75],[0,0],[0,0],[-0.75,-0.75],[0.75,-0.75],[0,0],[0.75,0.75],[0.02,0.02]],"o":[[0,0],[-0.75,-0.75],[0.75,-0.75],[0,0],[0,0],[0.75,-0.75],[0.75,0.75],[0,0],[-0.75,0.75],[-0.02,-0.02],[0,0]],"v":[[14.26,23.85],[9.86,19.44],[9.86,16.71],[12.58,16.71],[15.69,19.82],[23.42,12.09],[26.15,12.09],[26.15,14.82],[17.05,23.91],[14.32,23.91],[14.26,23.85]]}],"t":182}]}},{"ty":"fl","bm":0,"hd":false,"nm":"","c":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0.7295,0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0.7295,0],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0.7295,0],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0.7295,0],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[0,0.7295,0],"t":170},{"s":[0,0.7295,0],"t":182}]},"r":2,"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100],"t":170},{"s":[100],"t":182}]}}],"ind":1},{"ty":4,"nm":"Union","sr":1,"st":0,"op":170.97,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[56,70],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[56,70],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[56,70],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[56,70],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[56,70],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[56,70],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[56,70],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[56,70],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[56,70],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[56,70],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[56,70],"t":170},{"s":[56,70],"t":182}]},"s":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100,100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100,100],"t":170},{"s":[100,100],"t":182}]},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,96],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,96],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[96,96],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[96,96],"t":170},{"s":[96,96],"t":182}]},"r":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[-90],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[-90],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[8.16],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[-0.49],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0.01],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[-98.16],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[-89.51],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[-90.01],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[-90],"t":170},{"s":[-90],"t":182}]},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100],"t":170},{"s":[100],"t":182}]}},"shapes":[{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.1060300000000005],[0,0],[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0]],"o":[[-5.15466,0],[0,0],[0,5.1059999999999945],[0,0],[5.153999999999996,0],[0,0],[0,-5.10603],[0,0],[0,0]],"v":[[9.33334,0],[0,9.24529],[0,130.755],[9.33334,140],[102.667,140],[112,130.755],[112,9.24528],[102.667,0],[9.33334,0]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,-5.11],[0,0],[-5.15,0],[0,0],[0,5.11],[0,0],[5.15,0],[0,0]],"o":[[-5.15,0],[0,0],[0,5.11],[0,0],[5.15,0],[0,0],[0,-5.11],[0,0],[0,0]],"v":[[9.33,0],[0,9.25],[0,130.76],[9.33,140],[102.67,140],[112,130.76],[112,9.25],[102.67,0],[9.33,0]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[0,-5.11],[0,0],[-5.15,0],[0,0],[0,5.11],[0,0],[5.15,0],[0,0]],"o":[[-5.15,0],[0,0],[0,5.11],[0,0],[5.15,0],[0,0],[0,-5.11],[0,0],[0,0]],"v":[[9.33,0],[0,9.25],[0,130.76],[9.33,140],[102.67,140],[112,130.76],[112,9.25],[102.67,0],[9.33,0]]}],"t":182}]}},{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.7363800000000005,0],[0,0],[0,-0.7294299999999989],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0]],"o":[[0,-0.7294400000000003],[0,0],[0.7360000000000042,0],[0,0],[0,0.7290000000000134],[0,0],[-0.7363800000000005,0],[0,0],[0,0]],"v":[[8,9.24529],[9.33334,7.92453],[102.667,7.92453],[104,9.24528],[104,130.755],[102.667,132.075],[9.33334,132.075],[8,130.755],[8,9.24529]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-0.74,0],[0,0],[0,-0.73],[0,0],[0.74,0],[0,0],[0,0.73],[0,0]],"o":[[0,-0.73],[0,0],[0.74,0],[0,0],[0,0.73],[0,0],[-0.74,0],[0,0],[0,0]],"v":[[8,9.25],[9.33,7.92],[102.67,7.92],[104,9.25],[104,130.76],[102.67,132.07],[9.33,132.07],[8,130.76],[8,9.25]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[-0.74,0],[0,0],[0,-0.73],[0,0],[0.74,0],[0,0],[0,0.73],[0,0]],"o":[[0,-0.73],[0,0],[0.74,0],[0,0],[0,0.73],[0,0],[-0.74,0],[0,0],[0,0]],"v":[[8,9.25],[9.33,7.92],[102.67,7.92],[104,9.25],[104,130.76],[102.67,132.07],[9.33,132.07],[8,130.76],[8,9.25]]}],"t":182}]}},{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.2090999999999994,0],[0,0],[0,-2.209000000000003],[2.2091000000000065,0],[0,0],[0,2.209000000000003]],"o":[[0,-2.209000000000003],[0,0],[2.2091000000000065,0],[0,2.209000000000003],[0,0],[-2.2090999999999994,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[-2.21,0],[0,0],[0,-2.21],[2.21,0],[0,0],[0,2.21]],"o":[[0,-2.21],[0,0],[2.21,0],[0,2.21],[0,0],[-2.21,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[-2.21,0],[0,0],[0,-2.21],[2.21,0],[0,0],[0,2.21]],"o":[[0,-2.21],[0,0],[2.21,0],[0,2.21],[0,0],[-2.21,0],[0,0]],"v":[[28,118],[32,114],[80,114],[84,118],[80,122],[32,122],[28,118]]}],"t":182}]}},{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.418300000000002],[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0]],"o":[[4.418300000000002,0],[0,-4.418299999999999],[-4.418300000000002,0],[0,4.418300000000002],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,4.42],[4.42,0],[0,-4.42],[-4.42,0]],"o":[[4.42,0],[0,-4.42],[-4.42,0],[0,4.42],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":170},{"s":[{"c":true,"i":[[0,0],[0,4.42],[4.42,0],[0,-4.42],[-4.42,0]],"o":[[4.42,0],[0,-4.42],[-4.42,0],[0,4.42],[0,0]],"v":[[56,38],[64,30],[56,22],[48,30],[56,38]]}],"t":182}]}},{"ty":"fl","bm":0,"hd":false,"nm":"","c":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0,0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0,0],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0,0],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0,0],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0,0],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0,0],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0,0,0],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0,0,0],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0,0,0],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[0,0,0],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[0,0,0],"t":170},{"s":[0,0,0],"t":182}]},"r":2,"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":56.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":57},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":69},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":83.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":98.77022171020508},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":113},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":113.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":125},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":139.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":154.77022171020508},{"o":{"x":1,"y":1},"i":{"x":1,"y":1},"s":[100],"t":169.65533256530762},{"o":{"x":0,"y":0},"i":{"x":1,"y":1},"s":[100],"t":170},{"s":[100],"t":182}]}}],"ind":2},{"ty":4,"nm":"One Bg","sr":1,"st":0,"op":170.97,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":41.77022171020508},{"s":[96,96],"t":56.65533256530762}]},"s":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100,100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100,100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100,100],"t":41.77022171020508},{"s":[100,100],"t":56.65533256530762}]},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[96,96],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[96,96],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[96,96],"t":41.77022171020508},{"s":[96,96],"t":56.65533256530762}]},"r":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[0],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[0],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[0],"t":41.77022171020508},{"s":[0],"t":56.65533256530762}]},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"s":[100],"t":56.65533256530762}]}},"shapes":[{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":41.77022171020508},{"s":[{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[192,0],[192,192],[0,192],[0,0]]}],"t":56.65533256530762}]}},{"ty":"fl","bm":0,"hd":false,"nm":"","c":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[1,1,1],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[1,1,1],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[1,1,1],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[1,1,1],"t":41.77022171020508},{"s":[1,1,1],"t":56.65533256530762}]},"r":1,"o":{"a":1,"k":[{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":0},{"o":{"x":0,"y":0},"i":{"x":1.11,"y":1.11},"s":[100],"t":12},{"o":{"x":1.11,"y":1.11},"i":{"x":0.99,"y":0.99},"s":[100],"t":26.88511085510254},{"o":{"x":0.99,"y":0.99},"i":{"x":1,"y":1},"s":[100],"t":41.77022171020508},{"s":[100],"t":56.65533256530762}]}}],"ind":3}],"v":"5.7.0","fr":60,"op":169.97,"ip":0,"assets":[]}');


const $20281fe09bc700a8$export$994f7af6d0b36256 = {
    USER: "-4",
    ROLE: "-2",
    ACCOUNT: "0",
    ENTITLEMENT: 1
};
const $20281fe09bc700a8$export$758743ec42a300f1 = {
    TILE: "detailsTile",
    FOOTER: "sidePanelFooter"
};
const $20281fe09bc700a8$export$3f43cf8434698562 = {
    APPROVE: "approve",
    REJECT: "reject",
    TERMINATE: "terminated",
    REASSIGN: "reassign",
    CONSULT: "consult",
    WORKS_FOR_ME: "worksForMe",
    DOES_NOT_WORK_FOR_ME: "doesNotWorksForMe",
    EXTEND_END_DATE: "extendEndDate",
    CONDITIONAL_CERTIFIY: "conditionalCertifiy"
};
const $20281fe09bc700a8$export$6bf521f24032eb49 = {
    NO_ACTION: -1,
    RESET: 0,
    WORKS_FOR_ME: 2,
    APPROVE: 2,
    REVOKED: 3,
    TERMINATED: 4,
    CONDITIONAL_CERTIFIY: 5,
    EXTEND_END_DATE: 6
};
const $20281fe09bc700a8$export$506bde9fe967e89b = {
    CHECK: "Check",
    EXTEND_END_DATE: "ExtendEndDate",
    CONSULT: "Consult",
    APPROVE: "approve",
    REJECT: "reject",
    TERMINATE: "terminate",
    REASSIGN_USER: "reassignUser",
    REASSIGN_ITEM: "reassignItem",
    CONFIRM_MANAGER: "confirmManager",
    CHANGE_END_DATE: "changeEndDate",
    CONSULT_WITH_PEERS: "consultWithPeers"
};
const $20281fe09bc700a8$export$523985e6ca7aa3bf = {
    TITLE: "Terminate User and Access?",
    DESC: "Do you want to terminate this user and revoke all their access?",
    SUBDESC: "Termination won\u2019t be fulfilled right away. It\u2019ll take effect after you finish your review and submit.",
    NOTE: "If you don\u2019t submit by the due date, termination will occur automatically at that time.",
    PLACEHOLDER: "Provide a reason for your decision",
    PRIMARYBUTTON: "Terminate",
    SECONDARYBUTTON: "Cancel"
};
const $20281fe09bc700a8$export$170ce1a49c989948 = {
    TITLE: "Reject this ",
    DESC: "Access won\u2018t be removed right away. It\u2019ll take effect after you finish your review and submit.",
    NOTE: "If you don\u2019t submit by the due date, access will be removed automatically at that time.",
    PRIMARYBUTTON: "Reject",
    SECONDARYBUTTON: "Got it",
    CANCELBUTTON: "Cancel"
};
const $20281fe09bc700a8$export$80dc2c0ddeaedcb2 = {
    DOES_NOT_WORK_FOR_ME: "DOES NOT WORK FOR ME",
    WORKS_FOR_ME: "WORKS FOR ME",
    NORESPONSE: "NORESPONSE",
    TERMINATED: "TERMINATED",
    REASSIGN: "RE-ASSIGN",
    EXTEND_END_DATE: "EXTEND_END_DATE"
};
const $20281fe09bc700a8$export$69894cdd9841cdfb = {
    APPROVE: "YES",
    REJECT: "NO",
    NORESPONSE: "NORESPONSE",
    REASSIGN: "RE-ASSIGN",
    REASSIGNSTEP2: "REASSIGNSTEP2"
};
const $20281fe09bc700a8$export$9612f125f9c1cfb7 = {
    CONSULT_POPOVER: "show_consultPopover",
    REASSIGN: "show_reassignWarnModal",
    CONSULT_WARN: "show_consultWarnModal",
    AUTO_REVOKE_WARN: "shouldNotShow_autoRevokeWarnBanner_"
};
const $20281fe09bc700a8$export$684f6d0b3182db31 = {
    APPROVE: "APPROVE",
    REJECT: "REJECT",
    WORKS_FOR_ME: "CONFIRM",
    DOES_NOT_WORK_FORME_WITHOUT_REASSIGNMENT: "DOESNOTWORKFORMEWITHOUTREASSIGNMENT",
    DOES_NOT_WORK_FOR_ME: "DOESNOTWORKFORMEWITHREASSIGNMENT",
    REASSIGN: "REASSIGNACCESS",
    CONSULT: "CONSULT",
    TERMINATE: "TERMINATE",
    EXTEND_END_DATE_USERS: "EXTENDENDDATEFORUSERS",
    EXTENDENDDATEFORACCESS: "EXTENDENDDATEFORACCESS",
    REVIEWANDSUBMIT: "REVIEWANDSUBMIT"
};








/* eslint-disable camelcase */ /* eslint-disable consistent-return */ /* eslint-disable indent */ 

const $d60257e8dc27bf16$export$7219e4813ca4abf0 = "Application";
const $d60257e8dc27bf16$export$1cc98074061c90d2 = "User";
const $d60257e8dc27bf16$export$7d6712c2cb8377b2 = "Role";
const $d60257e8dc27bf16$export$153ab95c08227093 = "Account";
const $d60257e8dc27bf16$export$be9a3074cb3ae0c7 = "Entitlement";
const $d60257e8dc27bf16$export$994f7af6d0b36256 = "CERT_ENTITLEMENT_VALUEKEY";
const $d60257e8dc27bf16$export$dc13af498303679 = "User_DISPLAYNAME";
const $d60257e8dc27bf16$export$76f2b9e2abf8cf0c = "User description";
const $d60257e8dc27bf16$export$669183101cc88fb6 = "Role_DISPLAYNAME";
const $d60257e8dc27bf16$export$71193c4d5e3b3956 = "LASTCERTIFIEDCAMPAIGNNAME";
const $d60257e8dc27bf16$export$843e8b0030038872 = "Account_DISPLAYNAME";
const $d60257e8dc27bf16$export$c0a9d10def3a6309 = "Account_DESCRIPTION";
const $d60257e8dc27bf16$export$9dee3ced165b51d1 = "Ent_DISPLAYNAME";
const $d60257e8dc27bf16$export$6940d0d32ae129a1 = "Ent_DESCRIPTION";
const $d60257e8dc27bf16$export$bde14d5a1cbdb371 = "tab_summary";
const $d60257e8dc27bf16$export$9b67fda1e37e6e63 = "tab_history";
const $d60257e8dc27bf16$export$a06b6c2be556dac8 = "tab_privilege";
const $d60257e8dc27bf16$export$6cc684447a8d7b17 = "tab_entitlement";
const $d60257e8dc27bf16$export$51f82826650bc3c3 = "tab_children";
const $d60257e8dc27bf16$export$ed0bf72b1f4a9681 = "tab_dependent";
const $d60257e8dc27bf16$export$8f78881bb4058858 = "tab_sod";
const $d60257e8dc27bf16$export$d66151c7af00715f = "tab_menu";


const $d44c789d5b60f9bf$export$48ae29ec3f91ef49 = "TAB_STATUS_TODO";
const $d44c789d5b60f9bf$export$807a0bc890800408 = "TAB_STATUS_DONE";
const $d44c789d5b60f9bf$export$d5eea126dff5a615 = "TAB_STATUS_ALL";
const $d44c789d5b60f9bf$export$b2766b46106d3053 = "TAB_STATUS_CONS";


/* eslint-disable import/prefer-default-export */ /* eslint-disable no-param-reassign */ 




const $135adfecc1ed8f07$export$49390a4605a2336a = {
    LIGHT: "light",
    DARK: "dark"
};
const $135adfecc1ed8f07$export$f9b8d04d2b2b982f = {
    APPROVE: "APPROVE",
    REJECT: "REJECT",
    WORKS_FOR_ME: "CONFIRM",
    DOES_NOT_WORK_FOR_ME: "DOESNOTWORKFORMEWITHREASSIGNMENT",
    REASSIGN: "REASSIGNACCESS",
    CONSULT: "CONSULT",
    BULKACTION: "BULKACTION"
};
const $135adfecc1ed8f07$export$be78a55db3e4bce5 = "MobileLarge";
const $135adfecc1ed8f07$export$1cc96dc9f9fe057a = "MobileXLarge";
const $135adfecc1ed8f07$export$fb1abf44d8c33b97 = "TabletXSmall";
const $135adfecc1ed8f07$export$6e89092ed3d96394 = "TabletSmall";
const $135adfecc1ed8f07$export$e1d684fb703347f = "TabletMedium";
const $135adfecc1ed8f07$export$a470274a05d4e556 = "DesktopSmall";
const $135adfecc1ed8f07$export$12bfde30afe7dcf1 = [
    {
        query: "(max-width: 479px)",
        value: 120,
        label: $135adfecc1ed8f07$export$be78a55db3e4bce5
    },
    {
        query: "(max-width: 599px)",
        value: 110,
        label: $135adfecc1ed8f07$export$1cc96dc9f9fe057a
    },
    {
        query: "(max-width: 767px)",
        value: 100,
        label: $135adfecc1ed8f07$export$fb1abf44d8c33b97
    },
    {
        query: "(max-width: 833px)",
        value: 90,
        label: $135adfecc1ed8f07$export$6e89092ed3d96394
    },
    {
        query: "(max-width: 899px)",
        value: 80,
        label: $135adfecc1ed8f07$export$e1d684fb703347f
    },
    {
        query: "(max-width: 1279px)",
        value: 50,
        label: $135adfecc1ed8f07$export$a470274a05d4e556
    }
];
const $135adfecc1ed8f07$export$f0065dd01c1d9ed2 = {
    UP: "up",
    DOWN: "down"
};
const $135adfecc1ed8f07$export$80936d44d15279d1 = {
    SUCCESS: "Success",
    CRITICAL: "Critical"
};
const $135adfecc1ed8f07$export$de87879afd52ccf9 = (0, $hopDi$proptypes).oneOfType([
    (0, $hopDi$proptypes).func,
    (0, $hopDi$proptypes).shape({
        current: (0, $hopDi$proptypes).instanceOf(Element)
    })
]);
const $135adfecc1ed8f07$export$f688697617dd0589 = 100;
const $135adfecc1ed8f07$export$510f63ad8e5b2cec = [
    "Account_CREATED_ON",
    "Role_UPDATEDATE",
    "Account_LASTLOGONDATE",
    "User_STARTDATE",
    "User_ENDDATE",
    "Account_PASSWORDLOCKDATE",
    "Ent_LASTSCANDATE",
    "Account_UPDATEDATE",
    "User_EXTENDEDENDDATE",
    "UPDATEDATE",
    "CREATEDATE",
    "LASTREVIEWEDDATE",
    "LASTCERTIFIED",
    "Ent_LASTREVIEWEDDATE",
    "Ent_UPDATEDATE",
    "User_UPDATEDATE",
    "User_CREATEDATE",
    "User_TERMDATE",
    "User_SOURCELASTLOGINDATE",
    "User_LASTSYNCDATE",
    "LASTUSEDENDDATE",
    "User_LASTCERTIFIEDDATE"
];
const $135adfecc1ed8f07$export$819c6a8205c73110 = {
    "MM/dd/yyyy HH:mm:ss": "MM/DD/yyyy HH:mm:ss",
    "MM/dd/yy": "MM/DD/YY"
};
const $135adfecc1ed8f07$export$9f3245bec405e186 = {
    certs: {
        // Custom Keys added
        NOT_PROVIDED: {
            ATTESTATIONS: {
                id: "NOT_PROVIDED.ATTESTATIONS",
                defaultMessage: "Not Provided"
            }
        },
        UserName: {
            ATTESTATIONS: {
                id: "userName.ATTESTATIONS",
                defaultMessage: "User Name"
            }
        },
        entitlement_value: {
            ATTESTATIONS: {
                id: "entitlement_value.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        entitlement_glossary: {
            ATTESTATIONS: {
                id: "entitlement_glossary.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        entitlement_type: {
            ATTESTATIONS: {
                id: "entitlement_type.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        systemname: {
            ATTESTATIONS: {
                id: "systemname.ATTESTATIONS",
                defaultMessage: "System Name"
            }
        },
        endpointname: {
            ATTESTATIONS: {
                id: "endpointname.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        customproperty1: {
            ATTESTATIONS: {
                id: "customproperty1.ATTESTATIONS",
                defaultMessage: "Custom Property 1"
            }
        },
        "Certificatipn.Unresponded.label": {
            ATTESTATIONS: {
                id: "Certificatipn.Unresponded.label",
                defaultMessage: "Unresponded"
            }
        },
        "Certification.Unresponded.label": {
            ATTESTATIONS: {
                id: "Certification.Unresponded.label",
                defaultMessage: "Unresponded"
            }
        },
        "CR.JRM.NO_RULES_FOUND.Reason.Default.label": {
            ATTESTATIONS: {
                id: "TCR.JRM.NO_RULES_FOUND.Reason.Default.label",
                defaultMessage: "None of the user's attributes correspond to this entitlement"
            }
        },
        "TM.OOB.Unsure.label": {
            ATTESTATIONS: {
                id: "TM.OOB.Unsure.label",
                defaultMessage: "Access provided Outside of Saviynt"
            }
        },
        "TM.OOB.label": {
            ATTESTATIONS: {
                id: "TM.OOB.label",
                defaultMessage: "Access provided from Saviynt"
            }
        },
        "TM.LastCert.Less3months.label": {
            ATTESTATIONS: {
                id: "TM.LastCert.Less3months.label",
                defaultMessage: "Certified within last 3 months"
            }
        },
        "TM.LastCert.Greater3monthsAndLess6months.label": {
            ATTESTATIONS: {
                id: "TM.LastCert.Greater3monthsAndLess6months.label",
                defaultMessage: "Certified within last 6 months"
            }
        },
        "TM.LastCert.Greater6monthsAndLess9months": {
            ATTESTATIONS: {
                id: "TM.LastCert.Greater6monthsAndLess9months.label",
                defaultMessage: "Certified within last 9 months"
            }
        },
        "TM.LastCert.Greater9monthsAndLess12months.label": {
            ATTESTATIONS: {
                id: "TM.LastCert.Greater9monthsAndLess12months.label",
                defaultMessage: "Certified within last year"
            }
        },
        "TM.LastCert.0monthsDiff.label": {
            ATTESTATIONS: {
                id: "TM.LastCert.0monthsDiff.label",
                defaultMessage: "Certified more than an year ago"
            }
        },
        "TM.LastCert.Unsure.label": {
            ATTESTATIONS: {
                id: "TM.LastCert.Unsure.label",
                defaultMessage: "Data not available for last certified"
            }
        },
        "TM.PAA.label": {
            ATTESTATIONS: {
                id: "TM.PAA.label",
                defaultMessage: "{0} Confidence of Peer Access"
            }
        },
        "TM.PAA.NoData.Unsure.label": {
            ATTESTATIONS: {
                id: "TM.PAA.NoData.Unsure.label",
                defaultMessage: "Data not available to calculate Peer Access Confidence"
            }
        },
        "TM.SOX.Unsure.label": {
            ATTESTATIONS: {
                id: "TM.SOX.Unsure.label",
                defaultMessage: "Data not available for Sox Criticality"
            }
        },
        "TM.SOX.VeryHigh.label": {
            ATTESTATIONS: {
                id: "TM.SOX.VeryHigh.label",
                defaultMessage: "Very High SOX Criticality"
            }
        },
        "TM.SOX.High.label": {
            ATTESTATIONS: {
                id: "TM.SOX.High.label",
                defaultMessage: "High SOX Criticality"
            }
        },
        "TM.SOX.Medium.label": {
            ATTESTATIONS: {
                id: "TM.SOX.Medium.label",
                defaultMessage: "Medium SOX Criticality"
            }
        },
        "TM.SOX.Low.label": {
            ATTESTATIONS: {
                id: "TM.SOX.Low.label",
                defaultMessage: "Low SOX Criticality"
            }
        },
        "TM.SOX.VeryLow.label": {
            ATTESTATIONS: {
                id: "TM.SOX.VeryLow.label",
                defaultMessage: "Very Low SOX Criticality"
            }
        },
        "TM.SOD.NoEntitlement.label": {
            ATTESTATIONS: {
                id: "TM.SOD.NoEntitlement.label",
                defaultMessage: "No SOD found for this Entitlement"
            }
        },
        "TM.SOD.MitigatedLowRisk.label": {
            ATTESTATIONS: {
                id: "TM.SOD.MitigatedLowRisk.label",
                defaultMessage: "Mitigated Low SOD Risk"
            }
        },
        "TM.SOX.MitigatedMediumRisk.label": {
            ATTESTATIONS: {
                id: "TM.SOX.MitigatedMediumRisk.label",
                defaultMessage: "Mitigated Medium SOX Risk"
            }
        },
        "TM.SOD.MitigatedHighRisk.label": {
            ATTESTATIONS: {
                id: "TM.SOD.MitigatedHighRisk.label",
                defaultMessage: "Mitigated High SOD Risk"
            }
        },
        "TM.SOD.MitigatedCriticalRisk.label": {
            ATTESTATIONS: {
                id: "TM.SOD.MitigatedCriticalRisk.label",
                defaultMessage: "Mitigated Critical SOD Risk"
            }
        },
        "TM.SOX.OpenLowRisk.label": {
            ATTESTATIONS: {
                id: "TM.SOX.OpenLowRisk.label",
                defaultMessage: "Open Low SOX Risk"
            }
        },
        "TM.SOX.OpenMediumRisk.label": {
            ATTESTATIONS: {
                id: "TM.SOX.OpenMediumRisk.label",
                defaultMessage: "Open Medium SOX Risk"
            }
        },
        "TM.SOX.OpenHighRisk.label": {
            ATTESTATIONS: {
                id: "TM.SOX.OpenHighRisk.label",
                defaultMessage: "Open High SOX Risk"
            }
        },
        "TM.SOX.OpenCriticalRisk.label": {
            ATTESTATIONS: {
                id: "TM.SOX.OpenCriticalRisk.label",
                defaultMessage: "Open Critical SOX Risk"
            }
        },
        "TM.SOD.DataNotAvailable.label": {
            ATTESTATIONS: {
                id: "TM.SOD.DataNotAvailable.label",
                defaultMessage: "Data not available for SOD Risk"
            }
        },
        "TM.RUA.BeyondEndDate.beyond.label": {
            ATTESTATIONS: {
                id: "TM.RUA.BeyondEndDate.beyond.label",
                defaultMessage: "Role Access available beyond Enddate"
            }
        },
        "TM.RUA.BeyondEndDate.within.label": {
            ATTESTATIONS: {
                id: "TM.RUA.BeyondEndDate.within.label",
                defaultMessage: "Role Access available within Enddate"
            }
        },
        "TM.RUA.RAC.minscore.label": {
            ATTESTATIONS: {
                id: "TM.RUA.RAC.minscore.label",
                defaultMessage: "Role Access Composition score is {0}"
            }
        },
        "TM.RUA.RAC.nodata.label": {
            ATTESTATIONS: {
                id: "TM.RUA.RAC.nodata.label",
                defaultMessage: "Role Access Composition score is not available"
            }
        },
        "syscritical.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "syscritical.ATTESTATIONS",
                defaultMessage: "Syscritical"
            }
        },
        "entitlement_valuekey.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "entitlement_valuekey.ATTESTATIONS",
                defaultMessage: "Entitlement Value Key"
            }
        },
        "endpointKey.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "endpointKey.ATTESTATIONS",
                defaultMessage: "Endpoint Key"
            }
        },
        "createdate.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "createdate.ATTESTATIONS",
                defaultMessage: "Create Date"
            }
        },
        "entitlementOwner.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "entitlementOwner.ATTESTATIONS",
                defaultMessage: "Entitlement Owner"
            }
        },
        "entitlementTypeName.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "entitlementTypeName.ATTESTATIONS",
                defaultMessage: "Entitlement Type Name"
            }
        },
        "entitlementType.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "entitlementType.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        "entitlementTypeKey.ATTESTATION": {
            ATTESTATIONS: {
                id: "entitlement_glossary.ATTESTATIONS",
                defaultMessage: "Entitlement Type Key"
            }
        },
        "endpoint.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "endpoint.ATTESTATIONS",
                defaultMessage: "Endpoint"
            }
        },
        "updatedate.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "updatedate.ATTESTATIONS",
                defaultMessage: "Update Date"
            }
        },
        "requestForm.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "requestForm.ATTESTATIONS",
                defaultMessage: "Request Form"
            }
        },
        "displayname.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "displayname.ATTESTATIONS",
                defaultMessage: "Display Name"
            }
        },
        "soxcritical.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "soxcritical.ATTESTATIONS",
                defaultMessage: "Sox Critical"
            }
        },
        "entitlement_value.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "entitlement_value.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        "status.ATTESTATIONS": {
            ATTESTATIONS: {
                id: "status.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        "V2.ARS.Review.Requests.Request.assignee.label": {
            ATTESTATIONS: {
                id: "V2.ARS.Review.Requests.Request.assignee.label",
                defaultMessage: "Assigned to"
            }
        },
        "V2.ARS.Request.Review.Approved.By.label": {
            ATTESTATIONS: {
                id: "V2.ARS.Request.Review.Approved.By.label",
                defaultMessage: "Approved to"
            }
        },
        "NewAccountRequest.Default.label": {
            ATTESTATIONS: {
                id: "NewAccountRequest.Default.label",
                defaultMessage: "New Account"
            }
        },
        "AddAccessRequest.Default.label": {
            ATTESTATIONS: {
                id: "AddAccessRequest.Default.label",
                defaultMessage: "Add Access"
            }
        },
        "completedV2.Default.label": {
            ATTESTATIONS: {
                id: "completedV2.Default.label",
                defaultMessage: "Complete"
            }
        },
        "V2.ARS.Request.Task.History.GroupApprovals.Default.Label": {
            ATTESTATIONS: {
                id: "V2.ARS.Request.Task.History.GroupApprovals.Default.Label",
                defaultMessage: "Group Approvals"
            }
        },
        "Usergroup.label": {
            ATTESTATIONS: {
                id: "Usergroup.label",
                defaultMessage: "User Group"
            }
        },
        AutoApprove: {
            ATTESTATIONS: {
                id: "AutoApprove",
                defaultMessage: "AutoApprove"
            }
        },
        MangerApprove: {
            ATTESTATIONS: {
                id: "MangerApprove",
                defaultMessage: "ManagerApprove"
            }
        },
        ManagerApprove: {
            ATTESTATIONS: {
                id: "ManagerApprove",
                defaultMessage: "ManagerApprove"
            }
        },
        manager: {
            ATTESTATIONS: {
                id: "manager",
                defaultMessage: "manager"
            }
        },
        "RequestId.Default.label": {
            ATTESTATIONS: {
                id: "RequestId.Default.label",
                defaultMessage: "Request ID"
            }
        },
        "Requested.Default.label": {
            ATTESTATIONS: {
                id: "Requested.Default.label",
                defaultMessage: "Requested"
            }
        },
        "MultipleApprovals.Default.label": {
            ATTESTATIONS: {
                id: "MultipleApprovals.Default.label",
                defaultMessage: "Multiple Approvals"
            }
        },
        "REQUEST.ACCESS.STATUS.APPROVED": {
            ATTESTATIONS: {
                id: "REQUEST.ACCESS.STATUS.APPROVED",
                defaultMessage: "Approved"
            }
        },
        "V2.Application.label": {
            ATTESTATIONS: {
                id: "V2.Application.label",
                defaultMessage: "Application"
            }
        },
        "RequestType.Default.label": {
            ATTESTATIONS: {
                id: "RequestType.Default.label",
                defaultMessage: "Request Type"
            }
        },
        "SystemName.Default.label": {
            ATTESTATIONS: {
                id: "RequestType.Default.label",
                defaultMessage: "System Name"
            }
        },
        "Role.Default.label": {
            ATTESTATIONS: {
                id: "Role.Default.label",
                defaultMessage: "Role"
            }
        },
        "Entitlement.Default.label": {
            ATTESTATIONS: {
                id: "Entitlement.Default.label",
                defaultMessage: "Entitlement"
            }
        },
        "AccountName.Default.label": {
            ATTESTATIONS: {
                id: "AccountName.Default.label",
                defaultMessage: "Account Name"
            }
        },
        "RequestedBy.Default.label": {
            ATTESTATIONS: {
                id: "RequestedBy.Default.label",
                defaultMessage: "Requested By"
            }
        },
        "RequestedFor.Default.label": {
            ATTESTATIONS: {
                id: "RequestedFor.Default.label",
                defaultMessage: "Requested For"
            }
        },
        "V2.ARS.Request.Review.Justification.Title": {
            ATTESTATIONS: {
                id: "V2.ARS.Request.Review.Justification.Title",
                defaultMessage: "Justification"
            }
        },
        "V2.ARS.Request.Task.History.Time.Label": {
            ATTESTATIONS: {
                id: "V2.ARS.Request.Task.History.Time.Label",
                defaultMessage: "Time"
            }
        },
        "V2.ReviewMethod.Label": {
            ATTESTATIONS: {
                id: "V2.ReviewMethod.Label",
                defaultMessage: "Review Method"
            }
        },
        "TaskId.Default.label": {
            ATTESTATIONS: {
                id: "TaskId.Default.label",
                defaultMessage: "Task ID"
            }
        },
        "parenttaskid.Default.label": {
            ATTESTATIONS: {
                id: "parenttaskid.Default.label",
                defaultMessage: "Parent Task ID"
            }
        },
        "V2.ARS.Request.Review.Assigned.To.Label": {
            ATTESTATIONS: {
                id: "V2.ARS.Request.Review.Assigned.To.Label",
                defaultMessage: "Assigned to"
            }
        },
        "Tasktype.Default.label": {
            ATTESTATIONS: {
                id: "TaskId.Default",
                defaultMessage: "Task Type"
            }
        },
        DEFAULT: {
            ATTESTATIONS: {
                id: "DEFAULT.ATTESTATIONS",
                defaultMessage: "Custom Property"
            }
        },
        // Custom keys addition ends here...
        PARENTMENU: {
            ATTESTATIONS: {
                id: "PARENTMENU.ATTESTATIONS",
                defaultMessage: "Attestations"
            }
        },
        SUBMENU: {
            ATTESTATIONS: {
                id: "SUBMENU.ATTESTATIONS.attestations_create",
                defaultMessage: "Create New attestation"
            }
        },
        SAVLEVEL: {
            ATTESTATIONS: {
                id: "SAVLEVEL.ATTESTATIONS",
                defaultMessage: "SAV Level"
            }
        },
        PRIVILEGED: {
            ATTESTATIONS: {
                id: "PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Privileged"
            }
        },
        parentmenu: {
            ATTESTATIONS: {
                id: "parentmenu.ATTESTATION",
                defaultMessage: "Attestations"
            }
        },
        Childent_CERT_ENTITLEMENT_VALUEKEY: {
            ATTESTATIONS: {
                id: "Childent_CERT_ENTITLEMENT_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Certification Entitlement Value Key"
            }
        },
        Childent_ENTITLEMENT_VALUEKEY: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENT_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Value Key"
            }
        },
        Childent_ENTITLEMENT_VALUE: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENT_VALUE.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        Childent_ENTITLEMENTTYPEKEY: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENTTYPEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Type Key"
            }
        },
        Childent_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 1"
            }
        },
        Childent_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 2"
            }
        },
        Childent_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 3"
            }
        },
        Childent_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 4"
            }
        },
        Childent_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 5"
            }
        },
        Childent_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 6"
            }
        },
        Childent_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 7"
            }
        },
        Childent_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 8"
            }
        },
        Childent_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 9"
            }
        },
        Childent_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 10"
            }
        },
        Childent_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 11"
            }
        },
        Childent_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 12"
            }
        },
        Childent_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 13"
            }
        },
        Childent_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 14"
            }
        },
        Childent_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 15"
            }
        },
        Childent_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 16"
            }
        },
        Childent_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 17"
            }
        },
        Childent_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 18"
            }
        },
        Childent_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 19"
            }
        },
        Childent_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 20"
            }
        },
        Childent_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 21"
            }
        },
        Childent_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 22"
            }
        },
        Childent_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 23"
            }
        },
        Childent_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 24"
            }
        },
        Childent_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 25"
            }
        },
        Childent_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 26"
            }
        },
        Childent_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 27"
            }
        },
        Childent_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 28"
            }
        },
        Childent_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 29"
            }
        },
        Childent_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 30"
            }
        },
        Childent_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 31"
            }
        },
        Childent_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 32"
            }
        },
        Childent_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 33"
            }
        },
        Childent_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 34"
            }
        },
        Childent_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 35"
            }
        },
        Childent_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 36"
            }
        },
        Childent_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 37"
            }
        },
        Childent_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 38"
            }
        },
        Childent_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 39"
            }
        },
        Childent_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Childent_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 40"
            }
        },
        Childent_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Childent_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        Childent_GLOSSARY: {
            ATTESTATIONS: {
                id: "Childent_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Childent_ENTITLEMENT_GLOSSARY: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENT_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Childent_STATUS: {
            ATTESTATIONS: {
                id: "Childent_STATUS.ATTESTATIONS",
                defaultMessage: "Entitlement Status"
            }
        },
        Childent_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Childent_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Entitlement Update User"
            }
        },
        Childent_RISK: {
            ATTESTATIONS: {
                id: "Childent_RISK.ATTESTATIONS",
                defaultMessage: "Entitlement Risk"
            }
        },
        Childent_SOXCRITICAL: {
            ATTESTATIONS: {
                id: "Childent_SOXCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Childent_SYSCRITICAL: {
            ATTESTATIONS: {
                id: "Childent_SYSCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Childent_ORPHAN: {
            ATTESTATIONS: {
                id: "Childent_ORPHAN.ATTESTATIONS",
                defaultMessage: "Entitlement Orphan"
            }
        },
        Childent_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Childent_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Update Date"
            }
        },
        Childent_SAVLEVEL: {
            ATTESTATIONS: {
                id: "Childent_SAVLEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Childent_PRIVILIGED: {
            ATTESTATIONS: {
                id: "Childent_PRIVILIGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Childent_CONFIDENTIALITY: {
            ATTESTATIONS: {
                id: "Childent_CONFIDENTIALITY.ATTESTATIONS",
                defaultMessage: "Entitlement Confidentiality"
            }
        },
        Childent_SOD: {
            ATTESTATIONS: {
                id: "Childent_SOD.ATTESTATIONS",
                defaultMessage: "Entitlement SOD"
            }
        },
        Childent_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Childent_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Display Name"
            }
        },
        Childent_ENTITLEMENTID: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMENTID.ATTESTATIONS",
                defaultMessage: "Entitlement ID"
            }
        },
        Childent_PROGRAM: {
            ATTESTATIONS: {
                id: "Childent_PROGRAM.ATTESTATIONS",
                defaultMessage: "Entitlement Program"
            }
        },
        Childent_MODULE: {
            ATTESTATIONS: {
                id: "Childent_MODULE.ATTESTATIONS",
                defaultMessage: "Entitlement Module"
            }
        },
        Childent_ACCESS: {
            ATTESTATIONS: {
                id: "Childent_ACCESS.ATTESTATIONS",
                defaultMessage: "Entitlement Access"
            }
        },
        Childent_SCHEMANAME: {
            ATTESTATIONS: {
                id: "Childent_SCHEMANAME.ATTESTATIONS",
                defaultMessage: "Entitlement Schema Name"
            }
        },
        Childent_ENTCLASS: {
            ATTESTATIONS: {
                id: "Childent_ENTCLASS.ATTESTATIONS",
                defaultMessage: "Entitlement Classification"
            }
        },
        Childent_LASTSCANDATE: {
            ATTESTATIONS: {
                id: "Childent_LASTSCANDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Scan Date"
            }
        },
        Childent_ENTITLEMGLOSSARY: {
            ATTESTATIONS: {
                id: "Childent_ENTITLEMGLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Childent_JOBID: {
            ATTESTATIONS: {
                id: "Childent_JOBID.ATTESTATIONS",
                defaultMessage: "Entitlement Job ID"
            }
        },
        Childent_LASTUSEDENDDATE: {
            ATTESTATIONS: {
                id: "Childent_LASTUSEDENDDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Used End Date"
            }
        },
        DASHBOARD: {
            ATTESTATIONS: {
                id: "DASHBOARD.ATTESTATION",
                defaultMessage: "Dashboard"
            }
        },
        ACCESSTHROUGH: {
            ATTESTATIONS: {
                id: "ACCESSTHROUGH.ATTESTATIONS",
                defaultMessage: "Granted Through"
            }
        },
        ENDPOINT: {
            ATTESTATIONS: {
                id: "ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        LASTUSEDDATE: {
            ATTESTATIONS: {
                id: "LASTUSEDDATE.ATTESTATIONS",
                defaultMessage: "Last Used Date"
            }
        },
        Ent2_LASTUSEDDATE: {
            ATTESTATIONS: {
                id: "Ent2_LASTUSEDDATE.ATTESTATIONS",
                defaultMessage: "Last Used Date"
            }
        },
        USERNAME: {
            ATTESTATIONS: {
                id: "USERNAME.ATTESTATIONS",
                defaultMessage: "User ID"
            }
        },
        ENTITLEMENT_VALUE: {
            ATTESTATIONS: {
                id: "ENTITLEMENT_VALUE.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        ENTITLEMENTID: {
            ATTESTATIONS: {
                id: "ENTITLEMENTID.ATTESTATIONS",
                defaultMessage: "Entitlement ID"
            }
        },
        ENTITLEMENT_GLOSSARY: {
            ATTESTATIONS: {
                id: "ENTITLEMENT_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        JOB_ID: {
            ATTESTATIONS: {
                id: "JOB_ID.ATTESTATIONS",
                defaultMessage: "Entitlement Job ID"
            }
        },
        LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        LASTSCANDATE: {
            ATTESTATIONS: {
                id: "LASTSCANDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Scan Date"
            }
        },
        ORPHAN: {
            ATTESTATIONS: {
                id: "ORPHAN.ATTESTATIONS",
                defaultMessage: "Entitlement Orphan"
            }
        },
        SOX_CRITICAL: {
            ATTESTATIONS: {
                id: "SOX_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        SYS_CRITICAL: {
            ATTESTATIONS: {
                id: "SYS_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        ACCOUNTNAME: {
            ATTESTATIONS: {
                id: "ACCOUNTNAME.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        STATUS: {
            ATTESTATIONS: {
                id: "STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        SYSTEMNAME: {
            ATTESTATIONS: {
                id: "SYSTEMNAME.ATTESTATIONS",
                defaultMessage: "System Name"
            }
        },
        COMMENTS: {
            ATTESTATIONS: {
                id: "COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        HISTORY: {
            ATTESTATIONS: {
                id: "HISTORY.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        JRMRULES: {
            ATTESTATIONS: {
                id: "JRMRULES.ATTESTATIONS.MESSAGE",
                defaultMessage: "Outlier Analysis"
            }
        },
        NO_OPINION: {
            ATTESTATIONS: {
                id: "JRMRULES.ATTESTATIONS.NO_OPINION",
                defaultMessage: "No Opinion"
            }
        },
        JRMNORULES: {
            ATTESTATIONS: {
                id: "JRMNORULES.ATTESTATIONS.MESSAGE",
                defaultMessage: "Less than 20% of users in the peer group have access to this data"
            }
        },
        LASTUSEDENDDATE: {
            ATTESTATIONS: {
                id: "LASTUSEDENDDATE.ATTESTATIONS",
                defaultMessage: "Last used"
            }
        },
        RISKS: {
            ATTESTATIONS: {
                id: "RISKS.ATTESTATIONS",
                defaultMessage: "SOD Risks"
            }
        },
        CERTIFICATION: {
            ATTESTATIONS: {
                id: "CERTIFICATION.ATTESTATIONS",
                defaultMessage: "Certification"
            }
        },
        CERTIFIER: {
            ATTESTATIONS: {
                id: "CERTIFIER.ATTESTATIONS",
                defaultMessage: "Certifier"
            }
        },
        Assign: {
            ATTESTATIONS: {
                id: "Assign.ATTESTATIONS.label",
                defaultMessage: "Consult"
            }
        },
        UPDATEDATE: {
            ATTESTATIONS: {
                id: "UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Last Certified"
            }
        },
        SELECTALL: {
            ATTESTATIONS: {
                id: "SELECTALL.ATTESTATIONS",
                defaultMessage: "Select All"
            }
        },
        ACTION: {
            ATTESTATIONS: {
                id: "ACTION.ATTESTATIONS",
                defaultMessage: "Action"
            }
        },
        JRMRULESAVAILABLE: {
            ATTESTATIONS: {
                id: "JRMRULESAVAILABLE.ATTESTATIONS",
                defaultMessage: "Outlier Analysis"
            }
        },
        RISKSAVAILABLE: {
            ATTESTATIONS: {
                id: "RISKSAVAILABLE.ATTESTATIONS",
                defaultMessage: "SOD Risks"
            }
        },
        LASTCERTIFIEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Certified Campaign"
            }
        },
        LASTCERTIFIED: {
            ATTESTATIONS: {
                id: "LASTCERTIFIED.ATTESTATIONS",
                defaultMessage: "Last Certified Date"
            }
        },
        AUDIT_TRAIL: {
            ATTESTATIONS: {
                id: "AUDIT_TRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        CRITICALITY: {
            ATTESTATIONS: {
                id: "CRITICALITY.ATTESTATIONS",
                defaultMessage: "Entitlement Criticality"
            }
        },
        CERTIFIED_Action: {
            ATTESTATIONS: {
                id: "CERTIFIED_Action",
                defaultMessage: "Action Filters"
            }
        },
        CERTIFIED: {
            ATTESTATIONS: {
                id: "CERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        REASSIGNED: {
            ATTESTATIONS: {
                id: "REASSIGNED.ATTESTATIONS",
                defaultMessage: "Consulted"
            }
        },
        ENTITLEMENTTYPE: {
            ATTESTATIONS: {
                id: "ENTITLEMENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        Account_CERT_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "Account_CERT_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Account Certification Account Key"
            }
        },
        Account_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Account Key"
            }
        },
        Account_NAME: {
            ATTESTATIONS: {
                id: "Account_NAME.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        Account_REFERENCED_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "Account_REFERENCED_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Referenced Account"
            }
        },
        Account_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Account_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Account Description"
            }
        },
        Account_COMMENTS: {
            ATTESTATIONS: {
                id: "Account_COMMENTS.ATTESTATIONS",
                defaultMessage: "Account Comments"
            }
        },
        Account_ACCOUNTTYPE: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTTYPE.ATTESTATIONS",
                defaultMessage: "Account Type"
            }
        },
        Account_STATUS: {
            ATTESTATIONS: {
                id: "Account_STATUS.ATTESTATIONS",
                defaultMessage: "Account Status"
            }
        },
        Account_VALIDFROM: {
            ATTESTATIONS: {
                id: "Account_VALIDFROM.ATTESTATIONS",
                defaultMessage: "Account Valid From"
            }
        },
        Account_VALIDTHROUGH: {
            ATTESTATIONS: {
                id: "Account_VALIDTHROUGH.ATTESTATIONS",
                defaultMessage: "Account Valid Through"
            }
        },
        Account_USERLOCK: {
            ATTESTATIONS: {
                id: "Account_USERLOCK.ATTESTATIONS",
                defaultMessage: "Account User Lock"
            }
        },
        Account_CREATOR: {
            ATTESTATIONS: {
                id: "Account_CREATOR.ATTESTATIONS",
                defaultMessage: "Account Created By"
            }
        },
        Account_CREATED_ON: {
            ATTESTATIONS: {
                id: "Account_CREATED_ON.ATTESTATIONS",
                defaultMessage: "Account Created On"
            }
        },
        Account_LASTLOGONDATE: {
            ATTESTATIONS: {
                id: "Account_LASTLOGONDATE.ATTESTATIONS",
                defaultMessage: "Account Last Login Date"
            }
        },
        Account_ORPHAN: {
            ATTESTATIONS: {
                id: "Account_ORPHAN.ATTESTATIONS",
                defaultMessage: "Account Orphan"
            }
        },
        Account_JOBID: {
            ATTESTATIONS: {
                id: "Account_JOBID.ATTESTATIONS",
                defaultMessage: "Account Job ID"
            }
        },
        Account_PRIVILEGED: {
            ATTESTATIONS: {
                id: "Account_PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Account Privileged"
            }
        },
        Account_ENDPOINTKEY: {
            ATTESTATIONS: {
                id: "Account_ENDPOINTKEY.ATTESTATIONS",
                defaultMessage: "Account Endpoint"
            }
        },
        Account_SYSTEMID: {
            ATTESTATIONS: {
                id: "Account_SYSTEMID.ATTESTATIONS",
                defaultMessage: "Account System"
            }
        },
        Account_INCORRECTLOGONS: {
            ATTESTATIONS: {
                id: "Account_INCORRECTLOGONS.ATTESTATIONS",
                defaultMessage: "Account Incorrect Logins"
            }
        },
        Account_LASTPASSWORDCHANGE: {
            ATTESTATIONS: {
                id: "Account_LASTPASSWORDCHANGE.ATTESTATIONS",
                defaultMessage: "Account Last Password Change"
            }
        },
        Account_PASSWORDLOCKDATE: {
            ATTESTATIONS: {
                id: "Account_PASSWORDLOCKDATE.ATTESTATIONS",
                defaultMessage: "Account Password Locked Date"
            }
        },
        Account_PASSWORDCHANGESTATUS: {
            ATTESTATIONS: {
                id: "Account_PASSWORDCHANGESTATUS.ATTESTATIONS",
                defaultMessage: "Account Password Change Status"
            }
        },
        Account_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Account Custom Property 1"
            }
        },
        Account_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Account Custom Property 2"
            }
        },
        Account_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Account Custom Property 3"
            }
        },
        Account_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Account Custom Property 4"
            }
        },
        Account_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Account Custom Property 5"
            }
        },
        Account_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Account Custom Property 6"
            }
        },
        Account_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Account Custom Property 7"
            }
        },
        Account_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Account Custom Property 8"
            }
        },
        Account_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Account Custom Property 9"
            }
        },
        Account_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Account Custom Property 10"
            }
        },
        Account_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Account Custom Property 11"
            }
        },
        Account_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Account Custom Property 12"
            }
        },
        Account_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Account Custom Property 13"
            }
        },
        Account_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Account Custom Property 14"
            }
        },
        Account_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Account Custom Property 15"
            }
        },
        Account_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Account Custom Property 16"
            }
        },
        Account_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Account Custom Property 17"
            }
        },
        Account_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Account Custom Property 18"
            }
        },
        Account_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Account Custom Property 19"
            }
        },
        Account_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Account Custom Property 20"
            }
        },
        Account_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Account Custom Property 21"
            }
        },
        Account_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Account Custom Property 22"
            }
        },
        Account_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Account Custom Property 23"
            }
        },
        Account_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Account Custom Property 24"
            }
        },
        Account_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Account Custom Property 25"
            }
        },
        Account_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Account Custom Property 26"
            }
        },
        Account_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Account Custom Property 27"
            }
        },
        Account_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Account Custom Property 28"
            }
        },
        Account_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Account Custom Property 29"
            }
        },
        Account_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Account Custom Property 30"
            }
        },
        Account_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Account Custom Property 31"
            }
        },
        Account_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Account Custom Property 32"
            }
        },
        Account_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Account Custom Property 33"
            }
        },
        Account_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Account Custom Property 34"
            }
        },
        Account_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Account Custom Property 35"
            }
        },
        Account_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Account Custom Property 36"
            }
        },
        Account_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Account Custom Property 37"
            }
        },
        Account_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Account Custom Property 38"
            }
        },
        Account_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Account Custom Property 39"
            }
        },
        Account_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Account Custom Property 40"
            }
        },
        Account_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "Account Custom Property 41"
            }
        },
        Account_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "Account Custom Property 42"
            }
        },
        Account_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "Account Custom Property 43"
            }
        },
        Account_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "Account Custom Property 44"
            }
        },
        Account_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "Account Custom Property 45"
            }
        },
        Account_CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "Account Custom Property 46"
            }
        },
        Account_CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "Account Custom Property 47"
            }
        },
        Account_CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "Account Custom Property 48"
            }
        },
        Account_CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "Account Custom Property 49"
            }
        },
        Account_CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "Account Custom Property 50"
            }
        },
        Account_CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "Account Custom Property 51"
            }
        },
        Account_CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "Account Custom Property 52"
            }
        },
        Account_CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "Account Custom Property 53"
            }
        },
        Account_CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "Account Custom Property 54"
            }
        },
        Account_CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "Account Custom Property 55"
            }
        },
        Account_CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "Account Custom Property 56"
            }
        },
        Account_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Account_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Account Update Date"
            }
        },
        Account_ACCOUNTID: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTID.ATTESTATIONS",
                defaultMessage: "Account ID"
            }
        },
        Account_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Account_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Account"
            }
        },
        Account_REFERENCED_ACCOUNTNAME: {
            ATTESTATIONS: {
                id: "Account_REFERENCED_ACCOUNTNAME.ATTESTATIONS",
                defaultMessage: "Referenced Account Name"
            }
        },
        Account_ACCOUNTCLASS: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTCLASS.ATTESTATIONS",
                defaultMessage: "Account Classification"
            }
        },
        Account_USERGROUP: {
            ATTESTATIONS: {
                id: "Account_USERGROUP.ATTESTATIONS",
                defaultMessage: "Account User Group"
            }
        },
        User_ACCOUNT_CERT_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CERT_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Account Certification Account Key"
            }
        },
        User_ACCOUNT_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Account Key"
            }
        },
        User_ACCOUNT_NAME: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_NAME.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        User_ACCOUNT_REFERENCED_ACCOUNTKEY: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_REFERENCED_ACCOUNTKEY.ATTESTATIONS",
                defaultMessage: "Referenced Account"
            }
        },
        User_ACCOUNT_DESCRIPTION: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Account Description"
            }
        },
        User_ACCOUNT_COMMENTS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_COMMENTS.ATTESTATIONS",
                defaultMessage: "Account Comments"
            }
        },
        User_ACCOUNT_ACCOUNTTYPE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTTYPE.ATTESTATIONS",
                defaultMessage: "Account Type"
            }
        },
        User_ACCOUNT_STATUS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_STATUS.ATTESTATIONS",
                defaultMessage: "Account Status"
            }
        },
        User_ACCOUNT_VALIDFROM: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_VALIDFROM.ATTESTATIONS",
                defaultMessage: "Account Valid From"
            }
        },
        User_ACCOUNT_VALIDTHROUGH: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_VALIDTHROUGH.ATTESTATIONS",
                defaultMessage: "Account Valid Through"
            }
        },
        User_ACCOUNT_USERLOCK: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_USERLOCK.ATTESTATIONS",
                defaultMessage: "Account User Lock"
            }
        },
        User_ACCOUNT_CREATOR: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CREATOR.ATTESTATIONS",
                defaultMessage: "Account Created By"
            }
        },
        User_ACCOUNT_CREATED_ON: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CREATED_ON.ATTESTATIONS",
                defaultMessage: "Account Created On"
            }
        },
        User_ACCOUNT_LASTLOGONDATE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_LASTLOGONDATE.ATTESTATIONS",
                defaultMessage: "Account Last Login Date"
            }
        },
        User_ACCOUNT_ORPHAN: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ORPHAN.ATTESTATIONS",
                defaultMessage: "Account Orphan"
            }
        },
        User_ACCOUNT_JOBID: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_JOBID.ATTESTATIONS",
                defaultMessage: "Account Job ID"
            }
        },
        User_ACCOUNT_PRIVILEGED: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Account Privileged"
            }
        },
        User_ACCOUNT_ENDPOINTKEY: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ENDPOINTKEY.ATTESTATIONS",
                defaultMessage: "Account Endpoint"
            }
        },
        User_ACCOUNT_SYSTEMID: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_SYSTEMID.ATTESTATIONS",
                defaultMessage: "Account System"
            }
        },
        User_ACCOUNT_INCORRECTLOGONS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_INCORRECTLOGONS.ATTESTATIONS",
                defaultMessage: "Account Incorrect Logins"
            }
        },
        User_ACCOUNT_LASTPASSWORDCHANGE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_LASTPASSWORDCHANGE.ATTESTATIONS",
                defaultMessage: "Account Last Password Change"
            }
        },
        User_ACCOUNT_PASSWORDLOCKDATE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_PASSWORDLOCKDATE.ATTESTATIONS",
                defaultMessage: "Account Password Locked Date"
            }
        },
        User_ACCOUNT_PASSWORDCHANGESTATUS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_PASSWORDCHANGESTATUS.ATTESTATIONS",
                defaultMessage: "Account Password Change Status"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Account Custom Property 1"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Account Custom Property 2"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Account Custom Property 3"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Account Custom Property 4"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Account Custom Property 5"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Account Custom Property 6"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Account Custom Property 7"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Account Custom Property 8"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Account Custom Property 9"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Account Custom Property 10"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Account Custom Property 11"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Account Custom Property 12"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Account Custom Property 13"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Account Custom Property 14"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Account Custom Property 15"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Account Custom Property 16"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Account Custom Property 17"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Account Custom Property 18"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Account Custom Property 19"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Account Custom Property 20"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Account Custom Property 21"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Account Custom Property 22"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Account Custom Property 23"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Account Custom Property 24"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Account Custom Property 25"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Account Custom Property 26"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Account Custom Property 27"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Account Custom Property 28"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Account Custom Property 29"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Account Custom Property 30"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Account Custom Property 31"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Account Custom Property 32"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Account Custom Property 33"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Account Custom Property 34"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Account Custom Property 35"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Account Custom Property 36"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Account Custom Property 37"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Account Custom Property 38"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Account Custom Property 39"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Account Custom Property 40"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "Account Custom Property 41"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "Account Custom Property 42"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "Account Custom Property 43"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "Account Custom Property 44"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "Account Custom Property 45"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "Account Custom Property 46"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "Account Custom Property 47"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "Account Custom Property 48"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "Account Custom Property 49"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "Account Custom Property 50"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "Account Custom Property 51"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "Account Custom Property 52"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "Account Custom Property 53"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "Account Custom Property 54"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "Account Custom Property 55"
            }
        },
        User_ACCOUNT_CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "Account Custom Property 56"
            }
        },
        User_ACCOUNT_ACCOUNTSTATUS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTSTATUS.ATTESTATIONS",
                defaultMessage: "Account Status"
            }
        },
        User_ACCOUNT_CREATEDON: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_CREATEDON.ATTESTATIONS",
                defaultMessage: "Account Created On"
            }
        },
        User_ACCOUNT_OLDOWNER: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_OLDOWNER.ATTESTATIONS",
                defaultMessage: "Account Old Owner"
            }
        },
        User_ACCOUNT_NEWOWNER: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_NEWOWNER.ATTESTATIONS",
                defaultMessage: "Account New Owner"
            }
        },
        User_ACCOUNT_UPDATEDATE: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Account Update Date"
            }
        },
        User_ACCOUNT_ACCOUNTID: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTID.ATTESTATIONS",
                defaultMessage: "Account ID"
            }
        },
        User_ACCOUNT_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Account Display Name"
            }
        },
        User_ACCOUNT_REFERENCED_ACCOUNTNAME: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_REFERENCED_ACCOUNTNAME.ATTESTATIONS",
                defaultMessage: "Referenced Account Name"
            }
        },
        User_ACCOUNT_ACCOUNTCLASS: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_ACCOUNTCLASS.ATTESTATIONS",
                defaultMessage: "Account Classification"
            }
        },
        User_ACCOUNT_USERGROUP: {
            ATTESTATIONS: {
                id: "User_ACCOUNT_USERGROUP.ATTESTATIONS",
                defaultMessage: "Account User Group"
            }
        },
        Ent_CERT_ENTITLEMENT_VALUEKEY: {
            ATTESTATIONS: {
                id: "Ent_CERT_ENTITLEMENT_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Certification Entitlement Value Key"
            }
        },
        Ent_ENTITLEMENT_VALUEKEY: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENT_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Value Key"
            }
        },
        Ent_ENTITLEMENT_VALUE: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENT_VALUE.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        Ent_ENTITLEMENTTYPEKEY: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENTTYPEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Type Key"
            }
        },
        Ent_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 1"
            }
        },
        Ent_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 2"
            }
        },
        Ent_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 3"
            }
        },
        Ent_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 4"
            }
        },
        Ent_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 5"
            }
        },
        Ent_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 6"
            }
        },
        Ent_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 7"
            }
        },
        Ent_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 8"
            }
        },
        Ent_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 9"
            }
        },
        Ent_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 10"
            }
        },
        Ent_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 11"
            }
        },
        Ent_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 12"
            }
        },
        Ent_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 13"
            }
        },
        Ent_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 14"
            }
        },
        Ent_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 15"
            }
        },
        Ent_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 16"
            }
        },
        Ent_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 17"
            }
        },
        Ent_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 18"
            }
        },
        Ent_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 19"
            }
        },
        Ent_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 20"
            }
        },
        Ent_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 21"
            }
        },
        Ent_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 22"
            }
        },
        Ent_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 23"
            }
        },
        Ent_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 24"
            }
        },
        Ent_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 25"
            }
        },
        Ent_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 26"
            }
        },
        Ent_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 27"
            }
        },
        Ent_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 28"
            }
        },
        Ent_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 29"
            }
        },
        Ent_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 30"
            }
        },
        Ent_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 31"
            }
        },
        Ent_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 32"
            }
        },
        Ent_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 33"
            }
        },
        Ent_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 34"
            }
        },
        Ent_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 35"
            }
        },
        Ent_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 36"
            }
        },
        Ent_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 37"
            }
        },
        Ent_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 38"
            }
        },
        Ent_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 39"
            }
        },
        Ent_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Ent_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 40"
            }
        },
        Ent_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Ent_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        Ent_ENTITLEMENT_GLOSSARY: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENT_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Ent_STATUS: {
            ATTESTATIONS: {
                id: "Ent_STATUS.ATTESTATIONS",
                defaultMessage: "Entitlement Status"
            }
        },
        Ent_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Ent_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Entitlement Update User"
            }
        },
        Ent_RISK: {
            ATTESTATIONS: {
                id: "Ent_RISK.ATTESTATIONS",
                defaultMessage: "Entitlement Risk"
            }
        },
        Ent_SOX_CRITICAL: {
            ATTESTATIONS: {
                id: "Ent_SOX_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Ent_SYS_CRITICAL: {
            ATTESTATIONS: {
                id: "Ent_SYS_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Ent_ORPHAN: {
            ATTESTATIONS: {
                id: "Ent_ORPHAN.ATTESTATIONS",
                defaultMessage: "Entitlement Orphan"
            }
        },
        Ent_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Ent_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Update Date"
            }
        },
        Ent_SAVLEVEL: {
            ATTESTATIONS: {
                id: "Ent_SAVLEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Ent_LEVEL: {
            ATTESTATIONS: {
                id: "Ent_LEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Ent_PRIVILEGED: {
            ATTESTATIONS: {
                id: "Ent_PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Ent_CONFIDENTIALITY: {
            ATTESTATIONS: {
                id: "Ent_CONFIDENTIALITY.ATTESTATIONS",
                defaultMessage: "Entitlement Confidentiality"
            }
        },
        Ent_SOD: {
            ATTESTATIONS: {
                id: "Ent_SOD.ATTESTATIONS",
                defaultMessage: "Entitlement SOD"
            }
        },
        Ent_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Ent_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement"
            }
        },
        Ent_ENTITLEMENTID: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMENTID.ATTESTATIONS",
                defaultMessage: "Entitlement ID"
            }
        },
        Ent_PROGRAM: {
            ATTESTATIONS: {
                id: "Ent_PROGRAM.ATTESTATIONS",
                defaultMessage: "Entitlement Program"
            }
        },
        Ent_MODULE: {
            ATTESTATIONS: {
                id: "Ent_MODULE.ATTESTATIONS",
                defaultMessage: "Entitlement Module"
            }
        },
        Ent_ACCESS: {
            ATTESTATIONS: {
                id: "Ent_ACCESS.ATTESTATIONS",
                defaultMessage: "Entitlement Access"
            }
        },
        Ent_SCHEMANAME: {
            ATTESTATIONS: {
                id: "Ent_SCHEMANAME.ATTESTATIONS",
                defaultMessage: "Entitlement Schema Name"
            }
        },
        Ent_ENTCLASS: {
            ATTESTATIONS: {
                id: "Ent_ENTCLASS.ATTESTATIONS",
                defaultMessage: "Entitlement Classification"
            }
        },
        Ent_LASTSCANDATE: {
            ATTESTATIONS: {
                id: "Ent_LASTSCANDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Scan Date"
            }
        },
        Ent_ENTITLEMGLOSSARY: {
            ATTESTATIONS: {
                id: "Ent_ENTITLEMGLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Ent_JOBID: {
            ATTESTATIONS: {
                id: "Ent_JOBID.ATTESTATIONS",
                defaultMessage: "Entitlement Job ID"
            }
        },
        Ent_SAVACCESS: {
            ATTESTATIONS: {
                id: "Ent_SAVACCESS.ATTESTATIONS",
                defaultMessage: "Entitlement Sav Access"
            }
        },
        User_CERT_USERKEY: {
            ATTESTATIONS: {
                id: "User_CERT_USERKEY.ATTESTATIONS",
                defaultMessage: "Certification User Key"
            }
        },
        User_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "User_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "User"
            }
        },
        User_USERKEY: {
            ATTESTATIONS: {
                id: "User_USERKEY.ATTESTATIONS",
                defaultMessage: "User Key"
            }
        },
        User_USERNAME: {
            ATTESTATIONS: {
                id: "User_USERNAME.ATTESTATIONS",
                defaultMessage: "Username"
            }
        },
        User_TERMDATE: {
            ATTESTATIONS: {
                id: "User_TERMDATE.ATTESTATIONS",
                defaultMessage: "User Term Date"
            }
        },
        User_FIRSTNAME: {
            ATTESTATIONS: {
                id: "User_FIRSTNAME.ATTESTATIONS",
                defaultMessage: "User First Name"
            }
        },
        User_TOTALACCOUNTS: {
            ATTESTATIONS: {
                id: "User_TOTALACCOUNTS.ATTESTATIONS",
                defaultMessage: "Total Accounts"
            }
        },
        User_AUDITTRAIL: {
            ATTESTATIONS: {
                id: "User_AUDITTRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        User_UPDATEUSER: {
            ATTESTATIONS: {
                id: "User_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        User_CERTIFIED: {
            ATTESTATIONS: {
                id: "User_CERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        User_LASTNAME: {
            ATTESTATIONS: {
                id: "User_LASTNAME.ATTESTATIONS",
                defaultMessage: "User Last Name"
            }
        },
        User_MIDDLENAME: {
            ATTESTATIONS: {
                id: "User_MIDDLENAME.ATTESTATIONS",
                defaultMessage: "User Middle Name"
            }
        },
        User_STREET: {
            ATTESTATIONS: {
                id: "User_STREET.ATTESTATIONS",
                defaultMessage: "User Street"
            }
        },
        User_CITY: {
            ATTESTATIONS: {
                id: "User_CITY.ATTESTATIONS",
                defaultMessage: "User City"
            }
        },
        User_EMAIL: {
            ATTESTATIONS: {
                id: "User_EMAIL.ATTESTATIONS",
                defaultMessage: "User Email"
            }
        },
        User_COMMENTS: {
            ATTESTATIONS: {
                id: "User_COMMENTS.ATTESTATIONS",
                defaultMessage: "User Comments"
            }
        },
        User_STATUSKEY: {
            ATTESTATIONS: {
                id: "User_STATUSKEY.ATTESTATIONS",
                defaultMessage: "User Status"
            }
        },
        User_STARTDATE: {
            ATTESTATIONS: {
                id: "User_STARTDATE.ATTESTATIONS",
                defaultMessage: "User Start Date"
            }
        },
        User_ENDDATE: {
            ATTESTATIONS: {
                id: "User_ENDDATE.ATTESTATIONS",
                defaultMessage: "User End Date"
            }
        },
        User_MANAGER: {
            ATTESTATIONS: {
                id: "User_MANAGER.ATTESTATIONS",
                defaultMessage: "User Manager"
            }
        },
        User_PASSWORD: {
            ATTESTATIONS: {
                id: "User_PASSWORD.ATTESTATIONS",
                defaultMessage: "User Password"
            }
        },
        User_ENABLED: {
            ATTESTATIONS: {
                id: "User_ENABLED.ATTESTATIONS",
                defaultMessage: "User Enabled"
            }
        },
        User_LOCATION: {
            ATTESTATIONS: {
                id: "User_LOCATION.ATTESTATIONS",
                defaultMessage: "User Location"
            }
        },
        User_JOBCODE: {
            ATTESTATIONS: {
                id: "User_JOBCODE.ATTESTATIONS",
                defaultMessage: "User Job Code"
            }
        },
        User_JOBDESCRIPTION: {
            ATTESTATIONS: {
                id: "User_JOBDESCRIPTION.ATTESTATIONS",
                defaultMessage: "User Job Description"
            }
        },
        User_EMPLOYEETYPE: {
            ATTESTATIONS: {
                id: "User_EMPLOYEETYPE.ATTESTATIONS",
                defaultMessage: "User Employee Type"
            }
        },
        User_SYSTEMUSERNAME: {
            ATTESTATIONS: {
                id: "User_SYSTEMUSERNAME.ATTESTATIONS",
                defaultMessage: "User System Username"
            }
        },
        User_DEPARTMENTNUMBER: {
            ATTESTATIONS: {
                id: "User_DEPARTMENTNUMBER.ATTESTATIONS",
                defaultMessage: "User Department Number"
            }
        },
        User_TITLE: {
            ATTESTATIONS: {
                id: "User_TITLE.ATTESTATIONS",
                defaultMessage: "User Title"
            }
        },
        User_STATE: {
            ATTESTATIONS: {
                id: "User_STATE.ATTESTATIONS",
                defaultMessage: "User State"
            }
        },
        User_COMPANYNAME: {
            ATTESTATIONS: {
                id: "User_COMPANYNAME.ATTESTATIONS",
                defaultMessage: "User Company Name"
            }
        },
        User_COSTCENTER: {
            ATTESTATIONS: {
                id: "User_COSTCENTER.ATTESTATIONS",
                defaultMessage: "User Cost Centre"
            }
        },
        User_DEPARTMENTNAME: {
            ATTESTATIONS: {
                id: "User_DEPARTMENTNAME.ATTESTATIONS",
                defaultMessage: "User Department Name"
            }
        },
        User_EMPLOYEECLASS: {
            ATTESTATIONS: {
                id: "User_EMPLOYEECLASS.ATTESTATIONS",
                defaultMessage: "User Employee Class"
            }
        },
        User_ENTITY: {
            ATTESTATIONS: {
                id: "User_ENTITY.ATTESTATIONS",
                defaultMessage: "User Entity"
            }
        },
        User_JOBCODEDESC: {
            ATTESTATIONS: {
                id: "User_JOBCODEDESC.ATTESTATIONS",
                defaultMessage: "User Job Code Description"
            }
        },
        User_LOCATIONDESC: {
            ATTESTATIONS: {
                id: "User_LOCATIONDESC.ATTESTATIONS",
                defaultMessage: "User Location Description"
            }
        },
        User_LOCATIONNUMBER: {
            ATTESTATIONS: {
                id: "User_LOCATIONNUMBER.ATTESTATIONS",
                defaultMessage: "User Location Number"
            }
        },
        User_SITEID: {
            ATTESTATIONS: {
                id: "User_SITEID.ATTESTATIONS",
                defaultMessage: "User Site"
            }
        },
        User_ORGUNITID: {
            ATTESTATIONS: {
                id: "User_ORGUNITID.ATTESTATIONS",
                defaultMessage: "User Organization Unit"
            }
        },
        User_REGION: {
            ATTESTATIONS: {
                id: "User_REGION.ATTESTATIONS",
                defaultMessage: "User Region"
            }
        },
        User_REGIONCODE: {
            ATTESTATIONS: {
                id: "User_REGIONCODE.ATTESTATIONS",
                defaultMessage: "User Region Code"
            }
        },
        User_OWNER: {
            ATTESTATIONS: {
                id: "User_OWNER.ATTESTATIONS",
                defaultMessage: "User Owner"
            }
        },
        User_EMPLOYEEID: {
            ATTESTATIONS: {
                id: "User_EMPLOYEEID.ATTESTATIONS",
                defaultMessage: "User Employee"
            }
        },
        User_LASTSYNCDATE: {
            ATTESTATIONS: {
                id: "User_LASTSYNCDATE.ATTESTATIONS",
                defaultMessage: "User Last Sync Date"
            }
        },
        User_PHONENUMBER: {
            ATTESTATIONS: {
                id: "User_PHONENUMBER.ATTESTATIONS",
                defaultMessage: "User Phone Number"
            }
        },
        User_COUNTRY: {
            ATTESTATIONS: {
                id: "User_COUNTRY.ATTESTATIONS",
                defaultMessage: "User Country"
            }
        },
        User_ACCOUNTEXPIRED: {
            ATTESTATIONS: {
                id: "User_ACCOUNTEXPIRED.ATTESTATIONS",
                defaultMessage: "User Account Expired"
            }
        },
        User_ACCOUNTLOCKED: {
            ATTESTATIONS: {
                id: "User_ACCOUNTLOCKED.ATTESTATIONS",
                defaultMessage: "User Account Locked"
            }
        },
        User_PASSWORDEXPIRED: {
            ATTESTATIONS: {
                id: "User_PASSWORDEXPIRED.ATTESTATIONS",
                defaultMessage: "User Password Expired"
            }
        },
        User_JOB_FUNCTION: {
            ATTESTATIONS: {
                id: "User_JOB_FUNCTION.ATTESTATIONS",
                defaultMessage: "User Job Function"
            }
        },
        User_DONOTDISTURBDELEGATE: {
            ATTESTATIONS: {
                id: "User_DONOTDISTURBDELEGATE.ATTESTATIONS",
                defaultMessage: "User Do Not Disturb Delegate"
            }
        },
        User_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "User Custom Property 1"
            }
        },
        User_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "User Custom Property 2"
            }
        },
        User_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "User Custom Property 3"
            }
        },
        User_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "User Custom Property 4"
            }
        },
        User_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "User Custom Property 5"
            }
        },
        User_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "User Custom Property 6"
            }
        },
        User_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "User Custom Property 7"
            }
        },
        User_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "User Custom Property 8"
            }
        },
        User_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "User Custom Property 9"
            }
        },
        User_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "User Custom Property 10"
            }
        },
        User_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "User Custom Property 11"
            }
        },
        User_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "User Custom Property 12"
            }
        },
        User_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "User Custom Property 13"
            }
        },
        User_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "User Custom Property 14"
            }
        },
        User_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "User Custom Property 15"
            }
        },
        User_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "User Custom Property 16"
            }
        },
        User_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "User Custom Property 17"
            }
        },
        User_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "User Custom Property 18"
            }
        },
        User_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "User Custom Property 19"
            }
        },
        User_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "User Custom Property 20"
            }
        },
        User_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "User Custom Property 21"
            }
        },
        User_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "User Custom Property 22"
            }
        },
        User_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "User Custom Property 23"
            }
        },
        User_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "User Custom Property 24"
            }
        },
        User_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "User Custom Property 25"
            }
        },
        User_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "User Custom Property 26"
            }
        },
        User_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "User Custom Property 27"
            }
        },
        User_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "User Custom Property 28"
            }
        },
        User_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "User Custom Property 29"
            }
        },
        User_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "User Custom Property 30"
            }
        },
        User_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "User Custom Property 31"
            }
        },
        User_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "User Custom Property 32"
            }
        },
        User_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "User Custom Property 33"
            }
        },
        User_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "User Custom Property 34"
            }
        },
        User_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "User Custom Property 35"
            }
        },
        User_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "User Custom Property 36"
            }
        },
        User_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "User Custom Property 37"
            }
        },
        User_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "User Custom Property 38"
            }
        },
        User_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "User Custom Property 39"
            }
        },
        User_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "User Custom Property 40"
            }
        },
        User_RISKSCORE: {
            ATTESTATIONS: {
                id: "User_RISKSCORE.ATTESTATIONS",
                defaultMessage: "User Risk Score"
            }
        },
        User_EXTENDEDENDDATE: {
            ATTESTATIONS: {
                id: "User_EXTENDEDENDDATE.ATTESTATIONS",
                defaultMessage: "User Extended Date"
            }
        },
        User_LASTCERTIFIEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "User_LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Certified Campaign"
            }
        },
        User_LASTCERTIFIEDDATE: {
            ATTESTATIONS: {
                id: "User_LASTCERTIFIEDDATE.ATTESTATIONS",
                defaultMessage: "Last Certified Date"
            }
        },
        User_LASTCERTIFIEDUSER: {
            ATTESTATIONS: {
                id: "User_LASTCERTIFIEDUSER.ATTESTATIONS",
                defaultMessage: "Last Certified User"
            }
        },
        ACCDESCRIPTION: {
            ATTESTATIONS: {
                id: "ACCDESCRIPTION.ATTESTATIONS",
                defaultMessage: "Account Description"
            }
        },
        ENTDESCRIPTION: {
            ATTESTATIONS: {
                id: "ENTDESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        LASTCERTIFIEDUSER: {
            ATTESTATIONS: {
                id: "LASTCERTIFIEDUSER.ATTESTATIONS",
                defaultMessage: "Last Certified User"
            }
        },
        name: {
            ATTESTATIONS: {
                id: "name.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        displayName: {
            ATTESTATIONS: {
                id: "displayName.ATTESTATIONS",
                defaultMessage: "DisplayName"
            }
        },
        comments: {
            ATTESTATIONS: {
                id: "comments.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        securitysystem: {
            ATTESTATIONS: {
                id: "securitysystem.ATTESTATIONS",
                defaultMessage: "Security System"
            }
        },
        auditTrail: {
            ATTESTATIONS: {
                id: "auditTrail.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        endpoints: {
            ATTESTATIONS: {
                id: "endpoints.ATTESTATIONS",
                defaultMessage: "Endpoints"
            }
        },
        description: {
            ATTESTATIONS: {
                id: "description.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        enddate: {
            ATTESTATIONS: {
                id: "enddate.ATTESTATIONS",
                defaultMessage: "End Date"
            }
        },
        status: {
            ATTESTATIONS: {
                id: "status.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        TASKID: {
            ATTESTATIONS: {
                id: "TASKID.ATTESTATIONS",
                defaultMessage: "Task Id"
            }
        },
        not_consulted: {
            ATTESTATIONS: {
                id: "not_consulted.ATTESTATIONS.label",
                defaultMessage: "Not Consulted"
            }
        },
        reassigned: {
            ATTESTATIONS: {
                id: "reassigned.ATTESTATIONS.label",
                defaultMessage: "Reassigned"
            }
        },
        consulted: {
            ATTESTATIONS: {
                id: "consulted..ATTESTATIONS.label",
                defaultMessage: "Consulted"
            }
        },
        IsConsulted: {
            ATTESTATIONS: {
                id: "IsConsulted.ATTESTATIONS",
                defaultMessage: "IsConsulted"
            }
        },
        Ent_NEWENTITLEMENTOWNER: {
            ATTESTATIONS: {
                id: "Ent_NEWENTITLEMENTOWNER.ATTESTATIONS",
                defaultMessage: "New Entitlement Owner"
            }
        },
        Role_RISK: {
            ATTESTATIONS: {
                id: "Role_RISK.ATTESTATIONS",
                defaultMessage: "Risk"
            }
        },
        Role_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Role_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Role Update Date"
            }
        },
        Role_ENDDATE: {
            ATTESTATIONS: {
                id: "Role_ENDDATE.ATTESTATIONS",
                defaultMessage: "Role End Date"
            }
        },
        Role_GLOSSARY: {
            ATTESTATIONS: {
                id: "Role_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Glossary"
            }
        },
        Role_SOXCRITICAL: {
            ATTESTATIONS: {
                id: "Role_SOXCRITICAL.ATTESTATIONS",
                defaultMessage: "SOX Critical"
            }
        },
        Role_SYSCRITICAL: {
            ATTESTATIONS: {
                id: "Role_SYSCRITICAL.ATTESTATIONS",
                defaultMessage: "Sys Critical"
            }
        },
        Role_PRIVILIGED: {
            ATTESTATIONS: {
                id: "Role_PRIVILIGED.ATTESTATIONS",
                defaultMessage: "Privileged"
            }
        },
        Role_CONFIDENTIALITY: {
            ATTESTATIONS: {
                id: "Role_CONFIDENTIALITY.ATTESTATIONS",
                defaultMessage: "Confidentiality"
            }
        },
        Role_DEFAULTTIMEFRAMEHRS: {
            ATTESTATIONS: {
                id: "Role_DEFAULTTIMEFRAMEHRS.ATTESTATIONS",
                defaultMessage: "Default Time Frame"
            }
        },
        Role_REQUESTABLE: {
            ATTESTATIONS: {
                id: "Role_REQUESTABLE.ATTESTATIONS",
                defaultMessage: "Requestable"
            }
        },
        Role_ROLETYPE: {
            ATTESTATIONS: {
                id: "Role_ROLETYPE.ATTESTATIONS",
                defaultMessage: "Role Type"
            }
        },
        Role_ROLESTATE: {
            ATTESTATIONS: {
                id: "Role_ROLESTATE.ATTESTATIONS",
                defaultMessage: "Role State"
            }
        },
        Role_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Custom Property 1"
            }
        },
        Role_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Custom Property 10"
            }
        },
        Role_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Custom Property 11"
            }
        },
        Role_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Custom Property 12"
            }
        },
        Role_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Custom Property 13"
            }
        },
        Role_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Custom Property 14"
            }
        },
        Role_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Custom Property 15"
            }
        },
        Role_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Custom Property 16"
            }
        },
        Role_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Custom Property 17"
            }
        },
        Role_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Custom Property 18"
            }
        },
        Role_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Custom Property 19"
            }
        },
        Role_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Custom Property 2"
            }
        },
        Role_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Custom Property 20"
            }
        },
        Role_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Custom Property 3"
            }
        },
        Role_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Custom Property 4"
            }
        },
        Role_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Custom Property 5"
            }
        },
        Role_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Custom Property 6"
            }
        },
        Role_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Custom Property 7"
            }
        },
        Role_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Custom Property 8"
            }
        },
        Role_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Custom Property 9"
            }
        },
        Role_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Custom Property 21"
            }
        },
        Role_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Custom Property 22"
            }
        },
        Role_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Custom Property 23"
            }
        },
        Role_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Custom Property 24"
            }
        },
        Role_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Custom Property 25"
            }
        },
        Role_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Custom Property 26"
            }
        },
        Role_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Custom Property 27"
            }
        },
        Role_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Custom Property 28"
            }
        },
        Role_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Custom Property 29"
            }
        },
        Role_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Custom Property 30"
            }
        },
        Role_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Custom Property 31"
            }
        },
        Role_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Custom Property 32"
            }
        },
        Role_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Custom Property 33"
            }
        },
        Role_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Custom Property 34"
            }
        },
        Role_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Custom Property 35"
            }
        },
        Role_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Custom Property 36"
            }
        },
        Role_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Custom Property 37"
            }
        },
        Role_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Custom Property 38"
            }
        },
        Role_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Custom Property 39"
            }
        },
        Role_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Custom Property 40"
            }
        },
        Organization_LOGONAME: {
            ATTESTATIONS: {
                id: "Organization_LOGONAME.ATTESTATIONS",
                defaultMessage: "Logoname"
            }
        },
        Organization_LOCATION: {
            ATTESTATIONS: {
                id: "Organization_LOCATION.ATTESTATIONS",
                defaultMessage: "Location"
            }
        },
        Organization_PRIMARYVENDORCONTACT: {
            ATTESTATIONS: {
                id: "Organization_PRIMARYVENDORCONTACT.ATTESTATIONS",
                defaultMessage: "Primary Vendor Contact"
            }
        },
        Organization_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Custom Property 1"
            }
        },
        Organization_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Custom Property 10"
            }
        },
        Organization_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Custom Property 11"
            }
        },
        Organization_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Custom Property 12"
            }
        },
        Organization_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Custom Property 13"
            }
        },
        Organization_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Custom Property 14"
            }
        },
        Organization_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Custom Property 15"
            }
        },
        Organization_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Custom Property 16"
            }
        },
        Organization_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Custom Property 17"
            }
        },
        Organization_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Custom Property 18"
            }
        },
        Organization_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Custom Property 19"
            }
        },
        Organization_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Custom Property 2"
            }
        },
        Organization_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Custom Property 20"
            }
        },
        Organization_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Custom Property 3"
            }
        },
        Organization_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Custom Property 4"
            }
        },
        Organization_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Custom Property 5"
            }
        },
        Organization_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Custom Property 6"
            }
        },
        Organization_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Custom Property 7"
            }
        },
        Organization_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Custom Property 8"
            }
        },
        Organization_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Custom Property 9"
            }
        },
        Organization_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Custom Property 21"
            }
        },
        Organization_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Custom Property 22"
            }
        },
        Organization_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Custom Property 23"
            }
        },
        Organization_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Custom Property 24"
            }
        },
        Organization_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Custom Property 25"
            }
        },
        Organization_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Custom Property 26"
            }
        },
        Organization_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Custom Property 27"
            }
        },
        Organization_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Custom Property 28"
            }
        },
        Organization_COMMENTS: {
            ATTESTATIONS: {
                id: "Organization_COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        Organization_CUSTOMERCODE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERCODE.ATTESTATIONS",
                defaultMessage: "Organization Code"
            }
        },
        Organization_CUSTOMERNAME: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERNAME.ATTESTATIONS",
                defaultMessage: "Organization Name"
            }
        },
        Organization_CUSTOMERNUMBER: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERNUMBER.ATTESTATIONS",
                defaultMessage: "Organization Number"
            }
        },
        Organization_CUSTOMERTYPE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERTYPE.ATTESTATIONS",
                defaultMessage: "Organization Type"
            }
        },
        Organization_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Organization_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        Organization_ENDDATE: {
            ATTESTATIONS: {
                id: "Organization_ENDDATE.ATTESTATIONS",
                defaultMessage: "End Date"
            }
        },
        Organization_LASTCERTIFICATIONDATE: {
            ATTESTATIONS: {
                id: "Organization_LASTCERTIFICATIONDATE.ATTESTATIONS",
                defaultMessage: "Last Certification Date"
            }
        },
        Organization_PHONENUMBER: {
            ATTESTATIONS: {
                id: "Organization_PHONENUMBER.ATTESTATIONS",
                defaultMessage: "Phone Number"
            }
        },
        Organization_RISK: {
            ATTESTATIONS: {
                id: "Organization_RISK.ATTESTATIONS",
                defaultMessage: "Risk"
            }
        },
        Organization_SCORE: {
            ATTESTATIONS: {
                id: "Organization_SCORE.ATTESTATIONS",
                defaultMessage: "Score"
            }
        },
        Organization_STARTDATE: {
            ATTESTATIONS: {
                id: "Organization_STARTDATE.ATTESTATIONS",
                defaultMessage: "Start Date"
            }
        },
        Organization_STATUS: {
            ATTESTATIONS: {
                id: "Organization_STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        Organization_PARENTCUSTOMER: {
            ATTESTATIONS: {
                id: "Organization_PARENTCUSTOMER.ATTESTATIONS",
                defaultMessage: "Parent Organization"
            }
        },
        Organization_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Organization_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        Organization_VENDORMANAGER: {
            ATTESTATIONS: {
                id: "Organization_VENDORMANAGER.ATTESTATIONS",
                defaultMessage: "Vendor Manager"
            }
        },
        Organization_CREATEUSER: {
            ATTESTATIONS: {
                id: "Organization_CREATEUSER.ATTESTATIONS",
                defaultMessage: "Create User"
            }
        },
        Organization_EVENTSOURCE: {
            ATTESTATIONS: {
                id: "Organization_EVENTSOURCE.ATTESTATIONS",
                defaultMessage: "Event Source"
            }
        },
        Organization_LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "Organization_LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last Reviewed Date"
            }
        },
        Organization_LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "Organization_LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Viewed By"
            }
        },
        Organization_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Organization_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Viewed Campaign"
            }
        },
        Organization_SAVCREATEDATE: {
            ATTESTATIONS: {
                id: "Organization_SAVCREATEDATE.ATTESTATIONS",
                defaultMessage: "SAV Create Date"
            }
        },
        Organization_SAVUPDATEDATE: {
            ATTESTATIONS: {
                id: "Organization_SAVUPDATEDATE.ATTESTATIONS",
                defaultMessage: "SAV Update Date"
            }
        },
        Organization_JOBID: {
            ATTESTATIONS: {
                id: "Organization_JOBID.ATTESTATIONS",
                defaultMessage: "Job ID"
            }
        },
        Organization_ORGOWNERS: {
            ATTESTATIONS: {
                id: "Organization_ORGOWNERS.ATTESTATIONS",
                defaultMessage: "Organization Owners"
            }
        },
        Organization_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Organization_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Display Name"
            }
        },
        Organization_CUSTOMER_TARGET_UNIQUE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMER_TARGET_UNIQUE.ATTESTATIONS",
                defaultMessage: "Target Customer"
            }
        },
        Organization_CUSTOMER_SOURCE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMER_SOURCE.ATTESTATIONS",
                defaultMessage: "Customer Source"
            }
        },
        Organization_CUSTOMERSOURCE: {
            ATTESTATIONS: {
                id: "Organization_CUSTOMERSOURCE.ATTESTATIONS",
                defaultMessage: "Customer Source"
            }
        },
        LeftDefault_ENTITLEMENTTYPE: {
            ATTESTATIONS: {
                id: "LeftDefault_ENTITLEMENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        LeftDefault_ENDPOINT: {
            ATTESTATIONS: {
                id: "LeftDefault_ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint"
            }
        },
        LeftDefault_SYSTEMNAME: {
            ATTESTATIONS: {
                id: "LeftDefault_SYSTEMNAME.ATTESTATIONS",
                defaultMessage: "System Name"
            }
        },
        LeftDefault_RISKS: {
            ATTESTATIONS: {
                id: "LeftDefault_RISKS.ATTESTATIONS",
                defaultMessage: "Risks"
            }
        },
        LeftDefault_LASTUSEDENDDATE: {
            ATTESTATIONS: {
                id: "LeftDefault_LASTUSEDENDDATE.ATTESTATIONS",
                defaultMessage: "Last Used End Date"
            }
        },
        LeftDefault_LASTCERTIFIEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "LeftDefault_LASTCERTIFIEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Certified Campaign Name"
            }
        },
        LeftDefault_ACCESSTHROUGH: {
            ATTESTATIONS: {
                id: "LeftDefault_ACCESSTHROUGH.ATTESTATIONS",
                defaultMessage: "Acces Through"
            }
        },
        LeftDefault_JRMRULES: {
            ATTESTATIONS: {
                id: "LeftDefault_JRMRULES.ATTESTATIONS",
                defaultMessage: "Outlier Analysis"
            }
        },
        ShowAttStep1Default_AUDITTRAIL: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_AUDITTRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        ShowAttStep1Default_TOTALACCOUNTS: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_TOTALACCOUNTS.ATTESTATIONS",
                defaultMessage: "Total Accounts"
            }
        },
        ShowAttStep1Default_EXTENDEDENDDATE: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_EXTENDEDENDDATE.ATTESTATIONS",
                defaultMessage: "Extended End Date"
            }
        },
        ShowAttStep1Default_UPDATEUSER: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        ShowAttStep1Default_COMMENTS: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        ShowAttStep1Default_CERTIFIED: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_CERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        ShowAttStep1Default_ENDDATE: {
            ATTESTATIONS: {
                id: "ShowAttStep1Default_ENDDATE.ATTESTATIONS",
                defaultMessage: "End Date"
            }
        },
        REASSIGNSTEP2: {
            ATTESTATIONS: {
                id: "REASSIGNSTEP2.ATTESTATIONS.label",
                defaultMessage: "Reassign"
            }
        },
        Account_ENDDATE: {
            ATTESTATIONS: {
                id: "Account_ENDDATE.ATTESTATIONS",
                defaultMessage: "Account End Date"
            }
        },
        Account_CREATEDON: {
            ATTESTATIONS: {
                id: "Account_CREATEDON.ATTESTATIONS",
                defaultMessage: "Account Created On"
            }
        },
        Ent_PRIVILIGED: {
            ATTESTATIONS: {
                id: "Ent_PRIVILIGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Ent_SYSCRITICAL: {
            ATTESTATIONS: {
                id: "Ent_SYSCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Ent_ENDDATE: {
            ATTESTATIONS: {
                id: "Ent_ENDDATE.ATTESTATIONS",
                defaultMessage: "Entitlement End Date"
            }
        },
        Ent_SOXCRITICAL: {
            ATTESTATIONS: {
                id: "Ent_SOXCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Ent_GLOSSARY: {
            ATTESTATIONS: {
                id: "Ent_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        YES_BelongsToMe: {
            ATTESTATIONS: {
                id: "YES_BelongsToMe.ATTESTATIONS",
                defaultMessage: "Belongs To Me"
            }
        },
        NO_Decommission: {
            ATTESTATIONS: {
                id: "NO_Decommission.ATTESTATIONS",
                defaultMessage: "Decommission"
            }
        },
        DOES_NOT_BELONG_TO_ME: {
            ATTESTATIONS: {
                id: "DOES_NOT_BELONG_TO_ME.ATTESTATIONS",
                defaultMessage: "Does Not Belong to Me"
            }
        },
        CONSULT: {
            ATTESTATIONS: {
                id: "CONSULT.ATTESTATIONS",
                defaultMessage: "Consult"
            }
        },
        YES_Approve: {
            ATTESTATIONS: {
                id: "YES_Approve.ATTESTATIONS",
                defaultMessage: "Approve"
            }
        },
        NO_Reject: {
            ATTESTATIONS: {
                id: "NO_Reject.ATTESTATIONS",
                defaultMessage: "Reject"
            }
        },
        User_SECONDARYPHONE: {
            ATTESTATIONS: {
                id: "User_SECONDARYPHONE.ATTESTATIONS",
                defaultMessage: "Secondary Phone"
            }
        },
        User_SECONDARYEMAIL: {
            ATTESTATIONS: {
                id: "User_SECONDARYEMAIL.ATTESTATIONS",
                defaultMessage: "Secondary Email"
            }
        },
        User_JOBID: {
            ATTESTATIONS: {
                id: "User_JOBID.ATTESTATIONS",
                defaultMessage: "User Job ID"
            }
        },
        User_UPDATEDATE: {
            ATTESTATIONS: {
                id: "User_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "User Update Date"
            }
        },
        User_CREATEDBY: {
            ATTESTATIONS: {
                id: "User_CREATEDBY.ATTESTATIONS",
                defaultMessage: "Created By"
            }
        },
        User_LEAVESTATUS: {
            ATTESTATIONS: {
                id: "User_LEAVESTATUS.ATTESTATIONS",
                defaultMessage: "Leave Status"
            }
        },
        User_PREFEREDFIRSTNAME: {
            ATTESTATIONS: {
                id: "User_PREFEREDFIRSTNAME.ATTESTATIONS",
                defaultMessage: "Preferred First Name"
            }
        },
        User_CUSTOMER: {
            ATTESTATIONS: {
                id: "User_CUSTOMER.ATTESTATIONS",
                defaultMessage: "User Customer"
            }
        },
        User_LOCALE: {
            ATTESTATIONS: {
                id: "User_LOCALE.ATTESTATIONS",
                defaultMessage: "User Locale"
            }
        },
        User_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "User Custom Property 41"
            }
        },
        User_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "User Custom Property 42"
            }
        },
        User_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "User Custom Property 43"
            }
        },
        User_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "User Custom Property 44"
            }
        },
        User_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "User Custom Property 45"
            }
        },
        User_CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "User Custom Property 46"
            }
        },
        User_CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "User Custom Property 47"
            }
        },
        User_CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "User Custom Property 48"
            }
        },
        User_CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "User Custom Property 49"
            }
        },
        User_CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "User Custom Property 50"
            }
        },
        User_CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "User Custom Property 51"
            }
        },
        User_CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "User Custom Property 52"
            }
        },
        User_CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "User Custom Property 53"
            }
        },
        User_CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "User Custom Property 54"
            }
        },
        User_CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "User Custom Property 55"
            }
        },
        User_CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "User Custom Property 56"
            }
        },
        User_CUSTOMPROPERTY57: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY57.ATTESTATIONS",
                defaultMessage: "User Custom Property 57"
            }
        },
        User_CUSTOMPROPERTY58: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY58.ATTESTATIONS",
                defaultMessage: "User Custom Property 58"
            }
        },
        User_CUSTOMPROPERTY59: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY59.ATTESTATIONS",
                defaultMessage: "User Custom Property 59"
            }
        },
        User_CUSTOMPROPERTY60: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY60.ATTESTATIONS",
                defaultMessage: "User Custom Property 60"
            }
        },
        User_CUSTOMPROPERTY61: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY61.ATTESTATIONS",
                defaultMessage: "User Custom Property 61"
            }
        },
        User_CUSTOMPROPERTY62: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY62.ATTESTATIONS",
                defaultMessage: "User Custom Property 62"
            }
        },
        User_CUSTOMPROPERTY63: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY63.ATTESTATIONS",
                defaultMessage: "User Custom Property 63"
            }
        },
        User_CUSTOMPROPERTY64: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY64.ATTESTATIONS",
                defaultMessage: "User Custom Property 64"
            }
        },
        User_CUSTOMPROPERTY65: {
            ATTESTATIONS: {
                id: "User_CUSTOMPROPERTY65.ATTESTATIONS",
                defaultMessage: "User Custom Property 65"
            }
        },
        serviceAccDefault_NAME: {
            ATTESTATIONS: {
                id: "serviceAccDefault_NAME.ATTESTATIONS",
                defaultMessage: "Name"
            }
        },
        serviceAccDefault_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "serviceAccDefault_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Display Name"
            }
        },
        serviceAccDefault_SECURITYSYSTEM: {
            ATTESTATIONS: {
                id: "serviceAccDefault_SECURITYSYSTEM.ATTESTATIONS",
                defaultMessage: "Security System"
            }
        },
        serviceAccDefault_COMMENTS: {
            ATTESTATIONS: {
                id: "serviceAccDefault_COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        serviceAccDefault_AUDITTRAIL: {
            ATTESTATIONS: {
                id: "serviceAccDefault_AUDITTRAIL.ATTESTATIONS",
                defaultMessage: "Audit Trail"
            }
        },
        serviceAccDefault_ENDPOINTS: {
            ATTESTATIONS: {
                id: "serviceAccDefault_ENDPOINTS.ATTESTATIONS",
                defaultMessage: "Endpoints"
            }
        },
        serviceAccDefault_DESCRIPTION: {
            ATTESTATIONS: {
                id: "serviceAccDefault_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        serviceAccDefault_STATUS: {
            ATTESTATIONS: {
                id: "serviceAccDefault_STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        JobControl: {
            ATTESTATIONS: {
                id: "JobControl.ATTESTATION.label",
                defaultMessage: "ATTESTATION"
            }
        },
        Account_ACCOUNTSTATUS: {
            ATTESTATIONS: {
                id: "Account_ACCOUNTSTATUS.ATTESTATIONS",
                defaultMessage: "Account Status"
            }
        },
        ELEMENTTYPE: {
            ATTESTATIONS: {
                id: "ELEMENTTYPE.ATTESTATIONS",
                defaultMessage: "Element Type"
            }
        },
        ENDPOINTNAME: {
            ATTESTATIONS: {
                id: "ENDPOINTNAME.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        Endpoint_ENDPOINTNAME: {
            ATTESTATIONS: {
                id: "Endpoint_ENDPOINTNAME.ATTESTATIONS",
                defaultMessage: "Endpointname"
            }
        },
        Endpoint_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Endpoint_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        Endpoint_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property1"
            }
        },
        Endpoint_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property2"
            }
        },
        Endpoint_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property3"
            }
        },
        Endpoint_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property4"
            }
        },
        Endpoint_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property5"
            }
        },
        Endpoint_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property6"
            }
        },
        Endpoint_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property7"
            }
        },
        Endpoint_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property8"
            }
        },
        Endpoint_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property9"
            }
        },
        Endpoint_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property10"
            }
        },
        Endpoint_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property11"
            }
        },
        Endpoint_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property12"
            }
        },
        Endpoint_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property13"
            }
        },
        Endpoint_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property14"
            }
        },
        Endpoint_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property15"
            }
        },
        Endpoint_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property16"
            }
        },
        Endpoint_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property17"
            }
        },
        Endpoint_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property18"
            }
        },
        Endpoint_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property19"
            }
        },
        Endpoint_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property20"
            }
        },
        Endpoint_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property21"
            }
        },
        Endpoint_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property22"
            }
        },
        Endpoint_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property23"
            }
        },
        Endpoint_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property24"
            }
        },
        Endpoint_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property25"
            }
        },
        Endpoint_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property26"
            }
        },
        Endpoint_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property27"
            }
        },
        Endpoint_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property28"
            }
        },
        Endpoint_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property29"
            }
        },
        Endpoint_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property30"
            }
        },
        Endpoint_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property31"
            }
        },
        Endpoint_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property32"
            }
        },
        Endpoint_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property33"
            }
        },
        Endpoint_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property34"
            }
        },
        Endpoint_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property35"
            }
        },
        Endpoint_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property36"
            }
        },
        Endpoint_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property37"
            }
        },
        Endpoint_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property38"
            }
        },
        Endpoint_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property39"
            }
        },
        Endpoint_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property40"
            }
        },
        Endpoint_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property41"
            }
        },
        Endpoint_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property42"
            }
        },
        Endpoint_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property43"
            }
        },
        Endpoint_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property44"
            }
        },
        Endpoint_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property45"
            }
        },
        Endpoint_CUSTOMPROPERTY1LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY1LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 1 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY2LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY2LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 2 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY3LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY3LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 3 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY4LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY4LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 4 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY5LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY5LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 5 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY6LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY6LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 6 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY7LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY7LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 7 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY8LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY8LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 8 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY9LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY9LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 9 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY10LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY10LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 10 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY11LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY11LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 11 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY12LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY12LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 12 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY13LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY13LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 13 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY14LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY14LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 14 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY15LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY15LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 15 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY16LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY16LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 16 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY17LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY17LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 17 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY18LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY18LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 18 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY19LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY19LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 19 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY20LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY20LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 20 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY21LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY21LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 21 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY22LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY22LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 22 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY23LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY23LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 23 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY24LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY24LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 24 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY25LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY25LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 25 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY26LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY26LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 26 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY27LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY27LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 27 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY28LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY28LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 28 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY29LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY29LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 29 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY30LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY30LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 30 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY31LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY31LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 31 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY32LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY32LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 32 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY33LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY33LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 33 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY34LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY34LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 34 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY35LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY35LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 35 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY36LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY36LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 36 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY37LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY37LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 37 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY38LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY38LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 38 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY39LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY39LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 39 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY40LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY40LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 40 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY41LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY41LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 41 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY42LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY42LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 42 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY43LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY43LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 43 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY44LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY44LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 44 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY45LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY45LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 45 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY46LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY46LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 46 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY47LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY47LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 47 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY48LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY48LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 48 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY49LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY49LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 49 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY50LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY50LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 50 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY51LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY51LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 51 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY52LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY52LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 52 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY53LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY53LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 53 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY54LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY54LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 54 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY55LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY55LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 55 Label"
            }
        },
        Endpoint_CUSTOMPROPERTY56LABEL: {
            ATTESTATIONS: {
                id: "Endpoint_CUSTOMPROPERTY56LABEL.ATTESTATIONS",
                defaultMessage: "Endpoint Custom Property 56 Label"
            }
        },
        Endpoint_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Endpoint_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Displayname"
            }
        },
        Endpoint_STATUS: {
            ATTESTATIONS: {
                id: "Endpoint_STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        Endpoint_ROLETYPEASJSON: {
            ATTESTATIONS: {
                id: "Endpoint_ROLETYPEASJSON.ATTESTATIONS",
                defaultMessage: "Role Type as Json"
            }
        },
        Endpoint_CREATEDBY: {
            ATTESTATIONS: {
                id: "Endpoint_CREATEDBY.ATTESTATIONS",
                defaultMessage: "Created By"
            }
        },
        Endpoint_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Endpoint_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Update Date"
            }
        },
        Endpoint_CREATEDATE: {
            ATTESTATIONS: {
                id: "Endpoint_CREATEDATE.ATTESTATIONS",
                defaultMessage: "Create Date"
            }
        },
        Endpoint_UPDATEDBY: {
            ATTESTATIONS: {
                id: "Endpoint_UPDATEDBY.ATTESTATIONS",
                defaultMessage: "Updated By"
            }
        },
        Endpoint_CREATEDFROM: {
            ATTESTATIONS: {
                id: "Endpoint_CREATEDFROM.ATTESTATIONS",
                defaultMessage: "Created From"
            }
        },
        Endpoint_LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "Endpoint_LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last Reviewed Date"
            }
        },
        Endpoint_LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "Endpoint_LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Reviewed By"
            }
        },
        Ent_SODDETAILDATA: {
            ATTESTATIONS: {
                id: "Ent_SODDETAILDATA.ATTESTATIONS",
                defaultMessage: "SOD Detail Data"
            }
        },
        Ent_CREATEDATE: {
            ATTESTATIONS: {
                id: "Ent_CREATEDATE.ATTESTATIONS",
                defaultMessage: "Create  Date"
            }
        },
        Role_ROLE_NAME: {
            ATTESTATIONS: {
                id: "Role_ROLE_NAME.ATTESTATIONS",
                defaultMessage: "Role Name"
            }
        },
        Role_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Role_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        ROW_TYPE: {
            ATTESTATIONS: {
                id: "ROW_TYPE.ATTESTATIONS",
                defaultMessage: "Rows"
            }
        },
        Role_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Role_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Role"
            }
        },
        Role_STATUS: {
            ATTESTATIONS: {
                id: "Role_STATUS.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        Role_CRITICALITY: {
            ATTESTATIONS: {
                id: "Role_CRITICALITY.ATTESTATIONS",
                defaultMessage: "Role Crititcality"
            }
        },
        Role_CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "CustomProperty 41"
            }
        },
        Role_CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "CustomProperty 42"
            }
        },
        Role_CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "CustomProperty 43"
            }
        },
        Role_CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "CustomProperty 44"
            }
        },
        Role_CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "CustomProperty 45"
            }
        },
        Role_CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "CustomProperty 46"
            }
        },
        Role_CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "CustomProperty 47"
            }
        },
        Role_CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "CustomProperty 48"
            }
        },
        Role_CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "CustomProperty 49"
            }
        },
        Role_CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "CustomProperty 50"
            }
        },
        Role_CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "CustomProperty 51"
            }
        },
        Role_CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "CustomProperty 52"
            }
        },
        Role_CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "CustomProperty 53"
            }
        },
        Role_CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "CustomProperty 54"
            }
        },
        Role_CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "CustomProperty 55"
            }
        },
        Role_CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "CustomProperty 56"
            }
        },
        Role_CUSTOMPROPERTY57: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY57.ATTESTATIONS",
                defaultMessage: "CustomProperty 57"
            }
        },
        Role_CUSTOMPROPERTY58: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY58.ATTESTATIONS",
                defaultMessage: "CustomProperty 58"
            }
        },
        Role_CUSTOMPROPERTY59: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY59.ATTESTATIONS",
                defaultMessage: "CustomProperty 59"
            }
        },
        Role_CUSTOMPROPERTY60: {
            ATTESTATIONS: {
                id: "Role_CUSTOMPROPERTY60.ATTESTATIONS",
                defaultMessage: "CustomProperty 60"
            }
        },
        EntitlementType_ENTITLEMENTNAME: {
            ATTESTATIONS: {
                id: "EntitlementType_ENTITLEMENTNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Name"
            }
        },
        EntitlementType_ENTITLEMENTDESCRIPTION: {
            ATTESTATIONS: {
                id: "EntitlementType_ENTITLEMENTDESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        EntitlementType_REQUIREDINREQUEST: {
            ATTESTATIONS: {
                id: "EntitlementType_REQUIREDINREQUEST.ATTESTATIONS",
                defaultMessage: "Required Inrequest"
            }
        },
        EntitlementType_CREATETASKACTION: {
            ATTESTATIONS: {
                id: "EntitlementType_CREATETASKACTION.ATTESTATIONS",
                defaultMessage: "Create Task Action"
            }
        },
        EntitlementType_RECON: {
            ATTESTATIONS: {
                id: "EntitlementType_RECON.ATTESTATIONS",
                defaultMessage: "Recon"
            }
        },
        EntitlementType_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "EntitlementType_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Displayname"
            }
        },
        EntitlementType_CUSTOMPROPERTY1_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY1_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 1 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY2_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY2_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 2 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY3_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY3_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 3 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY4_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY4_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 4 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY5_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY5_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 5 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY6_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY6_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 6 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY7_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY7_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 7 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY8_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY8_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 8 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY9_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY9_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 9 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY10_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY10_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 10 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY11_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY11_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 11 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY12_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY12_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 12 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY13_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY13_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 13 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY14_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY14_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 14 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY15_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY15_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 15 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY16_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY16_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 16 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY17_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY17_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 17 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY18_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY18_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 18 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY19_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY19_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 19 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY20_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY20_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 20 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY21_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY21_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 21 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY22_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY22_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 22 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY23_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY23_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 23 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY24_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY24_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 24 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY25_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY25_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 25 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY26_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY26_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 26 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY27_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY27_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 27 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY28_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY28_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 28 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY29_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY29_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 29 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY30_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY30_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 30 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY31_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY31_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 31 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY32_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY32_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 32 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY33_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY33_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 33 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY34_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY34_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 34 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY35_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY35_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 35 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY36_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY36_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 36 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY37_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY37_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 37 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY38_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY38_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 38 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY39_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY39_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 39 label"
            }
        },
        EntitlementType_CUSTOMPROPERTY40_LABEL: {
            ATTESTATIONS: {
                id: "EntitlementType_CUSTOMPROPERTY40_LABEL.ATTESTATIONS",
                defaultMessage: "EntitlementType CustomProperty 40 label"
            }
        },
        ROLE_NAME: {
            ATTESTATIONS: {
                id: "ROLE_NAME.ATTESTATIONS",
                defaultMessage: "Role Name"
            }
        },
        ROLETYPE: {
            ATTESTATIONS: {
                id: "ROLETYPE.ATTESTATIONS",
                defaultMessage: "Role Type"
            }
        },
        DESCRIPTION: {
            ATTESTATIONS: {
                id: "DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        Ent_APPROVERNAME: {
            ATTESTATIONS: {
                id: "Ent_APPROVERNAME.ATTESTATIONS",
                defaultMessage: "Approver Level"
            }
        },
        APPROVERNAME: {
            ATTESTATIONS: {
                id: "APPROVERNAME.ATTESTATIONS",
                defaultMessage: "Approver Level"
            }
        },
        NAME: {
            ATTESTATIONS: {
                id: "NAME.ATTESTATIONS",
                defaultMessage: "Account Name"
            }
        },
        APPROVERTYPE: {
            ATTESTATIONS: {
                id: "APPROVERTYPE.ATTESTATIONS",
                defaultMessage: "Approver Type"
            }
        },
        APPROVERVALUE: {
            ATTESTATIONS: {
                id: "APPROVERVALUE.ATTESTATIONS",
                defaultMessage: "Approver Value"
            }
        },
        LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last Review Date"
            }
        },
        LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Reviewed By"
            }
        },
        RE_DESCRIPTION: {
            ATTESTATIONS: {
                id: "RE_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Description"
            }
        },
        RISK: {
            ATTESTATIONS: {
                id: "RISK.ATTESTATIONS",
                defaultMessage: "Risk"
            }
        },
        Endpoint_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Endpoint_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        Ent_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Ent_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        EntitlementType_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "EntitlementType_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        Role_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Role_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        Ent_LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "Ent_LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last reviewed Date"
            }
        },
        Ent_LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "Ent_LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Reviewed By"
            }
        },
        Ent_PRIORITY: {
            ATTESTATIONS: {
                id: "Ent_PRIORITY.ATTESTATIONS",
                defaultMessage: "Entitlement Priority"
            }
        },
        ELEMENTNAME: {
            ATTESTATIONS: {
                id: "ELEMENTNAME.ATTESTATIONS",
                defaultMessage: "Element Name"
            }
        },
        CERTIFICATIONSTATUS: {
            ATTESTATIONS: {
                id: "CERTIFICATIONSTATUS.ATTESTATIONS",
                defaultMessage: "Certification Status"
            }
        },
        CERTIFIERNAME: {
            ATTESTATIONS: {
                id: "CERTIFIERNAME.ATTESTATIONS",
                defaultMessage: "Certifier Name"
            }
        },
        Account_NEWOWNER: {
            ATTESTATIONS: {
                id: "Account_NEWOWNER.ATTESTATIONS",
                defaultMessage: "Account New Owner"
            }
        },
        Account_OLDOWNER: {
            ATTESTATIONS: {
                id: "Account_OLDOWNER.ATTESTATIONS",
                defaultMessage: "Account Old Owner"
            }
        },
        Ent_OLDENTITLEMENTOWNER: {
            ATTESTATIONS: {
                id: "Ent_OLDENTITLEMENTOWNER.ATTESTATIONS",
                defaultMessage: "Entitlement Old Owner"
            }
        },
        User_CREATEDATE: {
            ATTESTATIONS: {
                id: "User_CREATEDATE.ATTESTATIONS",
                defaultMessage: "User Create Date"
            }
        },
        totalAccounts: {
            ATTESTATIONS: {
                id: "totalAccounts.ATTESTATIONS",
                defaultMessage: "Total Accounts"
            }
        },
        extendedendDate: {
            ATTESTATIONS: {
                id: "extendedendDate.ATTESTATIONS",
                defaultMessage: "Extended End Date"
            }
        },
        updateuser: {
            ATTESTATIONS: {
                id: "updateuser.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        certified: {
            ATTESTATIONS: {
                id: "certified.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        CERT_USERKEY: {
            ATTESTATIONS: {
                id: "CERT_USERKEY.ATTESTATIONS",
                defaultMessage: "Certification User Key"
            }
        },
        DISPLAYNAME: {
            ATTESTATIONS: {
                id: "DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "User Display Name"
            }
        },
        USERKEY: {
            ATTESTATIONS: {
                id: "USERKEY.ATTESTATIONS",
                defaultMessage: "User Key"
            }
        },
        TERMDATE: {
            ATTESTATIONS: {
                id: "TERMDATE.ATTESTATIONS",
                defaultMessage: "User Term Date"
            }
        },
        FIRSTNAME: {
            ATTESTATIONS: {
                id: "FIRSTNAME.ATTESTATIONS",
                defaultMessage: "User First Name"
            }
        },
        TOTALACCOUNTS: {
            ATTESTATIONS: {
                id: "TOTALACCOUNTS.ATTESTATIONS",
                defaultMessage: "Total Accounts"
            }
        },
        AUDITTRAIL: {
            ATTESTATIONS: {
                id: "AUDITTRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        UPDATEUSER: {
            ATTESTATIONS: {
                id: "UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Update User"
            }
        },
        LASTNAME: {
            ATTESTATIONS: {
                id: "LASTNAME.ATTESTATIONS",
                defaultMessage: "User Last Name"
            }
        },
        MIDDLENAME: {
            ATTESTATIONS: {
                id: "MIDDLENAME.ATTESTATIONS",
                defaultMessage: "User Middle Name"
            }
        },
        STREET: {
            ATTESTATIONS: {
                id: "STREET.ATTESTATIONS",
                defaultMessage: "User Street"
            }
        },
        CITY: {
            ATTESTATIONS: {
                id: "CITY.ATTESTATIONS",
                defaultMessage: "City"
            }
        },
        EMAIL: {
            ATTESTATIONS: {
                id: "EMAIL.ATTESTATIONS",
                defaultMessage: "User Email"
            }
        },
        STATUSKEY: {
            ATTESTATIONS: {
                id: "STATUSKEY.ATTESTATIONS",
                defaultMessage: "User Status"
            }
        },
        STARTDATE: {
            ATTESTATIONS: {
                id: "STARTDATE.ATTESTATIONS",
                defaultMessage: "User Start Date"
            }
        },
        ENDDATE: {
            ATTESTATIONS: {
                id: "ENDDATE.ATTESTATIONS",
                defaultMessage: "End Date"
            }
        },
        MANAGER: {
            ATTESTATIONS: {
                id: "MANAGER.ATTESTATIONS",
                defaultMessage: "User Manager"
            }
        },
        PASSWORD: {
            ATTESTATIONS: {
                id: "PASSWORD.ATTESTATIONS",
                defaultMessage: "User Password"
            }
        },
        ENABLED: {
            ATTESTATIONS: {
                id: "ENABLED.ATTESTATIONS",
                defaultMessage: "User Enabled"
            }
        },
        LOCATION: {
            ATTESTATIONS: {
                id: "LOCATION.ATTESTATIONS",
                defaultMessage: "User Location"
            }
        },
        JOBCODE: {
            ATTESTATIONS: {
                id: "JOBCODE.ATTESTATIONS",
                defaultMessage: "User Job Code"
            }
        },
        JOBDESCRIPTION: {
            ATTESTATIONS: {
                id: "JOBDESCRIPTION.ATTESTATIONS",
                defaultMessage: "User Job Description"
            }
        },
        EMPLOYEETYPE: {
            ATTESTATIONS: {
                id: "EMPLOYEETYPE.ATTESTATIONS",
                defaultMessage: "User Employee Type"
            }
        },
        SYSTEMUSERNAME: {
            ATTESTATIONS: {
                id: "SYSTEMUSERNAME.ATTESTATIONS",
                defaultMessage: "User System Username"
            }
        },
        DEPARTMENTNUMBER: {
            ATTESTATIONS: {
                id: "DEPARTMENTNUMBER.ATTESTATIONS",
                defaultMessage: "User Department Number"
            }
        },
        TITLE: {
            ATTESTATIONS: {
                id: "TITLE.ATTESTATIONS",
                defaultMessage: "User Title"
            }
        },
        STATE: {
            ATTESTATIONS: {
                id: "STATE.ATTESTATIONS",
                defaultMessage: "User State"
            }
        },
        COMPANYNAME: {
            ATTESTATIONS: {
                id: "COMPANYNAME.ATTESTATIONS",
                defaultMessage: "User Company Name"
            }
        },
        COSTCENTER: {
            ATTESTATIONS: {
                id: "COSTCENTER.ATTESTATIONS",
                defaultMessage: "User Cost Centre"
            }
        },
        DEPARTMENTNAME: {
            ATTESTATIONS: {
                id: "DEPARTMENTNAME.ATTESTATIONS",
                defaultMessage: "User Department Name"
            }
        },
        EMPLOYEECLASS: {
            ATTESTATIONS: {
                id: "EMPLOYEECLASS.ATTESTATIONS",
                defaultMessage: "User Employee Class"
            }
        },
        ENTITY: {
            ATTESTATIONS: {
                id: "ENTITY.ATTESTATIONS",
                defaultMessage: "User Entity"
            }
        },
        JOBCODEDESC: {
            ATTESTATIONS: {
                id: "JOBCODEDESC.ATTESTATIONS",
                defaultMessage: "User Job Code Description"
            }
        },
        LOCATIONDESC: {
            ATTESTATIONS: {
                id: "LOCATIONDESC.ATTESTATIONS",
                defaultMessage: "User Location Description"
            }
        },
        LOCATIONNUMBER: {
            ATTESTATIONS: {
                id: "LOCATIONNUMBER.ATTESTATIONS",
                defaultMessage: "User Location Number"
            }
        },
        SITEID: {
            ATTESTATIONS: {
                id: "SITEID.ATTESTATIONS",
                defaultMessage: "User Site"
            }
        },
        ORGUNITID: {
            ATTESTATIONS: {
                id: "ORGUNITID.ATTESTATIONS",
                defaultMessage: "User Organization Unit"
            }
        },
        REGION: {
            ATTESTATIONS: {
                id: "REGION.ATTESTATIONS",
                defaultMessage: "User Region"
            }
        },
        REGIONCODE: {
            ATTESTATIONS: {
                id: "REGIONCODE.ATTESTATIONS",
                defaultMessage: "User Region Code"
            }
        },
        OWNER: {
            ATTESTATIONS: {
                id: "OWNER.ATTESTATIONS",
                defaultMessage: "User Owner"
            }
        },
        EMPLOYEEID: {
            ATTESTATIONS: {
                id: "EMPLOYEEID.ATTESTATIONS",
                defaultMessage: "User Employee"
            }
        },
        LASTSYNCDATE: {
            ATTESTATIONS: {
                id: "LASTSYNCDATE.ATTESTATIONS",
                defaultMessage: "User Last Sync Date"
            }
        },
        PHONENUMBER: {
            ATTESTATIONS: {
                id: "PHONENUMBER.ATTESTATIONS",
                defaultMessage: "User Phone Number"
            }
        },
        COUNTRY: {
            ATTESTATIONS: {
                id: "COUNTRY.ATTESTATIONS",
                defaultMessage: "User Country"
            }
        },
        ACCOUNTEXPIRED: {
            ATTESTATIONS: {
                id: "ACCOUNTEXPIRED.ATTESTATIONS",
                defaultMessage: "User Account Expired"
            }
        },
        ACCOUNTLOCKED: {
            ATTESTATIONS: {
                id: "ACCOUNTLOCKED.ATTESTATIONS",
                defaultMessage: "User Account Locked"
            }
        },
        PASSWORDEXPIRED: {
            ATTESTATIONS: {
                id: "PASSWORDEXPIRED.ATTESTATIONS",
                defaultMessage: "User Password Expired"
            }
        },
        JOB_FUNCTION: {
            ATTESTATIONS: {
                id: "JOB_FUNCTION.ATTESTATIONS",
                defaultMessage: "User Job Function"
            }
        },
        DONOTDISTURBDELEGATE: {
            ATTESTATIONS: {
                id: "DONOTDISTURBDELEGATE.ATTESTATIONS",
                defaultMessage: "User Do Not Disturb Delegate"
            }
        },
        CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "User Custom Property 1"
            }
        },
        CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "User Custom Property 2"
            }
        },
        CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "User Custom Property 3"
            }
        },
        CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "User Custom Property 4"
            }
        },
        CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "User Custom Property 5"
            }
        },
        CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "User Custom Property 6"
            }
        },
        CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "User Custom Property 7"
            }
        },
        CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "User Custom Property 8"
            }
        },
        CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "User Custom Property 9"
            }
        },
        CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "User Custom Property 10"
            }
        },
        CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "User Custom Property 11"
            }
        },
        CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "User Custom Property 12"
            }
        },
        CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "User Custom Property 13"
            }
        },
        CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "User Custom Property 14"
            }
        },
        CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "User Custom Property 15"
            }
        },
        CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "User Custom Property 16"
            }
        },
        CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "User Custom Property 17"
            }
        },
        CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "User Custom Property 18"
            }
        },
        CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "User Custom Property 19"
            }
        },
        CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "User Custom Property 20"
            }
        },
        CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "User Custom Property 21"
            }
        },
        CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "User Custom Property 22"
            }
        },
        CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "User Custom Property 23"
            }
        },
        CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "User Custom Property 24"
            }
        },
        CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "User Custom Property 25"
            }
        },
        CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "User Custom Property 26"
            }
        },
        CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "User Custom Property 27"
            }
        },
        CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "User Custom Property 28"
            }
        },
        CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "User Custom Property 29"
            }
        },
        CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "User Custom Property 30"
            }
        },
        CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "User Custom Property 31"
            }
        },
        CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "User Custom Property 32"
            }
        },
        CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "User Custom Property 33"
            }
        },
        CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "User Custom Property 34"
            }
        },
        CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "User Custom Property 35"
            }
        },
        CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "User Custom Property 36"
            }
        },
        CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "User Custom Property 37"
            }
        },
        CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "User Custom Property 38"
            }
        },
        CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "User Custom Property 39"
            }
        },
        CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "User Custom Property 40"
            }
        },
        CUSTOMPROPERTY41: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY41.ATTESTATIONS",
                defaultMessage: "User Custom Property 41"
            }
        },
        CUSTOMPROPERTY42: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY42.ATTESTATIONS",
                defaultMessage: "User Custom Property 42"
            }
        },
        CUSTOMPROPERTY43: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY43.ATTESTATIONS",
                defaultMessage: "User Custom Property 43"
            }
        },
        CUSTOMPROPERTY44: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY44.ATTESTATIONS",
                defaultMessage: "User Custom Property 44"
            }
        },
        CUSTOMPROPERTY45: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY45.ATTESTATIONS",
                defaultMessage: "User Custom Property 45"
            }
        },
        CUSTOMPROPERTY46: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY46.ATTESTATIONS",
                defaultMessage: "User Custom Property 46"
            }
        },
        CUSTOMPROPERTY47: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY47.ATTESTATIONS",
                defaultMessage: "User Custom Property 47"
            }
        },
        CUSTOMPROPERTY48: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY48.ATTESTATIONS",
                defaultMessage: "User Custom Property 48"
            }
        },
        CUSTOMPROPERTY49: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY49.ATTESTATIONS",
                defaultMessage: "User Custom Property 49"
            }
        },
        CUSTOMPROPERTY50: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY50.ATTESTATIONS",
                defaultMessage: "User Custom Property 50"
            }
        },
        CUSTOMPROPERTY51: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY51.ATTESTATIONS",
                defaultMessage: "User Custom Property 51"
            }
        },
        CUSTOMPROPERTY52: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY52.ATTESTATIONS",
                defaultMessage: "User Custom Property 52"
            }
        },
        CUSTOMPROPERTY53: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY53.ATTESTATIONS",
                defaultMessage: "User Custom Property 53"
            }
        },
        CUSTOMPROPERTY54: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY54.ATTESTATIONS",
                defaultMessage: "User Custom Property 54"
            }
        },
        CUSTOMPROPERTY55: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY55.ATTESTATIONS",
                defaultMessage: "User Custom Property 55"
            }
        },
        CUSTOMPROPERTY56: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY56.ATTESTATIONS",
                defaultMessage: "User Custom Property 56"
            }
        },
        CUSTOMPROPERTY57: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY57.ATTESTATIONS",
                defaultMessage: "User Custom Property 57"
            }
        },
        CUSTOMPROPERTY58: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY58.ATTESTATIONS",
                defaultMessage: "User Custom Property 58"
            }
        },
        CUSTOMPROPERTY59: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY59.ATTESTATIONS",
                defaultMessage: "User Custom Property 59"
            }
        },
        CUSTOMPROPERTY60: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY60.ATTESTATIONS",
                defaultMessage: "User Custom Property 60"
            }
        },
        CUSTOMPROPERTY61: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY61.ATTESTATIONS",
                defaultMessage: "User Custom Property 61"
            }
        },
        CUSTOMPROPERTY62: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY62.ATTESTATIONS",
                defaultMessage: "User Custom Property 62"
            }
        },
        CUSTOMPROPERTY63: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY63.ATTESTATIONS",
                defaultMessage: "User Custom Property 63"
            }
        },
        CUSTOMPROPERTY64: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY64.ATTESTATIONS",
                defaultMessage: "User Custom Property 64"
            }
        },
        CUSTOMPROPERTY65: {
            ATTESTATIONS: {
                id: "CUSTOMPROPERTY65.ATTESTATIONS",
                defaultMessage: "User Custom Property 65"
            }
        },
        RISKSCORE: {
            ATTESTATIONS: {
                id: "RISKSCORE.ATTESTATIONS",
                defaultMessage: "User Risk Score"
            }
        },
        EXTENDEDENDDATE: {
            ATTESTATIONS: {
                id: "EXTENDEDENDDATE.ATTESTATIONS",
                defaultMessage: "User Extended Date"
            }
        },
        LASTCERTIFIEDDATE: {
            ATTESTATIONS: {
                id: "LASTCERTIFIEDDATE.ATTESTATIONS",
                defaultMessage: "Last Certified Date"
            }
        },
        CREATEDATE: {
            ATTESTATIONS: {
                id: "CREATEDATE.ATTESTATIONS",
                defaultMessage: "User Create Date"
            }
        },
        CREATEDBY: {
            ATTESTATIONS: {
                id: "CREATEDBY.ATTESTATIONS",
                defaultMessage: "created By"
            }
        },
        SECONDARYPHONE: {
            ATTESTATIONS: {
                id: "SECONDARYPHONE.ATTESTATIONS",
                defaultMessage: "User Secondary Phone"
            }
        },
        SECONDARYEMAIL: {
            ATTESTATIONS: {
                id: "SECONDARYEMAIL.ATTESTATIONS",
                defaultMessage: "User Secondary Email"
            }
        },
        PREFEREDFIRSTNAME: {
            ATTESTATIONS: {
                id: "PREFEREDFIRSTNAME.ATTESTATIONS",
                defaultMessage: "User Prefered First Name"
            }
        },
        LEAVESTATUS: {
            ATTESTATIONS: {
                id: "LEAVESTATUS.ATTESTATIONS",
                defaultMessage: "User Leave Status"
            }
        },
        OLDVALUE: {
            ATTESTATIONS: {
                id: "OLDVALUE.ATTESTATIONS",
                defaultMessage: "Old Value"
            }
        },
        NEWVALUE: {
            ATTESTATIONS: {
                id: "NEWVALUE.ATTESTATIONS",
                defaultMessage: "New Value"
            }
        },
        FIELDNAME: {
            ATTESTATIONS: {
                id: "FIELDNAME.ATTESTATIONS",
                defaultMessage: "Field Name"
            }
        },
        MODIFIEDON: {
            ATTESTATIONS: {
                id: "MODIFIEDON.ATTESTATIONS",
                defaultMessage: "Modified On"
            }
        },
        User_USERCOMMENTS: {
            ATTESTATIONS: {
                id: "User_USERCOMMENTS.ATTESTATIONS",
                defaultMessage: "User Comments"
            }
        },
        User_CERTCOMMENTS: {
            ATTESTATIONS: {
                id: "User_CERTCOMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        Account_CUSTOMPROPERTY57: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY57.ATTESTATIONS",
                defaultMessage: "Account Custom Property 57"
            }
        },
        Account_CUSTOMPROPERTY58: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY58.ATTESTATIONS",
                defaultMessage: "Account Custom Property 58"
            }
        },
        Account_CUSTOMPROPERTY59: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY59.ATTESTATIONS",
                defaultMessage: "Account Custom Property 59"
            }
        },
        Account_CUSTOMPROPERTY60: {
            ATTESTATIONS: {
                id: "Account_CUSTOMPROPERTY60.ATTESTATIONS",
                defaultMessage: "Account Custom Property 60"
            }
        },
        ACTN: {
            ATTESTATIONS: {
                id: "ACTN.ATTESTATIONS",
                defaultMessage: "ACTION"
            }
        },
        ENTSTATUS: {
            ATTESTATIONS: {
                id: "ENTSTATUS.ATTESTATIONS",
                defaultMessage: "Entitlement Status"
            }
        },
        ACCOUNTCERTFIED: {
            ATTESTATIONS: {
                id: "ACCOUNTCERTFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        ENT2CERTIFIED: {
            ATTESTATIONS: {
                id: "ENT2CERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        ENTDISPLAYNAME: {
            ATTESTATIONS: {
                id: "ENTDISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Display Name"
            }
        },
        ENTCERTIFIED: {
            ATTESTATIONS: {
                id: "ENTCERTIFIED.ATTESTATIONS",
                defaultMessage: "Status"
            }
        },
        Ent_SODFLAG: {
            ATTESTATIONS: {
                id: "Ent_SODFLAG.ATTESTATIONS",
                defaultMessage: "Entitlement SOD Flag"
            }
        },
        Ent2_SODFLAG: {
            ATTESTATIONS: {
                id: "Ent2_SODFLAG.ATTESTATIONS",
                defaultMessage: "Entitlement SOD Flag"
            }
        },
        Ent2_CERT_ENTITLEMEnt2_VALUEKEY: {
            ATTESTATIONS: {
                id: "Ent2_CERT_ENTITLEMEnt2_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Certification Entitlement Value Key"
            }
        },
        Ent2_ENTITLEMEnt2_VALUEKEY: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMEnt2_VALUEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Value Key"
            }
        },
        Ent2_ENTITLEMEnt2_VALUE: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMEnt2_VALUE.ATTESTATIONS",
                defaultMessage: "Entitlement Value"
            }
        },
        Ent2_ENTITLEMENTTYPEKEY: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMENTTYPEKEY.ATTESTATIONS",
                defaultMessage: "Entitlement Type Key"
            }
        },
        Ent2_CUSTOMPROPERTY1: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY1.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 1"
            }
        },
        Ent2_CUSTOMPROPERTY2: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY2.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 2"
            }
        },
        Ent2_CUSTOMPROPERTY3: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY3.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 3"
            }
        },
        Ent2_CUSTOMPROPERTY4: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY4.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 4"
            }
        },
        Ent2_CUSTOMPROPERTY5: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY5.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 5"
            }
        },
        Ent2_CUSTOMPROPERTY6: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY6.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 6"
            }
        },
        Ent2_CUSTOMPROPERTY7: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY7.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 7"
            }
        },
        Ent2_CUSTOMPROPERTY8: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY8.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 8"
            }
        },
        Ent2_CUSTOMPROPERTY9: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY9.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 9"
            }
        },
        Ent2_CUSTOMPROPERTY10: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY10.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 10"
            }
        },
        Ent2_CUSTOMPROPERTY11: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY11.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 11"
            }
        },
        Ent2_CUSTOMPROPERTY12: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY12.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 12"
            }
        },
        Ent2_CUSTOMPROPERTY13: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY13.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 13"
            }
        },
        Ent2_CUSTOMPROPERTY14: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY14.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 14"
            }
        },
        Ent2_CUSTOMPROPERTY15: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY15.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 15"
            }
        },
        Ent2_CUSTOMPROPERTY16: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY16.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 16"
            }
        },
        Ent2_CUSTOMPROPERTY17: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY17.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 17"
            }
        },
        Ent2_CUSTOMPROPERTY18: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY18.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 18"
            }
        },
        Ent2_CUSTOMPROPERTY19: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY19.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 19"
            }
        },
        Ent2_CUSTOMPROPERTY20: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY20.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 20"
            }
        },
        Ent2_CUSTOMPROPERTY21: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY21.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 21"
            }
        },
        Ent2_CUSTOMPROPERTY22: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY22.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 22"
            }
        },
        Ent2_CUSTOMPROPERTY23: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY23.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 23"
            }
        },
        Ent2_CUSTOMPROPERTY24: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY24.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 24"
            }
        },
        Ent2_CUSTOMPROPERTY25: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY25.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 25"
            }
        },
        Ent2_CUSTOMPROPERTY26: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY26.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 26"
            }
        },
        Ent2_CUSTOMPROPERTY27: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY27.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 27"
            }
        },
        Ent2_CUSTOMPROPERTY28: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY28.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 28"
            }
        },
        Ent2_CUSTOMPROPERTY29: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY29.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 29"
            }
        },
        Ent2_CUSTOMPROPERTY30: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY30.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 30"
            }
        },
        Ent2_CUSTOMPROPERTY31: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY31.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 31"
            }
        },
        Ent2_CUSTOMPROPERTY32: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY32.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 32"
            }
        },
        Ent2_CUSTOMPROPERTY33: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY33.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 33"
            }
        },
        Ent2_CUSTOMPROPERTY34: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY34.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 34"
            }
        },
        Ent2_CUSTOMPROPERTY35: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY35.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 35"
            }
        },
        Ent2_CUSTOMPROPERTY36: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY36.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 36"
            }
        },
        Ent2_CUSTOMPROPERTY37: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY37.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 37"
            }
        },
        Ent2_CUSTOMPROPERTY38: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY38.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 38"
            }
        },
        Ent2_CUSTOMPROPERTY39: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY39.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 39"
            }
        },
        Ent2_CUSTOMPROPERTY40: {
            ATTESTATIONS: {
                id: "Ent2_CUSTOMPROPERTY40.ATTESTATIONS",
                defaultMessage: "Entitlement Custom Property 40"
            }
        },
        Ent2_DESCRIPTION: {
            ATTESTATIONS: {
                id: "Ent2_DESCRIPTION.ATTESTATIONS",
                defaultMessage: "Entitlement Description"
            }
        },
        Ent2_ENTITLEMENT_GLOSSARY: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMENT_GLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Ent2_STATUS: {
            ATTESTATIONS: {
                id: "Ent2_STATUS.ATTESTATIONS",
                defaultMessage: "Entitlement Status"
            }
        },
        Ent2_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Ent2_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Entitlement Update User"
            }
        },
        Ent2_RISK: {
            ATTESTATIONS: {
                id: "Ent2_RISK.ATTESTATIONS",
                defaultMessage: "Entitlement Risk"
            }
        },
        Ent2_SOX_CRITICAL: {
            ATTESTATIONS: {
                id: "Ent2_SOX_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Ent2_SOXCRITICAL: {
            ATTESTATIONS: {
                id: "Ent2_SOXCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement SOX Critical"
            }
        },
        Ent2_SYS_CRITICAL: {
            ATTESTATIONS: {
                id: "Ent2_SYS_CRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Ent2_SYSCRITICAL: {
            ATTESTATIONS: {
                id: "Ent2_SYSCRITICAL.ATTESTATIONS",
                defaultMessage: "Entitlement Sys Critical"
            }
        },
        Ent2_ORPHAN: {
            ATTESTATIONS: {
                id: "Ent2_ORPHAN.ATTESTATIONS",
                defaultMessage: "Entitlement Orphan"
            }
        },
        Ent2_UPDATEDATE: {
            ATTESTATIONS: {
                id: "Ent2_UPDATEDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Update Date"
            }
        },
        Ent2_SAVLEVEL: {
            ATTESTATIONS: {
                id: "Ent2_SAVLEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Ent2_LEVEL: {
            ATTESTATIONS: {
                id: "Ent2_LEVEL.ATTESTATIONS",
                defaultMessage: "Entitlement SAV Level"
            }
        },
        Ent2_PRIVILEGED: {
            ATTESTATIONS: {
                id: "Ent2_PRIVILEGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Ent2_PRIVILIGED: {
            ATTESTATIONS: {
                id: "Ent2_PRIVILIGED.ATTESTATIONS",
                defaultMessage: "Entitlement Privileged"
            }
        },
        Ent2_CONFIDENTIALITY: {
            ATTESTATIONS: {
                id: "Ent2_CONFIDENTIALITY.ATTESTATIONS",
                defaultMessage: "Entitlement Confidentiality"
            }
        },
        Ent2_SOD: {
            ATTESTATIONS: {
                id: "Ent2_SOD.ATTESTATIONS",
                defaultMessage: "Entitlement SOD"
            }
        },
        Ent2_DISPLAYNAME: {
            ATTESTATIONS: {
                id: "Ent2_DISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Display Name"
            }
        },
        Ent2_ENTITLEMENTID: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMENTID.ATTESTATIONS",
                defaultMessage: "Entitlement ID"
            }
        },
        Ent2_PROGRAM: {
            ATTESTATIONS: {
                id: "Ent2_PROGRAM.ATTESTATIONS",
                defaultMessage: "Entitlement Program"
            }
        },
        Ent2_MODULE: {
            ATTESTATIONS: {
                id: "Ent2_MODULE.ATTESTATIONS",
                defaultMessage: "Entitlement Module"
            }
        },
        Ent2_ACCESS: {
            ATTESTATIONS: {
                id: "Ent2_ACCESS.ATTESTATIONS",
                defaultMessage: "Entitlement Access"
            }
        },
        Ent2_SCHEMANAME: {
            ATTESTATIONS: {
                id: "Ent2_SCHEMANAME.ATTESTATIONS",
                defaultMessage: "Entitlement Schema Name"
            }
        },
        Ent2_ENTCLASS: {
            ATTESTATIONS: {
                id: "Ent2_ENTCLASS.ATTESTATIONS",
                defaultMessage: "Entitlement Classification"
            }
        },
        Ent2_LASTSCANDATE: {
            ATTESTATIONS: {
                id: "Ent2_LASTSCANDATE.ATTESTATIONS",
                defaultMessage: "Entitlement Last Scan Date"
            }
        },
        Ent2_ENTITLEMGLOSSARY: {
            ATTESTATIONS: {
                id: "Ent2_ENTITLEMGLOSSARY.ATTESTATIONS",
                defaultMessage: "Entitlement Glossary"
            }
        },
        Ent2_JOBID: {
            ATTESTATIONS: {
                id: "Ent2_JOBID.ATTESTATIONS",
                defaultMessage: "Entitlement Job ID"
            }
        },
        Ent2_LASTREVIEWEDDATE: {
            ATTESTATIONS: {
                id: "Ent2_LASTREVIEWEDDATE.ATTESTATIONS",
                defaultMessage: "Last reviewed Date"
            }
        },
        Ent2_LASTREVIEWEDBY: {
            ATTESTATIONS: {
                id: "Ent2_LASTREVIEWEDBY.ATTESTATIONS",
                defaultMessage: "Last Reviewed By"
            }
        },
        Ent2_LASTREVIEWEDCAMPAIGNNAME: {
            ATTESTATIONS: {
                id: "Ent2_LASTREVIEWEDCAMPAIGNNAME.ATTESTATIONS",
                defaultMessage: "Last Reviewed Campaign"
            }
        },
        User_NEWMANAGER: {
            ATTESTATIONS: {
                id: "User_NEWMANAGER.ATTESTATIONS",
                defaultMessage: "User New Manager"
            }
        },
        USERCOUNT: {
            ATTESTATIONS: {
                id: "USERCOUNT.ATTESTATIONS",
                defaultMessage: "Accounts"
            }
        },
        CHILDCOUNT: {
            ATTESTATIONS: {
                id: "CHILDCOUNT.ATTESTATIONS",
                defaultMessage: "Child Entitlements"
            }
        },
        ENTCOMMENTS: {
            ATTESTATIONS: {
                id: "ENTCOMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        ACCCOMMENT: {
            ATTESTATIONS: {
                id: "ACCCOMMENT.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        ACC_AUDIT_TRAIL: {
            ATTESTATIONS: {
                id: "ACC_AUDIT_TRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        ENT2COMMENTS: {
            ATTESTATIONS: {
                id: "ENT2COMMENTS.ATTESTATIONS",
                defaultMessage: "Comments"
            }
        },
        ENT2_AUDIT_TRAIL: {
            ATTESTATIONS: {
                id: "ENT2_AUDIT_TRAIL.ATTESTATIONS",
                defaultMessage: "History"
            }
        },
        ENT2NAME: {
            ATTESTATIONS: {
                id: "ENT2NAME.ATTESTATIONS",
                defaultMessage: "Child Entitlement"
            }
        },
        ENTTYPE: {
            ATTESTATIONS: {
                id: "ENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        User_ENTSODRISKS: {
            ATTESTATIONS: {
                id: "User_ENTSODRISKS.ATTESTATIONS",
                defaultMessage: "SOD Risks"
            }
        },
        SODRISKCOUNT: {
            ATTESTATIONS: {
                id: "SODRISKCOUNT.ATTESTATIONS",
                defaultMessage: "SOD Risks"
            }
        },
        Account_TOTALUSAGE: {
            ATTESTATIONS: {
                id: "Account_TOTALUSAGE.ATTESTATIONS",
                defaultMessage: "Total Usage"
            }
        },
        Account_UPDATEUSER: {
            ATTESTATIONS: {
                id: "Account_UPDATEUSER.ATTESTATIONS",
                defaultMessage: "Account Update User"
            }
        },
        Account_LASTCERTIFIEDACTION: {
            ATTESTATIONS: {
                id: "Account_LASTCERTIFIEDACTION.ATTESTATIONS",
                defaultMessage: "Last Certified Action"
            }
        },
        Account_LASTCERTIFIEDCOMMENT: {
            ATTESTATIONS: {
                id: "Account_LASTCERTIFIEDCOMMENT.ATTESTATIONS",
                defaultMessage: "Last Certified Comment"
            }
        },
        Role_NEWROLEOWNER: {
            ATTESTATIONS: {
                id: "Role_NEWROLEOWNER.ATTESTATIONS",
                defaultMessage: "New Role Owner"
            }
        },
        Role_OLDROLEOWNER: {
            ATTESTATIONS: {
                id: "Role_OLDROLEOWNER.ATTESTATIONS",
                defaultMessage: "Old Role Owner"
            }
        },
        User_USERSOURCE: {
            ATTESTATIONS: {
                id: "User_USERSOURCE.ATTESTATIONS",
                defaultMessage: "User Source"
            }
        },
        User_SOURCELASTLOGINDATE: {
            ATTESTATIONS: {
                id: "User_SOURCELASTLOGINDATE.ATTESTATIONS",
                defaultMessage: "Source Last Login Date"
            }
        },
        SOURCELASTLOGINDATE: {
            ATTESTATIONS: {
                id: "SOURCELASTLOGINDATE.ATTESTATIONS",
                defaultMessage: "Source Last Login Date"
            }
        },
        User_JRMRULES: {
            ATTESTATIONS: {
                id: "User_JRMRULES.ATTESTATIONS",
                defaultMessage: "Outlier Analysis"
            }
        },
        JSON_JRMRULESAVAILABLE: {
            ATTESTATIONS: {
                id: "JSON_JRMRULESAVAILABLE.ATTESTATIONS",
                defaultMessage: "Outlier Analysis"
            }
        },
        CUSTOMER: {
            ATTESTATIONS: {
                id: "CUSTOMER.ATTESTATIONS",
                defaultMessage: "User Customer"
            }
        },
        Ent_ENDPOINT: {
            ATTESTATIONS: {
                id: "Ent_ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        Ent_ENTTYPE: {
            ATTESTATIONS: {
                id: "Ent_ENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        User_ENTDISPLAYNAME: {
            ATTESTATIONS: {
                id: "User_ENTDISPLAYNAME.ATTESTATIONS",
                defaultMessage: "Entitlement Display Name"
            }
        },
        User_ENDPOINT: {
            ATTESTATIONS: {
                id: "User_ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        User_ENTTYPE: {
            ATTESTATIONS: {
                id: "User_ENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        Ent2_ENDPOINT: {
            ATTESTATIONS: {
                id: "Ent2_ENDPOINT.ATTESTATIONS",
                defaultMessage: "Endpoint Name"
            }
        },
        Ent2_ENTTYPE: {
            ATTESTATIONS: {
                id: "Ent2_ENTTYPE.ATTESTATIONS",
                defaultMessage: "Entitlement Type"
            }
        },
        NoActionRequired: {
            ATTESTATIONS: {
                id: "NoActionRequired.v2.label.ATTESTATIONS",
                defaultMessage: "No Action Required"
            }
        },
        "No Action Required": {
            ATTESTATIONS: {
                id: "NoActionRequired.v2.label.ATTESTATIONS",
                defaultMessage: "No Action Required"
            }
        },
        Done: {
            ATTESTATIONS: {
                id: "Done.v2.label.ATTESTATIONS",
                defaultMessage: "Done"
            }
        },
        Progress: {
            ATTESTATIONS: {
                id: "Progress.v2.label.ATTESTATIONS",
                defaultMessage: "Progress"
            }
        },
        EndDateChanged: {
            ATTESTATIONS: {
                id: "EndDateChanged.v2.label.ATTESTATIONS",
                defaultMessage: "End Date Changed"
            }
        },
        "End Date Changed": {
            ATTESTATIONS: {
                id: "EndDateChanged.v2.label.ATTESTATIONS",
                defaultMessage: "End Date Changed"
            }
        },
        Total: {
            ATTESTATIONS: {
                id: "Total.v2.label.ATTESTATIONS",
                defaultMessage: "Total"
            }
        },
        Approved: {
            ATTESTATIONS: {
                id: "Approved.v2.label.ATTESTATIONS",
                defaultMessage: "Approved"
            }
        },
        ManagerConfirmed: {
            ATTESTATIONS: {
                id: "ManagerConfirmed.v2.label.ATTESTATIONS",
                defaultMessage: "Manager Confirmed"
            }
        },
        "Manager Confirmed": {
            ATTESTATIONS: {
                id: "ManagerConfirmed.v2.label.ATTESTATIONS",
                defaultMessage: "Manager Confirmed"
            }
        },
        "Manager Confirmed With End Date Changed": {
            ATTESTATIONS: {
                id: "ManagerConfirmedWithEndDateChanged.v2.label.ATTESTATIONS",
                defaultMessage: "Manager Confirmed With End Date Changed"
            }
        },
        Rejected: {
            ATTESTATIONS: {
                id: "Rejected.v2.label.ATTESTATIONS",
                defaultMessage: "Rejected"
            }
        },
        Terminated: {
            ATTESTATIONS: {
                id: "Terminated.v2.label.ATTESTATIONS",
                defaultMessage: "Terminated"
            }
        },
        Pending: {
            ATTESTATIONS: {
                id: "Pending.v2.label.ATTESTATIONS",
                defaultMessage: "Pending"
            }
        },
        Account: {
            ATTESTATIONS: {
                id: "Account.v2.label.ATTESTATIONS",
                defaultMessage: "Account"
            }
        },
        Entitlement: {
            ATTESTATIONS: {
                id: "Entitlement.v2.label.ATTESTATIONS",
                defaultMessage: "Entitlement"
            }
        },
        Role: {
            ATTESTATIONS: {
                id: "Role.v2.label.ATTESTATIONS",
                defaultMessage: "Role"
            }
        },
        User: {
            ATTESTATIONS: {
                id: "User.v2.label.ATTESTATIONS",
                defaultMessage: "User"
            }
        },
        "Not Confirmed By Manager": {
            ATTESTATIONS: {
                id: "NotConfirmedByManager.v2.label.ATTESTATIONS",
                defaultMessage: "Not Confirmed By Manager"
            }
        },
        "Conditionally Certified": {
            ATTESTATIONS: {
                id: "ConditionallyCertified.v2.label.ATTESTATIONS",
                defaultMessage: "Conditionally Certified"
            }
        },
        "Risk.Factor.smart.cards.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Risk.Factor.smart.cards.V2.Attestations.Label",
                defaultMessage: "Risk Factors"
            }
        },
        "Risk.Factor.smart.cards.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Risk.Factor.smart.cards.Description.V2.Attestations.Label",
                defaultMessage: "These factors commonly lead to access rejections."
            }
        },
        "Trust.Factor.smart.cards.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Trust.Factor.smart.cards.V2.Attestations.Label",
                defaultMessage: "Trust Factors"
            }
        },
        "Trust.Factor.smart.cards.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Trust.Factor.smart.cards.Description.V2.Attestations.Label",
                defaultMessage: "These factors commonly lead to access approvals."
            }
        },
        "OutOfBand.Access.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "OutOfBand.Access.V2.Attestations.Label",
                defaultMessage: "Out of Band Access"
            }
        },
        "OutOfBand.Access.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "OutOfBand.Access.Description.V2.Attestations.Label",
                defaultMessage: "Access that was imported from applications connected to Saviynt"
            }
        },
        "OutOfBand.Account.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "OutOfBand.Account.V2.Attestations.Label",
                defaultMessage: "Out of Band Account"
            }
        },
        "OutOfBand.Account.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "OutOfBand.Account.Description.V2.Attestations.Label",
                defaultMessage: "Account that was imported from applications connected to Saviynt"
            }
        },
        "HighRisk.Access.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "HighRisk.Access.V2.Attestations.Label",
                defaultMessage: "High Risk Entitlements"
            }
        },
        "HighRisk.Access.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "HighRisk.Access.Description.V2.Attestations.Label",
                defaultMessage: "Entitlements with High or Critical Risk Category"
            }
        },
        "LowRisk.Access.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "LowRisk.Access.V2.Attestations.Label",
                defaultMessage: "Low Risk Access"
            }
        },
        "LowRisk.Access.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "LowRisk.Access.Description.V2.Attestations.Label",
                defaultMessage: "Entitlements with No, Low or Medium Risk Category"
            }
        },
        "HighRisk.Users.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "HighRisk.Users.V2.Attestations.Label",
                defaultMessage: "High Risk Users"
            }
        },
        "HighRisk.Users.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "HighRisk.Users.Description.V2.Attestations.Label",
                defaultMessage: "Users with High Risk Score"
            }
        },
        "LowRisk.Users.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "LowRisk.Users.V2.Attestations.Label",
                defaultMessage: "Low Risk Users"
            }
        },
        "LowRisk.Users.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "LowRisk.Users.Description.V2.Attestations.Label",
                defaultMessage: "Users with Low Risk Score"
            }
        },
        "HighRisk.Account.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "HighRisk.Account.V2.Attestations.Label",
                defaultMessage: "High Risk Account"
            }
        },
        "HighRisk.Account.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "HighRisk.Account.Description.V2.Attestations.Label",
                defaultMessage: "Accounts that are associated to Entitlements with High or Critical Risk Category"
            }
        },
        "LowRisk.Account.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "LowRisk.Account.V2.Attestations.Label",
                defaultMessage: "Low Risk Account"
            }
        },
        "LowRisk.Account.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "LowRisk.Account.Description.V2.Attestations.Label",
                defaultMessage: "Accounts that are associated to Entitlements with No, Low or Medium Risk Category"
            }
        },
        "HighRisk.Roles.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "HighRisk.Roles.V2.Attestations.Label",
                defaultMessage: "High Risk Roles"
            }
        },
        "HighRisk.Roles.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "HighRisk.Roles.Description.V2.Attestations.Label",
                defaultMessage: "Roles with High or Critical Risk Category"
            }
        },
        "LowRisk.Roles.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "LowRisk.Roles.V2.Attestations.Label",
                defaultMessage: "Low Risk Roles"
            }
        },
        "LowRisk.Roles.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "LowRisk.Roles.Description.V2.Attestations.Label",
                defaultMessage: "Roles with No, Low or Medium Risk Category"
            }
        },
        "Recently.Reviewed.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Recently.Reviewed.V2.Attestations.Label",
                defaultMessage: "Recently Reviewed in 30 Days"
            }
        },
        "Recently.Reviewed.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Recently.Reviewed.Description.V2.Attestations.Label",
                defaultMessage: "Access that has been recently reviewed in 30 Days"
            }
        },
        "Inactive.Accounts.60days.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Inactive.Accounts.60days.V2.Attestations.Label",
                defaultMessage: "Inactive Accounts for 60 days"
            }
        },
        "Inactive.Accounts.60days.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Inactive.Accounts.60days.Description.V2.Attestations.Label",
                defaultMessage: "Accounts that are inactive or Manually Suspended for 60 days"
            }
        },
        "Access.SOD.Violations.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Access.SOD.Violations.V2.Attestations.Label",
                defaultMessage: "Segregation of Duties (SoD)"
            }
        },
        "Access.SOD.Violations.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Access.SOD.Violations.Description.V2.Attestations.Label",
                defaultMessage: "Entitlements with Access Conflicts"
            }
        },
        "Inactive.Accounts.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Inactive.Accounts.V2.Attestations.Label",
                defaultMessage: "Inactive Accounts"
            }
        },
        "Inactive.Accounts.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Inactive.Accounts.Description.V2.Attestations.Label",
                defaultMessage: "Accounts that are inactive or Manually Suspended"
            }
        },
        "Confidence.trust.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Confidence.trust.V2.Attestations.Label",
                defaultMessage: "Confidence"
            }
        },
        "Confidence.trust.Description.V2.Attestations.Label": {
            ATTESTATIONS: {
                id: "Confidence.trust.Description.V2.Attestations.Label",
                defaultMessage: "Access with Low Confidence Score"
            }
        }
    }
};
const $135adfecc1ed8f07$export$ad5ae49be0159af2 = {
    DEFAULT_VIEW: "Default View",
    MY_PERSONALIZED_VIEW: "My Personalized View"
};
const $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc = {
    CREATE_SUCCESS: "Create successful",
    CREATE_FAILED: "Create failed",
    UPDATE_SUCCESS: "Update successful",
    UPDATE_FAILED: "Update failed",
    UPDATE_FAILED_INVALID_LENGTH: "Update failed invalid length"
};


function $e7628c995f405891$export$695b5822e913940f() {
    return window.envConfig || {};
}
const $e7628c995f405891$export$63087e5d2dd3ce07 = (ref, position)=>{
    if (ref.current && typeof ref.current === "object") ref.current.scroll({
        top: position,
        behavior: "smooth"
    });
};
const $e7628c995f405891$export$622a7128677021ae = (value)=>{
    if (value === "LIKELY_APPROVAL") return {
        kind: "success",
        label: "High"
    };
    if (value === "POSSIBLE_APPROVAL") return {
        kind: "warning",
        label: "Medium"
    };
    if (value === "POSSIBLE_REJECTION") return {
        kind: "critical",
        label: "Low"
    };
    return {
        kind: "info",
        label: ""
    };
};
const $e7628c995f405891$export$5e3a05818856a5b7 = (riskKind)=>{
    switch(riskKind){
        case "success":
            return "Happy";
        case "warning":
            return "Neutral";
        case "critical":
            return "Sad";
        default:
            return "Sad";
    }
};
const $e7628c995f405891$export$33ebd1c882bff43f = (score, upper = null, lower = null, middle = null)=>{
    if (typeof score !== "number") return {
        score: 0,
        kind: "info",
        label: ""
    };
    if (upper && score >= upper) return {
        score: score,
        kind: "success",
        label: "High"
    };
    if (lower && score <= lower) return {
        score: score,
        kind: "critical",
        label: "Low"
    };
    const middleRange = middle.split("-");
    if (score >= Number(middleRange[0]) && score <= Number(middleRange[1]) && middle?.trim()?.length !== 0) return {
        score: score,
        kind: "warning",
        label: "Medium"
    };
    return {
        score: score,
        kind: "info",
        label: ""
    };
};
const $e7628c995f405891$export$de7358b4991653b1 = (object)=>{
    let temp = {};
    Object.keys(object).forEach((key)=>{
        if (typeof object[key] === "object") temp = {
            ...temp,
            ...$e7628c995f405891$export$de7358b4991653b1(object[key])
        };
        else temp[key] = object[key];
    });
    return temp;
};
const $e7628c995f405891$export$8824054d4a42eac8 = (nodes)=>{
    const tempObj = [];
    nodes.forEach((node)=>{
        tempObj.push({
            ...node,
            children: []
        });
        if (node?.children && node?.children?.length > 0) tempObj.push(...$e7628c995f405891$export$8824054d4a42eac8(node?.children));
    });
    return tempObj;
};
const $e7628c995f405891$export$7f9a9407232f3c49 = {
    parent: "parent",
    children: "children",
    both: "both",
    bothFull: "bothFull",
    allChildren: "allChildren"
};
const $e7628c995f405891$export$66d087305585c751 = (nodes, targetNodeId, find = "parent")=>{
    if (!Object.values($e7628c995f405891$export$7f9a9407232f3c49).includes(find)) return [];
    const tempNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    const nodesList = $e7628c995f405891$export$8824054d4a42eac8(tempNodes);
    const flattenedListLength = nodesList?.length;
    if (flattenedListLength === 0 || flattenedListLength === 1) return [];
    const targetNode = nodesList.find((node)=>node?.tracker?.id === targetNodeId);
    if (!targetNode) return [];
    const targetNodeLevel = targetNode?.tracker?.level;
    if (find === $e7628c995f405891$export$7f9a9407232f3c49.parent) {
        if (targetNodeLevel === 0) return [];
        const flattenedList = nodesList.reverse();
        let hasLockedTargetNode = false;
        let currentParentLevel = targetNodeLevel - 1;
        const parentList = [];
        for(let i = 0; i < flattenedListLength; i += 1){
            if (!hasLockedTargetNode && flattenedList[i]?.tracker?.id === targetNodeId) hasLockedTargetNode = true;
            if (hasLockedTargetNode && flattenedList[i]?.tracker?.level === currentParentLevel) {
                parentList.push({
                    parent: targetNodeLevel - currentParentLevel,
                    ...flattenedList[i]?.tracker
                });
                currentParentLevel -= 1;
            }
            if (currentParentLevel < 0 || parentList.length === targetNodeLevel) return parentList;
        }
        return parentList;
    }
    if (find === $e7628c995f405891$export$7f9a9407232f3c49.children) {
        const flattenedList = nodesList;
        let hasLockedTargetNode = false;
        let childrenCount = 1;
        const childrenList = [];
        for(let i = 0; i < flattenedListLength; i += 1){
            if (!hasLockedTargetNode && flattenedList[i]?.tracker?.id === targetNodeId) hasLockedTargetNode = true;
            if (hasLockedTargetNode && flattenedList[i]?.tracker?.level > targetNodeLevel) {
                childrenList.push({
                    children: childrenCount,
                    ...flattenedList[i]?.tracker
                });
                childrenCount += 1;
            }
            if (flattenedList[i]?.tracker?.level === targetNodeLevel && flattenedList[i]?.tracker?.id !== targetNodeId) return childrenList;
        }
        return childrenList;
    }
    return [];
};
const $e7628c995f405891$var$flattenListV2 = (nodes, parent = (0, $hopDi$getRandomString)())=>{
    const tempObj = [];
    nodes.forEach((node)=>{
        tempObj.push({
            ...node,
            tracker: {
                ...node?.tracker,
                parentTrackerId: parent
            },
            children: []
        });
        if (node?.children && node?.children?.length > 0) tempObj.push(...$e7628c995f405891$var$flattenListV2(node?.children, node?.tracker?.id));
    });
    return tempObj;
};
const $e7628c995f405891$export$d3bf36f5a7258ab0 = (nodes, targetNodeId, find = "parent")=>{
    if (!Object.values($e7628c995f405891$export$7f9a9407232f3c49).includes(find)) return [];
    const tempNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    const nodesList = $e7628c995f405891$var$flattenListV2(tempNodes);
    const flattenedListLength = nodesList?.length;
    if (flattenedListLength === 0) return [];
    const targetNode = nodesList.find((node)=>node?.tracker?.id === targetNodeId);
    if (!targetNode) return [];
    const targetNodeLevel = targetNode?.tracker?.level;
    const getParentNode = (id)=>nodesList.find((node)=>node?.tracker?.id === id);
    if (find === $e7628c995f405891$export$7f9a9407232f3c49.parent) {
        let childNode = targetNode;
        let currentParentLevel = targetNodeLevel - 1;
        const firstItemSiblings = nodesList.filter((node)=>node?.tracker?.parentTrackerId === childNode?.tracker?.parentTrackerId);
        let parentList = [
            {
                nodeData: {
                    ...targetNode
                },
                ...targetNode?.tracker,
                isLastChild: firstItemSiblings.length === 1 && firstItemSiblings[0].tracker?.id === childNode?.tracker?.id
            }
        ];
        while(currentParentLevel >= 0){
            const parentNode = getParentNode(childNode?.tracker?.parentTrackerId);
            if (parentNode) {
                const siblings = nodesList.filter((node)=>node?.tracker?.parentTrackerId === parentNode?.tracker?.parentTrackerId);
                parentList = [
                    {
                        nodeData: {
                            ...parentNode
                        },
                        ...parentNode?.tracker,
                        isLastChild: siblings.length === 1 && siblings[0].tracker?.id === parentNode?.tracker?.id
                    }
                ].concat(parentList);
                childNode = parentNode;
                currentParentLevel -= 1;
            } else break;
        }
        return parentList;
    }
    if (find === $e7628c995f405891$export$7f9a9407232f3c49.children) return nodesList.filter((node)=>node?.tracker?.parentTrackerId === targetNodeId).map((node)=>({
            nodeData: {
                ...node
            },
            ...node?.tracker
        }));
    if (find === $e7628c995f405891$export$7f9a9407232f3c49.both) {
        let childNode = targetNode;
        let currentParentLevel = targetNodeLevel - 1;
        const firstItemSiblings = nodesList.filter((node)=>node?.tracker?.parentTrackerId === childNode?.tracker?.parentTrackerId);
        let parentList = [
            {
                nodeData: {
                    ...targetNode
                },
                ...targetNode?.tracker,
                isLastChild: firstItemSiblings.length === 1 && firstItemSiblings[0].tracker?.id === childNode?.tracker?.id
            }
        ];
        while(currentParentLevel >= 0){
            const parentNode = getParentNode(childNode?.tracker?.parentTrackerId);
            if (parentNode) {
                const siblings = nodesList.filter((node)=>node?.tracker?.parentTrackerId === parentNode?.tracker?.parentTrackerId);
                parentList = [
                    {
                        nodeData: {
                            ...parentNode
                        },
                        ...parentNode?.tracker,
                        isLastChild: siblings.length === 1 && siblings[0].tracker?.id === parentNode?.tracker?.id
                    }
                ].concat(parentList);
                childNode = parentNode;
                currentParentLevel -= 1;
            } else break;
        }
        const childrenList = nodesList.filter((node)=>node?.tracker?.parentTrackerId === targetNodeId).map((node)=>({
                nodeData: {
                    ...node
                },
                ...node?.tracker
            }));
        return [
            ...parentList,
            ...childrenList
        ];
    }
    if (find === $e7628c995f405891$export$7f9a9407232f3c49.allChildren) {
        let hasLockedTargetNode = false;
        const combinedList = [
            {
                nodeData: {
                    ...targetNode
                },
                ...targetNode?.tracker
            }
        ];
        for(let i = 0; i < flattenedListLength; i += 1){
            if (!hasLockedTargetNode && nodesList[i]?.tracker?.id === targetNodeId) hasLockedTargetNode = true;
            if (hasLockedTargetNode && nodesList[i]?.tracker?.level > targetNodeLevel) combinedList.push({
                nodeData: {
                    ...nodesList[i]
                },
                ...nodesList[i]?.tracker
            });
            if (hasLockedTargetNode && nodesList[i]?.tracker?.level === targetNodeLevel && nodesList[i]?.tracker?.id !== targetNodeId) return combinedList;
        }
        return combinedList;
    }
    return [];
};
const $e7628c995f405891$export$7cad4c9063025e24 = (name)=>(0, $135adfecc1ed8f07$export$9f3245bec405e186).certs[name]?.ATTESTATIONS || (0, $135adfecc1ed8f07$export$9f3245bec405e186).certs.DEFAULT.ATTESTATIONS;


const $167a6b08fa265d03$export$8946687e77bfb9e5 = "ECONNABORTED";
const $167a6b08fa265d03$export$b12833517019127a = "Not able to verify due to a network issue. Please refresh or try again later.";


const $adfd86cbf6e4f136$var$cookies = new (0, $hopDi$Cookies)();
// Create the Axios instance
const $adfd86cbf6e4f136$export$c1b2b945bea31d71 = (0, $hopDi$axios).create({
    headers: {
        "Content-Type": "application/json"
    }
});
// Request interceptor for adding the bearer token dynamically
$adfd86cbf6e4f136$export$c1b2b945bea31d71.interceptors.request.use((config)=>{
    const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
    config.baseURL = ECM_URL;
    // Token is added from cookies dynamically for each request
    const token = $adfd86cbf6e4f136$var$cookies.get("access_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
}, (error)=>Promise.reject(error));
// Response interceptor to handle 401 errors
$adfd86cbf6e4f136$export$c1b2b945bea31d71.interceptors.response.use((response)=>{
    const { responseURL: responseURL } = response.request;
    if (responseURL) try {
        // Info: Redirecting to login page, when session expires
        if (responseURL.includes("/login/auth")) window.location.reload();
    } catch (e) {
        (0, $hopDi$Logger).log("redirecting error");
    }
    return response;
}, (error)=>{
    if ((0, $hopDi$axios).isAxiosError(error) && error.response || // Axios error with response
    error?.code === (0, $167a6b08fa265d03$export$8946687e77bfb9e5 // Timeout error
    )) return Promise.reject((0, $167a6b08fa265d03$export$b12833517019127a));
    // If the error status is 401, redirect to the login page
    error.response && error.response.status;
    return Promise.reject(error);
});





const $d6d78fc758ee4148$export$d91439ca0ce56f8 = "UPDATE_SCREEN_SIZE";
const $d6d78fc758ee4148$export$e4d3b0aade0c82d6 = "CERTDETAILS/SET_TOUCH_DEVICE_STATUS";
const $d6d78fc758ee4148$export$f3d779ad78275d3b = "CERTDETAILS/SET_CERT_DETAILS_LISTS";
const $d6d78fc758ee4148$export$84719c80a3de3402 = "CERTDETAILS/SET_CERT_DETAILS_LISTS_COUNT";
const $d6d78fc758ee4148$export$804adfb6022843d9 = "CERTDETAILS/SET_CERTS_TIME_ZONE";
const $d6d78fc758ee4148$export$740ea107ca859e41 = "CERTDETAILS/SET_CERT_DETAILS_CERT_KEY";
const $d6d78fc758ee4148$export$f0d808954e0679c6 = "CERTDETAILS/CERT_DETAILS_LISTS_LOADING";
const $d6d78fc758ee4148$export$3fb13be2b9b8a4c9 = "CERTDETAILS/CERT_DETAILS_REFRESH_SUCCESS";
const $d6d78fc758ee4148$export$be9207d1796cf80 = "CERTDETAILS/CERT_DETAILS_LISTS_ERROR";
const $d6d78fc758ee4148$export$855d326a33362542 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_COLUMNS_LIST";
const $d6d78fc758ee4148$export$f8b68a93cd1396c = "CERTDETAILS/SET_CERT_DETAILS_VIEW_ROWS_LIST";
const $d6d78fc758ee4148$export$7ce0be7ec08b7bd9 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CAMPAIGN_KEY";
const $d6d78fc758ee4148$export$9f85bed13d6d6867 = "CERTDETAILS/SET_CERT_DETAILS_COLUMN_PICKER_LIST";
const $d6d78fc758ee4148$export$2e66e5f4c45faa57 = "CERTDETAILS/SET_CERT_DETAILS_FLATTENED_COLUMN_PICKER_LIST";
const $d6d78fc758ee4148$export$3b55c5d9f617705a = "CERTDETAILS/CERT_DETAILS_COL_PICKER_LOADING";
const $d6d78fc758ee4148$export$20c37c78e4076fd7 = "CERTDETAILS/CERT_DETAILS_SIDE_PANEL_VISIBLE";
const $d6d78fc758ee4148$export$dd33a29cc9f55309 = "CERTDETAILS/CERT_DETAILS_TRIGGER_FROM_SEARCH";
const $d6d78fc758ee4148$export$e560b62bb0ef76ae = "CERTDETAILS/CERT_DETAILS_VIEW_LOADING";
const $d6d78fc758ee4148$export$903196cd760f40e2 = "CERTDETAILS/CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER";
const $d6d78fc758ee4148$export$d954cd82d0ab56d0 = "CERTDETAILS/SET_CERT_FILTERS";
const $d6d78fc758ee4148$export$41e9b850f4b31bd = "CERTDETAILS/SET_CERT_TABS";
const $d6d78fc758ee4148$export$3db41bfbe846115 = "CERTDETAILS/SET_TABHIGHLIGHT_NAME";
const $d6d78fc758ee4148$export$af468c26aae4b8fa = "CERTDETAILS/SET_ROWS_FILTERS";
const $d6d78fc758ee4148$export$9d483e8c06e94386 = "CERTDETAILS/SET_COLS_FILTERS";
const $d6d78fc758ee4148$export$8c4d8141d3ba5d38 = "CERTDETAILS/ACTIVE_ADVANCED_FILTERS";
const $d6d78fc758ee4148$export$2444563004f47e89 = "ERR_CANCELED";
const $d6d78fc758ee4148$export$8946687e77bfb9e5 = "ECONNABORTED";
const $d6d78fc758ee4148$export$b493d788e1fd3b9a = 10000;
const $d6d78fc758ee4148$export$bfbc2f51126156c = "CERTDETAILS/CERTS_RECORDS_COUNT";
const $d6d78fc758ee4148$export$3f218b7834ef2f49 = "CERTDETAILS/CERT_DETAILS_COLUMNS_TO_SHOW";
const $d6d78fc758ee4148$export$8a89d25d4ad8783e = "CERTDETAILS/SET_CLEAR_FILTERS_BTN_STATUS";
const $d6d78fc758ee4148$export$12cd07f9e71f98b = "CERTDETAILS/SET_CLEAR_SEARCH_BTN_STATUS";
const $d6d78fc758ee4148$export$cea4a00589b4b78b = "CERTDETAILS/SET_CLEAR_HIERARCHY_BTN_STATUS";
const $d6d78fc758ee4148$export$1aaf381820aaad35 = "CERTDETAILS/CERT_DETAILS_VIEW_API_ERROR";
const $d6d78fc758ee4148$export$dd0462c52301fb4d = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_NAME";
const $d6d78fc758ee4148$export$5e310ea02d328fb1 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_START_DATE";
const $d6d78fc758ee4148$export$f3fb9edd8ce133a = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_END_DATE";
const $d6d78fc758ee4148$export$4bef839f3f67fcf6 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_AUTO_REVOKE_LIST";
const $d6d78fc758ee4148$export$51750fb5a6bddff5 = "CERTDETAILS/SET_CERT_DETAILS_VIEW_CERT_AUDITOR";
const $d6d78fc758ee4148$export$40d3ad20c39fea4a = "CERTDETAILS/SET_CERT_OBJECT_FOR_REDIRECT";
const $d6d78fc758ee4148$export$edbbcf29e994507a = "CERTDETAILS/SET_CERT_TRUST_SCORE_FLAG";
const $d6d78fc758ee4148$export$47b2e1637ffaf40d = "CERTDETAILS/SET_CERT_GLOBAL_DATE_FORMAT";
const $d6d78fc758ee4148$export$67aafc85739b867b = "CERTDETAILS/SET_CERTS_ACTIONS_FILTER";
const $d6d78fc758ee4148$export$9a3ca9b6c1caafdf = "CERTDETAILS/SET_SIDE_PANEL_BODY_LOADING";
const $d6d78fc758ee4148$export$1b7cff865d967245 = "CERTDETAILS/SET_SIDE_PANEL_ERROR";
const $d6d78fc758ee4148$export$44cea83c7eb86289 = "CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ENTITLEMENTS";
const $d6d78fc758ee4148$export$a252b37c42fd39c0 = "CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ENTITLEMENTS";
const $d6d78fc758ee4148$export$46e200503484c25f = "CERTDETAILS/SET_SIDE_PANEL_SOD_ENTITLEMENTS";
const $d6d78fc758ee4148$export$a71fe6648e4ae608 = "CERTDETAILS/SET_SIDE_PANEL_PRIVILEGES_ENTITLEMENTS";
const $d6d78fc758ee4148$export$842ba02ccf54b42b = "CERTDETAILS/SET_SIDE_PANEL_CHILDREN_ENTITLEMENTS";
const $d6d78fc758ee4148$export$e5cfbc544f1684eb = "CERTDETAILS/SET_SIDE_PANEL_DEPENDENT_ENTITLEMENTS";
const $d6d78fc758ee4148$export$b98808434921fbb1 = "CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ACCOUNTS";
const $d6d78fc758ee4148$export$7f0539351068ca18 = "CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ACCOUNTS";
const $d6d78fc758ee4148$export$a7a89423fc1f2d99 = "CERTDETAILS/SET_SIDE_PANEL_SUMMARY_USERS";
const $d6d78fc758ee4148$export$e6ae9922b78d19ee = "CERTDETAILS/SET_SIDE_PANEL_HISTORY2_USERS";
const $d6d78fc758ee4148$export$85fb16097b911 = "CERTDETAILS/SET_SIDE_PANEL_SUMMARY_ROLES";
const $d6d78fc758ee4148$export$b0fdc72ce6a50d97 = "CERTDETAILS/SET_SIDE_PANEL_HISTORY2_ROLES";
const $d6d78fc758ee4148$export$940b9d07f90752d = "CERTDETAILS/SET_SIDE_PANEL_ENTITLEMENT_ROLES";
const $d6d78fc758ee4148$export$d4c8fbbc4fca0999 = "CERTDETAILS/SET_SIDE_PANEL_CHILDREN_ROLES";
const $d6d78fc758ee4148$export$95aee1eca5275acc = "CERTDETAILS/SIDE_PANEL_INITIAL_LOAD";
const $d6d78fc758ee4148$export$2e6684ed5543ad11 = "CERTDETAILS/SIDE_PANEL_LOAD_MORE_FLAG";
const $d6d78fc758ee4148$export$550c586b0cc3ded0 = "CERTDETAILS/SET_PREDEFINED_COMMENTS";
const $d6d78fc758ee4148$export$e87c818aed68e8cb = "CERTDETAILS/SET_OPEN_STATUS_AND_ARSTASKKEY_FOR_ARS_MODAL";
const $d6d78fc758ee4148$export$7a8caab59b607807 = "CERTDETAILS/SET_LOADING_FOR_ARS_MODAL";
const $d6d78fc758ee4148$export$8671c3354e9690ea = "CERTDETAILS/SET_ERROR_FOR_ARS_MODAL";
const $d6d78fc758ee4148$export$dcc76e3383a21811 = "CERTDETAILS/SET_DATA_FOR_ARS_MODAL";
const $d6d78fc758ee4148$export$b0c18ac3058b419e = "CERTDETAILS/SET_SHOW_BULK_SELECT_CHEKBOX";
const $d6d78fc758ee4148$export$bfbc1bdccfb4abf5 = "CERTDETAILS/SET_CHECK_FOR_BULK_CHEKBOX";
const $d6d78fc758ee4148$export$69729db10395ff90 = "CERTDETAILS/SET_INDETERMINATE_FOR_BULK_CHEKBOX";
const $d6d78fc758ee4148$export$768f00e6b30d478 = "CERTDETAILS/SET_BULK_FOOTER_SHOW";
const $d6d78fc758ee4148$export$2d1f20523798a1b7 = "CERTDETAILS/SET_BULK_FOOTER_DATA";
const $d6d78fc758ee4148$export$60473f3971dee5df = "CERTDETAILS/SET_DISABLE_FOR_BULK_SELECT_ALL";
const $d6d78fc758ee4148$export$2890f4c8d2907863 = "CERTDETAILS/SET_SUBMIT_FOR_BULK_SELECT_ALL";
const $d6d78fc758ee4148$export$42cd2e4c8af9ab41 = "CERTDETAILS/SET_ATLEAST_ONE_IS_SELECTED";
const $d6d78fc758ee4148$export$98054ce8e1cd6185 = "CERTDETAILS/SET_BULK_ACTIONS_ALERT";
const $d6d78fc758ee4148$export$afe1eb1cba0072ef = "CERTDETAILS/SET_BULK_ACTIONS_ACTION_BY_SELECT_ALL";
const $d6d78fc758ee4148$export$c19826a63dd39ec7 = "CERTDETAILS/SET_BULK_ACTIONS_ISSUBMITTING";
const $d6d78fc758ee4148$export$a1d03b0ccb874026 = "CERTDETAILS/IS_BULK_ACTIONS_COMPLETED";
const $d6d78fc758ee4148$export$1d889ec5a0bd35b5 = "CERTDETAILS/REVIEW_AND_SUBMIT_LOADING";
const $d6d78fc758ee4148$export$32524a0d8ac0b191 = "CERTDETAILS/REVIEW_AND_SUBMIT_ERROR";
const $d6d78fc758ee4148$export$6375a4b78a6ebe = "CERTDETAILS/REVIEW_AND_SUBMIT_CONFIG";
const $d6d78fc758ee4148$export$8fa9055a97f67430 = "CERTDETAILS/REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS";
const $d6d78fc758ee4148$export$b1c80b328234b28e = "CERTDETAILS/REVIEW_AND_SUBMIT_STEP_1_DATA";
const $d6d78fc758ee4148$export$1b59f0ddd56aa357 = "CERTDETAILS/SET_REVIEW_AND_SUBMIT_BTN_DISPLAY";
const $d6d78fc758ee4148$export$c030357f73041b8 = "CERTDETAILS/POST_TAB_COUNTS_DISABLED";
const $d6d78fc758ee4148$export$8b461e828675fe2 = "CERTDETAILS/POST_TAB_COUNTS_ERROR";
const $d6d78fc758ee4148$export$bcfd799e4df08939 = "CERTDETAILS/POST_TAB_COUNTS_LOADING";
const $d6d78fc758ee4148$export$b61e16101d4e3f64 = "CERTDETAILS/POST_TAB_COUNTS_SUCCESS";
const $d6d78fc758ee4148$export$b77c91b145bf9647 = "CERTDETAILS/SET_PROGRESS_BREAKDOWN_DETAILS";
const $d6d78fc758ee4148$export$5296abadcbacb235 = "CERTDETAILS/SET_PROGRESS_BREAKDOWN_DETAILS_LOADING";
const $d6d78fc758ee4148$export$569cf9037aa74da = "CERTDETAILS/SET_PROGRESS_BREAKDOWN_DETAILS_ERROR";
const $d6d78fc758ee4148$export$e7b0a9aed86b0918 = "CERTDETAILS/SET_DYNAMIC_SORT_FILTER_DETAILS";
const $d6d78fc758ee4148$export$8810396661da9a69 = "CERTDETAILS/RESET_DYNAMIC_SORT_FILTER_DETAILS";
const $d6d78fc758ee4148$export$87218027c7ad9093 = "CERTDETAILS/SET_ENABLE_INDIVIDUAL_COMMENTS";
const $d6d78fc758ee4148$export$9130d79ae651148 = "CERTDETAILS/SET_ACTION_COUNT_CHECK";
const $d6d78fc758ee4148$export$8ca82b86b34f725b = "CERTDETAILS/SET_ACTION_LOADING";
const $d6d78fc758ee4148$export$b3c7c737b53ea33e = "CERTDETAILS/ET_ACTION_SUCCESS";
const $d6d78fc758ee4148$export$3564fc123aed043c = "CERTDETAILS/SET_ACTION_RESET";
const $d6d78fc758ee4148$export$e8fdce46a9e3e027 = "CERTDETAILS/SET_ACTION_MODAL_OPEN";
const $d6d78fc758ee4148$export$5755ae8e491f730 = "CERTDETAILS/SET_ACTION_ERROR";
const $d6d78fc758ee4148$export$f66f20183ec2a996 = "CERTDETAILS/SET_SUCCESS_ALERT_MESSAGE";
const $d6d78fc758ee4148$export$a8aa77f63d5aad19 = "CERTDETAILS/SET_CERT_DETAILS_TERMINATE_COMMENTS";
const $d6d78fc758ee4148$export$f7b4124f0c0fddd2 = "CERTDETAILS/SET_CERT_DETAILS_TERMINATE_CONFIG_MAP";
const $d6d78fc758ee4148$export$64b8a5600bac3cf7 = "CERTDETAILS/SET_ACTION_SUCCESS_TERMINATE";
const $d6d78fc758ee4148$export$97d842f50b1d9083 = "CERTDETAILS/SET_CONSULT_ACTION_ASSIGNEE_LIST";
const $d6d78fc758ee4148$export$c3fe830879e37a3d = "CERTDETAILS/SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING";
const $d6d78fc758ee4148$export$d91200b15b0cd8ec = "CERTDETAILS/SET_CONSULT_ACTION_ASSIGNEE_LIST_ERROR";
const $d6d78fc758ee4148$export$dd6b8d2bd42778be = "CERTDETAILS/SET_REASSIGN_CONFIG";
const $d6d78fc758ee4148$export$6eb1d8263e7e2d01 = "CERTDETAILS/SET_IS_REASSIGN_WARN_MSG_OPENED";
const $d6d78fc758ee4148$export$7fbc63266c535cea = "CERTDETAILS/SET_IS_REASSIGN_POPOVER_MSG";
const $d6d78fc758ee4148$export$6932187838de83d9 = "CERTDETAILS/SET_IS_SAVI_FILTER_APPLIED";
const $d6d78fc758ee4148$export$4f8e3fc5251d1e82 = "CERTDETAILS/GET_SAVI_COMPANION_STATUS";
const $d6d78fc758ee4148$export$df3ba5c051a876de = "CERTDETAILS/GET_SAVI_COMPANION_STATUS_LOAD";
const $d6d78fc758ee4148$export$4009fb2303280d3a = "CERTDETAILS/GET_SAVI_COMPANION_STATUS_SUCCESS";
const $d6d78fc758ee4148$export$9b4357356da505fc = "CERTDETAILS/GET_SAVI_COMPANION_STATUS_FAILURE";
const $d6d78fc758ee4148$export$7511d3817c55117f = "CERTDETAILS/APPLY_SAVI_COMPANION_ACTIONS";
const $d6d78fc758ee4148$export$a0f86ea1258b795c = "CERTDETAILS/APPLY_SAVI_COMPANION_ACTIONS_LOAD";
const $d6d78fc758ee4148$export$b021d9c474ee48de = "CERTDETAILS/APPLY_SAVI_COMPANION_ACTIONS_SUCCESS";
const $d6d78fc758ee4148$export$7e0741aad82ab94b = "CERTDETAILS/APPLY_SAVI_COMPANION_ACTIONS_FAILURE";
const $d6d78fc758ee4148$export$1e4b8a34c93a7dd0 = "CERTDETAILS/SET_IS_SAVI_COMPANION_ENABLED";
const $d6d78fc758ee4148$export$334e0072fdfb95ed = "CERTDETAILS/SET_IS_CERTIFICATE_ACTIONABLE";
const $d6d78fc758ee4148$export$25054d4d5db33a66 = "CERTDETAILS/CERT_DETAILS_TRIGGER_FROM_SAVI_APPLY_ACTIONS";
const $d6d78fc758ee4148$export$64fa42aee49aa7c3 = "CERTDETAILS/SET_VERIFY_PARENT_LOADING";
const $d6d78fc758ee4148$export$738bb6c8834cc24b = "CERTDETAILS/SET_VERIFY_PARENT_MAP";
const $d6d78fc758ee4148$export$3c40ab84ee726c27 = "CERTDETAILS/SET_VERIFY_PARENT_ERROR";
const $d6d78fc758ee4148$export$8ced494098659b02 = "CERTDETAILS/SET_IS_SMART_FILTER_APPLIED";
const $d6d78fc758ee4148$export$656079c87429a80d = "CERTDETAILS/FETCH_SMART_FILTERS_META";
const $d6d78fc758ee4148$export$58ccb446f68b9f12 = "CERTDETAILS/FETCH_SMART_FILTERS_META_SUCCESS";
const $d6d78fc758ee4148$export$71e126c527a418be = "CERTDETAILS/FETCH_SMART_FILTERS_META_FAILURE";
const $d6d78fc758ee4148$export$7955a070d3ebcb88 = "CERTDETAILS/CLEAR_SMART_FILTERS";
const $d6d78fc758ee4148$export$12b8b0c2680dfdd3 = "CERTDETAILS/CLEAR_ALL_FILTERS";
const $d6d78fc758ee4148$export$16e0d1398b26a1e2 = "SET_PERSONALIZATION_STATUS";
const $d6d78fc758ee4148$export$878cfd23fc23c300 = "SET_PERSONALIZATION";
const $d6d78fc758ee4148$export$82680184c83b750f = "CREATE_PERSONALIZATION";
const $d6d78fc758ee4148$export$6064b3ccd2b2ba30 = "UPDATE_PERSONALIZATION";
const $d6d78fc758ee4148$export$4907f9a8e1f94d67 = "UPDATE_PERSONALIZATION_API_STATUS";
const $d6d78fc758ee4148$export$c51bf664ca9c6b15 = "PERSONALIZATION_VIEW_OPTION";
const $d6d78fc758ee4148$export$e5f04d968a3f4885 = "CLEAR_CURRENT_PERSONALIZATION";
const $d6d78fc758ee4148$export$24686dd5be2846fd = "CERTDETAILS/PERSONALIZATION_SET_DEFAULT_VIEW";
const $d6d78fc758ee4148$export$40b13b5dcefcbafd = "PERSONALIZATION_ALL";
const $d6d78fc758ee4148$export$4ab9d0b6e0a2e2b = "CERTS_EXPORT_STATUS";
const $d6d78fc758ee4148$export$9f1b82a3dd944b0e = "CERTS_EXPORT_APPLY_FILTER";
const $d6d78fc758ee4148$export$384e10a5fce8f786 = "CERTS_EXPORT_COLUMNS_TO_EXPORT";
const $d6d78fc758ee4148$export$4102f51782d2b340 = "GET_CERTS_DETAILS_FOR_EXPORT";
const $d6d78fc758ee4148$export$bc0e04975792fb52 = "CERTDETAILS/CLEAR_SAVI_ACTIONS_FILTER";
const $d6d78fc758ee4148$export$ff736dce437d4f45 = "CERTDETAILS/APPLIED_SAVI_ACITONS_FILTER";
const $d6d78fc758ee4148$export$55cfff3090f887bb = "CERTDETAILS/APPLIED_SAVI_SMART_FILTER";


const $d623f23401a154f0$var$reviewAndSubmitESignatureLoginCredentialsField = "UserName";
let $d623f23401a154f0$var$cancelTokenForCertDetailsData;
let $d623f23401a154f0$var$cancelTokenForClearCertsFilter;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements;
let $d623f23401a154f0$var$cancelTokenForSidePanelBodyDependentForEntitlements;
let $d623f23401a154f0$var$cancelTokenForAccessRequestHistory;
const $d623f23401a154f0$var$tabMapping = {
    [(0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49)]: "todo",
    [(0, $d44c789d5b60f9bf$export$807a0bc890800408)]: "done",
    [(0, $d44c789d5b60f9bf$export$d5eea126dff5a615)]: "all",
    [(0, $d44c789d5b60f9bf$export$b2766b46106d3053)]: "consulted"
};
const $d623f23401a154f0$var$ALLOWED_CERTIFICATION_STATUS_FOR_REVIEW_AND_SUBMIT = [
    0,
    1,
    2
];
const $d623f23401a154f0$var$ALLOWED_CAMPAIGN_COMMENT_FOR_REVIEW_AND_SUBMIT = [
    "1",
    "[1, 2]"
];
const $d623f23401a154f0$var$axiosTimeoutConfig = {
    timeout: (0, $d6d78fc758ee4148$export$b493d788e1fd3b9a)
};
const $d623f23401a154f0$export$c10170f5705ccb4f = (state)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e4d3b0aade0c82d6),
            payload: state
        });
    };
const $d623f23401a154f0$export$62e9f0f2fe0d4fcd = (newLabel)=>(dispatch, getState)=>{
        const currentLabel = getState().certifications.mediaQueryValue;
        if (newLabel !== currentLabel) dispatch({
            type: (0, $d6d78fc758ee4148$export$d91439ca0ce56f8),
            payload: newLabel
        });
    };
const $d623f23401a154f0$export$1a246502936ad896 = (certKey)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$740ea107ca859e41),
            payload: certKey
        });
    };
const $d623f23401a154f0$export$a38b1f4e8e0cf926 = (zone)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$804adfb6022843d9),
            payload: zone
        });
    };
const $d623f23401a154f0$export$ebe6b5ce6ed9ef39 = (isVisible)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$20c37c78e4076fd7),
            payload: isVisible
        });
    };
const $d623f23401a154f0$export$877a3b3409060dd6 = (filters)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8c4d8141d3ba5d38),
            payload: {
                results: filters
            }
        });
    };
const $d623f23401a154f0$export$86d11b633a5d59e6 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8a89d25d4ad8783e),
            payload: status
        });
    };
const $d623f23401a154f0$export$661e1772dd5a4141 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$12cd07f9e71f98b),
            payload: status
        });
    };
const $d623f23401a154f0$export$aaae2b23f99e1308 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$cea4a00589b4b78b),
            payload: status
        });
    };
const $d623f23401a154f0$export$a7b1b02371ce779a = (trigger)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$903196cd760f40e2),
            payload: trigger
        });
    };
const $d623f23401a154f0$export$e9c5cd8aea0cabc7 = (tabs)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$41e9b850f4b31bd),
            payload: {
                results: tabs
            }
        });
    };
const $d623f23401a154f0$export$3ac645216ac406ce = (state)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$c030357f73041b8),
            payload: state
        });
    };
const $d623f23401a154f0$export$afd1b438af1720fe = (certKey, isFirstTime = false)=>async (dispatch, getState)=>{
        const body = {
            certkey: certKey
        };
        if (isFirstTime) body.fetchAllCount = "true";
        const { tabs: tabs } = getState().certifications;
        const allTab = tabs?.tabData?.find((item)=>item.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615));
        dispatch({
            type: (0, $d6d78fc758ee4148$export$bcfd799e4df08939)
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/getTabCount", body);
            // Map API response to the corresponding count based on the tab
            const consultedCount = data[`${$d623f23401a154f0$var$tabMapping[0, $d44c789d5b60f9bf$export$b2766b46106d3053]}Count`];
            const doneCount = data[`${$d623f23401a154f0$var$tabMapping[0, $d44c789d5b60f9bf$export$807a0bc890800408]}Count`];
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                payload: {
                    certKey: certKey,
                    tab: (0, $d44c789d5b60f9bf$export$b2766b46106d3053),
                    count: consultedCount || 0
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                payload: {
                    certKey: certKey,
                    tab: (0, $d44c789d5b60f9bf$export$807a0bc890800408),
                    count: doneCount
                }
            });
            if (isFirstTime) {
                const allCount = data[`${$d623f23401a154f0$var$tabMapping[0, $d44c789d5b60f9bf$export$d5eea126dff5a615]}Count`];
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                    payload: {
                        certKey: certKey,
                        tab: (0, $d44c789d5b60f9bf$export$d5eea126dff5a615),
                        count: allCount
                    }
                });
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                    payload: {
                        certKey: certKey,
                        tab: (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                        count: Math.max(allCount - doneCount - (consultedCount || 0), 0)
                    }
                });
            } else dispatch({
                type: (0, $d6d78fc758ee4148$export$b61e16101d4e3f64),
                payload: {
                    certKey: certKey,
                    tab: (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                    count: Math.max(allTab.count - doneCount - (consultedCount || 0), 0)
                }
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1aaf381820aaad35),
                payload: {
                    isError: true
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$8b461e828675fe2),
                payload: {
                    error: error.message
                }
            });
        }
    };
const $d623f23401a154f0$export$d290070680bebdf9 = (rowsFilters)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$af468c26aae4b8fa),
            payload: {
                results: rowsFilters
            }
        });
    };
const $d623f23401a154f0$export$b551d76884371ba3 = (colsFilters)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$9d483e8c06e94386),
            payload: {
                results: colsFilters
            }
        });
    };
const $d623f23401a154f0$export$44dea541cc9e89ed = (colToShow)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$3f218b7834ef2f49),
            payload: colToShow
        });
    };
const $d623f23401a154f0$export$61e757f80085daf4 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$9a3ca9b6c1caafdf),
            payload: status
        });
    };
const $d623f23401a154f0$export$eb61ad48998e2c20 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1d889ec5a0bd35b5),
            payload: status
        });
    };
const $d623f23401a154f0$export$dadc0bb56f5e8946 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8fa9055a97f67430),
            payload: status
        });
    };
const $d623f23401a154f0$export$b6eeabdfc6166e3c = (eids)=>async (dispatch, getState)=>{
        const { certKey: certKey, tabs: { tabData: tabData } } = getState().certifications;
        // Get the active tab key
        const activeTabKey = tabData?.find((tab)=>tab.isActive).key;
        const activeTab = $d623f23401a154f0$var$tabMapping[activeTabKey] || "all";
        const body = {
            certkey: certKey,
            max: String(Math.max(1, eids?.length)),
            offset: "0",
            tab: activeTab,
            requestOrigin: "UI",
            eids: eids,
            refresh: "1"
        };
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items?refresh=1", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            const { msg: msg, results: results } = data;
            if (msg !== "Success") throw Error("Failed to refresh the associated items");
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3fb13be2b9b8a4c9),
                    payload: false
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3fb13be2b9b8a4c9),
                payload: true
            });
            return results;
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3fb13be2b9b8a4c9),
                payload: false
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$fad033acbe739b9c = (certKey, columnNames, max, offset, searchText = "")=>async (dispatch, getState)=>{
        const { isLoading: isLoading, tabs: tabs, dynamicSortFilter: dynamicSortFilter } = getState().certifications;
        const { tabData: tabData } = tabs;
        // Get the active tab key
        const activeTabKey = tabData?.find((tab)=>tab.isActive).key;
        const activeTab = $d623f23401a154f0$var$tabMapping[activeTabKey] || "all";
        const { sortByColumn: sortByColumn, sortDirection: sortDirection } = dynamicSortFilter;
        const body = {
            certkey: certKey,
            max: `${max}`,
            offset: `${offset}`,
            requestOrigin: "UI",
            sSearch: `${searchText}`,
            columnsToShow: columnNames,
            tab: activeTab
        };
        if (sortByColumn && sortDirection) {
            body.columnNameToSort = sortByColumn;
            body.order = sortDirection;
        }
        if (!isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForCertDetailsData !== "undefined") $d623f23401a154f0$var$cancelTokenForCertDetailsData.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForCertDetailsData = (0, $hopDi$axios).CancelToken.source();
            if (!body?.columnsToShow) return 0, $d6d78fc758ee4148$export$2444563004f47e89;
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForCertDetailsData.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items", body, axiosRequestConfig);
            const { results: results, total: total } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f3d779ad78275d3b),
                payload: {
                    results: results,
                    total: total,
                    searchText: searchText,
                    error: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
                payload: false
            });
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) {
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$f3d779ad78275d3b),
                    payload: {
                        results: null,
                        error: "Data Fetch Error"
                    }
                });
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
                    payload: false
                });
            }
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
        }
    };
const $d623f23401a154f0$export$4fc2c513d50ba579 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
            payload: status
        });
    };
const $d623f23401a154f0$export$d4d469724f632e02 = ()=>async ()=>{
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/checkEsConnection");
            if (!data || !data.response) throw Error("ES Check Failed");
        } catch (error) {
            (0, $hopDi$Logger).error("Error: ", Error(error.message));
            throw error;
        }
    };
const $d623f23401a154f0$export$889bd3e7f249bccd = (certKey)=>async (dispatch)=>{
        const body = {
            certkey: certKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e560b62bb0ef76ae),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1aaf381820aaad35),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/view", body);
            const { certificationStatus: certificationStatus, consulteeLoggedIn: consulteeLoggedIn, defaultReassigneeName: defaultReassigneeName, enableloginSignature: enableloginSignature, objectsToBeIncluded: objectsToBeIncluded, hasCampaignLevelAccess: hasCampaignLevelAccess, hasOnlyCertifierLevelAccess: hasOnlyCertifierLevelAccess, columnList: columnList, campaignKey: campaignKey, createFilterActionMap: createFilterActionMap, certifierUsername: certifierUsername, certification_name: certification_name, certifierUserKey: certifierUserKey, configMap: configMap, noOfTries: noOfTries, globalDateFormat: globalDateFormat, enableCertificationTrustModel: enableCertificationTrustModel, enableIndividualCommentsForUsers: enableIndividualCommentsForUsers, enableIndividualCommentsForAccountEntitlementRoles: enableIndividualCommentsForAccountEntitlementRoles, role_AuditorLoggedIn: role_AuditorLoggedIn, enableReassignUser: enableReassignUser, defaultReassignee: defaultReassignee, enableReassignStep2: enableReassignStep2, campaignMap: campaignMap, savi_enabled: savi_enabled, useJrmRecommendationJSON: useJrmRecommendationJSON } = data;
            if (configMap?.NEW_CERT_UX === "1") ;
            else {
                if (hasCampaignLevelAccess || role_AuditorLoggedIn) window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
                if (hasOnlyCertifierLevelAccess || consulteeLoggedIn) window.location.replace("/ECM/certification/list");
            }
            const isCertificationActionable = Boolean(!role_AuditorLoggedIn && ($d623f23401a154f0$var$ALLOWED_CERTIFICATION_STATUS_FOR_REVIEW_AND_SUBMIT.includes(Number(certificationStatus)) || configMap?.hasValidAccess));
            const shouldShowReviewAndSubmitButton = isCertificationActionable;
            const isTrustScoreEnabled = Boolean(enableCertificationTrustModel || useJrmRecommendationJSON === "TRUE");
            // config for reassign user
            const reassignConfig = {
                enableReassignUser: enableReassignUser,
                enableReassignStep2: enableReassignStep2,
                defaultReassignee: defaultReassignee || configMap.defaultReassignee,
                defaultReassigneeName: defaultReassigneeName,
                enableIndividualCommentsForAccountEntitlementRoles: enableIndividualCommentsForAccountEntitlementRoles,
                enableIndividualCommentsForUsers: enableIndividualCommentsForUsers,
                showReassignPopup: configMap.SHOWREASSIGNPOPUP,
                certifierUserKey: certifierUserKey
            };
            dispatch({
                type: (0, $d6d78fc758ee4148$export$dd6b8d2bd42778be),
                payload: reassignConfig
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$47b2e1637ffaf40d),
                payload: globalDateFormat
            });
            // TODO: need to check If we need columnList
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f8b68a93cd1396c),
                payload: {
                    rowsList: objectsToBeIncluded
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$855d326a33362542),
                payload: {
                    columnList: columnList
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7ce0be7ec08b7bd9),
                payload: {
                    campaignKey: campaignKey
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$40d3ad20c39fea4a),
                payload: {
                    hasCampaignLevelAccess: hasCampaignLevelAccess,
                    role_AuditorLoggedIn: role_AuditorLoggedIn,
                    hasOnlyCertifierLevelAccess: hasOnlyCertifierLevelAccess,
                    consulteeLoggedIn: consulteeLoggedIn
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5e310ea02d328fb1),
                payload: {
                    certification_start_date: campaignMap?.startDate
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f3fb9edd8ce133a),
                payload: {
                    certification_end_date: campaignMap?.endDate
                }
            });
            const getAutoRevokeList = ()=>{
                const autoRevokeList = [];
                if (configMap?.LOCKTASKEXPIRE === "1") autoRevokeList.push("Terminated");
                if (configMap?.CREATEREVOKETASKFORUNRESPONDEDCERTIFICATIONITEMS === "1") autoRevokeList.push("Unresponded");
                if (configMap?.CREATETASKFORCERTIFIEDONEXPIRY === "1") autoRevokeList.push("Approved");
                return autoRevokeList;
            };
            const autoRevokeList = getAutoRevokeList();
            dispatch({
                type: (0, $d6d78fc758ee4148$export$4bef839f3f67fcf6),
                payload: {
                    certification_auto_revoke_list: autoRevokeList
                }
            });
            // TODO: @Sager, isTrustScoreEnabled should be renamed, as it is an object and not a bool
            dispatch({
                type: (0, $d6d78fc758ee4148$export$edbbcf29e994507a),
                payload: isTrustScoreEnabled ? {
                    enableCertificationTrustModel: enableCertificationTrustModel,
                    useJrmRecommendationJSON: useJrmRecommendationJSON
                } : undefined
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$dd0462c52301fb4d),
                payload: {
                    certification_name: certification_name
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f7b4124f0c0fddd2),
                payload: {
                    configMap: configMap
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$51750fb5a6bddff5),
                payload: {
                    isAuditor: role_AuditorLoggedIn || false
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a8aa77f63d5aad19),
                payload: {
                    enableIndividualCommentsForUsers: enableIndividualCommentsForUsers
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b0c18ac3058b419e),
                payload: Boolean(typeof configMap?.SHOWCHECKBOXBULK === "string" && configMap?.SHOWCHECKBOXBULK?.length > 0)
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$6375a4b78a6ebe),
                payload: {
                    certificationStatus: Number(certificationStatus),
                    hasValidAccess: Boolean(configMap?.hasValidAccess),
                    primaryCertifier: !consulteeLoggedIn,
                    primaryCertifierName: certifierUsername,
                    isCommentEnabled: Boolean($d623f23401a154f0$var$ALLOWED_CAMPAIGN_COMMENT_FOR_REVIEW_AND_SUBMIT?.includes(configMap?.CAMPAIGN_LOCK_COMMENTS)),
                    withESignature: Boolean(Number(configMap.ENABLE_ESIGNATURE) || Number(enableloginSignature)),
                    userAttribute: configMap.USERATTRIBUTE_ESIGNATURE || $d623f23401a154f0$var$reviewAndSubmitESignatureLoginCredentialsField,
                    enableloginSignature: enableloginSignature,
                    noOfTries: noOfTries
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$87218027c7ad9093),
                payload: {
                    enableIndividualCommentsForUsers: enableIndividualCommentsForUsers,
                    enableIndividualCommentsForAccountEntitlementRoles: enableIndividualCommentsForAccountEntitlementRoles
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b59f0ddd56aa357),
                payload: Boolean(shouldShowReviewAndSubmitButton)
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1e4b8a34c93a7dd0),
                payload: savi_enabled === "1"
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$334e0072fdfb95ed),
                payload: isCertificationActionable
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$67aafc85739b867b),
                payload: createFilterActionMap
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$855d326a33362542),
                payload: {
                    columnList: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7ce0be7ec08b7bd9),
                payload: {
                    campaignKey: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1aaf381820aaad35),
                payload: {
                    isError: true
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$dd0462c52301fb4d),
                payload: {
                    certification_name: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5e310ea02d328fb1),
                payload: {
                    certification_start_date: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f3fb9edd8ce133a),
                payload: {
                    certification_end_date: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$4bef839f3f67fcf6),
                payload: {
                    certification_auto_revoke_lsit: []
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$f7b4124f0c0fddd2),
                payload: {
                    configMap: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a8aa77f63d5aad19),
                payload: {
                    enableIndividualCommentsForUsers: null
                }
            });
            throw error;
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$e560b62bb0ef76ae),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$7f8f83f9a8bce93a = (campaignKey)=>async (dispatch)=>{
        const body = {
            campaignKey: campaignKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$3b55c5d9f617705a),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
            payload: false
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/fetchColumnsPickerList", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            const { resultsList: resultsList } = data;
            const flattenedPickerList = (0, $e7628c995f405891$export$de7358b4991653b1)(resultsList);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$9f85bed13d6d6867),
                payload: resultsList
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$2e66e5f4c45faa57),
                payload: flattenedPickerList
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$855d326a33362542),
                payload: {
                    columnList: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3b55c5d9f617705a),
                payload: false
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: true,
                    error: "Failed to fetch columns"
                }
            });
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3b55c5d9f617705a),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$4d715bff11887d61 = (certKey)=>async (dispatch, getState)=>{
        const { columnNames: columnNames } = getState().certifications;
        const body = {
            certkey: certKey,
            filterColumns: columnNames
        };
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/filters", body);
            const { valueCountMap: valueCountMap, messageKeys: messageKeys } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: false,
                    error: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$d954cd82d0ab56d0),
                payload: {
                    results: {
                        valueCountMap: valueCountMap,
                        messageKeys: messageKeys
                    }
                }
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$d954cd82d0ab56d0),
                payload: {
                    results: null
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: true,
                    error: "Failed to fetch filter data"
                }
            });
        }
    };
const $d623f23401a154f0$export$352097035a4cf7c6 = ()=>async (dispatch, getState)=>{
        const { certKey: certKey } = getState().certifications;
        const body = {
            certkey: certKey,
            clearAllCustomSessionAttributes: "true"
        };
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/updatefilter", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            const { response: response } = data;
            if (!response || response !== "Success") throw new Error("Failed to clear session objects");
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: true,
                    error: "Failed to clear session objects"
                }
            });
        }
    };
const $d623f23401a154f0$export$1f0b8da065fa133a = (filterKey, filterValue, isChecked, clearAllCustomSessionAttributes = false)=>async (dispatch, getState)=>{
        const { isLoading: isLoading, certKey: certKey } = getState().certifications;
        const body = {
            fieldname: filterKey,
            value: filterValue,
            checked: isChecked ? "1" : "0",
            certkey: certKey
        };
        if (clearAllCustomSessionAttributes) body.clearAllCustomSessionAttributes = "true";
        dispatch({
            type: (0, $d6d78fc758ee4148$export$903196cd760f40e2),
            payload: true
        });
        if (!isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            const response = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/updatefilter", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            if (response.status === 200) return true;
            throw Error("No 200 response from server");
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: true,
                    error: "Failed to update filter"
                }
            });
        }
    };
const $d623f23401a154f0$export$5ef35f45efc10503 = ()=>async (dispatch, getState)=>{
        const { certKey: certKey, isLoading: isLoading } = getState().certifications;
        const body = {
            certkey: certKey,
            clearFilter: "true"
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$903196cd760f40e2),
            payload: true
        });
        if (!isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForClearCertsFilter !== "undefined") $d623f23401a154f0$var$cancelTokenForClearCertsFilter.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForClearCertsFilter = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForClearCertsFilter.token;
            const { status: status } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/updatefilter", body, axiosRequestConfig);
            if (status === 200) return true;
            throw Error("No 200 response from server");
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$f0d808954e0679c6),
                payload: false
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Failed to clear filter" : "Data Fetch Error"
                }
            });
        }
    };
const $d623f23401a154f0$export$965ea1a49a0c67d1 = (eid, certkey, cert_entitlement_valuekey)=>async (dispatch)=>{
        const body = {
            eid: eid,
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForEntitlements.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/entitlementSummary", body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$44cea83c7eb86289),
                payload: {
                    results: response,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$44cea83c7eb86289),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$46991d3da34782bf = (certkey, cert_entitlement_valuekey, cert_userkey, cert_accountkey, cert_rolekey)=>async (dispatch)=>{
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_userkey: cert_userkey,
            cert_accountkey: cert_accountkey,
            cert_rolekey: cert_rolekey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForEntitlements.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/auditHistory", body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a252b37c42fd39c0),
                payload: {
                    results: typeof response === "object" && Array.isArray(response) ? response?.map((item, index)=>({
                            ...item,
                            index: index
                        })) : null,
                    error: null
                }
            });
            if (typeof response === "string") dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: true,
                    error: response
                }
            });
            return 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$a252b37c42fd39c0),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$83557c31dc95212a = (cert_entitlement_valuekey, cert_accountkey, offset, max)=>async (dispatch)=>{
        const body = {
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_accountkey: cert_accountkey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyPrivilegesForEntitlements.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/entitlementPrivileges", body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a71fe6648e4ae608),
                payload: {
                    results: typeof response === "object" ? response : null,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$a06b6c2be556dac8;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$a71fe6648e4ae608),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$1fbc321c679e35cc = (certkey, cert_entitlement_valuekey, cert_accountkey, offset, max, searchKey = "", loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_accountkey: cert_accountkey,
            offset: offset,
            max: max,
            searchKey: searchKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodySodForEntitlements.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/entitlementSOD", body, axiosRequestConfig);
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$46e200503484c25f),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        risks: response?.risks.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$46e200503484c25f),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.risks.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$8f78881bb4058858;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$46e200503484c25f),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$f8b073a05f313ac0 = (cert_entitlement_valuekey, offset, max, loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const body = {
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForEntitlements.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/childEntitlements", body, axiosRequestConfig);
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$842ba02ccf54b42b),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        childEntList: response?.childEntList.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$842ba02ccf54b42b),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.childEntList.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$51f82826650bc3c3;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$842ba02ccf54b42b),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$3b9a16a7c2bd6829 = (cert_entitlement_valuekey, offset, max, loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const body = {
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyDependentForEntitlements !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyDependentForEntitlements.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyDependentForEntitlements = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyDependentForEntitlements.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/mappedEntitlements", body, axiosRequestConfig);
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$e5cfbc544f1684eb),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        mappedEntList: response?.mappedEntList.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$e5cfbc544f1684eb),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.mappedEntList.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$e5cfbc544f1684eb),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$b903631ea95845bc = (eid, certKey)=>async (dispatch)=>{
        const body = {
            eid: eid,
            certkey: certKey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForAccounts.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/accountSummary", body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b98808434921fbb1),
                payload: {
                    results: response,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$b98808434921fbb1),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$188b24a44048ab8 = (certkey, cert_entitlement_valuekey, cert_userkey, cert_accountkey)=>async (dispatch)=>{
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_userkey: cert_userkey,
            cert_accountkey: cert_accountkey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForAccounts.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/auditHistory", body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7f0539351068ca18),
                payload: {
                    results: typeof response === "object" && Array.isArray(response) ? response?.map((item, index)=>({
                            ...item,
                            index: index
                        })) : null,
                    error: null
                }
            });
            if (typeof response === "string") dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: true,
                    error: response
                }
            });
            return 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$7f0539351068ca18),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$d5a553b80e9461bd = (eid, certkey, cert_userkey)=>async (dispatch)=>{
        const body = {
            eid: eid || "",
            certkey: certkey,
            cert_userkey: cert_userkey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForUsers.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/userSummary", body);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a7a89423fc1f2d99),
                payload: {
                    results: response,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$a7a89423fc1f2d99),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$ac08493018d65897 = (certkey, cert_entitlement_valuekey, cert_userkey)=>async (dispatch)=>{
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_userkey: cert_userkey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForUsers.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/auditHistory", body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$e6ae9922b78d19ee),
                payload: {
                    results: typeof response === "object" && Array.isArray(response) ? response?.map((item, index)=>({
                            ...item,
                            index: index
                        })) : null,
                    error: null
                }
            });
            if (typeof response === "string") dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: true,
                    error: response
                }
            });
            return 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$e6ae9922b78d19ee),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$d2ad049199ba44f6 = (eid, certkey, cert_rolekey)=>async (dispatch)=>{
        const body = {
            eid: eid,
            certkey: certkey,
            cert_rolekey: cert_rolekey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodySummaryForRoles.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/roleSummary", body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$85fb16097b911),
                payload: {
                    results: response,
                    error: null
                }
            });
            return 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$85fb16097b911),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$8ea25d5aa1748f67 = (certkey, cert_entitlement_valuekey, cert_userkey, cert_rolekey)=>async (dispatch)=>{
        const body = {
            certkey: certkey,
            cert_entitlement_valuekey: cert_entitlement_valuekey,
            cert_userkey: cert_userkey,
            cert_rolekey: cert_rolekey
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyHistoryForRoles.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/auditHistory", body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b0fdc72ce6a50d97),
                payload: {
                    results: typeof response === "object" && Array.isArray(response) ? response?.map((item, index)=>({
                            ...item,
                            index: index
                        })) : null,
                    error: null
                }
            });
            if (typeof response === "string") dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: true,
                    error: response
                }
            });
            return 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$b0fdc72ce6a50d97),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$5410f6e40c605c13 = (cert_rolekey, offset, max, loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const body = {
            cert_rolekey: cert_rolekey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyEntitlementForRoles.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/roleEntitlements", body, axiosRequestConfig);
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$940b9d07f90752d),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        roleEntList: response?.roleEntList.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$940b9d07f90752d),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.roleEntList.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$6cc684447a8d7b17;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$940b9d07f90752d),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$d602a5e5a48fdf7d = (cert_rolekey, offset, max, loadMoreStatus = (0, $d6d78fc758ee4148$export$95aee1eca5275acc))=>async (dispatch)=>{
        const body = {
            cert_rolekey: cert_rolekey,
            offset: offset,
            max: max
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
            payload: {
                isSidePanelError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles !== "undefined") $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForSidePanelBodyChildForRoles.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/childRoles", body, axiosRequestConfig);
            const { response: response } = data;
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) dispatch({
                type: (0, $d6d78fc758ee4148$export$d4c8fbbc4fca0999),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: {
                        ...response,
                        childRoleList: response?.childRoleList.map((item, index)=>({
                                ...item,
                                index: `${offset}-${index}`
                            }))
                    },
                    error: null
                }
            });
            if (loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) dispatch({
                type: (0, $d6d78fc758ee4148$export$d4c8fbbc4fca0999),
                loadMoreStatus: loadMoreStatus,
                payload: {
                    results: response?.childRoleList.map((item, index)=>({
                            ...item,
                            index: `${offset}-${index}`
                        }))
                }
            });
            return 0, $d60257e8dc27bf16$export$51f82826650bc3c3;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$d4c8fbbc4fca0999),
                payload: {
                    results: null,
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$1b7cff865d967245),
                payload: {
                    isSidePanelError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$886e16c80cfe3a1a = (certkey, group_by)=>async (dispatch, getState)=>{
        const { isLoadingReviewAndSubmit: isLoadingReviewAndSubmit } = getState().certifications;
        const body = {
            certkey: certkey,
            group_by: group_by
        };
        if (!isLoadingReviewAndSubmit) dispatch({
            type: (0, $d6d78fc758ee4148$export$1d889ec5a0bd35b5),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$32524a0d8ac0b191),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/lockSummary", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            const { response: response, Summary: Summary } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b1c80b328234b28e),
                payload: {
                    results: {
                        [group_by]: response === "Success" ? Summary : null
                    },
                    error: "null"
                }
            });
            return 0, $d6d78fc758ee4148$export$b1c80b328234b28e;
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$b1c80b328234b28e),
                payload: {
                    results: {},
                    error: "Data Fetch Error"
                }
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$32524a0d8ac0b191),
                payload: {
                    isError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$776ef17d04a202bf = (certkey, eSignatureLogin, noOfTries, payload)=>async (dispatch, getState)=>{
        const { isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit } = getState().certifications;
        const body = {
            certkey: certkey,
            eSignatureLogin: eSignatureLogin,
            noOfTries: noOfTries,
            ...payload
        };
        if (!isSubmittingReviewAndSubmit) dispatch({
            type: (0, $d6d78fc758ee4148$export$8fa9055a97f67430),
            payload: true
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/validateESignature", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            const { response: response, validateESignature: validateESignatureStatus } = data;
            if (validateESignatureStatus === undefined || validateESignatureStatus === null || !validateESignatureStatus) throw response;
            return response;
        } catch (error) {
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$6bd0ceb6f0238e0a = (certkey, lockComments)=>async (dispatch, getState)=>{
        const { isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit } = getState().certifications;
        const body = {
            certkey: certkey,
            lockComments: lockComments,
            requestOrigin: "UI"
        };
        if (!isSubmittingReviewAndSubmit) dispatch({
            type: (0, $d6d78fc758ee4148$export$8fa9055a97f67430),
            payload: true
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/lock", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            const { response: response, lockSuccessfull: lockSuccessfull } = data;
            if (lockSuccessfull === undefined || lockSuccessfull === null || !lockSuccessfull) throw response;
            return response;
        } catch (error) {
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$f75c1d1e7da3ca60 = (certkey)=>async (dispatch, getState)=>{
        const { isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit } = getState().certifications;
        const body = {
            certkey: certkey,
            requestOrigin: "UI"
        };
        if (!isSubmittingReviewAndSubmit) dispatch({
            type: (0, $d6d78fc758ee4148$export$8fa9055a97f67430),
            payload: true
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/completeConsult", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            const { consultComplete: consultComplete } = data;
            if (consultComplete === undefined || consultComplete === null || !consultComplete) throw Error("Unable to complete this certification at the moment");
            return "Success";
        } catch (error) {
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$d5c4a54b97b3960a = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$bfbc1bdccfb4abf5),
            payload: status
        });
    };
const $d623f23401a154f0$export$889241fc0afda8a9 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$69729db10395ff90),
            payload: status
        });
    };
const $d623f23401a154f0$export$2af49e179df91659 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$768f00e6b30d478),
            payload: status
        });
    };
const $d623f23401a154f0$export$ebeb2bd8ecd91be9 = (state)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$42cd2e4c8af9ab41),
            payload: state
        });
    };
const $d623f23401a154f0$export$4012debfa64c5cbf = (isAlert, alertText)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$98054ce8e1cd6185),
            payload: {
                isAlert: isAlert,
                alertText: alertText
            }
        });
    };
const $d623f23401a154f0$export$bb9465329a3d3cad = (data)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$2d1f20523798a1b7),
            payload: data
        });
    };
const $d623f23401a154f0$export$1a295a970dce82de = (state)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$afe1eb1cba0072ef),
            payload: state
        });
    };
const $d623f23401a154f0$export$1b5df5f4da3e20b8 = ()=>async (dispatch, getState)=>{
        const { certKey: certKey, tabs: tabs, totalItems: totalItems } = getState().certifications;
        const { tabData: tabData } = tabs;
        // Get the active tab key
        const activeTabKey = tabData?.find((tab)=>tab.isActive).key;
        const activeTab = $d623f23401a154f0$var$tabMapping[activeTabKey] || "all";
        const body = {
            certkey: certKey,
            tab: activeTab,
            requestOrigin: "UI",
            onlyTotalCount: true
        };
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/selectAll", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$84719c80a3de3402),
                payload: data.totalSelectedItems || totalItems
            });
        } catch (error) {
            (0, $hopDi$Logger).log("Error while updating count: - ", error);
        }
    };
const $d623f23401a154f0$export$c594ad0cf83b2327 = (certkey, clear = false)=>async (dispatch, getState)=>{
        const { searchText: searchText, tabs: tabs } = getState().certifications;
        const { tabData: tabData } = tabs;
        // Get the active tab key
        const activeTabKey = tabData?.find((tab)=>tab.isActive).key;
        const activeTab = $d623f23401a154f0$var$tabMapping[activeTabKey] || "all";
        const body = {
            certkey: certkey,
            tab: activeTab,
            sSearch: `${searchText}`,
            requestOrigin: "UI"
        };
        if (clear) body.clrAll = "1";
        dispatch({
            type: (0, $d6d78fc758ee4148$export$60473f3971dee5df),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$2890f4c8d2907863),
            payload: true
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/selectAll", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$2d1f20523798a1b7),
                payload: !clear ? data : null
            });
        } catch (error) {
            if (error === (0, $167a6b08fa265d03$export$b12833517019127a)) throw Error(error);
            throw Error("Not able to perform this action.");
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$60473f3971dee5df),
                payload: false
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$2890f4c8d2907863),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$5b43dc99ee28ff0f = (certkey, eid, checked)=>async (dispatch)=>{
        const body = {
            certkey: certkey,
            eid: eid,
            checked: checked ? "1" : "0",
            requestOrigin: "UI"
        };
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/addRemoveFromSession", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$2d1f20523798a1b7),
                payload: data
            });
            return data;
        } catch (error) {
            if (error === (0, $167a6b08fa265d03$export$b12833517019127a)) throw Error(error);
            throw Error("Not able to perform this action.");
        }
    };
const $d623f23401a154f0$export$79d150fc3aa7c31d = (userAccountKeys, clear = false)=>async (dispatch, getState)=>{
        const { searchText: searchText, certKey: certKey, tabs: tabs } = getState().certifications;
        const { tabData: tabData } = tabs;
        // Get the active tab key
        const activeTabKey = tabData?.find((tab)=>tab.isActive).key;
        const activeTab = $d623f23401a154f0$var$tabMapping[activeTabKey] || "all";
        const body = {
            certkey: certKey,
            tab: activeTab,
            requestOrigin: "UI",
            sSearch: `${searchText}`,
            ...userAccountKeys
        };
        if (clear) body.clrAll = "1";
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/selectAll", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$2d1f20523798a1b7),
                payload: data
            });
            return data;
        } catch (error) {
            if (error === (0, $167a6b08fa265d03$export$b12833517019127a)) throw Error(error);
            throw Error("Not able to perform this action.");
        }
    };
const $d623f23401a154f0$export$c6b81b3f3f151197 = (certkey, status, comments, payload)=>async (dispatch, getState)=>{
        const body = {
            certkey: certkey,
            status: status,
            comments: comments,
            bulkOperation: "1",
            ...payload
        };
        const { bulkAction: bulkAction } = getState().certifications;
        if (!bulkAction?.isSubmittingAction) dispatch({
            type: (0, $d6d78fc758ee4148$export$c19826a63dd39ec7),
            payload: true
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/bulkUpdate", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            return data;
        } catch (error) {
            if (error === (0, $167a6b08fa265d03$export$b12833517019127a)) throw Error(error);
            throw bulkAction?.bulkFooterInfo;
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$c19826a63dd39ec7),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$327928746d63d77e = (certkey, assignee, comments, reassignAssociated)=>async (dispatch, getState)=>{
        const body = {
            certkey: certkey,
            assignee: assignee,
            bulkOperation: "1",
            comments: comments,
            reassignAssociated: reassignAssociated
        };
        const { bulkAction: bulkAction } = getState().certifications;
        if (!bulkAction?.isSubmittingAction) dispatch({
            type: (0, $d6d78fc758ee4148$export$c19826a63dd39ec7),
            payload: true
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/bulkConsult", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            return data;
        } catch (error) {
            if (error === (0, $167a6b08fa265d03$export$b12833517019127a)) throw Error(error);
            throw bulkAction?.bulkFooterInfo;
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$c19826a63dd39ec7),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$1f381a6abe5abb6c = (certkey, assignee, comments, controllerToPoint, payload)=>async (dispatch, getState)=>{
        const { bulkAction: bulkAction, campaignKey: campaignKey } = getState().certifications;
        const body = {
            certkey: certkey,
            campaignkey: `${campaignKey}`,
            callFromBulk: "yes",
            comments: comments,
            requestOrigin: "UI",
            ...payload
        };
        if (assignee.length > 0) {
            body.assignee = assignee;
            body.useDefaultReassignee = "0";
            body.hasNewManagerSelected = "yes";
        }
        if (!bulkAction?.isSubmittingAction) dispatch({
            type: (0, $d6d78fc758ee4148$export$c19826a63dd39ec7),
            payload: true
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post(`/certifications/v2/items/${controllerToPoint}`, body, $d623f23401a154f0$var$axiosTimeoutConfig);
            const { msg: msg } = data;
            if (msg === null) throw Error("Coming null values as resposne //WIP");
            return data;
        } catch (error) {
            if (error === (0, $167a6b08fa265d03$export$b12833517019127a)) throw Error(error);
            throw bulkAction?.bulkFooterInfo;
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$c19826a63dd39ec7),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$9738ba63bdee8079 = (payload)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$a1d03b0ccb874026),
            payload: payload
        });
    };
const $d623f23401a154f0$export$6905b0d830e88406 = (state, arsTaskPayload)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e87c818aed68e8cb),
            payload: {
                isOpen: state,
                arsTaskPayload: arsTaskPayload
            }
        });
        if (!state) setTimeout(()=>{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
                payload: true
            });
        }, [
            500
        ]);
    };
const $d623f23401a154f0$export$fee47e6aac44de0e = (state)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
            payload: state
        });
    };
const $d623f23401a154f0$export$c45c025fc9b885f7 = (certkey, type, payload)=>async (dispatch, getState)=>{
        const { accessRequestHistory: accessRequestHistory } = getState().certifications;
        const body = {
            certkey: certkey,
            ...payload
        };
        if (!accessRequestHistory?.isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8671c3354e9690ea),
            payload: {
                isError: false,
                error: null
            }
        });
        try {
            if (typeof $d623f23401a154f0$var$cancelTokenForAccessRequestHistory !== "undefined") $d623f23401a154f0$var$cancelTokenForAccessRequestHistory.cancel("Forced Cancellation");
            $d623f23401a154f0$var$cancelTokenForAccessRequestHistory = (0, $hopDi$axios).CancelToken.source();
            const axiosRequestConfig = {
                ...$d623f23401a154f0$var$axiosTimeoutConfig
            };
            axiosRequestConfig.cancelToken = $d623f23401a154f0$var$cancelTokenForAccessRequestHistory.token;
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post(`/certifications/v2/items/${type}`, body, axiosRequestConfig);
            const { response: response } = data;
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
                payload: false
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$dcc76e3383a21811),
                payload: response
            });
        } catch (error) {
            if (error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89)) dispatch({
                type: (0, $d6d78fc758ee4148$export$dcc76e3383a21811),
                payload: null
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$8671c3354e9690ea),
                payload: {
                    isError: error?.code !== (0, $d6d78fc758ee4148$export$2444563004f47e89),
                    error: error?.code === (0, $d6d78fc758ee4148$export$2444563004f47e89) ? "Forced Cancellation" : "Data Fetch Error"
                }
            });
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7a8caab59b607807),
                payload: false
            });
        }
    };
// Action Button API Calls
const $d623f23401a154f0$var$performCertificationAction = async (dispatch, actionData)=>{
    let body = null;
    if (actionData?.accountKey) body = {
        certkey: actionData.certKey,
        cert_userkey: actionData.userKey,
        cert_entitlement_valuekey: actionData.entValueKey,
        cert_accountkey: actionData.accountKey,
        cert_rolekey: actionData.certRoleKey,
        status: `${actionData.status}`
    };
    else body = {
        certkey: actionData.certKey,
        cert_userkey: actionData.userKey,
        cert_entitlement_valuekey: actionData.entValueKey,
        cert_rolekey: actionData.certRoleKey,
        status: `${actionData.status}`
    };
    if (actionData?.comment) body.comments = actionData.comment;
    dispatch({
        type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b)
    });
    try {
        await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/approve", body);
        setTimeout(()=>{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
            });
        }, 2000);
        dispatch({
            type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
        });
        return {
            isSuccess: true,
            isLoading: false
        };
    } catch (error) {
        dispatch({
            type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
            payload: {
                error: error.message
            }
        });
        (0, $hopDi$Logger).error("Error: ", Error(error.message));
        // Reset for the isActionError to allow alertbanner to check on next call
        setTimeout(()=>{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
            });
        }, 1000);
    }
};
const $d623f23401a154f0$export$bae1635877bd1db1 = (modalState)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e8fdce46a9e3e027),
            payload: modalState
        });
    };
const $d623f23401a154f0$export$85696a56c199705e = (isAtLeastThreeActions)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$9130d79ae651148),
            payload: isAtLeastThreeActions
        });
    };
const $d623f23401a154f0$export$a0116b9e1a4bda07 = async (dispatch, actionData, currentChildObject)=>{
    let body = null;
    body = {
        certkey: actionData.certKey,
        cert_userkey: actionData.userKey,
        cert_entitlement_valuekey: actionData.entValueKey,
        cert_accountkey: actionData.accountKey,
        cert_rolekey: actionData.roleKey
    };
    dispatch({
        type: (0, $d6d78fc758ee4148$export$64fa42aee49aa7c3),
        payload: {
            isLoading: true
        }
    });
    try {
        const response = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/verifyParentItemStatus", body);
        const formattedVarifyRes = [];
        const userData = response.data.userMap;
        const accountData = response.data.accountMap;
        if (userData) formattedVarifyRes.push(userData);
        if (accountData) formattedVarifyRes.push(accountData);
        if (formattedVarifyRes?.length > 0) formattedVarifyRes.push(currentChildObject);
        dispatch({
            type: (0, $d6d78fc758ee4148$export$738bb6c8834cc24b),
            payload: {
                data: formattedVarifyRes
            }
        });
        return response.data;
    } catch (error) {
        dispatch({
            type: (0, $d6d78fc758ee4148$export$3c40ab84ee726c27),
            payload: {
                error: error.message
            }
        });
        (0, $hopDi$Logger).error("Error: ", Error(error.message));
        // Reset for the isActionError to allow alertbanner to check on next call
        setTimeout(()=>{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
            });
        }, 1000);
    }
};
const $d623f23401a154f0$export$348853d7c8cab35b = (actionData)=>async (dispatch)=>{
        const body = {
            certkey: actionData.certKey,
            cert_userkey: actionData.userKey,
            status: `${actionData.status}`
        };
        if (actionData?.comments) body.comments = actionData.comments;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b)
        });
        try {
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/revoke", body);
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: error.message
                }
            });
        }
    };
const $d623f23401a154f0$export$9f62cbf6b3b94af9 = (actionData)=>async (dispatch)=>{
        const body = {
            certkey: actionData.certKey,
            cert_userkey: actionData.userKey,
            status: `${actionData.status}`
        };
        if (!actionData?.accountKey) body.extendedEndDate = actionData?.extendedEndDate;
        else body.cert_accountkey = actionData?.accountKey;
        if (actionData?.comments) body.comments = actionData.comments;
        if (actionData?.entValueKey) {
            body.requestOrigin = "UI";
            body.cert_entitlement_valuekey = actionData?.entValueKey;
            body.enddate = actionData?.extendedEndDate;
            delete body.extendedEndDate;
        }
        if (actionData?.certRoleKey) body.cert_rolekey = actionData?.certRoleKey;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b)
        });
        try {
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/approve", body);
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: error?.response?.data?.response || error.message
                }
            });
        }
    };
const $d623f23401a154f0$export$8a3b1d82a4510306 = (actionData)=>async (dispatch)=>{
        const body = {
            eid: actionData.eid,
            cert_accountkey: actionData.accountKey,
            certkey: actionData.certKey,
            cert_userkey: actionData.userKey,
            cert_entitlement_valuekey: actionData.entValueKey,
            status: `${actionData.status}`
        };
        if (actionData?.comments) body.comments = actionData.comments;
        if (actionData?.certRoleKey) body.cert_rolekey = actionData?.certRoleKey;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b)
        });
        try {
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/reject", body);
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: error.message
                }
            });
        }
    };
const $d623f23401a154f0$export$e77519515695c9c7 = (actionData)=>async (dispatch)=>$d623f23401a154f0$var$performCertificationAction(dispatch, actionData);
const $d623f23401a154f0$export$70cd670b72ffe020 = (actionData)=>async (dispatch)=>$d623f23401a154f0$var$performCertificationAction(dispatch, actionData);
const $d623f23401a154f0$export$6e5b0daaf8d927e4 = (certKey, groupByType, initialLoad)=>async (dispatch)=>{
        const body = {
            certkey: certKey,
            group_by: groupByType
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$5296abadcbacb235),
            payload: true
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/fetchCertificationProgress", body);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b77c91b145bf9647),
                payload: {
                    groupByType: groupByType,
                    data: data
                }
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$569cf9037aa74da),
                payload: {
                    error: error.message,
                    initialLoad: initialLoad
                }
            });
        // throw Error(error);
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5296abadcbacb235),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$aa7b16fe4622cebe = (columnName, sortDirection)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e7b0a9aed86b0918),
            payload: {
                columnName: columnName,
                sortDirection: sortDirection
            }
        });
    };
const $d623f23401a154f0$export$683be6298bff3717 = ()=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8810396661da9a69)
        });
    };
const $d623f23401a154f0$export$b839edba12a89f4d = (state)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$c3fe830879e37a3d),
            payload: state
        });
    };
const $d623f23401a154f0$export$348ff7906afdfd12 = (certKey, searchText)=>async (dispatch, getState)=>{
        const { consultActionAssignee: consultActionAssignee } = getState().certifications;
        const body = {
            certkey: certKey,
            offset: "0",
            max: "3000"
        };
        if (searchText) // to search user by name
        body.sSearch = searchText;
        if (!consultActionAssignee?.isLoading) dispatch({
            type: (0, $d6d78fc758ee4148$export$c3fe830879e37a3d),
            payload: true
        });
        dispatch({
            type: (0, $d6d78fc758ee4148$export$d91200b15b0cd8ec),
            payload: {
                error: null
            }
        });
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/fetchUserList", body);
            if (data.resultsList) dispatch({
                type: (0, $d6d78fc758ee4148$export$97d842f50b1d9083),
                payload: {
                    data: data.resultsList
                }
            });
            else dispatch({
                type: (0, $d6d78fc758ee4148$export$97d842f50b1d9083),
                payload: {
                    data: []
                }
            });
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$d91200b15b0cd8ec),
                payload: {
                    error: error === (0, $167a6b08fa265d03$export$b12833517019127a) ? error : error.message
                }
            });
        } finally{
            dispatch({
                type: (0, $d6d78fc758ee4148$export$c3fe830879e37a3d),
                payload: false
            });
        }
    };
const $d623f23401a154f0$export$29d12c975855399 = (actionData, actionKind)=>async (dispatch, getState)=>{
        const body = {
            ...actionData
        };
        const { reassignConfigMap: reassignConfigMap } = getState().certifications;
        // remove assignee when default assignee selected
        if (body?.assignee === reassignConfigMap.defaultReassignee) // eslint-disable-next-line no-param-reassign
        delete body.assignee;
        if (body?.updateStatus) delete body.updateStatus;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
            payload: actionKind
        });
        try {
            const actionURL = actionData?.updateStatus ? "reject" : "reassign";
            const reassignResponse = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post(`/certifications/v2/items/${actionURL}`, body);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            const { data: data } = reassignResponse;
            const alertBannerPayload = {
                shouldShowBanner: false
            };
            if (data?.response && typeof data?.response === "string") {
                alertBannerPayload.shouldShowBanner = true;
                alertBannerPayload.payload = {
                    title: "Success",
                    description: data.response
                };
            }
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            return {
                isSuccess: true,
                isLoading: false,
                alertBannerPayload: alertBannerPayload
            };
        } catch (error) {
            let errorMsg = "";
            if (error?.response?.data?.response) errorMsg = error.response.data.response;
            else errorMsg = error.message;
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: errorMsg
                }
            });
        }
    };
const $d623f23401a154f0$export$627e0e03ed6c2927 = (actionData, actionKind)=>async (dispatch)=>{
        const body = actionData;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
            payload: actionKind
        });
        try {
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/approve", body);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            let errorMsg = "";
            if (error?.response?.data?.response) errorMsg = error.response.data.response;
            else errorMsg = error.message;
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: errorMsg
                }
            });
        }
    };
const $d623f23401a154f0$export$4fcead6ba6a8c371 = (tabToHighLight)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$3db41bfbe846115),
            payload: tabToHighLight
        });
    };
const $d623f23401a154f0$export$a80194b4790381a6 = (payload)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$f66f20183ec2a996),
            payload: payload
        });
    };
const $d623f23401a154f0$export$3f4330c48a705a7a = (actionData, actionKind)=>async (dispatch)=>{
        const body = {
            ...actionData
        };
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
            payload: actionKind
        });
        try {
            const consultResponse = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/consult", body);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            const { data: data } = consultResponse;
            const alertBannerPayload = {
                shouldShowBanner: false
            };
            if (data?.response && typeof data?.response === "string") {
                alertBannerPayload.shouldShowBanner = true;
                alertBannerPayload.payload = {
                    title: "Success",
                    description: data.response
                };
            }
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            return {
                isSuccess: true,
                isLoading: false,
                alertBannerPayload: alertBannerPayload
            };
        } catch (error) {
            let errorMsg = "";
            if (error?.response?.data?.response) errorMsg = error.response.data.response;
            else errorMsg = error.message;
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: errorMsg
                }
            });
        }
    };
const $d623f23401a154f0$export$9bbc436a94e70d04 = (actionData, actionKind)=>async (dispatch)=>{
        const body = actionData;
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
            payload: actionKind
        });
        try {
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/approve", body);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b3c7c737b53ea33e)
            });
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            return {
                isSuccess: true,
                isLoading: false
            };
        } catch (error) {
            let errorMsg = "";
            if (error?.response?.data?.response) errorMsg = error.response.data.response;
            else errorMsg = error.message;
            setTimeout(()=>{
                dispatch({
                    type: (0, $d6d78fc758ee4148$export$3564fc123aed043c)
                });
            }, 2000);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$5755ae8e491f730),
                payload: {
                    error: errorMsg
                }
            });
        }
    };
const $d623f23401a154f0$export$e349e9296213dd36 = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$6932187838de83d9),
            payload: status
        });
    };
const $d623f23401a154f0$export$f4f9bb309d2b8abf = (certkey, postFailureAction, retryAction)=>async (dispatch)=>{
        try {
            // Set loading status to true
            dispatch({
                type: (0, $d6d78fc758ee4148$export$df3ba5c051a876de),
                payload: true
            });
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/saviStatus", {
                certkey: certkey,
                signal: "TRUST_SCORE"
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$4009fb2303280d3a),
                payload: data
            });
        } catch (err) {
            postFailureAction({
                title: "There was a problem loading Smart Decisions.",
                retryAction: retryAction
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$9b4357356da505fc),
                payload: false
            });
        }
    };
const $d623f23401a154f0$var$TabDecision = {
    0: (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
    1: (0, $d44c789d5b60f9bf$export$807a0bc890800408),
    2: (0, $d44c789d5b60f9bf$export$807a0bc890800408)
};
const $d623f23401a154f0$var$isDecidedTabDoneTab = (tabKey, decidedTab)=>tabKey === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && tabKey === decidedTab;
const $d623f23401a154f0$export$f9e5f61dba028e00 = (flag)=>async (dispatch)=>dispatch({
            type: (0, $d6d78fc758ee4148$export$25054d4d5db33a66),
            payload: flag
        });
const $d623f23401a154f0$export$257ace57b4563d30 = (payload, config)=>async (dispatch)=>{
        const { columnNames: columnNames, max: max, offset: offset, postSuccessAction: postSuccessAction, postFailureAction: postFailureAction, tabData: tabData } = config;
        try {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$a0f86ea1258b795c),
                payload: true
            });
            const { approve_overwrite: approve_overwrite, reject_overwrite: reject_overwrite, savi_approve: savi_approve, savi_reject: savi_reject } = payload;
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/applySaviActions", {
                ...payload,
                approve_overwrite: approve_overwrite !== undefined ? `${approve_overwrite}` : approve_overwrite,
                reject_overwrite: reject_overwrite !== undefined ? `${reject_overwrite}` : reject_overwrite,
                savi_approve: savi_approve !== undefined ? `${savi_approve}` : savi_approve,
                savi_reject: savi_reject !== undefined ? `${savi_reject}` : savi_reject
            });
            dispatch($d623f23401a154f0$export$afd1b438af1720fe(payload.certkey));
            dispatch($d623f23401a154f0$export$6e5b0daaf8d927e4(payload.certkey, "decision", true));
            const decidedTab = $d623f23401a154f0$var$TabDecision[(savi_approve || 0) + (savi_reject || 0)];
            const isHighlightedTab = tabData.map((tab)=>({
                    ...tab,
                    isHighlighted: tab.key === decidedTab,
                    showSaviPopupTab: $d623f23401a154f0$var$isDecidedTabDoneTab(tab.key, decidedTab)
                }));
            dispatch($d623f23401a154f0$export$e9c5cd8aea0cabc7(isHighlightedTab));
            dispatch($d623f23401a154f0$export$f9e5f61dba028e00(true));
            dispatch($d623f23401a154f0$export$fad033acbe739b9c(payload.certkey, columnNames, max, offset));
            postSuccessAction();
            dispatch($d623f23401a154f0$export$4fcead6ba6a8c371(decidedTab));
            dispatch({
                type: (0, $d6d78fc758ee4148$export$b021d9c474ee48de),
                payload: payload
            });
        } catch (err) {
            postFailureAction({
                title: "There was a problem loading Smart Decisions.",
                retryAction: config.retryAction
            });
            dispatch({
                type: (0, $d6d78fc758ee4148$export$7e0741aad82ab94b),
                payload: false
            });
        }
    };
const $d623f23401a154f0$var$fetchFactorsFromTrustData = (factor)=>{
    const factorsList = [];
    Object.entries(factor).forEach(([key, value])=>{
        const { messageKey: messageKey, messageKeyDescription: messageKeyDescription, payload: payload } = value;
        const factorItem = {
            id: key,
            title: messageKey,
            description: messageKeyDescription,
            iconKind: payload.icon,
            payload: payload
        };
        factorsList.push(factorItem);
    });
    return factorsList;
};
const $d623f23401a154f0$export$fe65047b4416261e = (status)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$8ced494098659b02),
            payload: status
        });
    };
const $d623f23401a154f0$export$5221a830a76e1142 = (certkey)=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/smartCardFilters", {
                certkey: certkey
            });
            const { riskFactorsSmartCards: riskFactorsSmartCards, trustFactorsSmartCards: trustFactorsSmartCards } = data;
            // Commented the trust factors due to requirement change. Trust factors will be re-introduced as a separate tab later.
            const sanitizedData = {
                risk_factors: {
                    title: riskFactorsSmartCards.messageKey,
                    description: riskFactorsSmartCards.messageKeyDescription,
                    iconKind: "SmartFilterRiskMeter",
                    factors: $d623f23401a154f0$var$fetchFactorsFromTrustData(riskFactorsSmartCards.smartCards)
                }
            };
            const trustFactors = $d623f23401a154f0$var$fetchFactorsFromTrustData(trustFactorsSmartCards.trustSmartCards);
            sanitizedData.risk_factors.factors.push(...trustFactors);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$58ccb446f68b9f12),
                payload: sanitizedData
            });
        } catch (err) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$71e126c527a418be)
            });
        }
    };
const $d623f23401a154f0$export$fe1a3b23990ade30 = (payload, postDispatchAction)=>async (dispatch, getState)=>{
        try {
            const { certKey: certKey, columnNames: columnNames, searchText: searchText } = getState().certifications;
            const { MAX_NUMBER_OF_RECORDS: MAX_NUMBER_OF_RECORDS, setShowSmartFilterLoader: setShowSmartFilterLoader, dontRefreshItems: dontRefreshItems } = postDispatchAction;
            if (!payload.clearFilter) await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/updatefilter", {
                certkey: certKey,
                clearFilter: "true"
            }, $d623f23401a154f0$var$axiosTimeoutConfig);
            dispatch({
                type: (0, $d6d78fc758ee4148$export$903196cd760f40e2),
                payload: true
            });
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/updatefilter", payload, $d623f23401a154f0$var$axiosTimeoutConfig);
            if (!dontRefreshItems) dispatch($d623f23401a154f0$export$fad033acbe739b9c(certKey, columnNames, MAX_NUMBER_OF_RECORDS, 0, searchText));
            if (setShowSmartFilterLoader) setShowSmartFilterLoader(false);
        } catch (error) {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$be9207d1796cf80),
                payload: {
                    isError: true,
                    error: "Failed to update filter"
                }
            });
        }
    };
const $d623f23401a154f0$export$3afc30d9c2fc6ef = (status)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$16e0d1398b26a1e2),
            payload: {
                status: status
            }
        });
    };
const $d623f23401a154f0$export$ce1119a9829e80f8 = (payload)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$c51bf664ca9c6b15),
            payload: payload
        });
    };
const $d623f23401a154f0$export$7d8ceafb9568ec2d = (status)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$24686dd5be2846fd),
            payload: status
        });
    };
const $d623f23401a154f0$export$ff97474e35a46941 = (flag)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$e5f04d968a3f4885),
            payload: flag
        });
    };
const $d623f23401a154f0$export$5b19fac081290462 = (payload)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$40b13b5dcefcbafd),
            payload: payload
        });
    };
const $d623f23401a154f0$export$5015b7af24ac6daa = ()=>async (dispatch)=>{
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/getPersonalization");
            const status = data.response === "No View Found" ? "NO_PERSONALIZATION" : "EXIST_PERSONALIZATION";
            dispatch($d623f23401a154f0$export$ce1119a9829e80f8({
                view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW,
                applied: true
            }));
            dispatch($d623f23401a154f0$export$3afc30d9c2fc6ef(status));
            dispatch({
                type: (0, $d6d78fc758ee4148$export$878cfd23fc23c300),
                payload: data
            });
        } catch (error) {
            dispatch($d623f23401a154f0$export$ce1119a9829e80f8({
                view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                applied: false
            }));
            dispatch($d623f23401a154f0$export$3afc30d9c2fc6ef(""));
            dispatch({
                type: (0, $d6d78fc758ee4148$export$878cfd23fc23c300),
                payload: {}
            });
        }
    };
const $d623f23401a154f0$export$837b183b02987624 = (payload)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$4907f9a8e1f94d67),
            payload: payload
        });
    };
const $d623f23401a154f0$export$b8bb943818e6e839 = (payload)=>async (dispatch)=>{
        const body = payload;
        try {
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/createPersonalization", body);
            dispatch($d623f23401a154f0$export$837b183b02987624((0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).CREATE_SUCCESS));
            dispatch($d623f23401a154f0$export$5015b7af24ac6daa());
        } catch (error) {
            dispatch($d623f23401a154f0$export$837b183b02987624((0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).CREATE_FAILED));
            dispatch($d623f23401a154f0$export$3afc30d9c2fc6ef(""));
            dispatch($d623f23401a154f0$export$ff97474e35a46941(true));
        }
    };
const $d623f23401a154f0$export$1ecd851f8e273137 = (payload, eTag)=>async (dispatch)=>{
        const body = payload;
        try {
            const config = {
                headers: {
                    "If-Match": `${eTag}`
                }
            };
            await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/updatePersonalization", body, config);
            dispatch($d623f23401a154f0$export$837b183b02987624((0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).UPDATE_SUCCESS));
            dispatch($d623f23401a154f0$export$5015b7af24ac6daa());
        } catch (error) {
            if (error?.response?.data?.response === "invalidLength") dispatch($d623f23401a154f0$export$837b183b02987624((0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).UPDATE_FAILED_INVALID_LENGTH));
            else dispatch($d623f23401a154f0$export$837b183b02987624((0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).UPDATE_FAILED));
            dispatch($d623f23401a154f0$export$3afc30d9c2fc6ef("UPDATE_PERSONALIZATION_FAILED"));
        }
    };
const $d623f23401a154f0$export$2cbfe24d13ec38c6 = (flag)=>(dispatch)=>dispatch({
            type: (0, $d6d78fc758ee4148$export$7955a070d3ebcb88),
            payload: flag
        });
const $d623f23401a154f0$export$a38f157fd98f0bab = (flag)=>(dispatch)=>dispatch({
            type: (0, $d6d78fc758ee4148$export$12b8b0c2680dfdd3),
            payload: flag
        });
const $d623f23401a154f0$export$40982fad6484543 = (payload)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$4ab9d0b6e0a2e2b),
            payload: payload
        });
    };
const $d623f23401a154f0$export$c379fcb2cf9e7a46 = (payload)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$9f1b82a3dd944b0e),
            payload: payload
        });
    };
const $d623f23401a154f0$export$c2f798e898b3f9ba = (payload)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$384e10a5fce8f786),
            payload: payload
        });
    };
const $d623f23401a154f0$export$bf978479f6cb60e8 = (certkey)=>async (dispatch)=>{
        const body = {
            certkey: certkey
        };
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/export", body);
            if (data.response) dispatch($d623f23401a154f0$export$40982fad6484543({
                exportStatus: "SUCCESS",
                timeStamp: Date.now()
            }));
        } catch (error) {
            if (error?.response?.status === 412) dispatch($d623f23401a154f0$export$40982fad6484543({
                exportStatus: "FAILED-412",
                timeStamp: Date.now()
            }));
            else dispatch($d623f23401a154f0$export$40982fad6484543({
                exportStatus: "FAILED",
                timeStamp: Date.now()
            }));
        }
    };
const $d623f23401a154f0$export$2fef834aeec9521f = (payload)=>(dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$4102f51782d2b340),
            payload: payload
        });
    };
const $d623f23401a154f0$export$7f414ea94ed1bade = (certKey, columnNames, max, offset, searchText = "")=>async (dispatch)=>{
        const body = {
            certkey: certKey,
            max: `${max}`,
            offset: `${offset}`,
            requestOrigin: "UI",
            sSearch: `${searchText}`,
            columnsToShow: columnNames,
            tab: "all"
        };
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items", body);
            const { total: total } = data;
            dispatch($d623f23401a154f0$export$2fef834aeec9521f(total));
        } catch (error) {
            dispatch($d623f23401a154f0$export$2fef834aeec9521f(null));
        }
    };
const $d623f23401a154f0$export$99843d46b6bfa277 = (payload)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$55cfff3090f887bb),
            payload: payload
        });
    };
const $d623f23401a154f0$export$e9d81ac38d0006c1 = (payload)=>async (dispatch)=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$ff736dce437d4f45),
            payload: payload
        });
    };
const $d623f23401a154f0$export$fa25dca28252b044 = (flag)=>(dispatch)=>dispatch({
            type: (0, $d6d78fc758ee4148$export$bc0e04975792fb52),
            payload: flag
        });
const $d623f23401a154f0$export$4c41e2d57bc57d23 = (requestPayload)=>async ()=>{
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/uniqueRecordFilter", requestPayload);
            return data;
        } catch (error) {
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$72e26222fdd0ded = (requestPayload)=>async ()=>{
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/clearFilter", requestPayload);
            return data;
        } catch (error) {
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$faa42d9d9aeac826 = (requestPayload)=>async ()=>{
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/fetchUserList", requestPayload);
            return data;
        } catch (error) {
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$f3c11d569c729db5 = (requestPayload)=>async ()=>{
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/items/auditHistory", requestPayload);
            return data;
        } catch (error) {
            throw Error(error);
        }
    };
const $d623f23401a154f0$export$27dd55286e4e826a = (action, certKeyProvided)=>async (dispatch, getState)=>{
        const { certKey: certKey } = getState().certifications;
        const body = {
            certkey: certKey || certKeyProvided,
            action: action
        };
        try {
            const { data: data } = await (0, $adfd86cbf6e4f136$export$c1b2b945bea31d71).post("/certifications/v2/getPredefinedComments", body, $d623f23401a154f0$var$axiosTimeoutConfig);
            if (data?.response === "Success") // update redux store
            dispatch({
                type: (0, $d6d78fc758ee4148$export$550c586b0cc3ded0),
                payload: {
                    action: action,
                    comments: data?.result
                }
            });
            return true;
        } catch (error) {
            throw Error(error);
        }
    };



/* eslint-disable indent */ 











/* eslint-disable no-param-reassign */ /* eslint-disable indent */ 




const $78e652061c9728b8$export$f84f5fc6b255ddc1 = 30;
const $78e652061c9728b8$export$e47dcbf10d7af366 = 10;
const $78e652061c9728b8$export$a1d1a2dbce5ef265 = {
    user: "User",
    account: "Account",
    role: "Role",
    entitlement: "Entitlement"
};



function $dcba5eba4d2647c8$var$BreadCrumb({ data: data, onPrevClicked: onPrevClicked }) {
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = (0, $hopDi$useState)(false);
    const containerRef = (0, $hopDi$useRef)(null);
    const levelCount = data?.length || 0;
    const shouldRenderBreadCrumb = Boolean(Array.isArray(data) && levelCount > 1);
    (0, $hopDi$useEffect)(()=>{
        const addEllipsesToMiddleItem = ()=>{
            const middleItem = containerRef.current?.getElementsByClassName("BreadCrumb-wrapperMiddleItem")?.[0];
            if (middleItem) {
                if (middleItem.offsetWidth <= (0, $78e652061c9728b8$export$f84f5fc6b255ddc1)) middleItem.classList.add("active");
                else middleItem.classList.remove("active");
            }
            let borderItems;
            if (levelCount === 3) borderItems = containerRef.current?.getElementsByClassName("BreadCrumb-wrapperItems--threeNodes");
            if (levelCount === 2) borderItems = containerRef.current?.getElementsByClassName("BreadCrumb-wrapperItems--twoNodes");
            if (borderItems) Object.values(borderItems)?.forEach((borderItem)=>{
                if (borderItem.clientWidth <= 80) {
                    if (borderItem.lastElementChild.offsetWidth < borderItem.lastElementChild.scrollWidth) borderItem.style.minWidth = "5rem";
                    else borderItem.style.minWidth = "fit-content";
                } else borderItem.style.minWidth = "5rem";
            });
        };
        addEllipsesToMiddleItem();
        window.addEventListener("resize", addEllipsesToMiddleItem);
        return ()=>window.removeEventListener("resize", addEllipsesToMiddleItem);
    }, [
        data,
        levelCount
    ]);
    const getIcon = (kind, size = "")=>{
        switch(kind){
            case (0, $78e652061c9728b8$export$a1d1a2dbce5ef265).user:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Avatar), {
                    size: size === "medium" ? "xSmall" : "xxSmall",
                    className: "BreadCrumb-wrapperItemIcons"
                });
            case (0, $78e652061c9728b8$export$a1d1a2dbce5ef265).account:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Account",
                    color: "navy-900",
                    size: size === "medium" ? "medium" : "xSmall",
                    className: "BreadCrumb-wrapperItemIcons"
                });
            case (0, $78e652061c9728b8$export$a1d1a2dbce5ef265).role:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Role",
                    color: "navy-900",
                    size: size === "medium" ? "medium" : "xSmall",
                    className: "BreadCrumb-wrapperItemIcons"
                });
            case (0, $78e652061c9728b8$export$a1d1a2dbce5ef265).entitlement:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Entitlement",
                    color: "navy-900",
                    size: size === "medium" ? "medium" : "xSmall",
                    className: "BreadCrumb-wrapperItemIcons"
                });
            default:
                return null;
        }
    };
    const handleBreadCrumbItemClick = (level)=>{
        const shouldOpenMobileDrawer = Boolean(levelCount === 3 && level === 1 && containerRef.current?.getElementsByClassName("BreadCrumb-wrapperMiddleItem")?.[0]?.classList.contains("active"));
        if (shouldOpenMobileDrawer) {
            setIsMobileDrawerOpen(true);
            return;
        }
        onPrevClicked(level);
    };
    const handleBreadCrumbMobileItemClick = (level)=>{
        if (isMobileDrawerOpen) setIsMobileDrawerOpen(false);
        onPrevClicked(level);
    };
    if (!shouldRenderBreadCrumb) return null;
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "BreadCrumb",
                children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "BreadCrumb-wrapper",
                    ref: containerRef,
                    children: data?.map((item, index, array)=>{
                        const wrapperItemClasses = (0, $hopDi$classnames)("BreadCrumb-wrapperItems", levelCount === 2 && "BreadCrumb-wrapperItems--twoNodes", levelCount === 3 && index === 1 && "BreadCrumb-wrapperMiddleItem", levelCount === 3 && index !== 1 && "BreadCrumb-wrapperItems--threeNodes");
                        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$react).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: wrapperItemClasses,
                                    onClick: item.isActive ? ()=>{} : ()=>handleBreadCrumbItemClick(levelCount - index - 1),
                                    onKeyDown: ()=>{},
                                    role: "button",
                                    tabIndex: "0",
                                    children: [
                                        array.length - 1 !== index && getIcon(item.icon),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body4",
                                            desktop: "body4-m",
                                            mobile: "body4-m",
                                            className: item.isActive ? "BreadCrumb-wrapperItemText--active" : "BreadCrumb-wrapperItemText--inactive",
                                            children: item.text
                                        })
                                    ]
                                }),
                                array.length - 1 !== index && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "ChevronRight",
                                    color: "neutral-600",
                                    size: "xSmall",
                                    className: "BreadCrumb-wrapperItemIcons"
                                })
                            ]
                        }, item.level);
                    })
                })
            }),
            isMobileDrawerOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                isOpen: isMobileDrawerOpen,
                setIsOpen: setIsMobileDrawerOpen,
                isSwipeEnabled: true,
                isCloseButtonEnabled: false,
                className: "BreadCrumb-drawer",
                content: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "BreadCrumb-drawerContent",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h4",
                            desktop: "h4-d",
                            mobile: "h4-d",
                            className: "BreadCrumb-drawerContentTitle",
                            children: "Relational Hierarchy"
                        }),
                        data?.map((item, index, array)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "BreadCrumb-drawerMenuItemWrapper",
                                children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "BreadCrumb-drawerMenuItem",
                                    style: {
                                        marginLeft: `${1.25 * index}rem`
                                    },
                                    onClick: item.isActive ? ()=>{} : ()=>handleBreadCrumbMobileItemClick(levelCount - index - 1),
                                    onKeyDown: ()=>{},
                                    role: "button",
                                    tabIndex: "0",
                                    children: [
                                        getIcon(item.icon, "medium"),
                                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                            className: "BreadCrumb-drawerMenuItemDetails",
                                            children: [
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                    kind: "body2-bold",
                                                    desktop: "body2-bold-d",
                                                    mobile: "body2-bold-d",
                                                    className: item?.isActive ? "BreadCrumb-drawerMenuItemTitle--active" : "BreadCrumb-drawerMenuItemTitle--inactive",
                                                    children: item?.text
                                                }),
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                    kind: "body3",
                                                    desktop: "body3-d",
                                                    mobile: "body3-d",
                                                    children: item.icon
                                                })
                                            ]
                                        }),
                                        array.length - 1 !== index && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "ChevronRight",
                                            color: "neutral-600"
                                        })
                                    ]
                                })
                            }, item.level))
                    ]
                })
            })
        ]
    });
}
$dcba5eba4d2647c8$var$BreadCrumb.propTypes = {
    data: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
        text: (0, $hopDi$proptypes).string,
        onClick: (0, $hopDi$proptypes).func,
        icon: (0, $hopDi$proptypes).oneOf(Object.values((0, $78e652061c9728b8$export$a1d1a2dbce5ef265))),
        level: (0, $hopDi$proptypes).number,
        isActive: (0, $hopDi$proptypes).bool
    })),
    onPrevClicked: (0, $hopDi$proptypes).func
};
$dcba5eba4d2647c8$var$BreadCrumb.defaultProps = {
    data: [],
    onPrevClicked: ()=>{}
};
var $dcba5eba4d2647c8$export$2e2bcd8739ae039 = $dcba5eba4d2647c8$var$BreadCrumb;


var $4e9aede7a04f128a$export$2e2bcd8739ae039 = (0, $dcba5eba4d2647c8$export$2e2bcd8739ae039);



function $b5640530fe79ab49$var$CarouselHeader({ header: header, headerClassName: headerClassName, breadCrumb: breadCrumb, breadCrumbOnClick: breadCrumbOnClick, onClick: onClick, dataTestId: dataTestId }) {
    const headerClasses = (0, $hopDi$classnames)("Carousel-header", headerClassName);
    const shouldRenderBreadCrumb = Boolean(Array.isArray(breadCrumb) && breadCrumb.length > 1);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: headerClasses,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "Carousel-headerContents",
                children: [
                    shouldRenderBreadCrumb && /*#__PURE__*/ (0, $hopDi$jsx)((0, $4e9aede7a04f128a$export$2e2bcd8739ae039), {
                        data: breadCrumb,
                        onPrevClicked: breadCrumbOnClick
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Carousel-headerTextIconGroup",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ApplicationIcon), {
                                logo: header.icon,
                                size: "large"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "Carousel-headerText",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h3",
                                        color: "--color-foreground-neutral-bold",
                                        lineLimit: 2,
                                        tooltipConfigs: {
                                            openDelay: 500
                                        },
                                        children: header.title
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body3",
                                        color: "--color-foreground-neutral-subtle",
                                        lineLimit: 2,
                                        tooltipConfigs: {
                                            openDelay: 500
                                        },
                                        children: header.description
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                id: "Carousel-closeButton",
                size: "medium",
                kind: "ghost",
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "close",
                    color: "neutral-100",
                    size: "medium"
                }),
                onClick: onClick,
                dataTestId: dataTestId
            })
        ]
    });
}
$b5640530fe79ab49$var$CarouselHeader.propTypes = {
    header: (0, $hopDi$proptypes).shape({
        title: (0, $hopDi$proptypes).string,
        description: (0, $hopDi$proptypes).string,
        icon: (0, $hopDi$proptypes).string
    }),
    headerClassName: (0, $hopDi$proptypes).string,
    breadCrumb: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})),
    breadCrumbOnClick: (0, $hopDi$proptypes).func,
    onClick: (0, $hopDi$proptypes).func,
    dataTestId: (0, $hopDi$proptypes).string
};
$b5640530fe79ab49$var$CarouselHeader.defaultProps = {
    header: {
        title: "User Title",
        description: "User Description",
        icon: "UserBg"
    },
    headerClassName: "",
    breadCrumb: [],
    breadCrumbOnClick: ()=>{},
    onClick: ()=>{},
    dataTestId: "CarouselHeader-testId"
};
var $b5640530fe79ab49$export$2e2bcd8739ae039 = $b5640530fe79ab49$var$CarouselHeader;


var $f5c38c30fa11b8ae$export$2e2bcd8739ae039 = (0, $b5640530fe79ab49$export$2e2bcd8739ae039);





function $945cc6900560efae$var$CarouselSkeleton() {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "CarouselSkeleton",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CarouselSkeleton-header",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CarouselSkeleton-headerTextIconGroup",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-headerIcon CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CarouselSkeleton-headerText",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: "CarouselSkeleton-headerTitle CarouselSkeleton-animateSkeleton"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: "CarouselSkeleton-headerDescription CarouselSkeleton-animateSkeleton"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CarouselSkeleton-closeButton CarouselSkeleton-animateSkeleton"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CarouselSkeleton-body",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CarouselSkeleton-bodyMennu",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-menuButtons CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-menuButtons CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-menuButtons CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-menuButtons CarouselSkeleton-animateSkeleton"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CarouselSkeleton-scoreGroup",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-scoreIcon CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-scoreText CarouselSkeleton-animateSkeleton"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CarouselSkeleton-bodyText",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CarouselSkeleton-bodyTextLineItem CarouselSkeleton-animateSkeleton"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CarouselSkeleton-footer",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CarouselSkeleton-actionButtons CarouselSkeleton-animateSkeleton"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CarouselSkeleton-actionButtons CarouselSkeleton-animateSkeleton"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CarouselSkeleton-actionButtons CarouselSkeleton-animateSkeleton"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CarouselSkeleton-actionButtons CarouselSkeleton-animateSkeleton"
                    })
                ]
            })
        ]
    });
}
var $945cc6900560efae$export$2e2bcd8739ae039 = $945cc6900560efae$var$CarouselSkeleton;


var $7a46a95e653c082f$export$2e2bcd8739ae039 = (0, $945cc6900560efae$export$2e2bcd8739ae039);



const $dfdf658132d8322c$export$800daf5fbbe96aff = {
    CAROUSEL_CLOSE_BUTTON: "carousel-close-button"
};
const $dfdf658132d8322c$export$8f31a4dc6d6fd09e = {
    CAROUSEL_TRANSITION_DELAY: 500,
    CAROUSEL_MENU_CLOSE_TRANSITION_DELAY_MS: 10,
    CAROUSEL_CLOSE_DELAY: 220
};
const $dfdf658132d8322c$export$7534c6a613585847 = {
    PREV2: "previous_2",
    PREV1: "previous_1",
    MID: "middle",
    NEXT1: "forward_1",
    NEXT2: "forward_2"
};


const $def10ac19444af8d$export$de363e709c412c8a = (callback, current, dist)=>{
    let lastValue = 0;
    if (current - lastValue >= dist) {
        lastValue = current;
        callback();
    }
};
var $def10ac19444af8d$export$2e2bcd8739ae039 = $def10ac19444af8d$export$de363e709c412c8a;



// Do not change this counter
const $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS = 5;
const $ff0040eb65cb57ba$var$MAX_TRAVEL_FOR_SWIPE_HANDLE = 80; // 80px is the max value we can have
const $ff0040eb65cb57ba$var$RANGE_FOR_LEFT_PROPERTY_SWIPE = 30;
const $ff0040eb65cb57ba$var$DEFAULT_LEFT_PROPERTY_VALUE_FOR_CARD = 50;
function $ff0040eb65cb57ba$var$Carousel({ isOpen: isOpen, onClose: onClose, isLoading: isLoading, header: header, headerClassName: headerClassName, layout: layout, layoutClassName: layoutClassName, footer: footer, footerClassName: footerClassName, isPrevDisabled: isPrevDisabled, isNextDisabled: isNextDisabled, onClickNext: onClickNext, onClickPrev: onClickPrev, breadCrumb: breadCrumb, breadCrumbOnClick: breadCrumbOnClick, isCloseOnOutsideClick: isCloseOnOutsideClick, isSwipeDisabled: isSwipeDisabled, dataTheme: dataTheme, className: className, dataTestId: dataTestId }) {
    const carouselRef = (0, $hopDi$useRef)(null);
    const overlayRef = (0, $hopDi$useRef)(null);
    /** focusOnlyModalIslandElements makes the tab order locked to only the focusable components inside the modalIsland */ const focusOnlyModalIslandElements = (e)=>{
        if (!carouselRef.current) return;
        const focusableElements = carouselRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        if (e.keyCode === 9) {
            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    lastElement.focus();
                    e.preventDefault();
                }
            } else if (document.activeElement === lastElement) {
                firstElement.focus();
                e.preventDefault();
            }
        }
    };
    // Get the browser scrollBar width
    (0, $hopDi$useScrollbarWidth)();
    const overlayBgClasses = (0, $hopDi$classnames)("Carousel-background", isOpen && `Carousel-background--isOpen`);
    const carouselClasses = (0, $hopDi$classnames)("Carousel", isOpen && "Carousel--isOpen", className);
    const carouselSectionClasses = (0, $hopDi$classnames)("Carousel-section");
    const layoutClasses = (0, $hopDi$classnames)("Carousel-layout", layoutClassName);
    const footerClasses = (0, $hopDi$classnames)("Carousel-footer", footerClassName);
    (0, $hopDi$useEffect)(()=>{
        if (isOpen) {
            document.body.classList.add("Carousel--isOpen--bodyScrollLock");
            document.addEventListener("keydown", focusOnlyModalIslandElements);
            const closeButton = document.getElementById("modalCloseButton-true");
            closeButton?.focus();
        } else document.body.classList.remove("Carousel--isOpen--bodyScrollLock");
        return ()=>{
            document.body.classList.remove("Carousel--isOpen--bodyScrollLock");
            document.removeEventListener("keydown", focusOnlyModalIslandElements);
        };
    }, [
        isOpen
    ]);
    // Used to get the final height of the container the set it to 0 for the transition animation to play
    (0, $hopDi$useEffect)(()=>{
        const modalCurrent = carouselRef.current;
        const overlayCurrent = overlayRef.current;
        if (!modalCurrent && !overlayCurrent) return;
        if (isOpen) setTimeout(()=>{
            modalCurrent.style.opacity = 1;
            modalCurrent.style.pointerEvents = "all";
            overlayCurrent.style.opacity = 1;
            overlayCurrent.style.pointerEvents = "all";
        }, (0, $dfdf658132d8322c$export$8f31a4dc6d6fd09e).CAROUSEL_MENU_CLOSE_TRANSITION_DELAY_MS);
    }, [
        isOpen
    ]);
    const toggleCarouselOpen = (0, $hopDi$useCallback)(()=>{
        if (isOpen) {
            const modalCurrent = carouselRef.current;
            const overlayCurrent = overlayRef.current;
            if (modalCurrent && overlayCurrent) {
                setTimeout(()=>{
                    modalCurrent.style.opacity = 0;
                    modalCurrent.style.pointerEvents = "none";
                    overlayCurrent.style.opacity = 0;
                    overlayCurrent.style.pointerEvents = "none";
                }, (0, $dfdf658132d8322c$export$8f31a4dc6d6fd09e).CAROUSEL_MENU_CLOSE_TRANSITION_DELAY_MS);
                setTimeout(()=>{
                    onClose(false);
                }, (0, $dfdf658132d8322c$export$8f31a4dc6d6fd09e).CAROUSEL_CLOSE_DELAY);
            }
        }
    }, [
        isOpen,
        onClose
    ]);
    const closeOnEscapeKeyDown = (0, $hopDi$useCallback)((e)=>{
        if (e.key === "Escape") toggleCarouselOpen();
    }, [
        toggleCarouselOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        document.body.addEventListener("keydown", closeOnEscapeKeyDown);
        return ()=>{
            document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
        };
    }, [
        closeOnEscapeKeyDown
    ]);
    (0, $hopDi$useOutsideClickEffect)(carouselRef, ()=>toggleCarouselOpen(), isOpen && isCloseOnOutsideClick);
    // Code for cards' management
    const [currentIndex, setCurrentIndex] = (0, $hopDi$useState)(2);
    const [visibleCards, setVisibleCards] = (0, $hopDi$useState)([
        0,
        1,
        $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS - 1
    ]);
    // TODO: Sagar to handle delayed offloading of side cards which is not working currently
    (0, $hopDi$useEffect)(()=>{
        const sideCardDelay = setTimeout(()=>{
            setVisibleCards([
                (currentIndex - 1 + $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS) % $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS,
                currentIndex,
                (currentIndex + 1) % $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS
            ]);
        }, (0, $dfdf658132d8322c$export$8f31a4dc6d6fd09e).CAROUSEL_TRANSITION_DELAY);
        return ()=>clearTimeout(sideCardDelay);
    }, [
        currentIndex
    ]);
    // Code for cards' click events
    const handleNextClick = ()=>{
        setCurrentIndex((prev)=>(prev + 1) % $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS);
        if (typeof onClickNext === "function") onClickNext();
    };
    const handlePrevClick = (shouldSwipeCardOnly = false)=>{
        setCurrentIndex((prev)=>(prev - 1) % $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS);
        if (typeof onClickPrev === "function" && !shouldSwipeCardOnly) onClickPrev();
    };
    const handleClick = (event)=>{
        const targetClass = event.target.className;
        if (typeof targetClass === "string" && targetClass?.includes((0, $dfdf658132d8322c$export$7534c6a613585847).PREV1) && !isPrevDisabled) {
            event.preventDefault();
            handlePrevClick();
        }
        if (typeof targetClass === "string" && targetClass?.includes((0, $dfdf658132d8322c$export$7534c6a613585847).NEXT1) && !isNextDisabled) {
            event.preventDefault();
            handleNextClick();
        }
    };
    const handleBreadCrumbItemClick = (level)=>{
        handlePrevClick(true);
        breadCrumbOnClick(level);
    };
    // Code for the swipe animation
    const [defaultLeftValue, setDefaultLeftValue] = (0, $hopDi$useState)($ff0040eb65cb57ba$var$DEFAULT_LEFT_PROPERTY_VALUE_FOR_CARD);
    const addDefaultLeft = ()=>{
        const cards = document.querySelectorAll(".Carousel li");
        cards.forEach((card)=>{
            card.classList.add("Carousel-cards--hardLeft");
        });
        setDefaultLeftValue(50);
    };
    const removeDefaultLeft = ()=>{
        const cards = document.querySelectorAll(".Carousel li");
        cards.forEach((card)=>{
            card.classList.remove("Carousel-cards--hardLeft");
        });
    };
    const swipeHandle = (0, $hopDi$useHorizontalSwipe)({
        onSwipedLeft: ()=>!isNextDisabled ? handleNextClick() : ()=>{},
        onSwipedRight: ()=>!isPrevDisabled ? handlePrevClick() : ()=>{},
        onEventStart: ()=>removeDefaultLeft(),
        onEventStop: ()=>addDefaultLeft()
    }, 80);
    const swipeDirection = swipeHandle.displacement.direction;
    const swipeTravel = swipeHandle.boundedDistance;
    (0, $hopDi$useAvoidFirstRender)(()=>{
        const swipeTravelMapped = Math.floor($ff0040eb65cb57ba$var$RANGE_FOR_LEFT_PROPERTY_SWIPE / $ff0040eb65cb57ba$var$MAX_TRAVEL_FOR_SWIPE_HANDLE * swipeTravel * 0.9);
        const leftValue = swipeDirection === "R" ? $ff0040eb65cb57ba$var$DEFAULT_LEFT_PROPERTY_VALUE_FOR_CARD + swipeTravelMapped : $ff0040eb65cb57ba$var$DEFAULT_LEFT_PROPERTY_VALUE_FOR_CARD - swipeTravelMapped;
        (0, $def10ac19444af8d$export$de363e709c412c8a)(()=>setDefaultLeftValue(leftValue), swipeTravel, 5);
    }, [
        swipeDirection,
        swipeTravel
    ]);
    // Code for the layout, header and footer
    const getClassNameForCards = (index)=>{
        const position = (index - currentIndex + $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS) % $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS;
        switch(position){
            case 0:
                return (0, $dfdf658132d8322c$export$7534c6a613585847).MID;
            case 1:
                return `${(0, $dfdf658132d8322c$export$7534c6a613585847).NEXT1} ${isNextDisabled ? "forward_1--isDisabled" : ""}`;
            case 2:
                return (0, $dfdf658132d8322c$export$7534c6a613585847).NEXT2;
            case $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS - 1:
                return `${(0, $dfdf658132d8322c$export$7534c6a613585847).PREV1} ${isPrevDisabled ? "previous_1--isDisabled" : ""}`;
            case $ff0040eb65cb57ba$var$DEFAULT_COUNT_OF_CARDS - 2:
                return (0, $dfdf658132d8322c$export$7534c6a613585847).PREV2;
            default:
                return "";
        }
    };
    const renderModalSections = ()=>{
        if (!isLoading) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            tag: "section",
            className: carouselSectionClasses,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $f5c38c30fa11b8ae$export$2e2bcd8739ae039), {
                    header: header,
                    headerClassName: headerClassName,
                    breadCrumb: breadCrumb,
                    breadCrumbOnClick: handleBreadCrumbItemClick,
                    onClick: toggleCarouselOpen,
                    dataTestId: (0, $dfdf658132d8322c$export$800daf5fbbe96aff).CAROUSEL_CLOSE_BUTTON
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: layoutClasses,
                    children: layout
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: footerClasses,
                    children: footer
                })
            ]
        });
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "section",
            className: `${carouselSectionClasses} Carousel-section--isLoading`,
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "loop",
                format: "main",
                color: "brand",
                size: "large",
                dataTestId: "Carousel-loadingTestId"
            })
        });
    };
    const getModalContent = ()=>Object.values((0, $dfdf658132d8322c$export$7534c6a613585847))?.map((item, index)=>{
            const isClassForMidSection = Boolean(getClassNameForCards(index) === (0, $dfdf658132d8322c$export$7534c6a613585847).MID);
            const middleCardTouchProps = {
                onTouchStart: swipeHandle.handlers.onTouchStart,
                onTouchMove: swipeHandle.handlers.onTouchMove,
                onTouchEnd: swipeHandle.handlers.onTouchEnd
            };
            return /*#__PURE__*/ (0, $hopDi$jsx)("li", {
                style: {
                    left: `${defaultLeftValue}%`
                },
                className: `${getClassNameForCards(index)} Carousel-cards--hardLeft`,
                onClick: (e)=>handleClick(e),
                onKeyDown: ()=>{},
                ...isClassForMidSection && !isSwipeDisabled ? middleCardTouchProps : {},
                role: "presentation",
                children: isClassForMidSection ? renderModalSections() : visibleCards.includes(index) && /*#__PURE__*/ (0, $hopDi$jsx)((0, $7a46a95e653c082f$export$2e2bcd8739ae039), {})
            }, item);
        });
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $hopDi$reactdom).createPortal(/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                ref: overlayRef,
                className: overlayBgClasses
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "ul",
                ref: carouselRef,
                id: "Carousel",
                className: carouselClasses,
                dataTestId: dataTestId,
                dataTheme: dataTheme,
                children: getModalContent()
            })
        ]
    }), document.body);
}
$ff0040eb65cb57ba$var$Carousel.propTypes = {
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    onClose: (0, $hopDi$proptypes).func.isRequired,
    isLoading: (0, $hopDi$proptypes).bool,
    header: (0, $hopDi$proptypes).shape({
        title: (0, $hopDi$proptypes).string,
        description: (0, $hopDi$proptypes).string,
        icon: (0, $hopDi$proptypes).string
    }).isRequired,
    headerClassName: (0, $hopDi$proptypes).string,
    layout: (0, $hopDi$proptypes).element.isRequired,
    layoutClassName: (0, $hopDi$proptypes).string,
    footer: (0, $hopDi$proptypes).element.isRequired,
    footerClassName: (0, $hopDi$proptypes).string,
    isPrevDisabled: (0, $hopDi$proptypes).bool,
    isNextDisabled: (0, $hopDi$proptypes).bool,
    onClickPrev: (0, $hopDi$proptypes).func,
    onClickNext: (0, $hopDi$proptypes).func,
    breadCrumb: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})),
    breadCrumbOnClick: (0, $hopDi$proptypes).func,
    isCloseOnOutsideClick: (0, $hopDi$proptypes).bool,
    isSwipeDisabled: (0, $hopDi$proptypes).bool,
    dataTheme: (0, $hopDi$proptypes).oneOf(Object.values((0, $135adfecc1ed8f07$export$49390a4605a2336a))),
    className: (0, $hopDi$proptypes).string,
    dataTestId: (0, $hopDi$proptypes).string
};
$ff0040eb65cb57ba$var$Carousel.defaultProps = {
    isLoading: false,
    headerClassName: "",
    layoutClassName: "",
    footerClassName: "",
    isPrevDisabled: false,
    isNextDisabled: false,
    onClickPrev: ()=>{},
    onClickNext: ()=>{},
    breadCrumb: [],
    breadCrumbOnClick: ()=>{},
    isCloseOnOutsideClick: false,
    isSwipeDisabled: false,
    dataTheme: null,
    className: null,
    dataTestId: null
};
var $ff0040eb65cb57ba$export$2e2bcd8739ae039 = $ff0040eb65cb57ba$var$Carousel;


var $1854031227665b12$export$2e2bcd8739ae039 = (0, $ff0040eb65cb57ba$export$2e2bcd8739ae039);



























function $1c4893cc536d206e$var$AdvancedFilterButton({ filters: filters, showFilterBar: showFilterBar, setShowFilterBar: setShowFilterBar, showBadgeOnFilterButton: showBadgeOnFilterButton, isButtonKindIcon: isButtonKindIcon }) {
    const { isLoading: isLoading, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabs?.tabData?.find((tab)=>tab.isActive)?.count;
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
        label: "Filter",
        kind: isButtonKindIcon ? "rectangle" : "icon",
        className: "CertsAdvancedFilterButton",
        onClick: ()=>{
            if (filters.length > 0) setShowFilterBar((prev)=>!prev);
        },
        isOpen: showFilterBar,
        size: "medium",
        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "Filter",
            color: "neutral-600",
            size: "smallMedium"
        }),
        BadgeComp: showBadgeOnFilterButton ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
            kind: "dot",
            color: "primary",
            size: "small"
        }) : null,
        isDisabled: filters.length === 0 || activeTabCount === 0 || isLoading
    });
}
$1c4893cc536d206e$var$AdvancedFilterButton.propTypes = {
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    setShowFilterBar: (0, $hopDi$proptypes).func.isRequired,
    showBadgeOnFilterButton: (0, $hopDi$proptypes).bool.isRequired,
    isButtonKindIcon: (0, $hopDi$proptypes).bool.isRequired
};
var $1c4893cc536d206e$export$2e2bcd8739ae039 = $1c4893cc536d206e$var$AdvancedFilterButton;


/* eslint-disable indent */ 

















const $6d218ab9b83faef2$export$e12a4cadfc09074e = "-4";
const $6d218ab9b83faef2$export$addbd3a73cd831b8 = "-2";
const $6d218ab9b83faef2$export$2fdde2b3b0357dd1 = "0";
const $6d218ab9b83faef2$export$b5f0f72f5619891f = ">0";
const $6d218ab9b83faef2$export$e99ca72b1ac3fcd6 = "users";
const $6d218ab9b83faef2$export$33e5df6437060fe4 = "roles";
const $6d218ab9b83faef2$export$67904de277d10d08 = "accounts";
const $6d218ab9b83faef2$export$28401dcfd55adaaa = "entitlements";
const $6d218ab9b83faef2$export$cfb9e92ff3cd43f4 = 10;
const $6d218ab9b83faef2$export$6a2b1149d9dd6e5f = [
    {
        label: "User",
        value: $6d218ab9b83faef2$export$e12a4cadfc09074e,
        isParent: false,
        isChecked: true,
        isDisabled: false,
        isLast: false,
        options: [
            {
                label: "Role",
                value: $6d218ab9b83faef2$export$addbd3a73cd831b8,
                isParent: false,
                isChecked: true,
                isDisabled: false,
                isLast: false,
                options: []
            },
            {
                label: "Account",
                value: $6d218ab9b83faef2$export$2fdde2b3b0357dd1,
                isParent: false,
                isChecked: true,
                isDisabled: false,
                isLast: false,
                options: [
                    {
                        label: "Entitlement",
                        value: $6d218ab9b83faef2$export$b5f0f72f5619891f,
                        isParent: false,
                        isChecked: true,
                        isDisabled: false,
                        isLast: false,
                        options: []
                    }
                ]
            }
        ]
    }
];
const $6d218ab9b83faef2$export$751b1412348af195 = {
    [$6d218ab9b83faef2$export$e12a4cadfc09074e]: $6d218ab9b83faef2$export$e99ca72b1ac3fcd6,
    [$6d218ab9b83faef2$export$addbd3a73cd831b8]: $6d218ab9b83faef2$export$33e5df6437060fe4,
    [$6d218ab9b83faef2$export$2fdde2b3b0357dd1]: $6d218ab9b83faef2$export$67904de277d10d08,
    [$6d218ab9b83faef2$export$b5f0f72f5619891f]: $6d218ab9b83faef2$export$28401dcfd55adaaa
};
const $6d218ab9b83faef2$export$da3f11392f2a7d63 = {
    [$6d218ab9b83faef2$export$e12a4cadfc09074e]: "User",
    [$6d218ab9b83faef2$export$addbd3a73cd831b8]: "Role",
    [$6d218ab9b83faef2$export$2fdde2b3b0357dd1]: "Account",
    [$6d218ab9b83faef2$export$b5f0f72f5619891f]: "Entitlement"
};
const $6d218ab9b83faef2$export$9e2b4f119567db3 = {
    [$6d218ab9b83faef2$export$da3f11392f2a7d63[$6d218ab9b83faef2$export$e12a4cadfc09074e]]: $6d218ab9b83faef2$export$e99ca72b1ac3fcd6,
    [$6d218ab9b83faef2$export$da3f11392f2a7d63[$6d218ab9b83faef2$export$addbd3a73cd831b8]]: $6d218ab9b83faef2$export$33e5df6437060fe4,
    [$6d218ab9b83faef2$export$da3f11392f2a7d63[$6d218ab9b83faef2$export$2fdde2b3b0357dd1]]: $6d218ab9b83faef2$export$67904de277d10d08,
    [$6d218ab9b83faef2$export$da3f11392f2a7d63[$6d218ab9b83faef2$export$b5f0f72f5619891f]]: $6d218ab9b83faef2$export$28401dcfd55adaaa
};
const $6d218ab9b83faef2$export$8fb661a8eb99bf9c = {
    [$6d218ab9b83faef2$export$e99ca72b1ac3fcd6]: "User",
    [$6d218ab9b83faef2$export$33e5df6437060fe4]: "Role",
    [$6d218ab9b83faef2$export$67904de277d10d08]: "Account",
    [$6d218ab9b83faef2$export$28401dcfd55adaaa]: "Entitlement"
};











const $c647e77118d4a3ed$export$a2b4ad410285e3a3 = (filters, appliedRowFilters)=>{
    const getCountAndCheck = (tree, countObj = {
        value: 0
    })=>tree.map((filter)=>{
            const updatedFilter = {
                ...filter,
                count: countObj.value,
                isChecked: appliedRowFilters.includes(filter.value)
            };
            // eslint-disable-next-line no-param-reassign
            countObj.value += 1;
            if (filter.options && filter.options.length > 0) updatedFilter.options = getCountAndCheck(filter.options, countObj);
            return updatedFilter;
        });
    return getCountAndCheck(filters);
};
const $c647e77118d4a3ed$export$c33ee69d36354d25 = (arr)=>{
    const tempArr = [];
    for(let i = 0; i < arr.length; i += 1){
        if (arr[i].isDisabled === false) tempArr.push(arr[i].value);
        if (arr[i].options.length !== 0) tempArr.push(...$c647e77118d4a3ed$export$c33ee69d36354d25(arr[i].options));
    }
    return tempArr;
};
const $c647e77118d4a3ed$export$81d81b51abd59a55 = (arr)=>{
    const tempArr = [];
    for(let i = 0; i < arr.length; i += 1){
        if (arr[i].isChecked === true && arr[i].isDisabled === false) tempArr.push(arr[i].value);
        if (arr[i].options.length !== 0) tempArr.push(...$c647e77118d4a3ed$export$81d81b51abd59a55(arr[i].options));
    }
    return tempArr;
};
const $c647e77118d4a3ed$export$397227221b180a45 = (filterTree, viewRowsList)=>{
    const tempTree = JSON.parse(JSON.stringify(filterTree));
    const reMapIsDisabled = (tree)=>{
        tree.forEach((obj)=>{
            if (obj.value === (0, $6d218ab9b83faef2$export$e12a4cadfc09074e) && !viewRowsList.includes((0, $6d218ab9b83faef2$export$e99ca72b1ac3fcd6))) // eslint-disable-next-line no-param-reassign
            obj.isDisabled = true;
            if (obj.value === (0, $6d218ab9b83faef2$export$addbd3a73cd831b8) && !viewRowsList.includes((0, $6d218ab9b83faef2$export$33e5df6437060fe4))) // eslint-disable-next-line no-param-reassign
            obj.isDisabled = true;
            if (obj.value === (0, $6d218ab9b83faef2$export$2fdde2b3b0357dd1) && !viewRowsList.includes((0, $6d218ab9b83faef2$export$67904de277d10d08))) // eslint-disable-next-line no-param-reassign
            obj.isDisabled = true;
            if (obj.value === (0, $6d218ab9b83faef2$export$b5f0f72f5619891f) && !viewRowsList.includes((0, $6d218ab9b83faef2$export$28401dcfd55adaaa))) // eslint-disable-next-line no-param-reassign
            obj.isDisabled = true;
            if (obj.options.length > 0) reMapIsDisabled(obj.options);
        });
    };
    reMapIsDisabled(tempTree);
    const reCreateHierarchy = (tree)=>{
        const _tempTree = [];
        tree.forEach((obj)=>{
            if (!obj.isDisabled) _tempTree.push({
                ...obj,
                options: (obj?.options && obj.options.length) > 0 ? reCreateHierarchy(obj.options) : []
            });
            else if (obj.options && obj.options.length > 0) _tempTree.push(...reCreateHierarchy(obj.options));
        });
        return _tempTree;
    };
    const reMapIsParent = (tree)=>{
        tree.forEach((obj)=>{
            // eslint-disable-next-line no-param-reassign
            obj.isParent = true;
        });
    };
    const hierarchyTree = reCreateHierarchy(tempTree);
    reMapIsParent(hierarchyTree);
    return hierarchyTree;
};
const $c647e77118d4a3ed$export$64491fac9a125e2c = (filters)=>{
    let count = 0;
    const _getCountOfAvailableFilters = (_filters)=>{
        _filters.forEach((filter)=>{
            if (filter.isDisabled === false) count += 1;
            if (filter?.options?.length > 0) _getCountOfAvailableFilters(filter.options);
        });
    };
    _getCountOfAvailableFilters(filters);
    return count;
};
const $c647e77118d4a3ed$export$12cb800f03e426ca = (filterTree)=>{
    const tempTree = JSON.parse(JSON.stringify(filterTree));
    const resetFilter = (tree)=>{
        const _tempTree = [];
        tree.forEach((obj)=>{
            _tempTree.push({
                ...obj,
                isChecked: true,
                options: (obj?.options && obj.options.length) > 0 ? resetFilter(obj.options) : []
            });
        });
        return _tempTree;
    };
    return resetFilter(tempTree);
};
const $c647e77118d4a3ed$export$6df37360bc913d97 = (rowsTree, personalizedRows)=>{
    const updateCheckedRecursive = (row)=>{
        const currentRow = row;
        currentRow.isChecked = personalizedRows?.includes(currentRow.value);
        row.options.forEach((option)=>updateCheckedRecursive(option));
    };
    return rowsTree.forEach((item)=>updateCheckedRecursive(item));
};
const $c647e77118d4a3ed$export$9d52876f8c04c1dd = (columnsFilter, personalizedCols)=>{
    const personalizedColsArray = Object.values(personalizedCols).flat();
    const personalizedColsIndexMap = new Map(personalizedColsArray.map((col, index)=>[
            col,
            index
        ]));
    columnsFilter.forEach((columnTab)=>{
        columnTab.options.forEach((column)=>{
            // eslint-disable-next-line no-param-reassign
            column.isChecked = personalizedColsIndexMap.has(column.value);
        });
        columnTab.options.sort((a, b)=>{
            const aIndex = personalizedColsIndexMap.get(a.value) ?? Infinity;
            const bIndex = personalizedColsIndexMap.get(b.value) ?? Infinity;
            return aIndex - bIndex;
        });
    });
};
function $c647e77118d4a3ed$export$ca4f91cac1cf9ec9(columnPickerList, personalizedColsFilters) {
    if (columnPickerList && personalizedColsFilters) {
        const columnPickerListArray = Object.entries(columnPickerList).flatMap(([key, value])=>Object.keys(value).map((item)=>`${key.toUpperCase()}-${item}`));
        const personalizedColsFiltersArray = Object.values(personalizedColsFilters).flat();
        return personalizedColsFiltersArray.every((item)=>columnPickerListArray.includes(item));
    }
    return false;
}
function $c647e77118d4a3ed$export$9aaeabff13cdbf0d(viewRowsList, personalizedRowsFilters) {
    const personalizedRowsFiltersMapped = personalizedRowsFilters?.map((item)=>(0, $6d218ab9b83faef2$export$751b1412348af195)[item]);
    return personalizedRowsFiltersMapped?.every((row)=>viewRowsList.includes(row));
}
function $c647e77118d4a3ed$export$fb9eaa94f2a46736(filters, personalizedAdvancedFilters) {
    return personalizedAdvancedFilters && personalizedAdvancedFilters.every(({ key: key, value: value })=>{
        const filter = filters.find((item)=>item.key === key);
        return filter && filter.options.some((option)=>option.value === value);
    });
}


function $6e598230156851b9$var$RowsFilter({ filters: filters, appliedRowFilters: appliedRowFilters, setAppliedRowFilters: setAppliedRowFilters, level: level }) {
    const [isEntireFilterDisabled, setIsEntireFilterDisabled] = (0, $hopDi$useState)(false);
    // Set initial state, only needed for the Menu open transition
    const updatedFiltersWithCount = (0, $c647e77118d4a3ed$export$a2b4ad410285e3a3)(filters, appliedRowFilters);
    const [nestedFilters, setNestedFilters] = (0, $hopDi$useState)(updatedFiltersWithCount);
    const dispatch = (0, $hopDi$useDispatch)();
    // TODO: Use redux rowFilters instead of calling assignCountToRowFilterTree twice every mount
    const { certKey: certKey, columnNames: columnNames, searchText: searchText } = (0, $hopDi$useSelector)((state)=>state.certifications);
    // Sync applied filters isChecked on mount
    (0, $hopDi$useEffect)(()=>{
        setNestedFilters(updatedFiltersWithCount);
    }, []);
    const handleToggle = (filterValue)=>{
        dispatch((0, $d623f23401a154f0$export$683be6298bff3717)());
        if (appliedRowFilters.includes(filterValue)) {
            if (appliedRowFilters.length === 1) {
                (0, $hopDi$Logger).warn("Atleast one filter is required");
                return;
            }
            setIsEntireFilterDisabled(true);
            dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
            dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)("ROW_TYPE", (0, $6d218ab9b83faef2$export$da3f11392f2a7d63)?.[filterValue], false)).then((response)=>{
                if (response) {
                    dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $6d218ab9b83faef2$export$cfb9e92ff3cd43f4), 0, searchText));
                    setAppliedRowFilters((prev)=>prev.filter((item)=>item !== filterValue));
                    setIsEntireFilterDisabled(false);
                }
            });
        } else {
            const newAppliedFilters = [
                ...appliedRowFilters,
                filterValue
            ];
            setIsEntireFilterDisabled(true);
            dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
            dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)("ROW_TYPE", (0, $6d218ab9b83faef2$export$da3f11392f2a7d63)?.[filterValue], true)).then((response)=>{
                if (response) {
                    dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $6d218ab9b83faef2$export$cfb9e92ff3cd43f4), 0, searchText));
                    setAppliedRowFilters(newAppliedFilters);
                    setIsEntireFilterDisabled(false);
                }
            });
        }
        setNestedFilters((prev)=>prev.map((filter)=>{
                if (filter.value === filterValue) return {
                    ...filter,
                    isChecked: !filter.isChecked
                };
                return filter;
            }));
        dispatch((0, $d623f23401a154f0$export$3afc30d9c2fc6ef)("UPDATE_PERSONALIZATION"));
        dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
    };
    (0, $hopDi$useEffect)(()=>{
        if (appliedRowFilters?.length === 1) setNestedFilters((prev)=>prev.map((filter)=>({
                    ...filter,
                    isLast: filter.value === appliedRowFilters[0]
                })));
        if (appliedRowFilters?.length > 1) setNestedFilters((prev)=>prev.map((filter)=>({
                    ...filter,
                    isLast: false
                })));
    }, [
        appliedRowFilters
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "RowsFilter-filterList",
        children: nestedFilters?.map((filter)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$react).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("label", {
                        className: "RowsFilter-filterListItem",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "RowsFilter-filterListItemWrapper",
                                style: {
                                    transform: `translateX(-${level * 1.125}rem)`,
                                    width: `calc(100% + ${level * 1.125 + 0.875}rem)`
                                }
                            }),
                            !filter?.isParent && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "RowsFilter-filterListItemConnectors--top",
                                style: {
                                    height: `${(filter.count + 1) * 2.375}rem`
                                }
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "RowsFilter-filterListItemCheckboxParent",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "RowsFilter-filterListItemCheckboxChild",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                        name: filter?.value,
                                        kind: "base",
                                        showHoverEffect: false,
                                        dataTestId: "checkbox-no-hovereffect",
                                        isChecked: filter?.isChecked || filter?.isDisabled,
                                        onChange: ()=>{
                                            if (!isEntireFilterDisabled) handleToggle(filter?.value);
                                        },
                                        isDisabled: filter?.isDisabled || filter?.isLast || isEntireFilterDisabled
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("p", {
                                className: "RowsFilter-filterListItemTextBox",
                                children: filter?.label
                            })
                        ]
                    }, filter?.value),
                    filter?.options.length > 0 && /*#__PURE__*/ (0, $hopDi$jsx)($6e598230156851b9$var$RowsFilter, {
                        filters: filter?.options,
                        appliedRowFilters: appliedRowFilters,
                        setAppliedRowFilters: setAppliedRowFilters,
                        isEntireFilterDisabled: isEntireFilterDisabled,
                        setIsEntireFilterDisabled: setIsEntireFilterDisabled,
                        level: level + 1
                    })
                ]
            }, filter?.value))
    });
}
$6e598230156851b9$var$RowsFilter.propTypes = {
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).string.isRequired,
        value: (0, $hopDi$proptypes).string.isRequired,
        isChecked: (0, $hopDi$proptypes).bool.isRequired,
        isParent: (0, $hopDi$proptypes).bool,
        options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
            label: (0, $hopDi$proptypes).string,
            value: (0, $hopDi$proptypes).string,
            isChecked: (0, $hopDi$proptypes).bool.isRequired
        }))
    })).isRequired,
    appliedRowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string).isRequired,
    setAppliedRowFilters: (0, $hopDi$proptypes).func.isRequired,
    level: (0, $hopDi$proptypes).number
};
$6e598230156851b9$var$RowsFilter.defaultProps = {
    level: 0
};
var $6e598230156851b9$export$2e2bcd8739ae039 = $6e598230156851b9$var$RowsFilter;




function $c1aab06b4e147060$var$RowFilterButton({ showbadgeOnRowButton: showbadgeOnRowButton, setShowbadgeOnRowButton: setShowbadgeOnRowButton, rowFilters: rowFilters, setRowFilters: setRowFilters, appliedRowFilters: appliedRowFilters, setAppliedRowFilters: setAppliedRowFilters, isButtonKindIcon: isButtonKindIcon }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, isLoading: isLoading, viewRowsList: viewRowsList, triggerClearBtnForHierarchy: triggerClearBtnForHierarchy, tabs: { tabData: tabData }, personalization: { personalizedData: personalizedData, viewOption: viewOption, clearCurrentPersonalization: clearCurrentPersonalization } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabData?.find((tab)=>tab.isActive)?.count;
    const personalizationViewOption = viewOption?.view;
    const personalizedRowsFilters = personalizedData?.result?.info?.defaultView?.[0] ? personalizedData.result.info.defaultView[0].rowsFilters : undefined;
    const tabletXSmallQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$fb1abf44d8c33b97));
    const isTabletXSmallWidth = tabletXSmallQuery.value <= mediaQueryValue;
    const shouldShowBadgeOnRowButton = (filters)=>{
        const activeFiltersForRows = (0, $c647e77118d4a3ed$export$c33ee69d36354d25)(rowFilters);
        return activeFiltersForRows.length !== filters.length && filters.length !== 0;
    };
    const onRowUpdate = ()=>{
        if (viewRowsList && viewRowsList?.length > 0) {
            const tempRowsTree = (0, $c647e77118d4a3ed$export$397227221b180a45)((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f), viewRowsList);
            if (personalizedRowsFilters && personalizedRowsFilters?.length > 0 && personalizationViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW) {
                if ((0, $c647e77118d4a3ed$export$9aaeabff13cdbf0d)(viewRowsList, personalizedRowsFilters)) {
                    (0, $c647e77118d4a3ed$export$6df37360bc913d97)(tempRowsTree, personalizedRowsFilters);
                    dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                        rows: true
                    }));
                } else {
                    dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
                        view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                        applied: false
                    }));
                    dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                        rows: false
                    }));
                }
            }
            setRowFilters(tempRowsTree);
            setAppliedRowFilters((0, $c647e77118d4a3ed$export$81d81b51abd59a55)(tempRowsTree));
        } else {
            setRowFilters((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f));
            setAppliedRowFilters((0, $c647e77118d4a3ed$export$81d81b51abd59a55)((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f)));
        }
    };
    const resetRowFiltersOnUI = ()=>{
        if (viewRowsList && viewRowsList?.length > 0) {
            const tempRowsTree = (0, $c647e77118d4a3ed$export$397227221b180a45)((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f), viewRowsList);
            setRowFilters(tempRowsTree);
            setAppliedRowFilters((0, $c647e77118d4a3ed$export$81d81b51abd59a55)(tempRowsTree));
        } else {
            setRowFilters((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f));
            setAppliedRowFilters((0, $c647e77118d4a3ed$export$81d81b51abd59a55)((0, $6d218ab9b83faef2$export$6a2b1149d9dd6e5f)));
        }
    };
    (0, $hopDi$useEffect)(()=>{
        onRowUpdate();
    }, [
        viewRowsList,
        personalizedRowsFilters,
        personalizationViewOption
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (clearCurrentPersonalization) onRowUpdate();
    }, [
        clearCurrentPersonalization
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (triggerClearBtnForHierarchy) {
            resetRowFiltersOnUI();
            dispatch((0, $d623f23401a154f0$export$aaae2b23f99e1308)(false));
        }
    }, [
        triggerClearBtnForHierarchy
    ]);
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$d290070680bebdf9)(appliedRowFilters));
        setShowbadgeOnRowButton(shouldShowBadgeOnRowButton(appliedRowFilters));
    }, [
        appliedRowFilters
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Menu), {
        CustomMenu: /*#__PURE__*/ (0, $hopDi$jsx)((0, $6e598230156851b9$export$2e2bcd8739ae039), {
            filters: rowFilters,
            appliedRowFilters: appliedRowFilters,
            setAppliedRowFilters: setAppliedRowFilters
        }),
        placement: isTabletXSmallWidth ? "bottom-start" : "bottom-end",
        fallbackPlacements: [
            "bottom",
            "bottom-start"
        ],
        trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
            kind: isButtonKindIcon ? "rectangle" : "icon",
            label: "Rows",
            size: "medium",
            BadgeComp: showbadgeOnRowButton ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                kind: "dot",
                color: "primary",
                size: "small"
            }) : null,
            prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "Rows",
                color: "neutral-600",
                size: "smallMedium"
            }),
            isDisabled: activeTabCount === 0 || isLoading,
            className: "RowsFilter-button"
        }),
        className: "RowsFilter"
    });
}
$c1aab06b4e147060$var$RowFilterButton.propTypes = {
    showbadgeOnRowButton: (0, $hopDi$proptypes).bool.isRequired,
    setShowbadgeOnRowButton: (0, $hopDi$proptypes).func.isRequired,
    rowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setRowFilters: (0, $hopDi$proptypes).func.isRequired,
    appliedRowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string).isRequired,
    setAppliedRowFilters: (0, $hopDi$proptypes).func.isRequired,
    isButtonKindIcon: (0, $hopDi$proptypes).bool.isRequired
};
var $c1aab06b4e147060$export$2e2bcd8739ae039 = $c1aab06b4e147060$var$RowFilterButton;




var $49b471e64a4eb65c$export$2e2bcd8739ae039 = (0, $c1aab06b4e147060$export$2e2bcd8739ae039);







const $36b8d1366c64b9c7$export$f46d66ac5a9e4045 = 6;
const $36b8d1366c64b9c7$export$7774877bdb857c73 = 200;
const $36b8d1366c64b9c7$export$b71a7e05ee124e8e = 3;
const $36b8d1366c64b9c7$export$1f43468d1110fd7b = $36b8d1366c64b9c7$export$f46d66ac5a9e4045 - 1; // In design it is set to 6, allowing to configure atleast one filter
const $36b8d1366c64b9c7$export$aac7f63bb7ed27e = 300;
const $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4 = 10;
const $36b8d1366c64b9c7$export$1befceae51a862ad = 7;
const $36b8d1366c64b9c7$export$4e1772f042a16d95 = "unchanged";
const $36b8d1366c64b9c7$export$435b46f4233ebe34 = "Added_Filter";
const $36b8d1366c64b9c7$export$35d42548e97bb61f = "Removed_Filter";
const $36b8d1366c64b9c7$export$734bd10a99f5687a = [
    "User",
    "Role",
    "Account",
    "Entitlement"
];
const $36b8d1366c64b9c7$export$5eda0606e22cfdcb = {
    SMART_FILTER: "key_for_smart_filter",
    SAVI_FILTER: "key_for_savi_filter",
    ADD_FILTER: "key_to_add_filter"
};







const $809c6fe4b590ebad$export$1bae5911fd45fa82 = (state, updatedState)=>{
    if (state.length === updatedState.length) return {
        state: (0, $36b8d1366c64b9c7$export$4e1772f042a16d95),
        filter: null
    };
    if (state.length > updatedState.length) return {
        state: (0, $36b8d1366c64b9c7$export$35d42548e97bb61f),
        filter: state.filter((item1)=>!updatedState.some((item2)=>item2.key === item1.key && item2.value === item1.value))
    };
    return {
        state: (0, $36b8d1366c64b9c7$export$435b46f4233ebe34),
        filter: updatedState.filter((item1)=>!state.some((item2)=>item2.key === item1.key && item2.value === item1.value))
    };
};
const $809c6fe4b590ebad$var$getAppliedToText = (columnPickerList, key)=>{
    const appliedToList = [];
    Object.entries(columnPickerList).forEach((column)=>{
        const appliedToName = column[0];
        const appliedToObject = Object.keys(column[1]);
        if (appliedToObject.includes(key) && !appliedToList.includes(appliedToName)) appliedToList.push(appliedToName);
    });
    const sortedAppliedToList = appliedToList.sort((a, b)=>(0, $36b8d1366c64b9c7$export$734bd10a99f5687a).indexOf(a) - (0, $36b8d1366c64b9c7$export$734bd10a99f5687a).indexOf(b));
    return `Applied to: ${sortedAppliedToList.join(", ")}`;
};
const $809c6fe4b590ebad$export$af798c228fb30a56 = (filterKey, options, baseSettings)=>{
    const tempOptions = [];
    // eslint-disable-next-line no-restricted-syntax
    for(const key in options)if (Object.prototype.hasOwnProperty.call(options, key)) {
        let fieldValue = key;
        if ((0, $135adfecc1ed8f07$export$510f63ad8e5b2cec).includes(filterKey) && key.trim() !== "" && key !== "NoResponse") fieldValue = (0, $hopDi$moment).utc(key).local().format(`${baseSettings.globalDateFormat?.toUpperCase()} hh:mm:ss`);
        if (key.trim() === "") fieldValue = "Blank";
        tempOptions.push({
            label: fieldValue,
            value: `${key}`,
            isChecked: false
        });
    }
    return tempOptions;
};
const $809c6fe4b590ebad$export$92b9437c5afd872a = (filters, baseSettings, intl, messages)=>{
    const { valueCountMap: valueCountMap, messageKeys: messageKeys } = filters;
    const COUNT_OF_FIXED_FILTERS = Math.min((0, $36b8d1366c64b9c7$export$1f43468d1110fd7b), (0, $36b8d1366c64b9c7$export$b71a7e05ee124e8e));
    let count = 0;
    const tempFilters = [];
    // eslint-disable-next-line no-restricted-syntax
    for(const key in valueCountMap)if (Object.prototype.hasOwnProperty.call(valueCountMap, key)) {
        const options = $809c6fe4b590ebad$export$af798c228fb30a56(key, valueCountMap[key], baseSettings);
        tempFilters.push({
            key: `${key}`,
            label: `${messages[messageKeys[key]] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key))}`,
            isActive: count < COUNT_OF_FIXED_FILTERS,
            isDefault: count < COUNT_OF_FIXED_FILTERS && false,
            isCustom: false,
            appliedTo: $809c6fe4b590ebad$var$getAppliedToText(baseSettings.columnPickerList, key),
            initialCount: options?.length || 0,
            options: options
        });
        count += 1;
    }
    return tempFilters;
};
const $809c6fe4b590ebad$export$d2ea28e46364c0c8 = (filters)=>filters.filter((filter)=>filter.isActive === true && !filter.isCustom).length;


function $e755bfdd37ca2612$var$AddFilterDropdown({ showFilterBar: showFilterBar, isDropDownMenuOpen: isDropDownMenuOpen, headingDescription: headingDescription, placeholder: placeholder, filters: filters, setFilters: setFilters, dropdownMenuPositionToRight: dropdownMenuPositionToRight, filterListWrapRef: filterListWrapRef, handleRemoveFilter: handleRemoveFilter, isMobileResponsivenessEnabled: isMobileResponsivenessEnabled }) {
    const [searchText, setSearchText] = (0, $hopDi$useState)("");
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(true);
    const addFilterDropdownClasses = (0, $hopDi$classnames)(isDropDownMenuOpen && showFilterBar ? "AddFilterDropdown-dropDown--isActive" : "AddFilterDropdown-dropDown--isDisabled", dropdownMenuPositionToRight && "AddFilterDropdown-dropDownRight");
    const onClose = ()=>{
        setIsVisible(false);
    };
    const enableFilter = (filterKey)=>{
        if ((0, $809c6fe4b590ebad$export$d2ea28e46364c0c8)(filters) >= (0, $36b8d1366c64b9c7$export$f46d66ac5a9e4045)) {
            setIsVisible(true);
            return;
        }
        const prevFilters = JSON.parse(JSON.stringify(filters));
        setFilters(prevFilters.map((filter)=>{
            if (filter.key === filterKey) return {
                ...filter,
                isActive: !filter.isActive
            };
            return filter;
        }));
    };
    const disableFilter = (filterKey)=>{
        handleRemoveFilter(filterKey);
        setIsVisible(false);
    };
    if (isMobileResponsivenessEnabled) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            (0, $809c6fe4b590ebad$export$d2ea28e46364c0c8)(filters) >= (0, $36b8d1366c64b9c7$export$f46d66ac5a9e4045) && isVisible && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AddFilterDropdown-dropDownHeadingDescription--mobileResponsive",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                    kind: "background",
                    size: "small",
                    text: "You\u2019ve reached maximum number of filter sets allowed. Remove existing ones to add more.",
                    colorTheme: "info",
                    leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Info"
                    }),
                    isVisible: isVisible,
                    onDismiss: onClose,
                    isDismissible: true
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AddFilterDropdown-dropDownSearchBar--mobileResponsive",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "basic",
                    placeholder: placeholder,
                    kind: "search",
                    size: "large",
                    prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "search",
                        color: "neutral-700",
                        size: "smallMedium"
                    }),
                    value: searchText,
                    setValue: setSearchText,
                    tabIndex: 0
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AddFilterDropdown-dropDownFilterList--mobileResponsive",
                ref: filterListWrapRef,
                children: filters?.filter((filter)=>!filter?.isDefault && filter.label.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 && !filter?.isCustom)?.sort((a, b)=>b.isActive - a.isActive || a.label.toLowerCase().localeCompare(b.label.toLowerCase()))?.map((filter)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "AddFilterDropdown-dropDownFilterListItems--mobileResponsive",
                        children: filter?.isActive ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "AddFilterDropdown-dropDownFilterListItemsWrapper--mobileResponsive",
                            onClick: ()=>{
                                disableFilter(filter?.key);
                            },
                            onKeyUp: ()=>{},
                            role: "button",
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtom--isEnabled",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "small",
                                        kind: "bold",
                                        isSelected: true,
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Remove"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2-bold",
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtomText--isEnabled",
                                    children: filter?.label
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "AddFilterDropdown-dropDownFilterListItemsWrapper--mobileResponsive",
                            onClick: ()=>{
                                enableFilter(filter?.key);
                            },
                            onKeyUp: ()=>{},
                            role: "button",
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtom--isDisabled",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "small",
                                        kind: "outlinedSecondary",
                                        isDisabled: false,
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Add"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtomText--isDisabled",
                                    children: filter?.label
                                })
                            ]
                        })
                    }, filter?.key))
            })
        ]
    });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: addFilterDropdownClasses,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "AddFilterDropdown-dropDownHeadingDescription",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        children: headingDescription
                    }),
                    (0, $809c6fe4b590ebad$export$d2ea28e46364c0c8)(filters) >= (0, $36b8d1366c64b9c7$export$f46d66ac5a9e4045) && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "background",
                        size: "small",
                        text: "You\u2019ve reached maximum number of filter sets allowed. Remove existing ones to add more.",
                        colorTheme: "info",
                        leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Info"
                        }),
                        isVisible: isVisible,
                        onDismiss: onClose,
                        isDismissible: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AddFilterDropdown-dropDownSearchBar",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "basic",
                    placeholder: placeholder,
                    kind: "search",
                    size: "small",
                    prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "search",
                        color: "neutral-700",
                        size: "smallMedium"
                    }),
                    value: searchText,
                    setValue: setSearchText,
                    tabIndex: 0
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AddFilterDropdown-dropDownFilterList",
                ref: filterListWrapRef,
                children: filters?.filter((filter)=>!filter?.isDefault && filter.label.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 && !filter?.isCustom)?.sort((a, b)=>b.isActive - a.isActive || a.label.toLowerCase().localeCompare(b.label.toLowerCase()))?.map((filter)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "AddFilterDropdown-dropDownFilterListItems",
                        children: filter?.isActive ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "AddFilterDropdown-dropDownFilterListItemsWrapper",
                            onClick: ()=>{
                                disableFilter(filter?.key);
                            },
                            onKeyUp: ()=>{},
                            role: "button",
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtom--isEnabled",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "small",
                                        kind: "bold",
                                        isSelected: true,
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Remove"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2-bold",
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtomText--isEnabled",
                                    children: filter?.label
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "AddFilterDropdown-dropDownFilterListItemsWrapper",
                            onClick: ()=>{
                                enableFilter(filter?.key);
                            },
                            onKeyUp: ()=>{},
                            role: "button",
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtom--isDisabled",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "small",
                                        kind: "outlinedSecondary",
                                        isDisabled: false,
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Add"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "AddFilterDropdown-dropDownFilterListItemsCustomButtomText--isDisabled",
                                    children: filter?.label
                                })
                            ]
                        })
                    }, filter?.key))
            })
        ]
    });
}
$e755bfdd37ca2612$var$AddFilterDropdown.propTypes = {
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    isDropDownMenuOpen: (0, $hopDi$proptypes).bool.isRequired,
    headingDescription: (0, $hopDi$proptypes).string,
    placeholder: (0, $hopDi$proptypes).string,
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).string.isRequired,
        key: (0, $hopDi$proptypes).string.isRequired,
        isActive: (0, $hopDi$proptypes).bool,
        options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
            label: (0, $hopDi$proptypes).string.isRequired,
            value: (0, $hopDi$proptypes).string.isRequired
        }))
    })).isRequired,
    setFilters: (0, $hopDi$proptypes).func.isRequired,
    dropdownMenuPositionToRight: (0, $hopDi$proptypes).bool,
    filterListWrapRef: (0, $hopDi$proptypes).shape({}).isRequired,
    handleRemoveFilter: (0, $hopDi$proptypes).func.isRequired,
    isMobileResponsivenessEnabled: (0, $hopDi$proptypes).bool
};
$e755bfdd37ca2612$var$AddFilterDropdown.defaultProps = {
    headingDescription: "",
    placeholder: "",
    dropdownMenuPositionToRight: false,
    isMobileResponsivenessEnabled: false
};
var $e755bfdd37ca2612$export$2e2bcd8739ae039 = $e755bfdd37ca2612$var$AddFilterDropdown;










const $877a89fa7e3a8479$var$LOAD_INCREMENT = 10;
function $877a89fa7e3a8479$var$ChipFilter({ filter: filter, handleRemoveFilter: handleRemoveFilter, setPersonalizationStatus: setPersonalizationStatus, handleMultiMenuChange: handleMultiMenuChange, certKey: certKey, countOfCheckedOptions: countOfCheckedOptions, updateFiltersAfterSearch: updateFiltersAfterSearch, isFilterOpen: isFilterOpen, isMobileResponsivenessEnabled: isMobileResponsivenessEnabled }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const [options, setOptions] = (0, $hopDi$useState)([]);
    const [prioritizeCheckedOptions, setPrioritizeCheckedOptions] = (0, $hopDi$useState)(false);
    const [mobileFilter, setMobileFilter] = (0, $hopDi$useState)(filter); // For mobile resposiveness below 600px
    const [filterText, setFilterText] = (0, $hopDi$useState)("");
    (0, $hopDi$useEffect)(()=>{
        setOptions(filter.options);
        setMobileFilter(filter);
    }, [
        filter
    ]);
    const getFilterList = async (searchText)=>{
        const body = {
            certkey: certKey,
            // "searchtext":"ro", // searchtext is optional parameter. to search in filter for available values
            // "searchtext":"ro_ent5_displayname", // searchtext is optional parameter. to search in filter for available values
            fieldtosearch: filter.key,
            moreoptions: "true",
            fieldnameSize: "500"
        };
        if (searchText) // to search filters by name
        body.searchtext = searchText;
        dispatch((0, $d623f23401a154f0$export$4c41e2d57bc57d23)(body)).then((data)=>{
            if (data?.valueCountMap) {
                if (data.valueCountMap[filter.key]) updateFiltersAfterSearch(data.valueCountMap[filter.key], filter.key);
            } else // set empty object
            updateFiltersAfterSearch({}, filter.key);
        }).catch((error)=>{
            (0, $hopDi$Logger).error("chip filter search error ", error);
        });
    };
    const loadFilterList = (0, $hopDi$useCallback)((searchTermValue, offsetValue = 0)=>{
        getFilterList(searchTermValue, offsetValue, $877a89fa7e3a8479$var$LOAD_INCREMENT);
    }, [
        options
    ]);
    // Wrap load filter list with debounce
    const debouncedloadFilterList = (0, $hopDi$useCallback)((0, $hopDi$debounce)(loadFilterList, (0, $hopDi$DEFAULT_INPUT_DEBOUNCE_DELAY)), [
        options
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (!filter?.options?.length && filter.initialCount > 0) debouncedloadFilterList(); // to fetch chip list
    }, []);
    // For the devices below than 600px width
    const [searchTextWhenMobile, setSearchTextWhenMobile] = (0, $hopDi$useState)("");
    const handleChangeForMobile = (optionValueKey)=>{
        setMobileFilter((prev)=>({
                ...prev,
                options: prev.options.map((option)=>option.value === optionValueKey ? {
                        ...option,
                        isChecked: !option.isChecked
                    } : option)
            }));
    };
    (0, $hopDi$useEffect)(()=>{
        if (isMobileResponsivenessEnabled) {
            const selectedOptions = mobileFilter.options.filter((option)=>option.isChecked) || [];
            handleMultiMenuChange(mobileFilter.key, selectedOptions);
            dispatch(setPersonalizationStatus("UPDATE_PERSONALIZATION"));
            dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
        }
    }, [
        mobileFilter
    ]);
    (0, $hopDi$useAvoidFirstRender)(()=>{
        if (isMobileResponsivenessEnabled && isFilterOpen) {
            debouncedloadFilterList(searchTextWhenMobile.trim());
            if (searchTextWhenMobile !== "") setPrioritizeCheckedOptions(true);
        }
    }, [
        searchTextWhenMobile
    ]);
    if (isMobileResponsivenessEnabled) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            filter.initialCount >= (0, $36b8d1366c64b9c7$export$1befceae51a862ad) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AddFilterDropdown-dropDownSearchBar--mobileResponsive",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "basic",
                    placeholder: "Search",
                    kind: "search",
                    size: "large",
                    prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "search",
                        color: "neutral-700",
                        size: "smallMedium"
                    }),
                    isDisabled: !isFilterOpen,
                    value: searchTextWhenMobile,
                    setValue: setSearchTextWhenMobile,
                    tabIndex: 0
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "AdvancedFilters-filterDrawerStep2NormalFilterOptions",
                children: [
                    mobileFilter?.options?.sort((a, b)=>{
                        if (searchTextWhenMobile !== "" && prioritizeCheckedOptions) return !b.isChecked - !a.isChecked;
                        return b.isChecked - a.isChecked;
                    })?.map((option)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawerItem), {
                            option: {
                                ...option,
                                isMulti: true
                            },
                            onClick: ()=>{
                                handleChangeForMobile(option.value);
                                if (prioritizeCheckedOptions) setPrioritizeCheckedOptions(false);
                                if (searchTextWhenMobile !== "") debouncedloadFilterList(searchTextWhenMobile.trim());
                            }
                        }, option.value)),
                    mobileFilter?.options?.length === 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: "AdvancedFilters-filterDrawerStep2NormalFilter--noDataScreen",
                        children: "No data available"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuMulti), {
        options: options,
        appendLabelsToButton: false,
        label: filter.label,
        onChange: (selectedOptions)=>{
            handleMultiMenuChange(filter.key, selectedOptions);
            dispatch(setPersonalizationStatus("UPDATE_PERSONALIZATION"));
            dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
            if (prioritizeCheckedOptions) setPrioritizeCheckedOptions(false);
            if (filterText !== "") debouncedloadFilterList(filterText.trim());
        },
        trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
            kind: "pill",
            label: "",
            BadgeComp: countOfCheckedOptions && countOfCheckedOptions > 0 ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                className: "AdvancedFilters-triggerBadgeWrap",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body3-bold",
                    className: "AdvancedFilters-triggerBadgeWrapText",
                    dataTestId: "chipfilter-triggerBadgeWrapText",
                    children: countOfCheckedOptions
                })
            }) : null
        }),
        minOptionsForFooter: 0,
        minOptionsForSearch: filter.initialCount < (0, $36b8d1366c64b9c7$export$1befceae51a862ad) ? options.length + 1 : 0,
        sortOnCheck: true,
        shouldSortCheckedAtBottom: prioritizeCheckedOptions,
        headerText: filter?.appliedTo,
        headerTextConfigs: {
            headerTextClassName: "AdvancedFilters-filterBarMenuItemHeaderText",
            splitOnToken: true,
            token: ":",
            preTokenClassName: "AdvancedFilters-filterBarMenuItemHeaderTextPreToken",
            postTokenClassName: "AdvancedFilters-filterBarMenuItemHeaderTextPostToken"
        },
        footerLink1Text: "Remove Filter",
        isFilteringDisabled: true,
        onFooterLink1Click: ()=>handleRemoveFilter(filter.key),
        onSearchTermChange: (searchText)=>{
            setFilterText(searchText);
            setPrioritizeCheckedOptions(searchText !== "");
            debouncedloadFilterList(searchText.trim());
        },
        showOptionLabelOnHover: true,
        showFooterLink1: true
    }, filter.key);
}
$877a89fa7e3a8479$var$ChipFilter.propTypes = {
    filter: (0, $hopDi$proptypes).shape({
        key: (0, $hopDi$proptypes).string.isRequired,
        label: (0, $hopDi$proptypes).string.isRequired,
        options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})),
        appliedTo: (0, $hopDi$proptypes).string,
        initialCount: (0, $hopDi$proptypes).number
    }),
    handleRemoveFilter: (0, $hopDi$proptypes).func.isRequired,
    setPersonalizationStatus: (0, $hopDi$proptypes).func.isRequired,
    handleMultiMenuChange: (0, $hopDi$proptypes).func.isRequired,
    certKey: (0, $hopDi$proptypes).string.isRequired,
    countOfCheckedOptions: (0, $hopDi$proptypes).number.isRequired,
    updateFiltersAfterSearch: (0, $hopDi$proptypes).func.isRequired,
    isFilterOpen: (0, $hopDi$proptypes).bool,
    isMobileResponsivenessEnabled: (0, $hopDi$proptypes).bool
};
$877a89fa7e3a8479$var$ChipFilter.defaultProps = {
    filter: {},
    isFilterOpen: false,
    isMobileResponsivenessEnabled: false
};
var $877a89fa7e3a8479$export$2e2bcd8739ae039 = $877a89fa7e3a8479$var$ChipFilter;









function $5b67af4e24cf2d4e$var$CustomChipFilter({ filter: filter, handleRemoveFilter: handleRemoveFilter, setPersonalizationStatus: setPersonalizationStatus, handleMultiMenuChange: handleMultiMenuChange, countOfCheckedOptions: countOfCheckedOptions, isMobileResponsivenessEnabled: isMobileResponsivenessEnabled }) {
    const dispatch = (0, $hopDi$useDispatch)();
    // For the devices below than 600px width
    const [searchTextWhenMobile, setSearchTextWhenMobile] = (0, $hopDi$useState)("");
    const [mobileFilter, setMobileFilter] = (0, $hopDi$useState)(filter);
    (0, $hopDi$useEffect)(()=>{
        setMobileFilter(filter);
    }, [
        filter
    ]);
    const handleChangeForMobile = (optionValueKey)=>{
        setMobileFilter((prev)=>({
                ...prev,
                options: prev.options.map((option)=>option.value === optionValueKey ? {
                        ...option,
                        isChecked: !option.isChecked
                    } : option)
            }));
    };
    (0, $hopDi$useEffect)(()=>{
        if (isMobileResponsivenessEnabled) {
            const selectedOptions = mobileFilter.options.filter((option)=>option.isChecked) || [];
            handleMultiMenuChange(mobileFilter.key, selectedOptions);
            dispatch(setPersonalizationStatus("UPDATE_PERSONALIZATION"));
            dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
        }
    }, [
        mobileFilter
    ]);
    if (isMobileResponsivenessEnabled) {
        const sortedAndFilteredFilterOptions = mobileFilter?.options?.sort((a, b)=>b.isChecked - a.isChecked)?.filter((option)=>option.isChecked || option.label.toLowerCase().indexOf(searchTextWhenMobile.toLowerCase()) !== -1);
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "AddFilterDropdown-dropDownSearchBar--mobileResponsive",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                        name: "basic",
                        placeholder: "Search",
                        kind: "search",
                        size: "large",
                        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "search",
                            color: "neutral-700",
                            size: "smallMedium"
                        }),
                        value: searchTextWhenMobile,
                        setValue: setSearchTextWhenMobile,
                        tabIndex: 0
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "AdvancedFilters-filterDrawerStep2NormalFilterOptions",
                    children: [
                        sortedAndFilteredFilterOptions?.map((option)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawerItem), {
                                option: {
                                    ...option,
                                    isMulti: true
                                },
                                onClick: ()=>{
                                    handleChangeForMobile(option.value);
                                }
                            }, option.value)),
                        sortedAndFilteredFilterOptions?.length === 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body3",
                            className: "AdvancedFilters-filterDrawerStep2NormalFilter--noDataScreen",
                            children: "No data available"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuMulti), {
        options: filter.options,
        appendLabelsToButton: false,
        label: filter.label,
        onChange: (selectedOptions)=>{
            handleMultiMenuChange(filter.key, selectedOptions);
            dispatch(setPersonalizationStatus("UPDATE_PERSONALIZATION"));
            dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
        },
        trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
            kind: "pill",
            label: "",
            BadgeComp: countOfCheckedOptions && countOfCheckedOptions > 0 ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                className: "AdvancedFilters-triggerBadgeWrap",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body3-bold",
                    className: "AdvancedFilters-triggerBadgeWrapText",
                    dataTestId: "chipfilter-triggerBadgeWrapText",
                    children: countOfCheckedOptions
                })
            }) : null
        }),
        minOptionsForFooter: 0,
        minOptionsForSearch: 0,
        sortOnCheck: true,
        headerText: filter?.appliedTo,
        headerTextConfigs: {
            headerTextClassName: "AdvancedFilters-filterBarMenuItemHeaderText",
            splitOnToken: true,
            token: ":",
            preTokenClassName: "AdvancedFilters-filterBarMenuItemHeaderTextPreToken",
            postTokenClassName: "AdvancedFilters-filterBarMenuItemHeaderTextPostToken"
        },
        footerLink1Text: " ",
        onFooterLink1Click: ()=>handleRemoveFilter(filter.key),
        showOptionLabelOnHover: true,
        showFooterLink1: true
    }, filter.key);
}
$5b67af4e24cf2d4e$var$CustomChipFilter.propTypes = {
    filter: (0, $hopDi$proptypes).shape({
        key: (0, $hopDi$proptypes).string.isRequired,
        label: (0, $hopDi$proptypes).string.isRequired,
        options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})),
        appliedTo: (0, $hopDi$proptypes).string
    }),
    handleRemoveFilter: (0, $hopDi$proptypes).func.isRequired,
    setPersonalizationStatus: (0, $hopDi$proptypes).func.isRequired,
    handleMultiMenuChange: (0, $hopDi$proptypes).func.isRequired,
    countOfCheckedOptions: (0, $hopDi$proptypes).number.isRequired,
    isMobileResponsivenessEnabled: (0, $hopDi$proptypes).bool
};
$5b67af4e24cf2d4e$var$CustomChipFilter.defaultProps = {
    filter: {},
    isMobileResponsivenessEnabled: false
};
var $5b67af4e24cf2d4e$export$2e2bcd8739ae039 = $5b67af4e24cf2d4e$var$CustomChipFilter;


/* eslint-disable indent */ 











function $a1db3afc27514bc6$export$4a17f49718afd99a({ isOpen: isOpen, setIsOpen: setIsOpen, label: label, showBadge: showBadge, prefixIcon: prefixIcon }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "SmartFilterButtonSelect-wrapper",
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
            kind: "pill",
            size: "medium",
            className: `SmartFilterButtonSelect-button ${isOpen ? "SmartFilterButtonSelect-button SmartFilterButtonSelect-button--IsOpen" : ""}`,
            isOpen: isOpen,
            onClick: ()=>setIsOpen(!isOpen),
            label: label,
            prefixIcon: prefixIcon,
            BadgeComp: showBadge ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                kind: "dot",
                color: "primary",
                size: "small"
            }) : null,
            isIconSvgFilled: false
        })
    });
}


var $0d1cca91eb2a2074$export$2e2bcd8739ae039 = (0, $a1db3afc27514bc6$export$4a17f49718afd99a);




const $299c839906ecd2ce$var$SAVI_ACTIONS_FILTER_OPTIONS = [
    {
        key: "SAVI_APPROVED",
        label: "Savi Approved"
    },
    {
        key: "SAVI_REJECTED",
        label: "Savi Rejected"
    }
];
function $299c839906ecd2ce$var$SaviActionsFilterItem({ id: id, label: label, onClick: onClick, isFilterSelected: isFilterSelected, isMobileResponsivenessEnabled: isMobileResponsivenessEnabled }) {
    const isChecked = isFilterSelected[id] || false;
    const handleOptionClick = (event)=>{
        // prevent the default behavior and event bubbling.
        event.preventDefault();
        event.stopPropagation();
        onClick(id, !isChecked);
    };
    if (isMobileResponsivenessEnabled) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawerItem), {
        option: {
            label: label,
            isChecked: isChecked,
            value: id,
            isMulti: true
        },
        onClick: ()=>onClick(id, !isChecked)
    }, id);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("li", {
        onClick: handleOptionClick,
        className: "SaviActionsFilter-menuItem",
        role: "option",
        "aria-selected": isFilterSelected && isFilterSelected[id],
        onKeyDown: undefined,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "MenuItemMulti-checkbox",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                    kind: "base",
                    tabIndex: 0,
                    isChecked: isChecked
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                className: "SaviActionsFilter-menuItemText",
                children: label
            })
        ]
    }, 1);
}
$299c839906ecd2ce$var$SaviActionsFilterItem.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    label: (0, $hopDi$proptypes).string.isRequired,
    onClick: (0, $hopDi$proptypes).func.isRequired,
    isFilterSelected: (0, $hopDi$proptypes).shape({}),
    isMobileResponsivenessEnabled: (0, $hopDi$proptypes).bool
};
$299c839906ecd2ce$var$SaviActionsFilterItem.defaultProps = {
    isFilterSelected: {},
    isMobileResponsivenessEnabled: false
};
function $299c839906ecd2ce$var$SaviActionsFilters({ setIsSaviActionsApplied: setIsSaviActionsApplied, isSmartFilterApplied: isSmartFilterApplied, isMobileDrawerOpen: isMobileDrawerOpen, setIsMobileDrawerOpen: setIsMobileDrawerOpen, isMobileResponsivenessEnabled: isMobileResponsivenessEnabled }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const [isFilterSelected, setIsFilterSelected] = (0, $hopDi$useState)({});
    //   const [selectedFactor, setSelectedFactor] = useState('');
    //   const [showSmartFilterLoader, setShowSmartFilterLoader] = useState(false);
    //   const { messages } = useSelector((state) => state?.user);
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, searchText: searchText, columnNames: columnNames, clearSaviActionsFilter: clearSaviActionsFilter } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const wrapperRef = (0, $hopDi$useRef)(null);
    (0, $hopDi$useOutsideClickEffect)(wrapperRef, ()=>setIsOpen(false));
    const isAnyFilterSelected = Object.keys(isFilterSelected).length > 0;
    const clearFilter = ()=>{
        if (isMobileResponsivenessEnabled) setIsMobileDrawerOpen(false);
        const promiseToComplete = [];
        Object.keys(isFilterSelected).forEach((item)=>{
            promiseToComplete.push(dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)("SAVI_ACTION", item, false)));
        });
        Promise.all(promiseToComplete).then((responses)=>{
            const combinedResponse = responses.every((response)=>response === true);
            if (combinedResponse) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
        });
        setIsFilterSelected({});
    };
    (0, $hopDi$useEffect)(()=>{
        setIsSaviActionsApplied(isAnyFilterSelected);
        dispatch((0, $d623f23401a154f0$export$e349e9296213dd36)(isAnyFilterSelected));
    }, [
        isAnyFilterSelected
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (clearSaviActionsFilter) {
            clearFilter();
            dispatch((0, $d623f23401a154f0$export$fa25dca28252b044)(false));
        }
    }, [
        clearSaviActionsFilter
    ]);
    (0, $hopDi$useEffect)(()=>{
        // This function is used to get applied savi action filters for exporting
        const findAppliedActionFilterForExport = ()=>{
            const appliedFilters = Object.keys(isFilterSelected).map((key)=>$299c839906ecd2ce$var$SAVI_ACTIONS_FILTER_OPTIONS.find((item)=>item.key === key)?.label);
            dispatch((0, $d623f23401a154f0$export$e9d81ac38d0006c1)(appliedFilters));
        };
        findAppliedActionFilterForExport();
    }, [
        isFilterSelected
    ]);
    const filterSaviActions = (id, isChecked)=>{
        const updateFilterAction = Promise.resolve(dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)("SAVI_ACTION", id, isChecked)));
        updateFilterAction.then(()=>{
            dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
        });
    };
    const updateSmartFilter = (id, isChecked)=>{
        if (isChecked) setIsFilterSelected({
            ...isFilterSelected,
            [id]: true
        });
        else {
            const _isFilterSelected = {
                ...isFilterSelected
            };
            delete _isFilterSelected[id];
            setIsFilterSelected(_isFilterSelected);
        }
        const promiseToComplete = isSmartFilterApplied ? [
            dispatch((0, $d623f23401a154f0$export$2cbfe24d13ec38c6)(true)),
            dispatch((0, $d623f23401a154f0$export$fe1a3b23990ade30)({
                certkey: certKey,
                clearFilter: "true"
            }, {
                MAX_NUMBER_OF_RECORDS: $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4,
                dontRefreshItems: true
            })),
            dispatch((0, $d623f23401a154f0$export$99843d46b6bfa277)(""))
        ] : [];
        if (promiseToComplete.length > 0) Promise.all(promiseToComplete).then(()=>{
            filterSaviActions(id, isChecked);
        });
        else filterSaviActions(id, isChecked);
    };
    if (isMobileResponsivenessEnabled) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "SaviFilter-dropdown-displayFlex",
                children: $299c839906ecd2ce$var$SAVI_ACTIONS_FILTER_OPTIONS.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $hopDi$jsx)($299c839906ecd2ce$var$SaviActionsFilterItem, {
                        id: key,
                        label: label,
                        onClick: updateSmartFilter,
                        isFilterSelected: isFilterSelected,
                        isMobileResponsivenessEnabled: true
                    }, key))
            }),
            isMobileDrawerOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                isOpen: isMobileDrawerOpen,
                setIsOpen: setIsMobileDrawerOpen,
                isSwipeEnabled: true,
                content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "ghost",
                    size: "medium",
                    onClick: clearFilter,
                    isDisabled: !isAnyFilterSelected,
                    className: "AdvancedFilters-filterDrawerClearAndRemoveBtns",
                    children: "Clear Filter"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SaviActionsFilter-wrapper",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $0d1cca91eb2a2074$export$2e2bcd8739ae039), {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                label: "Filters",
                showBadge: isAnyFilterSelected,
                prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "SaviCompanion",
                    size: "medium"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: (0, $hopDi$classnames)("SaviActionsFilter-dropdown", isOpen && "SaviActionsFilter-dropdown--isVisible"),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "SmartFilter-dropdown-displayFlex",
                        children: $299c839906ecd2ce$var$SAVI_ACTIONS_FILTER_OPTIONS.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $hopDi$jsx)($299c839906ecd2ce$var$SaviActionsFilterItem, {
                                id: key,
                                label: label,
                                onClick: updateSmartFilter,
                                isFilterSelected: isFilterSelected
                            }, key))
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "SaviActionsFilter-footer",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                            text: "Clear",
                            kind: "button",
                            onClick: clearFilter,
                            isDisabled: !isAnyFilterSelected,
                            size: "small"
                        })
                    })
                ]
            })
        ]
    });
}
$299c839906ecd2ce$var$SaviActionsFilters.propTypes = {
    setIsSaviActionsApplied: (0, $hopDi$proptypes).func.isRequired,
    isSmartFilterApplied: (0, $hopDi$proptypes).bool.isRequired,
    isMobileDrawerOpen: (0, $hopDi$proptypes).bool,
    setIsMobileDrawerOpen: (0, $hopDi$proptypes).func,
    isMobileResponsivenessEnabled: (0, $hopDi$proptypes).bool
};
$299c839906ecd2ce$var$SaviActionsFilters.defaultProps = {
    isMobileDrawerOpen: false,
    setIsMobileDrawerOpen: ()=>{},
    isMobileResponsivenessEnabled: false
};
var $299c839906ecd2ce$export$2e2bcd8739ae039 = $299c839906ecd2ce$var$SaviActionsFilters;


var $ffc97a672f354fdb$export$2e2bcd8739ae039 = (0, $299c839906ecd2ce$export$2e2bcd8739ae039);













function $28f02b7e15edd9c7$var$LoaderWrapper() {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "SmartFilters-loader",
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
            kind: "dots",
            format: "inline",
            size: "medium",
            color: "brand"
        })
    });
}
// Commented the below lines because title is removed from design for sometime
function $28f02b7e15edd9c7$var$FactorsTitle() {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "SmartFilters-factorsTitleWrapper"
    });
}
function $28f02b7e15edd9c7$var$FactorItem({ id: id, title: title, description: description, payload: payload, handleChange: handleChange, isDisabled: isDisabled, selectedFactor: selectedFactor, setShowSmartFilterLoader: setShowSmartFilterLoader }) {
    const [isChecked, setIschecked] = (0, $hopDi$useState)(id === selectedFactor);
    (0, $hopDi$useEffect)(()=>{
        setIschecked(id === selectedFactor);
    }, [
        selectedFactor
    ]);
    const handleItemClick = (event)=>{
        setShowSmartFilterLoader(true);
        const _isChecked = !isChecked;
        setIschecked(_isChecked);
        handleChange(id, {
            ...payload,
            checked: _isChecked
        });
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$RadioButton), {
        id: `smartFiltersRadioButton${Math.random()}`,
        name: "smartFiltersRadioButtonGroup",
        title: title,
        description: description,
        value: id,
        isDisabled: isDisabled,
        radioSelection: selectedFactor,
        onClick: handleItemClick,
        isTruncated: true
    }, `smartFiltersRadioButton${Math.random()}`);
}
$28f02b7e15edd9c7$var$FactorItem.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    title: (0, $hopDi$proptypes).string.isRequired,
    description: (0, $hopDi$proptypes).string.isRequired,
    payload: (0, $hopDi$proptypes).shape({}).isRequired,
    handleChange: (0, $hopDi$proptypes).func.isRequired,
    selectedFactor: (0, $hopDi$proptypes).string.isRequired,
    isDisabled: (0, $hopDi$proptypes).bool,
    setShowSmartFilterLoader: (0, $hopDi$proptypes).func.isRequired
};
$28f02b7e15edd9c7$var$FactorItem.defaultProps = {
    isDisabled: false
};
function $28f02b7e15edd9c7$var$SmartFilters({ setShowBadgeOnFilterButton: setShowBadgeOnFilterButton, clearDropDownFilters: clearDropDownFilters, setIsSmartFilterApplied: setIsSmartFilterApplied, isMobileDrawerOpen: isMobileDrawerOpen, setIsMobileDrawerOpen: setIsMobileDrawerOpen, isMobileResponsivenessEnabled: isMobileResponsivenessEnabled }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const [selectedFactor, setSelectedFactor] = (0, $hopDi$useState)("");
    const [showSmartFilterLoader, setShowSmartFilterLoader] = (0, $hopDi$useState)(false);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const dispatch = (0, $hopDi$useDispatch)();
    const localize = (0, $hopDi$useLocalize)();
    const { certKey: certKey, smartFiltersMeta: smartFiltersMeta, bulkAction: bulkAction, clearSmartFilters: clearSmartFilters, clearAllFilters: clearAllFilters } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const wrapperRef = (0, $hopDi$useRef)(null);
    (0, $hopDi$useOutsideClickEffect)(wrapperRef, ()=>setIsOpen(false));
    (0, $hopDi$useEffect)(()=>{
        if (certKey && Object.keys(smartFiltersMeta)?.length === 0) dispatch((0, $d623f23401a154f0$export$5221a830a76e1142)(certKey));
    }, [
        certKey
    ]);
    const clearLocalFilters = ()=>{
        setSelectedFactor("");
        setIsSmartFilterApplied(false);
        dispatch((0, $d623f23401a154f0$export$fe65047b4416261e)(false));
        setShowBadgeOnFilterButton(false);
    };
    const clearFilter = ()=>{
        if (isMobileResponsivenessEnabled) setIsMobileDrawerOpen(false);
        setShowSmartFilterLoader(true);
        clearDropDownFilters();
        dispatch((0, $d623f23401a154f0$export$fe1a3b23990ade30)({
            certkey: certKey,
            clearFilter: "true"
        }, {
            MAX_NUMBER_OF_RECORDS: $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4,
            setShowSmartFilterLoader: setShowSmartFilterLoader
        }));
        clearLocalFilters();
    };
    (0, $hopDi$useEffect)(()=>{
        if (clearAllFilters) {
            clearFilter();
            dispatch((0, $d623f23401a154f0$export$a38f157fd98f0bab)(false));
        }
    }, [
        clearAllFilters
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (clearSmartFilters) {
            clearLocalFilters();
            dispatch((0, $d623f23401a154f0$export$2cbfe24d13ec38c6)(false));
        }
    }, [
        clearSmartFilters
    ]);
    const updateSmartFilter = (id, payload)=>{
        clearDropDownFilters();
        if (bulkAction?.isChecked || bulkAction?.isIndeterminate) {
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            });
        }
        if (payload.checked) {
            setSelectedFactor(id);
            dispatch((0, $d623f23401a154f0$export$fe1a3b23990ade30)({
                ...payload,
                checked: payload.checked ? "1" : "0"
            }, {
                MAX_NUMBER_OF_RECORDS: $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4,
                setShowSmartFilterLoader: setShowSmartFilterLoader
            }));
        } else {
            dispatch((0, $d623f23401a154f0$export$fe1a3b23990ade30)({
                certkey: certKey,
                clearFilter: "true"
            }, {
                MAX_NUMBER_OF_RECORDS: $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4,
                setShowSmartFilterLoader: setShowSmartFilterLoader
            }));
            setSelectedFactor("");
        }
        setIsSmartFilterApplied(payload.checked);
        dispatch((0, $d623f23401a154f0$export$fe65047b4416261e)(payload.checked));
        setShowBadgeOnFilterButton(payload.checked);
    };
    (0, $hopDi$useEffect)(()=>{
        // This function is used to get applied savi smart filter for exporting
        const findAppliedSmartFilterForExport = ()=>{
            if (!smartFiltersMeta || Object.keys(smartFiltersMeta).length === 0) return;
            // Get the first entry of smartFiltersMeta and its factors
            const metaData = Object.entries(smartFiltersMeta)[0];
            const smartFiltersMetaFactors = metaData[1]?.factors;
            // Find the selected factor in smart filters
            const appliedSmartFilter = smartFiltersMetaFactors?.find((filter)=>filter.id === selectedFactor);
            if (!appliedSmartFilter) return;
            // Get the title of the applied filter
            const appliedSmartFilterTitle = appliedSmartFilter?.title;
            const appliedSmartFilterTitleLabel = messages[appliedSmartFilterTitle] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(appliedSmartFilterTitle));
            dispatch((0, $d623f23401a154f0$export$99843d46b6bfa277)(appliedSmartFilterTitleLabel));
        };
        findAppliedSmartFilterForExport();
    }, [
        selectedFactor
    ]);
    if (isMobileResponsivenessEnabled) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "SmartFilter-dropdown-displayFlex--mobileResponsive",
                children: Object.entries(smartFiltersMeta).map(([factorType, { title: factorTitle, description: factorDescription, iconKind: factorIconKind, factors: factors }])=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "SmartFilter-factorsPartition",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)($28f02b7e15edd9c7$var$FactorsTitle, {
                                title: messages[factorTitle] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(factorTitle)),
                                description: messages[factorDescription] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(factorDescription)),
                                iconKind: factorIconKind
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "SmartFilter-factorsItemList--mobileResponsive",
                                children: factors?.map(({ id: id, title: title, description: description, iconKind: iconKind, payload: payload })=>/*#__PURE__*/ (0, $hopDi$jsx)($28f02b7e15edd9c7$var$FactorItem, {
                                        id: id,
                                        title: messages[title] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(title)),
                                        description: messages[description] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(description)),
                                        isDisabled: showSmartFilterLoader,
                                        iconKind: iconKind,
                                        payload: payload,
                                        handleChange: updateSmartFilter,
                                        selectedFactor: selectedFactor,
                                        setShowSmartFilterLoader: setShowSmartFilterLoader
                                    }, id))
                            })
                        ]
                    }, factorType))
            }),
            isMobileDrawerOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                isOpen: isMobileDrawerOpen,
                setIsOpen: setIsMobileDrawerOpen,
                isSwipeEnabled: true,
                content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "ghost",
                    size: "medium",
                    onClick: clearFilter,
                    isDisabled: !selectedFactor,
                    className: "AdvancedFilters-filterDrawerClearAndRemoveBtns",
                    children: "Clear Filter"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SmartFilter-wrapper",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "SmartFilterButtonSelect-wrapper",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                    kind: "pill",
                    size: "medium",
                    className: `SmartFilter-button ${isOpen ? "SmartFilter-button SmartFilter-button--IsOpen" : ""}`,
                    isOpen: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    label: "Smart Filters",
                    prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "SmartBrain",
                        size: "medium"
                    }),
                    BadgeComp: selectedFactor ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                        kind: "dot",
                        color: "primary",
                        size: "small"
                    }) : null,
                    isIconSvgFilled: false
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: (0, $hopDi$classnames)("SmartFilter-dropdown", isOpen && "SmartFilter-dropdown--isVisible"),
                children: [
                    showSmartFilterLoader ? /*#__PURE__*/ (0, $hopDi$jsx)($28f02b7e15edd9c7$var$LoaderWrapper, {}) : null,
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "SmartFilter-dropdown-displayFlex",
                        children: Object.entries(smartFiltersMeta).map(([factorType, { title: factorTitle, description: factorDescription, iconKind: factorIconKind, factors: factors }])=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "SmartFilter-factorsPartition",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)($28f02b7e15edd9c7$var$FactorsTitle, {
                                        title: messages[factorTitle] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(factorTitle)),
                                        description: messages[factorDescription] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(factorDescription)),
                                        iconKind: factorIconKind
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: "SmartFilter-factorsItemList",
                                        children: factors?.map(({ id: id, title: title, description: description, iconKind: iconKind, payload: payload })=>/*#__PURE__*/ (0, $hopDi$jsx)($28f02b7e15edd9c7$var$FactorItem, {
                                                id: id,
                                                title: messages[title] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(title)),
                                                description: messages[description] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(description)),
                                                iconKind: iconKind,
                                                payload: payload,
                                                handleChange: updateSmartFilter,
                                                selectedFactor: selectedFactor,
                                                setShowSmartFilterLoader: setShowSmartFilterLoader
                                            }, id))
                                    })
                                ]
                            }, factorType))
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "SmartFilter-footer",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                            text: "Clear",
                            kind: "button",
                            onClick: clearFilter,
                            isDisabled: !selectedFactor,
                            className: "MenuMultiFooter-selectAll",
                            size: "small"
                        })
                    })
                ]
            })
        ]
    });
}
$28f02b7e15edd9c7$var$SmartFilters.propTypes = {
    setShowBadgeOnFilterButton: (0, $hopDi$proptypes).func.isRequired,
    clearDropDownFilters: (0, $hopDi$proptypes).func.isRequired,
    setIsSmartFilterApplied: (0, $hopDi$proptypes).func.isRequired,
    isMobileDrawerOpen: (0, $hopDi$proptypes).bool,
    setIsMobileDrawerOpen: (0, $hopDi$proptypes).func,
    isMobileResponsivenessEnabled: (0, $hopDi$proptypes).bool
};
$28f02b7e15edd9c7$var$SmartFilters.defaultProps = {
    isMobileDrawerOpen: false,
    setIsMobileDrawerOpen: ()=>{},
    isMobileResponsivenessEnabled: false
};
var $28f02b7e15edd9c7$export$2e2bcd8739ae039 = $28f02b7e15edd9c7$var$SmartFilters;


var $1bd36db49effb408$export$2e2bcd8739ae039 = (0, $28f02b7e15edd9c7$export$2e2bcd8739ae039);




function $9080a8ca19badea3$var$AdvancedFilters({ setShowBadgeOnFilterButton: setShowBadgeOnFilterButton, showFilterBar: showFilterBar, setShowFilterBar: setShowFilterBar, filters: filters, setFilters: setFilters, appliedFilters: appliedFilters, setAppliedFilters: setAppliedFilters, filterBarRef: filterBarRef }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, isLoading: isLoading, totalItems: totalItems, bulkAction: bulkAction, certKey: certKey, certsFilters: certsFilters, customFilters: customFilters, globalDateFormat: globalDateFormat, searchText: searchText, columnPickerList: columnPickerList, columnNames: columnNames, triggerClearBtnForFilters: triggerClearBtnForFilters, personalization: personalization, viewRowsList: viewRowsList, tabs: tabs, saviCompanionDetails: { isSaviEnabled: isSaviEnabled } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabs?.tabData?.find((tab)=>tab.isActive)?.count;
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const [isDropDownMenuOpen, setIsDropDownMenuOpen] = (0, $hopDi$useState)(false);
    const [dropdownMenuPositionToRight, setDropDownMenuPositionToRight] = (0, $hopDi$useState)(true);
    const [isClearBtnDisabled, setIsClearBtnDisabled] = (0, $hopDi$useState)(false);
    // Get the applied advacned filter values
    const personalizedAdvancedFilters = personalization?.personalizedData?.result?.info?.defaultView?.[0] ? personalization.personalizedData.result.info.defaultView[0].advancedFilters : undefined;
    const personalizedRowsFilters = personalization?.personalizedData?.result?.info?.defaultView?.[0] ? personalization.personalizedData.result.info.defaultView[0].rowsFilters : undefined;
    const personalizationViewOption = personalization?.viewOption?.view;
    const [personalizedDataLoaded, setPersonalizedDataLoaded] = (0, $hopDi$useState)(false);
    const [isSmartFilterApplied, setIsSmartFilterApplied] = (0, $hopDi$useState)(false);
    const [isSaviActionsApplied, setIsSaviActionsApplied] = (0, $hopDi$useState)(false);
    const clearCurrentPersonalization = personalization?.clearCurrentPersonalization;
    const dropDownWrapperRef = (0, $hopDi$useRef)("menu");
    const filterListWrapRef = (0, $hopDi$useRef)("filterListWrap");
    const advancedFiltersClasses = (0, $hopDi$classnames)(isDropDownMenuOpen && "AdvancedFilters-filterBar--isDropDownMenuOpen", showFilterBar ? "AdvancedFilters-filterBar--isActive" : "AdvancedFilters-filterBar--isDisabled");
    (0, $hopDi$useEffect)(()=>{
        if (filters.length === 0 || activeTabCount === 0) setShowFilterBar(false);
    }, [
        activeTabCount
    ]);
    (0, $hopDi$useOutsideClickEffect)(dropDownWrapperRef, ()=>{
        (0, $e7628c995f405891$export$63087e5d2dd3ce07)(filterListWrapRef, 0);
        setIsDropDownMenuOpen(false);
    });
    (0, $hopDi$useEffect)(()=>{
        if (certKey && columnNames) dispatch((0, $d623f23401a154f0$export$4d715bff11887d61)(certKey));
    }, [
        certKey,
        columnNames
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certsFilters) {
            const sanitizedFilters = (0, $809c6fe4b590ebad$export$92b9437c5afd872a)(certsFilters, {
                columnPickerList: columnPickerList,
                globalDateFormat: globalDateFormat
            }, intl, messages);
            const customActionFilterKey = "CERTIFIED";
            const customActionFilter = {
                key: customActionFilterKey,
                label: `${messages[customActionFilterKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(`${customActionFilterKey}_Action`)) || customActionFilterKey}`,
                isActive: true,
                isDefault: false,
                isCustom: true,
                appliedTo: `Applied to: ${viewRowsList?.map((rowType)=>rowType.charAt(0).toUpperCase() + rowType.slice(1, rowType.length - 1)).join(", ")}`,
                options: [
                    ...Object.keys(customFilters?.actionfilter).map((action)=>({
                            value: action,
                            label: messages[customFilters?.actionfilter[action]] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(customFilters?.actionfilter[action])),
                            isChecked: false
                        }))
                ]
            };
            const sanitizedFiltersWithCustomFilters = [
                customActionFilter,
                ...sanitizedFilters
            ];
            setFilters(sanitizedFiltersWithCustomFilters);
        }
    }, [
        certsFilters
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (!filterBarRef || !filterBarRef.current) return;
        if (Math.abs(filterBarRef.current.offsetLeft - dropDownWrapperRef.current.offsetLeft) < (0, $36b8d1366c64b9c7$export$aac7f63bb7ed27e)) setDropDownMenuPositionToRight(false);
        else setDropDownMenuPositionToRight(true);
    }, [
        filters
    ]);
    (0, $hopDi$useEffect)(()=>{
        const handleResize = ()=>{
            if (!filterBarRef || !filterBarRef.current || !dropDownWrapperRef || !dropDownWrapperRef.current) return;
            if (Math.abs(filterBarRef.current.offsetLeft - dropDownWrapperRef.current.offsetLeft) < (0, $36b8d1366c64b9c7$export$aac7f63bb7ed27e)) setDropDownMenuPositionToRight(false);
            else setDropDownMenuPositionToRight(true);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // Get updated filter options
    const getUpdatedFilterOptions = (newOptions, oldOptions)=>{
        const mergedArray = [
            ...oldOptions,
            ...newOptions
        ];
        //  Remove duplicates while keeping the `isChecked: true` items
        const uniqueMap = new Map();
        mergedArray.forEach((item)=>{
            // If the key is not yet in the map, or if this item has `isChecked: true`
            if (!uniqueMap.has(item.value) || item.isChecked) uniqueMap.set(item.value, item);
        });
        const uniqueArray = Array.from(uniqueMap.values());
        return uniqueArray;
    };
    // after searching  with text for individual chip and update options data
    const updateFiltersAfterSearch = (data, filterKey)=>{
        const options = (0, $809c6fe4b590ebad$export$af798c228fb30a56)(filterKey, data, {
            columnPickerList: columnPickerList,
            globalDateFormat: globalDateFormat
        });
        setFilters((prev)=>prev.map((filter)=>{
                if (filter.key === filterKey) {
                    const oldOptions = [];
                    if (filter.options) filter.options.forEach((option)=>{
                        if (option.isChecked) oldOptions.push(option);
                    });
                    const mergedOptions = getUpdatedFilterOptions(options, oldOptions);
                    return {
                        ...filter,
                        options: mergedOptions
                    };
                }
                return filter;
            }));
    };
    const handleFilterUpdate = (filterToUpdate, latestFilters, modifiedFilters, alreadyAppliedFilters, updatedAppliedFilters)=>{
        const tempFilters = latestFilters;
        const tempAppliedFilters = alreadyAppliedFilters;
        // Remove or Add filters
        const addOrRemoveMultipleFilters = ()=>{
            const promiseToAddOrRemoveFilters = [];
            for(let i = 0; i < filterToUpdate.filter.length; i += 1)promiseToAddOrRemoveFilters.push(dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)(filterToUpdate?.filter[i].key, filterToUpdate?.filter[i].value, filterToUpdate.state === (0, $36b8d1366c64b9c7$export$435b46f4233ebe34))));
            Promise.all(promiseToAddOrRemoveFilters).then((responses)=>{
                const combinedResponse = responses.every((response)=>response === true);
                if (combinedResponse) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
                else {
                    setFilters(tempFilters);
                    setAppliedFilters(tempAppliedFilters);
                }
            }).catch(()=>{
                setFilters(tempFilters);
                setAppliedFilters(tempAppliedFilters);
            }).finally(()=>{
                setIsClearBtnDisabled(false);
            });
        };
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
        if (bulkAction?.isChecked || bulkAction?.isIndeterminate) {
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            });
        }
        if (filterToUpdate.state !== (0, $36b8d1366c64b9c7$export$4e1772f042a16d95)) {
            setIsClearBtnDisabled(true);
            setFilters(modifiedFilters);
            setAppliedFilters(updatedAppliedFilters);
            if (filterToUpdate?.filter.length > 1) {
                // getting unique keys for swithing from personalisation to default view
                const uniqueFilterChipKeys = [
                    ...new Set(filterToUpdate.filter.map((item)=>item.key))
                ];
                if (filterToUpdate.state === (0, $36b8d1366c64b9c7$export$435b46f4233ebe34) || filterToUpdate.state === (0, $36b8d1366c64b9c7$export$35d42548e97bb61f) && uniqueFilterChipKeys.length > 1) addOrRemoveMultipleFilters();
                else {
                    // clear the filters
                    const clearFilterPayload = {
                        certkey: certKey,
                        only: "true",
                        field: filterToUpdate.filter[0].key
                    };
                    dispatch((0, $d623f23401a154f0$export$72e26222fdd0ded)(clearFilterPayload)).then((data)=>{
                        (0, $hopDi$Logger).log("clearChipFilter success", data);
                        dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
                    }).catch((error)=>{
                        (0, $hopDi$Logger).error("clearChipFilter error ", error);
                        addOrRemoveMultipleFilters();
                    }).finally(()=>{
                        setIsClearBtnDisabled(false);
                    });
                }
            } else {
                const promiseToComplete = isSmartFilterApplied ? [
                    dispatch((0, $d623f23401a154f0$export$2cbfe24d13ec38c6)(true)),
                    dispatch((0, $d623f23401a154f0$export$fe1a3b23990ade30)({
                        certkey: certKey,
                        clearFilter: "true"
                    }, {
                        MAX_NUMBER_OF_RECORDS: $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4,
                        dontRefreshItems: true
                    }))
                ] : [];
                promiseToComplete.push(dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)(filterToUpdate?.filter[0].key, filterToUpdate?.filter[0].value, filterToUpdate.state === (0, $36b8d1366c64b9c7$export$435b46f4233ebe34))));
                Promise.all(promiseToComplete).then((response)=>{
                    if (response) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
                    else {
                        setFilters(tempFilters);
                        setAppliedFilters(tempAppliedFilters);
                    }
                }).catch(()=>{
                    setFilters(tempFilters);
                    setAppliedFilters(tempAppliedFilters);
                }).finally(()=>{
                    setIsClearBtnDisabled(false);
                });
            }
        }
    };
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$877a3b3409060dd6)(appliedFilters));
        if (appliedFilters.length > 0 || isSmartFilterApplied || isSaviActionsApplied) setShowBadgeOnFilterButton(true);
        else setShowBadgeOnFilterButton(false);
    }, [
        appliedFilters,
        isSmartFilterApplied,
        isSaviActionsApplied
    ]);
    const handleMultiMenuChange = (filterKey, selectedOptions)=>{
        const updatedAppliedFilters = [];
        const prevFilters = JSON.parse(JSON.stringify(filters));
        const modifiedFilters = prevFilters.map((filter)=>{
            if (filter.key === filterKey) return {
                ...filter,
                options: filter.options.map((option)=>({
                        ...option,
                        isChecked: selectedOptions.some((selectedOption)=>selectedOption.value === option.value)
                    }))
            };
            return filter;
        });
        modifiedFilters.forEach((filter)=>{
            const _selectedOptions = filter.options.filter((option)=>option.isChecked === true).map((option)=>({
                    key: filter.key,
                    ...option
                }));
            updatedAppliedFilters.push(..._selectedOptions);
        });
        const filterToUpdate = (0, $809c6fe4b590ebad$export$1bae5911fd45fa82)(appliedFilters, updatedAppliedFilters);
        handleFilterUpdate(filterToUpdate, prevFilters, modifiedFilters, appliedFilters, updatedAppliedFilters);
    };
    const handleRemoveFilter = (filterKey)=>{
        const updatedAppliedFilters = [];
        const prevFilters = JSON.parse(JSON.stringify(filters));
        const modifiedFilters = prevFilters.map((filter)=>{
            if (filter.key === filterKey) return {
                ...filter,
                options: filter.options.map((option)=>({
                        ...option,
                        isChecked: false
                    }))
            };
            return filter;
        });
        modifiedFilters.forEach((filter)=>{
            const _selectedOptions = filter.options.filter((option)=>option.isChecked === true).map((option)=>({
                    key: filter.key,
                    ...option
                }));
            updatedAppliedFilters.push(..._selectedOptions);
        });
        const filterToUpdate = (0, $809c6fe4b590ebad$export$1bae5911fd45fa82)(appliedFilters, updatedAppliedFilters);
        handleFilterUpdate(filterToUpdate, prevFilters, modifiedFilters, appliedFilters, updatedAppliedFilters);
        setFilters(prevFilters.map((filter)=>{
            if (filter.key === filterKey) return {
                ...filter,
                isActive: !filter.isActive || filter.isDefault,
                options: filter.options.map((option)=>({
                        ...option,
                        isChecked: false
                    }))
            };
            return filter;
        }));
    };
    const clearDropDownFilters = ()=>{
        setFilters((prev)=>prev.map((filter)=>({
                    ...filter,
                    options: filter.options.map((option)=>({
                            ...option,
                            isChecked: false
                        }))
                })));
        setAppliedFilters([]);
        dispatch((0, $d623f23401a154f0$export$fa25dca28252b044)(true));
    };
    const resetFilters = ()=>{
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
        setIsClearBtnDisabled(true);
        dispatch((0, $d623f23401a154f0$export$a38f157fd98f0bab)(true));
        dispatch((0, $d623f23401a154f0$export$fa25dca28252b044)(true));
        dispatch((0, $d623f23401a154f0$export$5ef35f45efc10503)()).then((response)=>{
            if (response && certKey) {
                dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $36b8d1366c64b9c7$export$cfb9e92ff3cd43f4), 0, searchText));
                clearDropDownFilters();
                setShowBadgeOnFilterButton(false);
                dispatch((0, $d623f23401a154f0$export$3afc30d9c2fc6ef)("UPDATE_PERSONALIZATION"));
            }
        }).finally(()=>{
            setIsClearBtnDisabled(false);
        });
    };
    (0, $hopDi$useEffect)(()=>{
        if (!isClearBtnDisabled && triggerClearBtnForFilters) {
            resetFilters();
            dispatch((0, $d623f23401a154f0$export$86d11b633a5d59e6)(false));
        }
    }, [
        triggerClearBtnForFilters
    ]);
    const personalizedMultiMenuChange = (originalFilters, personalisedFilters)=>{
        const updatedAppliedFilters = [];
        let modifiedFilters = originalFilters.map((filter)=>({
                ...filter,
                isActive: personalizedAdvancedFilters.some((f)=>f.key === filter.key),
                options: filter.options.map((option)=>({
                        ...option,
                        isChecked: personalisedFilters.some((selectedOption)=>filter.key === selectedOption.key && selectedOption.value === option.value)
                    }))
            }));
        const activeFilters = modifiedFilters.filter((filter)=>filter.isActive);
        const inactiveFilters = modifiedFilters.filter((filter)=>!filter.isActive);
        // If active filters are fewer than 4
        if (activeFilters.length < 4) {
            const originalActiveFilters = originalFilters.filter((filter)=>filter.isActive && !activeFilters.some((af)=>af.key === filter.key));
            // Filters to add from the original set (excluding already active ones)
            const additionalFiltersNeeded = 4 - activeFilters.length;
            const additionalFilters = originalActiveFilters.slice(0, additionalFiltersNeeded);
            const finalizedFilters = [
                ...activeFilters,
                ...additionalFilters.map((filter)=>({
                        ...filter,
                        isActive: true
                    })),
                ...inactiveFilters.filter((filter)=>!additionalFilters.some((af)=>af.key === filter.key))
            ];
            modifiedFilters = finalizedFilters;
        }
        // Sort so active filters come first
        modifiedFilters = modifiedFilters.sort((a, b)=>b.isActive - a.isActive);
        modifiedFilters.forEach((filter)=>{
            const _selectedOptions = filter.options.filter((option)=>option.isChecked === true).map((option)=>({
                    key: filter.key,
                    ...option
                }));
            updatedAppliedFilters.push(..._selectedOptions);
        });
        const filterToUpdate = (0, $809c6fe4b590ebad$export$1bae5911fd45fa82)(appliedFilters, updatedAppliedFilters);
        handleFilterUpdate(filterToUpdate, originalFilters, modifiedFilters, appliedFilters, updatedAppliedFilters);
    };
    (0, $hopDi$useEffect)(()=>{
        if (filters?.length && personalization?.personalizedData?.response === "Success") setPersonalizedDataLoaded(true);
    }, [
        filters,
        personalizedAdvancedFilters,
        personalizedRowsFilters
    ]);
    const onFiltersUpdate = ()=>{
        if (!personalizedDataLoaded) return;
        const applyFilters = (filtersToApply)=>{
            personalizedMultiMenuChange(filters, filtersToApply);
        };
        if (personalizationViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW) applyFilters([]);
        else {
            const personalizedFiltersExist = (0, $c647e77118d4a3ed$export$fb9eaa94f2a46736)(filters, personalizedAdvancedFilters);
            if (personalizedFiltersExist) {
                applyFilters(personalizedAdvancedFilters);
                dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                    advancedFilters: true
                }));
            } else {
                dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
                    view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                    applied: false
                }));
                dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                    advancedFilters: false
                }));
            }
        }
    };
    (0, $hopDi$useEffect)(()=>{
        onFiltersUpdate();
    }, [
        personalizedDataLoaded,
        personalizationViewOption,
        dispatch
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (clearCurrentPersonalization) onFiltersUpdate();
    }, [
        clearCurrentPersonalization
    ]);
    const shouldShowClearAllBtn = Boolean(appliedFilters.length > 0 || isSmartFilterApplied || isSaviActionsApplied);
    // Additional functionality for devices <600px width
    const [firstStep, setFirstStep] = (0, $hopDi$useState)(true);
    const [step2FilterKey, setStep2FilterKey] = (0, $hopDi$useState)("");
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = (0, $hopDi$useState)(false);
    const drawerRef = (0, $hopDi$useRef)();
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mobileXlargeQuery.value <= mediaQueryValue;
    (0, $hopDi$useEffect)(()=>{
        setShowFilterBar(false);
        setFirstStep(true);
    }, [
        mediaQueryValue
    ]);
    const mobileDrawerFirstSegmentClass = (0, $hopDi$classnames)("AdvancedFilters-filterDrawerSegments", "AdvancedFilters-filterDrawerSegmentsStep1", !firstStep && "AdvancedFilters-filterDrawerSegmentsStep1--transtioned");
    const mobileDrawerSecondSegmentClass = (0, $hopDi$classnames)("AdvancedFilters-filterDrawerSegments", "AdvancedFilters-filterDrawerSegmentsStep2", !firstStep && "AdvancedFilters-filterDrawerSegmentsStep2--transtioned");
    const handleFilterDrawerClose = ()=>{
        setTimeout(()=>setFirstStep(true), (0, $36b8d1366c64b9c7$export$7774877bdb857c73));
        drawerRef.current.closeDrawer();
    };
    const handleStep2Configuration = (key)=>{
        setStep2FilterKey(key);
        setFirstStep(false);
    };
    const renderMobileResponsiveHeaderStep1 = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "AdvancedFilters-filterDrawerHeader",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                    size: "medium",
                    kind: "ghost",
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: firstStep ? "Close" : "ChevronLeft"
                    }),
                    onClick: ()=>handleFilterDrawerClose()
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "AdvancedFilters-filterDrawerHeaderTitle",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Filter"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            children: "Filter"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "AdvancedFilters-linkBtnWrapper--mobile",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                        text: "Clear All",
                        kind: "button",
                        onClick: ()=>{
                            resetFilters();
                            handleFilterDrawerClose();
                        },
                        isDisabled: isClearBtnDisabled || !shouldShowClearAllBtn
                    })
                })
            ]
        });
    const renderMobileResponsiveStep1Body = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: // eslint-disable-next-line no-restricted-globals
            !isNaN(totalItems) ? "AdvancedFilters-filterDrawerBodyStep1" : "AdvancedFilters-filterDrawerBodyStep1--withFullBodyHeight",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                    className: "AdvancedFilters-filterDrawerBodyStep1MenuItems",
                    onClick: ()=>handleStep2Configuration((0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SMART_FILTER),
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            kind: isSmartFilterApplied ? "body2-bold" : "body2",
                            mobile: isSmartFilterApplied ? "body2-bold-m" : "body2-m",
                            className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsText--noFilterApplied",
                            children: [
                                "Smart Filters",
                                isSmartFilterApplied && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                                    kind: "dot",
                                    color: "primary",
                                    size: "small",
                                    className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsTextBadge"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "ChevronRight",
                            size: "smallMedium"
                        })
                    ]
                }),
                isSaviEnabled && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                    className: "AdvancedFilters-filterDrawerBodyStep1MenuItems",
                    onClick: ()=>handleStep2Configuration((0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SAVI_FILTER),
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            kind: isSaviActionsApplied ? "body2-bold" : "body2",
                            mobile: isSaviActionsApplied ? "body2-bold-m" : "body2-m",
                            className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsText--noFilterApplied",
                            children: [
                                "Savi Filters",
                                isSaviActionsApplied && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                                    kind: "dot",
                                    color: "primary",
                                    size: "small",
                                    className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsTextBadge"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "ChevronRight",
                            size: "smallMedium"
                        })
                    ]
                }),
                filters?.sort((a, b)=>b.isCustom - a.isCustom || b.isActive - a.isActive || a.label.toLowerCase().localeCompare(b.label.toLowerCase()))?.map((filter)=>{
                    if (filter?.isActive) {
                        const countOfCheckedOptions = filter?.options?.filter((option)=>option?.isChecked)?.length;
                        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                            className: "AdvancedFilters-filterDrawerBodyStep1MenuItems",
                            onClick: ()=>handleStep2Configuration(filter.key),
                            children: [
                                countOfCheckedOptions === 0 && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            mobile: "body2-m",
                                            className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsText--noFilterApplied",
                                            children: filter.label
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "ChevronRight",
                                            size: "smallMedium"
                                        })
                                    ]
                                }),
                                countOfCheckedOptions > 0 && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                            tag: "div",
                                            className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsWrapper",
                                            children: [
                                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                                    tag: "div",
                                                    className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsWrapper--filterApplied",
                                                    children: [
                                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                            kind: "body2-bold",
                                                            mobile: "body2-bold-m",
                                                            className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsText--filterApplied",
                                                            children: filter.label
                                                        }),
                                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                                                            kind: "number",
                                                            number: countOfCheckedOptions,
                                                            color: "primary",
                                                            size: "small"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                                    tag: "div",
                                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                        kind: "body3",
                                                        mobile: "body3-m",
                                                        className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsText--optionsSelected",
                                                        children: filter?.options?.filter((option)=>option?.isChecked).map((option)=>option?.label).join(", ")
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "ChevronRight",
                                            size: "smallMedium"
                                        })
                                    ]
                                })
                            ]
                        }, filter.key);
                    }
                    return null;
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonCore), {
                    className: "AdvancedFilters-filterDrawerBodyStep1MenuItems",
                    onClick: ()=>handleStep2Configuration((0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).ADD_FILTER),
                    children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                        kind: "body2",
                        mobile: "body2-m",
                        className: "AdvancedFilters-filterDrawerBodyStep1MenuItemsText--noFilterApplied",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "Add",
                                size: "medium",
                                color: "navy-900"
                            }),
                            "Add Filter"
                        ]
                    })
                })
            ]
        });
    const renderMobileResponsiveHeaderStep2 = ()=>{
        let targetFilter = filters.find((filter)=>filter.key === step2FilterKey);
        if (step2FilterKey === (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SMART_FILTER) targetFilter = {
            label: "Smart Filters",
            appliedTo: ""
        };
        if (step2FilterKey === (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SAVI_FILTER) targetFilter = {
            label: "Savi Filters",
            appliedTo: ""
        };
        const shouldShowKebabMenu = Boolean(step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).ADD_FILTER);
        return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "AdvancedFilters-filterDrawerHeader",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                    size: "medium",
                    kind: "ghost",
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "ChevronLeft"
                    }),
                    onClick: ()=>{
                        setFirstStep(true);
                        setStep2FilterKey("");
                    }
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    // TODO: use classnames
                    className: shouldShowKebabMenu ? "AdvancedFilters-filterDrawerHeaderTitle--focused" : "AdvancedFilters-filterDrawerHeaderTitle",
                    children: shouldShowKebabMenu ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                children: targetFilter?.label || " "
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                                kind: "body3",
                                children: [
                                    targetFilter?.appliedTo.split(":")[0] || " ",
                                    step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SMART_FILTER && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SAVI_FILTER ? ": " : null,
                                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                        className: "AdvancedFilters-filterDrawerHeaderTitleAppliedTo--categories",
                                        children: targetFilter?.appliedTo.split(":")[1] || " "
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "Add"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                children: "Add Filter"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "AdvancedFilters-linkBtnWrapper--mobile",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        onClick: shouldShowKebabMenu ? ()=>setIsMobileDrawerOpen(true) : ()=>handleFilterDrawerClose(),
                        icon: shouldShowKebabMenu ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "MoreVertical",
                            color: "neutral-1000",
                            size: "smallMedium"
                        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Close"
                        })
                    })
                })
            ]
        });
    };
    const renderMobileResponsiveStep2Body = ()=>{
        // eslint-disable-next-line no-restricted-globals
        const isMobileResponsiveFooterRendered = !isNaN(totalItems);
        if (step2FilterKey === (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).ADD_FILTER) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "AdvancedFilters-filterDrawerBodyStep2--withFullBodyHeight",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e755bfdd37ca2612$export$2e2bcd8739ae039), {
                showFilterBar: showFilterBar,
                isDropDownMenuOpen: isDropDownMenuOpen,
                headingDescription: "Add or Remove Filters",
                placeholder: "Search",
                filters: filters,
                setFilters: setFilters,
                appliedFilters: appliedFilters,
                setAppliedFilters: setAppliedFilters,
                dropdownMenuPositionToRight: dropdownMenuPositionToRight,
                filterListWrapRef: filterListWrapRef,
                handleRemoveFilter: handleRemoveFilter,
                isMobileResponsivenessEnabled: true
            })
        });
        if (step2FilterKey === (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SMART_FILTER) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            // TODO: use classnames
            className: isMobileResponsiveFooterRendered ? "AdvancedFilters-filterDrawerBodyStep2" : "AdvancedFilters-filterDrawerBodyStep2--withFullBodyHeight",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $1bd36db49effb408$export$2e2bcd8739ae039), {
                handleChange: handleMultiMenuChange,
                setShowBadgeOnFilterButton: setShowBadgeOnFilterButton,
                clearDropDownFilters: clearDropDownFilters,
                setIsSmartFilterApplied: setIsSmartFilterApplied,
                isMobileDrawerOpen: isMobileDrawerOpen,
                setIsMobileDrawerOpen: setIsMobileDrawerOpen,
                isMobileResponsivenessEnabled: true
            })
        });
        if (step2FilterKey === (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SAVI_FILTER) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            // TODO: use classnames
            className: isMobileResponsiveFooterRendered ? "AdvancedFilters-filterDrawerBodyStep2" : "AdvancedFilters-filterDrawerBodyStep2--withFullBodyHeight",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $ffc97a672f354fdb$export$2e2bcd8739ae039), {
                setIsSaviActionsApplied: setIsSaviActionsApplied,
                isSmartFilterApplied: isSmartFilterApplied,
                isMobileDrawerOpen: isMobileDrawerOpen,
                setIsMobileDrawerOpen: setIsMobileDrawerOpen,
                isMobileResponsivenessEnabled: true
            })
        });
        if (step2FilterKey !== "") {
            const targetFilter = filters.find((filter)=>filter.key === step2FilterKey);
            return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                // TODO: use classnames
                className: isMobileResponsiveFooterRendered ? "AdvancedFilters-filterDrawerBodyStep2" : "AdvancedFilters-filterDrawerBodyStep2--withFullBodyHeight",
                children: targetFilter?.isCustom ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $5b67af4e24cf2d4e$export$2e2bcd8739ae039), {
                    filter: targetFilter,
                    setFilters: setFilters,
                    handleRemoveFilter: handleRemoveFilter,
                    setPersonalizationStatus: (0, $d623f23401a154f0$export$3afc30d9c2fc6ef),
                    handleMultiMenuChange: handleMultiMenuChange,
                    countOfCheckedOptions: 0,
                    isMobileResponsivenessEnabled: true
                }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $877a89fa7e3a8479$export$2e2bcd8739ae039), {
                    filter: targetFilter,
                    handleRemoveFilter: handleRemoveFilter,
                    setPersonalizationStatus: (0, $d623f23401a154f0$export$3afc30d9c2fc6ef),
                    handleMultiMenuChange: handleMultiMenuChange,
                    certKey: certKey,
                    countOfCheckedOptions: 0,
                    updateFiltersAfterSearch: updateFiltersAfterSearch,
                    isFilterOpen: !firstStep,
                    isMobileResponsivenessEnabled: true
                })
            });
        }
        return null;
    };
    const renderMobileResponsiveFooter = ()=>{
        const shouldRenderResponsiveFooter = Boolean(// eslint-disable-next-line no-restricted-globals
        !isNaN(totalItems) && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).ADD_FILTER);
        if (shouldRenderResponsiveFooter) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "AdvancedFilters-filterDrawerFooter",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "filled",
                size: "medium",
                isLoading: isClearBtnDisabled || isLoading,
                isDisabled: isClearBtnDisabled || isLoading,
                onClick: ()=>handleFilterDrawerClose(),
                children: `See Results (${totalItems})`
            })
        });
        return null;
    };
    const handleMobileClearBtnClick = (targetFilter)=>{
        if (!firstStep && isMobileDrawerOpen && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).ADD_FILTER && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SMART_FILTER && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SAVI_FILTER) {
            handleMultiMenuChange(targetFilter.key, []);
            dispatch((0, $d623f23401a154f0$export$3afc30d9c2fc6ef)("UPDATE_PERSONALIZATION"));
            dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
            setIsMobileDrawerOpen(false);
        }
    };
    const handleMobileRemoveBtnClick = (targetFilter)=>{
        handleRemoveFilter(targetFilter.key);
        setIsMobileDrawerOpen(false);
        setFirstStep(true);
    };
    const renderClearBtnsForMobile = ()=>{
        const shouldRenderClearBtns = Boolean(isMobileDrawerOpen && !firstStep && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).ADD_FILTER && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SMART_FILTER && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SAVI_FILTER);
        const shouldRenderRemoveBtn = Boolean(step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).ADD_FILTER && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SMART_FILTER && step2FilterKey !== (0, $36b8d1366c64b9c7$export$5eda0606e22cfdcb).SAVI_FILTER && step2FilterKey !== "CERTIFIED");
        const targetFilter = filters.find((filter)=>filter.key === step2FilterKey);
        const shouldDisableCLearBtn = Boolean(!targetFilter?.options?.some((option)=>option.isChecked) || isClearBtnDisabled);
        return shouldRenderClearBtns && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
            isOpen: shouldRenderClearBtns,
            setIsOpen: setIsMobileDrawerOpen,
            isSwipeEnabled: true,
            content: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    shouldRenderRemoveBtn && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        onClick: ()=>handleMobileRemoveBtnClick(targetFilter),
                        className: "AdvancedFilters-filterDrawerClearAndRemoveBtns",
                        children: "Remove Filter"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        isDisabled: shouldDisableCLearBtn,
                        onClick: ()=>handleMobileClearBtnClick(targetFilter),
                        className: "AdvancedFilters-filterDrawerClearAndRemoveBtns",
                        children: "Clear Filter"
                    })
                ]
            })
        });
    };
    if (isMobileWidth && showFilterBar) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
        isOpen: showFilterBar,
        setIsOpen: setShowFilterBar,
        fixedHeight: 32,
        ref: drawerRef,
        isOutsideClickEnabled: !isMobileDrawerOpen,
        className: "AdvancedFilters-filterDrawer",
        content: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: mobileDrawerFirstSegmentClass,
                    children: [
                        renderMobileResponsiveHeaderStep1(),
                        renderMobileResponsiveStep1Body(),
                        renderMobileResponsiveFooter()
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: mobileDrawerSecondSegmentClass,
                    children: [
                        renderMobileResponsiveHeaderStep2(),
                        renderMobileResponsiveStep2Body(),
                        renderMobileResponsiveFooter(),
                        renderClearBtnsForMobile()
                    ]
                })
            ]
        })
    });
    // Segment ends here
    // For devices above 600px width
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        id: "certsAdvancedFilters",
        className: advancedFiltersClasses,
        ref: filterBarRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $1bd36db49effb408$export$2e2bcd8739ae039), {
                handleChange: handleMultiMenuChange,
                setShowBadgeOnFilterButton: setShowBadgeOnFilterButton,
                clearDropDownFilters: clearDropDownFilters,
                setIsSmartFilterApplied: setIsSmartFilterApplied
            }),
            isSaviEnabled && /*#__PURE__*/ (0, $hopDi$jsx)((0, $ffc97a672f354fdb$export$2e2bcd8739ae039), {
                setIsSaviActionsApplied: setIsSaviActionsApplied,
                isSmartFilterApplied: isSmartFilterApplied
            }),
            filters?.filter((filter)=>filter?.isCustom)?.sort((a, b)=>b.isActive - a.isActive || a.label.toLowerCase().localeCompare(b.label.toLowerCase()))?.map((filter)=>{
                if (filter?.isActive) {
                    const countOfCheckedOptions = filter?.options?.filter((option)=>option?.isChecked)?.length;
                    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $5b67af4e24cf2d4e$export$2e2bcd8739ae039), {
                        filter: filter,
                        handleRemoveFilter: handleRemoveFilter,
                        setPersonalizationStatus: (0, $d623f23401a154f0$export$3afc30d9c2fc6ef),
                        handleMultiMenuChange: handleMultiMenuChange,
                        countOfCheckedOptions: countOfCheckedOptions
                    }, filter.key);
                }
                return null;
            }),
            filters?.filter((filter)=>!filter?.isCustom)?.sort((a, b)=>b.isActive - a.isActive || a.label.toLowerCase().localeCompare(b.label.toLowerCase()))?.map((filter)=>{
                if (filter?.isActive) {
                    const countOfCheckedOptions = filter?.options?.filter((option)=>option?.isChecked)?.length;
                    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $877a89fa7e3a8479$export$2e2bcd8739ae039), {
                        filter: filter,
                        handleRemoveFilter: handleRemoveFilter,
                        setPersonalizationStatus: (0, $d623f23401a154f0$export$3afc30d9c2fc6ef),
                        handleMultiMenuChange: handleMultiMenuChange,
                        certKey: certKey,
                        countOfCheckedOptions: countOfCheckedOptions,
                        updateFiltersAfterSearch: updateFiltersAfterSearch
                    }, filter.key);
                }
                return null;
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                ref: dropDownWrapperRef,
                className: "AdvancedFilters-filterBarDropDownWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "outlinedNeutral",
                        isSelected: isDropDownMenuOpen,
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "add",
                            color: "neutral-1000"
                        }),
                        onClick: ()=>{
                            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(filterListWrapRef, 0);
                            setIsDropDownMenuOpen(!isDropDownMenuOpen);
                        }
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $e755bfdd37ca2612$export$2e2bcd8739ae039), {
                        showFilterBar: showFilterBar,
                        isDropDownMenuOpen: isDropDownMenuOpen,
                        headingDescription: "Add or Remove Filters",
                        placeholder: "Search",
                        filters: filters,
                        setFilters: setFilters,
                        appliedFilters: appliedFilters,
                        setAppliedFilters: setAppliedFilters,
                        dropdownMenuPositionToRight: dropdownMenuPositionToRight,
                        filterListWrapRef: filterListWrapRef,
                        handleRemoveFilter: handleRemoveFilter
                    })
                ]
            }),
            shouldShowClearAllBtn && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "AdvancedFilters-linkBtnWrapper",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                    text: "Clear",
                    kind: "button",
                    onClick: resetFilters,
                    isDisabled: isClearBtnDisabled
                })
            })
        ]
    });
}
$9080a8ca19badea3$var$AdvancedFilters.propTypes = {
    setShowBadgeOnFilterButton: (0, $hopDi$proptypes).func.isRequired,
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    setShowFilterBar: (0, $hopDi$proptypes).func.isRequired,
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setFilters: (0, $hopDi$proptypes).func.isRequired,
    appliedFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setAppliedFilters: (0, $hopDi$proptypes).func.isRequired,
    filterBarRef: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).func,
        (0, $hopDi$proptypes).shape({
            current: (0, $hopDi$proptypes).instanceOf(Element)
        })
    ])
};
$9080a8ca19badea3$var$AdvancedFilters.defaultProps = {
    filterBarRef: null
};
var $9080a8ca19badea3$export$2e2bcd8739ae039 = $9080a8ca19badea3$var$AdvancedFilters;










const $ddbc2f861c0388ff$export$98aa68d7c06704e9 = {
    ACCESSTHROUGH: (0, $hopDi$proptypes).string,
    AUDIT_TRAIL: (0, $hopDi$proptypes).string,
    CERTIFIED: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).number,
        (0, $hopDi$proptypes).string
    ]),
    CERT_ACCOUNTKEY: (0, $hopDi$proptypes).string,
    CERT_ENTITLEMENT_VALUEKEY: (0, $hopDi$proptypes).string,
    CERT_ROLEKEY: (0, $hopDi$proptypes).string,
    CERT_USERKEY: (0, $hopDi$proptypes).string,
    COMMENTS: (0, $hopDi$proptypes).string,
    ENDPOINT: (0, $hopDi$proptypes).string,
    ENTITLEMENTTYPE: (0, $hopDi$proptypes).string,
    ENTITLEMENT_VALUE: (0, $hopDi$proptypes).string,
    Ent_DESCRIPTION: (0, $hopDi$proptypes).string,
    Ent_DISPLAYNAME: (0, $hopDi$proptypes).string,
    Ent_ENTITLEMENT_GLOSSARY: (0, $hopDi$proptypes).string,
    Ent_PRIVILIGED: (0, $hopDi$proptypes).string,
    LASTCERTIFIED: (0, $hopDi$proptypes).string,
    LASTCERTIFIEDCAMPAIGNNAME: (0, $hopDi$proptypes).string,
    LASTCERTIFIEDUSER: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).number,
        (0, $hopDi$proptypes).string
    ]),
    availableAction: (0, $hopDi$proptypes).shape({
        approve: (0, $hopDi$proptypes).string,
        conditionalCertifiy: (0, $hopDi$proptypes).string,
        consult: (0, $hopDi$proptypes).string,
        reassign: (0, $hopDi$proptypes).string,
        reject: (0, $hopDi$proptypes).string
    }),
    enableAction: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    id: (0, $hopDi$proptypes).string,
    isConsulted: (0, $hopDi$proptypes).bool,
    tracker: (0, $hopDi$proptypes).shape({
        actions: (0, $hopDi$proptypes).objectOf((0, $hopDi$proptypes).shape({
            isSelected: (0, $hopDi$proptypes).bool,
            isLoading: (0, $hopDi$proptypes).bool
        })),
        id: (0, $hopDi$proptypes).string,
        isChecked: (0, $hopDi$proptypes).bool,
        isConnected: (0, $hopDi$proptypes).bool,
        level: (0, $hopDi$proptypes).number
    })
};
const $ddbc2f861c0388ff$export$82933e461ce879a9 = {
    isIncludeAssociatedEnt: (0, $hopDi$proptypes).bool.isRequired,
    isNoteRequired: (0, $hopDi$proptypes).bool.isRequired,
    noteText: (0, $hopDi$proptypes).string.isRequired,
    isIncludeAsscLabel: (0, $hopDi$proptypes).string.isRequired,
    lineItemKind: (0, $hopDi$proptypes).string.isRequired
};
const $ddbc2f861c0388ff$export$f9baae1e9d6bf8f = {
    certKey: (0, $hopDi$proptypes).string,
    userKey: (0, $hopDi$proptypes).string,
    status: (0, $hopDi$proptypes).string
};
const $ddbc2f861c0388ff$export$31c513300d132daf = (0, $hopDi$proptypes).shape({
    cert_userkey: (0, $hopDi$proptypes).string,
    cert_accountkey: (0, $hopDi$proptypes).string,
    status: (0, $hopDi$proptypes).string,
    type: (0, $hopDi$proptypes).string,
    username: (0, $hopDi$proptypes).string,
    userDisplayName: (0, $hopDi$proptypes).string,
    accountDisplayName: (0, $hopDi$proptypes).string,
    childName: (0, $hopDi$proptypes).string
});
const $ddbc2f861c0388ff$export$79819249befb86e5 = {
    defaultReassignee: (0, $hopDi$proptypes).string,
    defaultReassigneeName: (0, $hopDi$proptypes).string,
    enableIndividualCommentsForAccountEntitlementRoles: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    enableIndividualCommentsForUsers: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    enableReassignStep2: (0, $hopDi$proptypes).string,
    enableReassignUser: (0, $hopDi$proptypes).string,
    showReassignPopup: (0, $hopDi$proptypes).string
};
const $ddbc2f861c0388ff$export$b3d0e07d10e0d289 = (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
    label: (0, $hopDi$proptypes).string.isRequired,
    value: (0, $hopDi$proptypes).string.isRequired,
    options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).string,
        value: (0, $hopDi$proptypes).string,
        isChecked: (0, $hopDi$proptypes).bool.isRequired
    }))
}));
const $ddbc2f861c0388ff$export$d1649ee5b4635363 = (0, $hopDi$proptypes).shape({
    USER: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    ACCOUNT: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    ROLE: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    ENTITLEMENT: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string)
});


const $5630dd438c9b44f6$export$aeca2bf7951e0a69 = 10;
const $5630dd438c9b44f6$export$3231e969238304f3 = 0;
const $5630dd438c9b44f6$export$5697dc8441956872 = 34;
const $5630dd438c9b44f6$export$891b7fe69ec4a05c = {
    DEFAULT: "default",
    NO_LABEL: "no-label",
    INSIDE_MORE: "inside-more"
};
const $5630dd438c9b44f6$export$689ae8298085ebf = {
    SAVI: "Copilot",
    FILTER: "Filters",
    GROUP_BY: "Group By",
    ROWS: "Rows",
    COLUMNS: "Columns",
    SORT: "Sort",
    MORE: "More"
};
const $5630dd438c9b44f6$export$5fc0ac5e0be84463 = [
    {
        id: $5630dd438c9b44f6$export$689ae8298085ebf.SAVI,
        isVisible: true,
        shouldRender: false
    },
    {
        id: $5630dd438c9b44f6$export$689ae8298085ebf.FILTER,
        isVisible: true,
        shouldRender: true
    },
    {
        id: $5630dd438c9b44f6$export$689ae8298085ebf.GROUP_BY,
        isVisible: true,
        // Group By is only a placeholder so it should not render
        shouldRender: false
    },
    {
        id: $5630dd438c9b44f6$export$689ae8298085ebf.ROWS,
        isVisible: true,
        shouldRender: true
    },
    {
        id: $5630dd438c9b44f6$export$689ae8298085ebf.COLUMNS,
        isVisible: true,
        shouldRender: true
    },
    {
        id: $5630dd438c9b44f6$export$689ae8298085ebf.SORT,
        isVisible: true,
        shouldRender: false
    },
    {
        id: $5630dd438c9b44f6$export$689ae8298085ebf.MORE,
        isVisible: false
    }
];


















const $a23cd229b9113926$export$7774877bdb857c73 = 200;
const $a23cd229b9113926$export$ad084766e7fbe946 = 5;
const $a23cd229b9113926$export$be14771196440103 = {
    count: 0
};
const $a23cd229b9113926$export$c2fd574cc3b8c823 = "User";
const $a23cd229b9113926$export$c97501b522a7bf89 = "Role";
const $a23cd229b9113926$export$eeb9092565ce426a = "Account";
const $a23cd229b9113926$export$7d1f9b2b2a057886 = "Entitlement";
const $a23cd229b9113926$export$128908aadf8e4646 = [
    $a23cd229b9113926$export$c2fd574cc3b8c823,
    $a23cd229b9113926$export$eeb9092565ce426a,
    $a23cd229b9113926$export$7d1f9b2b2a057886,
    $a23cd229b9113926$export$c97501b522a7bf89
];
const $a23cd229b9113926$export$50fc35c85d3a3c9d = "User_DISPLAYNAME";
const $a23cd229b9113926$export$1772b047bb5ee9a = "Role_DISPLAYNAME";
const $a23cd229b9113926$export$e7e5437fabb30374 = "Account_DISPLAYNAME";
const $a23cd229b9113926$export$1b550718072cac3f = "Ent_DISPLAYNAME";
const $a23cd229b9113926$export$3d372a4d90e6e43c = [
    `${$a23cd229b9113926$export$c2fd574cc3b8c823.toUpperCase()}-${$a23cd229b9113926$export$50fc35c85d3a3c9d}`,
    `${$a23cd229b9113926$export$eeb9092565ce426a.toUpperCase()}-${$a23cd229b9113926$export$e7e5437fabb30374}`,
    `${$a23cd229b9113926$export$7d1f9b2b2a057886.toUpperCase()}-${$a23cd229b9113926$export$1b550718072cac3f}`,
    `${$a23cd229b9113926$export$c97501b522a7bf89.toUpperCase()}-${$a23cd229b9113926$export$1772b047bb5ee9a}`
];



const $5ed7a2f47bdaa9df$export$ed9a82d791c0007b = (obj)=>{
    const checkedOptions = {};
    obj.forEach((filter)=>{
        checkedOptions[filter.value] = [];
        filter.options.forEach((option)=>{
            if (option.isChecked === true) checkedOptions[filter.value].push(option.value);
        });
    });
    return checkedOptions;
};
const $5ed7a2f47bdaa9df$var$reCreateColOptions = (options, key)=>{
    const tempOptions = [];
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for(const optionKey in options)tempOptions.push({
        label: `${options[optionKey]}`,
        value: `${key}-${optionKey}`,
        isChecked: true
    });
    return tempOptions;
};
const $5ed7a2f47bdaa9df$export$c219b8879429123c = (filters, allowedFilters = [])=>{
    const tempColFilters = [];
    // eslint-disable-next-line no-restricted-syntax
    for(const key in filters)if (Object.prototype.hasOwnProperty.call(filters, key)) {
        let isDisabled = false;
        const options = $5ed7a2f47bdaa9df$var$reCreateColOptions(filters[key], key.toUpperCase());
        if (key === (0, $a23cd229b9113926$export$c2fd574cc3b8c823) && !allowedFilters.includes((0, $6d218ab9b83faef2$export$e99ca72b1ac3fcd6))) isDisabled = true;
        if (key === (0, $a23cd229b9113926$export$c97501b522a7bf89) && !allowedFilters.includes((0, $6d218ab9b83faef2$export$33e5df6437060fe4))) isDisabled = true;
        if (key === (0, $a23cd229b9113926$export$eeb9092565ce426a) && !allowedFilters.includes((0, $6d218ab9b83faef2$export$67904de277d10d08))) isDisabled = true;
        if (key === (0, $a23cd229b9113926$export$7d1f9b2b2a057886) && !allowedFilters.includes((0, $6d218ab9b83faef2$export$28401dcfd55adaaa))) isDisabled = true;
        tempColFilters.push({
            label: `${key}`,
            value: `${key.toUpperCase()}`,
            isDisabled: isDisabled,
            options: options
        });
    }
    return tempColFilters.sort((a, b)=>(0, $a23cd229b9113926$export$128908aadf8e4646).indexOf(a.label) - (0, $a23cd229b9113926$export$128908aadf8e4646).indexOf(b.label));
};



const $1b64cfc1069de672$var$MIN_COUNT_FOR_TOOLTIP = 30;
const $1b64cfc1069de672$var$TOOLTIP_DELAY_IN_MS_TILE = 500;
function $1b64cfc1069de672$var$ColumnsFilter({ isInMore: isInMore, colFilters: colFilters, setColFilters: setColFilters, setAppliedColFilters: setAppliedColFilters, appliedColFilters: appliedColFilters, isButtonKindIcon: isButtonKindIcon, setIsDraggingDndItem: setIsDraggingDndItem }) {
    const [showbadgeOnColButton, setShowbadgeOnColButton] = (0, $hopDi$useState)(false);
    const [activeTab, setActiveTab] = (0, $hopDi$useState)("USER");
    const [draggingItemId, setDraggingItemId] = (0, $hopDi$useState)(null);
    const [draggingItemScrollAmount, setDraggingItemScrollAmount] = (0, $hopDi$useState)(0);
    const menuRef = (0, $hopDi$useRef)(null);
    const dropDownBodyRef = (0, $hopDi$useRef)(null);
    const dispatch = (0, $hopDi$useDispatch)();
    const intl = (0, $hopDi$useIntl)();
    const activeFilterTab = colFilters.find((filter)=>!filter.isDisabled);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const { mediaQueryValue: mediaQueryValue, isLoading: isLoading, columnPickerList: columnPickerList, viewRowsList: viewRowsList, tabs: { tabData: tabData }, personalization: { personalizedData: personalizedData, viewOption: viewOption, clearCurrentPersonalization: clearCurrentPersonalization } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabData?.find((tab)=>tab.isActive)?.count;
    const personalizationViewOption = viewOption?.view;
    const personalizedColsFilters = personalizedData?.result?.info?.defaultView?.[0] ? personalizedData.result.info.defaultView[0].colsFilters : undefined;
    const tabletMediumQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$e1d684fb703347f));
    const isTabletMediumWidth = tabletMediumQuery.value <= mediaQueryValue;
    const handleActiveTab = (value)=>{
        if (value) {
            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(dropDownBodyRef, 0);
            setActiveTab(value);
        }
    };
    const handleChange = (optionValue)=>{
        const modifiedFilters = colFilters.map((filter)=>{
            const modifiedFilter = {
                ...filter,
                options: filter.options.map((option)=>{
                    if (option.value === optionValue) return {
                        ...option,
                        isChecked: !option.isChecked
                    };
                    return option;
                }).sort((a, b)=>b.isChecked - a.isChecked)
            };
            return modifiedFilter;
        });
        setColFilters(modifiedFilters);
        (0, $a23cd229b9113926$export$be14771196440103).count += 1;
        setAppliedColFilters((0, $5ed7a2f47bdaa9df$export$ed9a82d791c0007b)(modifiedFilters));
        dispatch((0, $d623f23401a154f0$export$3afc30d9c2fc6ef)("UPDATE_PERSONALIZATION"));
        dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
    };
    const reorderColFilterList = (srcIndex, destIndex, parentFilter)=>{
        const reorderedList = colFilters.map((filter)=>{
            if (filter.value === parentFilter) {
                const tempOptions = filter.options.filter((indexOption)=>!(0, $a23cd229b9113926$export$3d372a4d90e6e43c).includes(indexOption.value));
                const removedOption = tempOptions.splice(srcIndex, 1);
                const modifiedOptions = [
                    ...filter.options.filter((indexOption)=>(0, $a23cd229b9113926$export$3d372a4d90e6e43c).includes(indexOption.value)),
                    ...tempOptions.slice(0, destIndex),
                    ...removedOption,
                    ...tempOptions.slice(destIndex)
                ];
                return {
                    ...filter,
                    options: modifiedOptions.sort((a, b)=>b.isChecked - a.isChecked)
                };
            }
            return filter;
        });
        setColFilters(reorderedList);
        (0, $a23cd229b9113926$export$be14771196440103).count += 1;
        setAppliedColFilters((0, $5ed7a2f47bdaa9df$export$ed9a82d791c0007b)(reorderedList));
    };
    const onDragEnd = (result)=>{
        setDraggingItemId(null);
        setIsDraggingDndItem(false);
        if (!result.destination) return;
        reorderColFilterList(result.source.index, result.destination.index, result.destination.droppableId);
        dispatch((0, $d623f23401a154f0$export$3afc30d9c2fc6ef)("UPDATE_PERSONALIZATION"));
        dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
    };
    (0, $hopDi$useEffect)(()=>{
        const isAllPersonalisedColumnsExists = (0, $c647e77118d4a3ed$export$ca4f91cac1cf9ec9)(columnPickerList, personalizedColsFilters);
        if (isAllPersonalisedColumnsExists) {
            dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
                view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW,
                applied: true
            }));
            dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                columns: true
            }));
        } else {
            dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
                view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                applied: false
            }));
            dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                columns: false
            }));
        }
    }, [
        columnPickerList,
        personalizedColsFilters
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isTabletMediumWidth && menuRef && !isInMore) menuRef.current.closeDropdown();
    }, [
        isTabletMediumWidth
    ]);
    const onColumnsUpdate = ()=>{
        if (columnPickerList && viewRowsList) {
            const tempColFilters = (0, $5ed7a2f47bdaa9df$export$c219b8879429123c)(columnPickerList, viewRowsList);
            if (personalizedColsFilters && personalizationViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW) {
                if ((0, $c647e77118d4a3ed$export$ca4f91cac1cf9ec9)(columnPickerList, personalizedColsFilters)) {
                    (0, $c647e77118d4a3ed$export$9d52876f8c04c1dd)(tempColFilters, personalizedColsFilters);
                    dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                        columns: true
                    }));
                } else {
                    dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
                        view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                        applied: false
                    }));
                    dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                        columns: false
                    }));
                }
            }
            setColFilters(tempColFilters);
            setAppliedColFilters((0, $5ed7a2f47bdaa9df$export$ed9a82d791c0007b)(tempColFilters));
        }
    };
    (0, $hopDi$useEffect)(()=>{
        onColumnsUpdate();
    }, [
        columnPickerList,
        viewRowsList,
        personalizedColsFilters,
        personalizationViewOption
    ]);
    const mergeAndFlattenArraysByOrder = (data)=>{
        const keyOrder = [
            "USER",
            "ACCOUNT",
            "ENTITLEMENT",
            "ROLE"
        ];
        let mergedArray = [];
        keyOrder.forEach((key)=>{
            if (data[key]) mergedArray = mergedArray.concat(data[key]);
        });
        return mergedArray;
    };
    const isPersonalizedColumn = ()=>{
        if (personalizationViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW) return false;
        const personalized = personalizedColsFilters && mergeAndFlattenArraysByOrder(personalizedColsFilters);
        const applied = appliedColFilters && mergeAndFlattenArraysByOrder(appliedColFilters);
        const isLengthMatch = personalized?.length === applied?.length;
        if (isLengthMatch) {
            // eslint-disable-next-line no-plusplus
            for(let i = 0; i < personalized.length; i++){
                if (personalized[i] !== applied[i]) return false;
            }
            return true;
        }
        return false;
    };
    (0, $hopDi$useEffect)(()=>{
        if (clearCurrentPersonalization) onColumnsUpdate();
    }, [
        columnPickerList,
        viewRowsList,
        personalizedColsFilters,
        personalizationViewOption,
        clearCurrentPersonalization
    ]);
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$b551d76884371ba3)(appliedColFilters));
        setShowbadgeOnColButton((0, $a23cd229b9113926$export$be14771196440103).count > 0 || isPersonalizedColumn());
    }, [
        appliedColFilters
    ]);
    const getTabGroups = ()=>{
        const validTabsCount = colFilters?.reduce((acc, item)=>!item.isDisabled ? acc + 1 : acc, [
            0
        ]);
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabGroup), {
            value: activeTab,
            onChange: handleActiveTab,
            className: "ColumnsFilter-dropdownTabGroup",
            children: colFilters?.map((tab)=>{
                if (!tab.isDisabled) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    className: (0, $hopDi$classnames)(validTabsCount >= 3 && "ColumnsFilter-dropdownTabGroupTabItems"),
                    label: tab.label,
                    value: tab.value,
                    size: "medium"
                }, tab.value);
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {}, tab.value);
            })
        });
    };
    const getTooltipText = (option)=>{
        const optionLabel = messages[option?.label] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(option?.label?.split(".")[0]));
        return optionLabel?.length > $1b64cfc1069de672$var$MIN_COUNT_FOR_TOOLTIP ? optionLabel : null;
    };
    const getTooltipTrigger = (option)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
            kind: "body2",
            className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsCheckBoxText",
            lineLimit: 1,
            children: messages[option?.label] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(option?.label?.split(".")[0]))
        });
    const getDraggable = (option, index)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Draggable), {
            draggableId: `${option?.value}`,
            index: index,
            children: (draggableProvider)=>{
                const updatedDraggableProps = {
                    ...draggableProvider.draggableProps,
                    style: {
                        ...draggableProvider.draggableProps.style,
                        top: draggingItemId === option?.value ? index * 40 + 120 - draggingItemScrollAmount : 0,
                        left: 0
                    }
                };
                return /*#__PURE__*/ (0, $hopDi$createElement)("div", {
                    ref: draggableProvider.innerRef,
                    ...updatedDraggableProps,
                    key: option?.value,
                    className: "ColumnsFilter-dropDownBodyFilterListContainerSubItems",
                    children: [
                        option?.isChecked ? /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            ...draggableProvider.dragHandleProps,
                            className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsDragger",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                isPortalEnabled: true,
                                text: "Drag to Reorder",
                                trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "DragVertical",
                                    color: "neutral-1000",
                                    size: "smallMedium"
                                })
                            })
                        }) : /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                            ...draggableProvider.dragHandleProps,
                            className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsDraggerFiller"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("label", {
                            className: "ColumnsFilter-dropDownBodyFilterListContainerSubItemsCheckBox",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                    name: option?.value,
                                    kind: "base",
                                    showHoverEffect: false,
                                    dataTestId: "checkbox-no-hovereffect",
                                    isChecked: option?.isChecked,
                                    onChange: ()=>handleChange(option?.value)
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                    openDelay: $1b64cfc1069de672$var$TOOLTIP_DELAY_IN_MS_TILE,
                                    text: getTooltipText(option),
                                    maxWidth: "20rem",
                                    trigger: getTooltipTrigger(option)
                                })
                            ]
                        })
                    ]
                });
            }
        }, option?.value);
    const getColumnsFilter = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ColumnsFilter-dropDownBody",
            children: [
                getTabGroups(),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    ref: dropDownBodyRef,
                    className: "ColumnsFilter-dropDownScrollArea",
                    children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$DragDropContext), {
                        onDragStart: (initial)=>{
                            const scrollAmount = dropDownBodyRef?.current?.scrollTop || 0;
                            setDraggingItemId(initial.draggableId);
                            setDraggingItemScrollAmount(scrollAmount);
                            setIsDraggingDndItem(true);
                        },
                        onDragEnd: onDragEnd,
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "ColumnsFilter-dropDownBodyNote",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body3",
                                    children: "The number of visible attributes depends on the size of your browser and screen. Any attributes not shown are visible in the detailed view."
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "ColumnsFilter-dropDownBodyFilterList",
                                children: colFilters?.map((tab)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                                        value: activeTab,
                                        tabValue: tab?.value,
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Droppable), {
                                            droppableId: tab?.value,
                                            children: (droppableProvider, snapshot)=>{
                                                const style = snapshot.isDraggingOver ? {
                                                    pointerEvents: "none"
                                                } : {};
                                                return /*#__PURE__*/ (0, $hopDi$createElement)("div", {
                                                    ...droppableProvider.droppableProps,
                                                    ref: droppableProvider.innerRef,
                                                    className: "ColumnsFilter-dropDownBodyFilterListContainer",
                                                    key: tab?.value,
                                                    style: style,
                                                    children: [
                                                        tab?.options?.filter((indexOption)=>!(0, $a23cd229b9113926$export$3d372a4d90e6e43c).includes(indexOption?.value)).map((option, index)=>getDraggable(option, index)),
                                                        droppableProvider.placeholder
                                                    ]
                                                });
                                            }
                                        }, tab?.value)
                                    }, tab?.value))
                            })
                        ]
                    })
                })
            ]
        });
    if (isInMore) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Fragment), {
        children: getColumnsFilter()
    });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Menu), {
        ref: menuRef,
        CustomMenu: getColumnsFilter(),
        setIsExpanded: ()=>{
            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(dropDownBodyRef, 0);
            setActiveTab(activeFilterTab?.value ? activeFilterTab?.value : "0");
        },
        crossAxisOffset: isTabletMediumWidth ? -8 : 0,
        placement: "bottom-end",
        fallbackPlacements: [
            "bottom-start",
            "bottom"
        ],
        trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
            kind: isButtonKindIcon ? "rectangle" : "icon",
            label: "Columns",
            size: "medium",
            BadgeComp: showbadgeOnColButton ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                kind: "dot",
                color: "primary",
                size: "small"
            }) : null,
            prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "Columns",
                color: "neutral-600",
                size: "smallMedium"
            }),
            isDisabled: colFilters?.length === 0 || activeTabCount === 0 || isLoading,
            className: "ColumnsFilter-button"
        }),
        className: "ColumnsFilter"
    });
}
$1b64cfc1069de672$var$ColumnsFilter.propTypes = {
    isInMore: (0, $hopDi$proptypes).bool,
    colFilters: (0, $ddbc2f861c0388ff$export$b3d0e07d10e0d289),
    setColFilters: (0, $hopDi$proptypes).func.isRequired,
    setAppliedColFilters: (0, $hopDi$proptypes).func.isRequired,
    appliedColFilters: (0, $hopDi$proptypes).shape({}),
    isButtonKindIcon: (0, $hopDi$proptypes).bool,
    setIsDraggingDndItem: (0, $hopDi$proptypes).func.isRequired
};
$1b64cfc1069de672$var$ColumnsFilter.defaultProps = {
    isInMore: false,
    appliedColFilters: {},
    isButtonKindIcon: false,
    colFilters: []
};
var $1b64cfc1069de672$export$2e2bcd8739ae039 = $1b64cfc1069de672$var$ColumnsFilter;




// TODO: Savi in More drop down is still a WIP
// TODO: Group by in More drop down is still a WIP
// TODO: Sort in More drop down is still a WIP
function $f82331a2ea4ff183$var$CertsControlsMore({ options: options, setIsMoreOpen: setIsMoreOpen, showFilterBar: // Filter
showFilterBar, setShowFilterBar: setShowFilterBar, rowFilters: // Rows
rowFilters, appliedRowFilters: appliedRowFilters, setAppliedRowFilters: setAppliedRowFilters, colFilters: // Columns
colFilters, setColFilters: setColFilters, appliedColFilters: appliedColFilters, setAppliedColFilters: setAppliedColFilters, setIsDraggingDndItem: setIsDraggingDndItem }) {
    const [filtersOption, setFiltersOption] = (0, $hopDi$useState)({
        label: "Filters",
        value: "filters",
        isChecked: showFilterBar,
        icon: "Filter"
    });
    const { SAVI: SAVI, FILTER: FILTER, GROUP_BY: GROUP_BY, ROWS: ROWS, COLUMNS: COLUMNS, SORT: SORT } = (0, $5630dd438c9b44f6$export$689ae8298085ebf);
    const isSaviInMore = options.includes(SAVI);
    const isFilterInMore = options.includes(FILTER);
    const isGroupByInMore = options.includes(GROUP_BY);
    const isRowsInMore = options.includes(ROWS);
    const isColumnsInMore = options.includes(COLUMNS);
    const isSortInMore = options.includes(SORT);
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const tabletMediumQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$e1d684fb703347f));
    const isTabletMediumWidth = tabletMediumQuery.value <= mediaQueryValue;
    const handleFilterBar = ()=>{
        setFiltersOption((prev)=>({
                ...prev,
                isChecked: !prev.isChecked
            }));
        setShowFilterBar(!showFilterBar);
    };
    const getMenuTrigger = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
            className: "CertsControlsMore-trigger",
            kind: "rectangle",
            label: "More",
            size: "medium"
        });
    const initialPlacement = "left-start";
    const fallbackPlacementsForMenus = [
        "right-start",
        "bottom"
    ];
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$MenuNested), {
        trigger: getMenuTrigger(),
        setIsExpanded: setIsMoreOpen,
        children: [
            isSaviInMore ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuNested), {
                label: "Copilot",
                prefixIconKind: "SaviCompanion",
                itemClassName: "CertsControlsMore-saviItem",
                placement: initialPlacement,
                fallbackPlacements: fallbackPlacementsForMenus,
                children: "Savi in More drop down is still a WIP"
            }) : null,
            isFilterInMore ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuNestedItem), {
                option: filtersOption,
                onChange: handleFilterBar,
                shouldCloseMenuOnItemClick: true,
                placement: initialPlacement,
                fallbackPlacements: fallbackPlacementsForMenus
            }) : null,
            isGroupByInMore ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuNested), {
                placement: initialPlacement,
                fallbackPlacements: fallbackPlacementsForMenus,
                children: "GROUP_BY"
            }) : null,
            isRowsInMore ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuNested), {
                label: "Rows",
                prefixIconKind: "Rows",
                placement: initialPlacement,
                fallbackPlacements: fallbackPlacementsForMenus,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $6e598230156851b9$export$2e2bcd8739ae039), {
                    filters: rowFilters,
                    appliedRowFilters: appliedRowFilters,
                    setAppliedRowFilters: setAppliedRowFilters
                })
            }) : null,
            isColumnsInMore && !isTabletMediumWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuNested), {
                label: "Columns",
                prefixIconKind: "Columns",
                placement: initialPlacement,
                fallbackPlacements: fallbackPlacementsForMenus,
                dropdownClassName: "CertsControlsMore-columnsDropdown",
                itemsClassName: "CertsControlsMore-columnsItems",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $1b64cfc1069de672$export$2e2bcd8739ae039), {
                    isInMore: true,
                    colFilters: colFilters,
                    setColFilters: setColFilters,
                    appliedColFilters: appliedColFilters,
                    setAppliedColFilters: setAppliedColFilters,
                    setIsDraggingDndItem: setIsDraggingDndItem
                })
            }) : null,
            isSortInMore ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuNested), {
                placement: initialPlacement,
                fallbackPlacements: fallbackPlacementsForMenus,
                children: "Savi in More drop down is still a WIP"
            }) : null
        ]
    });
}
$f82331a2ea4ff183$var$CertsControlsMore.propTypes = {
    options: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    setIsMoreOpen: (0, $hopDi$proptypes).func.isRequired,
    // Filter
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    setShowFilterBar: (0, $hopDi$proptypes).func.isRequired,
    // Rows
    rowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    appliedRowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string).isRequired,
    setAppliedRowFilters: (0, $hopDi$proptypes).func.isRequired,
    // Columns
    colFilters: (0, $ddbc2f861c0388ff$export$b3d0e07d10e0d289).isRequired,
    setColFilters: (0, $hopDi$proptypes).func.isRequired,
    appliedColFilters: (0, $ddbc2f861c0388ff$export$d1649ee5b4635363),
    setAppliedColFilters: (0, $hopDi$proptypes).func.isRequired,
    setIsDraggingDndItem: (0, $hopDi$proptypes).func.isRequired
};
$f82331a2ea4ff183$var$CertsControlsMore.defaultProps = {
    options: [],
    appliedColFilters: null
};
var $f82331a2ea4ff183$export$2e2bcd8739ae039 = $f82331a2ea4ff183$var$CertsControlsMore;


var $22e1a26357cf11ca$export$2e2bcd8739ae039 = (0, $f82331a2ea4ff183$export$2e2bcd8739ae039);


/* eslint-disable indent */ 





// Enum doc: https://saviyntars.atlassian.net/wiki/spaces/uidesign/pages/5160960038/Automated+Test+Locators
const $b8f7755ebbf5c667$export$800daf5fbbe96aff = {
    // Consult
    CONSULT_MODAL_MENU_DROPDOWN: "consult-modal-menu-dropdown",
    CONSULT_MODAL_COMMENT_INPUTFIELD: "consult-modal-comment-inputfield",
    CONSULT_MODAL_SUBMIT_BUTTON: "consult-modal-submit-button",
    CONSULT_MODAL_ALERT_BANNER_ERROR: "consult-modal-alert-banner-error",
    // CertsSidePanel
    SIDEPANEL_ASIDE: "sidepanel-aside",
    CERTS_SIDEPANEL_CLOSE_BUTTON: "sidepanel-close-button",
    // Action Buttons
    SINGLE_ACTION_BUTTON: "certs-action-button-single",
    // Control Tabs
    CONTROL_TABS_TODO: "control-tabs-to-do",
    CONTROL_TABS_DONE: "control-tabs-done",
    CONTROL_TABS_CONS: "control-tabs-consulted",
    CONTROL_TABS_ALL: "control-tabs-all"
};
var $b8f7755ebbf5c667$export$2e2bcd8739ae039 = $b8f7755ebbf5c667$export$800daf5fbbe96aff;






function $f875ecc3d42fa49d$var$CertsControlTabs({ addTabItemTestIds: addTabItemTestIds }) {
    const [tempTabs, setTempTabs] = (0, $hopDi$useState)([]);
    const [activeTab, setActiveTab] = (0, $hopDi$useState)("");
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, isTouchEnabled: isTouchEnabled, certKey: certKey, bulkAction: bulkAction, tabs: tabs, reviewAndSubmit: { primaryCertifier: primaryCertifier } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { tabData: tabData, highlightTabName: highlightTabName } = tabs;
    const { CONTROL_TABS_TODO: CONTROL_TABS_TODO, CONTROL_TABS_DONE: CONTROL_TABS_DONE, CONTROL_TABS_CONS: CONTROL_TABS_CONS, CONTROL_TABS_ALL: CONTROL_TABS_ALL } = (0, $b8f7755ebbf5c667$export$800daf5fbbe96aff);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
    }, [
        activeTab
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (tabData) {
            const newTabs = tabData.map((tab)=>({
                    ...tab,
                    label: tab.label,
                    isActive: tab.key === activeTab,
                    isHighlighted: highlightTabName && tab.key === highlightTabName
                }));
            setTempTabs(newTabs);
            setActiveTab(tabData.find((tab)=>tab.isActive)?.key || tabData[0]?.key);
        }
    }, [
        tabData,
        highlightTabName,
        primaryCertifier
    ]);
    // Reset highlightTabName after animation plays
    (0, $hopDi$useEffect)(()=>{
        if (highlightTabName) {
            const timer = setTimeout(()=>{
                dispatch((0, $d623f23401a154f0$export$4fcead6ba6a8c371)(null));
            }, 1550);
            return ()=>clearTimeout(timer);
        }
        return ()=>{};
    }, [
        highlightTabName
    ]);
    const handleChange = (key)=>{
        if (bulkAction?.isChecked || bulkAction?.isIndeterminate) {
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
            if ((tabData.find((tab)=>tab.isActive)?.key || tabData[0]?.key) === activeTab) dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
                dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            });
        }
        setActiveTab(key);
        dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === key,
                isHighlighted: false
            }))));
        if (!bulkAction?.isChecked && !bulkAction?.isAtleastOneSelected && (tabData.find((tab)=>tab.isActive)?.key || tabData[0]?.key) === activeTab) {
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
        }
    };
    const getTooltipText = (key)=>{
        switch(key){
            case 0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49:
                return "Items waiting to be certified";
            case 0, $d44c789d5b60f9bf$export$807a0bc890800408:
                return "Items that have been certified";
            case 0, $d44c789d5b60f9bf$export$d5eea126dff5a615:
                return "All items included in the certification";
            case 0, $d44c789d5b60f9bf$export$b2766b46106d3053:
                return "Items that have been sent for consultation";
            default:
                return "Default Tooltip Text";
        }
    };
    const handlePopoverClick = ()=>{
        if (tabData) {
            const newTabs = tabData.map((tab)=>({
                    ...tab,
                    isHighlighted: false,
                    showSaviPopupTab: false
                }));
            dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(newTabs));
        }
    };
    const setTestIds = (tabKey)=>{
        if (!addTabItemTestIds) return null;
        switch(tabKey){
            case 0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49:
                return CONTROL_TABS_TODO;
            case 0, $d44c789d5b60f9bf$export$b2766b46106d3053:
                return CONTROL_TABS_CONS;
            case 0, $d44c789d5b60f9bf$export$807a0bc890800408:
                return CONTROL_TABS_DONE;
            case 0, $d44c789d5b60f9bf$export$d5eea126dff5a615:
                return CONTROL_TABS_ALL;
            default:
                return null;
        }
    };
    // TODO: Update these generic class names to suitcss utility conventions
    const getSaviPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "Savi-Companion-Popover-Wrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "DisplayFlex",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "SaviCompanion",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            children: "Smart Review Applied"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body1",
                    className: "DescriptionText",
                    children: "I moved the Smart Review items here. You must confirm all of the decisions I made before submitting your certification."
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: "flexWrapper",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "filled",
                        size: "medium",
                        onClick: ()=>handlePopoverClick(false),
                        children: "Got it"
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsControlTabs-contextWrapper",
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabGroup), {
            value: activeTab,
            onChange: handleChange,
            isHorizontalScroll: isMobileXlargeWidth,
            children: tempTabs?.filter((tab)=>tab.key !== (0, $d44c789d5b60f9bf$export$b2766b46106d3053) || primaryCertifier && tab.count !== 0)?.map((tab)=>{
                const tabItemClass = (0, $hopDi$classnames)(tab?.isHighlighted && "CertsControlTabs-tabItem--isHighlighted");
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: tab.label,
                    value: tab.key,
                    BadgeComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                        badgeStyle: activeTab === tab.key ? "filled" : "outlined",
                        number: tab.count,
                        color: "secondary",
                        kind: "number",
                        size: "medium"
                    }),
                    tooltipProps: isTouchEnabled ? {} : {
                        text: getTooltipText(tab.key),
                        maxWidth: "18rem",
                        isPortalEnabled: true
                    },
                    popoverProps: {
                        isOpen: tab.showSaviPopupTab,
                        setIsOpen: handlePopoverClick,
                        isPortalEnabled: true
                    },
                    className: tabItemClass,
                    dataTestId: setTestIds(tab.key),
                    PopoverContent: // Reason for fragmanet "Warning: Signature declarations can only be used in TypeScript files without the fragment"
                    tab.showSaviPopupTab ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Fragment), {
                        children: getSaviPopoverContent()
                    }) : null
                }, tab.key);
            })
        })
    });
}
$f875ecc3d42fa49d$var$CertsControlTabs.propTypes = {
    addTabItemTestIds: (0, $hopDi$proptypes).bool
};
$f875ecc3d42fa49d$var$CertsControlTabs.defaultProps = {
    addTabItemTestIds: false
};
var $f875ecc3d42fa49d$export$2e2bcd8739ae039 = $f875ecc3d42fa49d$var$CertsControlTabs;



var $b8f7c55addb0e434$export$2e2bcd8739ae039 = (0, $f875ecc3d42fa49d$export$2e2bcd8739ae039);










const $453466c718bc17f4$var$useDebounceForFunctions = (callback, delay)=>{
    const timeoutRef = (0, $hopDi$useRef)(null);
    (0, $hopDi$useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const debouncedCallback = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            callback(...args);
        }, delay);
    };
    return debouncedCallback;
};
var $453466c718bc17f4$export$2e2bcd8739ae039 = $453466c718bc17f4$var$useDebounceForFunctions;



const $7403271ae9830960$export$d5aa959239db7309 = 300;
const $7403271ae9830960$export$cfb9e92ff3cd43f4 = 10;
const $7403271ae9830960$export$b5f64487a8d6dc20 = 10;



function $ccc085f0dc7bbefc$var$CertsSearchBar({ isMoreOpen: isMoreOpen, isSearchBarExpanded: isSearchBarExpanded, setIsSearchBarExpanded: setIsSearchBarExpanded }) {
    const [searchQuery, setSearchQuery] = (0, $hopDi$useState)("");
    // Used to delay the labels and buttons from showing up to fast
    const [isTimeOutForExpanded, setIsTimeOutForExpanded] = (0, $hopDi$useState)(false);
    const searchBarButtonRef = (0, $hopDi$useRef)(null);
    const searchBarInputRef = (0, $hopDi$useRef)(null);
    const dispatch = (0, $hopDi$useDispatch)();
    const { bulkAction: bulkAction, certKey: certKey, columnNames: columnNames, isLoading: isLoading, triggerClearBtnForSearch: triggerClearBtnForSearch, tabs: { tabData: tabData } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabData?.find((tab)=>tab.isActive)?.count;
    const searchBarClasses = (0, $hopDi$classnames)("CertsSearchBar", isTimeOutForExpanded && "CertsSearchBar--isExpanded", (activeTabCount === 0 || isLoading) && "CertsSearchBar--isDisabled");
    const searchBarButtonClasses = (0, $hopDi$classnames)("CertsSearchBar-button", activeTabCount === 0 || isLoading && "CertsSearchBar-button--isDisabled");
    (0, $hopDi$useEffect)(()=>{
        if (searchQuery) {
            setIsSearchBarExpanded(true);
            setIsTimeOutForExpanded(true);
        }
    }, [
        searchQuery
    ]);
    const handleSearchExpand = ()=>{
        // Disallow collapse when value is present
        if (searchQuery) return;
        const inputField = searchBarInputRef?.current;
        if (isSearchBarExpanded) {
            setIsTimeOutForExpanded(false);
            inputField.blur();
            setTimeout(()=>{
                setIsSearchBarExpanded(false);
            }, 200);
        } else {
            inputField?.focus();
            setIsSearchBarExpanded(true);
            setIsTimeOutForExpanded(true);
        }
    };
    (0, $hopDi$useOutsideClickEffect)(searchBarInputRef, ()=>{
        handleSearchExpand();
    }, isTimeOutForExpanded && !isMoreOpen);
    // TODO: Give a timeframe for 1 min if Enter key is pressed for the same search query
    const handleSearch = (0, $453466c718bc17f4$export$2e2bcd8739ae039)(()=>{
        if (bulkAction?.isChecked || bulkAction?.isIndeterminate) {
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            });
        }
        if (certKey && (searchQuery.trim().length === 0 || searchQuery.trim().length > 2)) {
            dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(true));
            dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $7403271ae9830960$export$cfb9e92ff3cd43f4), 0, searchQuery.trim()));
            dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
        }
    }, (0, $7403271ae9830960$export$d5aa959239db7309));
    const handleChange = (event)=>{
        setSearchQuery(event.target.value);
    };
    const resetSearch = ()=>{
        dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(true));
        dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $7403271ae9830960$export$cfb9e92ff3cd43f4), 0, "")).then(()=>{
            setSearchQuery("");
        });
        dispatch((0, $d623f23401a154f0$export$661e1772dd5a4141)(false));
        handleSearchExpand();
    };
    const handleSearchBoxClose = ()=>{
        if (searchQuery.trim().length !== 0) {
            dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
            resetSearch();
            return;
        }
        handleSearchExpand();
    };
    (0, $hopDi$useEffect)(()=>{
        if (triggerClearBtnForSearch) resetSearch();
    }, [
        triggerClearBtnForSearch
    ]);
    const handleKeyDown = (event)=>{
        if (event.key === "Enter") handleSearch();
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: searchBarClasses,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                ref: searchBarInputRef,
                name: "CertsSearchBar",
                placeholder: "Search by certification name or username",
                kind: "search",
                size: "medium",
                prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "search",
                    color: "neutral-600",
                    size: "large"
                }),
                value: searchQuery,
                setValue: setSearchQuery,
                onChange: handleChange,
                resetValue: handleSearchBoxClose,
                onKeyDown: handleKeyDown,
                isDisabled: activeTabCount === 0 || isLoading,
                tabIndex: isSearchBarExpanded ? 0 : -1
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonCore), {
                ref: searchBarButtonRef,
                className: searchBarButtonClasses,
                onClick: handleSearchExpand,
                tabIndex: !isSearchBarExpanded ? 0 : -1,
                isDisabled: activeTabCount === 0 || isLoading
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                className: "CertsSearchBar-overlay"
            })
        ]
    });
}
$ccc085f0dc7bbefc$var$CertsSearchBar.propTypes = {
    isMoreOpen: (0, $hopDi$proptypes).bool,
    isSearchBarExpanded: (0, $hopDi$proptypes).bool.isRequired,
    setIsSearchBarExpanded: (0, $hopDi$proptypes).func.isRequired
};
$ccc085f0dc7bbefc$var$CertsSearchBar.defaultProps = {
    isMoreOpen: false
};
var $ccc085f0dc7bbefc$export$2e2bcd8739ae039 = $ccc085f0dc7bbefc$var$CertsSearchBar;


var $2e9a0432bbfd77e3$export$2e2bcd8739ae039 = (0, $ccc085f0dc7bbefc$export$2e2bcd8739ae039);





/* eslint-disable no-param-reassign */ 








const $2eea7f4bc7c0e2e9$export$994f7af6d0b36256 = {
    USER: "-4",
    ROLE: "-2",
    ACCOUNT: "0",
    ENTITLEMENT: ">0"
};
const $2eea7f4bc7c0e2e9$export$329ee40998204557 = {
    USER: "USER",
    ACCOUNT: "ACCOUNT",
    ENTITLEMENT: "ENTITLEMENT",
    ROLE: "ROLE"
};
const $2eea7f4bc7c0e2e9$export$c2fd574cc3b8c823 = "User";
const $2eea7f4bc7c0e2e9$export$c97501b522a7bf89 = "Role";
const $2eea7f4bc7c0e2e9$export$eeb9092565ce426a = "Account";
const $2eea7f4bc7c0e2e9$export$7d1f9b2b2a057886 = "Entitlement";
const $2eea7f4bc7c0e2e9$export$50fc35c85d3a3c9d = "User_DISPLAYNAME";
const $2eea7f4bc7c0e2e9$export$1772b047bb5ee9a = "Role_DISPLAYNAME";
const $2eea7f4bc7c0e2e9$export$e7e5437fabb30374 = "Account_DISPLAYNAME";
const $2eea7f4bc7c0e2e9$export$1b550718072cac3f = "Ent_DISPLAYNAME";
const $2eea7f4bc7c0e2e9$export$3d372a4d90e6e43c = [
    `${$2eea7f4bc7c0e2e9$export$c2fd574cc3b8c823.toUpperCase()}-${$2eea7f4bc7c0e2e9$export$50fc35c85d3a3c9d}`,
    `${$2eea7f4bc7c0e2e9$export$eeb9092565ce426a.toUpperCase()}-${$2eea7f4bc7c0e2e9$export$e7e5437fabb30374}`,
    `${$2eea7f4bc7c0e2e9$export$7d1f9b2b2a057886.toUpperCase()}-${$2eea7f4bc7c0e2e9$export$1b550718072cac3f}`,
    `${$2eea7f4bc7c0e2e9$export$c97501b522a7bf89.toUpperCase()}-${$2eea7f4bc7c0e2e9$export$1772b047bb5ee9a}`
];







const $93b356efe95f7cab$export$3fd9cf1e436e0f28 = (data)=>{
    let parentInfo = [];
    data?.forEach((ele)=>{
        if (ele.isParent) parentInfo.push(ele.label);
        else if (ele.options && ele.options?.length > 0) {
            const info = $93b356efe95f7cab$export$3fd9cf1e436e0f28(ele.options);
            parentInfo = [
                ...info,
                ...parentInfo
            ];
        }
    });
    return parentInfo;
};
const $93b356efe95f7cab$export$6289ca747cabdbcb = (list, option)=>{
    if (option) {
        const index = list.findIndex((obj)=>obj.label === option.label);
        if (index > -1) {
            list.splice(index, 1);
            list.unshift(option);
        }
    }
    return list;
};
const $93b356efe95f7cab$export$ad4c9ce976c36d4d = (string)=>{
    const pattern = /\b(?:date|Date)\b/;
    return pattern.test(string);
};
const $93b356efe95f7cab$export$a0913d6325605e9f = (selectedRowsArray, getWarnLabel)=>{
    const array = [
        ...selectedRowsArray
    ];
    if (array.length === 1) return array[0];
    if (array.includes("-4")) return "-4";
    if (!array.includes("-4") && array.includes("-2") && array.includes("0")) {
        if (getWarnLabel) return "Select either Role or Account in the Hierarchy filter to perform sorting.";
        return null;
    }
    if (array.length === 2 && array.includes("-2") && array.includes(">0")) {
        if (getWarnLabel) return "Select either Role or Entitlement in the Hierarchy filter to perform sorting.";
        return null;
    }
    if (array.includes("0")) return "0";
    return null;
};
const $93b356efe95f7cab$export$c763c2859d6ab0cb = (lineItemValue)=>{
    switch(lineItemValue){
        case (0, $2eea7f4bc7c0e2e9$export$994f7af6d0b36256).USER:
            return (0, $2eea7f4bc7c0e2e9$export$329ee40998204557).USER;
        case (0, $2eea7f4bc7c0e2e9$export$994f7af6d0b36256).ACCOUNT:
            return (0, $2eea7f4bc7c0e2e9$export$329ee40998204557).ACCOUNT;
        case (0, $2eea7f4bc7c0e2e9$export$994f7af6d0b36256).ROLE:
            return (0, $2eea7f4bc7c0e2e9$export$329ee40998204557).ROLE;
        case (0, $2eea7f4bc7c0e2e9$export$994f7af6d0b36256).ENTITLEMENT:
            return (0, $2eea7f4bc7c0e2e9$export$329ee40998204557).ENTITLEMENT;
        default:
            return (0, $2eea7f4bc7c0e2e9$export$994f7af6d0b36256).USER;
    }
};


function $1173b64c5f93fe2b$var$SortDropdown({ searchDescription: searchDescription, placeholder: placeholder, searchText: searchText, setSearchText: setSearchText, className: className, isRightIcon: isRightIcon, filteredSortList: filteredSortList, selectedOption: selectedOption, handleOptionSelect: handleOptionSelect, disableSearch: disableSearch }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: `Dynamic-dropdown ${className}`,
        children: [
            !disableSearch && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("p", {
                        className: "search-description",
                        children: searchDescription
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "SortSearchBar",
                        "data-test-id": "searchbar",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                            name: "basic",
                            placeholder: placeholder,
                            label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "label",
                                htmlFor: "Label",
                                children: "Label"
                            }),
                            kind: "search",
                            size: "small",
                            prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "search",
                                color: "neutral-700",
                                size: "smallMedium"
                            }),
                            value: searchText,
                            setValue: setSearchText,
                            tabIndex: 0
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "Dynamic-sortlistWrap",
                children: (0, $93b356efe95f7cab$export$6289ca747cabdbcb)(filteredSortList, selectedOption).map((option)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: `MenuItem ${option.isDisabled ? "MenuItem--isDisabled" : ""} ${selectedOption && selectedOption.value === option.value ? "MenuItem--isChecked" : ""}`,
                        onClick: ()=>handleOptionSelect(option, true),
                        onKeyUp: ()=>{},
                        role: "button",
                        tabIndex: "0",
                        children: selectedOption && selectedOption.value === option.value ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2-bold",
                                    children: option.label
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "Check",
                                    color: "navy-900",
                                    size: "medium"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    children: option.label
                                }),
                                isRightIcon && !selectedOption ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "ChevronRight",
                                    color: "navy-900",
                                    size: "xSmall"
                                }) : null
                            ]
                        })
                    }, option.value))
            })
        ]
    });
}
$1173b64c5f93fe2b$var$SortDropdown.propTypes = {
    searchDescription: (0, $hopDi$proptypes).string.isRequired,
    placeholder: (0, $hopDi$proptypes).string.isRequired,
    searchText: (0, $hopDi$proptypes).string.isRequired,
    setSearchText: (0, $hopDi$proptypes).func.isRequired,
    className: (0, $hopDi$proptypes).string,
    filteredSortList: (0, $hopDi$proptypes).arrayOf().isRequired,
    selectedOption: (0, $hopDi$proptypes).shape({
        value: (0, $hopDi$proptypes).string
    }),
    handleOptionSelect: (0, $hopDi$proptypes).func.isRequired,
    disableSearch: (0, $hopDi$proptypes).bool,
    isRightIcon: (0, $hopDi$proptypes).bool
};
$1173b64c5f93fe2b$var$SortDropdown.defaultProps = {
    className: "",
    selectedOption: null,
    disableSearch: false,
    isRightIcon: false
};
var $1173b64c5f93fe2b$export$2e2bcd8739ae039 = $1173b64c5f93fe2b$var$SortDropdown;




const $06d8bdc0aa76c00b$var$SORT_OPTIONS = [
    {
        label: "A to Z",
        value: "asc",
        isDisabled: false,
        isChecked: true
    },
    {
        label: "Z to A",
        value: "desc",
        isDisabled: false,
        isChecked: false
    }
];
const $06d8bdc0aa76c00b$var$SORT_DATE_OPTIONS = [
    {
        label: "Ascending",
        value: "asc",
        isDisabled: false,
        isChecked: true
    },
    {
        label: "Descending",
        value: "desc",
        isDisabled: false,
        isChecked: false
    }
];
function $06d8bdc0aa76c00b$var$DynamicSort({ rowFilters: rowFilters, colFilters: colFilters, handleSort: handleSort, resetDynamicSort: resetDynamicSort, appliedRowFilters: appliedRowFilters, isSortOpen: isSortOpen, setIsSortOpen: setIsSortOpen, hideSortForBeta: hideSortForBeta }) {
    const [sortList, setSortList] = (0, $hopDi$useState)([]);
    const [selectedOption, setSelectedOption] = (0, $hopDi$useState)(null);
    const [sortDirection, setSortDirection] = (0, $hopDi$useState)([]);
    const [selectedSortDirection, setSelectedSortDirection] = (0, $hopDi$useState)(null);
    const [popoverOpen, setPopoverOpen] = (0, $hopDi$useState)(false);
    const [isOpenLevel2, setIsOpenLevel2] = (0, $hopDi$useState)(false);
    const [isSortSelection, setIsSortSelection] = (0, $hopDi$useState)(false);
    const [isSortOptionsOpen, setIsSortOptionsOpen] = (0, $hopDi$useState)(false);
    const [searchText, setSearchText] = (0, $hopDi$useState)("");
    const dropdownRef = (0, $hopDi$useRef)(null);
    const intl = (0, $hopDi$useIntl)();
    const { isLoading: isLoading, tabs: tabs, dynamicSortFilter: dynamicSortFilter } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const activeTabCount = tabs?.tabData?.find((tab)=>tab.isActive)?.count;
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const { sortByColumn: sortByColumn } = dynamicSortFilter;
    const handleCloseSort = ()=>{
        setSelectedOption(null);
        setIsSortOpen(false);
        setIsOpenLevel2(false);
        setIsSortOptionsOpen(false);
        resetDynamicSort();
    };
    (0, $hopDi$useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsSortOpen(false);
                setIsOpenLevel2(false);
                setIsSortOptionsOpen(false);
                setIsSortSelection(false);
            }
        };
        setSortDirection($06d8bdc0aa76c00b$var$SORT_OPTIONS);
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (!sortByColumn) setSelectedOption(null);
    }, [
        sortByColumn
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (rowFilters.length > 0 && colFilters.length > 0) {
            const parentInfo = (0, $93b356efe95f7cab$export$3fd9cf1e436e0f28)(rowFilters);
            let filteredDynamicSortData = [];
            const getLineItem = (0, $93b356efe95f7cab$export$a0913d6325605e9f)(appliedRowFilters);
            if (getLineItem) colFilters.forEach((ele)=>{
                if (ele.value === (0, $93b356efe95f7cab$export$c763c2859d6ab0cb)(getLineItem)) {
                    const colOptions = JSON.parse(JSON.stringify(ele.options));
                    filteredDynamicSortData = [
                        ...filteredDynamicSortData,
                        ...colOptions
                    ];
                }
            });
            else // handleCloseSort(); // reset the filters
            colFilters.forEach((ele)=>{
                if (parentInfo.includes(ele.label)) {
                    const colOptions = JSON.parse(JSON.stringify(ele.options));
                    filteredDynamicSortData = [
                        ...filteredDynamicSortData,
                        ...colOptions
                    ];
                }
            });
            const data = [];
            filteredDynamicSortData.forEach((element)=>{
                // remove fixed columns for selected rows
                if (!(0, $2eea7f4bc7c0e2e9$export$3d372a4d90e6e43c).includes(element.value)) {
                    element.columnName = element.label;
                    element.label = messages[element.label] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(element?.label?.split(".")[0]));
                    element.isChecked = false;
                    data.push(element);
                }
            });
            setSortList(data);
        }
    }, [
        rowFilters,
        colFilters,
        appliedRowFilters
    ]);
    const handleSortAction = ()=>{
        if (handleSort) handleSort(selectedOption, sortDirection);
    };
    const handleOptionSelect = (option, initial)=>{
        if (selectedOption?.label === option.label) {
            setSelectedOption(null);
            setIsSortOpen(false);
            setIsOpenLevel2(false);
            setIsSortOptionsOpen(false);
            resetDynamicSort();
            // reset dynamic sort
            return;
        }
        setSelectedOption(option);
        if (initial) {
            const sortOptions = (0, $93b356efe95f7cab$export$ad4c9ce976c36d4d)(option.label) ? $06d8bdc0aa76c00b$var$SORT_DATE_OPTIONS : $06d8bdc0aa76c00b$var$SORT_OPTIONS;
            setSortDirection(sortOptions);
            setSelectedSortDirection(sortOptions[0]);
        }
        setIsSortOpen(false);
        setIsOpenLevel2(false);
        setIsSortOptionsOpen(true);
    };
    const handleSortDirectionSelect = (direction)=>{
        setSortDirection((currentOptions)=>currentOptions.map((option)=>({
                    ...option,
                    isChecked: option.value === direction.value
                })));
        setSelectedSortDirection(direction);
        setIsSortSelection(false);
    };
    const filteredSortList = sortList.filter((option)=>option.label.toLowerCase().includes(searchText.toLowerCase()));
    const handleSortDropdown = ()=>{
        setIsOpenLevel2(false);
        if (!selectedOption) setIsSortOpen(!isSortOpen);
        else setIsSortOptionsOpen(!isSortOptionsOpen);
    };
    const handleSortDropdownLevel2 = ()=>{
        setIsOpenLevel2(!isOpenLevel2);
    };
    const handleIsSortOption = ()=>{
        setIsSortSelection(!isSortSelection);
    };
    (0, $hopDi$useEffect)(()=>{
        if (selectedOption !== null) handleSortAction();
    }, [
        selectedOption,
        sortDirection
    ]);
    // TODO: This is to hide the sort options temporarily, remove this code once sort is ready to be implemented
    if (hideSortForBeta) return null;
    // TODO: END
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "DynamicSort-sort",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "DynamicSort-sortTriggerWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                        className: `${selectedOption !== null && "DynamicSort-trigger--isSelected"} DynamicSort-trigger`,
                        kind: "icon",
                        size: "medium",
                        isOpen: isSortOpen,
                        onClick: ()=>{
                            const getLineItem = (0, $93b356efe95f7cab$export$a0913d6325605e9f)(appliedRowFilters);
                            if (getLineItem) handleSortDropdown();
                            else // show popover message
                            setPopoverOpen(true);
                        },
                        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Sort"
                        }),
                        BadgeComp: selectedOption !== null ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                            kind: "dot",
                            color: "primary",
                            size: "small"
                        }) : null,
                        isDisabled: activeTabCount === 0 || isLoading
                    }),
                    !(0, $93b356efe95f7cab$export$a0913d6325605e9f)(appliedRowFilters) && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        className: "DynamicSort-flexWrapper",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                            isPortalEnabled: true,
                            popoverContent: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                className: "DynamicSort-flexContainer",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                        className: "DynamicSort-popoverHeader",
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                kind: "Warning",
                                                color: "warning-500"
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                kind: "h3",
                                                className: "DynamicSort-popoverTitle",
                                                children: "Multiple DataTypes"
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                                className: "DynamicSort-popoverCloseIcon",
                                                size: "medium",
                                                kind: "ghost",
                                                tabIndex: -1,
                                                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                    kind: "close",
                                                    color: "neutral-1000",
                                                    size: "smallMedium"
                                                }),
                                                onClick: ()=>setPopoverOpen(false)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        className: "DynamicSort-popoverDescription",
                                        children: (0, $93b356efe95f7cab$export$a0913d6325605e9f)(appliedRowFilters, true)
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                        tag: "div",
                                        className: "DynamicSort-Popovercontrols",
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                            type: "button",
                                            kind: "filled",
                                            size: "small",
                                            onClick: ()=>setPopoverOpen(false),
                                            children: "Got it"
                                        })
                                    })
                                ]
                            }),
                            isOpen: popoverOpen,
                            setIsOpen: setPopoverOpen
                        })
                    })
                ]
            }),
            isSortOpen && !selectedOption && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1173b64c5f93fe2b$export$2e2bcd8739ae039), {
                searchDescription: "Select an attribute to sort by.",
                placeholder: "Search attributes",
                searchText: searchText,
                setSearchText: setSearchText,
                className: "a",
                isRightIcon: true,
                filteredSortList: filteredSortList,
                selectedOption: selectedOption,
                handleOptionSelect: handleOptionSelect
            }),
            selectedOption && isSortOptionsOpen && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "Dynamic-dropdown sort-options-wrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "selected-options-trigger",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                            type: "button",
                            dataTestId: "menu-trigger",
                            "aria-pressed": isOpenLevel2,
                            label: selectedOption?.label,
                            onClick: handleSortDropdownLevel2,
                            isOpen: isOpenLevel2,
                            isDisabled: activeTabCount === 0 || isLoading
                        })
                    }),
                    isOpenLevel2 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1173b64c5f93fe2b$export$2e2bcd8739ae039), {
                        placeholder: "Search attributes",
                        searchText: searchText,
                        setSearchText: setSearchText,
                        className: "sort-option-second-level",
                        filteredSortList: filteredSortList,
                        selectedOption: selectedOption,
                        handleOptionSelect: handleOptionSelect
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "selected-options-trigger",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                            type: "button",
                            dataTestId: "menu-trigger",
                            "aria-pressed": isSortSelection,
                            label: selectedSortDirection?.label,
                            onClick: handleIsSortOption,
                            isOpen: isSortSelection,
                            isDisabled: activeTabCount === 0 || isLoading
                        })
                    }),
                    isSortSelection && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1173b64c5f93fe2b$export$2e2bcd8739ae039), {
                        className: "DynamicSort-direction",
                        filteredSortList: sortDirection,
                        selectedOption: selectedSortDirection,
                        handleOptionSelect: handleSortDirectionSelect,
                        disableSearch: true
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "sort-clear",
                        onClick: handleCloseSort,
                        onKeyUp: ()=>{},
                        role: "button",
                        tabIndex: "0",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-700",
                            size: "xSmall"
                        })
                    })
                ]
            })
        ]
    });
}
$06d8bdc0aa76c00b$var$DynamicSort.propTypes = {
    rowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})),
    colFilters: (0, $ddbc2f861c0388ff$export$b3d0e07d10e0d289),
    appliedRowFilters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    handleSort: (0, $hopDi$proptypes).func,
    resetDynamicSort: (0, $hopDi$proptypes).func,
    isSortOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsSortOpen: (0, $hopDi$proptypes).func.isRequired,
    hideSortForBeta: (0, $hopDi$proptypes).bool
};
$06d8bdc0aa76c00b$var$DynamicSort.defaultProps = {
    rowFilters: [],
    colFilters: [],
    handleSort: ()=>{},
    resetDynamicSort: ()=>{},
    appliedRowFilters: [],
    hideSortForBeta: true
};
var $06d8bdc0aa76c00b$export$2e2bcd8739ae039 = $06d8bdc0aa76c00b$var$DynamicSort;


var $96bbb2b8ad24fb0a$export$2e2bcd8739ae039 = (0, $06d8bdc0aa76c00b$export$2e2bcd8739ae039);






const $6702cb469143c6c9$export$29ae9ca85e0eb4a7 = 10;
const $6702cb469143c6c9$export$8a2c144908a2b8f5 = "fulfilled";
const $6702cb469143c6c9$export$2444563004f47e89 = "CanceledError: Forced Cancellation";
const $6702cb469143c6c9$export$14624c6c73370169 = 1;
const $6702cb469143c6c9$export$1c70425da51939b3 = {
    Medium: "warning",
    High: "critical",
    Critical: "critical"
};


const $0ae5e08f8dc713fb$export$2de30e2a30eba22b = {
    reassigned: {
        icon: "ReassignUser",
        iconColor: "neutral-000",
        heading: "Reassigned",
        date: "Resigned On",
        user: "Reassigned By",
        other: "Comments"
    },
    doesNotReport: {
        icon: "ReassignItem",
        iconColor: "neutral-000",
        heading: "Reassigned",
        date: "Resigned On",
        user: "Reassigned By",
        other: "Comments"
    },
    consulted: {
        icon: "Consult",
        iconColor: "neutral-000",
        heading: "Consulted",
        date: "Consulted On",
        user: "Consulted By",
        other: "Comments"
    },
    ChangeEnddate: {
        icon: "ExtendEndDate",
        iconColor: "navy-700",
        heading: "Certified",
        date: "Certified On",
        user: "Certified By",
        other: "Comments"
    },
    conditionallyCertified: {
        icon: "ExtendEndDate",
        iconColor: "success-700",
        heading: "Certified",
        date: "Certified On",
        user: "Certified By",
        other: "Comments"
    },
    Reject: {
        icon: "RejectSPH",
        iconColor: "critical-700",
        heading: "Rejected",
        date: "Rejected On",
        user: "Rejected By",
        other: "Comments"
    },
    terminated: {
        icon: "Terminate",
        iconColor: "critical-700",
        heading: "Approved",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    worksForMe: {
        icon: "ConfirmManagerSPH",
        iconColor: "success-700",
        heading: "Approved",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    Approve: {
        icon: "ApproveSPH",
        iconColor: "success-700",
        heading: "Works For Me",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    SaviCompanionSmartApprove: {
        icon: "SaviSPH",
        iconColor: "purple-900",
        heading: "Approved",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    SaviCompanionSmartReject: {
        icon: "SaviCompSPH",
        iconColor: "purple-900",
        heading: "Works For Me",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    cancelled: {
        icon: "Close",
        iconColor: "navy-700",
        heading: "Reset",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    },
    default: {
        icon: "Close",
        iconColor: "neutral-000",
        heading: "NOT_PROVIDED",
        date: "Approved On",
        user: "Approved By",
        other: "Comments"
    }
};


const $15388cfdc531d880$export$419658dfa295d7 = (tab)=>{
    switch(tab){
        case 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63:
            return "No actions or comments have been recorded for this certification yet.";
        case 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371:
            return "There's no summary available for this user.";
        default:
            return "";
    }
};
const $15388cfdc531d880$export$ba58c0596871524 = (tab)=>{
    switch(tab){
        case 0, $d60257e8dc27bf16$export$9b67fda1e37e6e63:
            return "The History tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$bde14d5a1cbdb371:
            return "The Summary tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$8f78881bb4058858:
            return "The Access Conflicts tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$a06b6c2be556dac8:
            return "The Privilege tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$51f82826650bc3c3:
            return "The Child Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681:
            return "The Dependent Entitlements tab didn't load properly due to a network issue. Please refresh or try again later.";
        case 0, $d60257e8dc27bf16$export$6cc684447a8d7b17:
            return "The Child Roles tab didn't load properly due to a network issue. Please refresh or try again later.";
        default:
            return "";
    }
};
const $15388cfdc531d880$export$3a17aa4bbe26c437 = (obj, mapper)=>{
    const filteredObj = {};
    // Determine category based on CERT_ENTITLEMENT_VALUEKEY
    let category;
    if (obj.CERT_ENTITLEMENT_VALUEKEY === "0") category = (0, $a23cd229b9113926$export$eeb9092565ce426a);
    else if (parseInt(obj.CERT_ENTITLEMENT_VALUEKEY, 10) > 0) category = (0, $a23cd229b9113926$export$7d1f9b2b2a057886);
    else if (obj.CERT_ENTITLEMENT_VALUEKEY === "-4") category = (0, $a23cd229b9113926$export$c2fd574cc3b8c823);
    else if (obj.CERT_ENTITLEMENT_VALUEKEY === "-2") category = (0, $a23cd229b9113926$export$c97501b522a7bf89);
    if (category) {
        const allowedAttributes = mapper[category];
        if (!allowedAttributes) return filteredObj;
        Object.keys(allowedAttributes)?.forEach((attr)=>{
            const realAttr = attr;
            if (Object.prototype.hasOwnProperty.call(obj, realAttr)) filteredObj[realAttr] = obj[realAttr];
        });
    }
    return filteredObj;
};
const $15388cfdc531d880$export$c7ecff4fc21646e6 = (data)=>{
    if (data?.CERT_ENTITLEMENT_VALUEKEY === "-2" || data?.CERT_ENTITLEMENT_VALUEKEY === "0" || data?.arstaskkeyflag) return true;
    return false;
};


function $b9063d77adf48209$var$CertsSidePanelBodyError({ tab: tab, retriggerApisForError: retriggerApisForError, handleCloseSidePanel: handleCloseSidePanel }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "CertsSidePanelBody-tabContent--isError",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h2",
                children: "Couldn't Load"
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                className: "CertsSidePanelBody-tabContentDescription--isError",
                children: (0, $15388cfdc531d880$export$ba58c0596871524)(tab)
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "outlined",
                isEnabled: true,
                onClick: retriggerApisForError,
                className: "CertsSidePanelBody-tabContentRefreshBtn--isError",
                size: "small",
                children: "Refresh"
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "small",
                onClick: handleCloseSidePanel,
                children: "Close"
            })
        ]
    });
}
$b9063d77adf48209$var$CertsSidePanelBodyError.propTypes = {
    tab: (0, $hopDi$proptypes).string,
    retriggerApisForError: (0, $hopDi$proptypes).func.isRequired,
    handleCloseSidePanel: (0, $hopDi$proptypes).func.isRequired
};
$b9063d77adf48209$var$CertsSidePanelBodyError.defaultProps = {
    tab: ""
};
var $b9063d77adf48209$export$2e2bcd8739ae039 = $b9063d77adf48209$var$CertsSidePanelBodyError;


var $8198211ef3cd686e$export$2e2bcd8739ae039 = (0, $b9063d77adf48209$export$2e2bcd8739ae039);














const $ce7e60e33da3b7cd$var$MIN_COUNT_FOR_TOOLTIP = 100;
const $ce7e60e33da3b7cd$var$TOOLTIP_DELAY_IN_MS_TILE = 500;
function $ce7e60e33da3b7cd$var$FieldSet({ fieldData: fieldData, type: type, isBlank: isBlank }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: type === "compact" ? "FieldSet-fieldset--compact" : "FieldSet-fieldset",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body3",
                className: "FieldSet-fieldsetLabel",
                children: fieldData.label
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                openDelay: $ce7e60e33da3b7cd$var$TOOLTIP_DELAY_IN_MS_TILE,
                text: fieldData?.value?.length > $ce7e60e33da3b7cd$var$MIN_COUNT_FOR_TOOLTIP ? fieldData.value : null,
                maxWidth: "20rem",
                placement: "bottom",
                offset: 8,
                trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    className: isBlank ? "FieldSet-fieldsetValue--blank" : "FieldSet-fieldsetValue--filled",
                    children: fieldData.value
                })
            })
        ]
    });
}
$ce7e60e33da3b7cd$var$FieldSet.propTypes = {
    fieldData: (0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).oneOf((0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string, (0, $hopDi$proptypes).number)),
        value: (0, $hopDi$proptypes).oneOf((0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string, (0, $hopDi$proptypes).number))
    }),
    type: (0, $hopDi$proptypes).string,
    isBlank: (0, $hopDi$proptypes).bool
};
$ce7e60e33da3b7cd$var$FieldSet.defaultProps = {
    type: "",
    fieldData: {
        label: " ",
        value: " "
    },
    isBlank: false
};
var $ce7e60e33da3b7cd$export$2e2bcd8739ae039 = $ce7e60e33da3b7cd$var$FieldSet;


var $5d9478e6fefd4bf2$export$2e2bcd8739ae039 = (0, $ce7e60e33da3b7cd$export$2e2bcd8739ae039);





function $ee8b26c91bf27a5f$var$HLine() {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "HLine"
    });
}
var $ee8b26c91bf27a5f$export$2e2bcd8739ae039 = $ee8b26c91bf27a5f$var$HLine;


var $030549388b36232f$export$2e2bcd8739ae039 = (0, $ee8b26c91bf27a5f$export$2e2bcd8739ae039);














const $38068f3c89a53550$export$b87f371cbc396fcf = {
    fill: "fill",
    outline: "outline"
};
const $38068f3c89a53550$export$60454f4d269823bb = {
    success: {
        icon: "success-700",
        fill: "#028329",
        outline: "#43A34D",
        overRideIconColor: false
    },
    critical: {
        icon: "critical-700",
        fill: "#CC1C10",
        outline: "#EF5955",
        overRideIconColor: false
    },
    savi: {
        icon: "critical-700",
        fill: "#CC1C10",
        outline: "#4C00AC",
        overRideIconColor: false
    },
    normal: {
        icon: "navy-900",
        fill: "#254B86",
        outline: "#6888B5",
        overRideIconColor: false
    },
    sod: {
        icon: "neutral-000",
        fill: "#F6A91C",
        outline: "#F6A91C",
        overRideIconColor: false
    },
    sodFunctions: {
        icon: "warning-900",
        fill: "#FFF1D9",
        outline: "#5C3C00",
        overRideIconColor: true
    },
    list: {
        icon: "neutral-1000",
        fill: "#F2F4F8",
        outline: "#212328",
        overRideIconColor: true
    }
};



function $e96946baab6dc3a3$var$SpbTimeLine({ bgColor: bgColor, type: type, kind: kind, iconKind: iconKind, iconSize: iconSize, iconColor: iconColor, showTail: showTail, className: className, isSidePanelHistory: isSidePanelHistory, dataTestId: dataTestId }) {
    const DASHED_FILLER_BLOCK_COUNT = 10;
    const spbTimeLineClass = (0, $hopDi$classnames)("SpbTimeLine", className);
    const spbTimeLineIconClass = (0, $hopDi$classnames)("SpbTimeLine-icon", iconSize === "xxxSmall" ? "SpbTimeLine-icon--small" : "SpbTimeLine-icon--large");
    const iconStyle = {
        backgroundColor: type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).fill ? bgColor || (0, $38068f3c89a53550$export$60454f4d269823bb)[kind].fill : "white",
        border: type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).outline ? `1px solid ${bgColor || (0, $38068f3c89a53550$export$60454f4d269823bb)[kind].outline}` : "none"
    };
    const renderSpbTimeLineTail = ()=>{
        if (showTail && isSidePanelHistory) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "SpbTimeLine-tail--normal"
        });
        if (showTail && type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).fill) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "SpbTimeLine-tail--normal"
        });
        if (showTail && type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).outline) return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "SpbTimeLine-tail--dashed",
            children: [
                ...Array(DASHED_FILLER_BLOCK_COUNT).keys()
            ].map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "SpbTimeLine-tailDashedBlocks"
                }, key))
        });
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
    };
    const iconColorValue = iconColor || (type === (0, $38068f3c89a53550$export$b87f371cbc396fcf).fill && !(0, $38068f3c89a53550$export$60454f4d269823bb)[kind].overRideIconColor ? "neutral-000" : (0, $38068f3c89a53550$export$60454f4d269823bb)[kind].icon);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: spbTimeLineClass,
        "data-testid": dataTestId,
        children: [
            renderSpbTimeLineTail(),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                style: iconStyle,
                className: spbTimeLineIconClass,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: iconKind,
                    size: iconSize,
                    color: iconColorValue
                })
            })
        ]
    });
}
$e96946baab6dc3a3$var$SpbTimeLine.propTypes = {
    bgColor: (0, $hopDi$proptypes).string,
    type: (0, $hopDi$proptypes).oneOf(Object.values((0, $38068f3c89a53550$export$b87f371cbc396fcf))),
    kind: (0, $hopDi$proptypes).oneOf(Object.keys((0, $38068f3c89a53550$export$60454f4d269823bb))),
    iconKind: (0, $hopDi$proptypes).string.isRequired,
    iconSize: (0, $hopDi$proptypes).string,
    iconColor: (0, $hopDi$proptypes).string,
    showTail: (0, $hopDi$proptypes).bool,
    className: (0, $hopDi$proptypes).string,
    isSidePanelHistory: (0, $hopDi$proptypes).bool,
    dataTestId: (0, $hopDi$proptypes).string
};
$e96946baab6dc3a3$var$SpbTimeLine.defaultProps = {
    bgColor: null,
    type: (0, $38068f3c89a53550$export$b87f371cbc396fcf).fill,
    kind: "normal",
    iconSize: "xSmall",
    iconColor: null,
    showTail: true,
    className: "",
    dataTestId: "",
    isSidePanelHistory: false
};
var $e96946baab6dc3a3$export$2e2bcd8739ae039 = $e96946baab6dc3a3$var$SpbTimeLine;


var $596ca118e64bea36$export$2e2bcd8739ae039 = (0, $e96946baab6dc3a3$export$2e2bcd8739ae039);



const $6324724ae4ae52e1$var$PAD = {
    sod: "sod",
    privileges: "privileges"
};
function $6324724ae4ae52e1$var$SimpleAccordion({ title: title, children: children, isInitialOpen: isInitialOpen, iconKind: iconKind = "Entitlement", kind: kind, pad: pad }) {
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mobileXlargeQuery.value <= mediaQueryValue;
    const accordianBodyClasses = (0, $hopDi$classnames)("SimpleAccordion-body", isMobileWidth && "SimpleAccordion-body--mobileResponsive");
    const accordianHeaderClasses = (0, $hopDi$classnames)("SimpleAccordion-header", isMobileWidth && "SimpleAccordion-header--mobileResponsive");
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(isInitialOpen);
    const toggleAccordion = ()=>{
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: pad === $6324724ae4ae52e1$var$PAD.privileges ? "SimpleAccordion--privileges" : "SimpleAccordion--sod",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: accordianHeaderClasses,
                onClick: toggleAccordion,
                onKeyUp: ()=>{},
                role: "button",
                tabIndex: 0,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "SimpleAccordion-headerTitle",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $596ca118e64bea36$export$2e2bcd8739ae039), {
                                iconKind: iconKind,
                                kind: kind,
                                type: "fill",
                                showTail: false,
                                dataTestId: "SimpleAccordion-SpbTimeLine"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                className: isOpen ? "SimpleAccordion-headerTitleText--expanded" : "SimpleAccordion-headerTitleText--closed",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: isOpen ? "SimpleAccordion-headerIcon--open" : "SimpleAccordion-headerIcon--closed",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "ChevronDown",
                            size: "small",
                            color: "neutral-800"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: accordianBodyClasses,
                children: children
            })
        ]
    });
}
$6324724ae4ae52e1$var$SimpleAccordion.propTypes = {
    title: (0, $hopDi$proptypes).string.isRequired,
    children: (0, $hopDi$proptypes).node.isRequired,
    iconKind: (0, $hopDi$proptypes).string,
    kind: (0, $hopDi$proptypes).string,
    isInitialOpen: (0, $hopDi$proptypes).bool,
    pad: (0, $hopDi$proptypes).oneOf(Object.values($6324724ae4ae52e1$var$PAD))
};
$6324724ae4ae52e1$var$SimpleAccordion.defaultProps = {
    iconKind: "Entitlement",
    kind: "list",
    isInitialOpen: false,
    pad: $6324724ae4ae52e1$var$PAD.sod
};
var $6324724ae4ae52e1$export$2e2bcd8739ae039 = $6324724ae4ae52e1$var$SimpleAccordion;


var $b291d00926535dc7$export$2e2bcd8739ae039 = (0, $6324724ae4ae52e1$export$2e2bcd8739ae039);








function $a7a9aa6df366a012$var$SODItem({ sodItem: sodItem }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SODItem",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $596ca118e64bea36$export$2e2bcd8739ae039), {
                iconKind: "JobFunctions",
                type: "fill",
                kind: "sodFunctions",
                showTail: false,
                dataTestId: "SODItem-SpbTimeLine"
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                className: "SODItem-details",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        className: "SODItem-detailsTitle",
                        children: sodItem.label
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: "SODItem-detailsDescription",
                        children: sodItem.description
                    })
                ]
            })
        ]
    });
}
$a7a9aa6df366a012$var$SODItem.propTypes = {
    sodItem: (0, $hopDi$proptypes).shape({
        label: (0, $hopDi$proptypes).string,
        description: (0, $hopDi$proptypes).string
    }).isRequired,
    label: (0, $hopDi$proptypes).string
};
$a7a9aa6df366a012$var$SODItem.defaultProps = {
    label: ""
};
var $a7a9aa6df366a012$export$2e2bcd8739ae039 = $a7a9aa6df366a012$var$SODItem;


var $55f6aa546a60d23d$export$2e2bcd8739ae039 = (0, $a7a9aa6df366a012$export$2e2bcd8739ae039);








const $3dba689dd3c247a4$var$DATA = {
    type: (0, $hopDi$proptypes).oneOf([
        (0, $d60257e8dc27bf16$export$1cc98074061c90d2),
        (0, $d60257e8dc27bf16$export$153ab95c08227093),
        (0, $d60257e8dc27bf16$export$7d6712c2cb8377b2),
        (0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7)
    ]),
    Ent_PRIVILIGED: (0, $hopDi$proptypes).string,
    Ent_ENTITLEMENT_GLOSSARY: (0, $hopDi$proptypes).string,
    COMMENTS: (0, $hopDi$proptypes).string,
    CERT_USERKEY: (0, $hopDi$proptypes).string,
    CERT_ACCOUNTKEY: (0, $hopDi$proptypes).string,
    CERTIFIED: (0, $hopDi$proptypes).number,
    enableAction: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    availableAction: (0, $hopDi$proptypes).shape({
        approve: (0, $hopDi$proptypes).string,
        conditionalCertifiy: (0, $hopDi$proptypes).string,
        consult: (0, $hopDi$proptypes).string,
        reassign: (0, $hopDi$proptypes).string,
        reject: (0, $hopDi$proptypes).string
    }),
    ENTITLEMENTTYPE: (0, $hopDi$proptypes).string,
    id: (0, $hopDi$proptypes).string,
    ENTITLEMENT_VALUE: (0, $hopDi$proptypes).string,
    CERT_ROLEKEY: (0, $hopDi$proptypes).string,
    LASTCERTIFIED: (0, $hopDi$proptypes).string,
    isConsulted: (0, $hopDi$proptypes).bool,
    AUDIT_TRAIL: (0, $hopDi$proptypes).string,
    ACCESSTHROUGH: (0, $hopDi$proptypes).string,
    Ent_DESCRIPTION: (0, $hopDi$proptypes).string,
    Ent_DISPLAYNAME: (0, $hopDi$proptypes).string,
    LASTCERTIFIEDUSER: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).string,
        (0, $hopDi$proptypes).number
    ]),
    LASTCERTIFIEDCAMPAIGNNAME: (0, $hopDi$proptypes).string,
    ENDPOINT: (0, $hopDi$proptypes).string,
    CERT_ENTITLEMENT_VALUEKEY: (0, $hopDi$proptypes).string,
    tracker: (0, $hopDi$proptypes).shape({
        actions: (0, $hopDi$proptypes).objectOf((0, $hopDi$proptypes).shape({
            isSelected: (0, $hopDi$proptypes).bool,
            isLoading: (0, $hopDi$proptypes).bool
        })),
        id: (0, $hopDi$proptypes).string,
        isChecked: (0, $hopDi$proptypes).bool,
        isConnected: (0, $hopDi$proptypes).bool,
        level: (0, $hopDi$proptypes).number
    })
};
var $3dba689dd3c247a4$export$2e2bcd8739ae039 = $3dba689dd3c247a4$var$DATA;


var $708c26a04684b266$export$2e2bcd8739ae039 = (0, $3dba689dd3c247a4$export$2e2bcd8739ae039);


var $a514f7ada4c4e300$export$2e2bcd8739ae039 = (0, $708c26a04684b266$export$2e2bcd8739ae039);



function $2561d5c287a89532$var$CertsSidePanelBodyHistory({ data: data, isLoadingHistory: isLoadingHistory, isMobileWidth: isMobileWidth }) {
    const { globalDateFormat: globalDateFormat } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            isLoadingHistory && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                className: "SidePanelView-loader",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                    kind: "dots",
                    format: "inline",
                    color: "info",
                    size: "medium"
                })
            }),
            !isLoadingHistory && data?.sidePanel?.history?.audit?.length === 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                className: "CertsSidePanelBody-tabContentTimeLineBlock--noData",
                children: (0, $15388cfdc531d880$export$419658dfa295d7)((0, $d60257e8dc27bf16$export$9b67fda1e37e6e63))
            }),
            !isLoadingHistory && data?.sidePanel?.history?.audit?.length > 0 && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: isMobileWidth ? "CertsSidePanelBody-tabContentDescription--mobileResponsive" : "CertsSidePanelBody-tabContentDescription",
                        children: "Review the actions taken and comments made by certifiers during the current certification."
                    }),
                    data?.sidePanel?.history?.audit?.map((item, index)=>{
                        const actionDate = (0, $hopDi$moment).utc(item.actionDate, (0, $135adfecc1ed8f07$export$819c6a8205c73110)?.[item.actionDateFormat]).local().format(`${globalDateFormat?.toUpperCase()} hh:mm:ss`);
                        const checkIconType = item.action?.toLowerCase()?.includes("cancelled") || item.action?.toLowerCase()?.includes("consult") || item.action?.toLowerCase()?.includes("reassign") || item.action?.toLowerCase()?.includes("does not") || item.action?.trim()?.length === 0 ? "fill" : "outline";
                        let checkIconKind;
                        switch(true){
                            case item.action?.toLowerCase()?.includes("cancelled"):
                            case item.action?.toLowerCase()?.includes("consult"):
                            case item.action?.toLowerCase()?.includes("reassign"):
                            case item.action?.toLowerCase()?.includes("certified"):
                            case item.action?.toLowerCase()?.includes("does not"):
                            case item.action?.toLowerCase() === "change enddate" || item.action?.toLowerCase() === "changed enddate":
                            case item.action?.trim()?.length === 0:
                                checkIconKind = "normal";
                                break;
                            case item.action?.toLowerCase()?.includes("terminated"):
                            case item.action?.toLowerCase()?.includes("reject"):
                                checkIconKind = "critical";
                                break;
                            case item.action?.toLowerCase()?.includes("savi"):
                                checkIconKind = "savi";
                                break;
                            default:
                                checkIconKind = "success";
                                break;
                        }
                        let checkIconShape;
                        switch(true){
                            case item.action?.toLowerCase()?.includes("approve") && !item.action?.toLowerCase()?.includes("savi"):
                                checkIconShape = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.Approve?.icon;
                                break;
                            case item.action?.toLowerCase()?.includes("confirm manager") && !item.action?.toLowerCase()?.includes("date"):
                                checkIconShape = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.worksForMe?.icon;
                                break;
                            case item.action?.toLowerCase()?.includes("extendenddate") || item.action?.toLowerCase()?.includes("confirm manager") && item.action?.toLowerCase()?.includes("date"):
                                checkIconShape = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.conditionallyCertified?.icon;
                                break;
                            case item.action?.toLowerCase()?.includes("date"):
                                checkIconShape = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.conditionallyCertified?.icon;
                                break;
                            case item.action?.toLowerCase()?.includes("does not"):
                                checkIconShape = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.doesNotReport?.icon;
                                break;
                            case item.action?.toLowerCase()?.includes("reassign"):
                                checkIconShape = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.reassigned?.icon;
                                break;
                            case item.action?.trim()?.length === 0:
                                checkIconShape = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.icon;
                                break;
                            default:
                                checkIconShape = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)[item.action?.replaceAll(" ", "")]?.icon || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.icon;
                                break;
                        }
                        let checkIconColor;
                        switch(true){
                            case item.action?.toLowerCase()?.includes("approve") && !item.action?.toLowerCase()?.includes("savi"):
                                checkIconColor = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.Approve?.iconColor;
                                break;
                            case item.action?.toLowerCase()?.includes("confirm manager") && !item.action?.toLowerCase()?.includes("date"):
                                checkIconColor = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.worksForMe?.iconColor;
                                break;
                            case item.action?.toLowerCase()?.includes("extendenddate") || item.action?.toLowerCase()?.includes("confirm manager") && item.action?.toLowerCase()?.includes("date"):
                                checkIconColor = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.conditionallyCertified?.iconColor;
                                break;
                            case item.action?.toLowerCase()?.includes("does not"):
                                checkIconColor = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.doesNotReport?.iconColor;
                                break;
                            case item.action?.toLowerCase()?.includes("reassign"):
                                checkIconColor = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.reassigned?.iconColor;
                                break;
                            case item.action?.toLowerCase()?.includes("change enddate ") || item.action?.toLowerCase()?.includes("changed enddate "):
                                checkIconColor = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.conditionallyCertified?.iconColor;
                                break;
                            case item.action?.trim()?.length === 0:
                                checkIconColor = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.iconColor;
                                break;
                            default:
                                checkIconColor = (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)[item.action?.replaceAll(" ", "")]?.iconColor || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.iconColor;
                                break;
                        }
                        return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "CertsSidePanelBody-tabContentTimeLineBlock",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $596ca118e64bea36$export$2e2bcd8739ae039), {
                                    iconKind: checkIconShape,
                                    iconColor: checkIconColor,
                                    type: checkIconType,
                                    kind: checkIconKind,
                                    isSidePanelHistory: true,
                                    showTail: index !== data.sidePanel.history.audit.length - 1,
                                    dataTestId: "CertsSidePanelBodyHistory-SpbTimeLine"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: isMobileWidth ? "CertsSidePanelBody-tabContentTimeLineBlockBody--mobileResponsive" : "CertsSidePanelBody-tabContentTimeLineBlockBody",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1-bold",
                                            className: "CertsSidePanelBody-tabContentTimeLineBlockBodyTitle",
                                            children: item?.actionMessage || item.action || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.heading
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                            type: "compact",
                                            fieldData: {
                                                label: "Actioned On",
                                                // TODO: Might need post Beta release
                                                // item.action === 'cancelled'
                                                //   ? 'Resetted On'
                                                //   : auditHistoryActionType[item.action]?.date ||
                                                //     auditHistoryActionType?.default?.date,
                                                value: item.actionDate ? actionDate : ""
                                            }
                                        }, `${item.index}-1`),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                            type: "compact",
                                            fieldData: {
                                                label: "Actioned By",
                                                // TODO: Might need post Beta release
                                                // item.action === 'cancelled'
                                                //   ? 'Resetted By'
                                                //   : auditHistoryActionType[item.action]?.user ||
                                                //     auditHistoryActionType?.default?.user,
                                                value: item.actionUser
                                            }
                                        }, `${item.index}-2`),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                            type: "compact",
                                            fieldData: {
                                                label: (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)[item.action]?.other || (0, $0ae5e08f8dc713fb$export$2de30e2a30eba22b)?.default?.other,
                                                value: item?.comment && item?.comment?.trim()?.length !== 0 ? item?.comment : "-"
                                            }
                                        }, `${item.index}-3`)
                                    ]
                                })
                            ]
                        }, item.index);
                    })
                ]
            })
        ]
    });
}
$2561d5c287a89532$var$CertsSidePanelBodyHistory.propTypes = {
    data: (0, $hopDi$proptypes).shape((0, $a514f7ada4c4e300$export$2e2bcd8739ae039)).isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    isMobileWidth: (0, $hopDi$proptypes).bool
};
$2561d5c287a89532$var$CertsSidePanelBodyHistory.defaultProps = {
    isMobileWidth: false
};
var $2561d5c287a89532$export$2e2bcd8739ae039 = $2561d5c287a89532$var$CertsSidePanelBodyHistory;


var $e52ca6c769e8713d$export$2e2bcd8739ae039 = (0, $2561d5c287a89532$export$2e2bcd8739ae039);























const $883fa4dd903b96ab$export$fd41194cca4d2bb5 = "certs_access_request_history_button_id";
const $883fa4dd903b96ab$export$d9266982e2bf3d17 = "ACCESSTHROUGH";
const $883fa4dd903b96ab$export$21b23db9600618c1 = "getRoleRequestHistory";
const $883fa4dd903b96ab$export$2e3672dd0afb4dec = "getAccountRequestHistory";
const $883fa4dd903b96ab$export$34655c42ce8db75a = "getEntitlementRequestHistory";
const $883fa4dd903b96ab$export$3f6c2199b3c5b3b8 = "Role";
const $883fa4dd903b96ab$export$7e10a96f60b56a22 = "Account";
const $883fa4dd903b96ab$export$b7454c9538e36d35 = "Entitlement";
const $883fa4dd903b96ab$export$8c93dbb2d9701e4f = {
    USER: "-4",
    ROLE: "-2",
    ACCOUNT: "0",
    ENTITLEMENT: 1
};
const $883fa4dd903b96ab$export$29a3424b0df52ad0 = [
    "requestDate",
    "approvedDate",
    "taskCreateDate",
    "taskUpdateDate"
];
const $883fa4dd903b96ab$export$5082b66912e4bf81 = 2;
const $883fa4dd903b96ab$export$2f4d5cc064f654e2 = 500;



const $9824ba98b0b6cbde$export$32f471889249712e = (nodeData)=>{
    if (nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $883fa4dd903b96ab$export$8c93dbb2d9701e4f).ROLE) return 0, $883fa4dd903b96ab$export$3f6c2199b3c5b3b8;
    if (nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $883fa4dd903b96ab$export$8c93dbb2d9701e4f).ACCOUNT) return 0, $883fa4dd903b96ab$export$7e10a96f60b56a22;
    return 0, $883fa4dd903b96ab$export$b7454c9538e36d35;
};
var $9824ba98b0b6cbde$export$2e2bcd8739ae039 = $9824ba98b0b6cbde$export$32f471889249712e;
















function $3102c9244ab5724c$var$ARSAccordian({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        className: `ARSAccordian ${className}`,
        children: children
    });
}
$3102c9244ab5724c$var$ARSAccordian.propTypes = {
    children: (0, $hopDi$proptypes).node.isRequired,
    className: (0, $hopDi$proptypes).string
};
$3102c9244ab5724c$var$ARSAccordian.defaultProps = {
    className: null
};
var $3102c9244ab5724c$export$2e2bcd8739ae039 = $3102c9244ab5724c$var$ARSAccordian;


var $2ba3f665d96bbbd7$export$2e2bcd8739ae039 = (0, $3102c9244ab5724c$export$2e2bcd8739ae039);








const $790d2b79af5c7639$var$KINDS = {
    fill: "fill",
    outline: "outline",
    none: "none"
};
const $790d2b79af5c7639$var$ICONS = {
    check: "check",
    reject: "reject"
};
function $790d2b79af5c7639$var$ARSTimeLineIconLarge({ kind: kind, head: head, tail: tail, iconKind: iconKind }) {
    const iconClass = (0, $hopDi$classnames)("ARSTimeLineIconLarge-icon", head === $790d2b79af5c7639$var$KINDS.fill ? "ARSTimeLineIconLarge-icon--fill" : "ARSTimeLineIconLarge-icon--outline", kind === "critical" && "ARSTimeLineIconLarge-icon--critical");
    const lineClass = (0, $hopDi$classnames)("ARSTimeLineIconLarge-line", tail === $790d2b79af5c7639$var$KINDS.fill ? "ARSTimeLineIconLarge-line--fill" : "ARSTimeLineIconLarge-line--outline", tail === $790d2b79af5c7639$var$KINDS.none && "ARSTimeLineIconLarge-line--none", kind === "critical" && "ARSTimeLineIconLarge-line--critical");
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "ARSTimeLineIconLarge",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: iconClass,
                children: head === $790d2b79af5c7639$var$KINDS.fill && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: iconKind === $790d2b79af5c7639$var$ICONS.reject ? "Reject" : "check",
                    color: "neutral-000",
                    size: "xxSmall"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: lineClass,
                children: tail === $790d2b79af5c7639$var$KINDS.outline && [
                    ...Array(10).keys()
                ].map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: `ARSTimeLineIconLarge-lineChild--outline ${kind === "critical" ? "ARSTimeLineIconLarge-lineChild--critical" : ""}`
                    }, key))
            })
        ]
    });
}
$790d2b79af5c7639$var$ARSTimeLineIconLarge.propTypes = {
    kind: (0, $hopDi$proptypes).string,
    head: (0, $hopDi$proptypes).oneOf(Object.values($790d2b79af5c7639$var$KINDS)),
    tail: (0, $hopDi$proptypes).oneOf(Object.values($790d2b79af5c7639$var$KINDS)),
    iconKind: (0, $hopDi$proptypes).oneOf(Object.values($790d2b79af5c7639$var$ICONS))
};
$790d2b79af5c7639$var$ARSTimeLineIconLarge.defaultProps = {
    kind: "info",
    head: $790d2b79af5c7639$var$KINDS.fill,
    tail: $790d2b79af5c7639$var$KINDS.fill,
    iconKind: $790d2b79af5c7639$var$ICONS.check
};
var $790d2b79af5c7639$export$2e2bcd8739ae039 = $790d2b79af5c7639$var$ARSTimeLineIconLarge;


var $663879d0d2cd5375$export$2e2bcd8739ae039 = (0, $790d2b79af5c7639$export$2e2bcd8739ae039);







const $2dadcc64a8aa0264$var$KINDS = {
    fill: "fill",
    outline: "outline",
    none: "none"
};
function $2dadcc64a8aa0264$var$ARSTimeLineIconSmall({ kind: kind, head: head, tail: tail, isActive: isActive }) {
    const iconClass = (0, $hopDi$classnames)("ARSTimeLineIconSmall-icon", isActive && kind !== "critical" && "ARSTimeLineIconSmall-icon--active", head === $2dadcc64a8aa0264$var$KINDS.fill ? "ARSTimeLineIconSmall-icon--fill" : "ARSTimeLineIconSmall-icon--outline", kind === "critical" && head === $2dadcc64a8aa0264$var$KINDS.fill && "ARSTimeLineIconSmall-icon--critical");
    const lineClass = (0, $hopDi$classnames)("ARSTimeLineIconSmall-line", tail === $2dadcc64a8aa0264$var$KINDS.fill ? "ARSTimeLineIconSmall-line--fill" : "ARSTimeLineIconSmall-line--outline", tail === $2dadcc64a8aa0264$var$KINDS.none && "ARSTimeLineIconSmall-line--none", kind === "critical" && tail === $2dadcc64a8aa0264$var$KINDS.fill && "ARSTimeLineIconSmall-line--critical");
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "ARSTimeLineIconSmall",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: iconClass
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: lineClass,
                children: tail === $2dadcc64a8aa0264$var$KINDS.outline && [
                    ...Array(10).keys()
                ].map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: `ARSTimeLineIconSmall-lineChild--outline ${kind === "critical" ? "ARSTimeLineIconSmall-lineChild--critical" : ""}`
                    }, key))
            })
        ]
    });
}
$2dadcc64a8aa0264$var$ARSTimeLineIconSmall.propTypes = {
    kind: (0, $hopDi$proptypes).string,
    head: (0, $hopDi$proptypes).oneOf(Object.values($2dadcc64a8aa0264$var$KINDS)),
    tail: (0, $hopDi$proptypes).oneOf(Object.values($2dadcc64a8aa0264$var$KINDS)),
    isActive: (0, $hopDi$proptypes).bool
};
$2dadcc64a8aa0264$var$ARSTimeLineIconSmall.defaultProps = {
    kind: "info",
    head: $2dadcc64a8aa0264$var$KINDS.fill,
    tail: $2dadcc64a8aa0264$var$KINDS.fill,
    isActive: false
};
var $2dadcc64a8aa0264$export$2e2bcd8739ae039 = $2dadcc64a8aa0264$var$ARSTimeLineIconSmall;


var $d62c7090591133a8$export$2e2bcd8739ae039 = (0, $2dadcc64a8aa0264$export$2e2bcd8739ae039);



function $777411d93493129d$var$ARSApproverTile({ approverTileData: approverTileData, taskSectionTileData: taskSectionTileData, globalDateFormat: globalDateFormat }) {
    if (!approverTileData) return null;
    const intl = (0, $hopDi$useIntl)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const { accessApproverSectionLabelKey: accessApproverSectionLabelKey, reviewMethodLabelKey: // accessApproverSectionLabelValue,
    reviewMethodLabelKey, accessApproversSectionLabelKey: // reviewMethodLabelValue,
    accessApproversSectionLabelKey, reviewMethodMessageKey: reviewMethodMessageKey, accessApprovers: // accessApproversSectionLabelValue,
    accessApprovers, messageKeys: messageKeys } = approverTileData;
    const accessApproversKeyMap = Object?.keys(accessApprovers);
    const shouldRenderApproversList = Boolean(accessApproversKeyMap?.length > 0);
    const assignedToList = accessApproversKeyMap?.reduce((total, item)=>{
        const temp = accessApprovers?.[item]?.accessApprovers?.assignedTo || [];
        const tempSanitzed = temp?.map((name)=>{
            if (name.startsWith("(") && name.endsWith(")")) {
                const sanitizedName = name.substring(1, name.length - 2);
                return sanitizedName;
            }
            return name;
        });
        return [
            ...total,
            ...tempSanitzed
        ];
    }, []);
    const shouldShowAssignedToList = Boolean(reviewMethodLabelKey !== "AutoApprove");
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $2ba3f665d96bbbd7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $663879d0d2cd5375$export$2e2bcd8739ae039), {
                tail: taskSectionTileData ? "fill" : "none"
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: "AccessRequestHistoryBody-accordianBox",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h3",
                        className: "AccessRequestHistoryBody-accordianBoxTitle",
                        children: messages[accessApproverSectionLabelKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(accessApproverSectionLabelKey))
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "AccessRequestHistoryBody-accordianBoxBody",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                style: {
                                    width: shouldShowAssignedToList ? "calc(25% - .75rem)" : ""
                                },
                                className: "AccessRequestHistoryBody-accordianBoxBodyTile",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body3",
                                        children: messages[reviewMethodMessageKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(reviewMethodMessageKey))
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        className: "AccessRequestHistoryBody-accordianBoxBodyHighlighted",
                                        children: messages[reviewMethodLabelKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(reviewMethodLabelKey))
                                    })
                                ]
                            }),
                            shouldShowAssignedToList && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                style: {
                                    width: "75%"
                                },
                                className: "AccessRequestHistoryBody-accordianBoxBodyTile",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body3",
                                        children: messages[messageKeys?.taskOwner] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(messageKeys?.taskOwner))
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        className: "AccessRequestHistoryBody-accordianBoxBodyHighlighted",
                                        children: assignedToList?.length > (0, $883fa4dd903b96ab$export$5082b66912e4bf81) ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                            children: [
                                                assignedToList.slice(0, (0, $883fa4dd903b96ab$export$5082b66912e4bf81))?.map((item)=>/*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                        className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                                        children: `${item}, `
                                                    })),
                                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                                    openDelay: (0, $883fa4dd903b96ab$export$2f4d5cc064f654e2),
                                                    text: assignedToList?.join(", "),
                                                    maxWidth: "20rem",
                                                    placement: "top-end",
                                                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                        className: "AccessRequestHistoryBody-accordianBoxBodyHighlighted--withToolTip",
                                                        children: `+${assignedToList.length - (0, $883fa4dd903b96ab$export$5082b66912e4bf81)} more`
                                                    })
                                                })
                                            ]
                                        }) : assignedToList?.map((item, index)=>/*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                                children: `${item}${index === assignedToList.length - 1 ? "" : ", "}`
                                            }))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $2ba3f665d96bbbd7$export$2e2bcd8739ae039), {
                        className: "subbody",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $d62c7090591133a8$export$2e2bcd8739ae039), {
                                tail: "none"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                tag: "div",
                                className: "AccessRequestHistoryBody-accordianBox--subbox",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h3",
                                        className: "AccessRequestHistoryBody-accordianBoxTitle--subbody",
                                        children: messages[accessApproversSectionLabelKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(accessApproversSectionLabelKey))
                                    }),
                                    shouldRenderApproversList && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                        tag: "div",
                                        className: "AccessRequestHistoryBody-accordianBoxSubBody--subbody",
                                        children: accessApproversKeyMap?.map((accessApproverKey, index)=>{
                                            const approverKeyData = accessApprovers?.[accessApproverKey]?.accessApprovers;
                                            const approverKeyDataMap = Object?.keys(approverKeyData);
                                            const showReviewMethodHeaderLabel = accessApprovers?.[accessApproverKey]?.showReviewMethodHeaderLabel;
                                            const reviewMethodHeaderLabelKey1 = accessApprovers?.[accessApproverKey]?.reviewMethodHeaderLabelKey1;
                                            const reviewMethodHeaderLabelKey2 = accessApprovers?.[accessApproverKey]?.reviewMethodHeaderLabelKey2;
                                            const reviewMethodHeaderLabelValue = accessApprovers?.[accessApproverKey]?.reviewMethodHeaderLabelValue;
                                            return approverKeyDataMap?.length > 0 ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                                children: [
                                                    showReviewMethodHeaderLabel && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                        kind: "body2-bold",
                                                        className: "AccessRequestHistoryBody-accordianBoxTitle--subbody",
                                                        children: reviewMethodHeaderLabelKey1 && reviewMethodHeaderLabelKey2 ? `${messages[reviewMethodHeaderLabelKey1] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(reviewMethodHeaderLabelKey1))} \xb7 ${messages[reviewMethodHeaderLabelKey2] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(reviewMethodHeaderLabelKey2))}` : `${reviewMethodHeaderLabelValue}`
                                                    }),
                                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                                        tag: "div",
                                                        className: `AccessRequestHistoryBody-accordianBoxSubBody--subbodyList ${showReviewMethodHeaderLabel ? "shifted" : ""} ${index === accessApproversKeyMap.length - 1 ? "lastItem" : ""}`,
                                                        children: approverKeyDataMap?.map((key)=>{
                                                            let fieldValue = approverKeyData?.[key];
                                                            if ((0, $883fa4dd903b96ab$export$29a3424b0df52ad0).includes(key)) fieldValue = (0, $hopDi$moment).utc(fieldValue).local().format(`${globalDateFormat?.toUpperCase()} hh:mm:ss`);
                                                            if (Array.isArray(fieldValue)) fieldValue = fieldValue?.length > (0, $883fa4dd903b96ab$export$5082b66912e4bf81) ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                                                children: [
                                                                    fieldValue.slice(0, (0, $883fa4dd903b96ab$export$5082b66912e4bf81))?.map((item)=>/*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                            className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                                                            children: `${item}, `
                                                                        })),
                                                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                                                        openDelay: (0, $883fa4dd903b96ab$export$2f4d5cc064f654e2),
                                                                        text: fieldValue?.join(", "),
                                                                        maxWidth: "20rem",
                                                                        placement: "top-end",
                                                                        trigger: /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                            className: "AccessRequestHistoryBody-accordianBoxBodyHighlighted--withToolTip",
                                                                            children: `+${fieldValue.length - (0, $883fa4dd903b96ab$export$5082b66912e4bf81)} more`
                                                                        })
                                                                    })
                                                                ]
                                                            }) : fieldValue?.map((item, idx)=>/*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                    className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                                                    children: `${item}${idx === fieldValue.length - 1 ? "" : ", "}`
                                                                }));
                                                            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$react).Fragment, {
                                                                children: !showReviewMethodHeaderLabel ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                                                    children: [
                                                                        key !== "approveMethod" && /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                                                                            className: "AccessRequestHistoryModalSubTitle-textBoxKey",
                                                                            children: [
                                                                                `${messages[messageKeys?.[key]] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(messageKeys?.[key]))}:`,
                                                                                "\xa0"
                                                                            ]
                                                                        }),
                                                                        Array.isArray(approverKeyData?.[key]) ? fieldValue : /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                            className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                                                            children: fieldValue
                                                                        }),
                                                                        /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                            className: "AccessRequestHistoryModalSubTitle-textBoxTerminate"
                                                                        })
                                                                    ]
                                                                }) : key !== "approveMethod" && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                                                                            className: "AccessRequestHistoryModalSubTitle-textBoxKey",
                                                                            children: [
                                                                                `${messages[messageKeys?.[key]] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(messageKeys?.[key]))}:`,
                                                                                "\xa0"
                                                                            ]
                                                                        }),
                                                                        Array.isArray(approverKeyData?.[key]) ? fieldValue : /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                            className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                                                            children: fieldValue
                                                                        }),
                                                                        /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                                            className: "AccessRequestHistoryModalSubTitle-textBoxTerminate"
                                                                        })
                                                                    ]
                                                                })
                                                            }, `${accessApproverKey}-${key}`);
                                                        })
                                                    }, accessApproverKey)
                                                ]
                                            }) : null;
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$777411d93493129d$var$ARSApproverTile.propTypes = {
    approverTileData: (0, $hopDi$proptypes).shape({
        accessApproverSectionLabelKey: (0, $hopDi$proptypes).string,
        accessApproverSectionLabelValue: (0, $hopDi$proptypes).string,
        reviewMethodLabelKey: (0, $hopDi$proptypes).string,
        reviewMethodLabelValue: (0, $hopDi$proptypes).string,
        reviewMethodMessageKey: (0, $hopDi$proptypes).string,
        reviewMethod: (0, $hopDi$proptypes).string,
        accessApproversSectionLabelKey: (0, $hopDi$proptypes).string,
        accessApproversSectionLabelValue: (0, $hopDi$proptypes).string,
        accessApprovers: (0, $hopDi$proptypes).shape({}),
        messageKeys: (0, $hopDi$proptypes).shape({
            taskOwner: (0, $hopDi$proptypes).string
        })
    }).isRequired,
    taskSectionTileData: (0, $hopDi$proptypes).shape({}).isRequired,
    globalDateFormat: (0, $hopDi$proptypes).string.isRequired
};
var $777411d93493129d$export$2e2bcd8739ae039 = $777411d93493129d$var$ARSApproverTile;














function $7b1ffbe96bc84776$var$ARSRequestTile({ requestTileData: requestTileData, approverTileData: approverTileData, globalDateFormat: globalDateFormat }) {
    if (!requestTileData) return null;
    const intl = (0, $hopDi$useIntl)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const { arsRequestSectionLabelKey: arsRequestSectionLabelKey, arsRequestMap: // arsRequestSectionLabelValue,
    arsRequestMap, messageKeys: messageKeys } = requestTileData;
    const requesterKeyMap = Object?.keys(arsRequestMap);
    const shouldRenderRequesterList = Boolean(requesterKeyMap?.length > 0);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $2ba3f665d96bbbd7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $663879d0d2cd5375$export$2e2bcd8739ae039), {
                tail: approverTileData ? "fill" : "none"
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: "AccessRequestHistoryBody-accordianBox",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h3",
                        className: "AccessRequestHistoryBody-accordianBoxTitle",
                        children: messages?.[arsRequestSectionLabelKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(arsRequestSectionLabelKey))
                    }),
                    shouldRenderRequesterList && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "AccessRequestHistoryBody-accordianBoxBody",
                        children: requesterKeyMap?.map((key)=>{
                            let fieldValue = arsRequestMap?.[key];
                            if ((0, $883fa4dd903b96ab$export$29a3424b0df52ad0).includes(key)) fieldValue = (0, $hopDi$moment).utc(fieldValue).local().format(`${globalDateFormat?.toUpperCase()} hh:mm:ss`);
                            return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                tag: "div",
                                className: "AccessRequestHistoryBody-accordianBoxBodyTile",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body3",
                                        children: messageKeys?.[messageKeys?.[key]] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(messageKeys?.[key]))
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        className: "AccessRequestHistoryBody-accordianBoxBodyHighlighted",
                                        children: fieldValue
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
}
$7b1ffbe96bc84776$var$ARSRequestTile.propTypes = {
    requestTileData: (0, $hopDi$proptypes).shape({
        arsRequestSectionLabelKey: (0, $hopDi$proptypes).string,
        arsRequestSectionLabelValue: (0, $hopDi$proptypes).string,
        arsRequestMap: (0, $hopDi$proptypes).shape({}),
        messageKeys: (0, $hopDi$proptypes).shape({})
    }).isRequired,
    approverTileData: (0, $hopDi$proptypes).shape({}).isRequired,
    globalDateFormat: (0, $hopDi$proptypes).string.isRequired
};
var $7b1ffbe96bc84776$export$2e2bcd8739ae039 = $7b1ffbe96bc84776$var$ARSRequestTile;















const $cc7a731588783384$var$FIELDS_TO_EXCLUDE = [
    "arsTaskLabelKey1",
    "arsTaskLabelKey2",
    "arsTaskLabel",
    "taskCreateDate"
];
function $cc7a731588783384$var$ARSTaskTile({ taskSectionTileData: taskSectionTileData, globalDateFormat: globalDateFormat }) {
    if (!taskSectionTileData) return null;
    const intl = (0, $hopDi$useIntl)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const { arsTaskSectionLabelKey: arsTaskSectionLabelKey, arsTaskLabelKey1: // arsTaskSectionLabeValue,
    arsTaskLabelKey1, arsTaskLabelKey2: arsTaskLabelKey2, arsTaskSectionLabelValue: arsTaskSectionLabelValue, arsTaskMap: arsTaskMap, arsTaskList: arsTaskList, messageKeys: messageKeys } = taskSectionTileData;
    const taskList = arsTaskList || [
        {
            ...arsTaskMap,
            arsTaskLabelKey1: arsTaskLabelKey1,
            arsTaskLabelKey2: arsTaskLabelKey2,
            arsTaskLabel: arsTaskSectionLabelValue
        }
    ];
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $2ba3f665d96bbbd7$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $663879d0d2cd5375$export$2e2bcd8739ae039), {
                tail: "none"
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: "AccessRequestHistoryBody-accordianBox",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h3",
                        className: "AccessRequestHistoryBody-accordianBoxTitle",
                        children: messages[arsTaskSectionLabelKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(arsTaskSectionLabelKey))
                    }),
                    taskList?.length > 0 && taskList.map((task, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $2ba3f665d96bbbd7$export$2e2bcd8739ae039), {
                            className: "subbody--1",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $d62c7090591133a8$export$2e2bcd8739ae039), {
                                    tail: index === taskList.length - 1 ? "none" : "fill"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    tag: "div",
                                    className: "AccessRequestHistoryBody-accordianBox--subbox",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "h3",
                                            className: "AccessRequestHistoryBody-accordianBoxTitle--subbody",
                                            children: task?.arsTaskLabelKey1 && task?.arsTaskLabelKey2 ? `${messageKeys?.[task?.arsTaskLabelKey1] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(task?.arsTaskLabelKey1))} \xb7 ${messageKeys?.[task?.arsTaskLabelKey2] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(task?.arsTaskLabelKey2))}` : `${task?.arsTaskLabel}`
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                            tag: "div",
                                            className: `AccessRequestHistoryBody-accordianBoxSubBody--subbodyList ${index === task.length - 1 ? "lastItem" : ""}`,
                                            children: Object?.keys(task)?.map((key)=>{
                                                if ($cc7a731588783384$var$FIELDS_TO_EXCLUDE.includes(key)) return null;
                                                let fieldValue = task?.[key];
                                                if ((0, $883fa4dd903b96ab$export$29a3424b0df52ad0).includes(key)) fieldValue = (0, $hopDi$moment).utc(fieldValue).local().format(`${globalDateFormat?.toUpperCase()} hh:mm:ss`);
                                                if (Array.isArray(fieldValue)) fieldValue = JSON.stringify(fieldValue);
                                                return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$react).Fragment, {
                                                    children: [
                                                        key !== "taskLabel" && /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                                                            className: "AccessRequestHistoryModalSubTitle-textBoxKey",
                                                            children: [
                                                                `${messages[messageKeys?.[key]] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(messageKeys?.[key]))}:`,
                                                                "\xa0"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                            className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                                            children: fieldValue
                                                        }),
                                                        /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                                            className: "AccessRequestHistoryModalSubTitle-textBoxTerminate"
                                                        })
                                                    ]
                                                }, `${task?.taskId}-${key}`);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, task?.taskId))
                ]
            })
        ]
    });
}
$cc7a731588783384$var$ARSTaskTile.propTypes = {
    taskSectionTileData: (0, $hopDi$proptypes).shape({
        arsTaskSectionLabelKey: (0, $hopDi$proptypes).string,
        arsTaskSectionLabeValue: (0, $hopDi$proptypes).string,
        arsTaskLabelKey1: (0, $hopDi$proptypes).string,
        arsTaskLabelKey2: (0, $hopDi$proptypes).string,
        arsTaskSectionLabelValue: (0, $hopDi$proptypes).string,
        arsTaskMap: (0, $hopDi$proptypes).shape({}),
        arsTaskList: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})),
        messageKeys: (0, $hopDi$proptypes).shape({})
    }).isRequired,
    globalDateFormat: (0, $hopDi$proptypes).string.isRequired
};
var $cc7a731588783384$export$2e2bcd8739ae039 = $cc7a731588783384$var$ARSTaskTile;


function $73be7037e1a95539$var$AccessRequestHistoryBody({ isError: isError, isLoading: isLoading, data: data, arsTaskPayload: arsTaskPayload, closeAccessRequestHistoryModal: closeAccessRequestHistoryModal, reTriggerAccessRequestHistoryModal: reTriggerAccessRequestHistoryModal, messageKeys: messageKeys, globalDateFormat: globalDateFormat }) {
    const hasDataAvailable = Boolean(data?.requestHistoryFound && !isLoading);
    const getArsObject = ()=>{
        const arsKind = (0, $9824ba98b0b6cbde$export$32f471889249712e)(arsTaskPayload);
        if (arsKind === (0, $883fa4dd903b96ab$export$3f6c2199b3c5b3b8)) return "role";
        if (arsKind === (0, $883fa4dd903b96ab$export$7e10a96f60b56a22)) return "account";
        if (arsKind === (0, $883fa4dd903b96ab$export$b7454c9538e36d35)) return "entitlement";
        return "";
    };
    const requestTileData = hasDataAvailable && {
        arsRequestSectionLabelKey: data?.arsRequestSectionLabelKey,
        arsRequestSectionLabelValue: data?.arsRequestSectionLabelValue,
        arsRequestMap: data?.arsRequestMap,
        messageKeys: messageKeys
    };
    const approverTileData = hasDataAvailable && {
        accessApproverSectionLabelKey: data?.accessApproverSectionLabelKey,
        accessApproverSectionLabelValue: data?.accessApproverSectionLabelValue,
        reviewMethodLabelKey: data?.reviewMethodLabelKey,
        reviewMethodLabelValue: data?.reviewMethodLabelValue,
        reviewMethodMessageKey: data?.reviewMethodMessageKey,
        accessApproversSectionLabelKey: data?.accessApproversSectionLabelKey,
        accessApproversSectionLabelValue: data?.accessApproversSectionLabelValue,
        accessApprovers: data?.accessApprovers,
        messageKeys: messageKeys
    };
    const taskSectionTileData = hasDataAvailable && {
        arsTaskSectionLabelKey: data?.arsTaskSectionLabelKey,
        arsTaskSectionLabeValue: data?.arsTaskSectionLabeValue,
        arsTaskLabelKey1: data?.arsTaskLabelKey1,
        arsTaskLabelKey2: data?.arsTaskLabelKey2,
        arsTaskSectionLabelValue: data?.arsTaskSectionLabelValue,
        arsTaskMap: data?.arsTaskMap,
        arsTaskList: data?.arsTaskList,
        messageKeys: messageKeys
    };
    const renderArsModalBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "AccessRequestHistoryBody-wrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "large",
                className: "AccessRequestHistoryBody-loader",
                dataTestId: "AccessRequestHistoryBodyLoaderTestId"
            })
        });
        if (isError) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "AccessRequestHistoryBody-wrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "ReviewAndSubmitModal-bodyError",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h2",
                        children: "Couldn't Load"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: "The History didn't load properly due to a network issue. Please refresh or try again later."
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "ReviewAndSubmitModal-bodyErrorButtons",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "filled",
                                onClick: reTriggerAccessRequestHistoryModal,
                                size: "medium",
                                children: "Refresh"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "ghost",
                                size: "medium",
                                onClick: closeAccessRequestHistoryModal,
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        });
        if (hasDataAvailable) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            tag: "div",
            className: "AccessRequestHistoryBody-wrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $7b1ffbe96bc84776$export$2e2bcd8739ae039), {
                    requestTileData: requestTileData,
                    approverTileData: approverTileData,
                    globalDateFormat: globalDateFormat
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $777411d93493129d$export$2e2bcd8739ae039), {
                    approverTileData: approverTileData,
                    taskSectionTileData: taskSectionTileData,
                    globalDateFormat: globalDateFormat
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $cc7a731588783384$export$2e2bcd8739ae039), {
                    taskSectionTileData: taskSectionTileData,
                    globalDateFormat: globalDateFormat
                })
            ]
        });
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: "AccessRequestHistoryBody-wrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                className: "AccessRequestHistoryBody-NoDataAvailable",
                children: `There is no request associated with this ${getArsObject()}.`
            })
        });
    };
    return renderArsModalBody();
}
$73be7037e1a95539$var$AccessRequestHistoryBody.propTypes = {
    isError: (0, $hopDi$proptypes).bool.isRequired,
    isLoading: (0, $hopDi$proptypes).bool.isRequired,
    data: (0, $hopDi$proptypes).shape({
        requestHistoryFound: (0, $hopDi$proptypes).bool
    }),
    arsTaskPayload: (0, $hopDi$proptypes).shape({}),
    closeAccessRequestHistoryModal: (0, $hopDi$proptypes).func.isRequired,
    reTriggerAccessRequestHistoryModal: (0, $hopDi$proptypes).func.isRequired,
    messageKeys: (0, $hopDi$proptypes).shape({}).isRequired,
    globalDateFormat: (0, $hopDi$proptypes).string.isRequired
};
$73be7037e1a95539$var$AccessRequestHistoryBody.defaultProps = {
    data: null
};
var $73be7037e1a95539$export$2e2bcd8739ae039 = $73be7037e1a95539$var$AccessRequestHistoryBody;


var $cc4b3ff99c216fd1$export$2e2bcd8739ae039 = (0, $73be7037e1a95539$export$2e2bcd8739ae039);











const $ea42dd75a8569c98$var$FIELDS_TO_EXCLUDE = [
    "securitySystem"
];
function $ea42dd75a8569c98$var$AccessRequestHistorySubTitle({ isError: isError, isLoading: isLoading, data: data, messageKeys: messageKeys }) {
    const intl = (0, $hopDi$useIntl)();
    const { ECM_URL: ECM_URL } = (0, $e7628c995f405891$export$695b5822e913940f)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const hasContentForSubtitles = Boolean(Object?.keys(data)?.length > 0);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: "AccessRequestHistoryModalSubTitle",
        children: [
            !isError && isLoading && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "small"
            }),
            !isError && !isLoading && hasContentForSubtitles && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "AccessRequestHistoryModalSubTitle-text",
                children: Object.keys(data)?.map((key)=>{
                    if (!$ea42dd75a8569c98$var$FIELDS_TO_EXCLUDE.includes(key)) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$react).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                                className: "AccessRequestHistoryModalSubTitle-textBoxKey",
                                children: [
                                    `${messages[messageKeys?.[key]] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(messageKeys?.[key]))}:`,
                                    "\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                className: "AccessRequestHistoryModalSubTitle-textBoxValue",
                                children: data[key]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                className: "AccessRequestHistoryModalSubTitle-textBoxTerminate"
                            })
                        ]
                    }, key);
                    return null;
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                url: `${ECM_URL}/jbpmworkflowmanagement/showmyhistoryrequests`,
                text: "View Request History",
                color: "brand",
                size: "large",
                suffixIconKind: "Jump"
            })
        ]
    });
}
$ea42dd75a8569c98$var$AccessRequestHistorySubTitle.propTypes = {
    isError: (0, $hopDi$proptypes).bool.isRequired,
    isLoading: (0, $hopDi$proptypes).bool.isRequired,
    data: (0, $hopDi$proptypes).shape({}),
    messageKeys: (0, $hopDi$proptypes).shape({})
};
$ea42dd75a8569c98$var$AccessRequestHistorySubTitle.defaultProps = {
    data: null,
    messageKeys: null
};
var $ea42dd75a8569c98$export$2e2bcd8739ae039 = $ea42dd75a8569c98$var$AccessRequestHistorySubTitle;





function $0b9d8820b93e64c2$var$AccessRequestHistory() {
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, certKey: certKey, accessRequestHistory: { arsData: arsData, arsTaskPayload: arsTaskPayload, isOpen: isOpen, isLoading: isArsLoading, isError: isArsError }, globalDateFormat: globalDateFormat } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [isError, setIsError] = (0, $hopDi$useState)(false);
    const [isLoading, setIsLoading] = (0, $hopDi$useState)(false);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mobileXlargeQuery.value <= mediaQueryValue;
    // TODO: This needs to be checked later
    // const { messages } = useSelector((state) => state?.user);
    // const modalTitle =
    //   messages[arsData?.requestAccessHistoryHeaderLabelKey] ||
    //   arsData?.requestAccessHistoryHeaderLabelValue ||
    //   'Access Request History';
    const modalTitle = "Access Request History";
    const callApiForArs = ()=>{
        const arsKind = (0, $9824ba98b0b6cbde$export$32f471889249712e)(arsTaskPayload);
        if (arsKind === (0, $883fa4dd903b96ab$export$3f6c2199b3c5b3b8)) {
            const payload = {
                cert_rolekey: arsTaskPayload?.CERT_ROLEKEY,
                cert_userkey: arsTaskPayload?.CERT_USERKEY
            };
            dispatch((0, $d623f23401a154f0$export$c45c025fc9b885f7)(certKey, (0, $883fa4dd903b96ab$export$21b23db9600618c1), payload));
        }
        if (arsKind === (0, $883fa4dd903b96ab$export$7e10a96f60b56a22)) {
            const payload = {
                cert_accountkey: arsTaskPayload?.CERT_ACCOUNTKEY,
                cert_userkey: arsTaskPayload?.CERT_USERKEY
            };
            dispatch((0, $d623f23401a154f0$export$c45c025fc9b885f7)(certKey, (0, $883fa4dd903b96ab$export$2e3672dd0afb4dec), payload));
        }
        if (arsKind === (0, $883fa4dd903b96ab$export$b7454c9538e36d35)) {
            const payload = {
                arstaskkey: arsTaskPayload?.ARSTASKKEY
            };
            dispatch((0, $d623f23401a154f0$export$c45c025fc9b885f7)(certKey, (0, $883fa4dd903b96ab$export$34655c42ce8db75a), payload));
        }
    };
    (0, $hopDi$useEffect)(()=>{
        setIsLoading(isArsLoading);
    }, [
        isArsLoading
    ]);
    (0, $hopDi$useEffect)(()=>{
        setIsError(isArsError);
    }, [
        isArsError
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isOpen && isLoading) callApiForArs();
    }, [
        isOpen,
        isLoading
    ]);
    const closeAccessRequestHistoryModal = ()=>{
        // Don't need to dispatch setIsARSModalLoading as when API is called it is already set to true
        dispatch((0, $d623f23401a154f0$export$6905b0d830e88406)(false, null));
    };
    const reTriggerAccessRequestHistoryModal = ()=>{
        dispatch((0, $d623f23401a154f0$export$fee47e6aac44de0e)(true));
    };
    const messageKeys = {
        ...arsData?.requestAccessAttributeMessageKeys,
        ...arsData?.arsRequestMapMessageKeys,
        ...arsData?.arsTaskMessageKeys,
        ...arsData?.messageKeys
    };
    // TODO: To fix why the modal is going behind the carousel till then this useEffect is kept here
    (0, $hopDi$useEffect)(()=>{
        closeAccessRequestHistoryModal();
    }, [
        isMobileWidth
    ]);
    if (isMobileWidth && isOpen) {
        const getHeaderContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "AccessRequestHistoryModal-mobileResponsiveHeaderText",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h1",
                                children: modalTitle
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $ea42dd75a8569c98$export$2e2bcd8739ae039), {
                                isError: isError,
                                isLoading: isLoading,
                                data: {
                                    ...arsData?.requestAccessAttributeMap,
                                    ...arsData?.requestHistoryFound ? {
                                        requestId: arsData?.requestId
                                    } : {}
                                },
                                messageKeys: messageKeys || {}
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Close"
                        }),
                        onClick: closeAccessRequestHistoryModal
                    })
                ]
            });
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
            fixedHeight: 32,
            isOpen: isOpen,
            setIsOpen: closeAccessRequestHistoryModal,
            className: "AccessRequestHistoryModal-mobileResponsive",
            headerContent: getHeaderContent(),
            content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $cc4b3ff99c216fd1$export$2e2bcd8739ae039), {
                isError: isError,
                isLoading: isLoading,
                data: arsData,
                arsTaskPayload: arsTaskPayload,
                closeAccessRequestHistoryModal: closeAccessRequestHistoryModal,
                reTriggerAccessRequestHistoryModal: reTriggerAccessRequestHistoryModal,
                messageKeys: messageKeys || {},
                globalDateFormat: globalDateFormat
            })
        });
    }
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: "AccessRequestHistoryModal",
        onClose: closeAccessRequestHistoryModal,
        isOpen: isOpen,
        title: modalTitle,
        subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $ea42dd75a8569c98$export$2e2bcd8739ae039), {
            isError: isError,
            isLoading: isLoading,
            data: {
                ...arsData?.requestAccessAttributeMap,
                ...arsData?.requestHistoryFound ? {
                    requestId: arsData?.requestId
                } : {}
            },
            messageKeys: messageKeys || {}
        }),
        contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $cc4b3ff99c216fd1$export$2e2bcd8739ae039), {
            isError: isError,
            isLoading: isLoading,
            data: arsData,
            arsTaskPayload: arsTaskPayload,
            closeAccessRequestHistoryModal: closeAccessRequestHistoryModal,
            reTriggerAccessRequestHistoryModal: reTriggerAccessRequestHistoryModal,
            messageKeys: messageKeys || {},
            globalDateFormat: globalDateFormat
        })
    });
}
var $0b9d8820b93e64c2$export$2e2bcd8739ae039 = $0b9d8820b93e64c2$var$AccessRequestHistory;







function $6be8371a7cd99dfd$var$AccessRequestHistoryButton() {
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        id: (0, $883fa4dd903b96ab$export$fd41194cca4d2bb5),
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
            kind: "body2-bold",
            className: "AccessRequestHistoryBtn",
            children: "Access Request"
        })
    });
}
var $6be8371a7cd99dfd$export$2e2bcd8739ae039 = $6be8371a7cd99dfd$var$AccessRequestHistoryButton;



var $2b016bbacf604946$export$2e2bcd8739ae039 = (0, $0b9d8820b93e64c2$export$2e2bcd8739ae039);





function $6c26eb59a53ecceb$var$CertsSidePanelBodySummary({ data: data }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    const { columnPickerList: columnPickerList, globalDateFormat: globalDateFormat } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const [colsToShow, setColsToShow] = (0, $hopDi$useState)({});
    (0, $hopDi$useEffect)(()=>{
        if (columnPickerList) setColsToShow(columnPickerList);
    }, [
        columnPickerList
    ]);
    const handleARSModalForSidePanel = ()=>{
        const payload = {
            ARSTASKKEY: data?.ARSTASKKEY,
            ARSTASKKEYFLAG: data?.arstaskkeyflag,
            CERT_ENTITLEMENT_VALUEKEY: data?.CERT_ENTITLEMENT_VALUEKEY,
            CERT_USERKEY: data?.CERT_USERKEY,
            CERT_ROLEKEY: data?.CERT_ROLEKEY,
            CERT_ACCOUNTKEY: data?.CERT_ACCOUNTKEY
        };
        dispatch((0, $d623f23401a154f0$export$6905b0d830e88406)(true, payload));
    };
    const getSidePanelNodeDataToView = (sidePanelSummaryNodedata)=>{
        let output = {};
        output = (0, $15388cfdc531d880$export$3a17aa4bbe26c437)({
            CERT_ENTITLEMENT_VALUEKEY: data?.CERT_ENTITLEMENT_VALUEKEY,
            ...sidePanelSummaryNodedata
        }, colsToShow);
        return output;
    };
    const sidePanelSummaryData = getSidePanelNodeDataToView(data?.sidePanel?.summary);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "CertsSidePanelBody-tabContentSummaryAttributes",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h4",
                children: "Attributes"
            }),
            Object.keys(sidePanelSummaryData).filter((key)=>typeof sidePanelSummaryData[key] !== "object" || sidePanelSummaryData[key] === null).map((key)=>{
                const getSummaryKey = data?.sidePanel?.summary[key];
                const fieldLabel = messages[key] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key));
                const isNoValue = getSummaryKey === null || getSummaryKey === undefined || typeof getSummaryKey === "object" || typeof getSummaryKey === "string" && getSummaryKey?.trim()?.length === 0;
                let fieldValue = isNoValue ? "-" : `${getSummaryKey}`;
                if (key === (0, $883fa4dd903b96ab$export$d9266982e2bf3d17) && (0, $15388cfdc531d880$export$c7ecff4fc21646e6)(data)) fieldValue = /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    onClick: handleARSModalForSidePanel,
                    onKeyDown: ()=>{},
                    role: "button",
                    tabIndex: "0",
                    className: "AccessRequestHistoryBtn-sidePanelMode",
                    children: "Access Request"
                });
                if ((0, $135adfecc1ed8f07$export$510f63ad8e5b2cec).includes(key) && getSummaryKey) fieldValue = (0, $hopDi$moment).utc(getSummaryKey).local().format(`${globalDateFormat?.toUpperCase()} hh:mm:ss`);
                if (getSummaryKey && typeof getSummaryKey === "string" && getSummaryKey?.includes("<br")) fieldValue = fieldValue?.replace(/<br\s*\/?>/gm, "\n");
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                    fieldData: {
                        label: fieldLabel,
                        value: fieldValue
                    }
                }, key);
            })
        ]
    });
}
$6c26eb59a53ecceb$var$CertsSidePanelBodySummary.propTypes = {
    data: (0, $hopDi$proptypes).shape((0, $a514f7ada4c4e300$export$2e2bcd8739ae039))
};
$6c26eb59a53ecceb$var$CertsSidePanelBodySummary.defaultProps = {
    data: null
};
var $6c26eb59a53ecceb$export$2e2bcd8739ae039 = $6c26eb59a53ecceb$var$CertsSidePanelBodySummary;


var $f628408145ad5bcd$export$2e2bcd8739ae039 = (0, $6c26eb59a53ecceb$export$2e2bcd8739ae039);







function $11c20874684f0ab9$var$CertsSidePanelAccounts({ dataTestId: dataTestId, className: className, data: data, activeTab: activeTab, setActiveTab: setActiveTab, isLoadingHistory: isLoadingHistory, retriggerApisForError: retriggerApisForError, handleCloseSidePanel: handleCloseSidePanel, tabGroupSidePanelRef: tabGroupSidePanelRef }) {
    const classes = (0, $hopDi$classnames)("CertsSidePanelBody", className);
    const [showHistory, setShowHistory] = (0, $hopDi$useState)(false);
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mobileXlargeQuery.value <= mediaQueryValue;
    (0, $hopDi$useEffect)(()=>{
        setShowHistory(activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63));
    }, [
        activeTab
    ]);
    const handleTabChange = (value)=>{
        setActiveTab(value);
    };
    const renderHistoryContent = ()=>{
        if (showHistory) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$9b67fda1e37e6e63]) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--history",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e52ca6c769e8713d$export$2e2bcd8739ae039), {
                    data: data,
                    isLoadingHistory: isLoadingHistory,
                    isMobileWidth: isMobileWidth
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent--history",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
            children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {})
        });
    };
    const shouldShowSidePanelSummaryForAccounts = Boolean(data?.sidePanel?.summary && data?.sidePanel?.status[0, $d60257e8dc27bf16$export$bde14d5a1cbdb371]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
                moreContainerRef: tabGroupSidePanelRef,
                value: activeTab,
                onChange: handleTabChange,
                isVerticalWithOverFlow: isMobileWidth,
                isTabOrderBeFixed: true,
                className: "CertsSidePanelBody-tabGroup",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "Summary",
                        value: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Document",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "History",
                        value: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RequestHistory",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "CertsSidePanelBody-tabGroupEmpty"
                    }, (0, $d60257e8dc27bf16$export$d66151c7af00715f))
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--summary",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                children: shouldShowSidePanelSummaryForAccounts ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $f628408145ad5bcd$export$2e2bcd8739ae039), {
                    data: data
                }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                    tab: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                    retriggerApisForError: retriggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                })
            }),
            renderHistoryContent()
        ]
    });
}
$11c20874684f0ab9$var$CertsSidePanelAccounts.propTypes = {
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    activeTab: (0, $hopDi$proptypes).string.isRequired,
    setActiveTab: (0, $hopDi$proptypes).func.isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    retriggerApisForError: (0, $hopDi$proptypes).func,
    handleCloseSidePanel: (0, $hopDi$proptypes).func,
    tabGroupSidePanelRef: (0, $135adfecc1ed8f07$export$de87879afd52ccf9).isRequired
};
$11c20874684f0ab9$var$CertsSidePanelAccounts.defaultProps = {
    dataTestId: null,
    className: null,
    retriggerApisForError: ()=>{},
    handleCloseSidePanel: ()=>{}
};
var $11c20874684f0ab9$export$2e2bcd8739ae039 = $11c20874684f0ab9$var$CertsSidePanelAccounts;


var $3ddf9bde0f45f198$export$2e2bcd8739ae039 = (0, $11c20874684f0ab9$export$2e2bcd8739ae039);




















/* eslint-disable indent */ 






























function $1c2fc2889f848be4$var$CertsTileActionsDrawer({ isActionDrawerOutsideClick: isActionDrawerOutsideClick, reusableActionsMap: reusableActionsMap, isTileActionDrawerOpen: isTileActionDrawerOpen, setIsTileActionDrawerOpen: setIsTileActionDrawerOpen, tileCheckIcon: tileCheckIcon, titleValue: titleValue, tileKindHeading: tileKindHeading, handleTileClick: handleTileClick, bulkSelectInfoForDrawer: bulkSelectInfoForDrawer, checkSidePanelMobileFooter: checkSidePanelMobileFooter }) {
    const handleDrawerClose = ()=>{
        setTimeout(()=>{
            setIsTileActionDrawerOpen(false);
        }, 250);
    };
    const getCheckBoxLabelForDrawer = (isChecked, count, isChildChecked)=>{
        if (isChecked && count > 0 && isChildChecked) return "Unelect Multiple Items";
        if (isChecked) return "Unselect Item";
        if (count > 0) return "Select Multiple Items";
        return "Select Item";
    };
    const mobileDrawerClasses = (0, $hopDi$classnames)(checkSidePanelMobileFooter && "CertsTileActionsDrawer-mobileDrawer-sidePanelMobileFooter");
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
        className: mobileDrawerClasses,
        isOpen: isTileActionDrawerOpen,
        setIsOpen: setIsTileActionDrawerOpen,
        isSwipeEnabled: true,
        // Add any Modals or other drawers that should block outside click
        isOutsideClickEnabled: isActionDrawerOutsideClick,
        content: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsTileActionsDrawer",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsTileActionsDrawer-header",
                    children: [
                        !checkSidePanelMobileFooter && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            className: "CertsTileActionsDrawer-drawerActionsIcon",
                            children: tileCheckIcon
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            className: "CertsTileActionsDrawer-text",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                mobile: "h4-d",
                                children: checkSidePanelMobileFooter ? "All Actions" : `${tileKindHeading}: ${titleValue}`
                            })
                        })
                    ]
                }),
                reusableActionsMap,
                !checkSidePanelMobileFooter && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawerItem), {
                            option: {
                                label: getCheckBoxLabelForDrawer(bulkSelectInfoForDrawer?.isChecked, bulkSelectInfoForDrawer?.childCount, bulkSelectInfoForDrawer?.isAtleastOneChildChecked),
                                value: "select-multiple-items",
                                isChecked: bulkSelectInfoForDrawer?.isChecked,
                                isDisabled: !bulkSelectInfoForDrawer?.isBulkActionEnabled
                            },
                            onClick: ()=>{
                                bulkSelectInfoForDrawer.handleBulkSelectFromDrawer();
                                handleDrawerClose();
                            }
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawerItem), {
                            option: {
                                label: "See details",
                                value: "see-details",
                                suffixIcon: "ChevronRightSmall",
                                isChecked: false,
                                isDisabled: false
                            },
                            onClick: (e)=>{
                                handleTileClick(e);
                                handleDrawerClose();
                            },
                            className: "CertsTileActionsDrawer-seeDetailsItem"
                        })
                    ]
                })
            ]
        })
    });
}
$1c2fc2889f848be4$var$CertsTileActionsDrawer.propTypes = {
    isActionDrawerOutsideClick: (0, $hopDi$proptypes).bool.isRequired,
    reusableActionsMap: (0, $hopDi$proptypes).element.isRequired,
    isTileActionDrawerOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsTileActionDrawerOpen: (0, $hopDi$proptypes).func.isRequired,
    tileCheckIcon: (0, $hopDi$proptypes).element.isRequired,
    titleValue: (0, $hopDi$proptypes).string.isRequired,
    tileKindHeading: (0, $hopDi$proptypes).string.isRequired,
    handleTileClick: (0, $hopDi$proptypes).func.isRequired,
    checkSidePanelMobileFooter: (0, $hopDi$proptypes).bool.isRequired,
    bulkSelectInfoForDrawer: (0, $hopDi$proptypes).shape({
        isChecked: (0, $hopDi$proptypes).bool,
        childCount: (0, $hopDi$proptypes).number,
        isBulkActionEnabled: (0, $hopDi$proptypes).bool,
        isAtleastOneChildChecked: (0, $hopDi$proptypes).bool,
        handleBulkSelectFromDrawer: (0, $hopDi$proptypes).func
    })
};
$1c2fc2889f848be4$var$CertsTileActionsDrawer.defaultProps = {
    bulkSelectInfoForDrawer: {
        isChecked: false,
        childCount: 0,
        isBulkActionEnabled: false,
        isAtleastOneChildChecked: false,
        handleBulkSelectFromDrawer: ()=>{}
    }
};
var $1c2fc2889f848be4$export$2e2bcd8739ae039 = $1c2fc2889f848be4$var$CertsTileActionsDrawer;





const $bae22e791544392c$export$63eb49a941fbc2c6 = 2;
const $bae22e791544392c$export$6b1c20b2e2de9059 = {
    USER: (0, $a23cd229b9113926$export$c2fd574cc3b8c823),
    ROLE: (0, $a23cd229b9113926$export$c97501b522a7bf89),
    ACCOUNT: (0, $a23cd229b9113926$export$eeb9092565ce426a),
    ENTITLEMENT: (0, $a23cd229b9113926$export$7d1f9b2b2a057886)
};
const $bae22e791544392c$export$994f7af6d0b36256 = {
    USER: "-4",
    ROLE: "-2",
    ACCOUNT: "0",
    ENTITLEMENT: 1
};



/* eslint-disable indent */ 






var $5a97dceba7e1a33b$exports = {};
$5a97dceba7e1a33b$exports = JSON.parse('{"v":"5.10.2","fr":60,"ip":0,"op":137,"w":56,"h":56,"nm":"Loop-Inline","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Load-Ellipse_Blue 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[1]},{"t":136,"s":[361]}],"ix":10},"p":{"a":0,"k":[28,28,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[50,50],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.4],"y":[1]},"o":{"x":[0.24],"y":[0]},"t":76,"s":[1]},{"t":136,"s":[99]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.76],"y":[1]},"o":{"x":[0.6],"y":[0]},"t":0,"s":[0]},{"t":60,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.145098045468,0.29411765933,0.525490224361,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"ct":1,"bm":0}],"markers":[]}');





/* eslint-disable indent */ 


const $4c1aa6449628783a$export$c40b9342a19db0b6 = (tileNodeData)=>{
    const certsKeyValue = tileNodeData?.CERT_ENTITLEMENT_VALUEKEY;
    if (certsKeyValue === (0, $bae22e791544392c$export$994f7af6d0b36256).USER) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).USER;
    if (certsKeyValue === (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE;
    if (certsKeyValue === (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT;
    return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT;
};
const $4c1aa6449628783a$export$18b54358355494a = (certsKind)=>{
    if (certsKind === (0, $bae22e791544392c$export$6b1c20b2e2de9059).USER) return 0, $a23cd229b9113926$export$50fc35c85d3a3c9d;
    if (certsKind === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT) return 0, $a23cd229b9113926$export$e7e5437fabb30374;
    if (certsKind === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT) return 0, $a23cd229b9113926$export$1b550718072cac3f;
    if (certsKind === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE) return 0, $a23cd229b9113926$export$1772b047bb5ee9a;
    return null;
};
const $4c1aa6449628783a$export$f87a1650caa3642b = (prev)=>prev.map((item)=>({
            ...item,
            tracker: {
                ...item.tracker,
                isConnected: false
            },
            children: item?.children?.length > 0 ? $4c1aa6449628783a$export$f87a1650caa3642b(item.children) : []
        }));
const $4c1aa6449628783a$export$86c6573c35d84094 = (previousTiles, targetId, targetLevel)=>{
    // First, disable connection status for all tiles except for the targeted one
    const modifiedTiles = $4c1aa6449628783a$export$f87a1650caa3642b(previousTiles).map((tile)=>{
        if (tile.tracker.level === targetLevel) {
            // Enable connection only if the current tile matches the target ID
            const isConnected = tile.tracker.id === targetId;
            return {
                ...tile,
                tracker: {
                    ...tile.tracker,
                    isConnected: isConnected
                }
            };
        }
        // If not on the target level, recursively adjust the connection status of children
        return {
            ...tile,
            tracker: {
                ...tile.tracker,
                isConnected: false
            },
            children: tile.children ? $4c1aa6449628783a$export$86c6573c35d84094(tile.children, targetId, targetLevel) : []
        };
    });
    return modifiedTiles;
};
const $4c1aa6449628783a$export$e946959053026eab = (children, targetStatus)=>children.map((child)=>({
            ...child,
            tracker: {
                ...child.tracker,
                isChecked: targetStatus,
                isIndeterminate: false
            },
            children: child?.children?.length > 0 ? $4c1aa6449628783a$export$e946959053026eab(child.children, targetStatus) : []
        }));
const $4c1aa6449628783a$export$489fa64af1a46e4 = (nodes)=>{
    const flattenedList = (0, $e7628c995f405891$export$8824054d4a42eac8)(nodes);
    return flattenedList.map((node)=>node?.tracker?.isChecked || node?.tracker?.isIndeterminate);
};
const $4c1aa6449628783a$export$e6436fb982b2017f = (prev)=>prev.map((item)=>{
        const hasChildren = item?.children?.length > 0;
        if (!hasChildren) return item;
        // first is parent status
        const childrenStatus = $4c1aa6449628783a$export$489fa64af1a46e4(item?.children);
        const isAtleastOneChildChecked = childrenStatus.some((value)=>value === true);
        if (isAtleastOneChildChecked) return {
            ...item,
            tracker: {
                ...item.tracker,
                isAtleastOneChildChecked: isAtleastOneChildChecked,
                isIndeterminate: !item?.tracker?.isChecked
            },
            children: hasChildren ? $4c1aa6449628783a$export$e6436fb982b2017f(item.children) : []
        };
        return {
            ...item,
            tracker: {
                ...item.tracker,
                isAtleastOneChildChecked: isAtleastOneChildChecked,
                isIndeterminate: false
            },
            children: hasChildren ? $4c1aa6449628783a$export$e6436fb982b2017f(item.children) : []
        };
    });
const $4c1aa6449628783a$export$57d225e2d2f6fa1f = (actions)=>{
    if (!actions) return false;
    const trackerActions = Object.keys(actions);
    const flag = Boolean(trackerActions.length > 0 && trackerActions?.some((key)=>{
        if (actions[key].isLoading) return true;
        return false;
    }));
    return flag;
};
const $4c1aa6449628783a$var$checkDivPosition = (divRef)=>{
    const divRect = divRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const distanceToBottom = viewportHeight - divRect.bottom;
    // Check if the element is partially obstructed by the footer (128px from the bottom)
    return distanceToBottom < 128;
};
const $4c1aa6449628783a$export$1a48656bb4f8148 = (tileRef)=>{
    if (!tileRef.current) return;
    // Check if the tile is in the viewport and if it's partially obstructed
    const isNodeInView = (0, $hopDi$isInViewport)(tileRef.current);
    const divIsVisible = !$4c1aa6449628783a$var$checkDivPosition(tileRef);
    // Scroll if the tile is not in the viewport or partially obstructed
    if (!isNodeInView || !divIsVisible) tileRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
};



const $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0 = {
    USER: "User",
    ACCOUNT: "Account",
    ROLE: "Role",
    ENTITLEMENT: "Entitlement"
};
const $e7683d2bb9b3b8c9$export$7f85b66a0bcac447 = {
    APPLICATION_ROLE: "APPLICATION ROLE"
};













function $0d23168c4a68b98d$var$CertsCommentInputField({ actionKey: actionKey, inputChanged: inputChanged, setInputChanged: setInputChanged, isCritical: isCritical, setIsCritical: setIsCritical, commentValue: commentValue, setCommentValue: setCommentValue, textAreaMaxHeight: textAreaMaxHeight }) {
    const [chipData, setChipData] = (0, $hopDi$useState)([]);
    const { predefinedComments: predefinedComments } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const getKeyMatch = ()=>{
        if (actionKey === (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE) return (0, $20281fe09bc700a8$export$684f6d0b3182db31).APPROVE;
        if (actionKey === (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT) return (0, $20281fe09bc700a8$export$684f6d0b3182db31).REJECT;
        if (actionKey === (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME) return (0, $20281fe09bc700a8$export$684f6d0b3182db31).WORKS_FOR_ME;
        return null;
    };
    (0, $hopDi$useEffect)(()=>{
        if (!actionKey) return;
        const keyMatch = getKeyMatch();
        // Check for key match and if `predefinedComments` contains data for the matched key
        if (predefinedComments[keyMatch]) setChipData(predefinedComments[keyMatch].map((label, index)=>({
                id: index,
                label: label,
                isSelected: false
            })));
    }, [
        predefinedComments,
        actionKey
    ]);
    (0, $hopDi$useEffect)(()=>{
        const hasAngleBrackets = /<|>/.test(commentValue);
        if (hasAngleBrackets) setIsCritical(true);
        if (inputChanged) {
            setChipData(chipData.map((chip)=>({
                    ...chip,
                    isSelected: false
                })));
            setInputChanged(false);
        }
    }, [
        commentValue
    ]);
    const isCommentNotValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    const handleChipSelection = (selectedChip)=>{
        if (selectedChip.isSelected) {
            setChipData(chipData.map((chip)=>({
                    ...chip,
                    isSelected: false
                })));
            setCommentValue("");
            setIsCritical(false);
        } else {
            setChipData(chipData.map((chip)=>({
                    ...chip,
                    isSelected: chip.id === selectedChip.id
                })));
            setCommentValue(selectedChip.label);
            setIsCritical(false);
        }
        setInputChanged(false);
    };
    const handleInputChange = (e)=>{
        setCommentValue(e.target.value);
        setInputChanged(true);
    };
    const getChip = (chip)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
            kind: chip.isSelected ? "boldFilled" : "outlined",
            label: chip.label,
            color: "brandSecondary",
            isSelected: chip.isSelected,
            rightIcon: chip.isSelected ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "Close"
            }) : null,
            onClick: ()=>handleChipSelection(chip),
            size: "medium"
        }, chip.label.length > 25 ? null : chip.id);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsCommentInputField-commentSection",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsCommentInputField-label",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "CertsCommentInputField-asterisk--isRequired",
                        children: isCommentNotValid && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            tag: "div",
                            className: `CertsCommentInputField-asterisk--${isCritical ? "isCritical" : "isWarning"}`,
                            children: "*"
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "label",
                        htmlFor: "CertsCommentInputFieldMultiline",
                        desktop: "h4-d",
                        mobile: "h4-d",
                        children: "Comments"
                    })
                ]
            }),
            chipData?.length > 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsCommentInputField-chips",
                children: chipData.map((chip)=>chip.label.length > 25 ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                        trigger: getChip(chip),
                        isWordBreak: false,
                        text: chip.label,
                        placement: "top"
                    }, chip.id) : getChip(chip))
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsCommentInputField-inputField",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "CertsCommentInputFieldMultiline",
                    kind: "multiline",
                    placeholder: "Provide a reason for your decision",
                    value: commentValue,
                    setValue: setCommentValue,
                    onChange: handleInputChange,
                    isCritical: isCritical,
                    setIsCritical: setIsCritical,
                    textAreaMaxHeight: textAreaMaxHeight,
                    CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "missingRequiredField",
                        size: "small"
                    })
                })
            })
        ]
    });
}
$0d23168c4a68b98d$var$CertsCommentInputField.propTypes = {
    actionKey: (0, $hopDi$proptypes).string,
    inputChanged: (0, $hopDi$proptypes).bool.isRequired,
    setInputChanged: (0, $hopDi$proptypes).func.isRequired,
    isCritical: (0, $hopDi$proptypes).bool.isRequired,
    setIsCritical: (0, $hopDi$proptypes).func.isRequired,
    commentValue: (0, $hopDi$proptypes).string.isRequired,
    setCommentValue: (0, $hopDi$proptypes).func.isRequired,
    textAreaMaxHeight: (0, $hopDi$proptypes).string
};
// TODO: @Jacob, Action key is required, remove next Sprint
$0d23168c4a68b98d$var$CertsCommentInputField.defaultProps = {
    actionKey: null,
    textAreaMaxHeight: "20rem"
};
var $0d23168c4a68b98d$export$2e2bcd8739ae039 = $0d23168c4a68b98d$var$CertsCommentInputField;




const $3cd234bd4f1cf26a$export$3edeae7c90cf2ca0 = (actionKind)=>{
    switch(actionKind){
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE:
            return "Approve";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT:
            return "Reject";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE:
            return "Terminated";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN:
            return "Reassign";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT:
            return "Consult";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME:
            return "Confirm Manager";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME:
            return "Submit"; // showing submit label for user lineitem
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE:
            return "Extend End Date";
        case (0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY:
            return "Certify Conditionally";
        default:
            return "Unformatted Action";
    }
};
var $3cd234bd4f1cf26a$export$2e2bcd8739ae039 = $3cd234bd4f1cf26a$export$3edeae7c90cf2ca0;



function $8c613cbc0666ae78$var$CertsActionPopover({ actionKind: actionKind, isMobileXlargeWidth: isMobileXlargeWidth, isCommentPopoverOpen: isCommentPopoverOpen, setIsCommentPopoverOpen: setIsCommentPopoverOpen, placement: placement, trigger: trigger, onSubmit: onSubmit, getTypeActEntRole: // eslint-disable-next-line react/prop-types
getTypeActEntRole }) {
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const [inputChanged, setInputChanged] = (0, $hopDi$useState)(false);
    const drawerRef = (0, $hopDi$useRef)();
    // Reset on close
    (0, $hopDi$useEffect)(()=>{
        if (!isCommentPopoverOpen) {
            setIsCritical(false);
            setCommentValue("");
            setInputChanged(false);
        }
    }, [
        isCommentPopoverOpen
    ]);
    const isCommentNotValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    const isWorksForMe = actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME;
    const handleClose = ()=>{
        if (isMobileXlargeWidth) drawerRef.current.closeDrawer();
        else setIsCommentPopoverOpen(false);
    };
    const handleCommentSubmit = ()=>{
        if (isCommentNotValid) return setIsCritical(true);
        handleClose();
        return onSubmit(commentValue);
    };
    const titleString = `${isWorksForMe ? "Confirm Manager for this" : "Approve this"} ${getTypeActEntRole}?`;
    const getMobileHeader = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsActionPopover-headerWrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsActionPopover-title",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "HelpFilled",
                            className: "CertsActionPopover-headerIcon"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "label",
                            desktop: "h3-d",
                            mobile: "h1-m",
                            lineLimit: 2,
                            children: titleString
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: "CertsActionPopover-headerButtonIcon",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: !isMobileXlargeWidth ? "small" : "medium",
                        kind: "ghost",
                        tabIndex: -1,
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Close"
                        }),
                        onClick: handleClose
                    })
                })
            ]
        });
    // TODO: @Jacob, Tech Debt, Post CR-17078, and other early Nov 2024 Jira's. Remove CertsCommentInputField. Then update and rename CertsModalCommentBox for use here.
    const getMobileContent = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $0d23168c4a68b98d$export$2e2bcd8739ae039), {
            actionKey: actionKind,
            inputChanged: inputChanged,
            setInputChanged: setInputChanged,
            isCritical: isCritical,
            setIsCritical: setIsCritical,
            commentValue: commentValue,
            setCommentValue: setCommentValue
        });
    const getMobileFooter = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
            size: "large",
            className: "CertsActionPopover-controls",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "ghost",
                    onClick: ()=>drawerRef.current.closeDrawer(),
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: !isCommentNotValid ? "filled" : "outlined",
                    onClick: handleCommentSubmit,
                    className: "CertsActionPopover-submtBtn",
                    children: (0, $3cd234bd4f1cf26a$export$3edeae7c90cf2ca0)(actionKind)
                })
            ]
        });
    // Render one time use multiple places
    const mobileHeader = getMobileHeader();
    const mobileContent = getMobileContent();
    const mobileFooter = getMobileFooter();
    const getPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsActionPopover",
            children: [
                mobileHeader,
                mobileContent,
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "CertsActionPopover-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            onClick: ()=>setIsCommentPopoverOpen(false),
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: !isCommentNotValid ? "filled" : "outlined",
                            onClick: handleCommentSubmit,
                            children: (0, $3cd234bd4f1cf26a$export$3edeae7c90cf2ca0)(actionKind)
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsActionPopover-contextWrapper",
        children: isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                trigger,
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                    ref: drawerRef,
                    isOpen: isCommentPopoverOpen,
                    setIsOpen: setIsCommentPopoverOpen,
                    headerContent: mobileHeader,
                    content: mobileContent,
                    footerActionBar: mobileFooter,
                    className: "CertsActionPopover"
                })
            ]
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
            isPortalEnabled: true,
            placement: placement,
            trigger: trigger,
            popoverContent: getPopoverContent(),
            isOpen: isCommentPopoverOpen,
            setIsOpen: setIsCommentPopoverOpen
        })
    });
}
$8c613cbc0666ae78$var$CertsActionPopover.propTypes = {
    actionKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$3f43cf8434698562))),
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired,
    isCommentPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsCommentPopoverOpen: (0, $hopDi$proptypes).func.isRequired,
    placement: (0, $hopDi$proptypes).string.isRequired,
    trigger: (0, $hopDi$proptypes).element.isRequired,
    onSubmit: (0, $hopDi$proptypes).func.isRequired
};
$8c613cbc0666ae78$var$CertsActionPopover.defaultProps = {
    actionKind: null
};
var $8c613cbc0666ae78$export$2e2bcd8739ae039 = $8c613cbc0666ae78$var$CertsActionPopover;



























function $fc013bb675672a85$var$CertsConsultedContent({ isCommentPopoverOpen: isCommentPopoverOpen, onClose: onClose, resetAction: resetAction, nodeData: nodeData, certKey: certKey, globalDateFormat: globalDateFormat }) {
    const [isLoadingActionDetails, setIsLoadingActionDetails] = (0, $hopDi$useState)(true);
    const [latestActionDetails, setLatestActionDetails] = (0, $hopDi$useState)(null);
    const dispatch = (0, $hopDi$useDispatch)();
    const fetchAuditHistory = async ()=>{
        const body = {
            certkey: certKey,
            cert_entitlement_valuekey: nodeData?.CERT_ENTITLEMENT_VALUEKEY,
            cert_userkey: nodeData?.CERT_USERKEY
        };
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER:
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ACCOUNT:
                if (nodeData.CERT_ACCOUNTKEY) body.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ROLE:
                body.cert_rolekey = nodeData.CERT_ROLEKEY;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                if ((0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                    if (nodeData.CERT_ACCOUNTKEY) body.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                    if (nodeData?.CERT_ROLEKEY) body.cert_rolekey = nodeData.CERT_ROLEKEY;
                }
                break;
        }
        dispatch((0, $d623f23401a154f0$export$f3c11d569c729db5)(body)).then((data)=>{
            const { response: response } = data;
            if (Array.isArray(response) && response.length > 0) {
                let firstNonConsultedAction = null;
                response.forEach((ele)=>{
                    if (ele.action !== "consulted" && !firstNonConsultedAction) firstNonConsultedAction = ele;
                });
                // storing non consulted action
                if (firstNonConsultedAction) setLatestActionDetails(firstNonConsultedAction);
            } else {
                const details = {
                    errorMsg: "Network Error , Please retry after sometime"
                };
                setLatestActionDetails(details);
            }
        }).catch(()=>{
            const details = {
                errorMsg: "Network Error , Please retry after sometime"
            };
            setLatestActionDetails(details);
        }).finally(()=>{
            setIsLoadingActionDetails(false);
        });
    };
    (0, $hopDi$useEffect)(()=>{
        if (isCommentPopoverOpen) {
            fetchAuditHistory();
            return;
        }
        setIsLoadingActionDetails(true);
    }, [
        isCommentPopoverOpen
    ]);
    const getIconKind = ()=>{
        switch(latestActionDetails?.action){
            case "reassigned":
                return "ReassignUser";
            case "consulted":
            case "conditionallyCertified":
                return "Consult";
            case "rejected":
                return "Reject";
            case "approved":
            case "cancelled":
                return "CheckCircleOutline";
            case "worksForMe":
            default:
                return "Success";
        }
    };
    const getIconColor = ()=>{
        switch(latestActionDetails?.action){
            case "reassigned":
                return "navy-900";
            case "consulted":
                return "green-900";
            case "conditionallyCertified":
                return "success-900";
            case "rejected":
                return "warning-900";
            case "approved":
                return "success-900";
            case "worksForMe":
                return "success-700";
            case "cancelled":
                return "warning-700";
            default:
                return "success-700";
        }
    };
    const getActionType = (type)=>{
        if (type !== "") return type;
        return "NOT_PROVIDED";
    };
    const renderActionResetContent = ()=>{
        if (isLoadingActionDetails) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "CertsConsultedActionPopover-loader",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "small"
            })
        });
        if (latestActionDetails.errorMsg) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "CertsConsultedActionPopover-errorMsg",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2-bold",
                children: latestActionDetails?.errorMsg
            })
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsConsultedActionPopover-content",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                            className: "CertsConsultedActionPopover-header",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    className: "CertsConsultedActionPopover-actionStatus",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: getIconKind(),
                                            color: getIconColor()
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "h3",
                                            desktop: "h3-d",
                                            mobile: "h3-d",
                                            className: "CertsConsultedActionPopover-title",
                                            children: getActionType(latestActionDetails?.actionMessage)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                    size: "small",
                                    kind: "ghost",
                                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "Close",
                                        color: "neutral-1000"
                                    }),
                                    onClick: onClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                            kind: "body1",
                            className: "CertsConsultedActionPopover-details",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            className: "CertsConsultedActionPopover-heading",
                                            children: "Actioned By"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "CertsConsultedActionPopover-info",
                                            children: latestActionDetails?.actionUser
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            className: "CertsConsultedActionPopover-heading",
                                            children: "Actioned On"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "CertsConsultedActionPopover-info",
                                            children: latestActionDetails?.actionDate && (0, $hopDi$moment).utc(latestActionDetails?.actionDate, (0, $135adfecc1ed8f07$export$819c6a8205c73110)?.[latestActionDetails?.actionDateFormat]).local().format(`${globalDateFormat?.toUpperCase()} hh:mm:ss`)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                            className: "CertsConsultedActionPopover-commentsInfo",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body3",
                                    className: "CertsConsultedActionPopover-heading",
                                    children: "Comments"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                    openDelay: 500,
                                    text: latestActionDetails?.comment?.length > 100 ? latestActionDetails?.comment : null,
                                    maxWidth: "20rem",
                                    placement: "bottom",
                                    offset: 8,
                                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        className: "CertsConsultedActionPopover-info",
                                        children: latestActionDetails?.comment
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "CertsConsultedActionPopover-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            onClick: ()=>{
                                resetAction();
                            },
                            children: "Cancel Action"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "filled",
                            onClick: onClose,
                            children: "Got it"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        className: "CertsConsultedActionPopover",
        children: renderActionResetContent()
    });
}
$fc013bb675672a85$var$CertsConsultedContent.defaultProps = {};
$fc013bb675672a85$var$CertsConsultedContent.propTypes = {
    isCommentPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    onClose: (0, $hopDi$proptypes).func.isRequired,
    resetAction: (0, $hopDi$proptypes).func.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    certKey: (0, $hopDi$proptypes).string.isRequired,
    globalDateFormat: (0, $hopDi$proptypes).string.isRequired
};
var $fc013bb675672a85$export$2e2bcd8739ae039 = $fc013bb675672a85$var$CertsConsultedContent;



function $5cc4539d6b20fb8d$var$CertsConsultedActionPopover({ isMobileXlargeWidth: isMobileXlargeWidth, isCommentPopoverOpen: isCommentPopoverOpen, setIsCommentPopoverOpen: setIsCommentPopoverOpen, placement: placement, trigger: trigger, onClose: onClose, resetAction: resetAction, nodeData: nodeData, certKey: certKey, globalDateFormat: globalDateFormat }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const [isLoadingActionDetails, setIsLoadingActionDetails] = (0, $hopDi$useState)(true);
    const [latestActionDetails, setLatestActionDetails] = (0, $hopDi$useState)(null);
    const drawerRef = (0, $hopDi$useRef)();
    const certsKind = (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData);
    const fixedColKey = (0, $4c1aa6449628783a$export$18b54358355494a)(certsKind);
    const isNoValueTitle = nodeData[fixedColKey] === null || nodeData[fixedColKey] === undefined || nodeData?.[fixedColKey]?.trim()?.length === 0;
    const value = isNoValueTitle ? "Not Provided" : nodeData[fixedColKey];
    const heading = messages[fixedColKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(fixedColKey));
    const fetchAuditHistory = async ()=>{
        const body = {
            certkey: certKey,
            cert_entitlement_valuekey: nodeData?.CERT_ENTITLEMENT_VALUEKEY,
            cert_userkey: nodeData?.CERT_USERKEY
        };
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER:
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ACCOUNT:
                if (nodeData.CERT_ACCOUNTKEY) body.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ROLE:
                body.cert_rolekey = nodeData.CERT_ROLEKEY;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                if ((0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                    if (nodeData.CERT_ACCOUNTKEY) body.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                    if (nodeData?.CERT_ROLEKEY) body.cert_rolekey = nodeData.CERT_ROLEKEY;
                }
                break;
        }
        dispatch((0, $d623f23401a154f0$export$f3c11d569c729db5)(body)).then((data)=>{
            const { response: response } = data;
            if (Array.isArray(response) && response.length > 0) {
                let firstNonConsultedAction = null;
                response.forEach((ele)=>{
                    if (ele.action !== "consulted" && !firstNonConsultedAction) firstNonConsultedAction = ele;
                });
                // storing non consulted action
                if (firstNonConsultedAction) setLatestActionDetails(firstNonConsultedAction);
            } else {
                const details = {
                    errorMsg: "Network Error , Please retry after sometime"
                };
                setLatestActionDetails(details);
            }
        }).catch(()=>{
            const details = {
                errorMsg: "Network Error , Please retry after sometime"
            };
            setLatestActionDetails(details);
        }).finally(()=>{
            setIsLoadingActionDetails(false);
        });
    };
    (0, $hopDi$useEffect)(()=>{
        if (isCommentPopoverOpen) {
            fetchAuditHistory();
            return;
        }
        setIsLoadingActionDetails(true);
    }, [
        isCommentPopoverOpen
    ]);
    const handleClose = ()=>{
        if (isMobileXlargeWidth) drawerRef.current.closeDrawer();
        else setIsCommentPopoverOpen(false);
    };
    const handleSubmit = ()=>{
        resetAction();
        handleClose();
    };
    const getActionType = (type)=>{
        if (type !== "") return type;
        return "NOT_PROVIDED";
    };
    const getIconKind = ()=>{
        switch(latestActionDetails?.action){
            case "reassigned":
                return "ReassignUser";
            case "consulted":
            case "conditionallyCertified":
                return "Consult";
            case "rejected":
                return "Reject";
            case "approved":
            case "cancelled":
                return "CheckCircleOutline";
            case "worksForMe":
            default:
                return "Success";
        }
    };
    const getIconColor = ()=>{
        switch(latestActionDetails?.action){
            case "reassigned":
                return "navy-900";
            case "consulted":
                return "green-900";
            case "conditionallyCertified":
                return "success-900";
            case "rejected":
                return "warning-900";
            case "approved":
                return "success-900";
            case "worksForMe":
                return "success-700";
            case "cancelled":
                return "warning-700";
            default:
                return "success-700";
        }
    };
    const renderActionResetContent = ()=>{
        if (isLoadingActionDetails) // Skeleton added
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsConsultedActionPopover-icon",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: certsKind
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            className: "CertsConsultedActionPopover-text",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                mobile: "h4-d",
                                children: `${heading}: ${value}`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: "CertsConsultedActionPopover-headerWrapper",
                    children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "CertsConsultedActionPopover-title",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: getIconKind(),
                                color: getIconColor(),
                                className: "CertsConsultedActionPopover-headerIcon"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsConsultedActionPopoverSkeleton-title CertsConsultedActionPopoverSkeleton-animateSkeleton"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    kind: "body1",
                    className: "CertsConsultedActionPopover-details",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "CertsConsultedActionPopoverSkeleton",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "CertsConsultedActionPopoverSkeleton-heading CertsConsultedActionPopoverSkeleton-animateSkeleton"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "CertsConsultedActionPopoverSkeleton-info CertsConsultedActionPopoverSkeleton-animateSkeleton"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "CertsConsultedActionPopoverSkeleton",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "CertsConsultedActionPopoverSkeleton-heading CertsConsultedActionPopoverSkeleton-animateSkeleton"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "CertsConsultedActionPopoverSkeleton-info CertsConsultedActionPopoverSkeleton-animateSkeleton"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: "CertsConsultedActionPopover-commentsInfo",
                    children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsConsultedActionPopoverSkeleton",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsConsultedActionPopoverSkeleton-heading CertsConsultedActionPopoverSkeleton-animateSkeleton"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsConsultedActionPopoverSkeleton-info CertsConsultedActionPopoverSkeleton-animateSkeleton"
                            })
                        ]
                    })
                })
            ]
        });
        if (latestActionDetails.errorMsg) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "CertsConsultedActionPopover-errorMsg",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2-bold",
                children: latestActionDetails?.errorMsg
            })
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsConsultedActionPopover-icon",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: certsKind
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            className: "CertsConsultedActionPopover-text",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                mobile: "h4-d",
                                children: `${heading}: ${value}`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: "CertsConsultedActionPopover-headerWrapper",
                    children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "CertsConsultedActionPopover-title",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: getIconKind(),
                                color: getIconColor(),
                                className: "CertsConsultedActionPopover-headerIcon"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "label",
                                desktop: "h3-d",
                                mobile: "h3-d",
                                lineLimit: 2,
                                children: getActionType(latestActionDetails?.actionMessage)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    kind: "body1",
                    className: "CertsConsultedActionPopover-details",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body3",
                                    className: "CertsConsultedActionPopover-heading",
                                    children: "Actioned By"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "CertsConsultedActionPopover-info",
                                    lineLimit: 2,
                                    children: latestActionDetails?.actionUser
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body3",
                                    className: "CertsConsultedActionPopover-heading",
                                    children: "Actioned On"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "CertsConsultedActionPopover-info",
                                    children: latestActionDetails?.actionDate && (0, $hopDi$moment).utc(latestActionDetails?.actionDate, (0, $135adfecc1ed8f07$export$819c6a8205c73110)?.[latestActionDetails?.actionDateFormat]).local().format(`${globalDateFormat?.toUpperCase()} hh:mm:ss`)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsConsultedActionPopover-commentsInfo",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body3",
                            className: "CertsConsultedActionPopover-heading",
                            children: "Comments"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                            openDelay: 500,
                            text: latestActionDetails?.comment?.length > 100 ? latestActionDetails?.comment : null,
                            maxWidth: "20rem",
                            placement: "bottom",
                            offset: 8,
                            trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                className: "CertsConsultedActionPopover-info",
                                children: latestActionDetails?.comment
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsConsultedActionPopover-contextWrapper",
        children: isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                trigger,
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                    ref: drawerRef,
                    isSwipeEnabled: true,
                    isOpen: isCommentPopoverOpen,
                    setIsOpen: setIsCommentPopoverOpen,
                    isCloseButtonEnabled: false,
                    content: renderActionResetContent(),
                    footerActionBar: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
                        size: "large",
                        className: "CertsConsultedActionPopover-controls",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "subtle",
                                onClick: handleSubmit,
                                className: "CertsConsultedActionPopover-cancelBtn",
                                children: "Cancel Action"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "filled",
                                onClick: handleClose,
                                className: "CertsConsultedActionPopover-submtBtn",
                                children: "Got it"
                            })
                        ]
                    }),
                    className: "CertsConsultedActionPopover"
                })
            ]
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
            isPortalEnabled: true,
            placement: placement,
            trigger: trigger,
            popoverContent: /*#__PURE__*/ (0, $hopDi$jsx)((0, $fc013bb675672a85$export$2e2bcd8739ae039), {
                isCommentPopoverOpen: isCommentPopoverOpen,
                setIsCommentPopoverOpen: setIsCommentPopoverOpen,
                onClose: onClose,
                resetAction: resetAction,
                certKey: certKey,
                nodeData: nodeData,
                globalDateFormat: globalDateFormat
            }),
            isOpen: isCommentPopoverOpen,
            setIsOpen: setIsCommentPopoverOpen
        })
    });
}
$5cc4539d6b20fb8d$var$CertsConsultedActionPopover.propTypes = {
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired,
    isCommentPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsCommentPopoverOpen: (0, $hopDi$proptypes).func.isRequired,
    placement: (0, $hopDi$proptypes).string.isRequired,
    trigger: (0, $hopDi$proptypes).element.isRequired,
    onClose: (0, $hopDi$proptypes).func.isRequired,
    resetAction: (0, $hopDi$proptypes).func.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    certKey: (0, $hopDi$proptypes).string.isRequired,
    globalDateFormat: (0, $hopDi$proptypes).string.isRequired
};
var $5cc4539d6b20fb8d$export$2e2bcd8739ae039 = $5cc4539d6b20fb8d$var$CertsConsultedActionPopover;











function $aea7f6898cc7aef2$var$CertsConsultContent({ setIsCommentPopoverOpen: setIsCommentPopoverOpen, onSubmit: onSubmit, isMobileXlargeWidth: isMobileXlargeWidth }) {
    const [isChecked, setIsChecked] = (0, $hopDi$useState)(false);
    const handleSubmit = ()=>onSubmit(isChecked);
    const handleChange = (e)=>{
        setIsChecked(e.target.checked);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        className: "CertsConsultPopover",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                className: "CertsConsultPopover-content",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "CertsConsultPopover-header",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                mobile: "h2-m",
                                className: "CertsConsultPopover-title",
                                children: "Consultation Requested"
                            }),
                            !isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                size: "small",
                                kind: "ghost",
                                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "Close",
                                    color: "neutral-1000"
                                }),
                                onClick: ()=>setIsCommentPopoverOpen(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        mobile: "body2-d",
                        className: "CertsConsultPopover-note",
                        children: "You can wait for responses to your consultations, consult with other peers, or go ahead and make decisions. Once all decisions are made, you can review and submit your certification."
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        className: "CertsConsultPopover-checkbox",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                            name: "simpleText",
                            kind: "simpleText",
                            dataTestId: "simpleText",
                            size: "small",
                            isChecked: isChecked,
                            onChange: handleChange,
                            label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                mobile: "body2-m",
                                className: "CertsConsultPopover-label",
                                children: "Don\u2019t show this again for this certification"
                            }),
                            textPosition: "after",
                            showHoverEffect: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsConsultPopover-controls",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "filled",
                    onClick: handleSubmit,
                    size: isMobileXlargeWidth ? "medium" : "small",
                    children: "Got it"
                })
            })
        ]
    });
}
$aea7f6898cc7aef2$var$CertsConsultContent.defaultProps = {};
$aea7f6898cc7aef2$var$CertsConsultContent.propTypes = {
    setIsCommentPopoverOpen: (0, $hopDi$proptypes).func.isRequired,
    onSubmit: (0, $hopDi$proptypes).func.isRequired,
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired
};
var $aea7f6898cc7aef2$export$2e2bcd8739ae039 = $aea7f6898cc7aef2$var$CertsConsultContent;



function $b17240ba2f8a5623$var$CertsConsultPopover({ isMobileXlargeWidth: isMobileXlargeWidth, isCommentPopoverOpen: isCommentPopoverOpen, setIsCommentPopoverOpen: setIsCommentPopoverOpen, placement: placement, trigger: trigger, onSubmit: onSubmit }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsConsultPopover-contextWrapper",
        children: isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                trigger,
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                    isOpen: isCommentPopoverOpen,
                    setIsOpen: setIsCommentPopoverOpen,
                    isSwipeEnabled: true,
                    content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $aea7f6898cc7aef2$export$2e2bcd8739ae039), {
                        isMobileXlargeWidth: isMobileXlargeWidth,
                        onSubmit: onSubmit,
                        setIsCommentPopoverOpen: setIsCommentPopoverOpen
                    }),
                    className: "CertsConsultPopover"
                })
            ]
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
            isPortalEnabled: true,
            placement: placement,
            trigger: trigger,
            popoverContent: /*#__PURE__*/ (0, $hopDi$jsx)((0, $aea7f6898cc7aef2$export$2e2bcd8739ae039), {
                isMobileXlargeWidth: isMobileXlargeWidth,
                onSubmit: onSubmit,
                setIsCommentPopoverOpen: setIsCommentPopoverOpen
            }),
            isOpen: isCommentPopoverOpen,
            setIsOpen: setIsCommentPopoverOpen
        })
    });
}
$b17240ba2f8a5623$var$CertsConsultPopover.defaultProps = {};
$b17240ba2f8a5623$var$CertsConsultPopover.propTypes = {
    isCommentPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsCommentPopoverOpen: (0, $hopDi$proptypes).func.isRequired,
    placement: (0, $hopDi$proptypes).string.isRequired,
    trigger: (0, $hopDi$proptypes).element.isRequired,
    onSubmit: (0, $hopDi$proptypes).func.isRequired,
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired
};
var $b17240ba2f8a5623$export$2e2bcd8739ae039 = $b17240ba2f8a5623$var$CertsConsultPopover;







const $271c8dec800e3a4d$export$46f21910265caffc = "User_DISPLAYNAME";
const $271c8dec800e3a4d$export$b21a97077b446a0c = "Account_DISPLAYNAME";
const $271c8dec800e3a4d$export$ef258f55852583b5 = "Role_DISPLAYNAME";
const $271c8dec800e3a4d$export$8e9b5a553c0ae9b2 = "Ent_DISPLAYNAME";
const $271c8dec800e3a4d$export$ff09b90989b21a8 = "User";
const $271c8dec800e3a4d$export$5965ea730be9034a = "Role";
const $271c8dec800e3a4d$export$e201ada1fa50584 = "Account";
const $271c8dec800e3a4d$export$b0f71eb1e01c7936 = "Entitlement";



function $315ae4957e308cf1$var$CertsReassignPopover({ isCommentPopoverOpen: isCommentPopoverOpen, setIsCommentPopoverOpen: setIsCommentPopoverOpen, isMobileXlargeWidth: isMobileXlargeWidth, placement: placement, trigger: trigger, onSubmit: onSubmit, nodeData: nodeData }) {
    const drawerRef = (0, $hopDi$useRef)();
    const handleClose = ()=>{
        if (isMobileXlargeWidth) drawerRef.current.closeDrawer();
        else setIsCommentPopoverOpen(false);
    };
    const handleCommentSubmit = ()=>{
        setIsCommentPopoverOpen(false);
        return onSubmit();
    };
    const getButtonSize = ()=>isMobileXlargeWidth ? "medium" : "small";
    const getPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsReassignPopover",
            children: [
                isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "CertsReassignPopover-container-userDetails",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "UserNoBg",
                            color: "navy-900",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h4",
                            mobile: "h4-d",
                            className: "CertsReassignPopover-container-userDetailsName",
                            children: `User : ${nodeData[0, $271c8dec800e3a4d$export$46f21910265caffc]}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body1",
                    className: "CertsReassignPopover-note",
                    children: "By reassigning this user, their associated items will be included. Any approvals or rejections will be cleared upon reassignment."
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "CertsReassignPopover-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            onClick: handleClose,
                            size: getButtonSize(),
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "filled",
                            onClick: handleCommentSubmit,
                            size: getButtonSize(),
                            className: "CertsReassignPopover-controls-gotIt",
                            children: "Got it"
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsReassignPopover-contextWrapper",
        children: isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                trigger,
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                    ref: drawerRef,
                    isSwipeEnabled: true,
                    isOpen: isCommentPopoverOpen,
                    setIsOpen: setIsCommentPopoverOpen,
                    content: getPopoverContent(),
                    className: "CertsReassignPopover"
                })
            ]
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
            isPortalEnabled: true,
            placement: placement,
            trigger: trigger,
            popoverContent: getPopoverContent(),
            isOpen: isCommentPopoverOpen,
            setIsOpen: setIsCommentPopoverOpen
        })
    });
}
$315ae4957e308cf1$var$CertsReassignPopover.propTypes = {
    isCommentPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsCommentPopoverOpen: (0, $hopDi$proptypes).func.isRequired,
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired,
    placement: (0, $hopDi$proptypes).string.isRequired,
    trigger: (0, $hopDi$proptypes).element.isRequired,
    onSubmit: (0, $hopDi$proptypes).func.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired
};
$315ae4957e308cf1$var$CertsReassignPopover.defaultProps = {};
var $315ae4957e308cf1$export$2e2bcd8739ae039 = $315ae4957e308cf1$var$CertsReassignPopover;











/* eslint-disable indent */ 





/*
 * Name: CertsModalCommentBox
 * Accepts:
 *    defaultComments: [] (Array of pre defined comment)
 *    showAlert: boolean (Show the critical messsage when set to true, only when input box is empty)
 *    onChange: fn (function which receives the text from the input box)
 */ function $b3efe2b33729b6d5$var$CertsModalCommentBox({ defaultComments: defaultComments, showAlert: showAlert, onChange: onChange, isDisabled: isDisabled, clearModal: clearModal, shouldDisallowBrackets: shouldDisallowBrackets, className: className, dataTestId: dataTestId }) {
    const [predefComments, setPredefComments] = (0, $hopDi$useState)([]);
    const [commentDescription, setCommentDescription] = (0, $hopDi$useState)("");
    const [isCommentApplied, setIsCommentApplied] = (0, $hopDi$useState)(false);
    const CertsModalCommentBoxClasses = (0, $hopDi$classnames)("CertsModalCommentBox-wrapper", className);
    (0, $hopDi$useEffect)(()=>{
        setCommentDescription("");
    }, [
        clearModal
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (Array.isArray(defaultComments) && defaultComments?.length > 0) setPredefComments(defaultComments?.map((comment, index)=>({
                text: comment,
                isChecked: false,
                index: index + 1
            })));
    }, [
        defaultComments
    ]);
    const shouldShowChipsForSignature = Boolean(predefComments.length > 0);
    const shouldShowAlertForCommentForSignature = Boolean(showAlert && (/[<>]/.test(commentDescription) || commentDescription.trim().length < 3));
    (0, $hopDi$useEffect)(()=>{
        onChange(commentDescription);
    }, [
        commentDescription
    ]);
    const handleCommentClickForSignature = (id)=>{
        const tempPreDefComments = predefComments.map((comment)=>{
            if (comment.index === id) return {
                ...comment,
                isChecked: !comment.isChecked
            };
            return {
                ...comment,
                isChecked: false
            };
        });
        const isActiveComment = tempPreDefComments.some((comment)=>comment.isChecked);
        const tempCommentDescription = tempPreDefComments.find((item)=>item.index === id)?.text;
        setPredefComments(tempPreDefComments);
        setIsCommentApplied(isActiveComment);
        setCommentDescription(isActiveComment ? tempCommentDescription : "");
    };
    const handleSignatureComment = (text)=>{
        // Use `newdescription` to set the comment description if
        // - predefined comment is present and,
        // - on adding text manually,
        // - the comment should reset/blank
        // const newdescription = isCommentApplied
        //   ? getStringDifference(commentDescription, text)
        //   : text;
        setCommentDescription(text);
        setPredefComments(isCommentApplied ? predefComments.map((comment)=>({
                ...comment,
                isChecked: false
            })) : predefComments);
        setIsCommentApplied(false);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: CertsModalCommentBoxClasses,
        dataTestId: dataTestId,
        children: [
            shouldShowChipsForSignature && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsModalCommentBox-comments",
                children: predefComments?.map((item)=>{
                    if (item?.text?.length > 25) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                        trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                            kind: item.isChecked ? "boldFilled" : "outlined",
                            label: item.text,
                            isSelected: item.isChecked,
                            color: "brandSecondary",
                            className: "CertsModalCommentBox-commentsChips",
                            rightIcon: item.isChecked ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "Close",
                                size: "xxxSmall"
                            }) : null,
                            onClick: ()=>handleCommentClickForSignature(item.index)
                        }),
                        isWordBreak: false,
                        text: item.text,
                        placement: "top"
                    }, item.index);
                    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                        kind: item.isChecked ? "boldFilled" : "outlined",
                        label: item.text,
                        isSelected: item.isChecked,
                        color: "brandSecondary",
                        className: "CertsModalCommentBox-commentsChips",
                        rightIcon: item.isChecked ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Close",
                            size: "xxxSmall"
                        }) : null,
                        onClick: ()=>handleCommentClickForSignature(item.index)
                    }, item.index);
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: `CertsModalCommentBox-inputBox ${shouldShowChipsForSignature ? "" : "noCommentsPresent"}`,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "basic",
                    placeholder: "Provide a reason for your decision",
                    label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h4",
                        mobile: "h4-d",
                        htmlFor: "Required",
                        className: "CertsModalCommentBox-inputBox-label",
                        children: "Comments"
                    }),
                    value: commentDescription,
                    setValue: handleSignatureComment,
                    kind: "multiline",
                    isRequired: true,
                    isDisabled: isDisabled,
                    minRequiredChars: 3,
                    shouldDisallowBrackets: shouldDisallowBrackets,
                    isCritical: shouldShowAlertForCommentForSignature,
                    CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "missingRequiredField",
                        size: "small"
                    })
                })
            })
        ]
    });
}
$b3efe2b33729b6d5$var$CertsModalCommentBox.propTypes = {
    defaultComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    onChange: (0, $hopDi$proptypes).func,
    isDisabled: (0, $hopDi$proptypes).bool,
    shouldDisallowBrackets: (0, $hopDi$proptypes).bool,
    clearModal: (0, $hopDi$proptypes).bool,
    className: (0, $hopDi$proptypes).string,
    dataTestId: (0, $hopDi$proptypes).string
};
$b3efe2b33729b6d5$var$CertsModalCommentBox.defaultProps = {
    defaultComments: [],
    onChange: ()=>{},
    isDisabled: false,
    clearModal: true,
    shouldDisallowBrackets: true,
    className: null,
    dataTestId: null
};
var $b3efe2b33729b6d5$export$2e2bcd8739ae039 = $b3efe2b33729b6d5$var$CertsModalCommentBox;




function $70f14337b6a0828d$var$CertsChangeEndDate({ handleClick: handleClick, handleCancel: handleCancel, getCurrentEndDate: getCurrentEndDate, isChangeEndDateError: isChangeEndDateError, setIsChangeEndDateError: setIsChangeEndDateError, allowedChangeExtendDate: allowedChangeExtendDate, isLoading: isLoading, certificationStartDate: certificationStartDate, errorMessage: errorMessage, getDefaultEndDate: getDefaultEndDate, isCertsKindUser: isCertsKindUser, isMobileXlargeWidth: isMobileXlargeWidth }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(true);
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const { isActionLoading: isActionLoading } = (0, $hopDi$useSelector)((state)=>state?.certifications.action);
    let checkMinDate = (0, $hopDi$moment)(new Date()).isAfter((0, $hopDi$moment)(certificationStartDate), "day");
    checkMinDate = checkMinDate ? new Date() : certificationStartDate;
    const defaultDate = getDefaultEndDate || null;
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const [startDate, setStartDate] = (0, $hopDi$useState)(defaultDate);
    const [isDateCritical, setIsDateCritical] = (0, $hopDi$useState)(false);
    const [getAllowedChangeExtendDates, setAllowedChangeExtendDates] = (0, $hopDi$useState)(checkMinDate);
    const isCommentValid = Boolean(commentValue?.trim().length >= 3);
    const isFormValid = isCommentValid && defaultDate !== startDate;
    const dispatch = (0, $hopDi$useDispatch)();
    const { predefinedComments: predefinedComments } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [commentsDetails, setCommentDetails] = (0, $hopDi$useState)({
        commentDescription: "",
        predefComments: [],
        isCommentApplied: false,
        showAlert: false
    });
    (0, $hopDi$useEffect)(()=>{
        const lineItemType = isCertsKindUser ? (0, $20281fe09bc700a8$export$684f6d0b3182db31).EXTEND_END_DATE_USERS : (0, $20281fe09bc700a8$export$684f6d0b3182db31).EXTENDENDDATEFORACCESS;
        if (lineItemType in predefinedComments) setCommentDetails({
            ...commentsDetails,
            predefComments: predefinedComments[lineItemType] || []
        });
        else dispatch((0, $d623f23401a154f0$export$27dd55286e4e826a)(lineItemType)).catch((error)=>(0, $hopDi$Logger).log(error));
    }, [
        predefinedComments
    ]);
    (0, $hopDi$useEffect)(()=>{
        let getAllowedDays;
        if (Number(allowedChangeExtendDate) > 1) getAllowedDays = Number(allowedChangeExtendDate) - 1;
        else getAllowedDays = 0;
        if (allowedChangeExtendDate && allowedChangeExtendDate.length > 0) {
            const minDateForDatePicker = (0, $hopDi$moment)(certificationStartDate).add(getAllowedDays, "days");
            setAllowedChangeExtendDates(minDateForDatePicker.toDate());
        } else setAllowedChangeExtendDates(null);
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (startDate) setIsDateCritical(false);
        if (commentValue && !isCommentValid) setIsCritical(false);
    }, [
        startDate,
        commentValue
    ]);
    const handleSave = ()=>{
        if (!startDate) {
            setIsDateCritical(true);
            setCommentDetails({
                ...commentsDetails,
                showAlert: true
            });
        }
        if (!isCommentValid) {
            setIsCritical(true);
            setCommentDetails({
                ...commentsDetails,
                showAlert: true
            });
        }
        if (startDate && (isCommentValid || commentsDetails?.commentDescription)) {
            let currentDate = startDate;
            const dd = currentDate.getDate();
            const mm = currentDate.getMonth() + 1;
            const yyyy = currentDate.getFullYear();
            currentDate = `${mm < 10 ? `0${mm}` : mm}-${dd < 10 ? `0${dd}` : dd}-${yyyy}`;
            let comments = "";
            if (commentsDetails?.commentDescription) comments = commentsDetails.commentDescription;
            handleClick(currentDate, comments);
        }
    };
    const handleCommentText = (text)=>{
        setCommentValue(text);
        setCommentDetails({
            ...commentsDetails,
            commentDescription: text,
            showAlert: text.length === 0 ? commentsDetails.showAlert : false
        });
    };
    const handleClose = ()=>{
        setIsOpen(false);
        setIsChangeEndDateError();
        handleCancel();
    };
    const getChangeEndDateModal = ()=>{
        const changeEndDateActionBodyContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$StackingAlertBanner), {
                        colorTheme: "Critical",
                        title: "Error",
                        description: errorMessage,
                        isVisible: isChangeEndDateError,
                        onCancel: setIsChangeEndDateError
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsChangeEndDate-CommonMargin-Container",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                children: "Current End Date"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                variant: "body3",
                                className: (0, $hopDi$classnames)(`CertsChangeEndDate-Title${getCurrentEndDate && getCurrentEndDate === "-" ? " CertsChangeEndDate-title--isEmpty" : ""}`),
                                children: getCurrentEndDate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$DateAndTimePicker), {
                        isDisabled: allowedChangeExtendDate === "0",
                        className: "CertsChangeEndDate-CommonMargin-Container",
                        kind: "dateStart",
                        label: "New End Date",
                        isRequired: true,
                        isCritical: isDateCritical,
                        setIsCritical: setIsDateCritical,
                        CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                            text: "Please select a new end date.",
                            colorTheme: "critical",
                            size: "small",
                            leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "AlertCritical",
                                color: "critical-700"
                            })
                        }),
                        startDate: startDate,
                        setStartDate: setStartDate,
                        minDate: checkMinDate,
                        maxDate: getAllowedChangeExtendDates
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3efe2b33729b6d5$export$2e2bcd8739ae039), {
                        defaultComments: commentsDetails?.predefComments,
                        showAlert: isCritical,
                        onChange: handleCommentText,
                        shouldDisallowBrackets: false,
                        dataTestId: "CertsChangeEndDate-commentBoxTestId"
                    })
                ]
            });
        const changeEndDateActionFooterContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        isDisabled: isLoading,
                        size: "medium",
                        onClick: ()=>{
                            setIsOpen(false);
                            handleCancel();
                        },
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        className: "CertsChangeEndDate-saveButton",
                        type: "button",
                        kind: isFormValid ? "filled" : "outlined",
                        isLoading: isActionLoading,
                        isDisabled: isLoading,
                        size: "medium",
                        onClick: ()=>handleSave(),
                        children: "Save"
                    })
                ]
            });
        return !isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            onClose: ()=>handleClose(),
            className: "CertsChangeEndDateModal-wrapper",
            isOpen: isOpen,
            headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "ExtendEndDate",
                color: "neutral-1000",
                size: "large"
            }),
            title: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "CertsChangeEndDateModal-titleWrapper",
                children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "CertsChangeEndDateModal-commentsTitle",
                    children: "Change End Date"
                })
            }),
            subtitle: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "CertsChangeEndDateModal-commentsDesc",
                children: "The end date won't be changed until you finish the review and submit."
            }),
            contentBody: changeEndDateActionBodyContent(),
            FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
                size: "large",
                dataTestId: "CertsChangeEndDate-footerTestId",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsChangeEndDate-buttonWrapper",
                        children: changeEndDateActionFooterContent()
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
            maxHeight: "calc(100vh - 12rem)",
            headerContent: /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
                className: "CertsChangeEndDate-mobileDrawer-header",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsChangeEndDate-mobileDrawer-titleContainer",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "ExtendEndDate",
                                color: "neutral-1000",
                                size: "large"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CertsChangeEndDateModal-titleWrapper",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h1",
                                        className: "CertsChangeEndDateModal-commentsTitle",
                                        children: "Change End Date"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        className: "CertsChangeEndDateModal-commentsDesc",
                                        children: "The end date won't be changed until you finish the review and submit."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: ()=>handleClose()
                    })
                ]
            }),
            content: changeEndDateActionBodyContent(),
            footerActionBar: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$FooterActionBar), {
                size: "large",
                className: "CertsActionPopover-controls",
                children: changeEndDateActionFooterContent()
            }),
            className: "CertsChangeEndDate-mobileDrawer",
            setIsOpen: ()=>handleClose(),
            isOpen: isOpen,
            renderOnlyContent: true,
            isCloseButtonEnabled: false
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        className: "proof-that-this-element-is-rendered-in-test-file-while-rendering",
        children: getChangeEndDateModal()
    });
}
$70f14337b6a0828d$var$CertsChangeEndDate.propTypes = {
    handleClick: (0, $hopDi$proptypes).func.isRequired,
    handleCancel: (0, $hopDi$proptypes).func.isRequired,
    getCurrentEndDate: (0, $hopDi$proptypes).string.isRequired,
    isChangeEndDateError: (0, $hopDi$proptypes).bool.isRequired,
    setIsChangeEndDateError: (0, $hopDi$proptypes).func.isRequired,
    allowedChangeExtendDate: (0, $hopDi$proptypes).string.isRequired,
    isLoading: (0, $hopDi$proptypes).bool,
    certificationStartDate: (0, $hopDi$proptypes).instanceOf(Date).isRequired,
    errorMessage: (0, $hopDi$proptypes).string,
    getDefaultEndDate: (0, $hopDi$proptypes).string.isRequired,
    isCertsKindUser: (0, $hopDi$proptypes).bool.isRequired,
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired
};
$70f14337b6a0828d$var$CertsChangeEndDate.defaultProps = {
    errorMessage: "Error! Please try again later.",
    isLoading: null
};
var $70f14337b6a0828d$export$2e2bcd8739ae039 = $70f14337b6a0828d$var$CertsChangeEndDate;


var $2b983767f0657a26$export$2e2bcd8739ae039 = (0, $70f14337b6a0828d$export$2e2bcd8739ae039);















const $8ef29c07b3459fed$export$83b788b1a3698c03 = (obj)=>Object.keys(obj).length === 0;
const $8ef29c07b3459fed$export$a0a8ab6941a822be = (nodeData)=>{
    const certsKind = (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData);
    if (certsKind === (0, $271c8dec800e3a4d$export$b0f71eb1e01c7936) || certsKind === (0, $271c8dec800e3a4d$export$5965ea730be9034a) && nodeData?.Role_ROLETYPE === (0, $e7683d2bb9b3b8c9$export$7f85b66a0bcac447).APPLICATION_ROLE) return ` Assign the ${certsKind.toLocaleLowerCase()} to another certifier and provide a reason. Any approvals or rejections will be cleared upon reassignment.`;
    return ` Assign the ${certsKind.toLocaleLowerCase()} and their associated items to another certifier, and
    provide a reason. Any approvals or rejections will be cleared upon
    reassignment.`;
};












var $2515ed647c64b6ee$export$2e2bcd8739ae039 = (0, $b3efe2b33729b6d5$export$2e2bcd8739ae039);








const $67f34174d661edd3$export$5e67df2c6d1633e6 = {
    isIncludeAssociatedEnt: false,
    isNoteRequired: true,
    noteText: "Access items associated with this user are included.",
    isIncludeAsscLabel: "",
    lineItemKind: "User"
};
const $67f34174d661edd3$export$5e26257cd0129f38 = {
    enableReassignUser: "1",
    enableReassignStep2: "1",
    defaultReassignee: "33",
    defaultReassigneeName: "null null (EORO_Reassign1)",
    enableIndividualCommentsForAccountEntitlementRoles: [
        "YES",
        "NO",
        "NORESPONSE",
        "RE-ASSIGN",
        "REASSIGNSTEP2"
    ],
    enableIndividualCommentsForUsers: [
        "DOES NOT WORK FOR ME",
        "WORKS FOR ME",
        "NORESPONSE",
        "TERMINATED",
        "RE-ASSIGN"
    ],
    showReassignPopup: "1",
    certifierUserKey: "33"
};
const $67f34174d661edd3$export$215158a629df5eab = [
    {
        id: 2,
        username: "systemadmin",
        firstname: "system",
        lastname: "admin",
        email: "",
        displayname: "",
        manager: 5,
        value: "2",
        label: "system admin(systemadmin)",
        isChecked: false
    },
    {
        id: 4,
        username: "SaviyntSupportAgent2",
        firstname: "Saviynt",
        lastname: "Support",
        email: "",
        displayname: "",
        manager: 9,
        value: "4",
        label: "Saviynt Support(SaviyntSupportAgent2)",
        isChecked: false
    },
    {
        id: 5,
        username: "SaviyntSupportAgent3",
        firstname: "",
        lastname: "",
        email: "",
        displayname: "",
        manager: 65,
        value: "5",
        label: "(SaviyntSupportAgent3)",
        isChecked: false
    },
    {
        id: 6,
        username: "EO_Campaign_Owner",
        firstname: "FN",
        lastname: "LN",
        email: "yesaswini.k@saviynt.com",
        displayname: "",
        manager: 7,
        value: "6",
        label: "FN LN(EO_Campaign_Owner) - yesaswini.k@saviynt.com",
        isChecked: false
    },
    {
        id: 7,
        username: "EO_Campaign_Owner_Delegate",
        firstname: "",
        lastname: "",
        email: "",
        displayname: "",
        manager: 65,
        value: "7",
        label: "(EO_Campaign_Owner_Delegate)",
        isChecked: false
    },
    {
        id: 8,
        username: "EORO_Certifier1",
        firstname: "FN",
        lastname: "LN",
        email: "",
        displayname: "",
        manager: 61,
        value: "8",
        label: "FN LN(EORO_Certifier1)",
        isChecked: false
    },
    {
        id: 9,
        username: "AOMD_Owner",
        firstname: "",
        lastname: "",
        email: "",
        displayname: "",
        manager: 65,
        value: "9",
        label: "(AOMD_Owner)",
        isChecked: false
    },
    {
        id: 10,
        username: "AOMD_User1",
        firstname: "",
        lastname: "",
        email: "geetha.t@saviynt.com",
        displayname: "",
        manager: 95,
        value: "10",
        label: "(AOMD_User1) - geetha.t@saviynt.com",
        isChecked: false
    },
    {
        id: 11,
        username: "oo_owner1",
        firstname: "",
        lastname: "",
        email: "test9@saviynt.com",
        displayname: "",
        manager: 65,
        value: "11",
        label: "(oo_owner1) - test9@saviynt.com",
        isChecked: false
    },
    {
        id: 12,
        username: "oo_owner11",
        firstname: "",
        lastname: "",
        email: "test10@saviynt.com",
        displayname: "",
        manager: 65,
        value: "12",
        label: "(oo_owner11) - test10@saviynt.com",
        isChecked: false
    }
];



/* eslint-disable no-param-reassign */ const $537dfcd4057c7cd4$export$b978961550c58af1 = (firstName, lastName, username, email)=>{
    const namePart = `${firstName || ""} ${lastName || ""}`.trim();
    const usernamePart = username ? `(${username})` : "";
    const emailInfo = email ? ` - ${email}` : "";
    const label = `${namePart}${usernamePart}${emailInfo}`;
    return label.length > 80 ? `${label.slice(0, 80)}...` : label;
};
const $537dfcd4057c7cd4$export$843ad9807fe4b13f = (list)=>list.map((ele)=>{
        ele.value = ele.id?.toString();
        ele.label = `${$537dfcd4057c7cd4$export$b978961550c58af1(ele.firstname, ele.lastname, ele.username, ele.email)}`;
        ele.isChecked = false;
        return ele;
    });
const $537dfcd4057c7cd4$export$83b788b1a3698c03 = (obj)=>Object.keys(obj).length === 0;



function $fe98409497a36d0b$var$CertsUserListDropdown({ onSelect: onSelect, defaultReassignee: defaultReassignee, defaultAssigneName: defaultAssigneName, className: className, isDisabled: isDisabled, certKey: certKey, placeholder: placeholder, showDefaultCertifier: showDefaultCertifier, selectedUser: selectedUser, certifierUserKey: certifierUserKey, inputFieldTestId: inputFieldTestId, isCritical: isCritical }) {
    const [usersList, setUsersList] = (0, $hopDi$useState)(inputFieldTestId ? (0, $67f34174d661edd3$export$215158a629df5eab) : []);
    const [offset, setOffset] = (0, $hopDi$useState)(0);
    const [isLoading, setIsLoading] = (0, $hopDi$useState)(false);
    const [hasMoreOptions, setHasMoreOptions] = (0, $hopDi$useState)(true);
    const [searchTerm, setSearchTerm] = (0, $hopDi$useState)(null);
    const LOAD_INCREMENT = 10;
    const dispatch = (0, $hopDi$useDispatch)();
    const getUsersList = async (searchText, offSet, maxCount)=>{
        // TODO: Would like to not NEED this to stop api calls in tests errors, get with dev team to come up with a fix.
        // Disable for testing
        if (inputFieldTestId) return;
        const body = {
            certkey: certKey,
            offset: offSet,
            max: maxCount
        };
        if (searchText) // to search user by name
        body.sSearch = searchText;
        if (!isLoading) setIsLoading(true);
        const list = [];
        let fetchedRecords = [];
        if (defaultReassignee !== "" && defaultAssigneName !== "" && showDefaultCertifier && (searchText === "" || !searchText)) {
            if (certifierUserKey !== defaultReassignee) {
                const defaultCertifier = {};
                defaultCertifier.value = defaultReassignee;
                defaultCertifier.label = `${defaultAssigneName} - default certifier`;
                defaultCertifier.isChecked = false;
                list.push(defaultCertifier);
            }
        }
        dispatch((0, $d623f23401a154f0$export$faa42d9d9aeac826)(body)).then((data)=>{
            if (offSet === 0 && !data?.resultsList) {
                setUsersList([]);
                setHasMoreOptions(false);
            } else if (offSet === 0 && data?.resultsList?.length) {
                fetchedRecords = (0, $537dfcd4057c7cd4$export$843ad9807fe4b13f)(data.resultsList);
                fetchedRecords = list.concat(fetchedRecords);
                setUsersList(fetchedRecords);
                setHasMoreOptions(true);
            } else if (offSet !== 0 && !data?.resultsList) setHasMoreOptions(false);
            else if (offSet !== 0 && data.resultsList?.length) {
                fetchedRecords = (0, $537dfcd4057c7cd4$export$843ad9807fe4b13f)(data.resultsList);
                setUsersList((prevList)=>prevList.concat(fetchedRecords));
                setHasMoreOptions(true);
            }
        }).catch((error)=>{
            (0, $hopDi$Logger).error("getUsersListWithSearch error ", error);
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    (0, $hopDi$useEffect)(()=>{
        // initial load
        getUsersList(searchTerm, offset, LOAD_INCREMENT);
    }, []);
    const loadUsersList = (0, $hopDi$useCallback)((searchTermValue, offsetValue = 0)=>{
        getUsersList(searchTermValue, offsetValue, LOAD_INCREMENT);
    }, []);
    // Wrap loadUsersList with debounce
    const debouncedLoadUsersList = (0, $hopDi$useCallback)((0, $hopDi$debounce)(loadUsersList, 500), [
        loadUsersList
    ]);
    const handleChange = (selectedOption)=>{
        setUsersList((prevList)=>prevList.map((option)=>{
                // eslint-disable-next-line no-param-reassign
                option.isChecked = option.value === selectedOption.value;
                return option;
            }));
        // on clear resetting the offset  to 0 and calling user api with out search
        if (selectedOption && (0, $537dfcd4057c7cd4$export$83b788b1a3698c03)(selectedOption)) {
            setOffset(0);
            loadUsersList(null, 0);
        }
        onSelect(selectedOption);
    };
    const handleScroll = (e)=>{
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = e.target;
        if (scrollHeight - scrollTop === clientHeight && hasMoreOptions && !isLoading) {
            // load more options
            setIsLoading(true);
            setOffset((prevOffset)=>{
                const newOffset = prevOffset + LOAD_INCREMENT;
                debouncedLoadUsersList(searchTerm, newOffset);
                return newOffset;
            });
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        className: `CertsUserListDropdown anyWidthPositionRelative ${className} ${selectedUser && "Certs-userSelected"}`,
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MenuInput), {
            className: isDisabled ? "CertsUserListDropdown--disableMenu" : "CertsUserListDropdown--enableMenu",
            options: usersList,
            onChange: handleChange,
            placeholder: placeholder,
            setSearchTerm: setSearchTerm,
            isLoading: isLoading,
            isCritical: isCritical,
            CriticalHelperText: !searchTerm || searchTerm === "" ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                kind: "missingRequiredField",
                size: "small"
            }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                text: "Please select the correct option from the list.",
                colorTheme: "critical",
                size: "small",
                leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "AlertCritical"
                })
            }),
            onScroll: handleScroll,
            dropdownClassName: "Certs-dropdownSelect",
            hasMoreOptions: hasMoreOptions,
            suffixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "Check",
                color: "navy-700",
                size: "medium"
            }),
            isSearchDisabled: true,
            loadingText: "Loading more results",
            onSearchTermChange: (value)=>{
                setOffset(0);
                setSearchTerm(value);
                debouncedLoadUsersList(value.trim());
            },
            heightConfigs: {
                maxHeight: "11.5rem"
            },
            menuItemHeightConfigs: {
                height: "2rem"
            },
            inputFieldTestId: inputFieldTestId
        })
    });
}
$fe98409497a36d0b$var$CertsUserListDropdown.propTypes = {
    onSelect: (0, $hopDi$proptypes).func.isRequired,
    defaultReassignee: (0, $hopDi$proptypes).string.isRequired,
    defaultAssigneName: (0, $hopDi$proptypes).string.isRequired,
    className: (0, $hopDi$proptypes).string,
    isDisabled: (0, $hopDi$proptypes).bool,
    certKey: (0, $hopDi$proptypes).string.isRequired,
    placeholder: (0, $hopDi$proptypes).string,
    selectedUser: (0, $hopDi$proptypes).shape({}).isRequired,
    showDefaultCertifier: (0, $hopDi$proptypes).bool,
    certifierUserKey: (0, $hopDi$proptypes).string.isRequired,
    inputFieldTestId: (0, $hopDi$proptypes).string,
    isCritical: (0, $hopDi$proptypes).bool
};
$fe98409497a36d0b$var$CertsUserListDropdown.defaultProps = {
    placeholder: "Select a known certifier",
    showDefaultCertifier: false,
    isCritical: false,
    className: "",
    isDisabled: false,
    inputFieldTestId: ""
};
var $fe98409497a36d0b$export$2e2bcd8739ae039 = $fe98409497a36d0b$var$CertsUserListDropdown;


var $2c1f4f91a862faa4$export$2e2bcd8739ae039 = (0, $fe98409497a36d0b$export$2e2bcd8739ae039);





function $94cb1d296eacf3b1$var$CertsConsultContent({ consultModalDetails: consultModalDetails, nodeData: nodeData, isIncludeAssociateChecked: isIncludeAssociateChecked, setIsIncludedAssociateChecked: setIsIncludedAssociateChecked, dropdownClassName: dropdownClassName, handleSelectUser: handleSelectUser, isSelectVisible: isSelectVisible, menuDropdownTestId: menuDropdownTestId, commentsDetails: commentsDetails, isCritical: isCritical, handleCommentDescription: handleCommentDescription, commentInputTestId: commentInputTestId, selectedUser: selectedUser, isCommentRequired: isCommentRequired, isMobileWidth: isMobileWidth }) {
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(false);
    const { certKey: certKey, reassignConfigMap: reassignConfigMap, action: { errorMessage: errorMessage, isActionError: isActionError } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const isCertsKindUser = nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER;
    const { CONSULT_MODAL_ALERT_BANNER_ERROR: CONSULT_MODAL_ALERT_BANNER_ERROR } = (0, $b8f7755ebbf5c667$export$800daf5fbbe96aff);
    (0, $hopDi$useEffect)(()=>{
        setIsVisible(isActionError);
    }, [
        isActionError
    ]);
    /** to get lineitem display name */ const getSelectedLineItemName = (lineItemType)=>{
        let name = "";
        switch(lineItemType){
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER:
                name = nodeData[0, $271c8dec800e3a4d$export$46f21910265caffc];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ACCOUNT:
                name = nodeData[0, $271c8dec800e3a4d$export$b21a97077b446a0c];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ROLE:
                name = nodeData[0, $271c8dec800e3a4d$export$ef258f55852583b5];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ENTITLEMENT:
                name = nodeData[0, $271c8dec800e3a4d$export$8e9b5a553c0ae9b2];
                break;
            default:
                break;
        }
        if (!name) name = "Not Provided";
        return name;
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsConsultModal-containerHeader",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        className: "consultCertifier-selectionWarn",
                        colorTheme: "Critical",
                        title: "Error",
                        description: errorMessage,
                        isVisible: isVisible,
                        onCancel: ()=>setIsVisible(false),
                        dataTestId: CONSULT_MODAL_ALERT_BANNER_ERROR
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsConsultModal-details",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                mobile: "h4-d",
                                className: "CertsConsultModal-containerTitle",
                                children: "Items to Consult"
                            }),
                            consultModalDetails?.isNoteRequired && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsReassignModal-containerNote",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                    openDelay: 500,
                                    text: consultModalDetails?.noteText,
                                    maxWidth: "20rem",
                                    placement: isMobileWidth ? "top" : "right",
                                    offset: 8,
                                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "Info",
                                        color: "info-700",
                                        className: "CertsReassignModal-containerNoteIcon"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsConsultModal-container-userDetails",
                        children: [
                            isCertsKindUser ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Avatar), {
                                size: "small"
                            }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData),
                                color: "navy-900",
                                size: "smallMedium"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                mobile: "body2-d",
                                className: "CertsConsultModal-container-userDetailsName",
                                children: getSelectedLineItemName(consultModalDetails?.lineItemKind)
                            })
                        ]
                    }),
                    consultModalDetails?.isIncludeAssociatedEnt && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsConsultModal-includeCheckbox",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                            name: "checkbox2",
                            kind: "text",
                            isChecked: isIncludeAssociateChecked,
                            onChange: (event)=>{
                                setIsIncludedAssociateChecked(event.target.checked);
                            },
                            label: consultModalDetails?.isIncludeAsscLabel,
                            labelPosition: "before"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsConsultModal-containerCertifierSelection",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsConsultModal-DropdownAsterisk",
                        children: "*"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h4",
                        desktop: "h4-d",
                        mobile: "h4-d",
                        className: "CertsConsultModal-container-certifier",
                        children: "I want to consult with"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $2c1f4f91a862faa4$export$2e2bcd8739ae039), {
                        certKey: certKey,
                        className: dropdownClassName,
                        defaultReassignee: reassignConfigMap?.defaultReassignee,
                        defaultAssigneName: reassignConfigMap?.defaultReassigneeName,
                        certifierUserKey: reassignConfigMap?.certifierUserKey,
                        onSelect: (user)=>{
                            handleSelectUser(user);
                        },
                        isCritical: isSelectVisible,
                        selectedUser: selectedUser,
                        placeholder: "Search by first name, last name, username, or email",
                        inputFieldTestId: menuDropdownTestId
                    })
                ]
            }),
            isCommentRequired && /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
                defaultComments: commentsDetails?.predefComments,
                showAlert: isCritical,
                onChange: handleCommentDescription,
                className: "CertsConsultModal-comments",
                dataTestId: commentInputTestId
            })
        ]
    });
}
$94cb1d296eacf3b1$var$CertsConsultContent.propTypes = {
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    consultModalDetails: (0, $hopDi$proptypes).shape({
        isIncludeAssociatedEnt: (0, $hopDi$proptypes).bool,
        isNoteRequired: (0, $hopDi$proptypes).bool,
        noteText: (0, $hopDi$proptypes).string,
        isIncludeAsscLabel: (0, $hopDi$proptypes).string,
        lineItemKind: (0, $hopDi$proptypes).string
    }).isRequired,
    isIncludeAssociateChecked: (0, $hopDi$proptypes).bool.isRequired,
    setIsIncludedAssociateChecked: (0, $hopDi$proptypes).func.isRequired,
    dropdownClassName: (0, $hopDi$proptypes).string.isRequired,
    handleSelectUser: (0, $hopDi$proptypes).func.isRequired,
    isSelectVisible: (0, $hopDi$proptypes).bool.isRequired,
    menuDropdownTestId: (0, $hopDi$proptypes).bool.isRequired,
    commentsDetails: (0, $hopDi$proptypes).shape({
        commentDescription: (0, $hopDi$proptypes).string.isRequired,
        predefComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
        isCommentApplied: (0, $hopDi$proptypes).bool.isRequired,
        showAlert: (0, $hopDi$proptypes).bool.isRequired
    }).isRequired,
    isCritical: (0, $hopDi$proptypes).bool.isRequired,
    handleCommentDescription: (0, $hopDi$proptypes).func.isRequired,
    commentInputTestId: (0, $hopDi$proptypes).string.isRequired,
    selectedUser: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).shape({
            id: (0, $hopDi$proptypes).number.isRequired,
            username: (0, $hopDi$proptypes).string.isRequired,
            firstname: (0, $hopDi$proptypes).string.isRequired,
            lastname: (0, $hopDi$proptypes).string.isRequired,
            email: (0, $hopDi$proptypes).string.isRequired,
            displayname: (0, $hopDi$proptypes).string.isRequired,
            manager: (0, $hopDi$proptypes).number.isRequired
        }),
        (0, $hopDi$proptypes).oneOf([
            null
        ])
    ]).isRequired,
    isCommentRequired: (0, $hopDi$proptypes).bool.isRequired,
    isMobileWidth: (0, $hopDi$proptypes).bool.isRequired
};
var $94cb1d296eacf3b1$export$2e2bcd8739ae039 = $94cb1d296eacf3b1$var$CertsConsultContent;







function $2ae7ee36f788425a$var$CertsConsultFooter({ isActionLoading: isActionLoading, setIsConsultModalOpen: setIsConsultModalOpen, isConsultValid: isConsultValid, handleSubmit: handleSubmit }) {
    const { CONSULT_MODAL_SUBMIT_BUTTON: CONSULT_MODAL_SUBMIT_BUTTON } = (0, $b8f7755ebbf5c667$export$800daf5fbbe96aff);
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$FooterActionBar), {
        className: "CertsConsultModal-footer",
        size: "large",
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "CertsConsultModal-actionButtons",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "ghost",
                    size: "medium",
                    isDisabled: isActionLoading,
                    onClick: ()=>{
                        setIsConsultModalOpen(false);
                    },
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    className: "CertsConsultModal-submitButton",
                    type: "button",
                    kind: isConsultValid ? "filled" : "outlined",
                    size: "medium",
                    onClick: handleSubmit,
                    isLoading: isActionLoading,
                    loaderText: "Submitting",
                    dataTestId: CONSULT_MODAL_SUBMIT_BUTTON,
                    children: "Submit"
                })
            ]
        })
    });
}
$2ae7ee36f788425a$var$CertsConsultFooter.propTypes = {
    isActionLoading: (0, $hopDi$proptypes).bool.isRequired,
    setIsConsultModalOpen: (0, $hopDi$proptypes).func.isRequired,
    isConsultValid: (0, $hopDi$proptypes).bool.isRequired,
    handleSubmit: (0, $hopDi$proptypes).func.isRequired
};
var $2ae7ee36f788425a$export$2e2bcd8739ae039 = $2ae7ee36f788425a$var$CertsConsultFooter;



// TODO: Alert banner needs critical handler update for alert text and timing
function $7f3598ff04b0c7dc$var$CertsConsultModal({ isConsultModalOpen: isConsultModalOpen, setIsConsultModalOpen: setIsConsultModalOpen, setIsActionDrawerOutsideClick: setIsActionDrawerOutsideClick, consultModalDetails: consultModalDetails, nodeData: nodeData, isCommentRequired: isCommentRequired, onSubmit: onSubmit, menuDropdownTestId: // Testing
menuDropdownTestId, commentInputTestId: commentInputTestId }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const [isIncludeAssociateChecked, setIsIncludedAssociateChecked] = (0, $hopDi$useState)(false);
    const [selectedUser, setSelectedUser] = (0, $hopDi$useState)(null);
    const [isSelectVisible, setIsSelectVisible] = (0, $hopDi$useState)(false);
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, action: { isActionSuccess: isActionSuccess, isActionLoading: isActionLoading }, mediaQueryValue: mediaQueryValue, predefinedComments: predefinedComments } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [commentsDetails, setCommentDetails] = (0, $hopDi$useState)({
        commentDescription: "",
        predefComments: [],
        isCommentApplied: false,
        showAlert: false
    });
    const isCommentRequiredCompleteAndValid = Boolean(isCommentRequired && commentValue && !/[<>]/.test(commentValue) && commentValue.trim().length > 3);
    const isConsultValid = !isCritical && selectedUser && (!isCommentRequired || isCommentRequiredCompleteAndValid);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mediaQueryValue >= mobileXlargeQuery.value;
    const dropdownClassName = (0, $hopDi$classnames)("CertsConsultModal-dropdown");
    (0, $hopDi$useEffect)(()=>{
        setIsOpen(isConsultModalOpen);
    }, [
        isConsultModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        // by default checkbox should be selected for account
        if (consultModalDetails?.isIncludeAssociatedEnt) setIsIncludedAssociateChecked(true);
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (isActionSuccess) {
            setIsConsultModalOpen(false);
            setIsActionDrawerOutsideClick(true);
        }
    }, [
        isActionSuccess
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (commentValue && !isCommentRequiredCompleteAndValid) setIsCritical(false);
    }, [
        selectedUser,
        commentValue
    ]);
    (0, $hopDi$useEffect)(()=>{
        // to get predefined comments
        if (!isCommentRequired) return;
        if ((0, $20281fe09bc700a8$export$684f6d0b3182db31).CONSULT in predefinedComments) setCommentDetails({
            ...commentsDetails,
            predefComments: predefinedComments[(0, $20281fe09bc700a8$export$684f6d0b3182db31).CONSULT] || []
        });
        else dispatch((0, $d623f23401a154f0$export$27dd55286e4e826a)((0, $20281fe09bc700a8$export$684f6d0b3182db31).CONSULT)).catch((error)=>(0, $hopDi$Logger).log(error));
    }, [
        predefinedComments
    ]);
    const handleCommentDescription = (text)=>{
        setCommentValue(text);
        setCommentDetails({
            ...commentsDetails,
            commentDescription: text,
            showAlert: text.length === 0 ? commentsDetails.showAlert : false
        });
    };
    const handleSubmit = ()=>{
        const modalInfo = {
            isIncludeAssociateChecked: isIncludeAssociateChecked,
            selectedUser: selectedUser,
            certKey: certKey
        };
        if (!selectedUser) {
            setIsCritical(true);
            setIsSelectVisible(true);
            return;
        }
        if (!isCommentRequiredCompleteAndValid && isCommentRequired) {
            setIsCritical(true);
            setCommentDetails({
                ...commentsDetails,
                showAlert: true
            });
            return;
        }
        if (isCommentRequired && commentsDetails?.commentDescription) modalInfo.commentValue = commentsDetails.commentDescription;
        onSubmit(modalInfo);
    };
    const handleSelectUser = (user)=>{
        if ((0, $8ef29c07b3459fed$export$83b788b1a3698c03)(user)) {
            setSelectedUser(null);
            setIsSelectVisible(true);
            return;
        }
        setIsSelectVisible(false);
        setSelectedUser(user);
    };
    const consultContent = /*#__PURE__*/ (0, $hopDi$jsx)((0, $94cb1d296eacf3b1$export$2e2bcd8739ae039), {
        nodeData: nodeData,
        consultModalDetails: consultModalDetails,
        isIncludeAssociateChecked: isIncludeAssociateChecked,
        setIsIncludedAssociateChecked: setIsIncludedAssociateChecked,
        dropdownClassName: dropdownClassName,
        handleSelectUser: handleSelectUser,
        isSelectVisible: isSelectVisible,
        menuDropdownTestId: menuDropdownTestId,
        commentsDetails: commentsDetails,
        isCritical: isCritical,
        handleCommentDescription: handleCommentDescription,
        commentInputTestId: commentInputTestId,
        selectedUser: selectedUser,
        isCommentRequired: isCommentRequired,
        isMobileWidth: isMobileWidth
    });
    if (isMobileWidth) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
        className: "CertsConsultModal-mobileDrawer",
        isOpen: isOpen,
        setIsOpen: ()=>{
            setIsConsultModalOpen(false);
            setIsActionDrawerOutsideClick(true);
        },
        headerContent: /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
            className: "CertsConsultModal-mobileDrawerHeader",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Consult",
                    color: "neutral-1000",
                    size: "medium"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "CertsConsultModal-mobileDrawerTitleContainer",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h1",
                            className: "CertsConsultModal-mobileDrawerTitle",
                            children: "Consult with Peers"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            className: "CertsConsultModal-mobileDrawerSubTitle",
                            children: "Invite another user in your organization to review your certification items and advise on appropriate actions."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                    size: "medium",
                    kind: "ghost",
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "close",
                        color: "neutral-100",
                        size: "smallMedium"
                    }),
                    onClick: ()=>{
                        setIsConsultModalOpen(false);
                        setIsActionDrawerOutsideClick(true);
                    }
                })
            ]
        }),
        footerActionBar: /*#__PURE__*/ (0, $hopDi$jsx)((0, $2ae7ee36f788425a$export$2e2bcd8739ae039), {
            isActionLoading: isActionLoading,
            setIsConsultModalOpen: setIsConsultModalOpen,
            isConsultValid: isConsultValid,
            handleSubmit: handleSubmit
        }),
        content: consultContent
    });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        isOverflowVisible: !isCommentRequired,
        onClose: ()=>{
            setIsOpen(false);
            setIsConsultModalOpen(false);
            setIsActionDrawerOutsideClick(true);
        },
        isOpen: isOpen,
        headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "Consult",
            color: "neutral-1000",
            size: "large"
        }),
        title: "Consult with Peers",
        subtitle: "Invite another user in your organization to review your certification items and advise on appropriate actions.",
        contentBody: consultContent,
        FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $2ae7ee36f788425a$export$2e2bcd8739ae039), {
            isActionLoading: isActionLoading,
            setIsConsultModalOpen: setIsConsultModalOpen,
            isConsultValid: isConsultValid,
            handleSubmit: handleSubmit
        })
    });
}
$7f3598ff04b0c7dc$var$CertsConsultModal.propTypes = {
    isConsultModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsConsultModalOpen: (0, $hopDi$proptypes).func.isRequired,
    setIsActionDrawerOutsideClick: (0, $hopDi$proptypes).func,
    consultModalDetails: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$82933e461ce879a9)).isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    isCommentRequired: (0, $hopDi$proptypes).bool.isRequired,
    onSubmit: (0, $hopDi$proptypes).func.isRequired,
    menuDropdownTestId: (0, $hopDi$proptypes).string,
    commentInputTestId: (0, $hopDi$proptypes).string
};
$7f3598ff04b0c7dc$var$CertsConsultModal.defaultProps = {
    setIsActionDrawerOutsideClick: ()=>{},
    menuDropdownTestId: null,
    commentInputTestId: null
};
var $7f3598ff04b0c7dc$export$2e2bcd8739ae039 = $7f3598ff04b0c7dc$var$CertsConsultModal;







function $3000c97704c797ef$var$CertsConsultWarnModal({ isConsultWarnModalOpen: isConsultWarnModalOpen, handleClose: handleClose, handleWarnModal: handleWarnModal, isActionLoading: isActionLoading, errorMessage: errorMessage, isActionSuccess: isActionSuccess, warnText: warnText, btnText: btnText, showCheckBox: showCheckBox, title: title }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const [isChecked, setIsChecked] = (0, $hopDi$useState)(false);
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(false);
    const onCancel = ()=>setIsVisible(false);
    (0, $hopDi$useEffect)(()=>{
        setIsOpen(isConsultWarnModalOpen);
    }, [
        isConsultWarnModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isActionSuccess) handleClose();
    }, [
        isActionSuccess
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (errorMessage) setIsVisible(true);
        else if (isVisible) setIsVisible(false);
    }, [
        errorMessage
    ]);
    const getConsultWarnModal = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            kind: "warning",
            className: "CertsConsultWarnModal",
            alertTitle: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    title,
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Error",
                        description: errorMessage,
                        isVisible: isVisible,
                        onCancel: onCancel
                    })
                ]
            }),
            alertSubtitle: warnText,
            onClose: ()=>{
                // close modal
                handleClose();
            },
            isOpen: isOpen,
            primaryButton: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    showCheckBox && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        name: "checkbox0",
                        kind: "text",
                        dataTestId: "checkbox0",
                        isChecked: isChecked,
                        onChange: (event)=>{
                            setIsChecked(event.target.checked);
                        },
                        label: "Don\u2019t show this again for this certification",
                        textPosition: "after"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "outlined",
                        size: "medium",
                        isDisabled: isActionLoading,
                        isLoading: isActionLoading,
                        loaderText: btnText,
                        onClick: ()=>{
                            handleWarnModal(isChecked);
                        },
                        children: btnText
                    })
                ]
            }),
            secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "medium",
                onClick: handleClose,
                isDisabled: isActionLoading,
                children: "Cancel"
            })
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        children: getConsultWarnModal()
    });
}
$3000c97704c797ef$var$CertsConsultWarnModal.propTypes = {
    isConsultWarnModalOpen: (0, $hopDi$proptypes).bool,
    handleClose: (0, $hopDi$proptypes).func,
    handleWarnModal: (0, $hopDi$proptypes).func,
    isActionLoading: (0, $hopDi$proptypes).bool,
    errorMessage: (0, $hopDi$proptypes).string,
    isActionSuccess: (0, $hopDi$proptypes).bool,
    warnText: (0, $hopDi$proptypes).string,
    btnText: (0, $hopDi$proptypes).string,
    showCheckBox: (0, $hopDi$proptypes).bool,
    title: (0, $hopDi$proptypes).string
};
$3000c97704c797ef$var$CertsConsultWarnModal.defaultProps = {
    isConsultWarnModalOpen: false,
    handleClose: ()=>{},
    handleWarnModal: ()=>{},
    isActionLoading: false,
    errorMessage: null,
    isActionSuccess: false,
    warnText: "",
    btnText: "",
    showCheckBox: false,
    title: ""
};
var $3000c97704c797ef$export$2e2bcd8739ae039 = $3000c97704c797ef$var$CertsConsultWarnModal;




/* eslint-disable indent */ 










const $687791ac9134434b$export$a49393e96e2bf605 = (config)=>{
    if (config.enableReassignUser === "1" || config.showReassignPopup === "1") return true;
    return false;
};
const $687791ac9134434b$export$a0d8b60bc3ca1001 = (config)=>{
    if (config.enableReassignUser === "1") return true;
    return false;
};
const $687791ac9134434b$export$a5f2d48f68b29e88 = (config)=>{
    if (config.enableReassignUser === "0" && config.showReassignPopup === "0") return true;
    return false;
};
const $687791ac9134434b$export$7dd0d953c473a96c = ()=>{
    const consultPopoverFlag = localStorage.getItem((0, $20281fe09bc700a8$export$9612f125f9c1cfb7).CONSULT);
    if (consultPopoverFlag === null || consultPopoverFlag === undefined || consultPopoverFlag === "true") return true;
    return false;
};
const $687791ac9134434b$export$988d8a82de0113c9 = ()=>{
    const consultWarnFlag = localStorage.getItem((0, $20281fe09bc700a8$export$9612f125f9c1cfb7).CONSULT_WARN);
    if (consultWarnFlag === null || consultWarnFlag === undefined || consultWarnFlag === "true") return true;
    return false;
};
const $687791ac9134434b$export$a9e26aab2ac37c8b = (kind, consultantInfo, count)=>{
    let warnText = `A consultation with ${consultantInfo || "First Last (username)"} is pending and can\u{2019}t be canceled. Do you want to make your decision and move it to Done anyway?`;
    if (kind !== (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT) {
        if (count && count > 1) warnText = `There are consultations pending with ${count || 0} peers that can\u{2019}t be canceled. Do you want to make your decision and move it to Done anyway?`;
    } else if (kind === (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT) {
        if (count && count > 1) warnText = `There are consultations pending with ${count || 0} peers that can\u{2019}t be canceled. Do you want to request a new consultation with another user anyway?`;
        else warnText = `A consultation with ${consultantInfo || "First Last (username)"} is pending and can\u{2019}t be canceled. Do you want to request a new consultation with another user anyway?`;
    }
    return warnText;
};
const $687791ac9134434b$export$84ed66aad96abed5 = (kind)=>{
    let btnText = "Make Decision";
    if (kind === (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT) btnText = "Request New Consultation";
    return btnText;
};
const $687791ac9134434b$export$450cf8b9c8d4cff7 = (count)=>{
    let title = "Consultation Is Pending";
    if (count > 1) title = "Consultations Are Pending";
    return title;
};



/* eslint-disable indent */ 













function $3fab65119e6522ef$var$CertsReassignContent({ nodeData: nodeData, isReassignUserEnabled: isReassignUserEnabled, isReassignUser: isReassignUser, setIsIncludedAssociateChecked: setIsIncludedAssociateChecked, isIncludeAssociateChecked: isIncludeAssociateChecked, isSkipCertifierChecked: isSkipCertifierChecked, handleCommentDescription: handleCommentDescription, setIsSkipCertifierChecked: setIsSkipCertifierChecked, setSelectedUser: setSelectedUser, selectedUser: selectedUser, reassignModalDetails: reassignModalDetails, dropdownClassName: dropdownClassName, isCommentRequired: isCommentRequired, commentsDetails: commentsDetails, isSelectUserCritical: isSelectUserCritical, setIsSelectUserCritical: setIsSelectUserCritical, isMobileWidth: isMobileWidth }) {
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(false);
    const { certKey: certKey, reassignConfigMap: reassignConfigMap, action: { errorMessage: errorMessage, isActionError: isActionError }, objectForRedirectLink: objectForRedirectLink } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    (0, $hopDi$useEffect)(()=>{
        setIsVisible(isActionError);
    }, [
        isActionError
    ]);
    const isCertsKindUser = nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER;
    const isCertifierRequired = (isReassignUser && isReassignUserEnabled || !isReassignUser) && !objectForRedirectLink.consulteeLoggedIn;
    const CertifierClassNames = (0, $hopDi$classnames)("CertsReassignModal-containerCertifierSelection", !isCertifierRequired && "CertsReassignModal-containerCertifierSelection--noCertifier");
    /** to get lineitem display name */ const getSelectedLineItemName = (lineItemType)=>{
        let name = "";
        switch(lineItemType){
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER:
                name = nodeData[0, $271c8dec800e3a4d$export$46f21910265caffc];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ACCOUNT:
                name = nodeData[0, $271c8dec800e3a4d$export$b21a97077b446a0c];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ROLE:
                name = nodeData[0, $271c8dec800e3a4d$export$ef258f55852583b5];
                break;
            case (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ENTITLEMENT:
                name = nodeData[0, $271c8dec800e3a4d$export$8e9b5a553c0ae9b2];
                break;
            default:
                break;
        }
        if (!name) name = "Not Provided";
        return name;
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsReassignModal-containerHeader",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        className: "reassignCertifier-selectionWarn",
                        colorTheme: "Critical",
                        title: "Error",
                        description: errorMessage,
                        isVisible: isVisible,
                        onCancel: ()=>setIsVisible(false)
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsReassignModal-details",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                mobile: "h4-d",
                                className: "CertsReassignModal-containerTitle",
                                children: `Selected ${reassignModalDetails?.lineItemKind}`
                            }),
                            reassignModalDetails?.isNoteRequired && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsReassignModal-containerNote",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                    openDelay: 500,
                                    text: reassignModalDetails?.noteText,
                                    maxWidth: "20rem",
                                    placement: isMobileWidth ? "top" : "right",
                                    offset: 8,
                                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "Info",
                                        color: "info-700",
                                        className: "CertsReassignModal-containerNoteIcon"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsReassignModal-container-userDetails",
                        children: [
                            isCertsKindUser ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                size: "smallMedium",
                                kind: "UserNoBg",
                                color: "navy-900"
                            }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData),
                                color: "navy-900",
                                size: "smallMedium"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                mobile: "h4-d",
                                className: "CertsReassignModal-container-userDetailsName",
                                children: getSelectedLineItemName(reassignModalDetails?.lineItemKind)
                            })
                        ]
                    }),
                    reassignModalDetails?.isIncludeAssociatedEnt && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsReassignModal-includeCheckbox",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                            name: "checkbox2",
                            kind: "text",
                            dataTestId: "checkbox2",
                            isChecked: isIncludeAssociateChecked,
                            onChange: (event)=>{
                                setIsIncludedAssociateChecked(event.target.checked);
                            },
                            label: reassignModalDetails?.isIncludeAsscLabel,
                            labelPosition: "before"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: CertifierClassNames,
                children: [
                    isCertifierRequired && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                        children: [
                            !isSkipCertifierChecked && !selectedUser && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "CertsReassignModal-DropdownAsterisk",
                                children: "*"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h4",
                                mobile: "h4-d",
                                className: "CertsReassignModal-container-certifier",
                                children: "Select Certifier"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $2c1f4f91a862faa4$export$2e2bcd8739ae039), {
                                className: dropdownClassName,
                                defaultReassignee: reassignConfigMap?.defaultReassignee,
                                defaultAssigneName: reassignConfigMap?.defaultReassigneeName,
                                onSelect: (user)=>{
                                    if (user && !(0, $8ef29c07b3459fed$export$83b788b1a3698c03)(user)) setSelectedUser(user);
                                    else setSelectedUser(null);
                                    setIsSelectUserCritical(false);
                                },
                                selectedUser: selectedUser,
                                certKey: certKey,
                                showDefaultCertifier: true,
                                isCritical: isSelectUserCritical,
                                placeholder: "Select a known or default reassignee",
                                certifierUserKey: reassignConfigMap?.certifierUserKey
                            })
                        ]
                    }),
                    reassignModalDetails?.isSkipReassignment && (isReassignUser && isReassignUserEnabled || !isReassignUser) && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        className: "CertsReassignModal-skipReassignCheckbox",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                            name: "simpleText",
                            kind: "simpleText",
                            dataTestId: "simpleText",
                            isDisabled: !!selectedUser?.value || isReassignUser && !isReassignUserEnabled,
                            isChecked: isSkipCertifierChecked,
                            onChange: (event)=>{
                                if (isSelectUserCritical) setIsSelectUserCritical(false);
                                setIsSkipCertifierChecked(event.target.checked);
                            },
                            label: "Skip selecting certifier",
                            textPosition: "after",
                            showHoverEffect: true
                        })
                    })
                ]
            }),
            isCommentRequired && /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3efe2b33729b6d5$export$2e2bcd8739ae039), {
                defaultComments: commentsDetails?.predefComments,
                showAlert: commentsDetails.showAlert,
                onChange: handleCommentDescription,
                className: "CertsReassignModal-comments"
            })
        ]
    });
}
$3fab65119e6522ef$var$CertsReassignContent.propTypes = {
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    isReassignUserEnabled: (0, $hopDi$proptypes).bool.isRequired,
    isReassignUser: (0, $hopDi$proptypes).bool.isRequired,
    setIsIncludedAssociateChecked: (0, $hopDi$proptypes).func.isRequired,
    isIncludeAssociateChecked: (0, $hopDi$proptypes).bool.isRequired,
    isSkipCertifierChecked: (0, $hopDi$proptypes).bool.isRequired,
    handleCommentDescription: (0, $hopDi$proptypes).func.isRequired,
    setIsSkipCertifierChecked: (0, $hopDi$proptypes).func.isRequired,
    selectedUser: (0, $hopDi$proptypes).shape({
        value: (0, $hopDi$proptypes).string,
        label: (0, $hopDi$proptypes).string
    }).isRequired,
    setSelectedUser: (0, $hopDi$proptypes).func.isRequired,
    reassignModalDetails: (0, $hopDi$proptypes).shape({
        isSkipReassignment: (0, $hopDi$proptypes).bool,
        isIncludeAssociatedEnt: (0, $hopDi$proptypes).bool,
        isNoteRequired: (0, $hopDi$proptypes).bool,
        noteText: (0, $hopDi$proptypes).string,
        isIncludeAsscLabel: (0, $hopDi$proptypes).string,
        actionKind: (0, $hopDi$proptypes).string,
        lineItemKind: (0, $hopDi$proptypes).string
    }),
    dropdownClassName: (0, $hopDi$proptypes).string.isRequired,
    isCommentRequired: (0, $hopDi$proptypes).bool.isRequired,
    commentsDetails: (0, $hopDi$proptypes).shape({
        commentDescription: (0, $hopDi$proptypes).string.isRequired,
        predefComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
        isCommentApplied: (0, $hopDi$proptypes).bool.isRequired,
        showAlert: (0, $hopDi$proptypes).bool.isRequired
    }).isRequired,
    isSelectUserCritical: (0, $hopDi$proptypes).bool.isRequired,
    setIsSelectUserCritical: (0, $hopDi$proptypes).func.isRequired,
    isMobileWidth: (0, $hopDi$proptypes).bool.isRequired
};
$3fab65119e6522ef$var$CertsReassignContent.defaultProps = {
    reassignModalDetails: {}
};
var $3fab65119e6522ef$export$2e2bcd8739ae039 = $3fab65119e6522ef$var$CertsReassignContent;






function $39db174ba0c35d8a$var$CertsReassignFooter({ isActionLoading: isActionLoading, setIsReassignModalOpen: setIsReassignModalOpen, isBtnEnabled: isBtnEnabled, handleSubmit: handleSubmit }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$FooterActionBar), {
        className: "CertsReassignModal-footer",
        size: "large",
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "CertsReassignModal-actionButtons",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "ghost",
                    size: "medium",
                    isDisabled: isActionLoading,
                    onClick: ()=>{
                        setIsReassignModalOpen(false);
                    },
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    className: "CertsReassignModal-submitButton",
                    type: "button",
                    kind: isBtnEnabled() ? "filled" : "outlined",
                    size: "medium",
                    onClick: handleSubmit,
                    isLoading: isActionLoading,
                    loaderText: "Submit",
                    children: "Submit"
                })
            ]
        })
    });
}
$39db174ba0c35d8a$var$CertsReassignFooter.propTypes = {
    isActionLoading: (0, $hopDi$proptypes).bool.isRequired,
    setIsReassignModalOpen: (0, $hopDi$proptypes).func.isRequired,
    isBtnEnabled: (0, $hopDi$proptypes).func.isRequired,
    handleSubmit: (0, $hopDi$proptypes).func.isRequired
};
var $39db174ba0c35d8a$export$2e2bcd8739ae039 = $39db174ba0c35d8a$var$CertsReassignFooter;









function $e2c36875a8ec4133$var$CertsReassignWarnModal({ isReassignWarnModalOpen: isReassignWarnModalOpen, handleClose: handleClose, handleWarnModal: handleWarnModal, isActionLoading: isActionLoading, errorMessage: errorMessage }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const [isChecked, setIsChecked] = (0, $hopDi$useState)(false);
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(false);
    const onCancel = ()=>setIsVisible(false);
    const dispatch = (0, $hopDi$useDispatch)();
    (0, $hopDi$useEffect)(()=>{
        setIsOpen(isReassignWarnModalOpen);
    }, [
        isReassignWarnModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (errorMessage) setIsVisible(true);
        else if (isVisible) setIsVisible(false);
    }, [
        errorMessage
    ]);
    // TODO: @Jacob, ModalIsland Submit fail banners should NOT have a duplicate on the page behind them
    // TODO: @Jacob, errorMessage will be updated soon, need UX/ PO update
    // TODO: @Jacob, isVisible should not reset on isActionError set to false
    // TODO: @Jacob, Submit should reset banner: setIsVisible(false)
    // TODO: @Jacob, evaluate if AlertBanner is even needed here and location if so
    const getReassignWarnModal = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            kind: "warning",
            className: "CertsReassignWarnModal",
            alertTitle: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    "Reassignment Can\u2019t Be Undone",
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Error",
                        description: errorMessage,
                        isVisible: isVisible,
                        onCancel: onCancel
                    })
                ]
            }),
            alertSubtitle: "When you reassign one of your certification items to another certifier, it\u2019ll be removed from your list and can\u2019t be retracted. Do you want to reassign this item?",
            onClose: ()=>{
                // close modal
                handleClose();
            },
            isOpen: isOpen,
            primaryButton: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        name: "checkbox0",
                        kind: "text",
                        dataTestId: "checkbox0",
                        isChecked: isChecked,
                        onChange: (event)=>{
                            setIsChecked(event.target.checked);
                            dispatch({
                                type: (0, $d6d78fc758ee4148$export$6eb1d8263e7e2d01)
                            });
                        },
                        label: "Don\u2019t show this message again",
                        textPosition: "after"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "outlined",
                        size: "medium",
                        isDisabled: isActionLoading,
                        isLoading: isActionLoading,
                        loaderText: "Reassign",
                        onClick: (e)=>{
                            handleWarnModal(e, true);
                        },
                        children: "Reassign"
                    })
                ]
            }),
            secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "medium",
                onClick: handleClose,
                isDisabled: isActionLoading,
                children: "Cancel"
            })
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        children: getReassignWarnModal()
    });
}
$e2c36875a8ec4133$var$CertsReassignWarnModal.propTypes = {
    isReassignWarnModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    handleClose: (0, $hopDi$proptypes).func.isRequired,
    handleWarnModal: (0, $hopDi$proptypes).func.isRequired,
    isActionLoading: (0, $hopDi$proptypes).bool.isRequired,
    errorMessage: (0, $hopDi$proptypes).string
};
$e2c36875a8ec4133$var$CertsReassignWarnModal.defaultProps = {
    errorMessage: ""
};
var $e2c36875a8ec4133$export$2e2bcd8739ae039 = $e2c36875a8ec4133$var$CertsReassignWarnModal;




function $7de18020df34e39a$var$CertsReassignModal({ isReassignModalOpen: isReassignModalOpen, setIsReassignModalOpen: setIsReassignModalOpen, setIsActionDrawerOutsideClick: setIsActionDrawerOutsideClick, reassignModalDetails: reassignModalDetails, nodeData: nodeData, isCommentRequired: isCommentRequired, onSubmit: onSubmit }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(false);
    const { certKey: certKey, reassignConfigMap: reassignConfigMap, isWarnModalReassignShown: isWarnModalReassignShown, action: { isActionSuccess: isActionSuccess, errorMessage: errorMessage, isActionLoading: isActionLoading }, objectForRedirectLink: objectForRedirectLink, mediaQueryValue: mediaQueryValue, predefinedComments: predefinedComments } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const dispatch = (0, $hopDi$useDispatch)();
    const [isSkipCertifierChecked, setIsSkipCertifierChecked] = (0, $hopDi$useState)(false);
    const [isIncludeAssociateChecked, setIsIncludedAssociateChecked] = (0, $hopDi$useState)(false);
    const [selectedUser, setSelectedUser] = (0, $hopDi$useState)(null);
    const [isReassignWarnModalOpen, setIsReassignWarnModalOpen] = (0, $hopDi$useState)(false);
    const [isSelectUserCritical, setIsSelectUserCritical] = (0, $hopDi$useState)(false);
    const isReassignUser = reassignModalDetails?.actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME;
    const isReassignUserEnabled = (0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap);
    const isPredefinedCommentsWithReassign = (0, $687791ac9134434b$export$a0d8b60bc3ca1001)(reassignConfigMap);
    const dropdownClassName = (0, $hopDi$classnames)("CertsReassignModal-dropdown", isSkipCertifierChecked && `selection--disabled`);
    const [commentsDetails, setCommentDetails] = (0, $hopDi$useState)({
        commentDescription: "",
        predefComments: [],
        isCommentApplied: false,
        showAlert: false
    });
    (0, $hopDi$useEffect)(()=>{
        setIsOpen(isReassignModalOpen);
    }, [
        isReassignModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isOpen) setIsActionDrawerOutsideClick(false);
    }, [
        isOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isActionSuccess) {
            setIsReassignModalOpen(false);
            if (isReassignWarnModalOpen) setIsReassignWarnModalOpen(false);
        }
    }, [
        isActionSuccess
    ]);
    (0, $hopDi$useEffect)(()=>{
        // to get predefined comments
        if (!isCommentRequired) return;
        let actionType = (0, $20281fe09bc700a8$export$684f6d0b3182db31).REASSIGN;
        if (isReassignUser) actionType = isReassignUserEnabled && !objectForRedirectLink.consulteeLoggedIn && isPredefinedCommentsWithReassign ? (0, $20281fe09bc700a8$export$684f6d0b3182db31).DOES_NOT_WORK_FOR_ME : (0, $20281fe09bc700a8$export$684f6d0b3182db31).DOES_NOT_WORK_FORME_WITHOUT_REASSIGNMENT;
        if (actionType in predefinedComments) setCommentDetails({
            ...commentsDetails,
            predefComments: predefinedComments[actionType] || []
        });
        else dispatch((0, $d623f23401a154f0$export$27dd55286e4e826a)(actionType)).catch((error)=>(0, $hopDi$Logger).log(error));
    }, [
        predefinedComments
    ]);
    const handleCommentDescription = (text)=>{
        setCommentDetails({
            ...commentsDetails,
            commentDescription: text,
            showAlert: text.length === 0 ? commentsDetails.showAlert : false
        });
    };
    /** to enable handle submit button */ const isBtnEnabled = ()=>{
        if (isActionLoading) return false;
        // consultee login enable only comments
        if (isReassignUser && objectForRedirectLink?.consulteeLoggedIn) {
            if (commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length >= 3) return true;
        }
        // is button enabled
        if (isReassignUser && !isReassignUserEnabled && isCommentRequired) {
            if (commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length >= 3) return true;
        }
        if (!isCommentRequired) {
            if (!isSkipCertifierChecked && selectedUser) return true;
            // skip certifier and comment validation
            if (isSkipCertifierChecked) return true;
        }
        // selected user and comments validation
        if (isCommentRequired && commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length >= 3 && !isSkipCertifierChecked && selectedUser) return true;
        // skip certifier and comment validation
        if (isCommentRequired && commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length >= 3 && isSkipCertifierChecked) return true;
        return false;
    };
    const handleSubmit = (e, isFromWarnModal = false)=>{
        let proceedSubmit = true;
        if (isCommentRequired && commentsDetails.commentDescription?.replace(/[<>]/g, "")?.trim()?.length < 3) {
            proceedSubmit = false;
            setCommentDetails({
                ...commentsDetails,
                showAlert: true
            });
        }
        if ((isReassignUser && isReassignUserEnabled && !isSkipCertifierChecked || !isReassignUser) && !objectForRedirectLink.consulteeLoggedIn && !selectedUser) {
            setIsSelectUserCritical(true);
            proceedSubmit = false;
        }
        if (!proceedSubmit) return;
        if (isBtnEnabled()) {
            const modalInfo = {
                isSkipCertifierChecked: isSkipCertifierChecked,
                isIncludeAssociateChecked: isIncludeAssociateChecked,
                selectedUser: selectedUser,
                certKey: certKey
            };
            // is button enabled
            if (isReassignUser && !isReassignUserEnabled && isCommentRequired) {
                if (commentsDetails?.commentDescription?.replace(/[<>]/g, "")?.trim()?.length >= 3) {
                    // when comments only required for User(DNWFM)
                    if (isCommentRequired && commentsDetails?.commentDescription) modalInfo.commentValue = commentsDetails.commentDescription;
                    onSubmit(modalInfo);
                    return;
                }
            }
            // hanlde comments validation
            if (isCommentRequired && commentsDetails.commentDescription?.replace(/[<>]/g, "")?.trim()?.length < 3 && !isSkipCertifierChecked) {
                setCommentDetails({
                    ...commentsDetails,
                    showAlert: true
                });
                return;
            }
            if (isCommentRequired && commentsDetails?.commentDescription) modalInfo.commentValue = commentsDetails.commentDescription;
            if (isWarnModalReassignShown || isFromWarnModal) // call api directly from here
            onSubmit(modalInfo);
            else setIsReassignWarnModalOpen(true);
        }
    };
    const getReassignModal = ()=>{
        const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
        const isMobileWidth = mediaQueryValue >= mobileXlargeQuery.value;
        const reassignContent = /*#__PURE__*/ (0, $hopDi$jsx)((0, $3fab65119e6522ef$export$2e2bcd8739ae039), {
            handleCommentDescription: handleCommentDescription,
            isSkipCertifierChecked: isSkipCertifierChecked,
            setIsSkipCertifierChecked: setIsSkipCertifierChecked,
            nodeData: nodeData,
            isReassignUserEnabled: isReassignUserEnabled,
            isReassignUser: isReassignUser,
            setSelectedUser: setSelectedUser,
            selectedUser: selectedUser,
            reassignModalDetails: reassignModalDetails,
            dropdownClassName: dropdownClassName,
            isCommentRequired: isCommentRequired,
            commentsDetails: commentsDetails,
            setIsIncludedAssociateChecked: setIsIncludedAssociateChecked,
            isIncludeAssociateChecked: isIncludeAssociateChecked,
            isSelectUserCritical: isSkipCertifierChecked ? false : isSelectUserCritical,
            setIsSelectUserCritical: setIsSelectUserCritical,
            isMobileWidth: isMobileWidth
        });
        if (isMobileWidth) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
            className: "CertsReassignModal-mobileDrawer",
            isOpen: isOpen,
            setIsOpen: ()=>setIsReassignModalOpen(false),
            headerContent: /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
                className: "CertsReassignModal-mobileDrawerHeader",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Reassign",
                        color: "neutral-1000",
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsReassignModal-mobileDrawerTitleContainer",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h1",
                                className: "CertsReassign-mobileDrawerTitle",
                                children: "Reassign"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                className: "CertsReassignModal-mobileDrawerSubTitle",
                                children: (0, $8ef29c07b3459fed$export$a0a8ab6941a822be)(nodeData)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: ()=>setIsReassignModalOpen(false)
                    })
                ]
            }),
            footerActionBar: /*#__PURE__*/ (0, $hopDi$jsx)((0, $39db174ba0c35d8a$export$2e2bcd8739ae039), {
                isActionLoading: isActionLoading,
                setIsReassignModalOpen: setIsReassignModalOpen,
                isBtnEnabled: isBtnEnabled,
                handleSubmit: handleSubmit
            }),
            content: reassignContent
        });
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            isOpen: isOpen,
            onClose: ()=>{
                setIsOpen(false);
                setIsReassignModalOpen(false);
            },
            headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "Reassign",
                color: "neutral-1000",
                size: "large"
            }),
            title: "Reassign",
            subtitle: (0, $8ef29c07b3459fed$export$a0a8ab6941a822be)(nodeData),
            contentBody: reassignContent,
            FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $39db174ba0c35d8a$export$2e2bcd8739ae039), {
                isActionLoading: isActionLoading,
                setIsReassignModalOpen: setIsReassignModalOpen,
                isBtnEnabled: isBtnEnabled,
                handleSubmit: handleSubmit
            })
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        children: [
            !isReassignWarnModalOpen && getReassignModal(),
            isReassignWarnModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $e2c36875a8ec4133$export$2e2bcd8739ae039), {
                isReassignWarnModalOpen: isReassignWarnModalOpen,
                isActionLoading: isActionLoading,
                handleClose: ()=>{
                    setIsReassignWarnModalOpen(false);
                    setIsReassignModalOpen(false);
                },
                errorMessage: errorMessage,
                handleWarnModal: handleSubmit
            })
        ]
    });
}
$7de18020df34e39a$var$CertsReassignModal.propTypes = {
    isReassignModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsReassignModalOpen: (0, $hopDi$proptypes).func.isRequired,
    reassignModalDetails: (0, $hopDi$proptypes).shape({
        isSkipReassignment: (0, $hopDi$proptypes).bool,
        isIncludeAssociatedEnt: (0, $hopDi$proptypes).bool,
        isNoteRequired: (0, $hopDi$proptypes).bool,
        noteText: (0, $hopDi$proptypes).string,
        isIncludeAsscLabel: (0, $hopDi$proptypes).string,
        actionKind: (0, $hopDi$proptypes).string,
        lineItemKind: (0, $hopDi$proptypes).string
    }),
    setIsActionDrawerOutsideClick: (0, $hopDi$proptypes).func.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    isCommentRequired: (0, $hopDi$proptypes).bool.isRequired,
    onSubmit: (0, $hopDi$proptypes).func.isRequired
};
$7de18020df34e39a$var$CertsReassignModal.defaultProps = {
    reassignModalDetails: {}
};
var $7de18020df34e39a$export$2e2bcd8739ae039 = $7de18020df34e39a$var$CertsReassignModal;





/* eslint-disable indent */ 






var $1d9c427fd8513765$export$2e2bcd8739ae039 = (0, $20281fe09bc700a8$export$170ce1a49c989948);



function $55a45c22e6a9ad42$var$CertsRejectAction({ isMobileXlargeWidth: isMobileXlargeWidth, commentStatus: // autoRevoke,
commentStatus, handleClick: handleClick, getTypeActEntRole: // isLoading,
getTypeActEntRole, placement: placement, trigger: trigger, isRejectPopoverOpen: isRejectPopoverOpen, setIsRejectPopoverOpen: setIsRejectPopoverOpen }) {
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const [inputChanged, setInputChanged] = (0, $hopDi$useState)(false);
    const drawerRef = (0, $hopDi$useRef)();
    // Reset on close
    (0, $hopDi$useEffect)(()=>{
        if (!isRejectPopoverOpen) {
            setIsCritical(false);
            setCommentValue("");
            setInputChanged(false);
        }
    }, [
        isRejectPopoverOpen
    ]);
    const isCommentNotValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    const handleClose = ()=>{
        if (isMobileXlargeWidth) drawerRef.current.closeDrawer();
        else setIsRejectPopoverOpen(false);
    };
    const handleCommentSubmit = ()=>{
        if (isCommentNotValid) return setIsCritical(true);
        handleClose();
        return handleClick(commentValue);
    };
    const titleString = `${(0, $1d9c427fd8513765$export$2e2bcd8739ae039).TITLE} ${getTypeActEntRole}?`;
    const getMobileHeader = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsRejectAction-headerWrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsActionPopover-title",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "HelpFilled",
                            className: "CertsRejectAction-headerIcon"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "label",
                            desktop: "h3-d",
                            mobile: "h1-m",
                            children: titleString
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                    size: !isMobileXlargeWidth ? "small" : "medium",
                    kind: "ghost",
                    tabIndex: -1,
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Close"
                    }),
                    onClick: handleClose
                })
            ]
        });
    // TODO: @Jacob, Tech Debt, Post CR-17078, and other early Nov 2024 Jira's. Remove CertsCommentInputField. Then update and rename CertsModalCommentBox for use here.
    const getMobileContent = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $0d23168c4a68b98d$export$2e2bcd8739ae039), {
            actionKey: (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT,
            inputChanged: inputChanged,
            setInputChanged: setInputChanged,
            isCritical: isCritical,
            setIsCritical: setIsCritical,
            commentValue: commentValue,
            setCommentValue: setCommentValue
        });
    const getMobileFooter = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
            size: "large",
            className: "CertsActionPopover-controls",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "ghost",
                    onClick: ()=>drawerRef.current.closeDrawer(),
                    children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).CANCELBUTTON
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: !isCommentNotValid ? "filled" : "outlined",
                    onClick: ()=>handleCommentSubmit(),
                    className: "CertsActionPopover-submtBtn",
                    children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).PRIMARYBUTTON
                })
            ]
        });
    // Render one time use multiple places
    const mobileHeader = getMobileHeader();
    const mobileContent = getMobileContent();
    const mobileFooter = getMobileFooter();
    const withRequiredComments = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsRejectAction",
            children: [
                mobileHeader,
                mobileContent,
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    size: "large",
                    className: "CertsActionPopover-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            onClick: ()=>setIsRejectPopoverOpen(false),
                            children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).CANCELBUTTON
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: !isCommentNotValid ? "filled" : "outlined",
                            onClick: ()=>handleCommentSubmit(),
                            className: "CertsActionPopover-submtBtn",
                            children: (0, $1d9c427fd8513765$export$2e2bcd8739ae039).PRIMARYBUTTON
                        })
                    ]
                })
            ]
        });
    // TODO: Don't delete this code, might need in the future
    // const withAutoRevoke = (check) => (
    //   <Box className='CertsRejectActionPopover'>
    //     <Typography variant='h3' className='CertsRejectPopover-desc'>
    //       {REJECT_ACTION_DATA.DESC}
    //     </Typography>
    //     {check && (
    //       <Box className='CertsRejectPopover-NoteWrapper CertsRejectPopover-note'>
    //         <b className='CertsRejectPopover-NoteText'>Important: </b>
    //         {REJECT_ACTION_DATA.NOTE}
    //       </Box>
    //     )}
    //     <Box tag='div' className='CertsRejectAction-controls'>
    //       <Button
    //         type='button'
    //         kind='ghost'
    //         isDisabled={isLoading}
    //         onClick={() => setIsRejectPopoverOpen(false)}>
    //         {REJECT_ACTION_DATA.CANCELBUTTON}
    //       </Button>
    //       <Button
    //         isDisabled={isLoading}
    //         type='button'
    //         kind='filled'
    //         onClick={() => handleClick('')}>
    //         {REJECT_ACTION_DATA.SECONDARYBUTTON}
    //       </Button>
    //     </Box>
    //   </Box>
    // );
    const getRejectActionPopover = ()=>commentStatus ? withRequiredComments(true) : withRequiredComments(false);
    // TODO: Don't delete this code, might need in the future
    // if (autoRevoke) {return commentStatus ? withRequiredComments(true) : withAutoRevoke(true);} return commentStatus ? withRequiredComments(false) : withAutoRevoke(false);
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsRejectAction-contextWrapper",
        children: isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                trigger,
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                    ref: drawerRef,
                    isOpen: isRejectPopoverOpen,
                    setIsOpen: setIsRejectPopoverOpen,
                    headerContent: mobileHeader,
                    content: mobileContent,
                    footerActionBar: mobileFooter,
                    className: "CertsRejectAction"
                })
            ]
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
            isPortalEnabled: true,
            placement: placement,
            trigger: trigger,
            popoverContent: getRejectActionPopover(),
            isOpen: isRejectPopoverOpen,
            setIsOpen: setIsRejectPopoverOpen
        })
    });
}
$55a45c22e6a9ad42$var$CertsRejectAction.propTypes = {
    // autoRevoke: PropTypes.bool.isRequired,
    commentStatus: (0, $hopDi$proptypes).bool.isRequired,
    handleClick: (0, $hopDi$proptypes).func.isRequired,
    getTypeActEntRole: (0, $hopDi$proptypes).string.isRequired,
    placement: (0, $hopDi$proptypes).string.isRequired,
    trigger: (0, $hopDi$proptypes).element.isRequired,
    // isLoading: PropTypes.bool,
    isRejectPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsRejectPopoverOpen: (0, $hopDi$proptypes).func.isRequired,
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired
};
$55a45c22e6a9ad42$var$CertsRejectAction.defaultProps = {};
var $55a45c22e6a9ad42$export$2e2bcd8739ae039 = $55a45c22e6a9ad42$var$CertsRejectAction;


var $813c5abc50980873$export$2e2bcd8739ae039 = (0, $55a45c22e6a9ad42$export$2e2bcd8739ae039);


// TODO: @Flemin, Add Proptypes and remove this eslint rule disable











const $2c1dfa662a05ff16$var$TextMapping = {
    [(0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE]: {
        title: "Reasons for Smart Approval",
        buttonText: "Cancel Approval",
        iconKind: "CheckCircleOutline"
    },
    [(0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT]: {
        title: "Reasons for Smart Rejection",
        buttonText: "Cancel Rejection",
        iconKind: "AlertCriticalOutline",
        color: "critical-500"
    }
};
function $2c1dfa662a05ff16$var$CertsSaviActionPopover({ kind: kind, handleClick: handleClick, onClose: onClose, isOpen: isOpen, trigger: trigger, placement: placement, saviRespondedReason: saviRespondedReason, getTypeActEntRole: getTypeActEntRole, getCertIconKind: getCertIconKind, getColKey: getColKey }) {
    const localize = (0, $hopDi$useLocalize)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    // TODO: API integration pending
    const getPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "Savi-Companion-Action-Popover--ContentWrapper",
            children: [
                isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Savi-Companion-Action-Mobile-Drawer-Header",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: getCertIconKind,
                            color: "navy-900",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            kind: "h3",
                            children: [
                                getTypeActEntRole,
                                ":",
                                getColKey
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Savi-Companion-Action-Popover--DisplayFlex Title",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "SaviCompanion",
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            children: $2c1dfa662a05ff16$var$TextMapping[kind].title
                        })
                    ]
                }),
                saviRespondedReason && saviRespondedReason.length > 0 ? saviRespondedReason.map((reason)=>{
                    const reasonKeys = Object.keys(reason);
                    const messagePropertyKey = reasonKeys.length > 0 ? reasonKeys[0] : undefined;
                    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "Savi-Companion-Action-Popover--DisplayFlex Reasons",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: $2c1dfa662a05ff16$var$TextMapping[kind].iconKind,
                                    color: $2c1dfa662a05ff16$var$TextMapping[kind].color,
                                    size: "xSmall"
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                children: messagePropertyKey && (messages[messagePropertyKey] || localize((0, $e7628c995f405891$export$7cad4c9063025e24)(messagePropertyKey)))
                            })
                        ]
                    });
                }) : /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "Savi-Companion-Action-Popover--DisplayFlex Reasons",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: "No data available"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Savi-Companion-Action-Popover--DisplayFlex Action-Button-Wrapper",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "large",
                            className: "Cancel",
                            onClick: ()=>{
                                handleClick("");
                                onClose();
                            },
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3-bold",
                                className: "Text",
                                children: $2c1dfa662a05ff16$var$TextMapping[kind].buttonText
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            className: "Action-Button--MarginLeft-Auto GotIt",
                            type: "button",
                            kind: "filled",
                            size: "large",
                            onClick: ()=>onClose(false),
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3-bold",
                                className: "Text",
                                children: "Got It"
                            })
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsActionPopover-contextWrapper",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                    isPortalEnabled: true,
                    trigger: trigger,
                    popoverContent: getPopoverContent(),
                    isOpen: isOpen && !isMobileXlargeWidth,
                    setIsOpen: onClose,
                    placement: placement
                })
            }),
            isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                isOpen: isOpen,
                setIsOpen: onClose,
                content: getPopoverContent(),
                isSwipeEnabled: true
            })
        ]
    });
}
$2c1dfa662a05ff16$var$CertsSaviActionPopover.propTypes = {
    kind: (0, $hopDi$proptypes).string.isRequired,
    handleClick: (0, $hopDi$proptypes).func.isRequired,
    onClose: (0, $hopDi$proptypes).func.isRequired,
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    trigger: (0, $hopDi$proptypes).element.isRequired,
    placement: (0, $hopDi$proptypes).string.isRequired,
    // TODO: @Flemin, update this proptype
    // eslint-disable-next-line react/forbid-prop-types
    saviRespondedReason: (0, $hopDi$proptypes).any,
    getTypeActEntRole: (0, $hopDi$proptypes).func.isRequired,
    getCertIconKind: (0, $hopDi$proptypes).func.isRequired,
    getColKey: (0, $hopDi$proptypes).func.isRequired
};
$2c1dfa662a05ff16$var$CertsSaviActionPopover.defaultProps = {
    saviRespondedReason: null
};
var $2c1dfa662a05ff16$export$2e2bcd8739ae039 = $2c1dfa662a05ff16$var$CertsSaviActionPopover;


var $ac46cb6010681c0d$export$2e2bcd8739ae039 = (0, $2c1dfa662a05ff16$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-one-expression-per-line */ 










var $13730356a2f65477$export$2e2bcd8739ae039 = (0, $20281fe09bc700a8$export$523985e6ca7aa3bf);



function $4bbca83a32795fb9$var$CertsTerminateModal({ isMobileXlargeWidth: isMobileXlargeWidth, autoRevoke: autoRevoke, commentStatus: commentStatus, handleClick: handleClick, handleCancel: handleCancel, isLoading: isLoading, isTerminateError: isTerminateError, setIsTerminateError: setIsTerminateError, getDescriptionFlag: getDescriptionFlag }) {
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(true);
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const getDescription = getDescriptionFlag ? (0, $13730356a2f65477$export$2e2bcd8739ae039).DESC + (0, $13730356a2f65477$export$2e2bcd8739ae039).SUBDESC : (0, $13730356a2f65477$export$2e2bcd8739ae039).SUBDESC;
    const isCommentValid = Boolean(commentValue?.trim().length >= 3);
    const dispatch = (0, $hopDi$useDispatch)();
    const { predefinedComments: predefinedComments } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [commentsDetails, setCommentDetails] = (0, $hopDi$useState)({
        commentDescription: "",
        predefComments: [],
        isCommentApplied: false,
        showAlert: false
    });
    (0, $hopDi$useEffect)(()=>{
        if ((0, $20281fe09bc700a8$export$684f6d0b3182db31).TERMINATE in predefinedComments) setCommentDetails({
            ...commentsDetails,
            predefComments: predefinedComments[(0, $20281fe09bc700a8$export$684f6d0b3182db31).TERMINATE] || []
        });
        else dispatch((0, $d623f23401a154f0$export$27dd55286e4e826a)((0, $20281fe09bc700a8$export$684f6d0b3182db31).TERMINATE)).catch((error)=>(0, $hopDi$Logger).log(error));
    }, [
        predefinedComments
    ]);
    const handleCommentText = (text)=>{
        setCommentValue(text);
        setCommentDetails({
            ...commentsDetails,
            commentDescription: text,
            showAlert: text.length === 0 ? commentsDetails.showAlert : false
        });
    };
    const handleSubmit = ()=>{
        if (!isCommentValid) {
            setIsCritical(true);
            setCommentDetails({
                ...commentsDetails,
                showAlert: true
            });
        } else {
            let comments = "";
            if (commentsDetails?.commentDescription) comments = commentsDetails.commentDescription;
            handleClick(comments);
        }
    };
    const handleClose = ()=>{
        setIsOpen(false);
        setIsTerminateError(false);
        handleCancel();
    };
    const withoutAutoRevokeWithComments = ()=>{
        const terminateActionBodyContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("section", {
                className: (0, $hopDi$classnames)(isMobileXlargeWidth && "CertsTerminate-mobileDrawer-modalBackground"),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Data Fetch Error",
                        description: "Terminate Action failed, please try again.",
                        isVisible: isTerminateError,
                        onCancel: ()=>setIsTerminateError(false)
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3efe2b33729b6d5$export$2e2bcd8739ae039), {
                        defaultComments: commentsDetails?.predefComments,
                        showAlert: isCritical,
                        onChange: handleCommentText,
                        shouldDisallowBrackets: false,
                        dataTestId: "Certs-Terminate-commentBoxTestId"
                    })
                ]
            });
        const terminateActionFooterContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
                size: "large",
                className: (0, $hopDi$classnames)(isMobileXlargeWidth && "CertsActionPopover-controls"),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        isDisabled: isLoading,
                        onClick: ()=>{
                            setIsOpen(false);
                            handleCancel();
                        },
                        children: (0, $13730356a2f65477$export$2e2bcd8739ae039).SECONDARYBUTTON
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: isLoading || isCommentValid ? "filled" : "outlined",
                        size: "medium",
                        className: (0, $hopDi$classnames)(isMobileXlargeWidth && "CertsActionPopover-submtBtn"),
                        isDisabled: isLoading,
                        isLoading: isLoading,
                        loaderText: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON,
                        onClick: handleSubmit,
                        children: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON
                    })
                ]
            });
        return !isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            className: "CertsTerminateModal-wrapper CertsTerminateModal-withComments",
            onClose: handleClose,
            isOpen: isOpen,
            headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "AlertWarningFilledSeparateColors",
                className: (0, $hopDi$classnames)(`ModalIsland-alertContent-icon CertsTerminateModal-alertIcon${isLoading}` && "CertsTerminateModal-isCrossIconDisabled"),
                size: "large"
            }),
            title: (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE,
            subtitle: getDescription,
            contentBody: terminateActionBodyContent(),
            FooterActionBarComp: terminateActionFooterContent()
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
            content: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
                        className: "CertsTerminate-mobileDrawer-header",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "AlertWarningFilledSeparateColors",
                                className: "CertsTerminate-mobileDrawer-warningIcon CertsTerminateModal-isCrossIconDisabled",
                                size: "medium"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h1",
                                        children: (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        children: getDescription
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                size: "medium",
                                kind: "ghost",
                                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "close",
                                    color: "neutral-100",
                                    size: "smallMedium"
                                }),
                                onClick: handleClose
                            })
                        ]
                    }),
                    terminateActionBodyContent(),
                    terminateActionFooterContent()
                ]
            }),
            className: "CertsTerminate-mobileDrawer",
            setIsOpen: handleClose,
            isOpen: isOpen,
            renderOnlyContent: true,
            isCloseOnOutsideClick: true
        });
    };
    const withAutoRevokeWithComments = ()=>{
        const terminateActionBodyContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("section", {
                className: (0, $hopDi$classnames)(isMobileXlargeWidth && "CertsTerminate-mobileDrawer-modalBackground"),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Data Fetch Error",
                        description: "Terminate Action failed, please try again.",
                        isVisible: isTerminateError,
                        onCancel: ()=>setIsTerminateError(false)
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3efe2b33729b6d5$export$2e2bcd8739ae039), {
                        defaultComments: commentsDetails?.predefComments,
                        showAlert: isCritical,
                        onChange: handleCommentText,
                        shouldDisallowBrackets: false,
                        dataTestId: "Certs-Terminate-commentBoxTestId"
                    })
                ]
            });
        const terminateActionFooterContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
                size: "large",
                className: (0, $hopDi$classnames)("CertsTerminate-footerContent", isMobileXlargeWidth && "CertsActionPopover-controls"),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        onClick: ()=>{
                            setIsOpen(false);
                            handleCancel();
                        },
                        children: (0, $13730356a2f65477$export$2e2bcd8739ae039).SECONDARYBUTTON
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: isLoading || isCommentValid ? "filled" : "outlined",
                        size: "medium",
                        isEnabled: true,
                        isDisabled: isLoading,
                        isLoading: isLoading,
                        loaderText: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON,
                        onClick: handleSubmit,
                        children: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON
                    })
                ]
            });
        return !isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            className: "CertsTerminateModal-wrapper CertsTerminateModal-withComments",
            onClose: handleClose,
            isOpen: isOpen,
            headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "AlertCriticalFilledSeparateColors",
                className: "ModalIsland-alertContent-icon CertsTerminateModal-alertIcon",
                size: "large"
            }),
            title: (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE,
            subtitle: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                children: [
                    getDescription,
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsTerminateModal-NoteWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("b", {
                                className: "CertsTerminateModal-NoteText",
                                children: "Important: "
                            }),
                            (0, $13730356a2f65477$export$2e2bcd8739ae039).NOTE
                        ]
                    })
                ]
            }),
            contentBody: terminateActionBodyContent(),
            FooterActionBarComp: terminateActionFooterContent()
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
            content: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
                        className: "CertsTerminate-mobileDrawer-header",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "AlertCriticalFilledSeparateColors",
                                className: "ModalIsland-alertContent-icon CertsTerminateModal-alertIcon",
                                size: "large"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h1",
                                        children: (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        children: getDescription
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        className: "CertsTerminateModal-NoteWrapper",
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)("b", {
                                                className: "CertsTerminateModal-NoteText",
                                                children: "Important: "
                                            }),
                                            (0, $13730356a2f65477$export$2e2bcd8739ae039).NOTE
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                size: "medium",
                                kind: "ghost",
                                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "close",
                                    color: "neutral-100",
                                    size: "smallMedium"
                                }),
                                onClick: handleClose
                            })
                        ]
                    }),
                    terminateActionBodyContent(),
                    terminateActionFooterContent()
                ]
            }),
            className: "CertsTerminate-mobileDrawer",
            setIsOpen: handleClose,
            isOpen: isOpen,
            renderOnlyContent: true,
            isCloseOnOutsideClick: true
        });
    };
    const withoutAutoRevokeNoComments = ()=>{
        const terminateActionBodyContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Data Fetch Error",
                        description: "Please try again.",
                        isVisible: isTerminateError,
                        onCancel: ()=>setIsTerminateError(false)
                    }),
                    !isMobileXlargeWidth && (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                ]
            });
        const terminateActionPrimaryButton = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: isLoading ? "filled" : "outlined",
                size: "medium",
                isDisabled: isLoading,
                isLoading: isLoading,
                loaderText: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON,
                onClick: handleClick,
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON
            });
        const terminateActionSecondaryButton = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "medium",
                onClick: ()=>{
                    setIsOpen(false);
                    handleCancel();
                },
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).SECONDARYBUTTON
            });
        return !isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            className: "CertsTerminateModal-wrapper",
            kind: "warning",
            alertTitle: terminateActionBodyContent(),
            alertSubtitle: getDescription,
            onClose: handleClose,
            isOpen: isOpen,
            primaryButton: terminateActionPrimaryButton(),
            secondaryButton: terminateActionSecondaryButton()
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
            content: /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
                className: "CertsTerminate-mobileDrawer-header",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        className: "CertsTerminate-mobileDrawer-AlertModalCloseButton",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "AlertModalBackground",
                        color: "neutral-100",
                        className: "ModalIsland-alertBg ModalIsland-alertBg-warning"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "ModalIsland-alertContent",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "AlertWarningFilledSeparateColors",
                                className: "ModalIsland-alertContent-icon",
                                dataTestId: "ModalIsland-Warning"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "ModalIsland-alertContent-body",
                                children: [
                                    terminateActionBodyContent(),
                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                kind: "h1",
                                                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                kind: "body2",
                                                children: getDescription
                                            })
                                        ]
                                    }),
                                    terminateActionPrimaryButton(),
                                    terminateActionSecondaryButton()
                                ]
                            })
                        ]
                    })
                ]
            }),
            className: "CertsTerminate-mobileDrawer",
            setIsOpen: handleClose,
            isOpen: isOpen,
            renderOnlyContent: true,
            isCloseOnOutsideClick: true
        });
    };
    const withAutoRevokeNoComments = ()=>{
        const terminateActionBodyContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: "Critical",
                        title: "Data Fetch Error",
                        description: "Please try again.",
                        isVisible: isTerminateError,
                        onCancel: ()=>setIsTerminateError(false)
                    }),
                    !isMobileXlargeWidth && (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                ]
            });
        const terminateActionPrimaryButton = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: isLoading ? "filled" : "outlined",
                size: "medium",
                isDisabled: isLoading,
                isEnabled: true,
                isLoading: isLoading,
                loaderText: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON,
                onClick: handleClick,
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).PRIMARYBUTTON
            });
        const terminateActionSecondaryButton = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "ghost",
                size: "medium",
                onClick: ()=>{
                    setIsOpen(false);
                    handleCancel();
                },
                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).SECONDARYBUTTON
            });
        return !isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
            className: "CertsTerminateModal-wrapper",
            kind: "critical",
            alertTitle: terminateActionBodyContent(),
            alertSubtitle: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                children: [
                    getDescription,
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsTerminateModal-NoteWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("b", {
                                className: "CertsTerminateModal-NoteText",
                                children: "Important: "
                            }),
                            (0, $13730356a2f65477$export$2e2bcd8739ae039).NOTE
                        ]
                    })
                ]
            }),
            onClose: handleClose,
            isOpen: isOpen,
            primaryButton: terminateActionPrimaryButton(),
            secondaryButton: terminateActionSecondaryButton()
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
            content: /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
                className: "CertsTerminate-mobileDrawer-header",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        className: "CertsTerminate-mobileDrawer-AlertModalCloseButton",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: handleClose
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "AlertModalBackground",
                        color: "neutral-100",
                        className: "ModalIsland-alertBg ModalIsland-alertBg-critical"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "ModalIsland-alertContent",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "AlertCriticalFilledSeparateColors",
                                className: "ModalIsland-alertContent-icon",
                                dataTestId: "ModalIsland-Critical"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "ModalIsland-alertContent-body",
                                children: [
                                    terminateActionBodyContent(),
                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                kind: "h1",
                                                children: (0, $13730356a2f65477$export$2e2bcd8739ae039).TITLE
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                                                kind: "body2",
                                                children: [
                                                    getDescription,
                                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                                        className: "CertsTerminateModal-NoteWrapper",
                                                        children: [
                                                            /*#__PURE__*/ (0, $hopDi$jsxs)("b", {
                                                                className: "CertsTerminateModal-NoteText",
                                                                children: [
                                                                    "Important:",
                                                                    " "
                                                                ]
                                                            }),
                                                            (0, $13730356a2f65477$export$2e2bcd8739ae039).NOTE
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    terminateActionPrimaryButton(),
                                    terminateActionSecondaryButton()
                                ]
                            })
                        ]
                    })
                ]
            }),
            className: "CertsTerminate-mobileDrawer",
            setIsOpen: handleClose,
            isOpen: isOpen,
            renderOnlyContent: true,
            isCloseOnOutsideClick: true
        });
    };
    const getModalContent = ()=>{
        if (autoRevoke) return commentStatus ? withAutoRevokeWithComments() : withAutoRevokeNoComments();
        return commentStatus ? withoutAutoRevokeWithComments() : withoutAutoRevokeNoComments();
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        children: getModalContent()
    });
}
$4bbca83a32795fb9$var$CertsTerminateModal.defaultProps = {
    isLoading: null
};
$4bbca83a32795fb9$var$CertsTerminateModal.propTypes = {
    autoRevoke: (0, $hopDi$proptypes).bool.isRequired,
    commentStatus: (0, $hopDi$proptypes).bool.isRequired,
    handleClick: (0, $hopDi$proptypes).func.isRequired,
    handleCancel: (0, $hopDi$proptypes).func.isRequired,
    isLoading: (0, $hopDi$proptypes).bool,
    isTerminateError: (0, $hopDi$proptypes).bool.isRequired,
    setIsTerminateError: (0, $hopDi$proptypes).func.isRequired,
    getDescriptionFlag: (0, $hopDi$proptypes).bool.isRequired,
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired
};
var $4bbca83a32795fb9$export$2e2bcd8739ae039 = $4bbca83a32795fb9$var$CertsTerminateModal;


var $e5ef58c6194a06e4$export$2e2bcd8739ae039 = (0, $4bbca83a32795fb9$export$2e2bcd8739ae039);





const $57da59531dca7c37$var$defaultTooltipProps = {
    text: "",
    maxWidth: "12rem",
    placement: "bottom"
};
const $57da59531dca7c37$var$CertsActionButton = /*#__PURE__*/ (0, $hopDi$forwardRef)(({ id: id, setActionPopoverOpenId: setActionPopoverOpenId, setIsSidePanelCommentDrawerOpen: setIsSidePanelCommentDrawerOpen, kind: kind, setDrawerActionSelected: setDrawerActionSelected, groupKind: groupKind, tabIndex: tabIndex, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading, isDecisionMade: isDecisionMade, isDrawerActions: isDrawerActions, isCommentRequired: isCommentRequired, isHidden: isHidden, onClick: onClick, isToolTipDisabled: isToolTipDisabled, tooltipProperties: tooltipProperties, dataTheme: dataTheme, dataTestId: dataTestId, certKey: certKey, nodeData: nodeData, getViewApiConfigmap: //  TODO: Commented out at Umeshes request, add or remove based on user feedback
// verifyParentMap,
getViewApiConfigmap, extendEndDateDaysLimit: extendEndDateDaysLimit, isActionSuccess: isActionSuccess, isActionError: isActionError, getTypeActEntRole: getTypeActEntRole, isSidePanelVisible: isSidePanelVisible, reassignConfigMap: reassignConfigMap, getFirstTimeReject: getFirstTimeReject, certificationStartDate: certificationStartDate, isActionErrorMessage: isActionErrorMessage, conditionalCertifyDaysLimit: conditionalCertifyDaysLimit, isPopoverUserReassignMsgShown: isPopoverUserReassignMsgShown, setReassignUserPopoverMsg: setReassignUserPopoverMsg, setDrawerActionKind: setDrawerActionKind, isSaviResponded: isSaviResponded, saviRespondedReason: saviRespondedReason, isSidePanelCommentDrawerOpen: isSidePanelCommentDrawerOpen, consulteeLoggedIn: consulteeLoggedIn, actionTakenByPrimaryCertifier: actionTakenByPrimaryCertifier, isScrolling: isScrolling, globalDateFormat: globalDateFormat, isActionGroupExpanded: isActionGroupExpanded, activeTab: activeTab, filteredNodeData: filteredNodeData, isActionDrawerOutsideClick: isActionDrawerOutsideClick, setIsActionDrawerOutsideClick: setIsActionDrawerOutsideClick }, ref)=>{
    const getCertIconKinds = (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData);
    const getCertColKeys = (0, $4c1aa6449628783a$export$18b54358355494a)(getCertIconKinds);
    const isNoValue = filteredNodeData[getCertColKeys] === null || filteredNodeData[getCertColKeys] === undefined || filteredNodeData?.[getCertColKeys]?.trim()?.length === 0;
    const certTitleColValue = isNoValue ? "Not Provided" : filteredNodeData[getCertColKeys];
    // Modals and pop ups
    const [isCommentPopoverOpen, setIsCommentPopoverOpen] = (0, $hopDi$useState)(false);
    // const [isProceedStatus, setIsProceedStatus] = useState(false);
    // const [isActionAlertModalOpen, setIsActionAlertModalOpen] = useState(false);
    const [isConsultPopoverShown, setIsConsultPopoverShown] = (0, $hopDi$useState)(false);
    const [isConsultWarnShown, setIsConsultWarnShown] = (0, $hopDi$useState)(false);
    const [isConsultWarnModalOpen, setIsConsultWarnModalOpen] = (0, $hopDi$useState)(false);
    const [isRejectPopoverOpen, setIsRejectPopoverOpen] = (0, $hopDi$useState)(false);
    const [checkTerminateClick, setIsCheckTerminateClick] = (0, $hopDi$useState)(false);
    const [isTerminateError, setIsTerminateError] = (0, $hopDi$useState)(false);
    const [isExtendEndDateClick, setIsExtendEndDateClick] = (0, $hopDi$useState)(false);
    const [isExtendEndDateError, setIsExtendEndDateError] = (0, $hopDi$useState)(false);
    const [isConditionalCertifyClick, setIsConditionalCertifyClick] = (0, $hopDi$useState)(false);
    const [getIsConditionalCertifyError, setIsConditionalCertifyError] = (0, $hopDi$useState)(false);
    const [getCurrentDate, setCurrentDate] = (0, $hopDi$useState)(false);
    const getDefaultDate = nodeData?.ENDDATE && nodeData?.ENDDATE?.length > 0 && new Date(nodeData?.ENDDATE);
    const [getIsRejectError, setIsRejectError] = (0, $hopDi$useState)(false);
    const [isSaviApprovePopoverOpen, setIsSaviApprovePopoverOpen] = (0, $hopDi$useState)(false);
    const [isSaviRejectPopoverOpen, setIsSaviRejectPopoverOpen] = (0, $hopDi$useState)(false);
    const [isReassignModalOpen, setIsReassignModalOpen] = (0, $hopDi$useState)(false);
    const [reassignModalDetails, setReassignModalDetails] = (0, $hopDi$useState)(null);
    const [isConsultModalOpen, setIsConsultModalOpen] = (0, $hopDi$useState)(false);
    const [consultModalDetails, setconsultModalDetails] = (0, $hopDi$useState)(null);
    const dispatch = (0, $hopDi$useDispatch)();
    const { isActionModalOpen: isActionModalOpen } = (0, $hopDi$useSelector)((state)=>state?.certifications.action);
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const consultPopoverFlag = localStorage.getItem((0, $20281fe09bc700a8$export$9612f125f9c1cfb7).CONSULT_POPOVER);
    const consultWarnFlag = localStorage.getItem((0, $20281fe09bc700a8$export$9612f125f9c1cfb7).CONSULT_WARN);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    (0, $hopDi$useEffect)(()=>{
        // changing the current date format from yyyy-mm-dd to mm/dd/yyyy format
        if (nodeData?.User_ENDDATE && nodeData?.User_ENDDATE?.length > 0) {
            let getDate = nodeData?.User_ENDDATE?.split(" ")[0]?.split("-");
            getDate = `${getDate[1]}/${getDate[2]}/${getDate[0]}`;
            setCurrentDate(getDate);
        } else setCurrentDate("-");
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (isScrolling) {
            if (isCommentPopoverOpen || isRejectPopoverOpen) {
                setIsRejectPopoverOpen(false);
                setIsCommentPopoverOpen(false);
                setActionPopoverOpenId(false);
            }
        }
    }, [
        isScrolling
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isCommentPopoverOpen || isRejectPopoverOpen) {
            setIsRejectPopoverOpen(false);
            setIsCommentPopoverOpen(false);
            setActionPopoverOpenId(false);
        }
    }, [
        isActionGroupExpanded
    ]);
    // Set to IsModalOpen when a modal is open
    (0, $hopDi$useEffect)(()=>{
        const isModalOpen = isReassignModalOpen || isConsultModalOpen || isConsultWarnModalOpen || isExtendEndDateClick || checkTerminateClick || isConditionalCertifyClick;
        if (isModalOpen) dispatch((0, $d623f23401a154f0$export$bae1635877bd1db1)(isModalOpen));
        if (isActionModalOpen && !isModalOpen) dispatch((0, $d623f23401a154f0$export$bae1635877bd1db1)(isModalOpen));
    }, [
        isReassignModalOpen,
        isConsultModalOpen,
        isConsultWarnModalOpen,
        // TODO: Request these renamed to isXxxModalOpen
        isExtendEndDateClick,
        checkTerminateClick,
        isConditionalCertifyClick
    ]);
    const { APPROVE: APPROVE, REJECT: REJECT, TERMINATE: TERMINATE, REASSIGN: REASSIGN, CONSULT: CONSULT, WORKS_FOR_ME: WORKS_FOR_ME, DOES_NOT_WORK_FOR_ME: DOES_NOT_WORK_FOR_ME, EXTEND_END_DATE: EXTEND_END_DATE, CONDITIONAL_CERTIFIY: CONDITIONAL_CERTIFIY } = (0, $20281fe09bc700a8$export$3f43cf8434698562);
    const isDisabledException = ()=>{
        switch(kind){
            case REASSIGN:
            case WORKS_FOR_ME:
            case DOES_NOT_WORK_FOR_ME:
                return true;
            default:
                return false;
        }
    };
    const isFooterGroup = groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).FOOTER;
    const isDetailsGroup = groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind !== TERMINATE && // Eliminating Terminate Action for Modal creation
    kind !== EXTEND_END_DATE && // Eliminating Extend End Date Action for Modal creation
    kind !== REJECT && // Eliminating Reject Action for Popover creation
    kind !== DOES_NOT_WORK_FOR_ME && // Eliminating Reassign action for user
    kind !== REASSIGN && // Eliminating Reassign action for Account, Role, Entitilement
    kind !== CONDITIONAL_CERTIFIY; // Eliminating Conditional Certify Action for Modal creation
    const isConfirmManagerOrApproveTileAndCommentRequired = (kind === WORKS_FOR_ME || kind === APPROVE && groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE) && isCommentRequired;
    const isReassignUser = kind === DOES_NOT_WORK_FOR_ME;
    const isConsult = kind === CONSULT;
    const { isConsulted: isConsulted } = nodeData;
    // Needs to set false on is footer render when switching sidepanels
    (0, $hopDi$useEffect)(()=>{
        if (isFooterGroup) setIsSidePanelCommentDrawerOpen(false);
    }, []);
    const actionButtonTooltipClasses = (0, $hopDi$classnames)("CertsActionButton-tooltip", isHidden && "CertsActionButton-tooltip--isHidden", isToolTipDisabled && "CertsActionButton-tooltip--shouldNotRender");
    const actionButtonClasses = (0, $hopDi$classnames)("CertsActionButton", `CertsActionButton-${kind}`, isDisabledException() && "CertsActionButton--isDisabledException", isDisabled && "CertsActionButton--isDisabled", isSelected && !isConsult && "CertsActionButton--isSelected", isLoading && "CertsActionButton--isLoading", isDecisionMade && "CertsActionButton--isDecisionMade", isHidden && "CertsActionButton--isHidden", isSaviResponded && "Tile--DashedBorder", !actionTakenByPrimaryCertifier && !isSaviResponded && "Tile--DashedBorder");
    // Merge provided tooltipProperties with defaults
    const mergedTooltipProperties = {
        ...$57da59531dca7c37$var$defaultTooltipProps,
        ...tooltipProperties
    };
    const getPopoverPlacement = ()=>{
        if (groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).FOOTER) return isSaviResponded ? "top-start" : "top";
        return "left";
    };
    const getIconKind = ()=>{
        switch(kind){
            case APPROVE:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).CHECK;
            case REJECT:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).REJECT;
            case TERMINATE:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).TERMINATE;
            case DOES_NOT_WORK_FOR_ME:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).REASSIGN_USER;
            case REASSIGN:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).REASSIGN_ITEM;
            case WORKS_FOR_ME:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).CONFIRM_MANAGER;
            case EXTEND_END_DATE:
            case CONDITIONAL_CERTIFIY:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).EXTEND_END_DATE;
            case CONSULT:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).CONSULT;
            default:
                return (0, $20281fe09bc700a8$export$506bde9fe967e89b).CHECK;
        }
    };
    const getDrawerItemLabel = ()=>{
        const checkMobileSidePanelFooter = isMobileXlargeWidth && isFooterGroup && !isDrawerActions;
        switch(kind){
            case APPROVE:
                return isSelected ? "Approved" : "Approve";
            case REJECT:
                return "Reject";
            case TERMINATE:
                return "Terminate";
            case REASSIGN:
                return "Reassign";
            case CONSULT:
                return checkMobileSidePanelFooter ? "Consult" : "Consult with Peers";
            case WORKS_FOR_ME:
                if (isSelected) return checkMobileSidePanelFooter ? "Confirmed" : "Manager Confirmed";
                return "Confirm Manager";
            case DOES_NOT_WORK_FOR_ME:
                return "Reassign";
            case EXTEND_END_DATE:
                return checkMobileSidePanelFooter ? "Change Date" : "Change End Date";
            case CONDITIONAL_CERTIFIY:
                return checkMobileSidePanelFooter ? "Change Date..." : "Conditional Certify";
            default:
                return null;
        }
    };
    // Update the to let tile know to increase the z-index
    (0, $hopDi$useEffect)(()=>{
        const isConsultedWithSelectionCheck = !isConsult && isConsulted && kind !== EXTEND_END_DATE;
        const isReassignOrReassignUser = kind === REASSIGN || kind === DOES_NOT_WORK_FOR_ME;
        const isRejectCancelingConsulted = isSelected && groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind === REJECT;
        const isExtendCancelingConsulted = isSelected && groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind === EXTEND_END_DATE;
        const isTerminatedConsulted = isSelected && groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind === TERMINATE;
        if (isConsultedWithSelectionCheck || isReassignOrReassignUser || isDetailsGroup || isRejectCancelingConsulted || isExtendCancelingConsulted || isTerminatedConsulted) {
            if (isCommentPopoverOpen) setActionPopoverOpenId(nodeData?.tracker?.id);
            else setActionPopoverOpenId(false);
        }
    }, [
        isCommentPopoverOpen
    ]);
    // Re-enable outside click for tile Action drawer
    (0, $hopDi$useEffect)(()=>{
        if (!isActionDrawerOutsideClick && !isCommentPopoverOpen) setIsActionDrawerOutsideClick(true);
    }, [
        isCommentPopoverOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (!isActionDrawerOutsideClick && !isRejectPopoverOpen) setIsActionDrawerOutsideClick(true);
    }, [
        isRejectPopoverOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (!isActionDrawerOutsideClick && !isReassignModalOpen) setIsActionDrawerOutsideClick(true);
    }, [
        isReassignModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isConsultWarnModalOpen) setIsActionDrawerOutsideClick(false);
    }, [
        isConsultWarnModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (consultWarnFlag !== null) setIsConsultWarnShown(consultWarnFlag !== "true");
        else if (isSidePanelVisible && isConsulted) // Sidepanel open state and  taken any action  and refreshed the sidepanel data -- resetting state values
        setIsConsultWarnShown(false);
        if (consultPopoverFlag !== null) setIsConsultPopoverShown(consultPopoverFlag !== "true");
        else if (isSidePanelVisible && isConsulted) // Sidepanel open state and  taken any action  and refreshed the sidepanel data -- resetting state values
        setIsConsultPopoverShown(false);
    }, [
        consultPopoverFlag,
        consultWarnFlag,
        nodeData
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind === REJECT) {
            if (isRejectPopoverOpen) setActionPopoverOpenId(nodeData?.tracker?.id);
            if (!isRejectPopoverOpen) setActionPopoverOpenId(false);
        }
    }, [
        isRejectPopoverOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind === APPROVE && isSaviResponded) {
            if (isSaviApprovePopoverOpen) setActionPopoverOpenId(nodeData?.tracker?.id);
            if (!isSaviApprovePopoverOpen) setActionPopoverOpenId(false);
        }
    }, [
        isSaviApprovePopoverOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (groupKind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE && kind === REJECT && isSaviResponded) {
            if (isSaviRejectPopoverOpen) setActionPopoverOpenId(nodeData?.tracker?.id);
            if (!isSaviRejectPopoverOpen) setActionPopoverOpenId(false);
        }
    }, [
        isSaviRejectPopoverOpen
    ]);
    const getBorderIcon = ()=>{
        if (isSelected && isDecisionMade) return "CertsActionBtnSelectedBorderDash";
        return "CertsActionBtnSelectedBorderSolid";
    };
    // const getAlertSubtitle = () => {
    //   const hasAccountType = verifyParentMap.some(
    //     (item) => item.type === 'account'
    //   );
    //   if (certKind === LINE_ITEM_TYPES.ACCOUNT)
    //     return 'To approve this Account, you must also approve the User:';
    //   if (certKind === LINE_ITEM_TYPES.ENTITLEMENT) {
    //     if (hasAccountType) {
    //       return 'To approve this Entitlement, you must also approve the User and any associated Accounts:';
    //     }
    //     return 'To approve this Entitlement, you must also approve the User:';
    //   }
    //   if (certKind === LINE_ITEM_TYPES.ROLE) {
    //     if (hasAccountType) {
    //       return 'To approve this Role, you must also approve the User and any associated Accounts:';
    //     }
    //     return 'To approve this Role, you must also approve the User:';
    //   }
    //   return 'Error in subtitle handler';
    // };
    // const handleAlertModalSubmit = (commentPopperValue) => {
    //   const isModalDrawerVersion = true;
    //   if (isCommentRequired && !isSelected)
    //     onClick(commentPopperValue, isModalDrawerVersion);
    //   if (!isCommentRequired && !isSelected) onClick();
    // };
    (0, $hopDi$useEffect)(()=>{
        // Handling Error Banners on top of the Modals/Popovers based on Success or Error Action
        if (isActionSuccess) {
            if (kind === TERMINATE) {
                setIsCheckTerminateClick(false);
                setIsTerminateError(false);
            }
            if (kind === EXTEND_END_DATE) {
                setIsExtendEndDateClick(false);
                setIsExtendEndDateError(false);
            }
            if (kind === REJECT) {
                setIsRejectPopoverOpen(false);
                setIsRejectError(false);
            }
            if (kind === CONDITIONAL_CERTIFIY) {
                setIsConditionalCertifyClick(false);
                setIsConditionalCertifyError(false);
            }
            if (kind === APPROVE) setIsSaviApprovePopoverOpen(false);
        }
        if (isActionError) {
            if (kind === TERMINATE) setIsTerminateError(true);
            if (kind === EXTEND_END_DATE) setIsExtendEndDateError(true);
            if (kind === REJECT) setIsRejectError(true);
            if (kind === CONDITIONAL_CERTIFIY) setIsConditionalCertifyError(true);
        }
    }, [
        isActionSuccess,
        isActionError
    ]);
    const handleConsultWarnModal = ()=>{
        setIsConsultWarnModalOpen((prevState)=>!prevState);
    };
    const handleConsultModal = ()=>{
        const details = {
            // commented this code due to include associated check box is not for Reassign - Remove after beta Release
            // isIncludeAssociatedEnt: nodeData?.showConsultOrReassignAssociatedFlag
            //   ? nodeData?.showConsultOrReassignAssociatedFlag
            //   : false,
            isIncludeAssociatedEnt: false,
            isNoteRequired: true,
            noteText: "Dependent parent will be approved",
            isIncludeAsscLabel: ""
        };
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER:
                // details.isIncludeAsscLabel =
                //   'Include Associated Items (Accounts and Entitlements)';
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER;
                details.noteText = `Access items associated with this ${(0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER.toLowerCase()} are included.`;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ACCOUNT:
                details.isIncludeAssociatedEnt = true; // enable checkbox only for account lineitem
                details.isIncludeAsscLabel = "Include Associated Items"; // (Entitlements and Application Roles) not required - remove after beta release
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ACCOUNT;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ROLE:
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ROLE;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                details.isIncludeAsscLabel = "Include Associated Items";
                if ((0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT >= 0) details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ENTITLEMENT;
                details.isIncludeAsscLabel = "Include Associated Items (Account, Entitlements and Application Roles)";
                break;
        }
        setIsConsultModalOpen(true);
        setconsultModalDetails(details);
    };
    const handleReassignModal = ()=>{
        const details = {
            isSkipReassignment: false,
            // commented this code due to include associated check box is not for Reassign - Remove after beta Release
            // isIncludeAssociatedEnt: nodeData?.showConsultOrReassignAssociatedFlag
            //   ? nodeData?.showConsultOrReassignAssociatedFlag
            //   : false,
            isIncludeAssociatedEnt: false,
            isNoteRequired: true,
            noteText: "Dependent parent will be approved",
            isIncludeAsscLabel: "",
            actionKind: kind
        };
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER:
                if (reassignConfigMap.defaultReassignee === "") details.isSkipReassignment = true;
                details.isNoteRequired = true;
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER;
                details.noteText = `Access items associated with this ${(0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).USER.toLowerCase()} are included.`;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ACCOUNT:
                details.isIncludeAsscLabel = "Include Associated Items (Entitlements and Application Roles)";
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ACCOUNT;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ROLE:
                details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ROLE;
                break;
            case (0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                details.isIncludeAsscLabel = "Include Associated Items";
                if ((0, $20281fe09bc700a8$export$994f7af6d0b36256).ENTITLEMENT >= 0) details.lineItemKind = (0, $e7683d2bb9b3b8c9$export$7e6b1c64d872ccd0).ENTITLEMENT;
                details.isIncludeAsscLabel = "Include Associated Items (Account, Entitlements and Application Roles)";
                break;
        }
        setIsReassignModalOpen(true);
        setReassignModalDetails(details);
    };
    const handleActionClick = (proceedActionForConsultedRecord = true)=>{
        setIsActionDrawerOutsideClick(false);
        setIsSidePanelCommentDrawerOpen(false);
        setDrawerActionKind(null);
        // condition to show consulted record popover to take other actions
        const showConsultedPopover = isConsulted && !consulteeLoggedIn && !isConsultPopoverShown && kind !== CONSULT && kind !== EXTEND_END_DATE && !isSaviResponded && !isSidePanelVisible && activeTab !== (0, $d44c789d5b60f9bf$export$807a0bc890800408);
        // condition to show  popover to show details of action performed by non primary certifier
        const showActionedPopover = !actionTakenByPrimaryCertifier && !isSaviResponded && // isConsulted && // no need to check consulted record - remove once confirmation comes
        isSelected && kind !== CONSULT;
        if (showConsultedPopover || showActionedPopover) setIsCommentPopoverOpen(true);
        // Start - don't execute handle action click when actioin taken by non primary certifier (Admin or consultee or secondary certifier) excluding consult
        if (!actionTakenByPrimaryCertifier && kind !== CONSULT && kind !== EXTEND_END_DATE && isSelected && !isSaviResponded) {
            if (isFooterGroup) {
                setDrawerActionKind(kind);
                setIsSidePanelCommentDrawerOpen(true);
                setDrawerActionSelected(isSelected);
            }
            return;
        }
        // End - don't execute handle action click when action taken by non primary certifier (Admin or consultee or secondary certifier) excluding consult
        // Start Consult Record validation
        if (kind !== CONSULT && kind !== EXTEND_END_DATE && isConsulted && !isSaviResponded && proceedActionForConsultedRecord && activeTab !== (0, $d44c789d5b60f9bf$export$807a0bc890800408)) {
            if (!actionTakenByPrimaryCertifier && isSelected) return;
            if (isConsultPopoverShown && !isConsultWarnShown) {
                handleConsultWarnModal();
                return;
            }
            // dont't allow any actions
            if (!isConsultPopoverShown && !consulteeLoggedIn) {
                setDrawerActionKind(kind);
                setIsSidePanelCommentDrawerOpen(true);
                setDrawerActionSelected(isSelected);
                return;
            }
        }
        // End Consult Record validation
        if (kind === APPROVE && !isSelected) {
            if (isCommentRequired) {
                if (isDetailsGroup) setIsCommentPopoverOpen(true);
                if (isFooterGroup) {
                    setDrawerActionKind(APPROVE);
                    setIsSidePanelCommentDrawerOpen(true);
                }
                return;
            }
            onClick();
            return;
        // TODO: Commented out at Umeshes request, add or remove based on user feedback
        // setIsProceedStatus(false);
        // const getNameByType = () => {
        //   if (getTypeActEntRole === CERT_TILE_TYPE.ACCOUNT)
        //     return nodeData?.Account_DISPLAYNAME;
        //   if (getTypeActEntRole === CERT_TILE_TYPE.ROLE)
        //     return nodeData?.Role_DISPLAYNAME;
        //   if (getTypeActEntRole === CERT_TILE_TYPE.ENTITLEMENT)
        //     return nodeData?.Ent_DISPLAYNAME;
        //   return null;
        // };
        // const currentChildObject = {
        //   type: getTypeActEntRole.toLowerCase(),
        //   childname: getNameByType(),
        // };
        // const verifyPayload = {
        //   certKey,
        //   userKey,
        //   entValueKey,
        //   accountKey,
        //   roleKey,
        // };
        // getVarifyParentItemStatus(dispatch, verifyPayload, currentChildObject)
        //   .then((response) => {
        //     if (response.proceed) {
        //       setIsActionAlertModalOpen(false);
        //       setIsProceedStatus(true);
        //       if (isCommentRequired) {
        //         if (isDetailsGroup) setIsCommentPopoverOpen(true);
        //         if (isFooterGroup) {
        //           setDrawerActionKind(APPROVE);
        //           setIsSidePanelCommentDrawerOpen(true);
        //         }
        //         return;
        //       }
        //       onClick();
        //       return;
        //     }
        //     setIsActionAlertModalOpen(true);
        //     if (isDetailsGroup) setIsCommentPopoverOpen(false);
        //     if (isFooterGroup) setIsSidePanelCommentDrawerOpen(false);
        //   })
        //   .catch((error) => {
        //     Logger.log('Error handling API call:', error.message);
        //     setIsActionAlertModalOpen(false);
        //     setActionPopoverOpenId(false);
        //   });
        // TODO END: Commented out at Umeshes request, add or remove based on user feedback
        }
        if (kind === WORKS_FOR_ME) {
            if (isCommentRequired && !isSelected) {
                if (isDetailsGroup) setIsCommentPopoverOpen(true);
                if (isFooterGroup) {
                    setDrawerActionKind(WORKS_FOR_ME);
                    setIsSidePanelCommentDrawerOpen(true);
                    setDrawerActionSelected(isSelected);
                }
                return;
            }
            onClick();
            return;
        }
        // Set to open popover if required instead (handled isOpen set in CertsActionPopover)
        if (isCommentRequired && !isSelected && isDetailsGroup && kind !== CONSULT && kind !== REASSIGN && kind !== DOES_NOT_WORK_FOR_ME) return;
        // Handling Terminate Modal Ui events
        if (kind === TERMINATE) {
            if (!isSelected) {
                setIsCheckTerminateClick(true);
                setIsTerminateError(false);
                return;
            }
            setIsCheckTerminateClick(false);
            onClick();
            return;
        }
        // Handling Extend End Date Modal Ui events
        if (kind === EXTEND_END_DATE) {
            setIsExtendEndDateClick(true);
            setIsExtendEndDateError(false);
            return;
        }
        // Handling Reject Popover Ui events
        if (kind === REJECT) {
            if (!isSelected && !isSidePanelVisible && isCommentRequired) {
                if (getFirstTimeReject || isCommentRequired) {
                    setIsRejectPopoverOpen(true);
                    setIsRejectError(false);
                    return;
                }
            }
            if (isSaviResponded && isSelected) {
                setIsSaviRejectPopoverOpen(true);
                if (isSidePanelCommentDrawerOpen) setIsSidePanelCommentDrawerOpen(false);
                return;
            }
            setIsRejectPopoverOpen(false);
            onClick();
            return;
        }
        // Handling Conditional Certify Modal Ui events
        if (kind === CONDITIONAL_CERTIFIY) {
            if (!isSelected) {
                setIsConditionalCertifyClick(true);
                setIsConditionalCertifyError(false);
                return;
            }
            setIsConditionalCertifyClick(false);
            onClick();
            return;
        }
        if (kind === DOES_NOT_WORK_FOR_ME) {
            if (!isSelected) {
                // Mobile Responsiveness mode conditions
                if (isMobileXlargeWidth && !isPopoverUserReassignMsgShown && (0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap)) {
                    if (!proceedActionForConsultedRecord) handleReassignModal();
                    else setIsCommentPopoverOpen(true);
                    return;
                }
                // sidepanel reassign message
                if (isFooterGroup && !isMobileXlargeWidth) {
                    if ((0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap) && !isPopoverUserReassignMsgShown) {
                        setDrawerActionKind(DOES_NOT_WORK_FOR_ME);
                        setIsSidePanelCommentDrawerOpen(true);
                        setDrawerActionSelected(isSelected);
                        return;
                    }
                }
                if (consulteeLoggedIn) {
                    if (!isCommentRequired && (0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap) && isPopoverUserReassignMsgShown) {
                        onClick();
                        return;
                    }
                }
                if (!isCommentRequired && !(0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap)) onClick();
                else if (isCommentRequired && !(0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap)) handleReassignModal();
                else if ((0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap) && (isPopoverUserReassignMsgShown || !proceedActionForConsultedRecord)) handleReassignModal();
                return;
            }
            onClick();
            return;
        }
        if (kind === REASSIGN) {
            if (!isSelected) {
                handleReassignModal();
                return;
            }
            onClick();
            return;
        }
        // don't open any modal for reassign user until first popover accepted by user
        if (kind === DOES_NOT_WORK_FOR_ME && !isPopoverUserReassignMsgShown) return;
        if (isConsult) {
            if (isConsulted && isSelected && activeTab !== (0, $d44c789d5b60f9bf$export$807a0bc890800408)) {
                // Start -- only when record is consulted
                handleConsultWarnModal();
                return;
            }
            if (!isSelected || activeTab === (0, $d44c789d5b60f9bf$export$807a0bc890800408)) {
                handleConsultModal();
                return;
            }
            onClick();
            return;
        }
        if (kind === APPROVE) {
            if (isSaviResponded && isSelected) {
                setIsSaviApprovePopoverOpen(true);
                if (isSidePanelCommentDrawerOpen) setIsSidePanelCommentDrawerOpen(false);
                return;
            }
        }
        onClick();
    };
    const handleCommentSubmit = (commentPopperValue)=>{
        if (isCommentRequired && !isSelected) onClick(commentPopperValue);
    };
    const handleReassignSubmit = (reassignPayload)=>{
        // set first time notify message
        // handle popover and modal api call
        onClick(reassignPayload);
    };
    const handleConsultSubmit = (consultPayload)=>{
        onClick(consultPayload);
    };
    const handleConsultPopover = (checkBoxSelected)=>{
        if (checkBoxSelected) localStorage.setItem((0, $20281fe09bc700a8$export$9612f125f9c1cfb7).CONSULT_POPOVER, !checkBoxSelected);
        setIsConsultPopoverShown(true);
        setIsCommentPopoverOpen(false);
        if (!isConsultWarnShown) // open warn modal
        setIsConsultWarnModalOpen(true);
        else {
            // reassign user forcefully setting flag to true
            if (isReassignUser) setReassignUserPopoverMsg();
            handleActionClick(false); // proceed consult action
        }
    };
    // using handler in side panel comment drawer
    const handleReassignUserPopover = ()=>{
        setReassignUserPopoverMsg();
        if (consulteeLoggedIn && !isCommentRequired) onClick();
        else handleReassignModal();
    };
    (0, $hopDi$useImperativeHandle)(ref, ()=>({
            childFunction: handleConsultPopover,
            getIsConsultPopoverShown: ()=>isConsultPopoverShown,
            handleReassignUserPopover: handleReassignUserPopover
        }));
    const ActionButtonTrigger = /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                id: id,
                dataTheme: dataTheme,
                tabIndex: tabIndex,
                onClick: handleActionClick,
                isDisabled: isDisabled,
                className: actionButtonClasses,
                dataTestId: dataTestId,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "CertsActionButton-inner",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: getIconKind()
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                className: "CertsActionButton-overlay"
                            })
                        ]
                    }),
                    kind === CONSULT && isSelected && nodeData?.CONSULTED_USERCOUNT > 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        className: "CertsActionButton-consultIndicator",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3-bold",
                                children: nodeData?.CONSULTED_USERCOUNT
                            })
                        })
                    }),
                    isSelected && kind !== CONSULT && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        className: "CertsActionButton-borderIcon",
                        kind: getBorderIcon()
                    }),
                    isLoading && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$lottiereact), {
                        className: "CertsActionButton-borderLoading",
                        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($5a97dceba7e1a33b$exports)))
                    })
                ]
            }),
            isMobileXlargeWidth && !isHidden && isFooterGroup && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                className: "CertsTileActionsDrawer-item CertsTileActionsDrawer-sidepanelItem",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: "MobileDrawerItem-primaryLabelWrapper",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "label",
                        desktop: "body4-bold-d",
                        mobile: "body4-bold-m",
                        className: (0, $hopDi$classnames)("MobileDrawerItem-label", isSelected && "MobileDrawerItem-label--selected", isDisabled && "MobileDrawerItem-label--isDisabled"),
                        children: getDrawerItemLabel()
                    })
                })
            }),
            kind === TERMINATE && checkTerminateClick && /*#__PURE__*/ (0, $hopDi$jsx)((0, $e5ef58c6194a06e4$export$2e2bcd8739ae039), {
                isMobileXlargeWidth: isMobileXlargeWidth,
                autoRevoke: getViewApiConfigmap?.LOCKTASKEXPIRE === "1",
                commentStatus: isCommentRequired,
                handleClick: onClick,
                handleCancel: ()=>{
                    setIsCheckTerminateClick(false);
                    setIsActionDrawerOutsideClick(true);
                },
                isLoading: isLoading,
                isTerminateError: isTerminateError,
                setIsTerminateError: ()=>setIsTerminateError(false),
                getDescriptionFlag: getViewApiConfigmap?.LOCKTASKEXPIRE === "1" || getViewApiConfigmap?.LOCKTASKS === "1"
            }),
            kind === EXTEND_END_DATE && isExtendEndDateClick && /*#__PURE__*/ (0, $hopDi$jsx)((0, $2b983767f0657a26$export$2e2bcd8739ae039), {
                isMobileXlargeWidth: isMobileXlargeWidth,
                handleClick: onClick,
                handleCancel: ()=>{
                    setIsExtendEndDateClick(false);
                    setIsActionDrawerOutsideClick(true);
                },
                getCurrentEndDate: getCurrentDate,
                isChangeEndDateError: isExtendEndDateError,
                setIsChangeEndDateError: ()=>setIsExtendEndDateError(false),
                allowedChangeExtendDate: extendEndDateDaysLimit,
                isLoading: isLoading,
                certificationStartDate: new Date(certificationStartDate),
                errorMessage: isActionErrorMessage,
                getDefaultEndDate: getDefaultDate,
                isCertsKindUser: nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $20281fe09bc700a8$export$994f7af6d0b36256).USER
            }),
            kind === CONDITIONAL_CERTIFIY && isConditionalCertifyClick && /*#__PURE__*/ (0, $hopDi$jsx)((0, $2b983767f0657a26$export$2e2bcd8739ae039), {
                isMobileXlargeWidth: isMobileXlargeWidth,
                handleClick: onClick,
                handleCancel: ()=>{
                    setIsConditionalCertifyClick(false);
                    setIsActionDrawerOutsideClick(true);
                },
                getCurrentEndDate: getCurrentDate,
                isChangeEndDateError: getIsConditionalCertifyError,
                setIsChangeEndDateError: ()=>setIsConditionalCertifyError(false),
                allowedChangeExtendDate: conditionalCertifyDaysLimit,
                isLoading: isLoading,
                certificationStartDate: new Date(certificationStartDate),
                errorMessage: isActionErrorMessage,
                getDefaultEndDate: getDefaultDate
            }),
            (kind === DOES_NOT_WORK_FOR_ME || kind === REASSIGN) && isReassignModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $7de18020df34e39a$export$2e2bcd8739ae039), {
                isReassignModalOpen: isReassignModalOpen,
                setIsReassignModalOpen: ()=>setIsReassignModalOpen(false),
                setIsActionDrawerOutsideClick: setIsActionDrawerOutsideClick,
                onSubmit: handleReassignSubmit,
                isCommentRequired: isCommentRequired,
                reassignModalDetails: reassignModalDetails,
                nodeData: nodeData
            }),
            kind === CONSULT && isConsultModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $7f3598ff04b0c7dc$export$2e2bcd8739ae039), {
                isConsultModalOpen: isConsultModalOpen,
                setIsConsultModalOpen: ()=>{
                    setIsConsultModalOpen(false);
                    setIsActionDrawerOutsideClick(true);
                },
                onSubmit: handleConsultSubmit,
                isCommentRequired: isCommentRequired,
                consultModalDetails: consultModalDetails,
                nodeData: nodeData
            }),
            isConsultWarnModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $3000c97704c797ef$export$2e2bcd8739ae039), {
                warnText: (0, $687791ac9134434b$export$a9e26aab2ac37c8b)(kind, nodeData?.CONSULTED_USERNAME, nodeData?.CONSULTED_USERCOUNT),
                btnText: (0, $687791ac9134434b$export$84ed66aad96abed5)(kind),
                showCheckBox: kind !== CONSULT,
                title: (0, $687791ac9134434b$export$450cf8b9c8d4cff7)(nodeData?.CONSULTED_USERCOUNT),
                isConsultWarnModalOpen: isConsultWarnModalOpen,
                isActionLoading: isLoading,
                handleClose: ()=>{
                    handleConsultWarnModal();
                    setIsActionDrawerOutsideClick(true);
                },
                errorMessage: isActionErrorMessage,
                handleWarnModal: kind === CONSULT ? ()=>{
                    handleConsultWarnModal();
                    setTimeout(()=>{
                        handleConsultModal();
                    }, isMobileXlargeWidth ? (0, $135adfecc1ed8f07$export$f688697617dd0589) : 0);
                } : (checkBoxSelected)=>{
                    if (checkBoxSelected) localStorage.setItem((0, $20281fe09bc700a8$export$9612f125f9c1cfb7).CONSULT_WARN, !checkBoxSelected);
                    setIsConsultWarnShown(true);
                    handleConsultWarnModal();
                    // reassign user forcefully setting flag to true
                    if (isReassignUser) {
                        setReassignUserPopoverMsg();
                        setTimeout(()=>{
                            handleActionClick(false); // proceed consult action
                        }, 200);
                        return;
                    }
                    handleActionClick(false); // proceed consult action
                },
                isActionSuccess: isActionSuccess
            })
        ]
    });
    const getActionButton = ()=>{
        if (isDrawerActions) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "CertsTileActionsDrawer-actionPlaceholder",
                    children: ActionButtonTrigger
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawerItem), {
                    option: {
                        label: getDrawerItemLabel(),
                        value: id,
                        prefixIcon: getIconKind(),
                        onClick: onClick,
                        isChecked: isSelected,
                        isDisabled: isDisabled
                    },
                    onClick: handleActionClick,
                    suffixIcon: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "dots",
                        format: "inline",
                        color: isSelected ? "inverse" : "brand"
                    }) : null,
                    className: "CertsTileActionsDrawer-item"
                })
            ]
        });
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
            className: actionButtonTooltipClasses,
            openDelay: mergedTooltipProperties.openDelay,
            text: mergedTooltipProperties.text,
            maxWidth: mergedTooltipProperties.maxWidth,
            placement: !isCommentPopoverOpen || !isRejectPopoverOpen ? mergedTooltipProperties.placement : "right",
            offset: 8,
            isDisabled: isHidden,
            trigger: ActionButtonTrigger
        });
    };
    // action not taken by primary certifier and is consulted
    if (!actionTakenByPrimaryCertifier && !isSaviResponded && // isConsulted && // no need to check consulted record - remove once confirmation comes
    isSelected && kind !== CONSULT && kind !== EXTEND_END_DATE && !isSidePanelVisible) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $5cc4539d6b20fb8d$export$2e2bcd8739ae039), {
        isMobileXlargeWidth: isMobileXlargeWidth,
        isCommentPopoverOpen: isCommentPopoverOpen,
        setIsCommentPopoverOpen: setIsCommentPopoverOpen,
        placement: getPopoverPlacement(),
        trigger: getActionButton(),
        onClose: ()=>{
            if (isCommentPopoverOpen) setIsCommentPopoverOpen(false);
        },
        resetAction: ()=>{
            setIsCommentPopoverOpen(false);
            onClick(); // to reset action
        },
        certKey: certKey,
        nodeData: nodeData,
        globalDateFormat: globalDateFormat
    });
    if (isConsulted && !consulteeLoggedIn && !isConsultPopoverShown && kind !== CONSULT && kind !== EXTEND_END_DATE && !isSaviResponded && !isSidePanelVisible && activeTab !== (0, $d44c789d5b60f9bf$export$807a0bc890800408 // dont show consult popover in done tab
    )) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $b17240ba2f8a5623$export$2e2bcd8739ae039), {
        isMobileXlargeWidth: isMobileXlargeWidth,
        actionKind: kind,
        isCommentPopoverOpen: isCommentPopoverOpen,
        setIsCommentPopoverOpen: setIsCommentPopoverOpen,
        placement: getPopoverPlacement(),
        trigger: getActionButton(),
        onSubmit: (checkBoxSelected)=>{
            handleConsultPopover(checkBoxSelected);
        }
    });
    if (isConsulted && !consulteeLoggedIn && isConsultPopoverShown && isConsultWarnShown || !isConsulted || consulteeLoggedIn || isConsulted && activeTab === (0, $d44c789d5b60f9bf$export$807a0bc890800408)) {
        if (isSaviRejectPopoverOpen) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $ac46cb6010681c0d$export$2e2bcd8739ae039), {
            kind: REJECT,
            handleClick: onClick,
            onClose: setIsSaviRejectPopoverOpen,
            isOpen: isSaviRejectPopoverOpen,
            trigger: getActionButton(),
            placement: getPopoverPlacement(),
            saviRespondedReason: saviRespondedReason,
            getTypeActEntRole: getTypeActEntRole,
            getCertIconKind: getCertIconKinds,
            getColKey: certTitleColValue
        });
        if (isSaviApprovePopoverOpen) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $ac46cb6010681c0d$export$2e2bcd8739ae039), {
            kind: APPROVE,
            handleClick: onClick,
            onClose: setIsSaviApprovePopoverOpen,
            isOpen: isSaviApprovePopoverOpen,
            trigger: getActionButton(),
            placement: getPopoverPlacement(),
            saviRespondedReason: saviRespondedReason,
            getTypeActEntRole: getTypeActEntRole,
            getCertIconKind: getCertIconKinds,
            getColKey: certTitleColValue
        });
        if (isConfirmManagerOrApproveTileAndCommentRequired && !isSidePanelVisible) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8c613cbc0666ae78$export$2e2bcd8739ae039), {
            actionKind: kind,
            isMobileXlargeWidth: isMobileXlargeWidth,
            isCommentPopoverOpen: kind === APPROVE || kind === WORKS_FOR_ME ? isCommentPopoverOpen : false,
            setIsCommentPopoverOpen: isSelected ? ()=>{} : setIsCommentPopoverOpen,
            placement: getPopoverPlacement(),
            trigger: getActionButton(),
            onSubmit: handleCommentSubmit,
            getTypeActEntRole: getTypeActEntRole
        });
        // enable the popover when reassign and show reassign , comments if not required  popover is false
        if (isReassignUser && // isCommentRequired &&
        (0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap) && !isPopoverUserReassignMsgShown && !isReassignModalOpen && (!isSidePanelVisible || isMobileXlargeWidth)) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $315ae4957e308cf1$export$2e2bcd8739ae039), {
            actionKind: kind,
            nodeData: nodeData,
            isCommentPopoverOpen: isCommentPopoverOpen,
            isMobileXlargeWidth: isMobileXlargeWidth,
            setIsCommentPopoverOpen: isSelected ? ()=>{} : setIsCommentPopoverOpen,
            placement: getPopoverPlacement(),
            trigger: getActionButton(),
            onSubmit: ()=>{
                if (isCommentPopoverOpen) setIsCommentPopoverOpen(false);
                setReassignUserPopoverMsg();
                if (consulteeLoggedIn && !isCommentRequired) onClick();
                else handleReassignModal();
            }
        });
        // TO DO remove code after beta release
        // if (
        //   isReassignUser &&
        //   isCommentRequired &&
        //   checkReassignWithComments(reassignConfigMap)
        // ) {
        //   return (
        //     <CertsActionPopover
        //       actionKind={kind}
        //       isCommentPopoverOpen={isCommentPopoverOpen}
        //       setIsCommentPopoverOpen={
        //         isSelected ? () => {} : setIsCommentPopoverOpen
        //       }
        //       placement={getPopoverPlacement()}
        //       trigger={getActionButton()}
        //       onSubmit={(commentPopperValue) => {
        //         const modalInfo = { commentValue: commentPopperValue };
        //         handleReassignSubmit(modalInfo);
        //       }}
        //       getTypeActEntRole={getTypeActEntRole}
        //     />
        //   );
        // }
        /* Account, Entitlement and Role Reject Action Popover */ if (isRejectPopoverOpen && isCommentRequired && !getIsRejectError && !isSidePanelVisible) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $813c5abc50980873$export$2e2bcd8739ae039), {
            isMobileXlargeWidth: isMobileXlargeWidth,
            autoRevoke: getViewApiConfigmap?.LOCKTASKEXPIRE === "1",
            commentStatus: isCommentRequired,
            handleClick: onClick,
            isLoading: isLoading,
            getTypeActEntRole: getTypeActEntRole,
            placement: getPopoverPlacement(),
            trigger: getActionButton(),
            isRejectPopoverOpen: isRejectPopoverOpen,
            setIsRejectPopoverOpen: isSelected ? ()=>{} : setIsRejectPopoverOpen
        });
    }
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Fragment), {
        children: getActionButton()
    });
});
$57da59531dca7c37$var$CertsActionButton.defaultProps = {
    id: null,
    setActionPopoverOpenId: ()=>{},
    setIsSidePanelCommentDrawerOpen: ()=>{},
    setDrawerActionSelected: ()=>{},
    tabIndex: 0,
    isDisabled: false,
    isSelected: false,
    isLoading: false,
    isDecisionMade: false,
    isCommentRequired: false,
    isToolTipDisabled: false,
    tooltipProperties: $57da59531dca7c37$var$defaultTooltipProps,
    dataTheme: null,
    dataTestId: null,
    getViewApiConfigmap: null,
    extendEndDateDaysLimit: null,
    isActionSuccess: false,
    isActionError: false,
    getTypeActEntRole: null,
    isSidePanelVisible: null,
    reassignConfigMap: {
        defaultReassignee: "",
        defaultReassigneeName: "",
        enableIndividualCommentsForAccountEntitlementRoles: [],
        enableIndividualCommentsForUsers: [],
        enableReassignStep2: "0",
        enableReassignUser: "0",
        showReassignPopup: "0"
    },
    getFirstTimeReject: null,
    certificationStartDate: null,
    isActionErrorMessage: null,
    conditionalCertifyDaysLimit: null,
    isPopoverUserReassignMsgShown: false,
    setReassignUserPopoverMsg: ()=>{},
    setDrawerActionKind: ()=>{},
    isSaviResponded: false,
    saviRespondedReason: [],
    consulteeLoggedIn: false,
    isScrolling: false,
    isActionGroupExpanded: false,
    activeTab: (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
    filteredNodeData: {},
    isActionDrawerOutsideClick: true,
    setIsActionDrawerOutsideClick: ()=>{}
};
$57da59531dca7c37$var$CertsActionButton.propTypes = {
    id: (0, $hopDi$proptypes).string,
    setActionPopoverOpenId: (0, $hopDi$proptypes).func,
    setIsSidePanelCommentDrawerOpen: (0, $hopDi$proptypes).func,
    setDrawerActionSelected: (0, $hopDi$proptypes).func,
    kind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$3f43cf8434698562))).isRequired,
    groupKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$758743ec42a300f1))).isRequired,
    tabIndex: (0, $hopDi$proptypes).number,
    isDisabled: (0, $hopDi$proptypes).bool,
    isSelected: (0, $hopDi$proptypes).bool,
    isLoading: (0, $hopDi$proptypes).bool,
    isDecisionMade: (0, $hopDi$proptypes).bool,
    isDrawerActions: (0, $hopDi$proptypes).bool.isRequired,
    isCommentRequired: (0, $hopDi$proptypes).bool,
    isHidden: (0, $hopDi$proptypes).bool.isRequired,
    onClick: (0, $hopDi$proptypes).func.isRequired,
    isToolTipDisabled: (0, $hopDi$proptypes).bool,
    tooltipProperties: (0, $hopDi$proptypes).shape({
        text: (0, $hopDi$proptypes).string,
        openDelay: (0, $hopDi$proptypes).number,
        maxWidth: (0, $hopDi$proptypes).string,
        placement: (0, $hopDi$proptypes).string
    }),
    dataTheme: (0, $hopDi$proptypes).oneOf(Object.values((0, $135adfecc1ed8f07$export$49390a4605a2336a))),
    dataTestId: (0, $hopDi$proptypes).string,
    certKey: (0, $hopDi$proptypes).string.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    // TODO: Commented out at Umeshes request, add or remove based on user feedback
    // verifyParentMap: PropTypes.arrayOf(VERIFY_PARENT_MAP_MODEL),
    // eslint-disable-next-line react/forbid-prop-types
    getViewApiConfigmap: (0, $hopDi$proptypes).any,
    extendEndDateDaysLimit: (0, $hopDi$proptypes).string,
    isActionSuccess: (0, $hopDi$proptypes).bool,
    isActionError: (0, $hopDi$proptypes).bool,
    getTypeActEntRole: (0, $hopDi$proptypes).string,
    isSidePanelVisible: (0, $hopDi$proptypes).bool,
    getFirstTimeReject: (0, $hopDi$proptypes).bool,
    certificationStartDate: (0, $hopDi$proptypes).string,
    isActionErrorMessage: (0, $hopDi$proptypes).string,
    conditionalCertifyDaysLimit: (0, $hopDi$proptypes).string,
    reassignConfigMap: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$79819249befb86e5)),
    isPopoverUserReassignMsgShown: (0, $hopDi$proptypes).bool,
    setReassignUserPopoverMsg: (0, $hopDi$proptypes).func,
    setDrawerActionKind: (0, $hopDi$proptypes).func,
    isSaviResponded: (0, $hopDi$proptypes).bool,
    saviRespondedReason: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    isSidePanelCommentDrawerOpen: (0, $hopDi$proptypes).bool.isRequired,
    consulteeLoggedIn: (0, $hopDi$proptypes).bool,
    actionTakenByPrimaryCertifier: (0, $hopDi$proptypes).bool.isRequired,
    isScrolling: (0, $hopDi$proptypes).bool,
    globalDateFormat: (0, $hopDi$proptypes).string.isRequired,
    isActionGroupExpanded: (0, $hopDi$proptypes).bool,
    activeTab: (0, $hopDi$proptypes).string,
    filteredNodeData: (0, $hopDi$proptypes).shape({}),
    isActionDrawerOutsideClick: (0, $hopDi$proptypes).bool,
    setIsActionDrawerOutsideClick: (0, $hopDi$proptypes).func
};
var $57da59531dca7c37$export$2e2bcd8739ae039 = $57da59531dca7c37$var$CertsActionButton;



/* eslint-disable indent */ 
















const $94e77a9d2fb3d728$export$e3545fad69268330 = 10;
const $94e77a9d2fb3d728$export$bcc6539c83efd6b0 = 220;
function $94e77a9d2fb3d728$var$CertsSidePanelCommentDrawer({ isSidePanelCommentDrawerOpen: isSidePanelCommentDrawerOpen, setIsSidePanelCommentDrawerOpen: setIsSidePanelCommentDrawerOpen, drawerActionKind: drawerActionKind, onSubmit: onSubmit, getTypeActEntRole: getTypeActEntRole, isRejectCommentRequired: isRejectCommentRequired, setIsSidePanelLoadingKind: setIsSidePanelLoadingKind, nodeData: nodeData, globalDateFormat: globalDateFormat, certKey: certKey, drawerActionSelected: drawerActionSelected, consulteeLoggedIn: consulteeLoggedIn, isSaviResponded: isSaviResponded, closeConsultPopover: closeConsultPopover, actionBtnRefs: actionBtnRefs, tooltipPosition: tooltipPosition, isMobileXlargeWidth: isMobileXlargeWidth, activeTab: activeTab, isActionDrawerOutsideClick: isActionDrawerOutsideClick, setIsActionDrawerOutsideClick: setIsActionDrawerOutsideClick }) {
    // Form
    const [isCritical, setIsCritical] = (0, $hopDi$useState)(false);
    const [commentValue, setCommentValue] = (0, $hopDi$useState)("");
    const [inputChanged, setInputChanged] = (0, $hopDi$useState)(false);
    const [isConsultPopoverShown, setIsConsultPopoverShown] = (0, $hopDi$useState)(false);
    // Transitions
    const [dropdownOpenHeight, setDropdownOpenHeight] = (0, $hopDi$useState)(0);
    const drawerRef = (0, $hopDi$useRef)(null);
    const contentRef = (0, $hopDi$useRef)(null);
    const { actionTakenByPrimaryCertifier: actionTakenByPrimaryCertifier, isConsulted: isConsulted } = nodeData;
    const isWorksForMe = drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME;
    const isApprove = drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE;
    const isReject = drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT;
    const isTerminated = drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE;
    const isReassignUser = drawerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME;
    const showConsultedLineItemMsg = isConsulted && !consulteeLoggedIn && !isConsultPopoverShown && drawerActionKind !== (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT && drawerActionKind !== (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE && !isSaviResponded && activeTab !== (0, $d44c789d5b60f9bf$export$807a0bc890800408);
    const showConsultedActionedInfo = !actionTakenByPrimaryCertifier && drawerActionSelected && drawerActionKind !== (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT; // && isSelected) need to check
    const isCommentNotValid = Boolean(isCritical || commentValue?.replace(/[<>]/g, "")?.trim()?.length < 3);
    const sidePanelCommentDrawerClasses = (0, $hopDi$classnames)("CertsSidePanelCommentDrawer", isSidePanelCommentDrawerOpen && "CertsSidePanelCommentDrawer--isOpen");
    // Used to get the final height of the container the set it to 0 for the transition animation to play
    (0, $hopDi$useEffect)(()=>{
        const drawerCurrent = drawerRef.current;
        const drawerContent = contentRef.current;
        if (!drawerCurrent || !drawerContent) return;
        const initialHeight = drawerCurrent.offsetHeight;
        if (isSidePanelCommentDrawerOpen) {
            setDropdownOpenHeight(initialHeight);
            drawerCurrent.style.height = "0px";
            drawerContent.style.overflowY = "hidden";
        }
        setTimeout(()=>{
            drawerContent.style.overflowY = "auto";
            drawerCurrent.style.height = "auto";
        }, $94e77a9d2fb3d728$export$bcc6539c83efd6b0);
    }, [
        isSidePanelCommentDrawerOpen
    ]);
    // Uses the dropdownOpenHeight from the initial useEffect to set the height of the container for the transition animation to play
    (0, $hopDi$useEffect)(()=>{
        const drawerCurrent = drawerRef.current;
        if (!drawerCurrent) return;
        if (dropdownOpenHeight > 0) setTimeout(()=>{
            drawerCurrent.style.height = `${dropdownOpenHeight}px`;
        }, $94e77a9d2fb3d728$export$e3545fad69268330);
        if (isSidePanelCommentDrawerOpen && dropdownOpenHeight) drawerCurrent.style.opacity = 1;
    }, [
        dropdownOpenHeight,
        isSidePanelCommentDrawerOpen
    ]);
    const toggleDrawerOpen = (0, $hopDi$useCallback)(()=>{
        if (isSidePanelCommentDrawerOpen) {
            const drawerCurrent = drawerRef.current;
            const drawerContent = contentRef.current;
            if (drawerCurrent || drawerContent) {
                const currentHeight = drawerCurrent.offsetHeight;
                drawerCurrent.style.height = `${currentHeight}px`;
                setTimeout(()=>{
                    drawerCurrent.style.height = "0px";
                    drawerContent.style.overflowY = "hidden";
                }, $94e77a9d2fb3d728$export$e3545fad69268330);
                setTimeout(()=>{
                    drawerCurrent.style.opacity = 0;
                    setIsSidePanelCommentDrawerOpen(false);
                }, $94e77a9d2fb3d728$export$bcc6539c83efd6b0);
            }
        }
    }, [
        isSidePanelCommentDrawerOpen,
        setIsSidePanelCommentDrawerOpen
    ]);
    // TODO: @Vishnu, Please add a comment for what this does
    (0, $hopDi$useEffect)(()=>{
        if (drawerActionKind && actionBtnRefs?.current[drawerActionKind]) {
            if (actionBtnRefs?.current[drawerActionKind]?.current) setIsConsultPopoverShown(actionBtnRefs?.current[drawerActionKind].current?.getIsConsultPopoverShown());
        }
    }, [
        actionBtnRefs.current[drawerActionKind],
        drawerActionKind,
        nodeData
    ]);
    // Reset form state on close
    (0, $hopDi$useEffect)(()=>{
        if (!isSidePanelCommentDrawerOpen) {
            setIsCritical(false);
            setCommentValue("");
            setInputChanged(false);
        }
        // Handle outside click for Action Drawer Ref
        if (!isActionDrawerOutsideClick && !isSidePanelCommentDrawerOpen && (isWorksForMe || isApprove || isReject || isTerminated)) setIsActionDrawerOutsideClick(true);
        // Set false for reject
        if (isActionDrawerOutsideClick && isSidePanelCommentDrawerOpen && isReject) setIsActionDrawerOutsideClick(false);
    }, [
        isSidePanelCommentDrawerOpen
    ]);
    const handleCommentSubmit = ()=>{
        if (isCommentNotValid) return setIsCritical(true);
        toggleDrawerOpen();
        setIsSidePanelLoadingKind(drawerActionKind);
        return onSubmit(commentValue);
    };
    const shouldGetDrawerCommentForm = !showConsultedActionedInfo && !drawerActionSelected && !showConsultedLineItemMsg && (isWorksForMe || isApprove || isReject && isRejectCommentRequired);
    const getDrawerContent = ()=>{
        // TODO: Transitions broken, need data to be completely loaded before the drawer actually opens
        if (showConsultedActionedInfo && drawerActionSelected) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            ref: contentRef,
            className: "CertsSidePanelCommentDrawer-content",
            children: isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $5cc4539d6b20fb8d$export$2e2bcd8739ae039), {
                isMobileXlargeWidth: isMobileXlargeWidth,
                isCommentPopoverOpen: isSidePanelCommentDrawerOpen,
                setIsCommentPopoverOpen: setIsSidePanelCommentDrawerOpen,
                placement: tooltipPosition,
                onClose: ()=>{
                    if (isSidePanelCommentDrawerOpen) setIsSidePanelCommentDrawerOpen(false);
                },
                resetAction: onSubmit,
                certKey: certKey,
                nodeData: nodeData,
                globalDateFormat: globalDateFormat
            }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $fc013bb675672a85$export$2e2bcd8739ae039), {
                isCommentPopoverOpen: isSidePanelCommentDrawerOpen,
                setIsCommentPopoverOpen: setIsSidePanelCommentDrawerOpen,
                onClose: ()=>{
                    setIsSidePanelCommentDrawerOpen(false);
                },
                resetAction: onSubmit,
                certKey: certKey,
                nodeData: nodeData,
                globalDateFormat: globalDateFormat
            })
        });
        // TODO: Transitions broken, need data to be completely loaded before the drawer actually opens
        if (showConsultedLineItemMsg && !showConsultedActionedInfo) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            ref: contentRef,
            className: "CertsSidePanelCommentDrawer-content",
            children: isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $b17240ba2f8a5623$export$2e2bcd8739ae039), {
                isMobileXlargeWidth: isMobileXlargeWidth,
                actionKind: drawerActionKind,
                isCommentPopoverOpen: isSidePanelCommentDrawerOpen,
                setIsCommentPopoverOpen: setIsSidePanelCommentDrawerOpen,
                placement: tooltipPosition,
                onSubmit: (checkBoxSelected)=>{
                    setIsSidePanelCommentDrawerOpen(false);
                    setTimeout(()=>{
                        closeConsultPopover(checkBoxSelected);
                    }, 100);
                }
            }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $aea7f6898cc7aef2$export$2e2bcd8739ae039), {
                onSubmit: (checkBoxSelected)=>{
                    setIsSidePanelCommentDrawerOpen(false);
                    setTimeout(()=>{
                        closeConsultPopover(checkBoxSelected);
                    }, 100);
                },
                setIsCommentPopoverOpen: ()=>setIsSidePanelCommentDrawerOpen(false)
            })
        });
        if (shouldGetDrawerCommentForm) {
            if (isMobileXlargeWidth) return isWorksForMe || isApprove ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $8c613cbc0666ae78$export$2e2bcd8739ae039), {
                actionKind: drawerActionKind,
                isMobileXlargeWidth: isMobileXlargeWidth,
                isCommentPopoverOpen: isWorksForMe || isApprove ? isSidePanelCommentDrawerOpen : false,
                setIsCommentPopoverOpen: drawerActionSelected ? ()=>{} : setIsSidePanelCommentDrawerOpen,
                placement: tooltipPosition,
                onSubmit: onSubmit,
                getTypeActEntRole: getTypeActEntRole
            }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $813c5abc50980873$export$2e2bcd8739ae039), {
                commentStatus: isRejectCommentRequired,
                isMobileXlargeWidth: isMobileXlargeWidth,
                handleClick: onSubmit,
                getTypeActEntRole: getTypeActEntRole,
                placement: tooltipPosition,
                isRejectPopoverOpen: isSidePanelCommentDrawerOpen,
                setIsRejectPopoverOpen: drawerActionSelected ? ()=>{} : setIsSidePanelCommentDrawerOpen
            });
            return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                ref: contentRef,
                className: "CertsSidePanelCommentDrawer-content",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "CertsSidePanelCommentDrawer-header",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CertsSidePanelCommentDrawer-title",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "HelpFilled",
                                        className: "CertsSidePanelCommentDrawer-headerIcon"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                                        kind: "label",
                                        desktop: "h3-d",
                                        mobile: "h1-m",
                                        children: [
                                            isReject ? (0, $20281fe09bc700a8$export$170ce1a49c989948).TITLE : "Approve this",
                                            ` ${getTypeActEntRole}?`
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                size: "small",
                                kind: "ghost",
                                tabIndex: -1,
                                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "Close"
                                }),
                                onClick: toggleDrawerOpen
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "CertsSidePanelCommentDrawer-commentAndBtns",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $0d23168c4a68b98d$export$2e2bcd8739ae039), {
                                actionKey: drawerActionKind,
                                inputChanged: inputChanged,
                                setInputChanged: setInputChanged,
                                isCritical: isCritical,
                                setIsCritical: setIsCritical,
                                commentValue: commentValue,
                                setCommentValue: setCommentValue
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                tag: "div",
                                className: "CertsSidePanelCommentDrawer-controls",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: "ghost",
                                        onClick: toggleDrawerOpen,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: !isCommentNotValid ? "filled" : "outlined",
                                        onClick: ()=>handleCommentSubmit(),
                                        children: (0, $3cd234bd4f1cf26a$export$3edeae7c90cf2ca0)(drawerActionKind)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
        if (isReassignUser) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            ref: contentRef,
            className: "CertsSidePanelCommentDrawer-content",
            children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                className: "CertsSidePanelCommentDrawer-contentAndBtns",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelCommentDrawer-reassignCloseBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                            size: "small",
                            kind: "ghost",
                            tabIndex: -1,
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "Close"
                            }),
                            onClick: toggleDrawerOpen
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        mobile: "body2-d",
                        className: "CertsSidePanelCommentDrawer-reassignText",
                        children: "By reassigning this user, their associated items will be included. Any approvals or rejections will be cleared upon reassignment."
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "CertsSidePanelCommentDrawer-controls",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "ghost",
                                onClick: toggleDrawerOpen,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "filled",
                                onClick: ()=>{
                                    actionBtnRefs?.current[drawerActionKind].current?.handleReassignUserPopover();
                                    setIsSidePanelCommentDrawerOpen(false);
                                },
                                children: "Got it"
                            })
                        ]
                    })
                ]
            })
        });
        return null;
    };
    if (!isSidePanelCommentDrawerOpen) return null;
    const drawerContent = getDrawerContent();
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        ref: drawerRef,
        className: sidePanelCommentDrawerClasses,
        children: drawerContent
    });
}
$94e77a9d2fb3d728$var$CertsSidePanelCommentDrawer.propTypes = {
    isSidePanelCommentDrawerOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsSidePanelCommentDrawerOpen: (0, $hopDi$proptypes).func.isRequired,
    drawerActionKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$3f43cf8434698562))),
    onSubmit: (0, $hopDi$proptypes).func.isRequired,
    getTypeActEntRole: (0, $hopDi$proptypes).string.isRequired,
    isRejectCommentRequired: (0, $hopDi$proptypes).bool.isRequired,
    setIsSidePanelLoadingKind: (0, $hopDi$proptypes).func,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    certKey: (0, $hopDi$proptypes).string.isRequired,
    isSaviResponded: (0, $hopDi$proptypes).bool.isRequired,
    globalDateFormat: (0, $hopDi$proptypes).string.isRequired,
    drawerActionSelected: (0, $hopDi$proptypes).bool.isRequired,
    consulteeLoggedIn: (0, $hopDi$proptypes).bool.isRequired,
    closeConsultPopover: (0, $hopDi$proptypes).func.isRequired,
    actionBtnRefs: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({
        current: (0, $hopDi$proptypes).shape({})
    })).isRequired,
    tooltipPosition: (0, $hopDi$proptypes).string.isRequired,
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool.isRequired,
    activeTab: (0, $hopDi$proptypes).string,
    isActionDrawerOutsideClick: (0, $hopDi$proptypes).bool.isRequired,
    setIsActionDrawerOutsideClick: (0, $hopDi$proptypes).func.isRequired
};
$94e77a9d2fb3d728$var$CertsSidePanelCommentDrawer.defaultProps = {
    drawerActionKind: null,
    setIsSidePanelLoadingKind: ()=>{},
    activeTab: (0, $d44c789d5b60f9bf$export$807a0bc890800408)
};
var $94e77a9d2fb3d728$export$2e2bcd8739ae039 = $94e77a9d2fb3d728$var$CertsSidePanelCommentDrawer;



const $d1a53ac20dd201ee$var$actionNames = [
    "approve",
    "reject",
    "terminated",
    "reassign",
    "consult",
    "worksForMe",
    "doesNotWorksForMe",
    "extendEndDate",
    "conditionalCertifiy"
];
const $d1a53ac20dd201ee$var$extractActionStates = (nodeData, actionName)=>{
    const action = nodeData?.tracker?.actions?.[actionName];
    return {
        isSelected: action?.isSelected || null,
        isLoading: action?.isLoading || null,
        isDisabled: action?.isDisabled || null
    };
};
const $d1a53ac20dd201ee$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
const $d1a53ac20dd201ee$var$getActionStates = (nodeData)=>$d1a53ac20dd201ee$var$actionNames.reduce((acc, actionName)=>{
        const { isSelected: isSelected, isLoading: isLoading, isDisabled: isDisabled } = $d1a53ac20dd201ee$var$extractActionStates(nodeData, actionName);
        acc[`is${$d1a53ac20dd201ee$var$capitalize(actionName)}`] = isSelected;
        acc[`is${$d1a53ac20dd201ee$var$capitalize(actionName)}Loading`] = isLoading;
        acc[`is${$d1a53ac20dd201ee$var$capitalize(actionName)}Disabled`] = isDisabled;
        return acc;
    }, {});
var $d1a53ac20dd201ee$export$2e2bcd8739ae039 = $d1a53ac20dd201ee$var$getActionStates;



/* eslint-disable indent */ const $878df4c3ccf5afc4$export$9d3a58655199f101 = (prev, actionKind, status, trackerId)=>prev.map((item)=>{
        const actions = item.tracker?.actions || {};
        const currentAction = actions[actionKind] || {};
        return {
            ...item,
            tracker: {
                ...item.tracker,
                actions: {
                    ...actions,
                    [actionKind]: {
                        isLoading: false,
                        isSelected: item.tracker.id === trackerId ? status : currentAction.isSelected
                    }
                }
            },
            children: item.children?.length > 0 ? $878df4c3ccf5afc4$export$9d3a58655199f101(item.children, actionKind, status, trackerId) : []
        };
    });
const $878df4c3ccf5afc4$export$31db7a6341ffeb48 = (prev, actionKind, status, trackerId)=>prev.map((item)=>{
        const actions = item.tracker?.actions || {};
        const currentAction = actions[actionKind] || {};
        return {
            ...item,
            tracker: {
                ...item.tracker,
                actions: {
                    ...actions,
                    [actionKind]: {
                        ...currentAction,
                        isLoading: item.tracker.id === trackerId ? status : currentAction.isLoading
                    }
                }
            },
            children: item.children?.length > 0 ? $878df4c3ccf5afc4$export$31db7a6341ffeb48(item.children, actionKind, status, trackerId) : []
        };
    });
const $878df4c3ccf5afc4$export$e6d17c4e9ad617e5 = (nodeData, setMergedLists)=>{
    const setApprovalFalse = (node)=>{
        // Check if the current node matches the tracker id
        if (node.tracker && node.tracker.id === nodeData.tracker.id) {
            // Apply changes to all descendants
            const updateDescendants = (currentNode)=>({
                    ...currentNode,
                    tracker: currentNode.tracker && currentNode.tracker.actions ? {
                        ...currentNode.tracker,
                        actions: {
                            ...currentNode.tracker.actions,
                            approve: {
                                ...currentNode.tracker.actions.approve,
                                isSelected: false
                            }
                        }
                    } : currentNode.tracker,
                    children: currentNode.children ? currentNode.children.map(updateDescendants) : []
                });
            // Start updating from the children
            if (node.children && node.children.length > 0) return {
                ...node,
                children: node.children.map(updateDescendants)
            };
        } else if (node.children && node.children.length > 0) // If not a match, continue to recursively check its children
        return {
            ...node,
            children: node.children.map(setApprovalFalse)
        };
        // Return the node unchanged if no conditions are met
        return node;
    };
    // Update the list using the function
    setMergedLists((prev)=>prev.map((rootNode)=>setApprovalFalse(rootNode)));
};
const $878df4c3ccf5afc4$export$808adcb2ea9678fa = (prev, actionKind, status, trackerId)=>prev.map((item)=>{
        const actions = item.tracker?.actions || {};
        const currentAction = actions[actionKind] || {};
        return {
            ...item,
            tracker: {
                ...item.tracker,
                actions: {
                    ...actions,
                    [actionKind]: {
                        ...currentAction,
                        isDisabled: item.tracker.id === trackerId ? status : currentAction.isDisabled
                    }
                }
            },
            children: item.children?.length > 0 ? $878df4c3ccf5afc4$export$31db7a6341ffeb48(item.children, actionKind, status, trackerId) : []
        };
    });
const $878df4c3ccf5afc4$export$2cfbea6ef2b75009 = (nodeData)=>{
    let toolTip = "Consult with Peers";
    if (nodeData?.isConsulted) {
        if (nodeData?.CONSULTED_USERCOUNT === 1) toolTip = `Consultations pending with ${nodeData?.CONSULTED_USERNAME}`;
        else if (nodeData?.CONSULTED_USERCOUNT > 1) toolTip = `Consultations pending with ${nodeData?.CONSULTED_USERCOUNT || 1} peers`;
    }
    return toolTip;
};



const $f7cd7b23cff7a54f$var$TOOLTIP_DELAY_IN_MS_TILE = 1000;
const $f7cd7b23cff7a54f$var$TOOLTIP_DELAY_IN_MS_SIDEPANEL = 0;
const $f7cd7b23cff7a54f$var$prioritizeButtons = [
    (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME,
    (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE,
    (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME,
    (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT
];
const $f7cd7b23cff7a54f$var$actionPriority = [
    (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT,
    (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE,
    (0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY,
    (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN,
    (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE
];
function $f7cd7b23cff7a54f$var$CertsActionButtonsGroup({ kind: kind, nodeData: nodeData, filteredNodeData: filteredNodeData, actionsData: actionsData, handleAutoSelectParent: handleAutoSelectParent, isGroupDisabled: isGroupDisabled, groupTooltipText: groupTooltipText, isActionGroupExpanded: isActionGroupExpanded, setIsActionGroupExpanded: setIsActionGroupExpanded, setActionPopoverOpenId: setActionPopoverOpenId, setMergedLists: setMergedLists, isSaviResponded: isSaviResponded, saviRespondedReason: saviRespondedReason, isScrolling: isScrolling, getTileCheckIcon: getTileCheckIcon, titleValue: titleValue, getTileKindHeading: getTileKindHeading, handleTileClick: handleTileClick, bulkSelectInfoForDrawer: bulkSelectInfoForDrawer, dataTestId: dataTestId }) {
    // Side panel action comments
    const [isSidePanelCommentDrawerOpen, setIsSidePanelCommentDrawerOpen] = (0, $hopDi$useState)(false);
    const [drawerActionKind, setDrawerActionKind] = (0, $hopDi$useState)(null);
    const [isSidePanelLoadingKind, setIsSidePanelLoadingKind] = (0, $hopDi$useState)("");
    const [drawerActionSelected, setDrawerActionSelected] = (0, $hopDi$useState)(false);
    const [orderedButtons, setOrderedButtons] = (0, $hopDi$useState)([]);
    const [isTileActionDrawerOpen, setIsTileActionDrawerOpen] = (0, $hopDi$useState)(false);
    const [isActionDrawerOutsideClick, setIsActionDrawerOutsideClick] = (0, $hopDi$useState)(true);
    const expandedHoverTimerRef = (0, $hopDi$useRef)(null);
    const kabobRef = (0, $hopDi$useRef)(null);
    const actionBtnRefs = (0, $hopDi$useRef)([]);
    const dispatch = (0, $hopDi$useDispatch)();
    const initializeRefs = (action)=>{
        actionBtnRefs.current[action] = /*#__PURE__*/ (0, $hopDi$react).createRef();
    };
    // fetching redux store values for action items
    const { mediaQueryValue: mediaQueryValue, isTouchEnabled: isTouchEnabled, certKey: certKey, enableComments: enableComments, configMap: getViewApiConfigmap, globalDateFormat: globalDateFormat, reassignConfigMap: reassignConfigMap, action: { isAtLeastThreeActions: isAtLeastThreeActions, isActionSuccess: isActionSuccess, isActionLoading: isActionLoading, isActionError: isActionError, errorMessage: isActionErrorMessage }, isSidePanelVisible: isSidePanelVisible, certificationStartDate: certificationStartDate, progressBreakdowndetails: progressBreakdowndetails, tabs: tabs, isPopoverUserReassignMsgShown: isPopoverUserReassignMsgShown, objectForRedirectLink: objectForRedirectLink } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { tabData: tabData } = tabs;
    const { users: enableCommentsUsers, accEntRole: enableCommentsAccEntRole } = enableComments;
    const { byDecisionDetails: byDecisionDetails } = progressBreakdowndetails;
    const getFirstTimeReject = !(byDecisionDetails?.Summary && byDecisionDetails?.Summary?.Rejected);
    const activeTab = tabData?.find((tab)=>tab?.isActive);
    const isDetailsGroup = kind === (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE;
    const isFooterGroup = kind === (0, $20281fe09bc700a8$export$758743ec42a300f1).FOOTER;
    const nodeDataForGroup = actionsData || nodeData;
    // fetching each line item values from /items api
    const accountKey = nodeData?.CERT_ACCOUNTKEY;
    const userKey = nodeData?.CERT_USERKEY;
    const entValueKey = nodeData?.CERT_ENTITLEMENT_VALUEKEY;
    const roleKey = nodeData?.CERT_ROLEKEY;
    const trackerId = nodeData?.tracker?.id;
    const actionTakenByPrimaryCertifier = nodeData?.actionTakenByPrimaryCertifier;
    const actionButtonsMap = nodeData?.availableAction && Object.keys(nodeData?.availableAction);
    const disableButtonsMap = nodeDataForGroup?.enableAction;
    const mobileXLargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXLargeQuery.value <= mediaQueryValue;
    const MIN_BUTTONS_FOR_KABOB = isMobileXlargeWidth && !isFooterGroup ? 2 : 3;
    const getOrderedButtons = ()=>{
        const selectedActions = [];
        if (nodeDataForGroup?.tracker?.actions?.consult?.isSelected) selectedActions.push((0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT);
        if (nodeDataForGroup?.tracker?.actions?.extendEndDate?.isSelected) selectedActions.push((0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE);
        if (nodeDataForGroup?.tracker?.actions?.conditionalCertifiy?.isSelected) selectedActions.push((0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY);
        if (nodeDataForGroup?.tracker?.actions?.reassign?.isSelected) selectedActions.push((0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN);
        if (nodeDataForGroup?.tracker?.actions?.terminated?.isSelected) selectedActions.push((0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE);
        const orderedSelectedActions = $f7cd7b23cff7a54f$var$actionPriority.filter((key)=>selectedActions.includes(key));
        const prioritizedButtons = $f7cd7b23cff7a54f$var$prioritizeButtons.filter((key)=>actionButtonsMap.includes(key));
        // Combine prioritized with selected
        const selectedAndPrioritized = [
            ...prioritizedButtons,
            ...orderedSelectedActions
        ];
        const remainingButtons = actionButtonsMap.filter((key)=>!selectedAndPrioritized.includes(key));
        return [
            ...selectedAndPrioritized,
            ...remainingButtons
        ];
    };
    (0, $hopDi$useEffect)(()=>{
        setOrderedButtons(getOrderedButtons());
    }, [
        nodeDataForGroup
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (orderedButtons?.length > 0) orderedButtons.forEach((ele)=>{
            initializeRefs(ele);
        });
    }, [
        orderedButtons
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isTileActionDrawerOpen && !isMobileXlargeWidth) setIsTileActionDrawerOpen(false);
    }, [
        isMobileXlargeWidth
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (!isActionLoading) setIsSidePanelLoadingKind("");
    }, [
        isActionLoading
    ]);
    const getTypeActEntRole = ()=>{
        if (entValueKey === (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE;
        if (entValueKey === (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT;
        if (entValueKey === (0, $bae22e791544392c$export$994f7af6d0b36256).USER) return (0, $bae22e791544392c$export$6b1c20b2e2de9059).USER;
        return (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT;
    };
    // Destructure Action States using helper function
    const { isApprove: isApprove, isApproveDisabled: isApproveDisabled, isApproveLoading: isApproveLoading, isReassign: isReassign, isReassignDisabled: isReassignDisabled, isReassignLoading: isReassignLoading, isConsult: isConsult, isConsultLoading: isConsultLoading, isConsultDisabled: isConsultDisabled, isWorksForMe: isWorksForMe, isWorksForMeLoading: isWorksForMeLoading, isWorksForMeDisabled: isWorksForMeDisabled, isReject: isReject, isRejectDisabled: isRejectDisabled, isRejectLoading: isRejectLoading, isTerminated: isTerminated, isTerminatedDisabled: isTerminatedDisabled, isTerminatedLoading: isTerminatedLoading, isDoesNotWorksForMe: isDoesNotWorksForMe, isDoesNotWorksForMeLoading: isDoesNotWorksForMeLoading, isDoesNotWorksForMeDisabled: isDoesNotWorksForMeDisabled, isExtendEndDate: isExtendEndDate, isExtendEndDateLoading: isExtendEndDateLoading, isExtendEndDateDisabled: isExtendEndDateDisabled, isConditionalCertifiy: isConditionalCertifiy, isConditionalCertifiyLoading: isConditionalCertifiyLoading, isConditionalCertifiyDisabled: isConditionalCertifiyDisabled } = (0, $d1a53ac20dd201ee$export$2e2bcd8739ae039)(nodeDataForGroup);
    // Use these to set the tracker state of your actions
    const setIsActionLoading = (actionKind, isLoading)=>setMergedLists((prev)=>(0, $878df4c3ccf5afc4$export$31db7a6341ffeb48)(prev, actionKind, isLoading, trackerId));
    const setIsActionSelected = (actionKind, isSelected)=>{
        setMergedLists((prev)=>(0, $878df4c3ccf5afc4$export$9d3a58655199f101)(prev, actionKind, isSelected, trackerId));
    };
    const dispatchActionHandler = (actionKind, status, dispatchFunc, payload)=>{
        // Set Loading onClick
        setIsActionLoading(actionKind, true);
        setIsSidePanelLoadingKind(actionKind);
        setIsSidePanelCommentDrawerOpen(false);
        const currentState = !(status === null || status === undefined || status === false);
        dispatch(dispatchFunc(payload, actionKind)).then((response)=>{
            // Close Kabob on success
            if (isTileActionDrawerOpen) setIsTileActionDrawerOpen(false);
            // reset tab highlight
            dispatch((0, $d623f23401a154f0$export$4fcead6ba6a8c371)(null));
            if (response.isSuccess) {
                let tabToHighLight = "";
                if ((activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) || activeTab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053)) && !currentState) tabToHighLight = (0, $d44c789d5b60f9bf$export$807a0bc890800408);
                // TODO: @Jacob, @Sagar, This is not entirely correct. Consult options and done are being mis managed. We need to update Action button isConsulted to fix.
                if (activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && currentState) tabToHighLight = nodeData?.isConsulted ? (0, $d44c789d5b60f9bf$export$b2766b46106d3053) : (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49);
                if ((activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) || activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49)) && actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT) tabToHighLight = (0, $d44c789d5b60f9bf$export$b2766b46106d3053);
                const flags = {
                    shouldSwitchSidePanel: false,
                    jumpToSameLevel: true
                };
                if (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN) {
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) && !currentState || activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && currentState) flags.shouldSwitchSidePanel = true;
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && currentState) {
                        flags.shouldSwitchSidePanel = false;
                        flags.jumpToSameLevel = false;
                    }
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && !currentState) {
                        flags.shouldSwitchSidePanel = true;
                        flags.jumpToSameLevel = false;
                    }
                } else {
                    // START: Enter logic based on action here @padmavathi, @vishnu, @shaurabh, @jacob
                    if (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY) {
                        if ((activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) || activeTab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053)) && !currentState || activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && currentState) {
                            flags.shouldSwitchSidePanel = true;
                            // when consult account and inclued associate items
                            if (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT && payload?.cert_entitlement_valuekey === (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT && !payload?.reassignAssociated) flags.jumpToSameLevel = false;
                        }
                    }
                    // Logic for transitions for respective actions in respective tabs
                    // Approve actions
                    if (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE) {
                        // For Account - in side panel
                        if (nodeData?.CERT_ENTITLEMENT_VALUEKEY === "0") {
                            // todo tab
                            if ((activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) || activeTab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053)) && !currentState) {
                                // Should switch to next level - YES
                                flags.shouldSwitchSidePanel = true;
                                // Jump to same level - NO
                                flags.jumpToSameLevel = false;
                            }
                            // done tab
                            if (activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && currentState) {
                                // jump to same level - TDB
                                flags.shouldSwitchSidePanel = true;
                                flags.jumpToSameLevel = false;
                            }
                            // all tab
                            if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && currentState) // Should switch to next level - YES
                            flags.shouldSwitchSidePanel = true;
                        } else {
                            // For Role and Entitlements - side panels
                            // todo tab
                            if ((activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) || activeTab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053)) && !currentState) {
                                // Should switch to next level - YES
                                flags.shouldSwitchSidePanel = true;
                                // jump to same level
                                flags.jumpToSameLevel = true;
                            }
                            // done tab
                            if (activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && currentState) {
                                // only reset case
                                // jump to same level
                                flags.shouldSwitchSidePanel = true;
                                flags.jumpToSameLevel = false;
                            }
                            // all tab
                            if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && currentState) // Should switch to next level - YES
                            flags.shouldSwitchSidePanel = true;
                        }
                    }
                    // Works for me
                    if (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE) {
                        // todo tab
                        if ((activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) || activeTab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053)) && !currentState) {
                            // Should switch to next level - YES
                            flags.shouldSwitchSidePanel = true;
                            // jump to same level - NO
                            flags.jumpToSameLevel = false;
                        }
                        // done tab
                        if (activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && !currentState) {
                            // jump to same level - TDB
                            flags.shouldSwitchSidePanel = true;
                            flags.jumpToSameLevel = true;
                        }
                        // RESET in done tab for approve user
                        if (activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && status) // jump to next side panel in open state
                        flags.shouldSwitchSidePanel = true;
                        // all tab
                        if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && currentState) // Should switch to next level - YES
                        flags.shouldSwitchSidePanel = true;
                    }
                    // END: Enter logic based on action here @padmavathi, @vishnu, @shaurabh, @jacob
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && currentState) {
                        flags.shouldSwitchSidePanel = false;
                        flags.jumpToSameLevel = false;
                    }
                    if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && !currentState) {
                        flags.shouldSwitchSidePanel = true;
                        flags.jumpToSameLevel = false;
                    }
                }
                let shouldHighLightTab = false;
                // Tab highlight should be done after the animation (This should ideally be in finally block)
                if (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN) // don't highlight done tab ,  reassign record to another user highlight not required
                // when assignee is not selected and userlevel skip certifier is selected don't show done tab highlight
                {
                    if (!payload?.assignee || payload.status === (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED || payload.status === "0") shouldHighLightTab = true;
                } else shouldHighLightTab = true;
                if (activeTab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615) && (actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE || actionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME)) {
                    flags.shouldSwitchSidePanel = false;
                    flags.jumpToSameLevel = true;
                }
                // TODO: New function to handle auto Refresh list, Do not delete this comment
                handleAutoSelectParent(// referenceObject
                {
                    trackerId: nodeData?.tracker?.id,
                    trackerLevel: nodeData?.tracker?.level,
                    actionKind: actionKind,
                    currentState: currentState,
                    flags: flags
                }, // nonReferenceObject
                {
                    alertBannerPayload: response?.alertBannerPayload,
                    tabToHighLightPayload: {
                        shouldHighLightTab: shouldHighLightTab,
                        tabToHighLight: tabToHighLight
                    }
                });
            // if (!flags.jumpToSameLevel) {
            //   flags.shouldSwitchSidePanel = false; // MSG: true or false based on your requirements
            // }
            }
            if (isFooterGroup) setIsActionSelected(actionKind, !currentState);
        }).catch(()=>{
            setIsActionLoading(actionKind, false);
            setIsSidePanelLoadingKind("");
            setIsActionSelected(actionKind, currentState);
        });
    };
    const actionButtonWrapperClasses = (0, $hopDi$classnames)("CertsActionButtonsGroup-wrapper", isActionGroupExpanded && "CertsActionButtonsGroup-wrapper--isExpanded");
    const actionButtonGroupClasses = (0, $hopDi$classnames)("CertsActionButtonsGroup", actionButtonsMap?.length && `CertsActionButtonsGroup--length${actionButtonsMap.length}`, isAtLeastThreeActions && "CertsActionButtonsGroup--isAtLeastThreeActions");
    const getKindClasses = (isDrawerActions)=>(0, $hopDi$classnames)(isDetailsGroup && !isDrawerActions && "CertsActionButtonsGroup-actionsOnly", isFooterGroup && "CertsActionButtonsGroup-sidePanelFooter");
    // Reset drawerActionKind
    (0, $hopDi$useEffect)(()=>{
        if (!isSidePanelCommentDrawerOpen) setDrawerActionKind(null);
    }, [
        isSidePanelCommentDrawerOpen
    ]);
    // Functions completed
    const handleApprove = (commentValue, isModalDrawerVersion = false)=>{
        setIsActionDrawerOutsideClick(true);
        if (isModalDrawerVersion) setIsSidePanelCommentDrawerOpen(false);
        const isCommentRequired = enableCommentsAccEntRole?.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).APPROVE);
        const approvePayload = {
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            accountKey: nodeData?.CERT_ACCOUNTKEY,
            status: isApprove ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).APPROVE,
            certRoleKey: nodeData?.CERT_ROLEKEY
        };
        if (commentValue && commentValue.length > 0) {
            if (!isApprove) approvePayload.comment = commentValue;
        }
        if (isApprove) approvePayload.comment = "Action Canceled";
        const dispatchApprove = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE, isApprove, (0, $d623f23401a154f0$export$70cd670b72ffe020), approvePayload);
        setActionPopoverOpenId(false);
        // Tile on click
        if (isDetailsGroup) dispatchApprove();
        // Footer on click
        if (isFooterGroup) {
            if (!isApprove && isCommentRequired) {
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE);
                if (!isModalDrawerVersion) setIsSidePanelCommentDrawerOpen(true);
            }
            if (commentValue?.length >= 3) {
                setIsSidePanelCommentDrawerOpen(false);
                dispatchApprove();
            }
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isApprove) dispatchApprove();
        }
    };
    // Handling Works For Me api dispatch actions
    const handleWorksForMe = (commentValue)=>{
        setIsActionDrawerOutsideClick(true);
        const isCommentRequired = enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).WORKS_FOR_ME);
        const approveUserPayload = {
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            status: isWorksForMe ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).WORKS_FOR_ME
        };
        if (commentValue && commentValue.length > 0) {
            if (!isWorksForMe) approveUserPayload.comment = commentValue;
        }
        if (isWorksForMe) approveUserPayload.comment = "Action Cancelled";
        const dispatchWorksForMe = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME, isWorksForMe, (0, $d623f23401a154f0$export$e77519515695c9c7), approveUserPayload);
        // Tile on click
        if (isDetailsGroup) dispatchWorksForMe();
        // Footer on click
        if (isFooterGroup) {
            if (!isWorksForMe && isCommentRequired) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME);
            }
            if (commentValue?.length >= 3) dispatchWorksForMe();
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isWorksForMe) dispatchWorksForMe();
        }
    };
    // Handling Terminate api dispatch actions
    const handleTerminate = (commentValue)=>{
        setIsActionDrawerOutsideClick(true);
        const isCommentRequired = enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).TERMINATED);
        const payload = {
            certKey: certKey,
            userKey: userKey,
            status: isTerminated ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).TERMINATED
        };
        if (commentValue && commentValue.length > 0) {
            if (!isTerminated) payload.comments = commentValue;
        }
        if (isTerminated) payload.comments = "Action Cancelled";
        const dispatchTerminate = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE, isTerminated, (0, $d623f23401a154f0$export$348853d7c8cab35b), payload);
        // Tile on click
        if (isDetailsGroup) dispatchTerminate();
        // Footer on click
        if (isFooterGroup) {
            if (!isTerminated) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE);
            }
            if (commentValue?.length >= 3) {
                dispatchTerminate();
                return;
            }
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isTerminated) dispatchTerminate();
        }
    };
    // Handling Change End Date api dispatch actions for User
    const handleExtendEndDate = (getDate, commentValue)=>{
        setIsActionDrawerOutsideClick(true);
        const isCommentRequired = enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).EXTEND_END_DATE);
        let currentDate = new Date();
        const dd = currentDate.getDate();
        const mm = currentDate.getMonth() + 1;
        const yyyy = currentDate.getFullYear();
        currentDate = `${mm < 10 ? `0${mm}` : mm}-${dd < 10 ? `0${dd}` : dd}-${yyyy}`;
        const payload = {
            certKey: certKey,
            userKey: userKey,
            status: (0, $20281fe09bc700a8$export$6bf521f24032eb49).WORKS_FOR_ME,
            extendedEndDate: getDate && getDate.length > 0 ? getDate : currentDate
        };
        if (commentValue && commentValue.length > 0) payload.comments = commentValue;
        const dispatchExtendEndDate = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE, isExtendEndDate, (0, $d623f23401a154f0$export$9f62cbf6b3b94af9), payload);
        // Tile on click
        if (isDetailsGroup) dispatchExtendEndDate();
        // Footer on click
        if (isFooterGroup) {
            if (!isExtendEndDate) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE);
            }
            if (commentValue?.length >= 3) {
                dispatchExtendEndDate();
                return;
            }
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isExtendEndDate) dispatchExtendEndDate();
        }
    };
    // Handling Reject Action api dispatch actions
    const handleRejectAction = (commentValue)=>{
        setIsActionDrawerOutsideClick(true);
        const isCommentRequired = enableCommentsAccEntRole?.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).REJECT);
        let payload;
        if (entValueKey === (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE) {
            payload = {
                eid: nodeData.id,
                certKey: certKey,
                userKey: userKey,
                entValueKey: entValueKey,
                certRoleKey: nodeData?.CERT_ROLEKEY,
                status: isReject ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED
            };
            // for application role user and account auto approve - send account key as well in payload
            if (nodeData?.Role_ROLETYPE === (0, $e7683d2bb9b3b8c9$export$7f85b66a0bcac447).APPLICATION_ROLE) payload.accountKey = accountKey;
        } else payload = {
            eid: nodeData.id,
            accountKey: accountKey,
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            status: isReject ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED
        };
        if (commentValue && commentValue.length > 0) {
            if (!isReject) payload.comments = commentValue;
        }
        if (isReject) payload.comments = "Action Cancelled";
        const dispatchReject = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT, isReject, (0, $d623f23401a154f0$export$8a3b1d82a4510306), payload);
        // Tile on click
        if (isDetailsGroup) dispatchReject();
        // Footer on click
        if (isFooterGroup) {
            if (!isReject) {
                setIsSidePanelCommentDrawerOpen(true);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT);
                setDrawerActionSelected(isReject);
            }
            if (commentValue?.length >= 3) {
                dispatchReject();
                return;
            }
            // Reset in footer
            if (!isCommentRequired || isCommentRequired && isReject) dispatchReject();
        }
    };
    // Placeholder  Funcitons Below
    const handleReassign = async (reassignPayload)=>{
        setIsActionDrawerOutsideClick(true);
        const verifyPayload = {
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            accountKey: accountKey,
            roleKey: roleKey
        };
        const payload = {
            certkey: certKey,
            cert_userkey: nodeData.CERT_USERKEY,
            cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
            requestOrigin: "UI"
        };
        const getNameByType = ()=>{
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT) return nodeData?.Account_DISPLAYNAME;
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE) return nodeData?.Role_DISPLAYNAME;
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT) return nodeData?.Ent_DISPLAYNAME;
            return null;
        };
        const currentChildObject = {
            type: getTypeActEntRole().toLowerCase(),
            childname: getNameByType()
        };
        try {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
                payload: kind
            });
            const response = await (0, $d623f23401a154f0$export$a0116b9e1a4bda07)(dispatch, verifyPayload, currentChildObject);
            const { proceed: proceed } = response;
            if (Object.hasOwnProperty.call(response, "proceed") && !proceed) {
                // Logger.log("Approve user and entitlement")
                /* Start --- Approve parent  */ const approvePayload = {
                    certKey: certKey,
                    userKey: userKey,
                    entValueKey: entValueKey,
                    accountKey: nodeData?.CERT_ACCOUNTKEY,
                    status: isApprove ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).APPROVE,
                    certRoleKey: nodeData?.CERT_ROLEKEY
                };
                if (reassignPayload?.commentValue) approvePayload.comment = reassignPayload?.commentValue;
                switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
                    case (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT:
                        delete approvePayload?.accountKey;
                        delete approvePayload?.certRoleKey;
                        approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).USER; // value = -4
                        break;
                    case (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE:
                        if (nodeData?.Role_ROLETYPE === (0, $e7683d2bb9b3b8c9$export$7f85b66a0bcac447)?.APPLICATION_ROLE) {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT; // value 0
                            approvePayload.certRoleKey = null;
                        } else {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).USER; // value = -4
                            delete approvePayload?.certRoleKey;
                        }
                        break;
                    default:
                        if ((0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT; // value 0
                            approvePayload.certRoleKey = null;
                        }
                        break;
                }
                dispatch((0, $d623f23401a154f0$export$70cd670b72ffe020)(approvePayload));
            /* End --- Approve parent  */ }
        } catch (error) {
            (0, $hopDi$Logger).log("Error handling API call:", error.message);
        }
        if (reassignPayload?.commentValue) payload.comments = reassignPayload?.commentValue;
        if (reassignPayload?.selectedUser && !reassignPayload?.isSkipCertifierChecked) payload.assignee = reassignPayload?.selectedUser?.value;
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT:
                payload.cert_rolekey = nodeData.CERT_ROLEKEY;
                // by default pass isIncludeAssociateChecked value as true
                payload.reassignAssociated = "true";
                // reassignPayload.isIncludeAssociateChecked.toString(); remove code after beta release
                if (nodeData.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE:
                payload.cert_rolekey = nodeData.CERT_ROLEKEY;
                if (reassignPayload?.isIncludeAssociateChecked) payload.reassignAssociated = reassignPayload.isIncludeAssociateChecked.toString();
                if (nodeData.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                if ((0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                    if (reassignPayload?.isIncludeAssociateChecked) payload.reassignAssociated = reassignPayload.isIncludeAssociateChecked.toString();
                }
                if (nodeData.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
        }
        const dispatchReassign = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN, isReassign, isReassign ? (0, $d623f23401a154f0$export$627e0e03ed6c2927) : (0, $d623f23401a154f0$export$29d12c975855399), payload);
        // Tile on click
        if (isDetailsGroup) dispatchReassign();
        // Footer on click
        if (isFooterGroup) {
            setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
            setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN);
            dispatchReassign();
        }
    };
    // Handling Change End Date api dispatch actions for Account,Entitlement and Role
    const handleConditionalCertifiy = async (getDate, comment)=>{
        setIsActionDrawerOutsideClick(true);
        const verifyPayload = {
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            accountKey: accountKey,
            roleKey: roleKey
        };
        const getNameByType = ()=>{
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT) return nodeData?.Account_DISPLAYNAME;
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE) return nodeData?.Role_DISPLAYNAME;
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT) return nodeData?.Ent_DISPLAYNAME;
            return null;
        };
        const currentChildObject = {
            type: getTypeActEntRole().toLowerCase(),
            childname: getNameByType()
        };
        let commentValue = "Extend end date again";
        if (comment && comment.length > 0) commentValue = comment;
        else if (isConditionalCertifiy) commentValue = "Action Canceled";
        let currentDate = new Date();
        const dd = currentDate.getDate();
        const mm = currentDate.getMonth() + 1;
        const yyyy = currentDate.getFullYear();
        currentDate = `${mm < 10 ? `0${mm}` : mm}-${dd < 10 ? `0${dd}` : dd}-${yyyy}`;
        if (nodeData.CERT_ENTITLEMENT_VALUEKEY !== (0, $bae22e791544392c$export$994f7af6d0b36256).USER && !isConditionalCertifiy) try {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
                payload: kind
            });
            const response = await (0, $d623f23401a154f0$export$a0116b9e1a4bda07)(dispatch, verifyPayload, currentChildObject);
            const { proceed: proceed } = response;
            if (Object.hasOwnProperty.call(response, "proceed") && !proceed) {
                // Logger.log("Approve user and entitlement")
                /* Start --- Approve parent  */ const approvePayload = {
                    certKey: certKey,
                    userKey: userKey,
                    entValueKey: entValueKey,
                    accountKey: nodeData?.CERT_ACCOUNTKEY,
                    status: isApprove ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).APPROVE,
                    certRoleKey: nodeData?.CERT_ROLEKEY
                };
                if (comment) approvePayload.comment = comment;
                switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
                    case (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT:
                        delete approvePayload?.accountKey;
                        delete approvePayload?.certRoleKey;
                        approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).USER; // value = -4
                        break;
                    case (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE:
                        if (nodeData?.Role_ROLETYPE === (0, $e7683d2bb9b3b8c9$export$7f85b66a0bcac447)?.APPLICATION_ROLE) {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT; // value 0
                            approvePayload.certRoleKey = null;
                        } else {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).USER; // value = -4
                            delete approvePayload?.certRoleKey;
                        }
                        break;
                    default:
                        if ((0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT; // value 0
                            approvePayload.certRoleKey = null;
                        }
                        break;
                }
                dispatch((0, $d623f23401a154f0$export$70cd670b72ffe020)(approvePayload));
            /* End --- Approve parent  */ }
        } catch (error) {
            (0, $hopDi$Logger).log("Error handling API call:", error.message);
        }
        let payload;
        if (entValueKey <= 0) payload = {
            accountKey: accountKey,
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            certRoleKey: nodeData?.CERT_ROLEKEY,
            status: isConditionalCertifiy ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).CONDITIONAL_CERTIFIY,
            extendedEndDate: getDate && getDate.length > 0 ? getDate : currentDate
        };
        else payload = {
            accountKey: accountKey,
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            status: isConditionalCertifiy ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).CONDITIONAL_CERTIFIY,
            extendedEndDate: getDate && getDate.length > 0 ? getDate : currentDate
        };
        if (comment && comment.length > 0) {
            if (!isConditionalCertifiy) payload.comments = comment;
        }
        if (isConditionalCertifiy) payload.comments = "Action Cancelled";
        const dispatchConditionalCertify = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY, isConditionalCertifiy, (0, $d623f23401a154f0$export$9f62cbf6b3b94af9), payload);
        // Tile on click
        if (isDetailsGroup) dispatchConditionalCertify();
        // Footer on click
        if (isFooterGroup) {
            if (!isConditionalCertifiy) {
                setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
                setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY);
            }
            if (commentValue?.length >= 3) dispatchConditionalCertify();
        }
    };
    const handleConsultWithPeers = async (consultPayload)=>{
        setIsActionDrawerOutsideClick(true);
        const verifyPayload = {
            certKey: certKey,
            userKey: userKey,
            entValueKey: entValueKey,
            accountKey: accountKey,
            roleKey: roleKey
        };
        const payload = {
            eid: nodeData.id,
            certkey: certKey,
            cert_userkey: nodeData.CERT_USERKEY,
            cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
            requestOrigin: "UI"
        };
        const getNameByType = ()=>{
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ACCOUNT) return nodeData?.Account_DISPLAYNAME;
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ROLE) return nodeData?.Role_DISPLAYNAME;
            if (getTypeActEntRole() === (0, $bae22e791544392c$export$6b1c20b2e2de9059).ENTITLEMENT) return nodeData?.Ent_DISPLAYNAME;
            return null;
        };
        const currentChildObject = {
            type: getTypeActEntRole().toLowerCase(),
            childname: getNameByType()
        };
        if (nodeData.CERT_ENTITLEMENT_VALUEKEY !== (0, $bae22e791544392c$export$994f7af6d0b36256).USER) try {
            dispatch({
                type: (0, $d6d78fc758ee4148$export$8ca82b86b34f725b),
                payload: kind
            });
            const response = await (0, $d623f23401a154f0$export$a0116b9e1a4bda07)(dispatch, verifyPayload, currentChildObject);
            const { proceed: proceed } = response;
            if (Object.hasOwnProperty.call(response, "proceed") && !proceed) {
                // Logger.log("Approve user and entitlement")
                /* Start --- Approve parent  */ const approvePayload = {
                    certKey: certKey,
                    userKey: userKey,
                    entValueKey: entValueKey,
                    accountKey: nodeData?.CERT_ACCOUNTKEY,
                    status: isApprove ? (0, $20281fe09bc700a8$export$6bf521f24032eb49).RESET : (0, $20281fe09bc700a8$export$6bf521f24032eb49).APPROVE,
                    certRoleKey: nodeData?.CERT_ROLEKEY
                };
                if (consultPayload?.commentValue) approvePayload.comment = consultPayload?.commentValue;
                switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
                    case (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT:
                        delete approvePayload?.accountKey;
                        delete approvePayload?.certRoleKey;
                        approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).USER; // value = -4
                        break;
                    case (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE:
                        if (nodeData?.Role_ROLETYPE === (0, $e7683d2bb9b3b8c9$export$7f85b66a0bcac447)?.APPLICATION_ROLE) {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT; // value 0
                            approvePayload.certRoleKey = null;
                        } else {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).USER; // value = -4
                            delete approvePayload?.certRoleKey;
                        }
                        break;
                    default:
                        if ((0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                            approvePayload.entValueKey = (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT; // value 0
                            approvePayload.certRoleKey = null;
                        }
                        break;
                }
                dispatch((0, $d623f23401a154f0$export$70cd670b72ffe020)(approvePayload));
            /* End --- Approve parent  */ }
        } catch (error) {
            (0, $hopDi$Logger).log("Error handling API call:", error.message);
        }
        // WIP When resetting the consult for lineitem
        // if (isConsult) {
        //   payload.status = '0';
        //   payload.comments = consultPayload?.commentValue
        //     ? consultPayload?.commentValue
        //     : 'Consult';
        // } else {
        //  }
        if (consultPayload?.commentValue) payload.comments = consultPayload?.commentValue;
        if (consultPayload?.selectedUser && consultPayload.selectedUser?.value !== consultPayload.defaultReassignee) payload.assignee = consultPayload?.selectedUser?.value;
        switch(nodeData?.CERT_ENTITLEMENT_VALUEKEY){
            case (0, $bae22e791544392c$export$994f7af6d0b36256).USER:
                break;
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ACCOUNT:
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE:
                if (nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $bae22e791544392c$export$994f7af6d0b36256).ROLE) payload.cert_rolekey = nodeData.CERT_ROLEKEY; // not required in account level
                if (consultPayload?.isIncludeAssociateChecked) payload.reassignAssociated = consultPayload.isIncludeAssociateChecked.toString();
                if (nodeData?.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
            case (0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT:
            default:
                if ((0, $bae22e791544392c$export$994f7af6d0b36256).ENTITLEMENT >= 0) {
                    if (consultPayload?.isIncludeAssociateChecked) payload.reassignAssociated = consultPayload.isIncludeAssociateChecked.toString();
                }
                if (nodeData.CERT_ACCOUNTKEY) payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
                break;
        }
        const dispatchConsult = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT, isConsult, (0, $d623f23401a154f0$export$3f4330c48a705a7a), payload);
        // Tile on click
        if (isDetailsGroup) dispatchConsult();
        // Footer on click
        if (isFooterGroup) {
            setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
            setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT);
            dispatchConsult();
        }
    };
    const handleDoesNotWorksForMe = (reassignPayload)=>{
        setIsActionDrawerOutsideClick(true);
        const payload = {
            certkey: certKey,
            cert_userkey: nodeData.CERT_USERKEY,
            cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
            requestOrigin: "UI"
        };
        if (reassignPayload?.commentValue && reassignPayload?.commentValue?.length > 0) {
            if (!isDoesNotWorksForMe) payload.comments = reassignPayload?.commentValue;
        }
        if (isDoesNotWorksForMe) payload.comments = "Action Cancelled";
        //  When resetting the reassign for user lineitem
        if (isDoesNotWorksForMe) payload.status = "0";
        else if (!(0, $687791ac9134434b$export$a49393e96e2bf605)(reassignConfigMap) || objectForRedirectLink?.consulteeLoggedIn) {
            // update status when reassign popup is disabled
            payload.status = `${(0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED}`; // status should be 3
            payload.updateStatus = true;
        }
        if (reassignPayload?.selectedUser && !reassignPayload?.isSkipCertifierChecked) payload.assignee = reassignPayload?.selectedUser?.value;
        else if (reassignPayload?.isSkipCertifierChecked) // when skip certifier is checked for user lineitem
        payload.status = `${(0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED}`;
        const dispatchReassignDoesNotWorkForMe = ()=>dispatchActionHandler((0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME, isDoesNotWorksForMe, isDoesNotWorksForMe ? (0, $d623f23401a154f0$export$627e0e03ed6c2927) : (0, $d623f23401a154f0$export$29d12c975855399), payload);
        // Tile on click
        if (isDetailsGroup) dispatchReassignDoesNotWorkForMe();
        // Footer on click
        if (isFooterGroup) {
            setIsSidePanelCommentDrawerOpen(!isSidePanelCommentDrawerOpen);
            setDrawerActionKind((0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME);
            dispatchReassignDoesNotWorkForMe();
        }
    };
    const handleMouseEnter = ()=>{
        if (expandedHoverTimerRef.current) {
            clearTimeout(expandedHoverTimerRef.current);
            expandedHoverTimerRef.current = null;
        }
    };
    const handleMouseLeave = ()=>{
        if (isActionGroupExpanded) expandedHoverTimerRef.current = setTimeout(()=>{
            setIsActionGroupExpanded(false);
        }, 1000);
    };
    const handleKabobClick = ()=>{
        if (!isMobileXlargeWidth) {
            setIsActionGroupExpanded(!isActionGroupExpanded);
            return;
        }
        setIsTileActionDrawerOpen(true);
    };
    const tooltipPostion = isDetailsGroup ? "bottom" : "top";
    const tooltipDelay = isDetailsGroup ? $f7cd7b23cff7a54f$var$TOOLTIP_DELAY_IN_MS_TILE : $f7cd7b23cff7a54f$var$TOOLTIP_DELAY_IN_MS_SIDEPANEL;
    const getTooltipText = (defaultText, isDisabled, isSelected)=>{
        if (groupTooltipText) return groupTooltipText;
        if (isDisabled) return "";
        if (!actionTakenByPrimaryCertifier && isSelected) return "Review Decision";
        return defaultText;
    };
    const setReassignUserPopoverMsg = ()=>{
        dispatch({
            type: (0, $d6d78fc758ee4148$export$7fbc63266c535cea)
        });
    };
    const actionButtons = {
        approve: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE,
            onClick: handleApprove,
            isSelected: isApprove,
            isLoading: isApproveLoading,
            isDisabled: isApproveDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isApprove ? "Cancel Approval" : "Approve", isApproveDisabled, isApprove)
            }
        },
        reject: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT,
            onClick: handleRejectAction,
            isSelected: isReject,
            isLoading: isRejectLoading,
            isDisabled: isRejectDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isReject ? "Cancel Rejection" : "Reject", isRejectDisabled, isReject)
            }
        },
        terminated: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE,
            onClick: handleTerminate,
            isSelected: isTerminated,
            isLoading: isTerminatedLoading,
            isDisabled: isTerminatedDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isTerminated ? "Cancel Termination" : "Terminate", isTerminatedDisabled, isTerminated)
            }
        },
        reassign: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN,
            onClick: handleReassign,
            isSelected: isReassign,
            isLoading: isReassignLoading,
            isDisabled: isReassignDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText("Reassign", isReassignDisabled, isReassign)
            }
        },
        consult: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT,
            onClick: handleConsultWithPeers,
            isSelected: isConsult,
            isLoading: isConsultLoading,
            isDisabled: isConsultDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: nodeData?.isConsulted ? "bottom" : tooltipPostion,
                text: getTooltipText((0, $878df4c3ccf5afc4$export$2cfbea6ef2b75009)(nodeData), isConsultDisabled, isConsult)
            }
        },
        worksForMe: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME,
            onClick: handleWorksForMe,
            isSelected: isWorksForMe,
            isLoading: isWorksForMeLoading,
            isDisabled: isWorksForMeDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isWorksForMe ? "Cancel Manager Confirmation" : "Confirm Manager", isWorksForMeDisabled, isWorksForMe)
            }
        },
        doesNotWorksForMe: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME,
            onClick: handleDoesNotWorksForMe,
            isSelected: isDoesNotWorksForMe,
            isLoading: isDoesNotWorksForMeLoading,
            isDisabled: isDoesNotWorksForMeDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText("Reassign", isDoesNotWorksForMeDisabled, isDoesNotWorksForMe)
            }
        },
        extendEndDate: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE,
            onClick: handleExtendEndDate,
            isSelected: isExtendEndDate,
            isLoading: isExtendEndDateLoading,
            isDisabled: isExtendEndDateDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText("Change End Date", isExtendEndDateDisabled, isExtendEndDate)
            }
        },
        conditionalCertifiy: {
            id: (0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY,
            kind: (0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY,
            onClick: handleConditionalCertifiy,
            isSelected: isConditionalCertifiy,
            isLoading: isConditionalCertifiyLoading,
            isDisabled: isConditionalCertifiyDisabled,
            tooltipProperties: {
                openDelay: tooltipDelay,
                placement: tooltipPostion,
                text: getTooltipText(isConditionalCertifiy ? "Cancel End Date Change" : "Change End Date", isConditionalCertifiyDisabled, isConditionalCertifiy)
            }
        }
    };
    const handleSubmitFunctions = {
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE]: handleApprove,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT]: handleRejectAction,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE]: handleTerminate,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN]: handleReassign,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT]: handleConsultWithPeers,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME]: handleWorksForMe,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME]: handleDoesNotWorksForMe,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE]: handleExtendEndDate,
        [(0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY]: handleConditionalCertifiy
    };
    // close consult popover from side panel drawer
    const closeConsultPopover = (checkBoxSelected)=>{
        if (actionBtnRefs.current[drawerActionKind]) actionBtnRefs.current[drawerActionKind].current?.childFunction(checkBoxSelected);
    };
    const getReusableActionsMap = (isDrawerActions)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: getKindClasses(isDrawerActions),
            dataTestId: dataTestId,
            children: orderedButtons?.length > 0 && orderedButtons?.map((buttonKey, index)=>{
                const buttonConfig = actionButtons[buttonKey];
                const isNotTabbable = index >= MIN_BUTTONS_FOR_KABOB && !isActionGroupExpanded;
                const getIsCommentRequired = ()=>{
                    // User
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).WORKS_FOR_ME);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).DOES_NOT_WORK_FOR_ME);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).REASSIGN);
                    // Acounts, Entitilements, Roles
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER !== entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE === buttonConfig.id) return enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).APPROVE);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).TERMINATED);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER !== entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN === buttonConfig.id) return enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).REASSIGNSTEP2);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER !== entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT === buttonConfig.id) // consult 'RE-ASSIGN' value need to check
                    return enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).REASSIGN);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER === entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE === buttonConfig.id) return enableCommentsUsers.includes((0, $20281fe09bc700a8$export$80dc2c0ddeaedcb2).EXTEND_END_DATE);
                    if ((0, $bae22e791544392c$export$994f7af6d0b36256).USER !== entValueKey && (0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT === buttonConfig.id) return enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).REJECT);
                    return false;
                };
                if (!buttonConfig) {
                    (0, $hopDi$Logger).warn(`No configuration found for button: ${buttonKey}`);
                    return null;
                }
                const { id: id, kind: actionkind, onClick: onClick, isSelected: isSelected, isLoading: isLoading, isDisabled: isDisabled, tooltipProperties: tooltipProperties } = buttonConfig;
                const loadingConditions = isLoading || isActionLoading && actionkind === isSidePanelLoadingKind;
                const hideToolTipAndNotTabbable = (isDetailsGroup || isMobileXlargeWidth && isFooterGroup) && isNotTabbable;
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $57da59531dca7c37$export$2e2bcd8739ae039), {
                    ref: actionBtnRefs.current[actionkind],
                    id: id,
                    activeTab: activeTab?.key,
                    setActionPopoverOpenId: setActionPopoverOpenId,
                    setIsSidePanelCommentDrawerOpen: setIsSidePanelCommentDrawerOpen,
                    setDrawerActionSelected: setDrawerActionSelected,
                    kind: actionkind,
                    groupKind: kind,
                    onClick: onClick,
                    isSelected: isSelected,
                    isLoading: loadingConditions,
                    isDisabled: isDisabled || isGroupDisabled || !disableButtonsMap?.join(",")?.includes(id) || disableButtonsMap?.length === 0 && actionButtonsMap?.join(",")?.includes(id),
                    isToolTipDisabled: isTouchEnabled && !isGroupDisabled,
                    tooltipProperties: tooltipProperties,
                    tabIndex: hideToolTipAndNotTabbable ? -1 : 0,
                    isDrawerActions: isDrawerActions,
                    isCommentRequired: getIsCommentRequired(),
                    isHidden: hideToolTipAndNotTabbable && !isDrawerActions,
                    getViewApiConfigmap: getViewApiConfigmap,
                    extendEndDateDaysLimit: getViewApiConfigmap?.ExtendEndDateDaysLimit && getViewApiConfigmap?.ExtendEndDateDaysLimit?.length > 0 ? getViewApiConfigmap?.ExtendEndDateDaysLimit : "",
                    certKey: certKey,
                    nodeData: nodeData,
                    isActionSuccess: isActionSuccess,
                    isActionError: isActionError,
                    isActionErrorMessage: isActionErrorMessage,
                    userKey: userKey,
                    getTypeActEntRole: getTypeActEntRole(),
                    isSidePanelVisible: isSidePanelVisible,
                    reassignConfigMap: reassignConfigMap,
                    getFirstTimeReject: getFirstTimeReject,
                    certificationStartDate: certificationStartDate?.split(" ")[0],
                    conditionalCertifyDaysLimit: getViewApiConfigmap?.ConditionallyCertifyInDaysLimit && getViewApiConfigmap?.ConditionallyCertifyInDaysLimit?.length > 0 ? getViewApiConfigmap?.ConditionallyCertifyInDaysLimit : "",
                    isPopoverUserReassignMsgShown: isPopoverUserReassignMsgShown,
                    setReassignUserPopoverMsg: setReassignUserPopoverMsg,
                    setDrawerActionKind: setDrawerActionKind,
                    isSaviResponded: isSaviResponded,
                    saviRespondedReason: saviRespondedReason,
                    isSidePanelCommentDrawerOpen: isSidePanelCommentDrawerOpen,
                    consulteeLoggedIn: objectForRedirectLink?.consulteeLoggedIn,
                    actionTakenByPrimaryCertifier: actionTakenByPrimaryCertifier,
                    isScrolling: isScrolling,
                    globalDateFormat: globalDateFormat,
                    isActionGroupExpanded: isActionGroupExpanded,
                    filteredNodeData: filteredNodeData,
                    isActionDrawerOutsideClick: isActionDrawerOutsideClick,
                    setIsActionDrawerOutsideClick: setIsActionDrawerOutsideClick
                }, id);
            })
        });
    const shouldRenderKabobButtonIcon = actionButtonsMap && actionButtonsMap?.length > 0 && (actionButtonsMap?.length > MIN_BUTTONS_FOR_KABOB || isMobileXlargeWidth);
    if (isFooterGroup) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: "CertsActionButtonsGroup-footerGroup",
        children: [
            getReusableActionsMap(false),
            shouldRenderKabobButtonIcon && isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                className: "CertsTabItem-sidePanelMobileFooter-moreButton",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonCore), {
                        onClick: handleKabobClick,
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "MoreHorizontal",
                            size: "medium",
                            color: "indigo-700"
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        className: "CertsTileActionsDrawer-item CertsTileActionsDrawer-sidepanelItem",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            className: "MobileDrawerItem-primaryLabelWrapper",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "label",
                                desktop: "body4-bold-d",
                                mobile: "body4-bold-m",
                                className: (0, $hopDi$classnames)("CertsSidePanel-footerActions-moreButton"),
                                children: "More"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $94e77a9d2fb3d728$export$2e2bcd8739ae039), {
                isSidePanelCommentDrawerOpen: isSidePanelCommentDrawerOpen,
                setIsSidePanelCommentDrawerOpen: setIsSidePanelCommentDrawerOpen,
                setDrawerActionSelected: setDrawerActionSelected,
                drawerActionKind: drawerActionKind,
                onSubmit: handleSubmitFunctions[drawerActionKind] || (()=>{}),
                getTypeActEntRole: getTypeActEntRole(),
                isRejectCommentRequired: enableCommentsAccEntRole.includes((0, $20281fe09bc700a8$export$69894cdd9841cdfb).REJECT),
                setIsSidePanelLoadingKind: setIsSidePanelLoadingKind,
                nodeData: nodeData,
                globalDateFormat: globalDateFormat,
                certKey: certKey,
                drawerActionSelected: drawerActionSelected,
                isSaviResponded: isSaviResponded,
                consulteeLoggedIn: objectForRedirectLink?.consulteeLoggedIn,
                closeConsultPopover: closeConsultPopover,
                actionBtnRefs: actionBtnRefs,
                tooltipPosition: tooltipPostion,
                activeTab: activeTab?.key,
                isMobileXlargeWidth: isMobileXlargeWidth,
                isActionDrawerOutsideClick: isActionDrawerOutsideClick,
                setIsActionDrawerOutsideClick: setIsActionDrawerOutsideClick
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                className: "CertsActionButtonsGroup-overlay"
            }),
            isTileActionDrawerOpen && isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1c2fc2889f848be4$export$2e2bcd8739ae039), {
                isActionDrawerOutsideClick: isActionDrawerOutsideClick,
                reusableActionsMap: getReusableActionsMap(true),
                isTileActionDrawerOpen: isTileActionDrawerOpen,
                setIsTileActionDrawerOpen: setIsTileActionDrawerOpen,
                tileCheckIcon: getTileCheckIcon(true),
                titleValue: titleValue,
                tileKindHeading: getTileKindHeading(),
                handleTileClick: handleTileClick,
                bulkSelectInfoForDrawer: bulkSelectInfoForDrawer,
                checkSidePanelMobileFooter: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: actionButtonWrapperClasses,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: actionButtonGroupClasses,
                children: [
                    getReusableActionsMap(false),
                    shouldRenderKabobButtonIcon && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "CertsActionButtonsGroup-kabobWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                role: "button",
                                "aria-hidden": "true",
                                className: "CertsActionButtonsGroup-mobileKabobTarget",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    kabobRef.current?.click();
                                }
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                ref: kabobRef,
                                kind: "ghost",
                                size: "small",
                                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: isActionGroupExpanded ? "ExpandRight" : "MoreVertical"
                                }),
                                onClick: handleKabobClick,
                                className: "CertsActionButtonsGroup-kabob"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                className: "CertsActionButtonsGroup-overlay"
            }),
            isTileActionDrawerOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1c2fc2889f848be4$export$2e2bcd8739ae039), {
                isActionDrawerOutsideClick: isActionDrawerOutsideClick,
                reusableActionsMap: getReusableActionsMap(true),
                isTileActionDrawerOpen: isTileActionDrawerOpen,
                setIsTileActionDrawerOpen: setIsTileActionDrawerOpen,
                tileCheckIcon: getTileCheckIcon(true),
                titleValue: titleValue,
                tileKindHeading: getTileKindHeading(),
                handleTileClick: handleTileClick,
                bulkSelectInfoForDrawer: bulkSelectInfoForDrawer,
                checkSidePanelMobileFooter: false
            })
        ]
    });
}
$f7cd7b23cff7a54f$var$CertsActionButtonsGroup.defaultProps = {
    actionsData: null,
    groupTooltipText: null,
    isActionGroupExpanded: null,
    setIsActionGroupExpanded: ()=>{},
    setActionPopoverOpenId: ()=>{},
    saviRespondedReason: [],
    isScrolling: false,
    filteredNodeData: {},
    getTileCheckIcon: ()=>{},
    titleValue: null,
    getTileKindHeading: ()=>{},
    bulkSelectInfoForDrawer: {},
    dataTestId: null
};
$f7cd7b23cff7a54f$var$CertsActionButtonsGroup.propTypes = {
    kind: (0, $hopDi$proptypes).oneOf(Object.values((0, $20281fe09bc700a8$export$758743ec42a300f1))).isRequired,
    isGroupDisabled: (0, $hopDi$proptypes).bool.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    actionsData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)),
    handleAutoSelectParent: (0, $hopDi$proptypes).func.isRequired,
    groupTooltipText: (0, $hopDi$proptypes).string,
    isActionGroupExpanded: (0, $hopDi$proptypes).bool,
    setIsActionGroupExpanded: (0, $hopDi$proptypes).func,
    setActionPopoverOpenId: (0, $hopDi$proptypes).func,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    isSaviResponded: (0, $hopDi$proptypes).bool.isRequired,
    saviRespondedReason: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    isScrolling: (0, $hopDi$proptypes).bool,
    filteredNodeData: (0, $hopDi$proptypes).shape({}),
    getTileCheckIcon: (0, $hopDi$proptypes).func,
    titleValue: (0, $hopDi$proptypes).string,
    getTileKindHeading: (0, $hopDi$proptypes).func,
    handleTileClick: (0, $hopDi$proptypes).func.isRequired,
    bulkSelectInfoForDrawer: (0, $hopDi$proptypes).shape({}),
    dataTestId: (0, $hopDi$proptypes).string
};
var $f7cd7b23cff7a54f$export$2e2bcd8739ae039 = $f7cd7b23cff7a54f$var$CertsActionButtonsGroup;




var $2ee72dee6e5b726b$export$2e2bcd8739ae039 = (0, $f7cd7b23cff7a54f$export$2e2bcd8739ae039);







const $60e28faa4cf9b9fa$export$a1d1a2dbce5ef265 = {
    warning: "warning",
    success: "success",
    critical: "critical",
    info: "info"
};
const $60e28faa4cf9b9fa$export$93499b93a6aaed41 = {
    outlined: "outlined",
    plain: "plain"
};
const $60e28faa4cf9b9fa$export$57732b6846a8df7c = {
    small: "small",
    regular: "regular"
};
const $60e28faa4cf9b9fa$export$77f67d0acb1506cb = {
    width: 75,
    height: 75,
    baseSpanInDegree: 250,
    strokeWidth: 7
};
const $60e28faa4cf9b9fa$export$eec0d2dd696ca943 = {
    width: 50,
    height: 50,
    baseSpanInDegree: 200,
    strokeWidth: 5
};
const $60e28faa4cf9b9fa$export$1630b5343357e8b5 = {
    [$60e28faa4cf9b9fa$export$57732b6846a8df7c.small]: $60e28faa4cf9b9fa$export$eec0d2dd696ca943,
    [$60e28faa4cf9b9fa$export$57732b6846a8df7c.regular]: $60e28faa4cf9b9fa$export$77f67d0acb1506cb
};


const $4631ad19de1cc617$export$8ffc5d9dc47527cf = (cX, cY, rad, angleInDegrees)=>{
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: cX + rad * Math.cos(angleInRadians),
        y: cY + rad * Math.sin(angleInRadians)
    };
};
const $4631ad19de1cc617$export$419276ee4f979de5 = (x, y, rad, startAngle, endAngle)=>{
    const start = $4631ad19de1cc617$export$8ffc5d9dc47527cf(x, y, rad, endAngle);
    const end = $4631ad19de1cc617$export$8ffc5d9dc47527cf(x, y, rad, startAngle);
    const path = [
        `M ${start.x} ${start.y}`,
        `A ${rad} ${rad} 0 ${endAngle - startAngle <= 180 ? "0" : "1"} 0 ${end.x} ${end.y}`
    ].join(" ");
    return path;
};



function $9c7747fdd807b112$var$RiskScore({ kind: kind, size: size, value: value, label: label, chipKind: chipKind, className: className, shouldShowZero: shouldShowZero }) {
    // eslint-disable-next-line no-unused-vars
    const [svgDimensions, setSvgDimensions] = (0, $hopDi$useState)((0, $60e28faa4cf9b9fa$export$1630b5343357e8b5)[size]);
    // eslint-disable-next-line no-unused-vars
    const [percentage, setPercentage] = (0, $hopDi$useState)(// eslint-disable-next-line no-nested-ternary
    value ? Math.min(100, Math.max(0, value)) : shouldShowZero ? 0 : "-");
    const progressStatsIconIndicator = (0, $hopDi$classnames)("RiskScore-progressStatsIconIndicator", `RiskScore-progressStatsIconIndicator--${kind}`, className);
    const progressStatsNumberColor = (0, $hopDi$classnames)(`RiskScore-progressStatsNumberColor--${kind}`);
    const progressStatsLabelColor = (0, $hopDi$classnames)(`RiskScore-progressLabel--${kind}`);
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: `RiskScore--${size}${label?.trim()?.length === 0 && size === (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).regular ? "--noLabel" : ""}`,
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "RiskScore-wrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "RiskScore-progressStats",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "RiskScore-progressStatsIcon",
                            children: /*#__PURE__*/ (0, $hopDi$jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: svgDimensions.width,
                                height: svgDimensions.height,
                                viewBox: `0 0 ${svgDimensions.width} ${svgDimensions.height}`,
                                fill: "none",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)("path", {
                                        d: (0, $4631ad19de1cc617$export$419276ee4f979de5)(parseInt(svgDimensions.width / 2, 10), parseInt(svgDimensions.height / 2, 10), parseInt(svgDimensions.width / 2 - svgDimensions.strokeWidth, 10), -parseInt(svgDimensions.baseSpanInDegree / 2, 10), parseInt(svgDimensions.baseSpanInDegree / 2, 10)),
                                        fill: "none",
                                        stroke: "#EBECF2",
                                        strokeWidth: svgDimensions.strokeWidth,
                                        strokeLinecap: "round"
                                    }),
                                    typeof percentage === "number" && /*#__PURE__*/ (0, $hopDi$jsx)("path", {
                                        className: progressStatsIconIndicator,
                                        d: (0, $4631ad19de1cc617$export$419276ee4f979de5)(parseInt(svgDimensions.width / 2, 10), parseInt(svgDimensions.height / 2, 10), parseInt(svgDimensions.width / 2 - svgDimensions.strokeWidth, 10), -parseInt(svgDimensions.baseSpanInDegree / 2, 10), -parseInt(svgDimensions.baseSpanInDegree / 2, 10) + percentage / 100 * svgDimensions.baseSpanInDegree),
                                        fill: "none",
                                        stroke: "#028329",
                                        strokeWidth: svgDimensions.strokeWidth,
                                        strokeLinecap: "round"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "RiskScore-progressStatsNumber",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: size === (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).regular ? "h2" : "body2",
                                className: progressStatsNumberColor,
                                children: percentage
                            })
                        })
                    ]
                }),
                size === (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).small && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "RiskScore-progressChip--small",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: progressStatsLabelColor,
                        children: label
                    })
                }),
                size === (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).regular && label?.trim().length > 0 && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "RiskScore-progressChip--regular",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                        kind: chipKind,
                        label: label,
                        size: "small",
                        color: kind
                    })
                })
            ]
        })
    });
}
$9c7747fdd807b112$var$RiskScore.propTypes = {
    kind: (0, $hopDi$proptypes).oneOf(Object.values((0, $60e28faa4cf9b9fa$export$a1d1a2dbce5ef265))),
    size: (0, $hopDi$proptypes).oneOf(Object.values((0, $60e28faa4cf9b9fa$export$57732b6846a8df7c))),
    value: (0, $hopDi$proptypes).number,
    label: (0, $hopDi$proptypes).string,
    chipKind: (0, $hopDi$proptypes).oneOf(Object.values((0, $60e28faa4cf9b9fa$export$93499b93a6aaed41))),
    className: (0, $hopDi$proptypes).string,
    shouldShowZero: (0, $hopDi$proptypes).bool
};
$9c7747fdd807b112$var$RiskScore.defaultProps = {
    kind: (0, $60e28faa4cf9b9fa$export$a1d1a2dbce5ef265).info,
    size: (0, $60e28faa4cf9b9fa$export$57732b6846a8df7c).small,
    value: 0,
    label: "None",
    chipKind: (0, $60e28faa4cf9b9fa$export$93499b93a6aaed41).outlined,
    className: null,
    shouldShowZero: false
};
var $9c7747fdd807b112$export$2e2bcd8739ae039 = $9c7747fdd807b112$var$RiskScore;


var $d890b5a3788f0783$export$2e2bcd8739ae039 = (0, $9c7747fdd807b112$export$2e2bcd8739ae039);




/* eslint-disable indent */ 









const $48ea1ae565a51e3b$var$ROW_TYPE = {
    ROLE: "Role",
    ENTITLEMENT: "Entitlement"
};
const $48ea1ae565a51e3b$var$RISK_KINDS = {
    warning: "warning-700",
    success: "success-700",
    critical: "critical-700",
    info: "navy-900"
};
function $48ea1ae565a51e3b$var$TrustJustification({ isTrustScoreEnabled: isTrustScoreEnabled, nodeData: nodeData, certsKind: certsKind }) {
    const intl = (0, $hopDi$useIntl)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    if (isTrustScoreEnabled) {
        if (isTrustScoreEnabled?.enableCertificationTrustModel) {
            const trustJustification = nodeData?.TRUST_JUSTIFICATION || [
                {
                    "CR.JRM.NO_RULES_FOUND.Reason.Default.label": []
                }
            ];
            return Array.isArray(trustJustification) && trustJustification?.map((item)=>{
                const reasonKeys = Object.keys(item);
                const firstKey = reasonKeys.length > 0 ? reasonKeys[0] : undefined;
                const firstKeyValue = item[firstKey]?.map((value)=>value.toFixed(2)) || [];
                if (firstKey) return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "TrustJustification-listItem",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "InfoOutlined",
                            size: "small",
                            color: $48ea1ae565a51e3b$var$RISK_KINDS.info,
                            className: "TrustJustification-listItemIcon"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            className: "TrustJustification-listItemText",
                            children: messages[firstKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(firstKey), firstKeyValue)
                        })
                    ]
                }, firstKey);
                return "";
            });
        }
        if (nodeData?.JRMRULES?.rmd === "POSSIBLE_REJECTION") {
            const reasonMessage = typeof nodeData?.TRUST_JUSTIFICATION === "string" ? nodeData?.TRUST_JUSTIFICATION : "None of the user's attributes correspond to this entitlement";
            return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "TrustJustification-listItem",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "InfoOutlined",
                        size: "small",
                        color: $48ea1ae565a51e3b$var$RISK_KINDS.info,
                        className: "TrustJustification-listItemIcon"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        className: "TrustJustification-listItemText",
                        children: certsKind === $48ea1ae565a51e3b$var$ROW_TYPE.ROLE ? reasonMessage?.replace("Entitlement", "role")?.replace("entitlement", "role") : reasonMessage
                    })
                ]
            });
        }
        return nodeData?.JRMRULES?.rmd === "NO_OPINION" ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "TrustJustification-listItem",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "InfoOutlined",
                    size: "small",
                    color: $48ea1ae565a51e3b$var$RISK_KINDS.info,
                    className: "TrustJustification-listItemIcon"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    className: "TrustJustification-listItemText",
                    children: (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(nodeData?.JRMRULES?.rmd))
                })
            ]
        }) : /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "TrustJustification-listItem",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "InfoOutlined",
                    size: "small",
                    color: $48ea1ae565a51e3b$var$RISK_KINDS.info,
                    className: "TrustJustification-listItemIcon"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    className: "TrustJustification-listItemText",
                    children: nodeData?.JRMRULES?.rsn?.replace("Entitlement", "role") || nodeData?.JSON_JRMRULESAVAILABLE
                })
            ]
        });
    }
    return null;
}
$48ea1ae565a51e3b$var$TrustJustification.propTypes = {
    isTrustScoreEnabled: (0, $hopDi$proptypes).shape({
        enableCertificationTrustModel: (0, $hopDi$proptypes).bool
    }),
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    certsKind: (0, $hopDi$proptypes).string.isRequired
};
$48ea1ae565a51e3b$var$TrustJustification.defaultProps = {
    isTrustScoreEnabled: {}
};
var $48ea1ae565a51e3b$export$2e2bcd8739ae039 = $48ea1ae565a51e3b$var$TrustJustification;




const $cdc016b7003fff2a$var$TOOLTIP_DELAY_IN_MS_TILE = 500;
const $cdc016b7003fff2a$var$MIN_LENGTH_FOR_COL_TRUNCATION_TITLE = 26;
const $cdc016b7003fff2a$var$MIN_LENGTH_FOR_COL_TRUNCATION_ATT = 20;
const $cdc016b7003fff2a$var$SCROLL_THRESHOLD = 10;
function $cdc016b7003fff2a$var$Tile({ data: data, level: level, handleSidePanel: handleSidePanel, handleAutoSelectParent: handleAutoSelectParent, nodeData: nodeData, setMergedLists: setMergedLists, actionPopoverOpenId: actionPopoverOpenId, setActionPopoverOpenId: setActionPopoverOpenId, isScrolling: isScrolling }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    // isExpanded
    const [isCheckingIntoSession, setIsCheckingIntoSession] = (0, $hopDi$useState)(false);
    const [isActionGroupExpanded, setIsActionGroupExpanded] = (0, $hopDi$useState)(false);
    const [isScoreMeterPopoverOpen, setIsScoreMeterPopoverOpen] = (0, $hopDi$useState)(false);
    const [isStuck, setIsStuck] = (0, $hopDi$useState)(false);
    const [isTouchScrolling, setIsTouchScrolling] = (0, $hopDi$useState)(false);
    const [touchStartPosition, setTouchStartPosition] = (0, $hopDi$useState)({
        x: 0,
        y: 0
    });
    const tileRef = (0, $hopDi$useRef)(null);
    const { mediaQueryValue: mediaQueryValue, certKey: certKey, configMap: configMap, columnPickerList: columnPickerList, globalDateFormat: globalDateFormat, isLoading: isLoading, bulkAction: bulkAction, isAuditor: isAuditor, isSidePanelVisible: isSidePanelVisible, isTrustScoreEnabled: isTrustScoreEnabled, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    // Tile Scoped Variables
    const isCheckboxVisible = Boolean(bulkAction?.isBulkActionEnabled && (isCheckingIntoSession || nodeData?.tracker?.isChecked || nodeData?.tracker?.isIndeterminate || bulkAction?.isAtleastOneSelected));
    const isTileSidepanelSelected = nodeData?.tracker?.isConnected;
    const certsKind = (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData);
    const fixedColKey = (0, $4c1aa6449628783a$export$18b54358355494a)(certsKind);
    const actionButtonsMap = nodeData?.availableAction && Object.keys(nodeData?.availableAction);
    const trackerId = nodeData?.tracker?.id;
    const isLevelZero = level === 0;
    const isLevelOne = level === 1;
    const isLevelTwo = level === 2;
    const isThisTilesActionPopoverOpen = actionPopoverOpenId === trackerId;
    const shouldDisableWhileCallingActionApis = (0, $4c1aa6449628783a$export$57d225e2d2f6fa1f)(nodeData?.tracker?.actions);
    const isCertsKindUser = nodeData?.CERT_ENTITLEMENT_VALUEKEY === (0, $bae22e791544392c$export$994f7af6d0b36256).USER;
    const shouldDisableActionBtns = Boolean(bulkAction?.isAtleastOneSelected || bulkAction?.isChecked || bulkAction?.isDisabled || bulkAction?.isSubmittingAction || isCheckingIntoSession || shouldDisableWhileCallingActionApis || isAuditor);
    const shouldShowGroupToolTip = Boolean(bulkAction?.isAtleastOneSelected || bulkAction?.isChecked || bulkAction?.isDisabled && !bulkAction?.isSubmittingAction);
    const isSaviResponded = Boolean(nodeData?.savi_responded && nodeData?.savi_responded === "1");
    const saviRespondedReason = [];
    if (isSaviResponded && nodeData?.savi_reason && nodeData?.savi_reason.length > 0) nodeData?.savi_reason.map((item)=>saviRespondedReason.push(item));
    const tabletSmallQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$6e89092ed3d96394));
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isTabletWidth = tabletSmallQuery.value <= mediaQueryValue;
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    const isTrustChipVisible = isMobileXlargeWidth && isTrustScoreEnabled && (certsKind === (0, $a23cd229b9113926$export$7d1f9b2b2a057886) || certsKind === (0, $a23cd229b9113926$export$c97501b522a7bf89));
    // Conditional Classes
    const tileClasses = (0, $hopDi$classnames)("Tile", `Tile--${level}`, isSidePanelVisible && "Tile--isSidePanelVisible", isTileSidepanelSelected && "Tile--isTileSidepanelSelected", isStuck && "Tile--isStuck", isThisTilesActionPopoverOpen && "Tile--isActionPopoverOpen", isTrustScoreEnabled && "Tile--isTrustScoreEnabled");
    const leftHoverSideClasses = (0, $hopDi$classnames)("Tile-leftHoverSide", `Tile-leftHoverSide--${level}`, nodeData?.tracker?.isConnected && "Tile-leftHoverSide--isSidePanelOpen");
    // Within Hover Area
    const tileCheckHoverDisplayBtn = (0, $hopDi$classnames)("Tile-checkboxHoverDisplay", bulkAction?.isDisabled && "Tile-checkboxHoverDisplay--disabled");
    const tileCheckboxClasses = (0, $hopDi$classnames)("Tile-checkbox", isCheckboxVisible && "Tile-checkbox--isCheckboxVisible");
    const tileCheckboxIconClasses = (0, $hopDi$classnames)("Tile-checkboxIcon", isCheckboxVisible && "Tile-checkboxIcon--isCheckboxVisible");
    const actionButtonGroupClasses = (0, $hopDi$classnames)("Tile-actionButtonGroup", isActionGroupExpanded && "Tile-actionButtonGroup--isExpanded", actionButtonsMap?.length && `Tile-actionButtonGroup--length${actionButtonsMap.length}`);
    const buildThresholdList = ()=>{
        const thresholds = [];
        for(let i = 0; i <= 1.0; i += 0.01)thresholds.push(i);
        return thresholds;
    };
    (0, $hopDi$useEffect)(()=>{
        setMergedLists((prevMergedLists)=>(0, $4c1aa6449628783a$export$e6436fb982b2017f)(prevMergedLists));
        const stickyContainer = tileRef.current;
        const certsDetailsList = document.getElementById("certsDetailsList");
        if (!stickyContainer || isLevelTwo) return;
        // Debug background
        // stickyContainer.style.backgroundColor = 'rgba(255, 0, 0, 0.3)';
        let customRootMargin;
        if (isLevelZero) customRootMargin = "-1px 0px 500px 0px";
        if (isLevelOne) customRootMargin = isMobileXlargeWidth ? "-49px 0px 500px 0px" : "-65px 0px 500px 0px";
        const options = {
            root: certsDetailsList,
            rootMargin: customRootMargin,
            threshold: buildThresholdList()
        };
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const isCurrentlyStuck = entry.intersectionRatio > 0 && entry.intersectionRatio < 1;
                setIsStuck(isCurrentlyStuck);
            });
        }, options);
        observer.observe(stickyContainer);
        // eslint-disable-next-line consistent-return
        return ()=>observer.disconnect();
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (isSidePanelVisible) setIsScoreMeterPopoverOpen(false);
        else setMergedLists((prev)=>(0, $4c1aa6449628783a$export$f87a1650caa3642b)(prev));
    }, [
        isSidePanelVisible
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isActionGroupExpanded) setIsActionGroupExpanded(false);
    }, [
        isScrolling,
        isMobileXlargeWidth
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isTileSidepanelSelected) (0, $4c1aa6449628783a$export$1a48656bb4f8148)(tileRef);
    }, [
        isTileSidepanelSelected
    ]);
    const handleSidePanelOpening = (0, $hopDi$useCallback)((id, connectedBarLevel)=>{
        handleSidePanel();
        setMergedLists((prevMergedLists)=>(0, $4c1aa6449628783a$export$86c6573c35d84094)(prevMergedLists, id, connectedBarLevel));
    }, [
        data
    ]);
    const handleTileClick = (e)=>{
        if (e?.target?.parentNode?.id === (0, $883fa4dd903b96ab$export$fd41194cca4d2bb5)) {
            const payload = {
                ARSTASKKEY: nodeData?.ARSTASKKEY,
                ARSTASKKEYFLAG: nodeData?.arstaskkeyflag,
                CERT_ENTITLEMENT_VALUEKEY: nodeData?.CERT_ENTITLEMENT_VALUEKEY,
                CERT_USERKEY: nodeData?.CERT_USERKEY,
                CERT_ROLEKEY: nodeData?.CERT_ROLEKEY,
                CERT_ACCOUNTKEY: nodeData?.CERT_ACCOUNTKEY
            };
            dispatch((0, $d623f23401a154f0$export$6905b0d830e88406)(true, payload));
            return;
        }
        handleSidePanelOpening(trackerId, nodeData.tracker.level);
    };
    const handleKeyDownTile = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            handleTileClick();
        }
    };
    const handleTileCheck = (prev, id, tileLevel)=>{
        const prevMergedLists = prev.map((item)=>{
            if (id === null || tileLevel === null) return item;
            if (item.tracker.level !== tileLevel) return {
                ...item,
                children: item?.children?.length > 0 ? handleTileCheck(item.children, id, tileLevel) : []
            };
            if (item.tracker.id === id) return {
                ...item,
                tracker: {
                    ...item.tracker,
                    isChecked: !item.tracker.isChecked,
                    isIndeterminate: false
                },
                children: item?.children?.length > 0 ? (0, $4c1aa6449628783a$export$e946959053026eab)(item.children, !item.tracker.isChecked) : []
            };
            return item;
        });
        return (0, $4c1aa6449628783a$export$e6436fb982b2017f)(prevMergedLists);
    };
    const handleCheckboxChange = (id, checkBoxLevel, currentStatus, hasChildren)=>{
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
        setIsCheckingIntoSession(true);
        if ((nodeData.CERT_ENTITLEMENT_VALUEKEY === (0, $6d218ab9b83faef2$export$e12a4cadfc09074e) || nodeData.CERT_ENTITLEMENT_VALUEKEY === (0, $6d218ab9b83faef2$export$2fdde2b3b0357dd1)) && hasChildren) {
            const userAccountKeys = {};
            if (nodeData.CERT_ENTITLEMENT_VALUEKEY === (0, $6d218ab9b83faef2$export$e12a4cadfc09074e)) userAccountKeys.cert_userkey = nodeData.CERT_USERKEY;
            if (nodeData.CERT_ENTITLEMENT_VALUEKEY === (0, $6d218ab9b83faef2$export$2fdde2b3b0357dd1)) {
                userAccountKeys.cert_userkey = nodeData.CERT_USERKEY;
                userAccountKeys.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
            }
            dispatch((0, $d623f23401a154f0$export$79d150fc3aa7c31d)(userAccountKeys, currentStatus)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(false));
                setMergedLists((prevMergedLists)=>handleTileCheck(prevMergedLists, id, checkBoxLevel));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            }).finally(()=>{
                setIsCheckingIntoSession(false);
            });
        } else dispatch((0, $d623f23401a154f0$export$5b43dc99ee28ff0f)(certKey, nodeData?.id, !currentStatus)).then(()=>{
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(false));
            setMergedLists((prevMergedLists)=>handleTileCheck(prevMergedLists, id, checkBoxLevel));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
        }).finally(()=>{
            setIsCheckingIntoSession(false);
        });
    };
    const getTileCheckIcon = (isDrawer)=>isCertsKindUser ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Avatar), {
            size: isMobileXlargeWidth && isDrawer ? "xSmall" : "small",
            className: tileCheckboxIconClasses
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: (0, $4c1aa6449628783a$export$c40b9342a19db0b6)(nodeData),
            color: "navy-900",
            size: isMobileXlargeWidth ? "medium" : "smallMedium",
            className: tileCheckboxIconClasses
        });
    const handleCheckboxHoverDisplay = ()=>{
        const shouldDisableTileCheckBoxes = Boolean(!bulkAction?.isBulkActionEnabled || bulkAction?.isDisabled || bulkAction?.isSubmittingAction || !shouldShowReviewAndSubmitButton || isLoading || nodeData?.enableAction?.length === 0 && Object.keys(nodeData?.availableAction)?.length !== 0);
        const isCheckBoxChecked = Boolean(bulkAction?.isBulkActionEnabled && (nodeData?.tracker?.isChecked || nodeData?.enableAction?.length === 0 && Object.keys(nodeData?.availableAction)?.length !== 0));
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: tileCheckboxClasses,
                    children: !isCheckingIntoSession ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        name: "checkbox-no-hovereffect",
                        kind: "base",
                        showHoverEffect: true,
                        shouldStopCorePropagation: true,
                        dataTestId: "checkbox-no-hovereffect",
                        isChecked: isCheckBoxChecked,
                        isDisabled: shouldDisableTileCheckBoxes,
                        isIndeterminate: nodeData?.tracker?.isIndeterminate,
                        hasBackground: false,
                        onChange: ()=>handleCheckboxChange(nodeData?.tracker?.id, nodeData?.tracker?.level, nodeData?.tracker?.isChecked, nodeData?.tracker?.childCount > 0)
                    }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "loop",
                        format: "inline",
                        color: "brand",
                        size: "small"
                    })
                }),
                getTileCheckIcon(false)
            ]
        });
    };
    const isNoValueTitle = nodeData[fixedColKey] === null || nodeData[fixedColKey] === undefined || nodeData?.[fixedColKey]?.trim()?.length === 0;
    const titleValue = isNoValueTitle ? "Not Provided" : nodeData[fixedColKey];
    const getTileKindHeading = ()=>messages[fixedColKey] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(fixedColKey));
    const getTruncateLength = ()=>{
        if (isLevelTwo) return titleValue?.length > $cdc016b7003fff2a$var$MIN_LENGTH_FOR_COL_TRUNCATION_TITLE - 6;
        if (isLevelOne) return titleValue?.length > $cdc016b7003fff2a$var$MIN_LENGTH_FOR_COL_TRUNCATION_TITLE - 3;
        return titleValue?.length > $cdc016b7003fff2a$var$MIN_LENGTH_FOR_COL_TRUNCATION_TITLE;
    };
    // TODO: Currently there are duplicated usage of risk variables. Consider the implementation of each variable and combine what can be reused vars: riskScore, riskKind, riskLabel.
    const getRiskChip = ()=>{
        const chipRiskScore = Number(nodeData?.JRMRULES?.cnf || 0);
        if (isTrustScoreEnabled?.enableCertificationTrustModel) {
            const upperLimitValue = configMap?.TRUST_LIKELYAPPROVAL_LOWER?.trim()?.length !== 0 ? Number(configMap?.TRUST_LIKELYAPPROVAL_LOWER) : null;
            const lowerLimitValue = configMap?.TRUST_POSSIBLEREJECT_UPPER?.trim()?.length !== 0 ? Number(configMap?.TRUST_POSSIBLEREJECT_UPPER) : null;
            const middleRange = String(configMap?.TRUST_POSSIBLEAPPROVAL);
            const { score: riskScore, kind: riskKind } = (0, $e7628c995f405891$export$33ebd1c882bff43f)(Number(nodeData?.TRUST_SCORE) || Number(nodeData?.JRMRULES?.TRUST_SCORE), upperLimitValue, lowerLimitValue, middleRange);
            if (riskKind === "info" || Number(riskScore) === 0) return null;
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                color: riskKind,
                size: "xSmall",
                label: riskScore,
                leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: (0, $e7628c995f405891$export$5e3a05818856a5b7)(riskKind)
                })
            });
        }
        const { kind: riskKind } = (0, $e7628c995f405891$export$622a7128677021ae)(nodeData?.JRMRULES?.rmd);
        if (riskKind === "info" || Number(chipRiskScore) === 0) return null;
        if (chipRiskScore) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
            color: riskKind,
            size: "xSmall",
            label: chipRiskScore,
            leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: (0, $e7628c995f405891$export$5e3a05818856a5b7)(riskKind)
            })
        });
        return null;
    };
    const getTitleColData = ()=>{
        const titleValueClasses = (0, $hopDi$classnames)("Tile-titleValue", isNoValueTitle && "Tile-titleValue--isNoValue");
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "Tile-titleHeadingTrustWrapper",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body3",
                            mobile: "body4-m",
                            children: getTileKindHeading()
                        }),
                        isTrustChipVisible && getRiskChip()
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "Tile-titleValueWrapper",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                        openDelay: $cdc016b7003fff2a$var$TOOLTIP_DELAY_IN_MS_TILE,
                        text: getTruncateLength() ? titleValue : null,
                        maxWidth: "20rem",
                        placement: "bottom",
                        offset: 8,
                        trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            className: titleValueClasses,
                            lineLimit: 1,
                            children: titleValue
                        })
                    })
                })
            ]
        });
    };
    const maxCountOfColoumns = columnPickerList ? Math.max(...Object.keys(columnPickerList).map((column)=>Object.keys(columnPickerList[column]).length)) : 0;
    const shouldShowArsButton = ()=>{
        if (nodeData?.CERT_ENTITLEMENT_VALUEKEY === "-2" || nodeData?.CERT_ENTITLEMENT_VALUEKEY === "0" || nodeData?.arstaskkeyflag) return true;
        return false;
    };
    // TODO: Hidden Attribute Column Data is still rendered in overflow. Consider removing from DOM instead to reduce divs in DOM by ~5 per overflown attribute.
    const getAttributeColData = ()=>{
        let tempFilledColsCount = 0;
        const dataKeysWithOutFixedCol = Object.keys(data)?.filter((key)=>key !== fixedColKey);
        if (!dataKeysWithOutFixedCol || dataKeysWithOutFixedCol?.length === 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: "Tile-attribute"
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                dataKeysWithOutFixedCol?.map((key, index)=>{
                    let isNoValue = data[key] === null || data[key] === undefined || typeof data[key] === "object" || typeof data[key] === "string" && data?.[key]?.trim()?.length === 0;
                    let attributeValue = isNoValue ? "-" : `${data?.[key]}`;
                    if (key === "JRMRULES" && nodeData?.JSON_JRMRULESAVAILABLE) {
                        attributeValue = nodeData?.JSON_JRMRULESAVAILABLE;
                        isNoValue = false;
                    }
                    if (!isNoValue && (0, $135adfecc1ed8f07$export$510f63ad8e5b2cec).includes(key)) {
                        isNoValue = false;
                        attributeValue = (0, $hopDi$moment).utc(attributeValue).local().format(`${globalDateFormat?.toUpperCase()} hh:mm:ss`);
                    }
                    if (typeof attributeValue === "string" && attributeValue?.includes("<br")) {
                        if (typeof attributeValue === "string" && attributeValue?.includes("<br")) attributeValue = attributeValue?.replace(/<br\s*\/?>/gm, "\n");
                    }
                    attributeValue = attributeValue?.replace(/<br\s*\/?>/gm, "\n");
                    const attributeValueClasses = (0, $hopDi$classnames)("Tile-attributeValue");
                    tempFilledColsCount = index;
                    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "Tile-attribute",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "Tile-attributeValueHeading",
                                children: messages[key] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key))
                            }),
                            key === (0, $883fa4dd903b96ab$export$d9266982e2bf3d17) && shouldShowArsButton() ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $6be8371a7cd99dfd$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                openDelay: $cdc016b7003fff2a$var$TOOLTIP_DELAY_IN_MS_TILE,
                                text: attributeValue?.length > $cdc016b7003fff2a$var$MIN_LENGTH_FOR_COL_TRUNCATION_ATT ? attributeValue : null,
                                maxWidth: "20rem",
                                placement: "bottom",
                                offset: 8,
                                trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: attributeValueClasses,
                                    lineLimit: 1,
                                    children: attributeValue
                                })
                            })
                        ]
                    }, key);
                }),
                [
                    ...Array(Math.max(0, maxCountOfColoumns - tempFilledColsCount + 1)).keys()
                ].map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "Tile-attribute"
                    }, key))
            ]
        });
    };
    const handleMouseLeaveOnScoreMeter = (e)=>{
        e.stopPropagation();
        setIsScoreMeterPopoverOpen(false);
    };
    const handleMouseEnterOnScoreMeter = (e)=>{
        e.stopPropagation();
        setIsScoreMeterPopoverOpen(true);
    };
    // TODO: Currently there are duplicated usage of risk variables. Consider the implementation of each variable and combine what can be reused vars: riskScore, riskKind, riskLabel.
    const renderScoreMeter = ()=>{
        if (isTrustScoreEnabled && (certsKind === (0, $a23cd229b9113926$export$7d1f9b2b2a057886) || certsKind === (0, $a23cd229b9113926$export$c97501b522a7bf89))) {
            // Check if score coming from confidence
            if (isTrustScoreEnabled?.enableCertificationTrustModel) {
                const upperLimitValue = configMap?.TRUST_LIKELYAPPROVAL_LOWER?.trim()?.length !== 0 ? Number(configMap?.TRUST_LIKELYAPPROVAL_LOWER) : null;
                const lowerLimitValue = configMap?.TRUST_POSSIBLEREJECT_UPPER?.trim()?.length !== 0 ? Number(configMap?.TRUST_POSSIBLEREJECT_UPPER) : null;
                const middleRange = String(configMap?.TRUST_POSSIBLEAPPROVAL);
                const { score: riskScore, kind: riskKind, label: riskLabel } = (0, $e7628c995f405891$export$33ebd1c882bff43f)(Number(nodeData?.TRUST_SCORE) || Number(nodeData?.JRMRULES?.TRUST_SCORE), upperLimitValue, lowerLimitValue, middleRange);
                if (riskKind === "info" || Number(riskScore) === 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "Tile-placeholderScore--blank"
                });
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                    isPortalEnabled: true,
                    placement: "left-start",
                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "Tile-scoreMeterWrapper",
                        onMouseEnter: (e)=>handleMouseEnterOnScoreMeter(e),
                        onMouseLeave: (e)=>handleMouseLeaveOnScoreMeter(e),
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                            kind: riskKind,
                            size: "small",
                            value: riskScore,
                            label: riskLabel,
                            shouldShowZero: true
                        })
                    }),
                    popoverContent: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "div",
                        className: "Tile-scoreMeterPlaceHolder",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $48ea1ae565a51e3b$export$2e2bcd8739ae039), {
                            isTrustScoreEnabled: isTrustScoreEnabled,
                            nodeData: nodeData,
                            certsKind: certsKind
                        })
                    }),
                    isOpen: isScoreMeterPopoverOpen,
                    setIsOpen: setIsScoreMeterPopoverOpen
                });
            }
            const riskScoreNumber = Number(nodeData?.JRMRULES?.cnf || "0");
            const { kind: riskKind, label: riskLabel } = (0, $e7628c995f405891$export$622a7128677021ae)(nodeData?.JRMRULES?.rmd);
            if (riskKind === "info" || Number(riskScoreNumber) === 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "Tile-placeholderScore--blank"
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                isPortalEnabled: true,
                placement: "left-start",
                trigger: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "Tile-scoreMeterWrapper",
                    onMouseEnter: (e)=>handleMouseEnterOnScoreMeter(e),
                    onMouseLeave: (e)=>handleMouseLeaveOnScoreMeter(e),
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                        kind: riskKind,
                        size: "small",
                        value: riskScoreNumber,
                        label: riskLabel
                    })
                }),
                popoverContent: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "Tile-scoreMeterPlaceHolder",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $48ea1ae565a51e3b$export$2e2bcd8739ae039), {
                        isTrustScoreEnabled: isTrustScoreEnabled,
                        nodeData: nodeData,
                        certsKind: certsKind
                    })
                }),
                isOpen: isScoreMeterPopoverOpen,
                setIsOpen: setIsScoreMeterPopoverOpen
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "div",
            className: "Tile-placeholderScore--blank"
        });
    };
    const checkForActions = actionButtonsMap && actionButtonsMap.length > 0;
    const shouldRenderActionButtonsGroup = (!isSidePanelVisible || isSidePanelVisible && isTabletWidth) && checkForActions;
    // Code for touch device for checkbox actions
    let animationFrameId;
    const handlePointerDown = (e)=>{
        if (bulkAction?.isBulkActionEnabled) {
            setTouchStartPosition({
                x: e.clientX,
                y: e.clientY
            });
            setIsTouchScrolling(false);
        }
    };
    const handlePointerMove = (e)=>{
        if (animationFrameId || !bulkAction?.isBulkActionEnabled) return;
        animationFrameId = requestAnimationFrame(()=>{
            const deltaX = Math.abs(e.clientX - touchStartPosition.x);
            const deltaY = Math.abs(e.clientY - touchStartPosition.y);
            if (deltaX > $cdc016b7003fff2a$var$SCROLL_THRESHOLD || deltaY > $cdc016b7003fff2a$var$SCROLL_THRESHOLD) setIsTouchScrolling(true);
            animationFrameId = null;
        });
    };
    const handlePointeUp = (e)=>{
        if (!isTouchScrolling && e.pointerType === "touch" && !isCheckingIntoSession && bulkAction?.isBulkActionEnabled) handleCheckboxChange(nodeData?.tracker?.id, nodeData?.tracker?.level, nodeData?.tracker?.isChecked, nodeData?.tracker?.childCount > 0);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
                ref: tileRef,
                className: tileClasses,
                "data-testid": `cert-details-list-level-${level}`,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        onPointerDown: handlePointerDown,
                        onPointerMove: handlePointerMove,
                        onPointerUp: handlePointeUp,
                        className: tileCheckHoverDisplayBtn,
                        children: handleCheckboxHoverDisplay()
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        tabIndex: 0,
                        role: "button",
                        onClick: handleTileClick,
                        onKeyDown: (e)=>handleKeyDownTile(e),
                        className: leftHoverSideClasses,
                        "aria-label": "Click to open side panel",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                tag: "div",
                                className: "Tile-titleCol",
                                children: getTitleColData()
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                tag: "div",
                                className: "Tile-attributeCols",
                                children: getAttributeColData()
                            }),
                            !isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                tag: "div",
                                className: "Tile-trustScore",
                                children: renderScoreMeter()
                            })
                        ]
                    }),
                    shouldRenderActionButtonsGroup && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: actionButtonGroupClasses,
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $2ee72dee6e5b726b$export$2e2bcd8739ae039), {
                            kind: (0, $20281fe09bc700a8$export$758743ec42a300f1).TILE,
                            nodeData: nodeData,
                            filteredNodeData: data,
                            isActionGroupExpanded: isActionGroupExpanded,
                            setIsActionGroupExpanded: setIsActionGroupExpanded,
                            setActionPopoverOpenId: setActionPopoverOpenId,
                            setMergedLists: setMergedLists,
                            isScrolling: isScrolling,
                            handleAutoSelectParent: handleAutoSelectParent,
                            groupTooltipText: shouldShowGroupToolTip ? "Options for multiple-item selections are available in the toolbar below." : null,
                            isGroupDisabled: shouldDisableActionBtns,
                            isSaviResponded: isSaviResponded,
                            saviRespondedReason: saviRespondedReason,
                            getTileCheckIcon: getTileCheckIcon,
                            titleValue: titleValue,
                            getTileKindHeading: getTileKindHeading,
                            handleTileClick: handleTileClick,
                            bulkSelectInfoForDrawer: {
                                isChecked: nodeData?.tracker?.isChecked,
                                childCount: nodeData?.tracker?.childCount,
                                isBulkActionEnabled: bulkAction?.isBulkActionEnabled,
                                isAtleastOneChildChecked: nodeData?.tracker?.isAtleastOneChildChecked,
                                handleBulkSelectFromDrawer: ()=>handleCheckboxChange(nodeData?.tracker?.id, nodeData?.tracker?.level, nodeData?.tracker?.isChecked, nodeData?.tracker?.childCount > 0)
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        tag: "span",
                        className: "Tile-overlay"
                    })
                ]
            }),
            isLevelZero && isStuck && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "span",
                className: "Tile-fillStuck--0"
            }),
            isLevelOne && isStuck && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "span",
                className: "Tile-fillStuck--1"
            })
        ]
    });
}
$cdc016b7003fff2a$var$Tile.propTypes = {
    data: (0, $hopDi$proptypes).shape({}),
    level: (0, $hopDi$proptypes).number.isRequired,
    handleSidePanel: (0, $hopDi$proptypes).func.isRequired,
    handleAutoSelectParent: (0, $hopDi$proptypes).func.isRequired,
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)).isRequired,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    actionPopoverOpenId: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).bool,
        (0, $hopDi$proptypes).string
    ]),
    setActionPopoverOpenId: (0, $hopDi$proptypes).func.isRequired,
    isScrolling: (0, $hopDi$proptypes).bool.isRequired
};
$cdc016b7003fff2a$var$Tile.defaultProps = {
    data: {},
    actionPopoverOpenId: false
};
var $cdc016b7003fff2a$export$2e2bcd8739ae039 = $cdc016b7003fff2a$var$Tile;



var $e7ccc98e1a551e3a$export$2e2bcd8739ae039 = (0, $cdc016b7003fff2a$export$2e2bcd8739ae039);





const $076fc4f0a29566cf$export$8558f2aefa046992 = (totalChildrenCount, levelOneChildrenWithChildren, level, isMobileXlargeWidth)=>{
    const isLevelZero = level === 0;
    const isLevelOne = level === 1;
    const isLevelTwo = level === 2;
    if (isLevelTwo) return null;
    const baseHeights = {
        LEVEL_ZERO: 4,
        LEVEL_ONE: 4.0625
    };
    const additionalHeightPerChildLevel = {
        LEVEL_ZERO: 4,
        LEVEL_ONE: 4
    };
    const hasChildOffSet = {
        LEVEL_ZERO: isMobileXlargeWidth ? 4.75 : 6,
        LEVEL_ONE: isMobileXlargeWidth ? 5.5 : 6.0625
    };
    let height = isLevelZero ? baseHeights.LEVEL_ZERO : baseHeights.LEVEL_ONE;
    if (totalChildrenCount > 0 && isLevelZero) {
        height = additionalHeightPerChildLevel.LEVEL_ZERO * totalChildrenCount + hasChildOffSet.LEVEL_ZERO;
        if (levelOneChildrenWithChildren > 0) height += 2 * levelOneChildrenWithChildren;
    }
    if (totalChildrenCount > 0 && isLevelOne) height = additionalHeightPerChildLevel.LEVEL_ONE * totalChildrenCount + hasChildOffSet.LEVEL_ONE;
    return {
        height: `${height}rem`
    };
};
const $076fc4f0a29566cf$export$9c4e15d4b9c2625b = (node, level)=>{
    if (!node?.children || node.children.length === 0) return {
        count: 0,
        levelOneChildrenWithChildren: 0
    };
    let total = node.children.length;
    let levelOneChildrenWithChildren = 0;
    node.children.forEach((child)=>{
        const { count: count, levelOneChildrenWithChildren: childHasChildrenCount } = $076fc4f0a29566cf$export$9c4e15d4b9c2625b(child);
        total += count;
        if (level === 0 && child.children?.length > 0) levelOneChildrenWithChildren += 1;
        levelOneChildrenWithChildren += childHasChildrenCount;
    });
    return {
        count: total,
        levelOneChildrenWithChildren: levelOneChildrenWithChildren
    };
};
const $076fc4f0a29566cf$export$1e1c9bf5a4ffe0d1 = (node)=>{
    const rowData = JSON.parse(JSON.stringify(node));
    delete rowData?.children;
    return rowData;
};
const $076fc4f0a29566cf$export$63321e3ad1dbffda = (nodeData, colsToShow)=>{
    const filteredObj = {};
    // Determine category based on CERT_ENTITLEMENT_VALUEKEY
    let category;
    if (nodeData.CERT_ENTITLEMENT_VALUEKEY === "0") category = (0, $a23cd229b9113926$export$eeb9092565ce426a);
    else if (parseInt(nodeData.CERT_ENTITLEMENT_VALUEKEY, 10) > 0) category = (0, $a23cd229b9113926$export$7d1f9b2b2a057886);
    else if (nodeData.CERT_ENTITLEMENT_VALUEKEY === "-4") category = (0, $a23cd229b9113926$export$c2fd574cc3b8c823);
    else if (nodeData.CERT_ENTITLEMENT_VALUEKEY === "-2") category = (0, $a23cd229b9113926$export$c97501b522a7bf89);
    if (category) {
        const allowedAttributes = colsToShow[category.toUpperCase()];
        allowedAttributes?.forEach((attr)=>{
            const realAttr = attr?.split("-")[1];
            if (Object.prototype.hasOwnProperty.call(nodeData, realAttr)) filteredObj[realAttr] = nodeData[realAttr];
        });
    }
    return filteredObj;
};



function $9fe3bef4cc10ee7d$var$Cards({ data: data, level: level, handleSidePanel: handleSidePanel, handleAutoSelectParent: handleAutoSelectParent, setMergedLists: setMergedLists, actionPopoverOpenId: actionPopoverOpenId, setActionPopoverOpenId: setActionPopoverOpenId, isScrolling: isScrolling }) {
    const [colsToShow, setColsToShow] = (0, $hopDi$useState)({});
    const [disableTransition, setDisableTransition] = (0, $hopDi$useState)(false);
    const [treeStyles, setTreeStyles] = (0, $hopDi$useState)({});
    const [shouldGetStyles, setShouldGetStyles] = (0, $hopDi$useState)(false);
    const { mediaQueryValue: mediaQueryValue, colsFilters: colsFilters, isLoading: isLoading, isSidePanelVisible: isSidePanelVisible } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const allCardsRef = (0, $hopDi$useRef)(null);
    const isLevelZero = level === 0;
    const isLevelOne = level === 1;
    const mobileXLargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXLargeQuery.value <= mediaQueryValue;
    const cardsClasses = (0, $hopDi$classnames)("Cards", `Cards--${level}`, isSidePanelVisible && "Cards--isSidePanelVisible");
    // Remove transitions from Card trees for durations of transition after loading
    (0, $hopDi$useEffect)(()=>{
        let timer;
        if (isLoading) setDisableTransition(true);
        else timer = setTimeout(()=>{
            setDisableTransition(false);
        }, 800);
        return ()=>clearTimeout(timer);
    }, [
        isLoading
    ]);
    (0, $hopDi$useEffect)(()=>{
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === "attributes" && mutation.target.classList.contains("Cards-tree--isBeingRemoved")) {
                    const parent = mutation.target.closest(".Cards-tree--0");
                    const subParent = mutation.target.closest(".Cards-tree--1");
                    if (parent && !parent.classList.contains("Cards-tree--isBeingRemoved")) parent.style.height = "auto";
                    if (subParent && !subParent.classList.contains("Cards-tree--isBeingRemoved")) parent.style.height = "auto";
                }
            });
        });
        const config = {
            attributes: true,
            subtree: true,
            attributeFilter: [
                "class"
            ]
        };
        if (allCardsRef.current) {
            observer.observe(allCardsRef.current, config);
            setShouldGetStyles(true);
        }
        return ()=>{
            observer.disconnect();
        };
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (colsFilters) setColsToShow(colsFilters);
    }, [
        colsFilters
    ]);
    const getTreeClasses = (node, treeIndex)=>{
        const isTreeIndexZero = treeIndex === 0;
        const isTreeIndexEnd = treeIndex === data.length - 1;
        const isEnt = node.CERT_ENTITLEMENT_VALUEKEY <= 0;
        const hasNodeChildren = node?.children?.length > 0;
        const isTopTile = isTreeIndexZero && !isLevelZero;
        const isBottomTile = isTreeIndexEnd && !isLevelZero;
        const hasEntChild = isLevelOne && isEnt && hasNodeChildren;
        const defaultTreeClasses = (0, $hopDi$classnames)("Cards-tree", `Cards-tree--${level}`, `Cards-treeIndex--${treeIndex}`, isTopTile && "Cards-tree--isTopTile", isBottomTile && "Cards-tree--isBottomTile", hasEntChild && "Cards-tree--hasEntChild", !hasNodeChildren && "Cards-tree--hasNoChildren");
        return defaultTreeClasses;
    };
    const getTreeStyles = (node)=>{
        const { count: totalChildrenCount, levelOneChildrenWithChildren: levelOneChildrenWithChildren } = (0, $076fc4f0a29566cf$export$9c4e15d4b9c2625b)(node, level);
        const dynamicTreeStyles = (0, $076fc4f0a29566cf$export$8558f2aefa046992)(totalChildrenCount, levelOneChildrenWithChildren, level, isMobileXlargeWidth);
        return dynamicTreeStyles;
    };
    (0, $hopDi$useEffect)(()=>{
        if (!data) return;
        const updateTreeStyles = ()=>{
            const newTreeStyles = data.reduce((acc, node, index)=>{
                const dynamicTreeStyles = getTreeStyles(node);
                acc[index] = dynamicTreeStyles;
                return acc;
            }, {});
            setTreeStyles(newTreeStyles);
        };
        updateTreeStyles();
    }, [
        data,
        shouldGetStyles,
        isMobileXlargeWidth
    ]);
    if (!data) return null;
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: cardsClasses,
        ref: allCardsRef,
        children: data?.map((node, index)=>{
            const nodeData = (0, $076fc4f0a29566cf$export$1e1c9bf5a4ffe0d1)(node);
            const filteredNodeData = (0, $076fc4f0a29566cf$export$63321e3ad1dbffda)(nodeData, colsToShow);
            const treeClassNames = getTreeClasses(node, index);
            return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                id: node?.id,
                style: {
                    ...treeStyles[index],
                    transition: disableTransition ? "none" : ""
                },
                className: treeClassNames,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $e7ccc98e1a551e3a$export$2e2bcd8739ae039), {
                        data: filteredNodeData,
                        nodeData: nodeData,
                        level: level,
                        handleSidePanel: ()=>handleSidePanel(nodeData),
                        handleAutoSelectParent: handleAutoSelectParent,
                        setMergedLists: setMergedLists,
                        actionPopoverOpenId: actionPopoverOpenId,
                        setActionPopoverOpenId: setActionPopoverOpenId,
                        isScrolling: isScrolling
                    }),
                    node?.children?.length !== 0 && /*#__PURE__*/ (0, $hopDi$jsx)($9fe3bef4cc10ee7d$var$Cards, {
                        data: node?.children || [],
                        level: level + 1,
                        handleSidePanel: handleSidePanel,
                        handleAutoSelectParent: handleAutoSelectParent,
                        setMergedLists: setMergedLists,
                        actionPopoverOpenId: actionPopoverOpenId,
                        setActionPopoverOpenId: setActionPopoverOpenId,
                        isScrolling: isScrolling
                    })
                ]
            }, node?.tracker?.id);
        })
    });
}
$9fe3bef4cc10ee7d$var$Cards.propTypes = {
    data: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    level: (0, $hopDi$proptypes).number,
    handleSidePanel: (0, $hopDi$proptypes).func.isRequired,
    handleAutoSelectParent: (0, $hopDi$proptypes).func.isRequired,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    actionPopoverOpenId: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).bool,
        (0, $hopDi$proptypes).string
    ]),
    setActionPopoverOpenId: (0, $hopDi$proptypes).func.isRequired,
    isScrolling: (0, $hopDi$proptypes).bool.isRequired
};
$9fe3bef4cc10ee7d$var$Cards.defaultProps = {
    level: 0,
    actionPopoverOpenId: false
};
var $9fe3bef4cc10ee7d$export$2e2bcd8739ae039 = $9fe3bef4cc10ee7d$var$Cards;


var $691dbffebbf06698$export$2e2bcd8739ae039 = (0, $9fe3bef4cc10ee7d$export$2e2bcd8739ae039);







function $c37cf970f91ce261$var$CertDetailsError() {
    const history = (0, $hopDi$useHistory)();
    const [isOpen, setIsOpen] = (0, $hopDi$useState)(true);
    const onRefreshClick = ()=>{
        window.location.reload();
    };
    const onBackClick = ()=>{
        history.goBack();
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: "CertDetailsError",
        kind: "critical",
        alertTitle: "Could not Load Page",
        alertSubtitle: "This page of the certification did not load properly due to a network issue. Please refresh or try again later.",
        onClose: ()=>setIsOpen(false),
        isOpen: isOpen,
        primaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
            type: "button",
            kind: "filled",
            isEnabled: true,
            size: "medium",
            onClick: onRefreshClick,
            children: "Refresh"
        }),
        secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
            type: "button",
            kind: "ghost",
            size: "medium",
            onClick: onBackClick,
            children: "Go Back"
        })
    });
}
var $c37cf970f91ce261$export$2e2bcd8739ae039 = $c37cf970f91ce261$var$CertDetailsError;


var $87d4d732106452cd$export$2e2bcd8739ae039 = (0, $c37cf970f91ce261$export$2e2bcd8739ae039);











function $497631ad0623d8a8$var$CertsSidePanelEntitlements({ dataTestId: dataTestId, className: className, data: data, activeTab: activeTab, setActiveTab: setActiveTab, isLoadingHistory: isLoadingHistory, retriggerApisForError: retriggerApisForError, handleCloseSidePanel: handleCloseSidePanel, tabGroupSidePanelRef: tabGroupSidePanelRef }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, certKey: certKey, configMap: configMap, isTrustScoreEnabled: isTrustScoreEnabled } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const classes = (0, $hopDi$classnames)("CertsSidePanelBody", className);
    const [showHistory, setShowHistory] = (0, $hopDi$useState)(false);
    const [isLoadingMoreData, setIsLoadingMoreData] = (0, $hopDi$useState)(false);
    const [viewMore, setViewMore] = (0, $hopDi$useState)({
        [(0, $d60257e8dc27bf16$export$a06b6c2be556dac8)]: {
            currentOffset: 0
        },
        [(0, $d60257e8dc27bf16$export$8f78881bb4058858)]: {
            currentOffset: 0
        },
        [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: {
            currentOffset: 0
        },
        [(0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)]: {
            currentOffset: 0
        }
    });
    const [childrenSearchForEnts, setChildrenSearchForEnts] = (0, $hopDi$useState)("");
    const [dependentSearchForEnts, setDependentSearchForEnts] = (0, $hopDi$useState)("");
    const [entitlementMenu, setEntitlementMenu] = (0, $hopDi$useState)([]);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mobileXlargeQuery.value <= mediaQueryValue;
    const callApiForLoadBtn = (tab)=>{
        setIsLoadingMoreData(true);
        switch(tab){
            case 0, $d60257e8dc27bf16$export$8f78881bb4058858:
                dispatch((0, $d623f23401a154f0$export$1fbc321c679e35cc)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_ACCOUNTKEY, String(viewMore[0, $d60257e8dc27bf16$export$8f78881bb4058858].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), "", (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            case 0, $d60257e8dc27bf16$export$51f82826650bc3c3:
                dispatch((0, $d623f23401a154f0$export$f8b073a05f313ac0)(data.CERT_ENTITLEMENT_VALUEKEY, String(viewMore[0, $d60257e8dc27bf16$export$51f82826650bc3c3].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            case 0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681:
                dispatch((0, $d623f23401a154f0$export$3b9a16a7c2bd6829)(data.CERT_ENTITLEMENT_VALUEKEY, String(viewMore[0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            default:
                break;
        }
    };
    (0, $hopDi$useEffect)(()=>{
        setChildrenSearchForEnts("");
        setShowHistory(activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63));
    }, [
        activeTab
    ]);
    const handleTabChange = (value)=>{
        setActiveTab(value);
    };
    const renderHistoryContent = ()=>{
        if (showHistory) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$9b67fda1e37e6e63]) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--history",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e52ca6c769e8713d$export$2e2bcd8739ae039), {
                    data: data,
                    isLoadingHistory: isLoadingHistory,
                    isMobileWidth: isMobileWidth
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent--history",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
            children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {})
        });
    };
    const renderSodTab = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$8f78881bb4058858]) {
                if (data?.sidePanel?.sod?.totalRisks > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Conflicts",
                    value: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Entitlement",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$8f78881bb4058858));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty",
                    value: (0, $d60257e8dc27bf16$export$8f78881bb4058858)
                }, (0, $d60257e8dc27bf16$export$8f78881bb4058858));
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Conflicts",
                value: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Entitlement",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            }, (0, $d60257e8dc27bf16$export$8f78881bb4058858));
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$8f78881bb4058858)
        }, (0, $d60257e8dc27bf16$export$8f78881bb4058858));
    };
    const renderPrivilegesTab = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$a06b6c2be556dac8]) {
                if (data?.sidePanel?.privileges?.totalPrivileges > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Privilege",
                    value: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "PrivilgedAccess",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$a06b6c2be556dac8));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty",
                    value: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8)
                }, (0, $d60257e8dc27bf16$export$a06b6c2be556dac8));
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Privilege",
                value: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "PrivilgedAccess",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            }, (0, $d60257e8dc27bf16$export$a06b6c2be556dac8));
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8)
        }, (0, $d60257e8dc27bf16$export$a06b6c2be556dac8));
    };
    const renderChildrenTabForEnts = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) {
                if (data?.sidePanel?.children?.totalChildEnt > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Children",
                    value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Entitlement",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty",
                    value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3)
                }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Children",
                value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Entitlement",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3)
        }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
    };
    const renderDependentsTabForEnts = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681]) {
                if (data?.sidePanel?.dependents?.totalMappedEnt > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Dependents",
                    value: (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Entitlement",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty",
                    value: (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)
                }, (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681));
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Dependents",
                value: (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Entitlement",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            }, (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681));
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3)
        }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
    };
    const entValidTabsForMenu = ()=>data?.sidePanel?.unFixedTabs?.filter((tab)=>{
            if (tab === (0, $d60257e8dc27bf16$export$8f78881bb4058858)) {
                if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$8f78881bb4058858] && data?.sidePanel?.sod?.totalRisks > 0) return true;
                if (!data?.sidePanel?.status[0, $d60257e8dc27bf16$export$8f78881bb4058858]) return true;
            }
            if (tab === (0, $d60257e8dc27bf16$export$a06b6c2be556dac8)) {
                if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$a06b6c2be556dac8] && data?.sidePanel?.privileges?.totalPrivileges > 0) return true;
                if (!data?.sidePanel?.status[0, $d60257e8dc27bf16$export$a06b6c2be556dac8]) return true;
            }
            if (tab === (0, $d60257e8dc27bf16$export$51f82826650bc3c3)) {
                if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3] && data?.sidePanel?.children?.totalChildEnt > 0) return true;
                if (!data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) return true;
            }
            if (tab === (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)) {
                if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681] && data?.sidePanel?.dependents?.totalMappedEnt > 0) return true;
                if (!data?.sidePanel?.status[0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681]) return true;
            }
            return false;
        });
    const renderMenuForEntitlement = ()=>{
        const tempMenuList = [];
        if (data) {
            if (entitlementMenu.includes((0, $d60257e8dc27bf16$export$8f78881bb4058858))) tempMenuList.push(renderSodTab());
            if (entitlementMenu.includes((0, $d60257e8dc27bf16$export$a06b6c2be556dac8))) tempMenuList.push(renderPrivilegesTab());
            if (entitlementMenu.includes((0, $d60257e8dc27bf16$export$51f82826650bc3c3))) tempMenuList.push(renderChildrenTabForEnts());
            if (entitlementMenu.includes((0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681))) tempMenuList.push(renderDependentsTabForEnts());
            return tempMenuList;
        }
        return null;
    };
    const renderSodContent = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$8f78881bb4058858]) {
            if (data?.sidePanel?.sod?.totalRisks > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--sod",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                children: [
                    data?.sidePanel?.sod?.risks?.map((risk, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: risk.riskcode,
                            iconKind: "SOD",
                            kind: "sod",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "CertsSidePanelBody-tabContentSodRisk",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            className: "CertsSidePanelBody-tabContentSodRiskText",
                                            children: "Risk Priority"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "CertsSidePanelBody-tabContentSodRiskButton",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                                                size: isMobileWidth ? "small" : "medium",
                                                kind: risk.risk_priority?.toLowerCase() === "critical" || risk.risk_priority?.toLowerCase() === "high" ? "boldFilled" : "subtleFilled",
                                                label: risk.risk_priority || "",
                                                color: (0, $6702cb469143c6c9$export$1c70425da51939b3)[risk.risk_priority] || ""
                                            })
                                        })
                                    ]
                                }, `${risk.index}-1`),
                                (risk.function1_name || risk.function2_name) && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "CertsSidePanelBody-tabContentSodFuncGroup",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            className: "CertsSidePanelBody-tabContentSodFuncGroupTitle",
                                            children: "Conflicting Job Functions"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                            className: "CertsSidePanelBody-tabContentSodFuncGroupBody",
                                            children: [
                                                risk.function1_name && /*#__PURE__*/ (0, $hopDi$jsx)((0, $55f6aa546a60d23d$export$2e2bcd8739ae039), {
                                                    sodItem: {
                                                        label: risk.function1_name,
                                                        description: risk.function1_description
                                                    }
                                                }, `${risk.index}-2-1`),
                                                risk.function2_name && /*#__PURE__*/ (0, $hopDi$jsx)((0, $55f6aa546a60d23d$export$2e2bcd8739ae039), {
                                                    sodItem: {
                                                        label: risk.function2_name,
                                                        description: risk.function2_description
                                                    }
                                                }, `${risk.index}-2-2`)
                                            ]
                                        })
                                    ]
                                }, `${risk.index}-2`),
                                index !== data.sidePanel.sod.risks.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, risk.index)),
                    data?.sidePanel?.sod?.totalRisks > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$8f78881bb4058858].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.sod?.totalRisks || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$8f78881bb4058858)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const renderPrivilegesContent = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$a06b6c2be556dac8]) {
            if (data?.sidePanel?.privileges?.totalPrivileges > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent-privileges",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                    title: "Allow Action",
                    iconKind: "PrivilgedAccess",
                    isInitialOpen: true,
                    pad: "privileges",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)("ul", {
                        className: "CertsSidePanelBody-tabContentPrivilegesList",
                        children: data?.sidePanel?.privileges?.privileges?.map((item)=>/*#__PURE__*/ (0, $hopDi$jsx)("li", {
                                className: "CertsSidePanelBody-tabContentPrivilegesListItem",
                                children: item.attributeName
                            }, item.attributeName))
                    })
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const renderChildrenContentForEntitlements = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) {
            if (data?.sidePanel?.children?.totalChildEnt > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--child",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentChildDescription",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body3",
                            children: "Child entitlements are subsets of access and permissions that correlate to a parent entitlement. These aren't always revoked when a parent entitlement is revoked."
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                        name: "basic",
                        kind: "search",
                        placeholder: "Search by Entitlement Name",
                        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "search",
                            color: "neutral-600",
                            size: "smallMedium"
                        }),
                        value: childrenSearchForEnts,
                        setValue: setChildrenSearchForEnts
                    }),
                    data?.sidePanel?.children?.childEntList.filter((child)=>`${child?.entitlement_value}`.toLowerCase().indexOf(childrenSearchForEnts.toLowerCase()) !== -1).map((child, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: child.entitlement_value,
                            iconKind: "Entitlement",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                Object.keys(child).filter((node)=>node !== "entitlement_value" && node !== "index").map((node)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                        fieldData: {
                                            label: messages[node] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(node)),
                                            value: child[node] || node
                                        }
                                    }, `${child.index}-${node}`)),
                                index !== data.sidePanel.children.childEntList.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, child.index)),
                    data?.sidePanel?.children?.totalChildEnt > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$51f82826650bc3c3].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.children?.totalChildEnt || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$51f82826650bc3c3)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const renderDependentsContentForEntitlements = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681]) {
            if (data?.sidePanel?.dependents?.totalMappedEnt > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--child",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentChildDescription",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body3",
                            children: "Dependent entitlements are subsets of access and permissions that are directly mapped to a parent entitlement. If the parent entitlement is revoked, these are also revoked."
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                        name: "basic",
                        kind: "search",
                        placeholder: "Search by Entitlement Name",
                        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "search",
                            color: "neutral-600",
                            size: "smallMedium"
                        }),
                        value: dependentSearchForEnts,
                        setValue: setDependentSearchForEnts
                    }),
                    data?.sidePanel?.dependents?.mappedEntList?.filter((dependent)=>`${dependent?.permissionType}`.toLowerCase().indexOf(dependentSearchForEnts.toLowerCase()) !== -1)?.map((dependent, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: dependent?.permissionType,
                            iconKind: "Entitlement",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                Object.keys(dependent).filter((node)=>node !== "permissionType" && node !== "index").map((node)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                        fieldData: {
                                            label: messages[node] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(node)),
                                            value: dependent?.[node] || node
                                        }
                                    }, `${dependent?.index}-${node}`)),
                                index !== data.sidePanel.dependents.mappedEntList.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, dependent?.index)),
                    data?.sidePanel?.dependents?.totalMappedEnt > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.dependents?.totalMappedEnt || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    (0, $hopDi$useEffect)(()=>{
        if (data) setEntitlementMenu(entValidTabsForMenu());
    }, [
        data
    ]);
    const shouldShowSidePanelSummaryForEntitlement = Boolean(data?.sidePanel?.summary && data?.sidePanel?.status[0, $d60257e8dc27bf16$export$bde14d5a1cbdb371]);
    const renderScoreMeter = ()=>{
        if (isTrustScoreEnabled) {
            // Check if score coming from confidence
            if (isTrustScoreEnabled?.enableCertificationTrustModel) {
                const upperLimitValue = configMap?.TRUST_LIKELYAPPROVAL_LOWER?.trim()?.length !== 0 ? Number(configMap?.TRUST_LIKELYAPPROVAL_LOWER) : null;
                const lowerLimitValue = configMap?.TRUST_POSSIBLEREJECT_UPPER?.trim()?.length !== 0 ? Number(configMap?.TRUST_POSSIBLEREJECT_UPPER) : null;
                const middleRange = String(configMap?.TRUST_POSSIBLEAPPROVAL);
                const { score: riskScore, kind: riskKind, label: riskLabel } = (0, $e7628c995f405891$export$33ebd1c882bff43f)(Number(data?.TRUST_SCORE) || Number(data?.JRMRULES?.TRUST_SCORE), upperLimitValue, lowerLimitValue, middleRange);
                if (riskKind === "info" || Number(riskScore) === 0) return null;
                return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "CertsSidePanelBody-tabContentSummaryShorts",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: ".CertsSidePanelBody-tabContentSummaryShortsStatus",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h4",
                                        children: "Trust"
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: isMobileWidth ? "CertsSidePanelBody-tabContentSummaryShortsRisk--mobileResponsive" : "CertsSidePanelBody-tabContentSummaryShortsRisk",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                                            kind: riskKind,
                                            size: isMobileWidth ? "small" : "regular",
                                            value: riskScore,
                                            label: riskLabel,
                                            shouldShowZero: true
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "CertsSidePanelBody-tabContentSummaryShortsRiskList",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $48ea1ae565a51e3b$export$2e2bcd8739ae039), {
                                                isTrustScoreEnabled: isTrustScoreEnabled,
                                                nodeData: data,
                                                certsKind: "Entitlement"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                    ]
                });
            }
            const riskScore = Number(data?.JRMRULES?.cnf || "0");
            const { kind: riskKind, label: riskLabel } = (0, $e7628c995f405891$export$622a7128677021ae)(data?.JRMRULES?.rmd);
            if (riskKind === "info" || Number(riskScore) === 0) return null;
            return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsSidePanelBody-tabContentSummaryShorts",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: ".CertsSidePanelBody-tabContentSummaryShortsStatus",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "h4",
                                    children: "Trust"
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: isMobileWidth ? "CertsSidePanelBody-tabContentSummaryShortsRisk--mobileResponsive" : "CertsSidePanelBody-tabContentSummaryShortsRisk",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                                        kind: riskKind,
                                        size: isMobileWidth ? "small" : "regular",
                                        value: riskScore,
                                        label: riskLabel
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskList",
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $48ea1ae565a51e3b$export$2e2bcd8739ae039), {
                                            isTrustScoreEnabled: isTrustScoreEnabled,
                                            nodeData: data,
                                            certsKind: "Entitlement"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                ]
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
                moreContainerRef: tabGroupSidePanelRef,
                value: activeTab,
                isVerticalWithOverFlow: isMobileWidth,
                onChange: handleTabChange,
                isTabOrderBeFixed: true,
                className: "CertsSidePanelBody-tabGroup",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "Summary",
                        value: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Document",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "History",
                        value: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RequestHistory",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)),
                    renderMenuForEntitlement(),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "CertsSidePanelBody-tabGroupEmpty",
                        value: (0, $d60257e8dc27bf16$export$8f78881bb4058858)
                    }, (0, $d60257e8dc27bf16$export$8f78881bb4058858))
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--summary",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                children: [
                    isTrustScoreEnabled && shouldShowSidePanelSummaryForEntitlement && renderScoreMeter(),
                    shouldShowSidePanelSummaryForEntitlement ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $f628408145ad5bcd$export$2e2bcd8739ae039), {
                        data: data
                    }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                        tab: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        retriggerApisForError: retriggerApisForError,
                        handleCloseSidePanel: handleCloseSidePanel
                    })
                ]
            }),
            renderHistoryContent(),
            renderSodContent(),
            renderPrivilegesContent(),
            renderChildrenContentForEntitlements(),
            renderDependentsContentForEntitlements()
        ]
    });
}
$497631ad0623d8a8$var$CertsSidePanelEntitlements.propTypes = {
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    activeTab: (0, $hopDi$proptypes).string.isRequired,
    setActiveTab: (0, $hopDi$proptypes).func.isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    retriggerApisForError: (0, $hopDi$proptypes).func,
    handleCloseSidePanel: (0, $hopDi$proptypes).func,
    tabGroupSidePanelRef: (0, $135adfecc1ed8f07$export$de87879afd52ccf9).isRequired
};
$497631ad0623d8a8$var$CertsSidePanelEntitlements.defaultProps = {
    dataTestId: null,
    className: null,
    retriggerApisForError: ()=>{},
    handleCloseSidePanel: ()=>{}
};
var $497631ad0623d8a8$export$2e2bcd8739ae039 = $497631ad0623d8a8$var$CertsSidePanelEntitlements;


var $ce19cd0e10f2ccd9$export$2e2bcd8739ae039 = (0, $497631ad0623d8a8$export$2e2bcd8739ae039);





















function $43c5162f45fcf3ad$var$CertsSidePanelRoles({ dataTestId: dataTestId, className: className, data: data, activeTab: activeTab, setActiveTab: setActiveTab, isLoadingHistory: isLoadingHistory, retriggerApisForError: retriggerApisForError, handleCloseSidePanel: handleCloseSidePanel, tabGroupSidePanelRef: tabGroupSidePanelRef }) {
    const intl = (0, $hopDi$useIntl)();
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, configMap: configMap, isTrustScoreEnabled: isTrustScoreEnabled } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const classes = (0, $hopDi$classnames)("CertsSidePanelBody", className);
    const [showHistory, setShowHistory] = (0, $hopDi$useState)(false);
    const [isLoadingMoreData, setIsLoadingMoreData] = (0, $hopDi$useState)(false);
    const [viewMore, setViewMore] = (0, $hopDi$useState)({
        [(0, $d60257e8dc27bf16$export$6cc684447a8d7b17)]: {
            currentOffset: 0
        },
        [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: {
            currentOffset: 0
        }
    });
    const [entitlementSearchForRoles, setEntitlementSearchForRoles] = (0, $hopDi$useState)("");
    const [childrenSearchForRoles, setChildrenSearchForRoles] = (0, $hopDi$useState)("");
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mobileXlargeQuery.value <= mediaQueryValue;
    const callApiForLoadBtn = (tab)=>{
        setIsLoadingMoreData(true);
        switch(tab){
            case 0, $d60257e8dc27bf16$export$6cc684447a8d7b17:
                dispatch((0, $d623f23401a154f0$export$5410f6e40c605c13)(data.CERT_ROLEKEY, String(viewMore[0, $d60257e8dc27bf16$export$6cc684447a8d7b17].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            case 0, $d60257e8dc27bf16$export$51f82826650bc3c3:
                dispatch((0, $d623f23401a154f0$export$d602a5e5a48fdf7d)(data.CERT_ROLEKEY, String(viewMore[0, $d60257e8dc27bf16$export$51f82826650bc3c3].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), (0, $d6d78fc758ee4148$export$2e6684ed5543ad11))).then(()=>{
                    setViewMore((prevViewMore)=>({
                            ...prevViewMore,
                            [tab]: {
                                currentOffset: prevViewMore[tab].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)
                            }
                        }));
                    setIsLoadingMoreData(false);
                }).catch(()=>{
                    setIsLoadingMoreData(false);
                });
                break;
            default:
                break;
        }
    };
    (0, $hopDi$useEffect)(()=>{
        setEntitlementSearchForRoles("");
        setChildrenSearchForRoles("");
        setShowHistory(activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63));
    }, [
        activeTab
    ]);
    const handleTabChange = (value)=>{
        setActiveTab(value);
    };
    const renderHistoryContent = ()=>{
        if (showHistory) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$9b67fda1e37e6e63]) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--history",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e52ca6c769e8713d$export$2e2bcd8739ae039), {
                    data: data,
                    isLoadingHistory: isLoadingHistory,
                    isMobileWidth: isMobileWidth
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent--history",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
            children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {})
        });
    };
    const renderEntitlementTab = ()=>{
        if (data) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
            label: "Entitlement",
            value: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17),
            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: "Entitlement",
                size: "medium",
                color: "neutral-1000"
            }),
            size: "medium"
        }, (0, $d60257e8dc27bf16$export$6cc684447a8d7b17));
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty",
            value: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17)
        }, (0, $d60257e8dc27bf16$export$6cc684447a8d7b17));
    };
    const renderChildrenTabForRoles = ()=>{
        if (data) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) {
                if (data?.sidePanel?.children?.totalChildRole > 0) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Children",
                    value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Entitlement",
                        size: "medium",
                        color: "neutral-1000"
                    }),
                    size: "medium"
                }, (0, $d60257e8dc27bf16$export$51f82826650bc3c3));
                return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "CertsSidePanelBody-tabGroupEmpty"
                });
            }
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                label: "Children",
                value: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Entitlement",
                    size: "medium",
                    color: "neutral-1000"
                }),
                size: "medium"
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)("span", {
            className: "CertsSidePanelBody-tabGroupEmpty"
        });
    };
    const renderEntitlementContentForRoles = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$6cc684447a8d7b17]) {
            if (data?.sidePanel?.entitlements?.totalEnt > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--entitlement",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentEntitlementSearch",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                            name: "basic",
                            kind: "search",
                            placeholder: "Search by Entitlement Name",
                            prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "search",
                                color: "neutral-600",
                                size: "smallMedium"
                            }),
                            value: entitlementSearchForRoles,
                            setValue: setEntitlementSearchForRoles
                        })
                    }),
                    data?.sidePanel?.entitlements?.roleEntList.filter((child)=>`${child.entitlement_value}`.toLowerCase().indexOf(entitlementSearchForRoles.toLowerCase()) !== -1).map((child, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: child.entitlement_value,
                            iconKind: "Entitlement",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                Object.keys(child).filter((node)=>node !== "entitlement_value" && node !== "index").map((node)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                        fieldData: {
                                            label: messages[node] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(node)),
                                            value: child[node] || node
                                        }
                                    }, `${child.index}-${node}`)),
                                index !== data.sidePanel.entitlements.roleEntList.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, child.index)),
                    data?.sidePanel?.entitlements?.totalEnt > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$6cc684447a8d7b17].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.entitlements?.totalEnt || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$6cc684447a8d7b17)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$6cc684447a8d7b17),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const renderChildrenContentForRoles = ()=>{
        if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$51f82826650bc3c3]) {
            if (data?.sidePanel?.children?.totalChildRole > 0) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--child",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body3",
                        className: "CertsSidePanelBody-tabContentChildDescriptionGap",
                        children: `${"Text for gap"}`
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                        name: "basic",
                        kind: "search",
                        placeholder: "Search by Entitlement Name",
                        prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "search",
                            color: "neutral-600",
                            size: "smallMedium"
                        }),
                        value: childrenSearchForRoles,
                        setValue: setChildrenSearchForRoles
                    }),
                    data?.sidePanel?.children?.childRoleList.filter((child)=>`$${child.displayname}`.toLowerCase().indexOf(childrenSearchForRoles.toLowerCase()) !== -1).map((child, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $b291d00926535dc7$export$2e2bcd8739ae039), {
                            title: child.displayname || "",
                            iconKind: "Entitlement",
                            isInitialOpen: index < (0, $6702cb469143c6c9$export$14624c6c73370169),
                            children: [
                                Object.keys(child).filter((node)=>node !== "displayname" && node !== "index").map((node)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $5d9478e6fefd4bf2$export$2e2bcd8739ae039), {
                                        fieldData: {
                                            label: messages[node] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(node)),
                                            value: child[node] || node
                                        }
                                    }, `${child.index}-${node}`)),
                                index !== data.sidePanel.children.childRoleList.length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                            ]
                        }, child.index)),
                    data?.sidePanel?.children?.totalChildRole > (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsSidePanelBody-tabContentLoadBtn",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "subtle",
                            size: "medium",
                            isDisabled: viewMore[0, $d60257e8dc27bf16$export$51f82826650bc3c3].currentOffset + (0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7) > data?.sidePanel?.children?.totalChildRole || isLoadingMoreData,
                            onClick: ()=>callApiForLoadBtn((0, $d60257e8dc27bf16$export$51f82826650bc3c3)),
                            children: "Load More"
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)("span", {});
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            })
        });
    };
    const shouldShowSidePanelSummaryForRoles = Boolean(data?.sidePanel?.summary && data?.sidePanel?.status[0, $d60257e8dc27bf16$export$bde14d5a1cbdb371]);
    const renderScoreMeter = ()=>{
        if (isTrustScoreEnabled) {
            // Check if score coming from confidence
            if (isTrustScoreEnabled?.enableCertificationTrustModel) {
                const upperLimitValue = configMap?.TRUST_LIKELYAPPROVAL_LOWER?.trim()?.length !== 0 ? Number(configMap?.TRUST_LIKELYAPPROVAL_LOWER) : null;
                const lowerLimitValue = configMap?.TRUST_POSSIBLEREJECT_UPPER?.trim()?.length !== 0 ? Number(configMap?.TRUST_POSSIBLEREJECT_UPPER) : null;
                const middleRange = String(configMap?.TRUST_POSSIBLEAPPROVAL);
                const { score: riskScore, kind: riskKind, label: riskLabel } = (0, $e7628c995f405891$export$33ebd1c882bff43f)(Number(data?.TRUST_SCORE) || Number(data?.JRMRULES?.TRUST_SCORE), upperLimitValue, lowerLimitValue, middleRange);
                if (riskKind === "info" || Number(riskScore) === 0) return null;
                return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "CertsSidePanelBody-tabContentSummaryShorts",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: ".CertsSidePanelBody-tabContentSummaryShortsStatus",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h4",
                                        children: "Trust"
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: isMobileWidth ? "CertsSidePanelBody-tabContentSummaryShortsRisk--mobileResponsive" : "CertsSidePanelBody-tabContentSummaryShortsRisk",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "CertsSidePanelBody-tabContentSummaryShortsRiskScore",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                                                kind: riskKind,
                                                size: isMobileWidth ? "small" : "regular",
                                                value: riskScore,
                                                label: riskLabel,
                                                shouldShowZero: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "CertsSidePanelBody-tabContentSummaryShortsRiskList",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $48ea1ae565a51e3b$export$2e2bcd8739ae039), {
                                                isTrustScoreEnabled: isTrustScoreEnabled,
                                                nodeData: data,
                                                certsKind: "Role"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                    ]
                });
            }
            const riskScore = Number(data?.JRMRULES?.cnf || "0");
            const { kind: riskKind, label: riskLabel } = (0, $e7628c995f405891$export$622a7128677021ae)(data?.JRMRULES?.rmd);
            if (riskKind === "info" || Number(riskScore) === 0) return null;
            return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsSidePanelBody-tabContentSummaryShorts",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: ".CertsSidePanelBody-tabContentSummaryShortsStatus",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "h4",
                                    children: "Trust"
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: isMobileWidth ? "CertsSidePanelBody-tabContentSummaryShortsRisk--mobileResponsive" : "CertsSidePanelBody-tabContentSummaryShortsRisk",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskScore",
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $d890b5a3788f0783$export$2e2bcd8739ae039), {
                                            kind: riskKind,
                                            size: isMobileWidth ? "small" : "regular",
                                            value: riskScore,
                                            label: riskLabel
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: "CertsSidePanelBody-tabContentSummaryShortsRiskList",
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $48ea1ae565a51e3b$export$2e2bcd8739ae039), {
                                            isTrustScoreEnabled: isTrustScoreEnabled,
                                            nodeData: data,
                                            certsKind: "Role"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $030549388b36232f$export$2e2bcd8739ae039), {})
                ]
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
                moreContainerRef: tabGroupSidePanelRef,
                value: activeTab,
                isVerticalWithOverFlow: isMobileWidth,
                onChange: handleTabChange,
                isTabOrderBeFixed: true,
                className: "CertsSidePanelBody-tabGroup",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "Summary",
                        value: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Document",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "History",
                        value: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RequestHistory",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)),
                    renderEntitlementTab(),
                    renderChildrenTabForRoles()
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--summary",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                children: [
                    isTrustScoreEnabled && shouldShowSidePanelSummaryForRoles && renderScoreMeter(),
                    shouldShowSidePanelSummaryForRoles ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $f628408145ad5bcd$export$2e2bcd8739ae039), {
                        data: data
                    }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                        tab: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        retriggerApisForError: retriggerApisForError,
                        handleCloseSidePanel: handleCloseSidePanel
                    })
                ]
            }),
            renderHistoryContent(),
            renderEntitlementContentForRoles(),
            renderChildrenContentForRoles()
        ]
    });
}
$43c5162f45fcf3ad$var$CertsSidePanelRoles.propTypes = {
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    activeTab: (0, $hopDi$proptypes).string.isRequired,
    setActiveTab: (0, $hopDi$proptypes).func.isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    retriggerApisForError: (0, $hopDi$proptypes).func,
    handleCloseSidePanel: (0, $hopDi$proptypes).func,
    tabGroupSidePanelRef: (0, $135adfecc1ed8f07$export$de87879afd52ccf9).isRequired
};
$43c5162f45fcf3ad$var$CertsSidePanelRoles.defaultProps = {
    dataTestId: null,
    className: null,
    retriggerApisForError: ()=>{},
    handleCloseSidePanel: ()=>{}
};
var $43c5162f45fcf3ad$export$2e2bcd8739ae039 = $43c5162f45fcf3ad$var$CertsSidePanelRoles;


var $5de156f3e0748d5b$export$2e2bcd8739ae039 = (0, $43c5162f45fcf3ad$export$2e2bcd8739ae039);













function $91ffcbef557bd0e8$var$CertsSidePanelUsers({ dataTestId: dataTestId, className: className, data: data, activeTab: activeTab, setActiveTab: setActiveTab, isLoadingHistory: isLoadingHistory, retriggerApisForError: retriggerApisForError, handleCloseSidePanel: handleCloseSidePanel, tabGroupSidePanelRef: tabGroupSidePanelRef }) {
    const classes = (0, $hopDi$classnames)("CertsSidePanelBody", className);
    const [showHistory, setShowHistory] = (0, $hopDi$useState)(false);
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mobileXlargeQuery.value <= mediaQueryValue;
    (0, $hopDi$useEffect)(()=>{
        setShowHistory(activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63));
    }, [
        activeTab
    ]);
    const handleTabChange = (value)=>{
        setActiveTab(value);
    };
    const renderHistoryContent = ()=>{
        if (showHistory) {
            if (data?.sidePanel?.status[0, $d60257e8dc27bf16$export$9b67fda1e37e6e63]) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--history",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e52ca6c769e8713d$export$2e2bcd8739ae039), {
                    data: data,
                    isLoadingHistory: isLoadingHistory,
                    isMobileWidth: isMobileWidth
                })
            });
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                tab: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                retriggerApisForError: retriggerApisForError,
                handleCloseSidePanel: handleCloseSidePanel
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
            className: "CertsSidePanelBody-tabContent--history",
            value: activeTab,
            tabValue: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
            children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {})
        });
    };
    const shouldShowSidePanelSummaryForUsers = Boolean(data?.sidePanel?.summary && data?.sidePanel?.status[0, $d60257e8dc27bf16$export$bde14d5a1cbdb371]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        className: classes,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
                moreContainerRef: tabGroupSidePanelRef,
                value: activeTab,
                onChange: handleTabChange,
                isTabOrderBeFixed: true,
                isVerticalWithOverFlow: isMobileWidth,
                className: "CertsSidePanelBody-tabGroup",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "Summary",
                        value: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Document",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                        label: "History",
                        value: (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63),
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "RequestHistory",
                            size: "medium",
                            color: "neutral-1000"
                        }),
                        size: "medium"
                    }, (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)),
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "CertsSidePanelBody-tabGroupEmpty"
                    }, `${(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)}-1`)
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                className: "CertsSidePanelBody-tabContent--summary",
                value: activeTab,
                tabValue: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                children: shouldShowSidePanelSummaryForUsers ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $f628408145ad5bcd$export$2e2bcd8739ae039), {
                    data: data
                }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $8198211ef3cd686e$export$2e2bcd8739ae039), {
                    tab: (0, $d60257e8dc27bf16$export$bde14d5a1cbdb371),
                    retriggerApisForError: retriggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                })
            }),
            renderHistoryContent()
        ]
    });
}
$91ffcbef557bd0e8$var$CertsSidePanelUsers.propTypes = {
    dataTestId: (0, $hopDi$proptypes).string,
    className: (0, $hopDi$proptypes).string,
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    activeTab: (0, $hopDi$proptypes).string.isRequired,
    setActiveTab: (0, $hopDi$proptypes).func.isRequired,
    isLoadingHistory: (0, $hopDi$proptypes).bool.isRequired,
    retriggerApisForError: (0, $hopDi$proptypes).func,
    handleCloseSidePanel: (0, $hopDi$proptypes).func,
    tabGroupSidePanelRef: (0, $135adfecc1ed8f07$export$de87879afd52ccf9).isRequired
};
$91ffcbef557bd0e8$var$CertsSidePanelUsers.defaultProps = {
    dataTestId: null,
    className: null,
    retriggerApisForError: ()=>{},
    handleCloseSidePanel: ()=>{}
};
var $91ffcbef557bd0e8$export$2e2bcd8739ae039 = $91ffcbef557bd0e8$var$CertsSidePanelUsers;


var $a907449f3dde7b07$export$2e2bcd8739ae039 = (0, $91ffcbef557bd0e8$export$2e2bcd8739ae039);




function $56256445b185fcc5$var$CertsSidePanelBody({ data: data, handleCloseSidePanel: handleCloseSidePanel, tabGroupSidePanelRef: tabGroupSidePanelRef, className: className, dataTestId: dataTestId }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, isSidePanelLoading: isSidePanelLoading, sidePanelUsers: sidePanelUsers, sidePanelRoles: sidePanelRoles, sidePanelAccounts: sidePanelAccounts, sidePanelEntitlements: sidePanelEntitlements } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [activeTab, setActiveTab] = (0, $hopDi$useState)((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
    const [isLoadingHistory, setIsLoadingHistory] = (0, $hopDi$useState)(false);
    const [users, setUsers] = (0, $hopDi$useState)({
        ...data,
        sidePanel: {
            status: {
                [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false
            }
        }
    });
    const [roles, setRoles] = (0, $hopDi$useState)({
        ...data,
        sidePanel: {
            status: {
                [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false,
                [(0, $d60257e8dc27bf16$export$6cc684447a8d7b17)]: false,
                [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: false
            }
        }
    });
    const [accounts, setAccounts] = (0, $hopDi$useState)({
        ...data,
        sidePanel: {
            status: {
                [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false
            }
        }
    });
    const [entitlements, setEntitlements] = (0, $hopDi$useState)({
        ...data,
        sidePanel: {
            unFixedTabs: [
                (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)
            ],
            status: {
                [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false,
                [(0, $d60257e8dc27bf16$export$8f78881bb4058858)]: false,
                [(0, $d60257e8dc27bf16$export$a06b6c2be556dac8)]: false,
                [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: false,
                [(0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)]: false
            }
        }
    });
    const promisesForSidePanel = [];
    const sidePanelBodyClasses = (0, $hopDi$classnames)("SidePanelView", (isSidePanelLoading || isLoadingHistory) && "CertsSidePanelBody--isSidePanelLoading", className);
    const callApiForHistory = ()=>{
        setIsLoadingHistory(true);
        switch(data?.type){
            case 0, $d60257e8dc27bf16$export$1cc98074061c90d2:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$ac08493018d65897)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setUsers((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoadingHistory(false);
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$8ea25d5aa1748f67)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ROLEKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setRoles((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoadingHistory(false);
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$153ab95c08227093:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$188b24a44048ab8)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setAccounts((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoadingHistory(false);
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7:
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$46991d3da34782bf)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY, data.CERT_ROLEKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    const statusToExtend = {};
                    responses.forEach((response)=>{
                        if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
                    });
                    setEntitlements((prev)=>({
                            ...prev,
                            sidePanel: {
                                ...prev.sidePanel,
                                status: {
                                    ...prev.sidePanel.status,
                                    ...statusToExtend
                                }
                            }
                        }));
                }).finally(()=>{
                    setIsLoadingHistory(false);
                    promisesForSidePanel.length = 0;
                });
                break;
            default:
                break;
        }
    };
    const checksInThenBlock = (responses, setterFunc)=>{
        const isAtleastOnePromiseFullfiled = responses.some((response)=>response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5));
        const isAtleastOnePromiseForcedCancelled = responses.some((response)=>response?.reason?.message === (0, $6702cb469143c6c9$export$2444563004f47e89));
        if (isAtleastOnePromiseForcedCancelled) return;
        if (!isAtleastOnePromiseFullfiled) throw new Error({
            status: false
        });
        const statusToExtend = {};
        responses.forEach((response)=>{
            if (response.status === (0, $6702cb469143c6c9$export$8a2c144908a2b8f5)) statusToExtend[response.value] = true;
        });
        setterFunc((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    status: {
                        ...prev.sidePanel.status,
                        ...statusToExtend
                    }
                }
            }));
        dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(false));
    };
    const checksInCatchBlock = (state, setterFunc)=>{
        const statusToExtend = {};
        Object.keys(state?.sidePanel.status).forEach((key)=>{
            statusToExtend[key] = false;
        });
        setterFunc((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    status: {
                        ...prev.sidePanel.status,
                        ...statusToExtend
                    }
                }
            }));
        dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(false));
    };
    const callApiByType = ()=>{
        switch(data?.type){
            case 0, $d60257e8dc27bf16$export$1cc98074061c90d2:
                dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(true));
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$d5a553b80e9461bd)(data.id, certKey, data.CERT_USERKEY)), dispatch((0, $d623f23401a154f0$export$ac08493018d65897)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    checksInThenBlock(responses, setUsers);
                }).catch(()=>{
                    checksInCatchBlock(users, setUsers);
                }).finally(()=>{
                    setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2:
                dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(true));
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$d2ad049199ba44f6)(data.id, certKey, data.CERT_ROLEKEY)), dispatch((0, $d623f23401a154f0$export$8ea25d5aa1748f67)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ROLEKEY)), dispatch((0, $d623f23401a154f0$export$5410f6e40c605c13)(data.CERT_ROLEKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))), dispatch((0, $d623f23401a154f0$export$d602a5e5a48fdf7d)(data.CERT_ROLEKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    checksInThenBlock(responses, setRoles);
                }).catch(()=>{
                    checksInCatchBlock(roles, setRoles);
                }).finally(()=>{
                    setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$153ab95c08227093:
                dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(true));
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$b903631ea95845bc)(data.id, certKey)), dispatch((0, $d623f23401a154f0$export$188b24a44048ab8)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY)));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    checksInThenBlock(responses, setAccounts);
                }).catch(()=>{
                    checksInCatchBlock(accounts, setAccounts);
                }).finally(()=>{
                    setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
                    promisesForSidePanel.length = 0;
                });
                break;
            case 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7:
                dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(true));
                promisesForSidePanel.push(dispatch((0, $d623f23401a154f0$export$965ea1a49a0c67d1)(data.id, certKey, data.CERT_ENTITLEMENT_VALUEKEY)), dispatch((0, $d623f23401a154f0$export$46991d3da34782bf)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_USERKEY, data.CERT_ACCOUNTKEY, data.CERT_ROLEKEY)), dispatch((0, $d623f23401a154f0$export$83557c31dc95212a)(data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_ACCOUNTKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))), dispatch((0, $d623f23401a154f0$export$1fbc321c679e35cc)(certKey, data.CERT_ENTITLEMENT_VALUEKEY, data.CERT_ACCOUNTKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)), "")), dispatch((0, $d623f23401a154f0$export$f8b073a05f313ac0)(data.CERT_ENTITLEMENT_VALUEKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))), dispatch((0, $d623f23401a154f0$export$3b9a16a7c2bd6829)(data.CERT_ENTITLEMENT_VALUEKEY, "0", String((0, $6702cb469143c6c9$export$29ae9ca85e0eb4a7)))));
                Promise.allSettled(promisesForSidePanel).then((responses)=>{
                    checksInThenBlock(responses, setEntitlements);
                }).catch(()=>{
                    checksInCatchBlock(entitlements, setEntitlements);
                }).finally(()=>{
                    setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
                    promisesForSidePanel.length = 0;
                });
                break;
            default:
                break;
        }
    };
    (0, $hopDi$useEffect)(()=>{
        setUsers((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    ...sidePanelUsers
                }
            }));
    }, [
        sidePanelUsers
    ]);
    (0, $hopDi$useEffect)(()=>{
        setRoles((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    ...sidePanelRoles
                }
            }));
    }, [
        sidePanelRoles
    ]);
    (0, $hopDi$useEffect)(()=>{
        setAccounts((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    ...sidePanelAccounts
                }
            }));
    }, [
        sidePanelAccounts
    ]);
    (0, $hopDi$useEffect)(()=>{
        setEntitlements((prev)=>({
                ...prev,
                sidePanel: {
                    ...prev.sidePanel,
                    ...sidePanelEntitlements
                }
            }));
    }, [
        sidePanelEntitlements
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (data && certKey) {
            dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(true));
            setActiveTab((0, $d60257e8dc27bf16$export$bde14d5a1cbdb371));
            setUsers({
                ...data,
                sidePanel: {
                    status: {
                        [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                        [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false
                    }
                }
            });
            setRoles({
                ...data,
                sidePanel: {
                    status: {
                        [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                        [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false,
                        [(0, $d60257e8dc27bf16$export$6cc684447a8d7b17)]: false,
                        [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: false
                    }
                }
            });
            setAccounts({
                ...data,
                sidePanel: {
                    status: {
                        [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                        [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false
                    }
                }
            });
            setEntitlements({
                ...data,
                sidePanel: {
                    unFixedTabs: [
                        (0, $d60257e8dc27bf16$export$8f78881bb4058858),
                        (0, $d60257e8dc27bf16$export$a06b6c2be556dac8),
                        (0, $d60257e8dc27bf16$export$51f82826650bc3c3),
                        (0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)
                    ],
                    status: {
                        [(0, $d60257e8dc27bf16$export$bde14d5a1cbdb371)]: false,
                        [(0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)]: false,
                        [(0, $d60257e8dc27bf16$export$8f78881bb4058858)]: false,
                        [(0, $d60257e8dc27bf16$export$a06b6c2be556dac8)]: false,
                        [(0, $d60257e8dc27bf16$export$51f82826650bc3c3)]: false,
                        [(0, $d60257e8dc27bf16$export$ed0bf72b1f4a9681)]: false
                    }
                }
            });
            callApiByType();
        }
    }, [
        certKey,
        data
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (activeTab === (0, $d60257e8dc27bf16$export$9b67fda1e37e6e63)) callApiForHistory();
    }, [
        activeTab
    ]);
    const retriggerApisForError = ()=>{
        dispatch((0, $d623f23401a154f0$export$61e757f80085daf4)(true));
        callApiByType();
    };
    const renderSidePanelView = ()=>{
        switch(data?.type){
            case 0, $d60257e8dc27bf16$export$1cc98074061c90d2:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $a907449f3dde7b07$export$2e2bcd8739ae039), {
                    tabGroupSidePanelRef: tabGroupSidePanelRef,
                    activeTab: activeTab,
                    setActiveTab: setActiveTab,
                    data: users,
                    isLoadingHistory: isLoadingHistory,
                    retriggerApisForError: retriggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                });
            case 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $5de156f3e0748d5b$export$2e2bcd8739ae039), {
                    tabGroupSidePanelRef: tabGroupSidePanelRef,
                    activeTab: activeTab,
                    setActiveTab: setActiveTab,
                    data: roles,
                    isLoadingHistory: isLoadingHistory,
                    retriggerApisForError: retriggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                });
            case 0, $d60257e8dc27bf16$export$153ab95c08227093:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $3ddf9bde0f45f198$export$2e2bcd8739ae039), {
                    tabGroupSidePanelRef: tabGroupSidePanelRef,
                    activeTab: activeTab,
                    setActiveTab: setActiveTab,
                    data: accounts,
                    isLoadingHistory: isLoadingHistory,
                    retriggerApisForError: retriggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                });
            case 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7:
                return /*#__PURE__*/ (0, $hopDi$jsx)((0, $ce19cd0e10f2ccd9$export$2e2bcd8739ae039), {
                    tabGroupSidePanelRef: tabGroupSidePanelRef,
                    activeTab: activeTab,
                    setActiveTab: setActiveTab,
                    data: entitlements,
                    isLoadingHistory: isLoadingHistory,
                    retriggerApisForError: retriggerApisForError,
                    handleCloseSidePanel: handleCloseSidePanel
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)("aside", {
        className: sidePanelBodyClasses,
        "data-test-id": dataTestId,
        children: isSidePanelLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "SidePanelView-loader",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "info",
                size: "medium"
            })
        }) : renderSidePanelView()
    });
}
$56256445b185fcc5$var$CertsSidePanelBody.propTypes = {
    data: (0, $hopDi$proptypes).shape((0, $708c26a04684b266$export$2e2bcd8739ae039)).isRequired,
    handleCloseSidePanel: (0, $hopDi$proptypes).func.isRequired,
    tabGroupSidePanelRef: (0, $135adfecc1ed8f07$export$de87879afd52ccf9).isRequired,
    className: (0, $hopDi$proptypes).string,
    dataTestId: (0, $hopDi$proptypes).string
};
$56256445b185fcc5$var$CertsSidePanelBody.defaultProps = {
    className: null,
    dataTestId: null
};
var $56256445b185fcc5$export$2e2bcd8739ae039 = $56256445b185fcc5$var$CertsSidePanelBody;


var $e87eca063f13fc28$export$2e2bcd8739ae039 = (0, $56256445b185fcc5$export$2e2bcd8739ae039);












function $0a5df443e4be28d9$var$CertsSidePanelFooter({ nodeData: nodeData, actionsData: actionsData, handleAutoSelectParent: handleAutoSelectParent, setMergedLists: setMergedLists, isMobileMode: isMobileMode, dataTestId: dataTestId, className: className }) {
    const { bulkAction: bulkAction } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const sidePanelFooterClasses = (0, $hopDi$classnames)("CertsSidePanelFooter", className);
    const checkForActions = nodeData?.availableAction && Object.keys(nodeData?.availableAction).length > 0;
    const isSaviResponded = Boolean(nodeData?.savi_responded && nodeData?.savi_responded === "1");
    const saviRespondedReason = [];
    if (isSaviResponded && nodeData?.savi_reason && nodeData?.savi_reason.length > 0) nodeData?.savi_reason.map((item)=>saviRespondedReason.push(item));
    const getGroupTooltipText = ()=>{
        if (isMobileMode) return "Options for multiple-item selections are available in the toolbar behind.";
        return "Options for multiple-item selections are available in the toolbar on left.";
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "section",
        className: sidePanelFooterClasses,
        "data-testid": dataTestId,
        children: checkForActions && /*#__PURE__*/ (0, $hopDi$jsx)((0, $f7cd7b23cff7a54f$export$2e2bcd8739ae039), {
            kind: (0, $20281fe09bc700a8$export$758743ec42a300f1).FOOTER,
            nodeData: nodeData || {},
            actionsData: actionsData,
            handleAutoSelectParent: handleAutoSelectParent,
            setMergedLists: setMergedLists,
            groupTooltipText: bulkAction?.isAtleastOneSelected || bulkAction?.isChecked ? getGroupTooltipText() : null,
            isGroupDisabled: bulkAction?.isAtleastOneSelected || bulkAction?.isChecked,
            isSaviResponded: isSaviResponded,
            saviRespondedReason: saviRespondedReason
        })
    });
}
$0a5df443e4be28d9$var$CertsSidePanelFooter.propTypes = {
    nodeData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)),
    actionsData: (0, $hopDi$proptypes).shape((0, $ddbc2f861c0388ff$export$98aa68d7c06704e9)),
    handleAutoSelectParent: (0, $hopDi$proptypes).func.isRequired,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    isMobileMode: (0, $hopDi$proptypes).bool,
    className: (0, $hopDi$proptypes).string,
    dataTestId: (0, $hopDi$proptypes).string
};
$0a5df443e4be28d9$var$CertsSidePanelFooter.defaultProps = {
    nodeData: null,
    actionsData: null,
    isMobileMode: false,
    className: null,
    dataTestId: null
};
var $0a5df443e4be28d9$export$2e2bcd8739ae039 = $0a5df443e4be28d9$var$CertsSidePanelFooter;


var $b69fc74405c20c63$export$2e2bcd8739ae039 = (0, $0a5df443e4be28d9$export$2e2bcd8739ae039);




const $9bf869d146a874af$export$42ad9f3c9ee8e12f = (key)=>{
    if (key === (0, $d60257e8dc27bf16$export$1cc98074061c90d2)) return {
        title: (0, $d60257e8dc27bf16$export$dc13af498303679),
        desc: (0, $d60257e8dc27bf16$export$76f2b9e2abf8cf0c)
    };
    if (key === (0, $d60257e8dc27bf16$export$7d6712c2cb8377b2)) return {
        title: (0, $d60257e8dc27bf16$export$669183101cc88fb6),
        desc: (0, $d60257e8dc27bf16$export$71193c4d5e3b3956)
    };
    if (key === (0, $d60257e8dc27bf16$export$153ab95c08227093)) return {
        title: (0, $d60257e8dc27bf16$export$843e8b0030038872),
        desc: (0, $d60257e8dc27bf16$export$c0a9d10def3a6309)
    };
    if (key === (0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7)) return {
        title: (0, $d60257e8dc27bf16$export$9dee3ced165b51d1),
        desc: (0, $d60257e8dc27bf16$export$6940d0d32ae129a1)
    };
    return {};
};
const $9bf869d146a874af$export$33914de34c28be6c = (type)=>{
    switch(type){
        case 0, $d60257e8dc27bf16$export$1cc98074061c90d2:
            return "user";
        case 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2:
            return "role";
        case 0, $d60257e8dc27bf16$export$153ab95c08227093:
            return "certsaccount";
        case 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7:
            return "entitlement";
        default:
            return 0, $d60257e8dc27bf16$export$7219e4813ca4abf0;
    }
};
var $9bf869d146a874af$export$2e2bcd8739ae039 = {
    getKeysForSidePanelHeader: $9bf869d146a874af$export$42ad9f3c9ee8e12f,
    setIcon: $9bf869d146a874af$export$33914de34c28be6c
};



function $d5379df310c40957$var$CertsSidePanel({ data: data, actionsData: actionsData, handleAutoSelectParent: handleAutoSelectParent, handleSidePanelTileButton: handleSidePanelTileButton, handleSidePanelBreadCrumbAction: handleSidePanelBreadCrumbAction, checkNodePosition: checkNodePosition, isOpen: isOpen, setMergedLists: setMergedLists, dataTestId: dataTestId }) {
    const [currentTab, setCurrentTab] = (0, $hopDi$useState)(null);
    const [isDisabledUp, setIsDisabledUp] = (0, $hopDi$useState)(true);
    const [isDisabledDown, setIsDisabledDown] = (0, $hopDi$useState)(true);
    const certsSidePanelRef = (0, $hopDi$useRef)();
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const headerObj = (0, $9bf869d146a874af$export$42ad9f3c9ee8e12f)(data?.type);
    const nodeId = data?.tracker?.id;
    const handleCloseSidePanel = (0, $hopDi$useCallback)(()=>{
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
    }, [
        data
    ]);
    // Tablet size Modal list navigaion
    const onClickUp = ()=>handleSidePanelTileButton(nodeId, (0, $135adfecc1ed8f07$export$f0065dd01c1d9ed2).UP);
    const onClickDown = ()=>handleSidePanelTileButton(nodeId, (0, $135adfecc1ed8f07$export$f0065dd01c1d9ed2).DOWN);
    (0, $hopDi$useEffect)(()=>{
        if (tabs.tabData) {
            const activeTab = tabs.tabData.find((tab)=>tab.isActive);
            if (activeTab) setCurrentTab(activeTab.key);
        }
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (tabs?.tabData) {
            const activeTab = tabs.tabData.find((tab)=>tab.isActive);
            if (currentTab && currentTab !== activeTab.key) handleCloseSidePanel();
        }
    }, [
        tabs,
        currentTab
    ]);
    (0, $hopDi$useEffect)(()=>{
        const { isDisabledUp: upDisabled, isDisabledDown: downDisabled } = checkNodePosition(nodeId);
        setIsDisabledUp(upDisabled);
        setIsDisabledDown(downDisabled);
    }, [
        nodeId
    ]);
    let title = data[headerObj?.title];
    let desc = data[headerObj?.desc];
    if (data[headerObj?.title] && typeof data[headerObj?.title] === "string" && data[headerObj?.title]?.includes("<br")) title = data[headerObj?.title]?.replace(/<br\s*\/?>/gm, "\n");
    if (data[headerObj?.desc] && typeof data[headerObj?.desc] === "string" && data[headerObj?.desc]?.includes("<br")) desc = data[headerObj?.desc]?.replace(/<br\s*\/?>/gm, "\n");
    const tabletSmallQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$6e89092ed3d96394));
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isTabletSmallWidth = tabletSmallQuery.value <= mediaQueryValue;
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    const certsSidePanelBody = /*#__PURE__*/ (0, $hopDi$jsx)((0, $e87eca063f13fc28$export$2e2bcd8739ae039), {
        data: data,
        handleCloseSidePanel: handleCloseSidePanel,
        tabGroupSidePanelRef: certsSidePanelRef
    });
    const certsSidePanelFooter = /*#__PURE__*/ (0, $hopDi$jsx)((0, $b69fc74405c20c63$export$2e2bcd8739ae039), {
        nodeData: data,
        actionsData: actionsData,
        handleAutoSelectParent: handleAutoSelectParent,
        setMergedLists: setMergedLists,
        isMobileMode: !isTabletSmallWidth || isMobileXlargeWidth
    });
    const breadCrumbData = [];
    if (Array.isArray(data?.tracker?.parents) && data?.tracker?.parents.length > 0) {
        data?.tracker?.parents.forEach((parent)=>{
            const parentHeaderObj = (0, $9bf869d146a874af$export$42ad9f3c9ee8e12f)(parent?.type);
            breadCrumbData.push({
                text: parent[parentHeaderObj?.title],
                onClick: ()=>{},
                icon: parent?.type,
                level: parent?.level,
                isActive: false
            });
        });
        breadCrumbData.push({
            text: title,
            onClick: ()=>{},
            icon: data?.type,
            level: data?.tracker?.level,
            isActive: true
        });
    }
    // TODO: @Jacob, Temp for alertbanners remove post Sidepanel overlay update (ReactDOM.createPortal)
    if (isMobileXlargeWidth) return /*#__PURE__*/ (0, $hopDi$reactdom).createPortal(/*#__PURE__*/ (0, $hopDi$jsx)((0, $1854031227665b12$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: handleCloseSidePanel,
        header: {
            title: title || "",
            description: desc || "",
            icon: (0, $9bf869d146a874af$export$33914de34c28be6c)(data?.type)
        },
        layout: certsSidePanelBody,
        footer: certsSidePanelFooter,
        breadCrumb: breadCrumbData,
        breadCrumbOnClick: handleSidePanelBreadCrumbAction,
        className: "CertsSidePanel",
        layoutClassName: "CertsSidePanel-layout",
        isPrevDisabled: isDisabledUp,
        isNextDisabled: isDisabledDown,
        onClickNext: onClickDown,
        onClickPrev: onClickUp,
        dataTestId: dataTestId
    }), document.body);
    // TODO: @Jacob, Temp for alertbanners remove post Sidepanel overlay update (ReactDOM.createPortal)
    if (isTabletSmallWidth) return /*#__PURE__*/ (0, $hopDi$reactdom).createPortal(/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$SidePanel), {
        ref: certsSidePanelRef,
        isOpen: isOpen,
        onClose: handleCloseSidePanel,
        header: {
            title: title || "",
            description: desc || "",
            icon: (0, $9bf869d146a874af$export$33914de34c28be6c)(data?.type)
        },
        layout: certsSidePanelBody,
        footer: certsSidePanelFooter,
        isSidePanelNavigatingList: true,
        onClickUp: onClickUp,
        onClickDown: onClickDown,
        isDisabledUp: isDisabledUp,
        isDisabledDown: isDisabledDown,
        isTabletWidth: isTabletSmallWidth,
        className: "CertsSidePanel",
        layoutClassName: "CertsSidePanel-layout",
        dataTestId: dataTestId
    }), document.body);
    // TODO: @Jacob, END
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$SidePanel), {
        ref: certsSidePanelRef,
        isOpen: isOpen,
        onClose: handleCloseSidePanel,
        header: {
            title: title || "",
            description: desc || "",
            icon: (0, $9bf869d146a874af$export$33914de34c28be6c)(data?.type)
        },
        layout: certsSidePanelBody,
        footer: certsSidePanelFooter,
        isSidePanelNavigatingList: true,
        onClickUp: onClickUp,
        onClickDown: onClickDown,
        isDisabledUp: isDisabledUp,
        isDisabledDown: isDisabledDown,
        isTabletWidth: isTabletSmallWidth,
        className: "CertsSidePanel",
        layoutClassName: "CertsSidePanel-layout",
        dataTestId: dataTestId
    });
}
$d5379df310c40957$var$CertsSidePanel.propTypes = {
    data: (0, $hopDi$proptypes).shape((0, $3dba689dd3c247a4$export$2e2bcd8739ae039)),
    actionsData: (0, $hopDi$proptypes).shape((0, $3dba689dd3c247a4$export$2e2bcd8739ae039)),
    handleAutoSelectParent: (0, $hopDi$proptypes).func.isRequired,
    handleSidePanelTileButton: (0, $hopDi$proptypes).func.isRequired,
    handleSidePanelBreadCrumbAction: (0, $hopDi$proptypes).func,
    checkNodePosition: (0, $hopDi$proptypes).func.isRequired,
    isOpen: (0, $hopDi$proptypes).bool,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    dataTestId: (0, $hopDi$proptypes).string
};
$d5379df310c40957$var$CertsSidePanel.defaultProps = {
    data: null,
    handleSidePanelBreadCrumbAction: ()=>{},
    actionsData: null,
    isOpen: false,
    dataTestId: null
};
var $d5379df310c40957$export$2e2bcd8739ae039 = $d5379df310c40957$var$CertsSidePanel;



var $37b43aaf389f3f5d$export$2e2bcd8739ae039 = (0, $d5379df310c40957$export$2e2bcd8739ae039);


const $bf14b63763e2d183$export$4767a28fbd1026ef = "decision";
const $bf14b63763e2d183$export$14ae8ea77646ac77 = "type";
const $bf14b63763e2d183$export$eb22cfe55ebb02f = "1";
const $bf14b63763e2d183$export$2b8c69d2b22250ea = "2";
const $bf14b63763e2d183$export$aebb42912407fb2d = "Pending";
const $bf14b63763e2d183$export$71efb3495f6084f2 = "Done";
const $bf14b63763e2d183$export$e135c39ae3ebb92e = "Total";
const $bf14b63763e2d183$export$39f29f4125141985 = "Consulted";
const $bf14b63763e2d183$export$fbc5ebe2e580bf8b = "Progress";
const $bf14b63763e2d183$export$c4cfef2de2ef9e6a = {
    APPROVED: "Approved",
    DONE: "Done",
    MANAGER_CONFIRMED: "Manager Confirmed",
    MANAGER_NOT_CONFIRMED: "Not Confirmed By Manager",
    REVOKED: "Revoked",
    CONSULT: "Consult",
    CONDITIONALLY_CERTIFIED: "Conditionally Certified",
    REJECTED: "Rejected",
    PENDING: "Pending",
    END_DATE_CHANGED: "End Date Changed",
    NO_ACTION_REQUIRED: "NoActionRequired",
    TERMINATED: "Terminated",
    REASSIGN: "Reassign",
    ROLE: "Role",
    USER: "User",
    ENTITLEMENT: "Entitlement",
    ACCOUNT: "Account"
};











/* eslint-disable react/jsx-one-expression-per-line */ 








const $322ec8c4879370a2$var$MIN_DAYS_FOR_REVOKE_WARNING = 7;
function $322ec8c4879370a2$var$CertsAutoRevokeWarning() {
    const [isVisible, setIsVisible] = (0, $hopDi$useState)(true);
    const [isEndDateInWarningRange, setIsEndDateInWarningRange] = (0, $hopDi$useState)(null);
    const [shouldNotShowWarningAgain, setShouldNotShowWarningAgain] = (0, $hopDi$useState)(false);
    const location = (0, $hopDi$useLocation)();
    const { certificationEndDate: certificationEndDate, autoRevokeWarningList: autoRevokeWarningList } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const queryParams = new URLSearchParams(location?.search);
    const certKey = queryParams.get("certkey");
    const certificationEndDateTime = certificationEndDate ? (0, $hopDi$moment)(certificationEndDate).utc() : null;
    const revokeDueDate = certificationEndDateTime ? certificationEndDateTime.format("DD/MM/YYYY") : "";
    const autoRevokeCookieKey = `${(0, $20281fe09bc700a8$export$9612f125f9c1cfb7).AUTO_REVOKE_WARN}${certKey}`;
    const autoRevokeWarningFlag = (0, $hopDi$getCookie)(autoRevokeCookieKey);
    const shouldNotShowAutoRevokeWarning = autoRevokeWarningFlag === "true";
    const isRevokeVisibleWithinDate = isVisible && isEndDateInWarningRange && autoRevokeWarningList.length > 0;
    (0, $hopDi$useEffect)(()=>{
        // Check cookies for revoke warning flag
        if (shouldNotShowAutoRevokeWarning) setIsVisible(false);
    }, []);
    (0, $hopDi$useEffect)(()=>{
        if (certificationEndDate) {
            const currentDate = (0, $hopDi$moment)().utc();
            const daysDifference = certificationEndDateTime.diff(currentDate, "days");
            if (daysDifference < 0) setIsEndDateInWarningRange(false);
            else setIsEndDateInWarningRange(daysDifference <= $322ec8c4879370a2$var$MIN_DAYS_FOR_REVOKE_WARNING);
        }
    }, [
        certificationEndDate
    ]);
    const setAutoRevokeCookie = (checkedState)=>{
        const currentDate = (0, $hopDi$moment)().utc();
        const daysDifference = certificationEndDateTime.diff(currentDate, "days");
        (0, $hopDi$setCookieDaysTillExpired)(autoRevokeCookieKey, checkedState, daysDifference + 1);
    };
    const handleCheckboxChange = (e)=>{
        setShouldNotShowWarningAgain(e.target.checked);
        setAutoRevokeCookie(e.target.checked);
    };
    const headerDetail = `If you don\u{2019}t submit your certification by the due date (${revokeDueDate}),
  some access will be automatically revoked.`;
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$StackingAlertBanner), {
        colorTheme: "Warning",
        kind: "low",
        title: "Automatic Access Revocation Notice",
        description: headerDetail,
        isVisible: isRevokeVisibleWithinDate,
        onCancel: ()=>setIsVisible(false),
        expandButtonLabels: {
            expanded: "Show Less",
            collapsed: "Show More"
        },
        expandingContent: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    className: "CertsAutoRevokeWarning-expandedBodyText",
                    children: "This campaign has been configured so that the following items will be revoked after the due date:"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: "CertsAutoRevokeWarning-expandedBodyList",
                    children: autoRevokeWarningList?.map((value)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            kind: "body2",
                            className: "CertsAutoRevokeWarning-expandedBodyText",
                            children: [
                                "\u2022 ",
                                value
                            ]
                        }, value))
                })
            ]
        }),
        content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
            name: "dontShowCheck",
            kind: "simpleText",
            isChecked: shouldNotShowWarningAgain,
            onChange: handleCheckboxChange,
            label: "Don\u2019t show me this message again for this certification",
            textPosition: "after",
            showHoverEffect: true
        })
    });
}
var $322ec8c4879370a2$export$2e2bcd8739ae039 = $322ec8c4879370a2$var$CertsAutoRevokeWarning;




// File order, please maintain or add to:
// - Action Error
// - Info Banner
// - Personalization Banners
// - Auto Revoke Warning
function $987dc9af54194992$var$CertAlerts() {
    // Action Error
    const [isActionBannerVisible, setIsActionBannerVisible] = (0, $hopDi$useState)(false);
    // Info Banner
    const [showInfoBanner, setShowInfoBanner] = (0, $hopDi$useState)(false);
    // Personalization Banners
    const [personalizationColorTheme, setPersonalizationColorTheme] = (0, $hopDi$useState)("Success");
    const [personalizationTitle, setPersonalizationTitle] = (0, $hopDi$useState)("");
    const [personalizationDescription, setPersonalizationDescription] = (0, $hopDi$useState)("");
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, personalization: { updatePersonalizatonApiStatus: updatePersonalizatonApiStatus, status: status, viewOption: viewOption }, action: { isActionError: isActionError }, criticalAlertMessage: { title: alertTitle, description: alertDescription, colorTheme: alertTheme } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mediaQueryValue >= mobileXlargeQuery.value;
    // Action Errors
    (0, $hopDi$useEffect)(()=>{
        const errorsToCheck = isActionError;
        if (errorsToCheck) setIsActionBannerVisible(true);
        else setIsActionBannerVisible(false);
    }, [
        isActionError
    ]);
    (0, $hopDi$useEffect)(()=>{
        // to handle only success alert message
        if (alertDescription && alertTitle && !isActionError) setIsActionBannerVisible(true);
    }, [
        alertTheme,
        alertDescription,
        alertTitle
    ]);
    // Personalizaton API
    (0, $hopDi$useEffect)(()=>{
        switch(updatePersonalizatonApiStatus){
            case (0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).UPDATE_SUCCESS:
                setPersonalizationDescription("Success");
                setPersonalizationTitle("Success");
                setPersonalizationColorTheme("Personalization update successful");
                break;
            case (0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).UPDATE_FAILED:
                setPersonalizationDescription("Critical");
                setPersonalizationTitle("Failed");
                setPersonalizationColorTheme("Personalization update failed. Please try again.");
                break;
            case (0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).UPDATE_FAILED_INVALID_LENGTH:
                setPersonalizationDescription("Critical");
                setPersonalizationTitle("Failed");
                setPersonalizationColorTheme("View could not be saved as the size of the view exceeded threshold limit, Please remove some of the filters/columns/rows items and try again.");
                break;
            case (0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).CREATE_SUCCESS:
                setPersonalizationDescription("Success");
                setPersonalizationTitle("Success");
                setPersonalizationColorTheme("Personalization create successful");
                break;
            case (0, $135adfecc1ed8f07$export$d4dd1b9b49fd1dcc).CREATE_FAILED:
                setPersonalizationDescription("Critical");
                setPersonalizationTitle("Failed");
                setPersonalizationColorTheme("Personalization create failed. Please try later.");
                break;
            default:
                break;
        }
    }, [
        updatePersonalizatonApiStatus
    ]);
    // View Options Info
    (0, $hopDi$useEffect)(()=>{
        if (status === "EXIST_PERSONALIZATION" && (viewOption?.view === "Default View" || viewOption?.view === "My Personalized View")) setShowInfoBanner(true);
    }, [
        status,
        viewOption
    ]);
    const getInfoBannerTitle = ()=>viewOption?.view === "My Personalized View" ? "Enjoy Your Personalized View" : "Default View";
    const getInfoBannerDescription = ()=>{
        if (viewOption?.applied) {
            if (viewOption?.view === "My Personalized View") return `You are viewing your certification with your personalized view applied.${isMobileXlargeWidth ? "" : " If you need to switch view, do it from the menu."}`;
            return "Personalization is set to default view.";
        }
        return "Personalization is set to default view. Your personalized view has filters or other configurations that can\u2019t be applied to this certification.";
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$StackingAlertBanner), {
                colorTheme: alertTheme || "",
                title: alertTitle || "",
                description: alertDescription || "",
                isVisible: isActionBannerVisible,
                onCancel: ()=>setIsActionBannerVisible(false),
                shouldAutoDismiss: alertTheme === (0, $135adfecc1ed8f07$export$80936d44d15279d1).SUCCESS
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$StackingAlertBanner), {
                colorTheme: viewOption?.applied ? "Information" : "Warning",
                kind: "low",
                title: getInfoBannerTitle(),
                description: getInfoBannerDescription(),
                isVisible: showInfoBanner,
                onCancel: ()=>setShowInfoBanner(false),
                shouldAutoDismiss: true,
                autoDismissDelay: 3000
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$StackingAlertBanner), {
                colorTheme: personalizationColorTheme,
                title: personalizationTitle,
                isColonVisible: false,
                description: personalizationDescription,
                isVisible: updatePersonalizatonApiStatus?.length > 0,
                onCancel: ()=>dispatch((0, $d623f23401a154f0$export$837b183b02987624)("")),
                shouldAutoDismiss: true,
                autoDismissDelay: 3000
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $322ec8c4879370a2$export$2e2bcd8739ae039), {})
        ]
    });
}
var $987dc9af54194992$export$2e2bcd8739ae039 = $987dc9af54194992$var$CertAlerts;


/* eslint-disable indent */ 





const $8ae07190c6a505ba$export$6abaf2f4454ce80f = "rowNotToShow";


const $31eefeb47866cab8$export$66f25c06ac11131c = (value)=>{
    if (value === (0, $6d218ab9b83faef2$export$e12a4cadfc09074e)) return 0, $d60257e8dc27bf16$export$1cc98074061c90d2;
    if (value === (0, $6d218ab9b83faef2$export$addbd3a73cd831b8)) return 0, $d60257e8dc27bf16$export$7d6712c2cb8377b2;
    if (value === (0, $6d218ab9b83faef2$export$2fdde2b3b0357dd1)) return 0, $d60257e8dc27bf16$export$153ab95c08227093;
    return 0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7;
};
const $31eefeb47866cab8$export$89bc22408028ff3d = (nodes, trackerObjBaseSettings = {}, level = 0, parentEid = null, parents = [])=>nodes.map((node)=>{
        const type = $31eefeb47866cab8$export$66f25c06ac11131c(node[0, $d60257e8dc27bf16$export$994f7af6d0b36256]);
        const tracker = node.tracker ? {
            ...node.tracker,
            childCount: node?.children?.length
        } : {
            id: (0, $hopDi$getRandomString)(),
            parentEid: parentEid,
            parents: [
                ...parents
            ],
            isChecked: node?.checked === "1",
            isConnected: false,
            isIndeterminate: false,
            level: level,
            childCount: node?.children?.length,
            isAtleastOneChildChecked: false,
            ...trackerObjBaseSettings
        };
        return {
            ...node,
            type: type,
            tracker: tracker,
            children: node.children?.length > 0 ? $31eefeb47866cab8$export$89bc22408028ff3d(node.children, trackerObjBaseSettings, level + 1, node?.id, node?.[0, $8ae07190c6a505ba$export$6abaf2f4454ce80f] && node?.[0, $8ae07190c6a505ba$export$6abaf2f4454ce80f] === "0" ? [
                ...parents,
                {
                    type: $31eefeb47866cab8$export$66f25c06ac11131c(node[0, $d60257e8dc27bf16$export$994f7af6d0b36256]),
                    [`${type}_DISPLAYNAME`]: node[`${type}_DISPLAYNAME`],
                    level: tracker?.level,
                    trackerId: tracker?.id
                }
            ] : [
                ...parents
            ]) : []
        };
    });
const $31eefeb47866cab8$export$711a902d2e3a009f = (nodes)=>nodes.map((node)=>{
        const isUserAndStatusApproved = node?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).WORKS_FOR_ME;
        const isAccountEntRoleAndStatusApproved = node?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).APPROVE;
        const isTerminateUserSelected = node?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).TERMINATED;
        const isExtendEndDateUserSelected = node?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).EXTEND_END_DATE || node?.userEndDateExtended;
        const isConditionalCertifyUserSelected = node?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).CONDITIONAL_CERTIFIY;
        const isRejectUserSelected = node?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED || node?.terminatedUser;
        const isReassignSelected = node?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED;
        const isConsultSelected = node?.isConsulted && node?.CONSULTED_USERCOUNT > 0;
        const isConsultActionAvailable = node?.availableAction && node?.availableAction[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT];
        // check available actions as well for consult- Show Consult For Own Access & Disable Consult For Consultee
        const actionButtonPayload = {};
        if (isUserAndStatusApproved) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        if (isAccountEntRoleAndStatusApproved) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        if (isTerminateUserSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        if (isExtendEndDateUserSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        if (isRejectUserSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        if (isConditionalCertifyUserSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        if (isReassignSelected) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME || (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        // Start : Show Consult For Own Access & Disable Consult For Consultee
        if (isConsultSelected && isConsultActionAvailable) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT] = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        else if (isConsultActionAvailable) actionButtonPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT] = {
            isSelected: false,
            isLoading: false,
            isDisabled: false,
            shouldBeRemoved: false
        };
        // End: Show Consult For Own Access & Disable Consult For Consultee
        const defaultActionMap = node?.enableAction?.reduce((actionMap, action)=>{
            // eslint-disable-next-line no-param-reassign
            actionMap[action] = {
                isSelected: false,
                isLoading: false,
                isDisabled: false
            };
            return actionMap;
        }, {});
        return {
            ...node,
            tracker: {
                ...node.tracker,
                actions: {
                    ...defaultActionMap,
                    ...actionButtonPayload,
                    ...node?.tracker?.actions
                }
            },
            children: node?.children && node?.children?.length > 0 ? $31eefeb47866cab8$export$711a902d2e3a009f(node.children) : []
        };
    });
const $31eefeb47866cab8$export$5cf5ab282a6d1471 = (tree, key = (0, $8ae07190c6a505ba$export$6abaf2f4454ce80f))=>{
    const tempTree = [];
    tree.forEach((branch)=>{
        // If the branch matches the key and its value is '0',
        // add it to the temporary tree and recursively modify its children.
        if (branch?.[key] && branch?.[key] === "0") tempTree.push({
            ...branch,
            children: (branch?.children && branch.children.length) > 0 ? $31eefeb47866cab8$export$5cf5ab282a6d1471(branch.children, key) : []
        });
        else if (branch?.children && branch.children.length > 0) tempTree.push(...$31eefeb47866cab8$export$5cf5ab282a6d1471(branch.children, key));
    });
    return tempTree;
};
const $31eefeb47866cab8$export$180ffcd95abfdd08 = (columnPickerList)=>{
    let concatenatedString = "";
    // Iterate over each key in the column picker list
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for(const key in columnPickerList){
        const values = Object.keys(columnPickerList[key]);
        concatenatedString += `${values?.join(",")},`;
    }
    concatenatedString = concatenatedString?.slice(0, -1);
    return concatenatedString;
};
const $31eefeb47866cab8$export$2bb1953c0044b8fa = (trackerLevel)=>{
    switch(trackerLevel){
        case 0:
            return (0, $e7628c995f405891$export$7f9a9407232f3c49).allChildren;
        case 1:
            return (0, $e7628c995f405891$export$7f9a9407232f3c49).both;
        case 2:
            return (0, $e7628c995f405891$export$7f9a9407232f3c49).parent;
        default:
            return (0, $e7628c995f405891$export$7f9a9407232f3c49).bothFull;
    }
};
const $31eefeb47866cab8$export$efe17290047eb682 = (input1, input2)=>{
    if (!Array.isArray(input1) || !Array.isArray(input2)) return [];
    if (input1.length === 0) return input2;
    if (input2.length === 0) return input1;
    const tempArr1 = [
        ...input1
    ];
    const tempArr2 = [
        ...input2
    ];
    // Always should be the case where input2 is merged with input1 i.e. input2 length should be less
    tempArr2.forEach((newNode)=>{
        let newKey = (Number(newNode.CERT_ENTITLEMENT_VALUEKEY) > 0 ? newNode.CERT_ENTITLEMENT_VALUEKEY : null) || (Number(newNode.CERT_ROLEKEY) > 0 ? newNode.CERT_ROLEKEY : null) || (Number(newNode.CERT_ACCOUNTKEY) > 0 ? newNode.CERT_ACCOUNTKEY : null) || newNode.CERT_USERKEY;
        if (newNode.ROW_TYPE === "User" || newNode.CERT_ENTITLEMENT_VALUEKEY === "-4") newKey = newNode.CERT_USERKEY;
        if (newNode.ROW_TYPE === "Account" || newNode.CERT_ENTITLEMENT_VALUEKEY === "0") newKey = newNode.CERT_ACCOUNTKEY;
        if (newNode.ROW_TYPE === "Role" || newNode.CERT_ENTITLEMENT_VALUEKEY === "-2") {
            if (newNode.Role_ROLETYPE === "APPLICATION ROLE") newKey = newNode.CERT_ACCOUNTKEY;
            else newKey = newNode.CERT_ROLEKEY;
        }
        if (newNode.ROW_TYPE === "Entitlement" || Number(newNode.CERT_ENTITLEMENT_VALUEKEY) > 0) newKey = newNode.CERT_ENTITLEMENT_VALUEKEY;
        let existingNode = null;
        let existingNodeIndexToTarget = null;
        for(let i = 0; i < tempArr1.length; i += 1){
            let existingKey = (Number(tempArr1[i].CERT_ENTITLEMENT_VALUEKEY) > 0 ? tempArr1[i].CERT_ENTITLEMENT_VALUEKEY : null) || (Number(tempArr1[i].CERT_ROLEKEY) > 0 ? tempArr1[i].CERT_ROLEKEY : null) || (Number(tempArr1[i].CERT_ACCOUNTKEY) > 0 ? tempArr1[i].CERT_ACCOUNTKEY : null) || tempArr1[i].CERT_USERKEY;
            if (tempArr1[i].ROW_TYPE === "User" || tempArr1[i].CERT_ENTITLEMENT_VALUEKEY === "-4") existingKey = tempArr1[i].CERT_USERKEY;
            if (tempArr1[i].ROW_TYPE === "Account" || tempArr1[i].CERT_ENTITLEMENT_VALUEKEY === "0") existingKey = tempArr1[i].CERT_ACCOUNTKEY;
            if (tempArr1[i].ROW_TYPE === "Role" || tempArr1[i].CERT_ENTITLEMENT_VALUEKEY === "-2") {
                if (tempArr1[i].Role_ROLETYPE === "APPLICATION ROLE") existingKey = tempArr1[i].CERT_ACCOUNTKEY;
                else existingKey = tempArr1[i].CERT_ROLEKEY;
            }
            if (tempArr1[i].ROW_TYPE === "Entitlement" || Number(tempArr1[i].CERT_ENTITLEMENT_VALUEKEY) > 0) existingKey = tempArr1[i].CERT_ENTITLEMENT_VALUEKEY;
            if (existingKey === newKey) {
                existingNodeIndexToTarget = i;
                existingNode = tempArr1[i];
                break;
            }
        }
        if (!existingNode) tempArr1.push(newNode);
        else {
            const afterMergeChildrenArray = $31eefeb47866cab8$export$efe17290047eb682(existingNode?.children, newNode.children);
            if (!existingNode?.id && newNode?.id && existingNodeIndexToTarget !== null) {
                const existingNodeChildren = [
                    ...existingNode?.children ? existingNode.children : []
                ];
                const newNodeChildren = [
                    ...newNode?.children ? newNode.children : []
                ];
                const newExistingNode = {
                    ...existingNode,
                    ...newNode,
                    children: existingNodeChildren?.length > 0 || newNodeChildren?.length > 0 ? $31eefeb47866cab8$export$efe17290047eb682(existingNodeChildren, newNodeChildren) : []
                };
                tempArr1[existingNodeIndexToTarget] = newExistingNode;
            } else tempArr1[existingNodeIndexToTarget].children = afterMergeChildrenArray;
        }
    });
    return tempArr1;
};
const $31eefeb47866cab8$export$69c0d0b2ab73b812 = (nodeArray)=>{
    const flattenedNodeArray = (0, $e7628c995f405891$export$8824054d4a42eac8)(nodeArray);
    const hasAnyNodeWithEid = flattenedNodeArray.filter((node)=>node?.id);
    if (hasAnyNodeWithEid?.length > 0) return true;
    return false;
};
const $31eefeb47866cab8$export$7928099a872ca1a9 = (originalParentNodeArray, updatedNodes, actionKind, currentState, trackerId, eidsToUpdate, currentLevel = 0, highestLevelToRemove = null)=>originalParentNodeArray.reduce((total, item)=>{
        // Check weather id is sent to api for refreshed data
        const shouldUpdateNode = eidsToUpdate.includes(item?.id);
        if (!shouldUpdateNode) {
            const updatedItem = {
                ...item,
                children: item?.children?.length > 0 ? $31eefeb47866cab8$export$7928099a872ca1a9(item?.children, updatedNodes, actionKind, currentState, trackerId, eidsToUpdate, currentLevel + 1, highestLevelToRemove) : []
            };
            return [
                ...total,
                updatedItem
            ];
        }
        // Check weather to remove node or keep it
        const refreshedDataForItem = updatedNodes.find((_item)=>_item?.id === item?.id);
        const handleRemoval = (node)=>{
            const cardElement = document.getElementById(node.id);
            if (cardElement) cardElement.classList.add("Cards-tree--isBeingRemoved");
        };
        if (!refreshedDataForItem) {
            if (highestLevelToRemove === null || currentLevel < highestLevelToRemove) {
                handleRemoval(item);
                // eslint-disable-next-line no-param-reassign
                highestLevelToRemove = currentLevel;
            }
            const getUpdatedChildrenItems = $31eefeb47866cab8$export$7928099a872ca1a9(item?.children || [], updatedNodes, actionKind, currentState, trackerId, eidsToUpdate, currentLevel + 1, highestLevelToRemove);
            return [
                ...total,
                ...getUpdatedChildrenItems
            ];
        }
        // Update the node and the actions
        const actions = item?.tracker?.actions || {};
        // const currentAction = actions?.[actionKind] || {};
        const newActionPayload = {};
        Object?.keys(actions)?.forEach((actionKey)=>{
            newActionPayload[actionKey] = {
                isSelected: false,
                isLoading: false,
                isDisabled: false
            };
        });
        const defaultActionMap = {
            isSelected: true,
            isLoading: false,
            isDisabled: false
        };
        // Setting up the buttons state based on the CERTIFIED key
        // Action(s): Works For Me, Approve
        if (refreshedDataForItem?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).WORKS_FOR_ME) {
            if (item?.CERT_ENTITLEMENT_VALUEKEY === "-4") newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).WORKS_FOR_ME] = {
                ...defaultActionMap
            };
            else newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).APPROVE] = {
                ...defaultActionMap
            };
        }
        // Action(s): Terminate
        if (refreshedDataForItem?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).TERMINATED) newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE] = {
            ...defaultActionMap
        };
        // Action(s): Extend End Date
        if (refreshedDataForItem?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).EXTEND_END_DATE || refreshedDataForItem?.userEndDateExtended) newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE] = {
            ...defaultActionMap
        };
        // Action(s): Conditionally Certify
        if (refreshedDataForItem?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).CONDITIONAL_CERTIFIY) newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONDITIONAL_CERTIFIY] = {
            ...defaultActionMap
        };
        // Action(s): Does Not Work For Me, Revoke/Reject
        if (refreshedDataForItem?.CERTIFIED === (0, $20281fe09bc700a8$export$6bf521f24032eb49).REVOKED || refreshedDataForItem?.terminatedUser) {
            if (item?.CERT_ENTITLEMENT_VALUEKEY === "-4") newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME] = {
                ...defaultActionMap
            };
            else newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).REJECT] = {
                ...defaultActionMap
            };
        }
        // Action(s): Does Not Work For Me, Reassign (Reassign willl not be highlisghted in same certification)
        // if (refreshedDataForItem?.CERTIFIED === CERTIFIED.REVOKED) {
        //   newActionPayload[ACTION_BUTTON_KINDS.REASSIGN] = { ...defaultActionMap };
        // }
        // Action(s): Consult
        if (refreshedDataForItem?.isConsulted && refreshedDataForItem?.availableAction[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT]) newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT] = {
            ...defaultActionMap
        };
        else if (refreshedDataForItem?.availableAction[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT]) newActionPayload[(0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT] = {
            ...defaultActionMap,
            isSelected: false
        };
        const refreshedItem = {
            ...item,
            ...refreshedDataForItem,
            tracker: {
                ...item?.tracker,
                actions: newActionPayload
            },
            children: item?.children?.length > 0 ? $31eefeb47866cab8$export$7928099a872ca1a9(item?.children, updatedNodes, actionKind, currentState, trackerId, eidsToUpdate, currentLevel + 1, highestLevelToRemove) : []
        };
        return [
            ...total,
            refreshedItem
        ];
    }, []);
const $31eefeb47866cab8$export$98a1b4835a773956 = (nodes, actionKind, trackerId, currentState)=>nodes.map((item)=>{
        const actions = item.tracker?.actions || {};
        const currentAction = actions[actionKind] || {};
        return {
            ...item,
            tracker: {
                ...item.tracker,
                actions: {
                    ...actions,
                    [actionKind]: {
                        ...currentAction,
                        isSelected: item.tracker.id === trackerId ? !currentState : currentAction.isSelected,
                        isLoading: item.tracker.id === trackerId ? false : currentAction.isLoading
                    }
                }
            },
            children: item.children?.length > 0 ? $31eefeb47866cab8$export$98a1b4835a773956(item.children, actionKind, trackerId, currentState) : []
        };
    });
const $31eefeb47866cab8$export$b36e3052e968e5b9 = (nodes, trackerId, callback)=>nodes.map((item)=>{
        if (item.tracker?.id === trackerId) {
            callback(item);
            return {
                ...item
            };
        }
        return {
            ...item,
            children: item.children?.length > 0 ? $31eefeb47866cab8$export$b36e3052e968e5b9(item.children, trackerId, callback) : []
        };
    });


/* eslint-disable indent */ 











const $e4cfe974853390b2$export$aeca2bf7951e0a69 = 10;
const $e4cfe974853390b2$export$be606e9ab633c6e3 = "Savi";
const $e4cfe974853390b2$export$a8beb73f40515af4 = "Recommendations";
const $e4cfe974853390b2$export$780e9b8451ecceec = {
    landing: /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
        children: [
            "Hi, I\u2019m ",
            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                className: "Savi-highlight",
                children: $e4cfe974853390b2$export$be606e9ab633c6e3
            }),
            ", your AI Companion",
            " "
        ]
    }),
    normal: /*#__PURE__*/ (0, $hopDi$jsx)("span", {
        className: "Savi-highlight",
        children: $e4cfe974853390b2$export$a8beb73f40515af4
    })
};
const $e4cfe974853390b2$export$2ea9789638c50423 = [
    {
        id: "smart_decisions",
        label: "Make Smart Decisions for You",
        description: "I'll recommend decisions based on multiple trust and risk factors and you can review the reasons and change the decisions before you submit.",
        iconKind: "SaviSmartDecisions",
        isRecommended: true,
        tabIndex: -1
    },
    {
        id: "own_review",
        label: "Review on Your Own",
        description: "Go ahead and conduct your certification review without intelligence-based assistance.",
        iconKind: "SaviOwnReview",
        isRecommended: false,
        tabIndex: 0
    }
];
const $e4cfe974853390b2$export$66437e1fecf15ebb = {
    savi_approve: {
        label: "Approve",
        description: "Includes items identified as High Peer Match Score, Approved in Saviynt, Low Risk Entitlements and Birthright Access Origins.",
        iconKind: "SaviSmartApprove",
        totalKey: "savi_total_approve",
        actionTakenKey: "savi_approved",
        manuallyReviewedMessageKeys: [
            {
                actionTakenKey: "manually_approved",
                actionTakenLabel: "approved"
            },
            {
                actionTakenKey: "manually_revoked",
                actionTakenLabel: "rejected"
            },
            {
                actionTakenKey: "manually_enddate",
                actionTakenLabel: "changed end date on"
            }
        ],
        manuallyReviewedActionConfirmation: "Approvals",
        applyActionKey: "savi_approve",
        applyOverwriteKey: "approve_overwrite"
    },
    savi_revoke: {
        label: "Reject",
        description: "Includes items with Low Peer Match, Unused Accounts, Access Conflicts (SoD)",
        iconKind: "SaviSmartReject",
        totalKey: "savi_total_revoke",
        actionTakenKey: "savi_revoked",
        manuallyReviewedMessageKeys: [
            {
                actionTakenKey: "manually_approved",
                actionTakenLabel: "approved"
            },
            {
                actionTakenKey: "manually_revoked",
                actionTakenLabel: "rejected"
            },
            {
                actionTakenKey: "manually_enddate",
                actionTakenLabel: "changed end date on"
            }
        ],
        manuallyReviewedActionConfirmation: "Rejections",
        applyActionKey: "savi_reject",
        applyOverwriteKey: "reject_overwrite"
    }
};



const $e40ef6d119a5d30a$var$cookies = new (0, $hopDi$Cookies)();
const $e40ef6d119a5d30a$var$SaviCompanionTitle = ({ kind: kind })=>(0, $e4cfe974853390b2$export$780e9b8451ecceec)[kind];
function $e40ef6d119a5d30a$var$SaviCompanionLandingBody({ onGotItClick: onGotItClick }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "Savi-Landing-Body",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    className: "Text",
                    children: "I'm here to help make your certification go faster and easier with intelligence-based recommendations."
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "Landing-buttons-wrapper",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "filled",
                    size: "large",
                    className: "Landing-buttons",
                    onClick: onGotItClick,
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2-bold",
                        className: "Text",
                        children: "Got it"
                    })
                })
            })
        ]
    });
}
$e40ef6d119a5d30a$var$SaviCompanionLandingBody.propTypes = {
    onGotItClick: (0, $hopDi$proptypes).func.isRequired
};
function $e40ef6d119a5d30a$var$QuestionHeader({ isOptionSelected: isOptionSelected, minimiseReason: minimiseReason, title: title, setIsOptionSelected: setIsOptionSelected }) {
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "Question-Header-Wrapper-Minimised",
        children: isOptionSelected ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "Question-Header-Wrapper",
            role: "button",
            tabIndex: -1,
            onClick: ()=>setIsOptionSelected(!isOptionSelected),
            onKeyDown: ()=>setIsOptionSelected(!isOptionSelected),
            children: [
                isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "ChevronLeft",
                    size: "medium",
                    color: "navy-900"
                }),
                !isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "SaviCompanion",
                    size: "medium"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Minimised",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "Question-Header",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body1",
                                    className: "Question-Header Question-Header-Reason",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                                        color: "navy-900",
                                        children: minimiseReason
                                    })
                                })
                            ]
                        }),
                        !isMobileXlargeWidth && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Edit",
                            size: "medium",
                            color: "navy-900"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: `Question-Header-Wrapper ${minimiseReason ? " Question-Header-Wrapper-Minimised" : ""}`,
            role: "button",
            tabIndex: 0,
            onClick: ()=>minimiseReason && setIsOptionSelected && setIsOptionSelected(!isOptionSelected),
            onKeyDown: ()=>minimiseReason && setIsOptionSelected && setIsOptionSelected(!isOptionSelected),
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "SaviCompanion",
                    size: "medium"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "h3",
                    className: "Question-Header",
                    children: title
                })
            ]
        })
    });
}
$e40ef6d119a5d30a$var$QuestionHeader.propTypes = {
    isOptionSelected: (0, $hopDi$proptypes).bool.isRequired,
    minimiseReason: (0, $hopDi$proptypes).string,
    title: (0, $hopDi$proptypes).string.isRequired,
    setIsOptionSelected: (0, $hopDi$proptypes).func.isRequired
};
$e40ef6d119a5d30a$var$QuestionHeader.defaultProps = {
    minimiseReason: ""
};
function $e40ef6d119a5d30a$var$SaviStaticOption({ id: id, label: label, description: description, iconKind: iconKind, chipLabel: chipLabel, onClick: onClick, tabIndex: tabIndex }) {
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    return isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SaviCompanion-smartReviewWrapper",
        role: "button",
        onClick: ()=>onClick(id, label),
        tabIndex: tabIndex,
        onKeyDown: ()=>onClick(id, label),
        id: "SaviCompanion-smartReviewWrapper-mobile",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "SaviCompanion-mobileWrapper",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "SaviCompanion-smartDecision-Icon",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: iconKind,
                            size: "large"
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        children: [
                            chipLabel && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                                label: chipLabel,
                                kind: "subtleFilled",
                                color: "info"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                className: chipLabel && "SaviCompanion-mobileWrapper-Header",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                                    color: "navy-900",
                                    children: label
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "SaviCompanion-smartDecision-Icon",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "ArrowRight",
                            color: "indigo-700",
                            size: "medium"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                children: description
            })
        ]
    }) : /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SaviCompanion-smartReviewWrapper",
        role: "button",
        onClick: ()=>onClick(id, label),
        tabIndex: tabIndex,
        onKeyDown: ()=>onClick(id, label),
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "SaviCompanion-smartDecision-Icon",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: iconKind,
                    size: "large"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                children: [
                    chipLabel && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Chip), {
                        label: chipLabel,
                        kind: "subtleFilled",
                        color: "info"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h3",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                            color: "navy-900",
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "SaviCompanion-smartDecision-Icon",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "ArrowRight",
                    color: "indigo-700",
                    size: "medium"
                })
            })
        ]
    });
}
$e40ef6d119a5d30a$var$SaviStaticOption.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    label: (0, $hopDi$proptypes).string.isRequired,
    description: (0, $hopDi$proptypes).string.isRequired,
    iconKind: (0, $hopDi$proptypes).string.isRequired,
    chipLabel: (0, $hopDi$proptypes).string,
    onClick: (0, $hopDi$proptypes).func.isRequired,
    tabIndex: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).number,
        (0, $hopDi$proptypes).string
    ])
};
$e40ef6d119a5d30a$var$SaviStaticOption.defaultProps = {
    chipLabel: "",
    tabIndex: 0
};
function $e40ef6d119a5d30a$var$SaviPopover({ id: id, children: children, isPopoverOpen: isPopoverOpen, openPopover: openPopover, setSmartSelectedOption: setSmartSelectedOption, manuallyReviewedDetails: manuallyReviewedDetails, setShowKeepDecisionText: setShowKeepDecisionText, disablePopup: disablePopup }) {
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    const onButtonClick = (overwriteFlag)=>{
        openPopover(false, true);
        setSmartSelectedOption(id, 1, overwriteFlag);
        if (!overwriteFlag) setShowKeepDecisionText(true);
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        tag: "div",
        className: "SaviCompanion-contextWrapper",
        children: !disablePopup ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                    placement: "right",
                    trigger: children,
                    popoverContent: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "flexContainer",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                children: manuallyReviewedDetails.title
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                children: manuallyReviewedDetails.description
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                className: "flexWrapper",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: "ghost",
                                        size: "medium",
                                        className: "Overwrite",
                                        onClick: ()=>onButtonClick(1),
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3-bold",
                                            className: "Text",
                                            children: "Overwrite"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: "filled",
                                        size: "medium",
                                        className: "Keep",
                                        onClick: ()=>onButtonClick(0),
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3-bold",
                                            className: "Text",
                                            children: "Keep Your Decisions"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isOpen: isPopoverOpen && !isMobileXlargeWidth,
                    setIsOpen: openPopover
                }),
                isMobileXlargeWidth && isPopoverOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                    content: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
                                className: "SaviCompanion-mobileDrawer-overwriteDecision-headerWrapper",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                        className: "flexContainer",
                                        id: "flexContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                kind: "SaviCompanion",
                                                size: "medium"
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                kind: "h3",
                                                children: "Keep or Overwrite Your Decisions?"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "medium",
                                        kind: "ghost",
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "close",
                                            color: "neutral-100",
                                            size: "smallMedium"
                                        }),
                                        onClick: ()=>openPopover(false, false)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                className: "flexContainer",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "h3",
                                        children: manuallyReviewedDetails.title
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2",
                                        children: manuallyReviewedDetails.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                className: "flexContainer SaviCompanion-mobileDrawer-overwriteDecision-buttonsWrapper",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: "ghost",
                                        size: "medium",
                                        className: "Overwrite",
                                        onClick: ()=>onButtonClick(1),
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3-bold",
                                            className: "Text overwrite-Text",
                                            children: "Overwrite"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: "filled",
                                        size: "medium",
                                        className: "Keep",
                                        onClick: ()=>onButtonClick(0),
                                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3-bold",
                                            className: "Text keep-Text",
                                            children: "Keep Your Decisions"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    className: "SaviCompanion-mobileDrawer-overwriteDecision",
                    isOpen: isMobileXlargeWidth && isPopoverOpen,
                    setIsOpen: openPopover,
                    renderOnlyContent: true,
                    isCloseOnOutsideClick: true
                })
            ]
        }) : children
    });
}
$e40ef6d119a5d30a$var$SaviPopover.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    children: (0, $hopDi$proptypes).node.isRequired,
    isPopoverOpen: (0, $hopDi$proptypes).bool.isRequired,
    openPopover: (0, $hopDi$proptypes).func.isRequired,
    setSmartSelectedOption: (0, $hopDi$proptypes).func.isRequired,
    manuallyReviewedDetails: (0, $hopDi$proptypes).shape({
        title: (0, $hopDi$proptypes).string.isRequired,
        description: (0, $hopDi$proptypes).string.isRequired
    }).isRequired,
    setShowKeepDecisionText: (0, $hopDi$proptypes).func.isRequired,
    disablePopup: (0, $hopDi$proptypes).bool.isRequired
};
function $e40ef6d119a5d30a$var$SaviDynamicOption({ id: id, label: label, description: description, iconKind: iconKind, onClick: onClick, tabIndex: tabIndex, isManuallyReviewedItemsPresent: isManuallyReviewedItemsPresent, setSmartSelectedOption: setSmartSelectedOption, manuallyReviewedDetails: manuallyReviewedDetails, isSaviActionsApplied: isSaviActionsApplied, keepDecisionsLabel: keepDecisionsLabel, isCheckBoxSelected: isCheckBoxSelected, isKeepDecision: isKeepDecision, smartCancellationMessage: smartCancellationMessage, selectedSmartReviewOptions: selectedSmartReviewOptions }) {
    const [isChecked, setIsChecked] = (0, $hopDi$useState)(isCheckBoxSelected === 1);
    const [isPopoverOpen, setIsPopoverOpen] = (0, $hopDi$useState)(false);
    const [showKeepDecisionText, setShowKeepDecisionText] = (0, $hopDi$useState)(isKeepDecision === 0);
    const [showSaviActionsApplied, setShowSaviActionsApplied] = (0, $hopDi$useState)(isSaviActionsApplied);
    const { mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    const showCancelConfirmMessage = selectedSmartReviewOptions[(0, $e4cfe974853390b2$export$66437e1fecf15ebb)[id].applyActionKey] === 0;
    const onOptionClick = (event)=>{
        const isLocalChecked = !isChecked;
        setIsChecked(isLocalChecked);
        onClick(id, isLocalChecked, isManuallyReviewedItemsPresent);
        setShowKeepDecisionText(false);
        event.preventDefault();
    };
    const openPopover = (open, isButtonClicked)=>{
        let localIsChecked = isChecked;
        if (!open && !(isButtonClicked === true)) {
            localIsChecked = false;
            setIsChecked(localIsChecked);
        }
        setIsPopoverOpen(open && !localIsChecked);
    };
    const onCancelSaviActions = ()=>{
        setShowSaviActionsApplied(false);
        setSmartSelectedOption(id, 0);
        return false;
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviPopover, {
        id: id,
        isPopoverOpen: isManuallyReviewedItemsPresent ? isPopoverOpen : false,
        openPopover: openPopover,
        setSmartSelectedOption: setSmartSelectedOption,
        manuallyReviewedDetails: manuallyReviewedDetails,
        setShowKeepDecisionText: setShowKeepDecisionText,
        disablePopup: isSaviActionsApplied,
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "SaviCompanion-smartReviewWrapper",
            id: isMobileXlargeWidth && showSaviActionsApplied && !showCancelConfirmMessage && "SaviCompanion-smartReviewWrapper-mobile",
            role: "button",
            onClick: !showSaviActionsApplied && !showCancelConfirmMessage ? onOptionClick : undefined,
            tabIndex: tabIndex,
            onKeyDown: undefined,
            children: [
                isMobileXlargeWidth && showSaviActionsApplied && !showCancelConfirmMessage && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "Applied-Savi",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "CheckCircleOutline",
                            size: "xSmall"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body3",
                            children: "Applied"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "SaviCompanion-smartDecision-wrapper",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "SaviCompanion-smartDecision-Icon",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: iconKind,
                                    size: "xLarge"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                    className: "DisplayFlex-Column",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "h3",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                                                color: "navy-900",
                                                children: showKeepDecisionText ? keepDecisionsLabel : label
                                            })
                                        }),
                                        showKeepDecisionText && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Color), {
                                                color: "navy-900",
                                                children: manuallyReviewedDetails.overwriteDecision
                                            })
                                        })
                                    ]
                                }),
                                !isMobileXlargeWidth && showSaviActionsApplied && !showCancelConfirmMessage && /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "Applied-Savi",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "CheckCircleOutline",
                                            size: "xSmall"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body3",
                                            children: "Applied"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                children: description
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            children: showCancelConfirmMessage && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                                kind: "plain",
                                colorTheme: "info",
                                leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: "AlertCritical",
                                    size: "xSmall"
                                }),
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body3",
                                    className: "SaviCompanion-smartReview-cancelConfirmMessage",
                                    children: smartCancellationMessage
                                })
                            })
                        }),
                        showSaviActionsApplied && !showCancelConfirmMessage && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "SaviCompanion-cancelSmartApprovals",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                                type: "button",
                                kind: "subtle",
                                size: "large",
                                onClick: onCancelSaviActions,
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body3-bold",
                                    className: "Text",
                                    children: manuallyReviewedDetails.cancelLabel
                                })
                            })
                        })
                    ]
                }),
                (!showSaviActionsApplied || showCancelConfirmMessage) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "SaviCompanion-smartDecision-Icon",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                        kind: "base",
                        size: "medium",
                        isChecked: isChecked,
                        onChange: undefined,
                        isDisabled: showSaviActionsApplied || showCancelConfirmMessage
                    })
                })
            ]
        }, id)
    });
}
$e40ef6d119a5d30a$var$SaviDynamicOption.propTypes = {
    id: (0, $hopDi$proptypes).number.isRequired,
    iconKind: (0, $hopDi$proptypes).string.isRequired,
    label: (0, $hopDi$proptypes).string.isRequired,
    description: (0, $hopDi$proptypes).string.isRequired,
    smartCancellationMessage: (0, $hopDi$proptypes).string.isRequired,
    isSaviActionsApplied: (0, $hopDi$proptypes).bool.isRequired,
    selectedSmartReviewOptions: (0, $hopDi$proptypes).shape({}).isRequired,
    onClick: (0, $hopDi$proptypes).func.isRequired,
    isCheckBoxSelected: (0, $hopDi$proptypes).number.isRequired,
    isManuallyReviewedItemsPresent: (0, $hopDi$proptypes).bool.isRequired,
    manuallyReviewedDetails: (0, $hopDi$proptypes).shape({
        overwriteDecision: (0, $hopDi$proptypes).string,
        cancelLabel: (0, $hopDi$proptypes).string
    }).isRequired,
    setSmartSelectedOption: (0, $hopDi$proptypes).func.isRequired,
    isKeepDecision: (0, $hopDi$proptypes).number.isRequired,
    keepDecisionsLabel: (0, $hopDi$proptypes).string.isRequired,
    tabIndex: (0, $hopDi$proptypes).number
};
$e40ef6d119a5d30a$var$SaviDynamicOption.defaultProps = {
    tabIndex: 0
};
function $e40ef6d119a5d30a$var$Divider() {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "Savi-Companion-Divider"
    });
}
function $e40ef6d119a5d30a$var$SmartReview({ title: title, children: children, isOptionSelected: isOptionSelected, selectedOption: selectedOption, setIsOptionSelected: setIsOptionSelected }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "SaviCompanionBody-Wrapper",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$QuestionHeader, {
                isOptionSelected: isOptionSelected,
                minimiseReason: selectedOption,
                title: title,
                setIsOptionSelected: setIsOptionSelected
            }),
            !isOptionSelected && children
        ]
    });
}
$e40ef6d119a5d30a$var$SmartReview.propTypes = {
    title: (0, $hopDi$proptypes).string.isRequired,
    children: (0, $hopDi$proptypes).node.isRequired,
    isOptionSelected: (0, $hopDi$proptypes).bool.isRequired,
    selectedOption: (0, $hopDi$proptypes).string,
    setIsOptionSelected: (0, $hopDi$proptypes).func.isRequired
};
$e40ef6d119a5d30a$var$SmartReview.defaultProps = {
    selectedOption: null
};
function $e40ef6d119a5d30a$var$LoaderComponent({ text: text }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "Savi-Companion-Loader-Wrapper",
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "Savi-Companion-Loader-Body",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    className: "Savi-Companion-Loader-Text",
                    children: text
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                    className: "Savi-Companion-Loader-Setting",
                    kind: "loop",
                    format: "inline",
                    color: "brand",
                    size: "large"
                })
            ]
        })
    });
}
$e40ef6d119a5d30a$var$LoaderComponent.propTypes = {
    text: (0, $hopDi$proptypes).string.isRequired
};
function $e40ef6d119a5d30a$var$ErrorComponent({ errorText: errorText, retryAction: retryAction }) {
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "Savi-Companion-Loader-Wrapper",
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "Savi-Companion-Loader-Body",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "AlertText",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "AlertCriticalOutline",
                            color: "critical-500",
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            className: "Savi-Companion-Error-Text",
                            children: errorText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    onClick: retryAction,
                    kind: "ghost",
                    size: "medium",
                    rightIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Retry",
                        size: "small"
                    }),
                    children: "Retry"
                })
            ]
        })
    });
}
$e40ef6d119a5d30a$var$ErrorComponent.propTypes = {
    errorText: (0, $hopDi$proptypes).string.isRequired,
    retryAction: (0, $hopDi$proptypes).func.isRequired
};
function $e40ef6d119a5d30a$var$NothingToShow() {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "Savi-Companion-Loader-Wrapper",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "NothingToShow",
                    size: "large"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body2",
                className: "Savi-Companion-Loader-Text",
                children: "You are all caught up! Nothing to see here."
            })
        ]
    });
}
function $e40ef6d119a5d30a$var$SaviCompanionBody({ setSelectedSmartReviewOptions: setSelectedSmartReviewOptions, selectedSmartReviewOptions: selectedSmartReviewOptions, isLoading: isLoading, isSaviActionsTaken: isSaviActionsTaken, smartReviewOptions: smartReviewOptions, setShowSaviCompanion: setShowSaviCompanion, isApplyActionLoading: isApplyActionLoading, errorDetails: errorDetails, isCertificationActionable: isCertificationActionable }) {
    const [isOptionSelected, setIsOptionSelected] = (0, $hopDi$useState)(false);
    const [selectedOption, setSelectedOption] = (0, $hopDi$useState)("");
    const [isDynamicOptionSelected, setIsDynamicOptionSelected] = (0, $hopDi$useState)(false);
    const [dynamicSelectedOption, setDynamicSelectedOption] = (0, $hopDi$useState)([]);
    (0, $hopDi$useEffect)(()=>{
        if (smartReviewOptions.length > 0) {
            const dynamicOptions = [];
            smartReviewOptions.map((item)=>dynamicOptions.push(item.label));
            setDynamicSelectedOption(dynamicOptions);
        }
    }, [
        smartReviewOptions
    ]);
    const onOptionSelected = (id, reason)=>{
        if (id === "smart_decisions") {
            setIsOptionSelected(true);
            setSelectedOption(reason);
        } else setShowSaviCompanion(false);
    };
    const setSmartSelectedOption = (itemKey, value, overwriteFlag)=>{
        const optionKey = (0, $e4cfe974853390b2$export$66437e1fecf15ebb)[itemKey].applyActionKey;
        const overwriteOptionKey = (0, $e4cfe974853390b2$export$66437e1fecf15ebb)[itemKey].applyOverwriteKey;
        const { [optionKey]: selectedItem } = selectedSmartReviewOptions;
        const selectedOptions = {
            ...selectedSmartReviewOptions
        };
        if (selectedItem) {
            delete selectedOptions[optionKey];
            delete selectedOptions[overwriteOptionKey];
        } else {
            selectedOptions[optionKey] = value;
            selectedOptions[overwriteOptionKey] = overwriteFlag;
        }
        setSelectedSmartReviewOptions(selectedOptions);
    };
    const onDynamicOptionClick = (itemKey, isChecked, isManuallyReviewedItemsPresent)=>{
        if (!isChecked || !isManuallyReviewedItemsPresent) setSmartSelectedOption(itemKey, 1);
    };
    const dynamicActionsBody = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                !isSaviActionsTaken ? /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SmartReview, {
                    title: "How can I help with your certification?",
                    isOptionSelected: isOptionSelected,
                    selectedOption: selectedOption,
                    setIsOptionSelected: setIsOptionSelected,
                    children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "Options-Wrapper",
                        children: (0, $e4cfe974853390b2$export$2ea9789638c50423).map(({ id: id, label: label, description: description, iconKind: iconKind, isRecommended: isRecommended, tabIndex: tabIndex }, index)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$react).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviStaticOption, {
                                        id: id,
                                        label: label,
                                        description: description,
                                        iconKind: iconKind,
                                        onClick: onOptionSelected,
                                        tabIndex: tabIndex,
                                        chipLabel: isRecommended ? "Recommended" : null
                                    }),
                                    index < (0, $e4cfe974853390b2$export$2ea9789638c50423).length - 1 && /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$Divider, {})
                                ]
                            }, id))
                    })
                }) : null,
                (selectedOption || isSaviActionsTaken) && /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    children: isApplyActionLoading ? /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$LoaderComponent, {
                        text: "Thank you for your patience! I am working on getting smart decisions together for you."
                    }) : /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SmartReview, {
                        title: "What decisions can I make for you?",
                        isOptionSelected: isDynamicOptionSelected,
                        selectedOption: dynamicSelectedOption.join(", "),
                        setIsOptionSelected: setIsDynamicOptionSelected,
                        children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "Options-Wrapper",
                            children: smartReviewOptions.map(({ id: id, label: label, description: description, iconKind: iconKind, isManuallyReviewedItemsPresent: isManuallyReviewedItemsPresent, manuallyReviewedDetails: manuallyReviewedDetails, isSaviActionsApplied: isSaviActionsApplied, keepDecisionsLabel: keepDecisionsLabel, actionKey: actionKey, applyOverwriteKey: applyOverwriteKey, smartCancellationMessage: smartCancellationMessage })=>/*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviDynamicOption, {
                                    id: id,
                                    label: label,
                                    description: description,
                                    iconKind: iconKind,
                                    onClick: onDynamicOptionClick,
                                    isManuallyReviewedItemsPresent: isManuallyReviewedItemsPresent,
                                    setSmartSelectedOption: setSmartSelectedOption,
                                    manuallyReviewedDetails: manuallyReviewedDetails,
                                    isSaviActionsApplied: isSaviActionsApplied,
                                    keepDecisionsLabel: keepDecisionsLabel,
                                    isCheckBoxSelected: selectedSmartReviewOptions[actionKey],
                                    isKeepDecision: selectedSmartReviewOptions[applyOverwriteKey],
                                    smartCancellationMessage: smartCancellationMessage,
                                    selectedSmartReviewOptions: selectedSmartReviewOptions
                                }, id))
                        })
                    })
                })
            ]
        });
    if (!isCertificationActionable) return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$NothingToShow, {});
    if (errorDetails && errorDetails.title) return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$ErrorComponent, {
        errorText: errorDetails.title,
        retryAction: errorDetails.retryAction
    });
    if (isLoading) return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$LoaderComponent, {
        text: "Thank you for your patience! I am working on getting smart decisions together for you."
    });
    if (smartReviewOptions.length === 0) return /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$NothingToShow, {});
    return dynamicActionsBody();
}
$e40ef6d119a5d30a$var$SaviCompanionBody.propTypes = {
    smartReviewOptions: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setSelectedSmartReviewOptions: (0, $hopDi$proptypes).func.isRequired,
    selectedSmartReviewOptions: (0, $hopDi$proptypes).shape({}).isRequired,
    isApplyActionLoading: (0, $hopDi$proptypes).bool.isRequired,
    isSaviActionsTaken: (0, $hopDi$proptypes).bool.isRequired,
    isCertificationActionable: (0, $hopDi$proptypes).bool.isRequired,
    setShowSaviCompanion: (0, $hopDi$proptypes).func.isRequired,
    isLoading: (0, $hopDi$proptypes).bool.isRequired,
    errorDetails: (0, $hopDi$proptypes).shape({
        title: (0, $hopDi$proptypes).string,
        retryAction: (0, $hopDi$proptypes).func
    }).isRequired,
    onboardingList: (0, $hopDi$proptypes).func.isRequired,
    importSaviyntExAppClear: (0, $hopDi$proptypes).func.isRequired
};
const $e40ef6d119a5d30a$var$getDescriptionFromManuallyReviewedItems = (smartActionDetails, config)=>{
    const actionArray = [];
    config.manuallyReviewedMessageKeys.map((item)=>{
        const actionCount = smartActionDetails[item.actionTakenKey];
        if (actionCount > 0) actionArray.push(`${item.actionTakenLabel} ${actionCount} ${(0, $hopDi$pluralizeString)("item", actionCount > 1)}`);
        return item;
    });
    return `You've ${actionArray.join(", and ")} that I will smart ${config.label.toLowerCase()}.
  Would you like to maintain your decisions or would you like me to overwrite your decisions with smart ${config.manuallyReviewedActionConfirmation.toLowerCase()}?`;
};
const $e40ef6d119a5d30a$var$processSmartActionDetails = (smartActionDetails)=>{
    const newSmartReviewOptions = [];
    let saviActionTakenCount = 0;
    Object.keys(smartActionDetails).map((item)=>{
        const config = (0, $e4cfe974853390b2$export$66437e1fecf15ebb)[item];
        const manuallyReviewedTotal = smartActionDetails[item].manually_approved + smartActionDetails[item].manually_revoked + smartActionDetails[item].manually_enddate;
        const isSaviActionsTaken = smartActionDetails[item][config.actionTakenKey] > 0;
        const totalSmartActionsCount = smartActionDetails[item][isSaviActionsTaken ? config.actionTakenKey : config.totalKey] || 0;
        const keepDecisionsTotal = (totalSmartActionsCount || 0) - (manuallyReviewedTotal || 0);
        if (totalSmartActionsCount > 0) newSmartReviewOptions.push({
            id: item,
            label: `Smart ${config.label} ${totalSmartActionsCount} ${(0, $hopDi$pluralizeString)("Item", totalSmartActionsCount > 1)}`,
            keepDecisionsLabel: `Smart ${config.label} ${keepDecisionsTotal} ${(0, $hopDi$pluralizeString)("Item", keepDecisionsTotal > 1)}`,
            description: config.description,
            iconKind: config.iconKind,
            isManuallyReviewedItemsPresent: manuallyReviewedTotal > 0,
            isSaviActionsApplied: isSaviActionsTaken,
            smartCancellationMessage: `All Smart ${config.manuallyReviewedActionConfirmation} will be cancelled`,
            totalSmartActionsCount: totalSmartActionsCount,
            manuallyReviewedDetails: {
                title: `You have manually reviewed ${manuallyReviewedTotal} ${(0, $hopDi$pluralizeString)("item", manuallyReviewedTotal > 1)}`,
                description: $e40ef6d119a5d30a$var$getDescriptionFromManuallyReviewedItems(smartActionDetails[item], config),
                overwriteDecision: `Keep Your ${manuallyReviewedTotal} ${(0, $hopDi$pluralizeString)("Decision", manuallyReviewedTotal > 1)}`,
                cancelLabel: `Cancel Smart ${config.manuallyReviewedActionConfirmation}`
            },
            actionKey: config.applyActionKey,
            applyOverwriteKey: config.applyOverwriteKey
        });
        saviActionTakenCount += smartActionDetails[item][config.actionTakenKey];
        return item;
    });
    return {
        newSmartReviewOptions: newSmartReviewOptions,
        saviActionTakenCount: saviActionTakenCount
    };
};
function $e40ef6d119a5d30a$var$SaviCompanion({ certKey: certKey, setShowSaviCompanion: setShowSaviCompanion }) {
    const [isProceedWithSavi, setIsProceedWithSavi] = (0, $hopDi$useState)(false);
    const [smartReviewOptions, setSmartReviewOptions] = (0, $hopDi$useState)([]);
    const [selectedSmartReviewOptions, setSelectedSmartReviewOptions] = (0, $hopDi$useState)({});
    const [isSaviActionsTaken, setIsSaviActionsTaken] = (0, $hopDi$useState)(false);
    const showIntroLocal = $e40ef6d119a5d30a$var$cookies.get("show_savi_intro");
    const [showSaviCompanionIntro, setShowSaviCompanionIntro] = (0, $hopDi$useState)(!showIntroLocal || showIntroLocal === "1");
    const [errorDetails, setErrorDetails] = (0, $hopDi$useState)({});
    const dispatch = (0, $hopDi$useDispatch)();
    const { saviCompanionDetails: { statusDetails: { smartActionDetails: smartActionDetails, loading: loading } = {}, showIntro: showIntro, isApplyActionLoading: isApplyActionLoading }, columnNames: columnNames, tabs: { tabData: tabData }, isCertificationActionable: isCertificationActionable, mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    const getSaviStatus = ()=>{
        dispatch((0, $d623f23401a154f0$export$f4f9bb309d2b8abf)(certKey, setErrorDetails, getSaviStatus));
    };
    const mobileSaviFooterHeight = isMobileXlargeWidth && (Object.keys(selectedSmartReviewOptions).length > 0 ? "SaviCompanion-mobile-isSeeResults" : "SaviCompanion-mobile-isNotSeeResults");
    const saviModalClasses = (0, $hopDi$classnames)("SaviCompanion-modal", `SaviCompanion-main${isProceedWithSavi}`, mobileSaviFooterHeight);
    (0, $hopDi$useEffect)(()=>{
        if (isCertificationActionable) getSaviStatus();
    }, [
        isCertificationActionable
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (smartActionDetails) {
            const { newSmartReviewOptions: newSmartReviewOptions, saviActionTakenCount: saviActionTakenCount } = $e40ef6d119a5d30a$var$processSmartActionDetails(smartActionDetails);
            setSmartReviewOptions(newSmartReviewOptions);
            setIsSaviActionsTaken(saviActionTakenCount > 0);
            setIsProceedWithSavi(saviActionTakenCount > 0);
        }
    }, [
        smartActionDetails
    ]);
    const closeSaviPopup = ()=>{
        setShowSaviCompanion(false);
        setSmartReviewOptions([]);
        setSelectedSmartReviewOptions({});
    };
    const onApplySaviActions = ()=>{
        dispatch((0, $d623f23401a154f0$export$257ace57b4563d30)({
            certkey: certKey,
            signal: "TRUST_SCORE",
            ...selectedSmartReviewOptions
        }, {
            columnNames: columnNames,
            max: (0, $e4cfe974853390b2$export$aeca2bf7951e0a69),
            offset: 0,
            tabData: tabData,
            postSuccessAction: closeSaviPopup,
            postFailureAction: setErrorDetails,
            retryAction: onApplySaviActions
        }));
    };
    const onGotItClicked = ()=>{
        setIsProceedWithSavi(true);
        setShowSaviCompanionIntro(false);
        $e40ef6d119a5d30a$var$cookies.set("show_savi_intro", "0");
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        kind: "default",
        onClose: ()=>setShowSaviCompanion(false),
        className: saviModalClasses,
        isOpen: true,
        headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "SaviCompanion",
            size: "large"
        }),
        title: /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviCompanionTitle, {
            kind: !showSaviCompanionIntro ? "normal" : "landing"
        }),
        contentBody: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                showSaviCompanionIntro && /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviCompanionLandingBody, {
                    onGotItClick: onGotItClicked
                }),
                (!showIntro || isProceedWithSavi) && /*#__PURE__*/ (0, $hopDi$jsx)($e40ef6d119a5d30a$var$SaviCompanionBody, {
                    setSelectedSmartReviewOptions: setSelectedSmartReviewOptions,
                    selectedSmartReviewOptions: selectedSmartReviewOptions,
                    isLoading: loading,
                    isSaviActionsTaken: isSaviActionsTaken,
                    smartReviewOptions: smartReviewOptions,
                    setShowSaviCompanion: setShowSaviCompanion,
                    isApplyActionLoading: isApplyActionLoading,
                    errorDetails: errorDetails,
                    isCertificationActionable: isCertificationActionable
                })
            ]
        }),
        FooterActionBarComp: Object.keys(selectedSmartReviewOptions).length > 0 ? /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "SaviCompanion-Footer",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "filled",
                size: "large",
                className: "ApplyActionButton",
                onClick: onApplySaviActions,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2-bold",
                    className: "Text",
                    children: "See Results"
                })
            })
        }) : null
    }, "saviCompanionModal");
}
$e40ef6d119a5d30a$var$SaviCompanion.propTypes = {
    certKey: (0, $hopDi$proptypes).string.isRequired,
    setShowSaviCompanion: (0, $hopDi$proptypes).func.isRequired
};
var // SaviCompanion.defaultProps = {};
$e40ef6d119a5d30a$export$2e2bcd8739ae039 = $e40ef6d119a5d30a$var$SaviCompanion;













function $906ff14b2e08ddc3$export$d0db05f221f95({ title: title, description: description, isOpen: isOpen, setIsOpen: setIsOpen, children: children, value: value, onClick: onClick }) {
    const onPopoverClick = (flag)=>{
        setIsOpen(flag);
        if (onClick) onClick(flag);
    };
    // TODO: Update these generic class names to suitcss utility conventions
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
        className: "Savi-Companion-Popover",
        value: value,
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
            placement: "bottom",
            trigger: children,
            popoverContent: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                className: "Savi-Companion-Popover-Wrapper",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        className: "DisplayFlex",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "SaviCompanion",
                                size: "medium"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "h3",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body1",
                        className: "DescriptionText",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        className: "flexWrapper",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "filled",
                            size: "medium",
                            onClick: ()=>onPopoverClick(false),
                            children: "Got it"
                        })
                    })
                ]
            }),
            isOpen: isOpen,
            setIsOpen: onPopoverClick
        })
    });
}


var $636d79b44d133546$export$2e2bcd8739ae039 = (0, $906ff14b2e08ddc3$export$d0db05f221f95);









// TODO: @Vishnu, add prop validation for SaviIntroPopover. Also, move this to a new file (SaviIntroPopover).
function $7166cd89a2c7c0dc$var$SaviIntroPopover({ children: // eslint-disable-next-line react/prop-types
children, showSaviCompanionButtonPopup: // eslint-disable-next-line react/prop-types
showSaviCompanionButtonPopup, setShowSaviCompanionButtonPopup: // eslint-disable-next-line react/prop-types
setShowSaviCompanionButtonPopup }) {
    return showSaviCompanionButtonPopup ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $636d79b44d133546$export$2e2bcd8739ae039), {
        title: (0, $e4cfe974853390b2$export$a8beb73f40515af4),
        description: "If you'd like me to save you time and make some intelligence-based decisions for you, I'll be right here.",
        isOpen: showSaviCompanionButtonPopup,
        setIsOpen: setShowSaviCompanionButtonPopup,
        children: children
    }) : children;
}
function $7166cd89a2c7c0dc$var$CertsControlsGroup({ showFilterBar: showFilterBar, setShowFilterBar: setShowFilterBar, setShowSaviCompanion: setShowSaviCompanion, showSaviCompanionButtonPopup: showSaviCompanionButtonPopup, setShowSaviCompanionButtonPopup: setShowSaviCompanionButtonPopup, filterBarRef: filterBarRef, controlsRef: controlsRef, filters: filters, setFilters: setFilters, setIsDraggingDndItem: setIsDraggingDndItem }) {
    // For filter bar
    const [showBadgeOnFilterButton, setShowBadgeOnFilterButton] = (0, $hopDi$useState)(false);
    const [appliedFilters, setAppliedFilters] = (0, $hopDi$useState)([]);
    // For row filter
    const [showbadgeOnRowButton, setShowbadgeOnRowButton] = (0, $hopDi$useState)(false);
    const [rowFilters, setRowFilters] = (0, $hopDi$useState)([]);
    const [appliedRowFilters, setAppliedRowFilters] = (0, $hopDi$useState)([]);
    // For column filter
    const [colFilters, setColFilters] = (0, $hopDi$useState)([]);
    const [appliedColFilters, setAppliedColFilters] = (0, $hopDi$useState)({});
    // For Select All
    const [isSelectAllVisible, setIsSelectAllVisible] = (0, $hopDi$useState)(false);
    const [showTotalResults, setShowTotalResults] = (0, $hopDi$useState)(false);
    // Sort
    const [isSortOpen, setIsSortOpen] = (0, $hopDi$useState)(false);
    // Search
    const [isSearchBarExpanded, setIsSearchBarExpanded] = (0, $hopDi$useState)(false);
    // More button responsivness
    const [isMoreOpen, setIsMoreOpen] = (0, $hopDi$useState)(false);
    const [isButtonSelectLabelVisible, setIsButtonSelectLabelVisible] = (0, $hopDi$useState)(true);
    const [optionsInMore, setOptionsInMore] = (0, $hopDi$useState)([]);
    const [buttonConditions, setButtonConditions] = (0, $hopDi$useState)((0, $5630dd438c9b44f6$export$5fc0ac5e0be84463));
    const controlButtonsRef = (0, $hopDi$useRef)(null);
    const expandedObserverTargetRef = (0, $hopDi$useRef)(null);
    const noSearchObserverTargetRef = (0, $hopDi$useRef)(null);
    const iconSizedButtonsObserverTargetRef = (0, $hopDi$useRef)(null);
    const conditionalButtonsRef = (0, $hopDi$useRef)(null);
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, isLoading: isLoading, bulkAction: bulkAction, certKey: certKey, columnNames: columnNames, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton, totalItems: totalItems, objectForRedirectLink: objectForRedirectLink, searchText: searchText, isSidePanelVisible: isSidePanelVisible, viewRowsList: viewRowsList, tabs: { tabData: tabData }, saviCompanionDetails: { isSaviEnabled: isSaviEnabled } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const tabletMediumQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$e1d684fb703347f));
    const isTabletMediumWidth = tabletMediumQuery.value <= mediaQueryValue;
    const headerClasses = (0, $hopDi$classnames)("CertsControlsGroup", showFilterBar && "CertsControlsGroup--isFilterBar", tabData?.length && `CertsControlsGroup-tabLength--${tabData?.length}`, isSearchBarExpanded && "CertsControlsGroup--isSearchBarExpanded");
    const selectAllClasses = (0, $hopDi$classnames)("CertsControlsGroup-selectAll", isSelectAllVisible && "CertsControlsGroup-selectAll--isSelectAllVisible");
    const selectAllAreaClasses = (0, $hopDi$classnames)("CertsControlsGroup-selectAllArea", !isSelectAllVisible && !showTotalResults && "CertsControlsGroup-selectAllArea--noContent");
    const controlsGroupClasses = (0, $hopDi$classnames)("CertsControlsGroup-tabsAndControls");
    const controlButtonClasses = (0, $hopDi$classnames)("CertsControlsGroup-controlButtons");
    // Function to find the button condition by id
    const getVisibleCondition = (id)=>buttonConditions.find((condition)=>condition.id === id);
    const isSaviVisible = getVisibleCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).SAVI);
    const isFilterVisible = getVisibleCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).FILTER);
    const isGroupByVisible = getVisibleCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).GROUP_BY);
    const isRowsVisible = getVisibleCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).ROWS);
    const isColumnsVisible = getVisibleCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).COLUMNS);
    const isSortVisible = getVisibleCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).SORT);
    const isMoreVisible = getVisibleCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE);
    // Define the conditional classes for each button based on their visibility
    const conditionalButtonClasses = (0, $hopDi$classnames)("CertsControlsGroup-conditionalButtonsArray", !isSaviVisible?.isVisible && "CertsControlsGroup--isSaviInMore", !isFilterVisible?.isVisible && "CertsControlsGroup--isFilterInMore", !isGroupByVisible?.isVisible && "CertsControlsGroup--isGroupByInMore", !isRowsVisible?.isVisible && "CertsControlsGroup--isRowsInMore", !isColumnsVisible?.isVisible && "CertsControlsGroup--isColumnsInMore", !isSortVisible?.isVisible && "CertsControlsGroup--isSortInMore", !isMoreVisible?.isVisible && "CertsControlsGroup--isMoreVisible");
    const getRenderCondition = (id)=>{
        const button = buttonConditions.find((condition)=>condition.id === id);
        return id === (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE ? button.isVisible : button.shouldRender;
    };
    const isSaviRendered = getRenderCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).SAVI);
    const isFilterRendered = getRenderCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).FILTER);
    const isGroupByRendered = getRenderCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).GROUP_BY);
    const shouldShowRowFilterBtn = Boolean(viewRowsList && viewRowsList?.length > 1);
    const isRowsRendered = getRenderCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).ROWS) && shouldShowRowFilterBtn;
    const isSortRendered = getRenderCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).SORT);
    const isMoreRendered = getRenderCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE);
    // Set the observer widths on mount
    (0, $hopDi$useEffect)(()=>{
        // Update the render status of control buttons
        if (isSaviEnabled && !objectForRedirectLink?.consulteeLoggedIn) setButtonConditions((prev)=>prev.map((button)=>button.id === (0, $5630dd438c9b44f6$export$689ae8298085ebf).SAVI ? {
                    ...button,
                    shouldRender: true
                } : button));
        // Delay the setting of observer widths by 1 second
        const timerId = setTimeout(()=>{
            // Set observer widths
            const currentWidth = controlButtonsRef.current.offsetWidth;
            const newWidth = currentWidth - (0, $5630dd438c9b44f6$export$5697dc8441956872);
            if (expandedObserverTargetRef.current) expandedObserverTargetRef.current.style.width = `${newWidth}px`;
            if (noSearchObserverTargetRef.current) noSearchObserverTargetRef.current.style.width = `${newWidth}px`;
        }, 1000);
        return ()=>clearTimeout(timerId);
    }, [
        isSaviEnabled,
        objectForRedirectLink?.consulteeLoggedIn
    ]);
    // Update Tab Counts on Mount
    (0, $hopDi$useEffect)(()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$afd1b438af1720fe)(certKey, true));
    }, [
        certKey
    ]);
    (0, $hopDi$useEffect)(()=>{
        const activeTabCount = tabData?.find((tab)=>tab?.isActive)?.count;
        const selectAllFlag = Boolean(bulkAction?.isBulkActionEnabled && shouldShowReviewAndSubmitButton && activeTabCount > 0);
        setIsSelectAllVisible(selectAllFlag);
    }, [
        bulkAction?.isBulkActionEnabled,
        totalItems,
        shouldShowReviewAndSubmitButton,
        tabData
    ]);
    (0, $hopDi$useEffect)(()=>{
        const controlsContainer = controlsRef.current;
        const noSearchObserverTarget = noSearchObserverTargetRef.current;
        const expandedObserverTarget = expandedObserverTargetRef.current;
        if (!controlsContainer || !noSearchObserverTarget || !expandedObserverTarget) return;
        const simpleObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // Handle Label removal
                const isSearchExpanded = entry.target === expandedObserverTarget && isSearchBarExpanded;
                const isSearchNotExpanded = entry.target === noSearchObserverTarget && !isSearchBarExpanded;
                if (isSearchExpanded) {
                    if (entry.intersectionRatio === 1) setButtonConditions((prevConditions)=>prevConditions.map((button)=>button.id === (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE ? {
                                ...button,
                                isVisible: false
                            } : {
                                ...button,
                                isVisible: true
                            }));
                    setIsButtonSelectLabelVisible(entry.intersectionRatio === 1);
                }
                if (isSearchNotExpanded) {
                    if (entry.intersectionRatio === 1) setButtonConditions((prevConditions)=>prevConditions.map((button)=>button.id === (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE ? {
                                ...button,
                                isVisible: false
                            } : {
                                ...button,
                                isVisible: true
                            }));
                    setIsButtonSelectLabelVisible(entry.intersectionRatio === 1);
                }
            });
        }, {
            root: controlsContainer,
            threshold: 1
        });
        simpleObserver.observe(expandedObserverTarget);
        simpleObserver.observe(noSearchObserverTarget);
        // eslint-disable-next-line consistent-return
        return ()=>simpleObserver.disconnect();
    }, [
        isSidePanelVisible,
        filters,
        isSearchBarExpanded,
        isTabletMediumWidth,
        isButtonSelectLabelVisible
    ]);
    (0, $hopDi$useEffect)(()=>{
        const controlsContainer = controlsRef.current;
        const iconSizedButtonsObserverTarget = iconSizedButtonsObserverTargetRef.current;
        if (!controlsContainer || !iconSizedButtonsObserverTarget) return;
        const iconSizedButtonsObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const isMoreObserverAndLabelsHidden = entry.target === iconSizedButtonsObserverTarget && !isButtonSelectLabelVisible;
                if (isMoreObserverAndLabelsHidden) {
                    const roundedIntersectionRatio = Math.round(entry.intersectionRatio * 1000) / 1000;
                    const isVisible = roundedIntersectionRatio > 0.5;
                    const isFullyVisible = roundedIntersectionRatio === 1;
                    const isAllRenderableButtonsInMore = buttonConditions.filter((button)=>button.id !== "More" && button.shouldRender).every((button)=>!button.isVisible);
                    const isAllRenderableButtonsVisible = buttonConditions.filter((button)=>button.id !== "More" && button.shouldRender).every((button)=>button.isVisible);
                    if (!isVisible && !isAllRenderableButtonsInMore) setButtonConditions((prevConditions)=>{
                        const newConditions = [
                            ...prevConditions
                        ];
                        // Hide the last visible button that isn't "More"
                        for(let i = newConditions.length - 1; i >= 0; i -= 1)if (newConditions[i].isVisible && newConditions[i].id !== (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE) {
                            newConditions[i].isVisible = false;
                            break; // Stop once the last visible button is hidden
                        }
                        return newConditions;
                    });
                    if (isFullyVisible && !isAllRenderableButtonsVisible) setButtonConditions((prevConditions)=>{
                        const newConditions = [
                            ...prevConditions
                        ];
                        if (isFullyVisible && !isAllRenderableButtonsVisible) {
                            const firstHiddenIndex = newConditions.findIndex((c)=>!c.isVisible && c.id !== (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE);
                            if (firstHiddenIndex !== -1 && !newConditions[firstHiddenIndex].isVisible) {
                                newConditions[firstHiddenIndex].isVisible = true;
                                setButtonConditions(newConditions);
                            }
                        }
                        return newConditions;
                    });
                }
            });
        }, {
            root: controlsContainer,
            threshold: Array.from({
                length: 1001
            }, (_, i)=>i * 0.001)
        });
        iconSizedButtonsObserver.observe(iconSizedButtonsObserverTarget);
        // eslint-disable-next-line consistent-return
        return ()=>iconSizedButtonsObserver.disconnect();
    }, [
        buttonConditions,
        isSidePanelVisible,
        filters,
        isSearchBarExpanded,
        isTabletMediumWidth,
        isButtonSelectLabelVisible
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isButtonSelectLabelVisible) setButtonConditions((prevConditions)=>prevConditions.map((button)=>button.id === (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE ? {
                    ...button,
                    isVisible: false
                } : {
                    ...button,
                    isVisible: true
                }));
    }, [
        isButtonSelectLabelVisible
    ]);
    (0, $hopDi$useEffect)(()=>{
        const isAnyButtonInMore = buttonConditions.filter((button)=>button.id !== (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE && button.shouldRender).some((button)=>!button.isVisible);
        const moreButton = buttonConditions.find((button)=>button.id === (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE);
        if (isAnyButtonInMore && moreButton.isVisible) return;
        if (!isAnyButtonInMore && moreButton.isVisible) setButtonConditions((prevConditions)=>prevConditions.map((button)=>button.id === (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE ? {
                    ...button,
                    isVisible: false
                } : button));
        if (isAnyButtonInMore && !moreButton.isVisible) setButtonConditions((prevConditions)=>prevConditions.map((button)=>button.id === (0, $5630dd438c9b44f6$export$689ae8298085ebf).MORE ? {
                    ...button,
                    isVisible: true
                } : button));
    }, [
        buttonConditions,
        isSidePanelVisible,
        filters,
        isSearchBarExpanded,
        isTabletMediumWidth,
        isButtonSelectLabelVisible
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (searchText?.length > 0 || showBadgeOnFilterButton && !isLoading || showbadgeOnRowButton && !isLoading) setShowTotalResults(true);
        else setShowTotalResults(false);
    }, [
        searchText,
        isLoading,
        showBadgeOnFilterButton
    ]);
    (0, $hopDi$useEffect)(()=>{
        const debouncedUpdate = (0, $hopDi$debounce)(()=>{
            setOptionsInMore(buttonConditions.filter((button)=>button.shouldRender && !button.isVisible).map((button)=>button.id));
        }, 50);
        debouncedUpdate();
        return ()=>debouncedUpdate.cancel();
    }, [
        buttonConditions
    ]);
    const handleBulkChange = ()=>{
        dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
        if (bulkAction?.isIndeterminate) {
            const prevBulkCheckStatus = bulkAction?.isChecked;
            const prevBulkIndeterminateStatus = bulkAction?.isIndeterminate;
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(true));
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(prevBulkIndeterminateStatus));
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(prevBulkCheckStatus));
            });
            return;
        }
        const prevBulkCheckStatus = bulkAction?.isChecked;
        if (prevBulkCheckStatus) {
            dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
                dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            });
            return;
        }
        dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(true));
        dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey)).then(()=>{
            dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
            dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(prevBulkCheckStatus));
        });
    };
    const resetSort = ()=>{
        dispatch((0, $d623f23401a154f0$export$683be6298bff3717)());
        dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, (0, $5630dd438c9b44f6$export$aeca2bf7951e0a69), (0, $5630dd438c9b44f6$export$3231e969238304f3)));
    };
    const handleDynamicSort = (selectedOption, sortDirection)=>{
        if (selectedOption) {
            const sortValue = sortDirection.find((ele)=>ele.isChecked);
            dispatch((0, $d623f23401a154f0$export$aa7b16fe4622cebe)(selectedOption.columnName, sortValue?.value || "asc"));
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "section",
        className: headerClasses,
        dataTestId: "details-controls-group",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$StackingAlertBanner), {
                colorTheme: "Critical",
                title: "Action Failed",
                description: bulkAction?.alert?.alertText || "",
                isVisible: bulkAction?.alert?.isAlert,
                onCancel: ()=>dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(false, ""))
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: controlsGroupClasses,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $b8f7c55addb0e434$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "CertsControlsGroup-controls",
                        ref: controlsRef,
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "CertsControlsGroup-spacingObservers",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        ref: expandedObserverTargetRef,
                                        className: "CertsControlsGroup-expandedObserverTarget"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        ref: noSearchObserverTargetRef,
                                        className: "CertsControlsGroup-noSearchObserverTarget"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: controlButtonClasses,
                                ref: controlButtonsRef,
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                        className: conditionalButtonClasses,
                                        ref: conditionalButtonsRef,
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                                ref: iconSizedButtonsObserverTargetRef,
                                                className: "CertsControlsGroup-iconSizedButtonsObserverTarget"
                                            }),
                                            isSaviRendered && /*#__PURE__*/ (0, $hopDi$jsx)($7166cd89a2c7c0dc$var$SaviIntroPopover, {
                                                showSaviCompanionButtonPopup: showSaviCompanionButtonPopup,
                                                setShowSaviCompanionButtonPopup: setShowSaviCompanionButtonPopup,
                                                children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                                    role: "button",
                                                    "aria-label": "SaviCompanion",
                                                    className: "Savi-Companion-Button",
                                                    tabIndex: 0,
                                                    onKeyDown: ()=>setShowSaviCompanion(true),
                                                    onClick: ()=>setShowSaviCompanion(true),
                                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                        kind: "SaviCompanion",
                                                        size: "smallMedium"
                                                    })
                                                })
                                            }),
                                            isFilterRendered && /*#__PURE__*/ (0, $hopDi$jsx)((0, $1c4893cc536d206e$export$2e2bcd8739ae039), {
                                                filters: filters,
                                                showFilterBar: showFilterBar,
                                                setShowFilterBar: setShowFilterBar,
                                                showBadgeOnFilterButton: showBadgeOnFilterButton,
                                                isButtonKindIcon: isButtonSelectLabelVisible
                                            }),
                                            isGroupByRendered && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                                                className: "CertsGroupByButton",
                                                label: "Group By",
                                                kind: isButtonSelectLabelVisible ? "rectangle" : "icon",
                                                onClick: ()=>{
                                                    (0, $hopDi$Logger).log(" Placeholder Button ");
                                                },
                                                isOpen: false,
                                                size: "medium",
                                                prefixIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                    kind: "Dashboard",
                                                    color: "neutral-600",
                                                    size: "smallMedium"
                                                })
                                            }),
                                            isRowsRendered && /*#__PURE__*/ (0, $hopDi$jsx)((0, $49b471e64a4eb65c$export$2e2bcd8739ae039), {
                                                showbadgeOnRowButton: showbadgeOnRowButton,
                                                setShowbadgeOnRowButton: setShowbadgeOnRowButton,
                                                rowFilters: rowFilters,
                                                setRowFilters: setRowFilters,
                                                appliedRowFilters: appliedRowFilters,
                                                setAppliedRowFilters: setAppliedRowFilters,
                                                isButtonKindIcon: isButtonSelectLabelVisible
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $1b64cfc1069de672$export$2e2bcd8739ae039), {
                                                colFilters: colFilters,
                                                setColFilters: setColFilters,
                                                appliedColFilters: appliedColFilters,
                                                setAppliedColFilters: setAppliedColFilters,
                                                isButtonKindIcon: isButtonSelectLabelVisible,
                                                setIsDraggingDndItem: setIsDraggingDndItem
                                            }),
                                            isSortRendered && /*#__PURE__*/ (0, $hopDi$jsx)((0, $96bbb2b8ad24fb0a$export$2e2bcd8739ae039), {
                                                isSortOpen: isSortOpen,
                                                setIsSortOpen: setIsSortOpen,
                                                rowFilters: rowFilters,
                                                colFilters: colFilters,
                                                appliedRowFilters: appliedRowFilters,
                                                handleSort: handleDynamicSort,
                                                resetDynamicSort: resetSort,
                                                hideSortForBeta: !getRenderCondition((0, $5630dd438c9b44f6$export$689ae8298085ebf).SORT)
                                            }),
                                            isMoreRendered && /*#__PURE__*/ (0, $hopDi$jsx)((0, $22e1a26357cf11ca$export$2e2bcd8739ae039), {
                                                options: optionsInMore,
                                                setIsMoreOpen: setIsMoreOpen,
                                                // Filter
                                                showFilterBar: showFilterBar,
                                                setShowFilterBar: setShowFilterBar,
                                                // Rows
                                                rowFilters: rowFilters,
                                                appliedRowFilters: appliedRowFilters,
                                                setAppliedRowFilters: setAppliedRowFilters,
                                                // Columns
                                                colFilters: colFilters,
                                                setColFilters: setColFilters,
                                                appliedColFilters: appliedColFilters,
                                                setAppliedColFilters: setAppliedColFilters,
                                                setIsDraggingDndItem: setIsDraggingDndItem
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $2e9a0432bbfd77e3$export$2e2bcd8739ae039), {
                                        isMoreOpen: isMoreOpen,
                                        isSearchBarExpanded: isSearchBarExpanded,
                                        setIsSearchBarExpanded: setIsSearchBarExpanded
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsControlsGroup-advancedFilters",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9080a8ca19badea3$export$2e2bcd8739ae039), {
                    setShowBadgeOnFilterButton: setShowBadgeOnFilterButton,
                    showFilterBar: showFilterBar,
                    setShowFilterBar: setShowFilterBar,
                    filters: filters,
                    setFilters: setFilters,
                    appliedFilters: appliedFilters,
                    setAppliedFilters: setAppliedFilters,
                    filterBarRef: filterBarRef
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: selectAllAreaClasses,
                children: [
                    isSelectAllVisible && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: selectAllClasses,
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                name: "simpleText",
                                kind: "simpleText",
                                dataTestId: "simpleText",
                                isChecked: bulkAction?.isChecked,
                                isDisabled: totalItems === 0 || bulkAction?.isDisabled || bulkAction?.isSubmittingAction || isLoading,
                                isIndeterminate: bulkAction?.isIndeterminate,
                                onChange: handleBulkChange,
                                label: `Select All (${totalItems})`,
                                textPosition: "after",
                                showHoverEffect: true
                            }),
                            bulkAction?.isSelecting && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                                kind: "loop",
                                format: "inline",
                                color: "brand",
                                size: "small"
                            })
                        ]
                    }),
                    showTotalResults && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsControlsGroup-totalResults",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            children: `Total Results: ${totalItems}`
                        })
                    })
                ]
            })
        ]
    });
}
$7166cd89a2c7c0dc$var$CertsControlsGroup.propTypes = {
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    setShowFilterBar: (0, $hopDi$proptypes).func.isRequired,
    setShowSaviCompanion: (0, $hopDi$proptypes).func.isRequired,
    showSaviCompanionButtonPopup: (0, $hopDi$proptypes).bool,
    setShowSaviCompanionButtonPopup: (0, $hopDi$proptypes).func,
    controlsRef: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).func,
        (0, $hopDi$proptypes).shape({
            current: (0, $hopDi$proptypes).instanceOf(Element)
        })
    ]),
    filterBarRef: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).func,
        (0, $hopDi$proptypes).shape({
            current: (0, $hopDi$proptypes).instanceOf(Element)
        })
    ]),
    filters: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setFilters: (0, $hopDi$proptypes).func.isRequired,
    setIsDraggingDndItem: (0, $hopDi$proptypes).func.isRequired
};
$7166cd89a2c7c0dc$var$CertsControlsGroup.defaultProps = {
    showSaviCompanionButtonPopup: false,
    setShowSaviCompanionButtonPopup: ()=>{},
    controlsRef: null,
    filterBarRef: null
};
var $7166cd89a2c7c0dc$export$2e2bcd8739ae039 = $7166cd89a2c7c0dc$var$CertsControlsGroup;


var $2c4c83dadce0c268$export$2e2bcd8739ae039 = (0, $7166cd89a2c7c0dc$export$2e2bcd8739ae039);


/* eslint-disable indent */ 




















const $144e182e72703db5$var$KINDS = {
    warning: "warning",
    success: "success",
    critical: "critical",
    default: "default"
};
function $144e182e72703db5$var$LinearProgressBar({ value: value, kind: kind, showPointer: showPointer }) {
    const progressBarFillerColor = (0, $hopDi$classnames)(`LinearProgressBar-filler--${kind} ${showPointer && value < 100 ? "show-pointer" : "no-pointer"}`);
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "LinearProgressBar",
        "data-testid": "linear-progress-bar",
        children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: progressBarFillerColor,
            style: {
                height: "100%",
                width: `${value}%`
            }
        })
    });
}
$144e182e72703db5$var$LinearProgressBar.propTypes = {
    value: (0, $hopDi$proptypes).number,
    kind: (0, $hopDi$proptypes).oneOf(Object.values($144e182e72703db5$var$KINDS)),
    showPointer: (0, $hopDi$proptypes).bool
};
$144e182e72703db5$var$LinearProgressBar.defaultProps = {
    value: 0,
    kind: "default",
    showPointer: false
};
var $144e182e72703db5$export$2e2bcd8739ae039 = $144e182e72703db5$var$LinearProgressBar;


var $f731ea5e88f23f43$export$2e2bcd8739ae039 = (0, $144e182e72703db5$export$2e2bcd8739ae039);

















function $c898782d608477c1$var$DecisionLabel({ value: value, label: label, iconKind: iconKind, description: description }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "DecisionLabel-item",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "body1",
                className: "DecisionLabel-itemCount",
                children: value
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                kind: iconKind,
                color: "navy-900",
                size: "small",
                className: "DecisionLabel-itemIcon"
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                kind: "body2",
                className: "DecisionLabel-itemLabel",
                children: [
                    label,
                    /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                        className: "DecisionLabel-notify",
                        children: description && description
                    })
                ]
            })
        ]
    });
}
$c898782d608477c1$var$DecisionLabel.propTypes = {
    value: (0, $hopDi$proptypes).number.isRequired,
    label: (0, $hopDi$proptypes).string.isRequired,
    iconKind: (0, $hopDi$proptypes).string.isRequired,
    description: (0, $hopDi$proptypes).string
};
$c898782d608477c1$var$DecisionLabel.defaultProps = {
    description: ""
};
var $c898782d608477c1$export$2e2bcd8739ae039 = $c898782d608477c1$var$DecisionLabel;


/* eslint-disable indent */ 









const $c3fd831cb38d6d24$export$6712e0f6cd0ea03 = (count, totalCount)=>{
    if (totalCount === 0) return "0%";
    return `(${Math.round(count * 100 / totalCount)}%)`;
};
const $c3fd831cb38d6d24$export$c3e0f520a0aee8fc = (count, totalCount)=>Math.round(count * 100 / totalCount);
const $c3fd831cb38d6d24$export$a8484eb76959731d = (labelStatus)=>{
    switch(labelStatus){
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).MANAGER_NOT_CONFIRMED:
            return "NotConfirmedByManager";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).REVOKED:
            return "Revoked";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).CONSULT:
            return "Consult";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).ROLE:
            return "Role";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).ACCOUNT:
            return "Account";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).USER:
            return "UserNoBg";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).ENTITLEMENT:
            return "Entitlement";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).APPROVED:
            return "Check";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).TERMINATED:
            return "Terminate";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).NO_ACTION_REQUIRED:
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).REJECTED:
            return "Reject";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).END_DATE_CHANGED:
            return "ExtendEndDate";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).CONDITIONALLY_CERTIFIED:
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).PENDING:
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).REASSIGN:
            return "Reassign";
        case (0, $bf14b63763e2d183$export$c4cfef2de2ef9e6a).MANAGER_CONFIRMED:
        default:
            return "Manager";
    }
};
const $c3fd831cb38d6d24$export$83b788b1a3698c03 = (obj)=>Object.keys(obj).length === 0;
const $c3fd831cb38d6d24$export$af094ef85befd6db = {
    User: 0,
    Account: 1,
    Role: 2,
    Entitlement: 3
};
const $c3fd831cb38d6d24$export$adcbf81cce860edd = {
    "Manager Confirmed": 0,
    ManagerConfirmed: 0,
    "Manager Confirmed With End Date Changed": 1,
    ManagerConfirmedWithEndDateChanged: 1,
    "Not Confirmed By Manager": 2,
    Terminated: 3,
    Approved: 4,
    Rejected: 5,
    "End Date Changed": 6,
    EndDateChanged: 6,
    "Conditionally Certified": 7,
    ConditionallyCertified: 7,
    Reassigned: 8,
    "No Action Required": 9,
    NoActionRequired: 9
};
const $c3fd831cb38d6d24$export$a85d4de01aaf3250 = (a, b)=>{
    const decisionA = a[0];
    const decisionB = b[0];
    return $c3fd831cb38d6d24$export$adcbf81cce860edd[decisionA] - $c3fd831cb38d6d24$export$adcbf81cce860edd[decisionB];
};
const $c3fd831cb38d6d24$export$20888ab678d31dc7 = (a, b)=>{
    const roleA = a[0];
    const roleB = b[0];
    return $c3fd831cb38d6d24$export$af094ef85befd6db[roleA] - $c3fd831cb38d6d24$export$af094ef85befd6db[roleB];
};
var $c3fd831cb38d6d24$export$2e2bcd8739ae039 = {
    getPercentage: $c3fd831cb38d6d24$export$6712e0f6cd0ea03,
    getIconKind: $c3fd831cb38d6d24$export$a8484eb76959731d,
    isEmptyObject: $c3fd831cb38d6d24$export$83b788b1a3698c03,
    customSortByType: $c3fd831cb38d6d24$export$20888ab678d31dc7
};




const $aff3e1b514240397$var$excludeProperties = [
    (0, $bf14b63763e2d183$export$71efb3495f6084f2),
    (0, $bf14b63763e2d183$export$aebb42912407fb2d),
    (0, $bf14b63763e2d183$export$fbc5ebe2e580bf8b),
    (0, $bf14b63763e2d183$export$e135c39ae3ebb92e)
];
function $aff3e1b514240397$var$ViewByDecision() {
    const dispatch = (0, $hopDi$useDispatch)();
    const intl = (0, $hopDi$useIntl)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const { certKey: certKey, progressBreakdowndetails: progressBreakdowndetails } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { isLoading: isLoading, byDecisionDetails: byDecisionDetails, errorMessage: errorMessage } = progressBreakdowndetails;
    (0, $hopDi$useEffect)(()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef)));
    }, [
        certKey
    ]);
    const refreshProgressDataByDecision = ()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef)));
    };
    const showErrorMessage = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "ViewByDecision-progressFailure",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2-bold",
                    className: "ViewByDecision-errorMessage",
                    children: "Couldn't load decision progress breakdown data. Please refresh or try again later."
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "filled",
                    size: "medium",
                    onClick: refreshProgressDataByDecision,
                    children: "Refresh"
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "ViewByDecision",
        children: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "ViewByDecision-loader",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "small"
            })
        }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                errorMessage && showErrorMessage(),
                byDecisionDetails?.Summary && !(0, $c3fd831cb38d6d24$export$83b788b1a3698c03)(byDecisionDetails?.Summary) ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ViewByDecision-todoSection",
                            children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                className: "ViewByDecision-todo",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body1",
                                        className: "ViewByDecision-todoCount",
                                        children: byDecisionDetails.Summary[0, $bf14b63763e2d183$export$aebb42912407fb2d]
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2-bold",
                                        className: "ViewByDecision-todoLabel",
                                        children: "To do"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ViewByDecision-divider"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ViewByDecision-doneSection",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "ViewByDecision-done",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ViewByDecision-doneCount",
                                            children: byDecisionDetails.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2]
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2-bold",
                                            className: "ViewByDecision-doneLabel",
                                            children: "Done"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "ViewByDecision-doneItems",
                                    children: byDecisionDetails && Object.entries(byDecisionDetails.Summary).filter(([key])=>!$aff3e1b514240397$var$excludeProperties.includes(key)).sort((0, $c3fd831cb38d6d24$export$a85d4de01aaf3250)).map(([key, value])=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $c898782d608477c1$export$2e2bcd8739ae039), {
                                            value: value,
                                            iconKind: (0, $c3fd831cb38d6d24$export$a8484eb76959731d)(key),
                                            label: messages[key] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key))
                                        }, key))
                                })
                            ]
                        }),
                        byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$39f29f4125141985] && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "ViewByDecision-divider"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "ViewByDecision-consulted",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ViewByDecision-consultedCount",
                                            children: byDecisionDetails.Summary[0, $bf14b63763e2d183$export$39f29f4125141985]
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2-bold",
                                            className: "ViewByDecision-consultedLabel",
                                            children: "Consulted"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : !errorMessage && showErrorMessage()
            ]
        })
    });
}
var $aff3e1b514240397$export$2e2bcd8739ae039 = $aff3e1b514240397$var$ViewByDecision;











function $e7b279ebfe32fd45$var$TypeLabel({ count: count, totalCount: totalCount, label: label, iconKind: iconKind }) {
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "TypeLabel-item",
        children: [
            iconKind && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "icon",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: iconKind,
                    color: "navy-900",
                    size: "small",
                    className: "TypeLabel-itemIcon"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "TypeLabel-mainContent",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2-bold",
                        className: "TypeLabel-itemLabel",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $f731ea5e88f23f43$export$2e2bcd8739ae039), {
                        value: (0, $c3fd831cb38d6d24$export$c3e0f520a0aee8fc)(count, totalCount)
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "TypeLabel-progress",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "TypeLabel-progressNumber",
                                children: `${count} of ${totalCount}`
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "TypeLabel-progressPercentage",
                                children: (0, $c3fd831cb38d6d24$export$6712e0f6cd0ea03)(count, totalCount)
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3-bold",
                                className: "TypeLabel-progressStatus",
                                children: "Done"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$e7b279ebfe32fd45$var$TypeLabel.propTypes = {
    count: (0, $hopDi$proptypes).number.isRequired,
    totalCount: (0, $hopDi$proptypes).number.isRequired,
    label: (0, $hopDi$proptypes).string.isRequired,
    iconKind: (0, $hopDi$proptypes).string
};
$e7b279ebfe32fd45$var$TypeLabel.defaultProps = {
    iconKind: null
};
var $e7b279ebfe32fd45$export$2e2bcd8739ae039 = $e7b279ebfe32fd45$var$TypeLabel;


/* eslint-disable indent */ 











function $bf1a33cef097b883$var$ViewByType() {
    const dispatch = (0, $hopDi$useDispatch)();
    const intl = (0, $hopDi$useIntl)();
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const { certKey: certKey, progressBreakdowndetails: progressBreakdowndetails } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { isLoading: isLoading, byTypeDetails: byTypeDetails, errorMessage: errorMessage } = progressBreakdowndetails;
    (0, $hopDi$useEffect)(()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$14ae8ea77646ac77)));
    }, [
        certKey
    ]);
    const refreshProgressDataByType = ()=>{
        if (certKey) dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$14ae8ea77646ac77)));
    };
    const showErrorMessage = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "ViewByType-progressFailure",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2-bold",
                    className: "ViewByType-errorMessage",
                    children: "Couldn't load type progress breakdown data. Please refresh or try again later."
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "filled",
                    size: "medium",
                    onClick: refreshProgressDataByType,
                    children: "Refresh"
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        className: "ViewByType",
        children: isLoading ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "ViewByType-loader",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "small"
            })
        }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                errorMessage && showErrorMessage(),
                byTypeDetails?.Summary && !(0, $c3fd831cb38d6d24$export$83b788b1a3698c03)(byTypeDetails?.Summary) ? Object.entries(byTypeDetails.Summary)?.sort((0, $c3fd831cb38d6d24$export$20888ab678d31dc7)).map(([key, value])=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $e7b279ebfe32fd45$export$2e2bcd8739ae039), {
                        count: value[0, $bf14b63763e2d183$export$71efb3495f6084f2],
                        totalCount: value[0, $bf14b63763e2d183$export$e135c39ae3ebb92e],
                        iconKind: (0, $c3fd831cb38d6d24$export$a8484eb76959731d)(key),
                        label: messages[key] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(key))
                    }, key)) : !errorMessage && showErrorMessage()
            ]
        })
    });
}
var $bf1a33cef097b883$export$2e2bcd8739ae039 = $bf1a33cef097b883$var$ViewByType;






function $c9e15190d21f97b8$var$PopoverContent() {
    const [selection, setSelection] = (0, $hopDi$useState)(1);
    const { progressBreakdowndetails: progressBreakdowndetails } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { byDecisionDetails: byDecisionDetails } = progressBreakdowndetails;
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "PopoverContent",
        children: [
            byDecisionDetails?.Summary && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2-bold",
                        className: "PopoverContent-progressInfoTitle",
                        children: "All Items"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $f731ea5e88f23f43$export$2e2bcd8739ae039), {
                        value: (0, $c3fd831cb38d6d24$export$c3e0f520a0aee8fc)(byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2], byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e])
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "PopoverContent-progressBreakdown",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "PopoverContent-progressBreakdownCount",
                                children: `${byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2]} of ${byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e]}`
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3",
                                className: "PopoverContent-progressBreakdownPercentage",
                                children: (0, $c3fd831cb38d6d24$export$6712e0f6cd0ea03)(byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2], byDecisionDetails?.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e])
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body3-bold",
                                className: "PopoverContent-progressBreakdownStatus",
                                children: "Done"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "PopoverContent-tabs",
                children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ToggleButtonGroup), {
                            selection: selection,
                            setSelection: setSelection,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                                    label: "By Decision"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                                    label: "By Type"
                                })
                            ]
                        }),
                        selection === 1 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $aff3e1b514240397$export$2e2bcd8739ae039), {}),
                        selection === 2 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $bf1a33cef097b883$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
}
var $c9e15190d21f97b8$export$2e2bcd8739ae039 = $c9e15190d21f97b8$var$PopoverContent;



function $f22be45875ddd715$var$PopoverProgressBreakdown({ closePopover: closePopover, isProgressBarOpen: isProgressBarOpen, setIsProgressBarOpen: setIsProgressBarOpen, isMobileWidth: isMobileWidth }) {
    if (isMobileWidth) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
        isSwipeEnabled: true,
        isOpen: isProgressBarOpen,
        setIsOpen: setIsProgressBarOpen,
        isCloseButtonEnabled: false,
        className: "PopoverProgressBreakdown-mobileDrawer",
        content: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "h2",
                    mobile: "h3-d",
                    className: "PopoverProgressBreakdown-title",
                    children: "Progress"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $c9e15190d21f97b8$export$2e2bcd8739ae039), {})
            ]
        })
    });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "PopoverProgressBreakdown",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "PopoverProgressBreakdown-close",
                onClick: closePopover,
                onKeyDown: ()=>{},
                tabIndex: "0",
                role: "button",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Close",
                    color: "neutral-1000",
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h2",
                mobile: "h3-d",
                className: "PopoverProgressBreakdown-title",
                children: "Progress"
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $c9e15190d21f97b8$export$2e2bcd8739ae039), {})
        ]
    });
}
$f22be45875ddd715$var$PopoverProgressBreakdown.propTypes = {
    closePopover: (0, $hopDi$proptypes).func.isRequired,
    isProgressBarOpen: (0, $hopDi$proptypes).bool.isRequired,
    setIsProgressBarOpen: (0, $hopDi$proptypes).func.isRequired,
    isMobileWidth: (0, $hopDi$proptypes).bool.isRequired
};
$f22be45875ddd715$var$PopoverProgressBreakdown.defaultProps = {};
var $f22be45875ddd715$export$2e2bcd8739ae039 = $f22be45875ddd715$var$PopoverProgressBreakdown;





var $aedec3a09ed0c484$export$2e2bcd8739ae039 = (0, $f22be45875ddd715$export$2e2bcd8739ae039);







const $7e937afea8da6d42$export$cc844e58ea5510e9 = 500;
const $7e937afea8da6d42$export$d0f02cc015bd5768 = "REVIEWANDSUBMIT";
const $7e937afea8da6d42$export$cfce94e2b700a1a1 = "decision";
const $7e937afea8da6d42$export$31c34eb4b50de0b6 = "type";
const $7e937afea8da6d42$export$df8f064ab2a7c09c = [
    $7e937afea8da6d42$export$cfce94e2b700a1a1,
    $7e937afea8da6d42$export$31c34eb4b50de0b6
];
const $7e937afea8da6d42$export$506d5022cff8f7df = "primary_certifier";
const $7e937afea8da6d42$export$842181aaa7a414ff = "secondary_certifier";
const $7e937afea8da6d42$export$e38f3fe6f8e2e1d5 = "review_and_submit_completed";
const $7e937afea8da6d42$export$5d9f356b4d4d5628 = "review_and_submit_not_completed";
const $7e937afea8da6d42$export$33413024a053a1ca = "review_and_submit_step_1";
const $7e937afea8da6d42$export$deab3fee8d04afb5 = "review_and_submit_step_2";
const $7e937afea8da6d42$export$4414b99fd5cdebbf = "review_and_submit_signature";
const $7e937afea8da6d42$export$c7ded6134c5259a8 = "review_and_submit_comment";
const $7e937afea8da6d42$export$73e83bf2b7e02467 = [
    "small",
    "medium",
    "large"
];
const $7e937afea8da6d42$export$3dc46c1eba4a1c65 = "Locked by User";
const $7e937afea8da6d42$export$f1e53f710478ceb4 = {
    [$7e937afea8da6d42$export$506d5022cff8f7df]: {
        [$7e937afea8da6d42$export$e38f3fe6f8e2e1d5]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review and Submit Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review and Submit Your Certification"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review and Submit Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review and Submit Your Certification"
            }
        },
        [$7e937afea8da6d42$export$5d9f356b4d4d5628]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Your Certification Is Incomplete"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Your Certification Is Incomplete"
            }
        }
    },
    [$7e937afea8da6d42$export$842181aaa7a414ff]: {
        [$7e937afea8da6d42$export$e38f3fe6f8e2e1d5]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Complete Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Complete Your Certification"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Complete Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Complete Your Certification"
            }
        },
        [$7e937afea8da6d42$export$5d9f356b4d4d5628]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Complete Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Complete Your Certification"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Complete Your Certification",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Complete Your Certification"
            }
        }
    }
};
const $7e937afea8da6d42$export$5895c693c74b9cf4 = {
    [$7e937afea8da6d42$export$506d5022cff8f7df]: {
        [$7e937afea8da6d42$export$e38f3fe6f8e2e1d5]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Step 1 of 2",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Step 2 of 2"
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Step 1 of 2",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Step 2 of 2"
            }
        },
        [$7e937afea8da6d42$export$5d9f356b4d4d5628]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "You still have $$$ before your certification can be submitted.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "You still have $$$ before your certification can be submitted."
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "You still have $$$ before your certification can be submitted.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "You still have $$$ before your certification can be submitted."
            }
        }
    },
    [$7e937afea8da6d42$export$842181aaa7a414ff]: {
        [$7e937afea8da6d42$export$e38f3fe6f8e2e1d5]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review the items you've certified, and send them to the primary certifier $$$ who'll complete and submit the certification.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review the items you've certified, and send them to the primary certifier $$$ who'll complete and submit the certification."
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review the items you've certified, and send them to the primary certifier $$$ who'll complete and submit the certification.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review the items you've certified, and send them to the primary certifier $$$ who'll complete and submit the certification."
            }
        },
        [$7e937afea8da6d42$export$5d9f356b4d4d5628]: {
            [$7e937afea8da6d42$export$c7ded6134c5259a8]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review the items you've certified, and send them to the primary certifier $$$ who'll complete and submit the certification.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review the items you've certified, and send them to the primary certifier $$$ who'll complete and submit the certification."
            },
            [$7e937afea8da6d42$export$4414b99fd5cdebbf]: {
                [$7e937afea8da6d42$export$33413024a053a1ca]: "Review the items you've certified, and send them to the primary certifier $$$ who'll complete and submit the certification.",
                [$7e937afea8da6d42$export$deab3fee8d04afb5]: "Review the items you've certified, and send them to the primary certifier $$$ who'll complete and submit the certification."
            }
        }
    }
};



















const $c465f91860c9b0b1$export$86d760a8248fd97d = "Done";
const $c465f91860c9b0b1$export$7eb5fd7a28f937f3 = "Total";
const $c465f91860c9b0b1$export$75b3fab2883bdf8c = "Progress";
const $c465f91860c9b0b1$export$51ec0eec30d8f725 = "Pending";
const $c465f91860c9b0b1$export$b8e11e47a6aeff19 = {
    NoActionRequired: "ReassignItem",
    Done: "Check",
    Progress: "Check",
    Pending: "Consult",
    Approved: "Check",
    Rejected: "Reject",
    Total: "Reject",
    Terminated: "Terminate",
    Reassigned: "Reassign",
    "Manager Confirmed With End Date Changed": "ConfirmManager",
    "End Date Changed": "ExtendEndDate",
    "Not Confirmed By Manager": "NotConfirmedByManager",
    Revoked: "Revoked",
    Consult: "Consult",
    "Manager Confirmed": "ConfirmManager",
    "Conditionally Certified": "ExtendEndDate"
};
const $c465f91860c9b0b1$export$dfb085eaafffeece = {
    NoActionRequired: "No Action Required",
    Done: "Done",
    Progress: "Progress",
    Pending: "Pending",
    Approved: "Approved",
    Rejected: "Rejected",
    Total: "Total",
    Terminated: "Terminated",
    Reassigned: "Reassigned",
    "End Date Changed": "End Date Changed",
    "Not Confirmed By Manager": "Not Confirmed By Manager",
    "Manager Confirmed With End Date Changed": "Manager Confirmed With End Date Changed",
    "Manager Confirmed": "Manager Confirmed",
    "Conditionally Certified": "Conditionally Certified"
};
const $c465f91860c9b0b1$export$39a5b354431fba10 = {
    Role: "Role",
    Account: "Account",
    User: "UserNoBg",
    Entitlement: "Entitlement"
};
const $c465f91860c9b0b1$export$895acf55e792a35d = {
    User: "User",
    Account: "Account",
    Role: "Role",
    Entitlement: "Entitlement"
};
const $c465f91860c9b0b1$export$52c6ab51891f47ee = {
    "Manager Confirmed": 0,
    ManagerConfirmed: 0,
    "Manager Confirmed With End Date Changed": 1,
    ManagerConfirmedWithEndDateChanged: 1,
    "Not Confirmed By Manager": 2,
    Terminated: 3,
    Approved: 4,
    Rejected: 5,
    "End Date Changed": 6,
    EndDateChanged: 6,
    "Conditionally Certified": 7,
    ConditionallyCertified: 7,
    Reassigned: 8,
    "No Action Required": 9,
    NoActionRequired: 9
};



const $5242db288afcc49b$var$CONFIGDATA = {
    primaryCertifier: (0, $hopDi$proptypes).bool,
    isComplete: (0, $hopDi$proptypes).bool,
    withESignature: (0, $hopDi$proptypes).bool
};
var $5242db288afcc49b$export$2e2bcd8739ae039 = $5242db288afcc49b$var$CONFIGDATA;


var $0beb3fe990c568f7$export$2e2bcd8739ae039 = (0, $5242db288afcc49b$export$2e2bcd8739ae039);



function $61a6d08e636110b4$var$Step1({ isModalOpen: isModalOpen, firstStep: firstStep, configData: configData }) {
    const [selection, setSelection] = (0, $hopDi$useState)(1);
    const [step1DataByDecision, setStep1DataByDecision] = (0, $hopDi$useState)({});
    const [step1DataByType, setStep1DataByType] = (0, $hopDi$useState)({});
    const step1BodyWrapperRef = (0, $hopDi$useRef)("step1BodyWrapperRef");
    const shouldRenderDecisionList = Boolean(step1DataByDecision && Object.keys(step1DataByDecision).length > 0);
    const shouldRenderTypeList = Boolean(step1DataByType && Object.keys(step1DataByType).length > 0);
    const shouldShowNoDataForDecision = Boolean(configData?.todoTabCount === 0 && !shouldRenderDecisionList);
    const viewToDoListObjects = [
        (0, $c465f91860c9b0b1$export$51ec0eec30d8f725),
        (0, $c465f91860c9b0b1$export$75b3fab2883bdf8c),
        (0, $c465f91860c9b0b1$export$86d760a8248fd97d),
        (0, $c465f91860c9b0b1$export$7eb5fd7a28f937f3)
    ];
    (0, $hopDi$useEffect)(()=>{
        setTimeout(()=>{
            setSelection(1);
            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(step1BodyWrapperRef, 0);
        }, (0, $7e937afea8da6d42$export$cc844e58ea5510e9));
    }, [
        firstStep,
        isModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (configData) {
            setStep1DataByDecision(configData?.step1Data?.[0, $7e937afea8da6d42$export$cfce94e2b700a1a1]);
            setStep1DataByType(configData?.step1Data?.[0, $7e937afea8da6d42$export$31c34eb4b50de0b6]);
        }
    }, [
        configData
    ]);
    const reviewAndSubmitModalBodyStep1 = (0, $hopDi$classnames)("ReviewAndSubmitModal-bodyStep1Wrapper");
    const renderStep1Shorts = ()=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "ReviewAndSubmitModal-bodyStep1WrapperShorts",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $e7b279ebfe32fd45$export$2e2bcd8739ae039), {
                count: step1DataByDecision?.[0, $c465f91860c9b0b1$export$86d760a8248fd97d] || 0,
                totalCount: step1DataByDecision?.[0, $c465f91860c9b0b1$export$7eb5fd7a28f937f3] || 0,
                label: "All Items"
            })
        });
    const renderStep1Stats = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ReviewAndSubmitModal-bodyStep1WrapperStats",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2-bold",
                    className: "ReviewAndSubmitModal-bodyStep1WrapperStatsTitle",
                    children: "Progress Details"
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescription",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ToggleButtonGroup), {
                            selection: selection,
                            setSelection: setSelection,
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                                    label: "By Decision"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                                    label: "By Type"
                                })
                            ]
                        }),
                        !configData?.isComplete && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncomplete",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncompleteText",
                                            children: `${configData?.todoTabCount}`
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncompleteText",
                                            children: "To Do"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                    className: "ReviewAndSubmitModal-bodyStep1WrapperHLine"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncomplete",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncompleteText",
                                            children: `${configData?.doneTabCount}`
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body1",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionIncompleteText",
                                            children: "Done"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionList",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: selection === 1 ? "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionDecisionList--visible" : "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionDecisionList--hidden",
                                    children: [
                                        shouldRenderDecisionList && Object.keys(step1DataByDecision).filter((key)=>!viewToDoListObjects.includes(key)).sort((a, b)=>(0, $c465f91860c9b0b1$export$52c6ab51891f47ee)[a] - (0, $c465f91860c9b0b1$export$52c6ab51891f47ee)[b]).map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $c898782d608477c1$export$2e2bcd8739ae039), {
                                                value: step1DataByDecision[key] || 0,
                                                iconKind: (0, $c465f91860c9b0b1$export$b8e11e47a6aeff19)[key] || "Terminate",
                                                label: (0, $c465f91860c9b0b1$export$dfb085eaafffeece)[key] || "Terminated"
                                            }, key)),
                                        shouldShowNoDataForDecision && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionListCategoryMessage",
                                            children: "Not able to show summary for this certification."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                                    className: selection === 2 ? "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionTypeList--visible" : "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionTypeList--hidden",
                                    children: [
                                        shouldRenderTypeList && Object.keys((0, $c465f91860c9b0b1$export$895acf55e792a35d)).filter((key)=>Boolean(step1DataByType[key])).map((key)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $e7b279ebfe32fd45$export$2e2bcd8739ae039), {
                                                count: step1DataByType?.[key]?.[0, $c465f91860c9b0b1$export$86d760a8248fd97d],
                                                totalCount: step1DataByType?.[key]?.[0, $c465f91860c9b0b1$export$7eb5fd7a28f937f3],
                                                label: (0, $c465f91860c9b0b1$export$895acf55e792a35d)?.[key] || "",
                                                iconKind: (0, $c465f91860c9b0b1$export$39a5b354431fba10)?.[key] || ""
                                            }, key)),
                                        !shouldRenderTypeList && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body2",
                                            className: "ReviewAndSubmitModal-bodyStep1WrapperStatsDescriptionListCategoryMessage",
                                            children: "Not able to show summary for this certification."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: reviewAndSubmitModalBodyStep1,
        ref: step1BodyWrapperRef,
        children: [
            renderStep1Shorts(),
            renderStep1Stats()
        ]
    });
}
$61a6d08e636110b4$var$Step1.propTypes = {
    isModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    configData: (0, $hopDi$proptypes).shape((0, $0beb3fe990c568f7$export$2e2bcd8739ae039))
};
$61a6d08e636110b4$var$Step1.defaultProps = {
    configData: {}
};
var $61a6d08e636110b4$export$2e2bcd8739ae039 = $61a6d08e636110b4$var$Step1;


var $328d7b406278ef5b$export$2e2bcd8739ae039 = (0, $61a6d08e636110b4$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-one-expression-per-line */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable import/no-extraneous-dependencies -- requried for signature */ 












const $a358fc339b0a2079$export$2c2d63fc3ac6387a = "Under the Electronic Signature in Global and National Commerce Act (E-sign), this agreement and all electronic executed documents related hereto are legally binding in the same manner as are hard copy documents executed by hand signature.";
const $a358fc339b0a2079$export$8704469cbf3a8b0d = "";
const $a358fc339b0a2079$export$785f226259a2f905 = "SIGNATURE_ALERT_COUNT_USERNAME";
const $a358fc339b0a2079$export$5fda98cb5df0734d = "SIGNATURE_ALERT_COUNT_SIGNATURE";
const $a358fc339b0a2079$export$9af400ad4180fd4d = "SIGNATURE_ALERT_COUNT_AGREE_BTN";
const $a358fc339b0a2079$export$478adefe39e62e49 = "SIGNATURE_ALERT_COUNT_COMMENT";
const $a358fc339b0a2079$export$b1002483f894c26c = "esign_password";
const $a358fc339b0a2079$export$22d97d682d25d08 = "esign_type";
const $a358fc339b0a2079$export$4c71c21203ea4bc = "esign_draw";
const $a358fc339b0a2079$export$488e307073e5295d = "esign_upload";



var $9694675c3ac08467$export$2e2bcd8739ae039 = (0, $5242db288afcc49b$export$2e2bcd8739ae039);


const $a3a59a656673dced$export$5a269d4abf2bd409 = (baseArray, key, condition)=>{
    const isPresentInBaseArray = baseArray.includes(key);
    if (isPresentInBaseArray && condition || !isPresentInBaseArray && !condition) return baseArray;
    if (isPresentInBaseArray && !condition) return baseArray.filter((item)=>item !== key);
    if (!isPresentInBaseArray && condition) return [
        ...baseArray,
        key
    ];
    return [];
};
const $a3a59a656673dced$export$47a328b4cabd57cc = (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });



function $006ec638c01b2b4e$var$Step2({ isModalOpen: isModalOpen, firstStep: firstStep, configData: configData, isAlertActive: isAlertActive, setIsAlertActive: setIsAlertActive, setDataForSubmitAction: setDataForSubmitAction }) {
    const [isESignature, setIsESignature] = (0, $hopDi$useState)(false);
    const [isCommentEnabled, setIsCommentEnabled] = (0, $hopDi$useState)(false);
    const [isPrimaryCertifier, setIsPrimaryCertifier] = (0, $hopDi$useState)(true);
    const [step2CommentData, setStep2CommentData] = (0, $hopDi$useState)({
        commentDescription: "",
        predefComments: [],
        isCommentApplied: false,
        showAlert: false
    });
    const [step2SignatureData, setStep2SignatureData] = (0, $hopDi$useState)({
        userAttribute: "",
        enableloginSignature: "",
        noOfTries: "",
        predefComments: [],
        userAttributeValue: "",
        isAgreeChecked: false,
        commentDescription: "",
        isCommentApplied: false,
        eSignatureData: "",
        eSignatureTab: "",
        showAlert: false,
        alertFields: []
    });
    const step2BodyWrapperRef = (0, $hopDi$useRef)("step2BodyWrapperRef");
    const signaturePadDraw = (0, $hopDi$useRef)("signature_pad_draw");
    const signatureBoxRef = (0, $hopDi$useRef)(null);
    const intl = (0, $hopDi$useIntl)();
    const { mediaQueryValue: mediaQueryValue, isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit, predefinedComments: predefinedComments } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user);
    const mobileLargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileLargeQuery.value <= mediaQueryValue;
    const { uploadedFiles: uploadedFiles, handleFileSelect: handleFileSelect, handleFileDelete: handleFileDelete, handleFileReupload: handleFileReupload, reuploadFileName: reuploadFileName, hasAnyUploadErrors: hasAnyUploadErrors } = (0, $hopDi$useUploadFile)();
    const shouldShowStep2ForComment = Boolean(isPrimaryCertifier && isESignature);
    const shouldShowAlertForUserNameForSignature = Boolean(step2SignatureData.showAlert && step2SignatureData.userAttributeValue?.trim().length === 0);
    const shouldShowAlertForESignatureData = Boolean(step2SignatureData.showAlert && step2SignatureData.eSignatureData?.trim().length === 0);
    const shouldDisabledClearBtnForESig = Boolean(step2SignatureData.eSignatureData?.trim().length === 0 || isSubmittingReviewAndSubmit);
    const shouldShowAlertForTncForSignature = Boolean(step2SignatureData.showAlert && !step2SignatureData.isAgreeChecked);
    const shouldShowAlertForCommentForSignature = Boolean(step2SignatureData.showAlert && step2SignatureData.commentDescription?.length === 0);
    const reviewAndSubmitModalBodyStep2 = (0, $hopDi$classnames)("ReviewAndSubmitModal-bodyStep2Wrapper", isESignature && "ReviewAndSubmitModal-bodyStep2Wrapper--withESignature");
    (0, $hopDi$useEffect)(()=>{
        setTimeout(()=>{
            (0, $e7628c995f405891$export$63087e5d2dd3ce07)(step2BodyWrapperRef, 0);
        }, (0, $7e937afea8da6d42$export$cc844e58ea5510e9));
    }, [
        firstStep,
        isModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isModalOpen) {
            setStep2CommentData({
                ...step2CommentData,
                commentDescription: "",
                showAlert: false
            });
            setStep2SignatureData({
                ...step2SignatureData,
                userAttributeValue: "",
                eSignatureData: "",
                isAgreeChecked: false,
                commentDescription: "",
                eSignatureTab: step2SignatureData.enableloginSignature === "1" ? (0, $a358fc339b0a2079$export$b1002483f894c26c) : (0, $a358fc339b0a2079$export$22d97d682d25d08),
                showAlert: false,
                alertFields: []
            });
        }
    }, [
        isModalOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (configData) {
            setIsESignature(configData?.withESignature);
            setIsCommentEnabled(configData?.isCommentEnabled);
            setIsPrimaryCertifier(configData?.primaryCertifier);
            setStep2CommentData((prev)=>({
                    ...prev,
                    predefComments: configData?.step2Data?.predefComments
                }));
            setStep2SignatureData((prev)=>({
                    ...prev,
                    enableloginSignature: configData?.enableloginSignature,
                    userAttribute: configData?.userAttribute,
                    noOfTries: configData?.noOfTries,
                    eSignatureTab: configData?.enableloginSignature === "1" ? (0, $a358fc339b0a2079$export$b1002483f894c26c) : (0, $a358fc339b0a2079$export$22d97d682d25d08),
                    predefComments: configData?.step2Data?.predefComments
                }));
        }
    }, [
        configData
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isESignature && isAlertActive && isPrimaryCertifier) {
            const tempAlertFields = [];
            if (step2SignatureData.userAttributeValue.trim().length === 0) tempAlertFields.push((0, $a358fc339b0a2079$export$785f226259a2f905));
            if (step2SignatureData.eSignatureData.trim().length === 0) tempAlertFields.push((0, $a358fc339b0a2079$export$5fda98cb5df0734d));
            if (!step2SignatureData.isAgreeChecked) tempAlertFields.push((0, $a358fc339b0a2079$export$9af400ad4180fd4d));
            if (isCommentEnabled && step2SignatureData.commentDescription.trim().length === 0) tempAlertFields.push((0, $a358fc339b0a2079$export$478adefe39e62e49));
            setStep2SignatureData({
                ...step2SignatureData,
                alertFields: tempAlertFields,
                showAlert: isAlertActive
            });
        }
        if (isCommentEnabled && (!isESignature || !isPrimaryCertifier) && isAlertActive) {
            setIsAlertActive(false);
            setStep2CommentData({
                ...step2CommentData,
                showAlert: isAlertActive && step2CommentData.commentDescription.trim().length === 0
            });
        }
    }, [
        isAlertActive
    ]);
    (0, $hopDi$useEffect)(()=>{
        setDataForSubmitAction({
            isESignature: isESignature,
            isPrimaryCertifier: isPrimaryCertifier,
            isCommentEnabled: isCommentEnabled,
            step2CommentData: step2CommentData,
            step2SignatureData: step2SignatureData
        });
    }, [
        isESignature,
        step2CommentData,
        step2SignatureData
    ]);
    // Without Signature Functions
    const handleCommentDescription = (text)=>{
        setStep2CommentData({
            ...step2CommentData,
            commentDescription: text,
            showAlert: text.length === 0 ? step2CommentData.showAlert : false
        });
    };
    // With Signature functions
    const handleSignatureUserName = (text)=>{
        setStep2SignatureData({
            ...step2SignatureData,
            userAttributeValue: text,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$785f226259a2f905), text.trim().length === 0)
        });
    };
    // ESignature Box
    const [tabTypeData, setTabTypeData] = (0, $hopDi$useState)("");
    (0, $hopDi$useEffect)(()=>{
        if (typeof signaturePadDraw?.current === "object") signaturePadDraw?.current?.on();
        return ()=>{
            if (typeof signaturePadDraw?.current === "object") signaturePadDraw?.current?.off();
        };
    }, []);
    const handleSignatureESignTab = (tab)=>{
        setTabTypeData("");
        if (signaturePadDraw.current && typeof signaturePadDraw.current === "object" && typeof signaturePadDraw.current.clear !== "undefined") signaturePadDraw?.current?.clear();
        uploadedFiles.length = 0;
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: "",
            eSignatureTab: tab,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), true)
        });
    };
    const handleSignatureESignTypeAndPassword = (event)=>{
        setTabTypeData(event.target.value);
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: event.target.value,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), event.target.value.length === 0)
        });
    };
    const handleSignatureESignDrawOnBegin = ()=>{
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: "signature_started",
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), false)
        });
    };
    const handleSignatureESignDrawOnEnd = ()=>{
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: signaturePadDraw?.current?.toDataURL("image/svg", 1.0),
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), false)
        });
    };
    (0, $hopDi$useEffect)(()=>{
        const shouldSetData = Boolean(uploadedFiles.length > 0 && step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$488e307073e5295d) && !hasAnyUploadErrors);
        if (shouldSetData) (0, $a3a59a656673dced$export$47a328b4cabd57cc)(uploadedFiles[0].file).then((base64Text)=>{
            setStep2SignatureData({
                ...step2SignatureData,
                eSignatureData: base64Text,
                alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), base64Text.trim().length === 0)
            });
        });
    }, [
        uploadedFiles
    ]);
    const handleSignatureClearBtn = ()=>{
        if (step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$22d97d682d25d08) || step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$b1002483f894c26c)) setTabTypeData("");
        if (step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$4c71c21203ea4bc)) signaturePadDraw?.current?.clear();
        if (step2SignatureData.eSignatureTab === (0, $a358fc339b0a2079$export$488e307073e5295d)) uploadedFiles.length = 0;
        setStep2SignatureData({
            ...step2SignatureData,
            eSignatureData: "",
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$5fda98cb5df0734d), true)
        });
    };
    // Rest
    const handleAgreeCheckBox = ()=>{
        setStep2SignatureData({
            ...step2SignatureData,
            isAgreeChecked: !step2SignatureData.isAgreeChecked,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$9af400ad4180fd4d), step2SignatureData.isAgreeChecked)
        });
    };
    const handleSignatureComment = (text)=>{
        setStep2SignatureData({
            ...step2SignatureData,
            commentDescription: text,
            alertFields: (0, $a3a59a656673dced$export$5a269d4abf2bd409)(step2SignatureData.alertFields, (0, $a358fc339b0a2079$export$478adefe39e62e49), text?.length === 0)
        });
    };
    // Alert box function
    const handleAlertClose = ()=>{
        setIsAlertActive(false);
        if (isESignature && isPrimaryCertifier) setStep2SignatureData({
            ...step2SignatureData,
            showAlert: false,
            alertFields: []
        });
        if (!isESignature || !isPrimaryCertifier) setStep2CommentData({
            ...step2CommentData,
            showAlert: false
        });
    };
    const getAlertBoxTitle = ()=>shouldShowStep2ForComment ? `Required fields (${step2SignatureData.alertFields.length}) are missing.` : "Required field is missing.";
    const renderStep2WithOutSignature = ()=>{
        if (isCommentEnabled) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
            isDisabled: isSubmittingReviewAndSubmit,
            defaultComments: predefinedComments[0, $7e937afea8da6d42$export$d0f02cc015bd5768] || step2CommentData?.predefComments,
            showAlert: step2CommentData.showAlert,
            onChange: handleCommentDescription
        });
        return null;
    };
    // With Esignature
    const renderTabsForStep2SignatureBox = ()=>{
        if (step2SignatureData.enableloginSignature === "1") return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
            moreContainerRef: signatureBoxRef,
            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup",
            value: step2SignatureData.eSignatureTab,
            onChange: handleSignatureESignTab,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Password",
                    value: (0, $a358fc339b0a2079$export$b1002483f894c26c),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Password",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after"
                })
            ]
        });
        if (step2SignatureData.enableloginSignature === "0") return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
            moreContainerRef: signatureBoxRef,
            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup",
            value: step2SignatureData.eSignatureTab,
            onChange: handleSignatureESignTab,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Type",
                    value: (0, $a358fc339b0a2079$export$22d97d682d25d08),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "KeyBoard",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Draw",
                    value: (0, $a358fc339b0a2079$export$4c71c21203ea4bc),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "Edit",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Upload",
                    value: (0, $a358fc339b0a2079$export$488e307073e5295d),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "ImageOutline",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after"
                })
            ]
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabGroup), {
            moreContainerRef: signatureBoxRef,
            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup",
            value: step2SignatureData.eSignatureTab,
            onChange: handleSignatureESignTab,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabItem), {
                    label: "Type",
                    value: (0, $a358fc339b0a2079$export$22d97d682d25d08),
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "KeyBoard",
                        size: "medium",
                        color: "neutral-600"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after"
                })
            ]
        });
    };
    const renderStep2WithSignature = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                    name: "basic",
                    placeholder: `Please enter ${messages[step2SignatureData?.userAttribute] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(step2SignatureData?.userAttribute?.split(".")[0]))} if applicable else enter N/A`,
                    isDisabled: isSubmittingReviewAndSubmit,
                    label: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                        kind: "label",
                        mobile: "h4-d",
                        htmlFor: "Critical",
                        children: [
                            "Enter",
                            " ",
                            messages[step2SignatureData?.userAttribute] || (0, $hopDi$localize)(intl, (0, $e7628c995f405891$export$7cad4c9063025e24)(step2SignatureData?.userAttribute?.split(".")[0]))
                        ]
                    }),
                    value: step2SignatureData.userAttributeValue,
                    setValue: handleSignatureUserName,
                    kind: "singleline",
                    isRequired: true,
                    isCritical: shouldShowAlertForUserNameForSignature,
                    CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "missingRequiredField",
                        size: "small"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureESig",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureESigBox",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                                name: "basic",
                                placeholder: "",
                                isDisabled: isSubmittingReviewAndSubmit,
                                value: step2SignatureData.eSignatureData,
                                label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "label",
                                    mobile: "h4-d",
                                    htmlFor: "Critical",
                                    children: "E-Signature"
                                }),
                                kind: "multiline",
                                isRequired: true,
                                isCritical: shouldShowAlertForESignatureData || step2SignatureData.eSignatureData === "",
                                CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                                    text: "This required field is incomplete",
                                    colorTheme: "critical",
                                    size: "small",
                                    leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "AlertCritical",
                                        color: "critical-700"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            ref: signatureBoxRef,
                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePad",
                            children: [
                                renderTabsForStep2SignatureBox(),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent",
                                    value: step2SignatureData.eSignatureTab,
                                    tabValue: (0, $a358fc339b0a2079$export$b1002483f894c26c),
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText",
                                            children: "Type your password"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("input", {
                                            type: "password",
                                            maxLength: "32",
                                            value: tabTypeData,
                                            onChange: handleSignatureESignTypeAndPassword,
                                            className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentInput ${tabTypeData.length > 0 ? "filled" : ""}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent",
                                    value: step2SignatureData.eSignatureTab,
                                    tabValue: (0, $a358fc339b0a2079$export$22d97d682d25d08),
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText",
                                            children: "Type your name to sign"
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("input", {
                                            type: "text",
                                            maxLength: "32",
                                            value: tabTypeData,
                                            onChange: handleSignatureESignTypeAndPassword,
                                            className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentInput ${tabTypeData.length > 0 ? "filled" : ""}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$TabContent), {
                                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent",
                                    value: step2SignatureData.eSignatureTab,
                                    tabValue: (0, $a358fc339b0a2079$export$4c71c21203ea4bc),
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$reactsignaturecanvas), {
                                            ref: signaturePadDraw,
                                            onBegin: handleSignatureESignDrawOnBegin,
                                            onEnd: handleSignatureESignDrawOnEnd,
                                            canvasProps: {
                                                className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentDraw ${step2SignatureData.eSignatureData.length > 0 ? "hideBgText" : ""}`
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText",
                                            children: "Draw your signature"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$TabContent), {
                                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent",
                                    value: step2SignatureData.eSignatureTab,
                                    tabValue: (0, $a358fc339b0a2079$export$488e307073e5295d),
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Upload), {
                                        kind: "button",
                                        isMultiple: false,
                                        onFileSelect: handleFileSelect,
                                        onFileDelete: handleFileDelete,
                                        onFileReupload: handleFileReupload,
                                        uploadedFiles: uploadedFiles,
                                        acceptTypes: ".pdf,.png,.jpeg,.jpg",
                                        reuploadFileName: reuploadFileName,
                                        isMaxNumberUploaded: uploadedFiles.length === 1,
                                        isMaxTotalSizeReached: uploadedFiles.length === 1,
                                        maxFileSize: 10,
                                        maxTotalFileSize: 10,
                                        helperText: "",
                                        className: "ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentUpload"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadClearBtn ${shouldShowAlertForESignatureData ? "" : "noCommentsPresent"}`,
                            kind: shouldDisabledClearBtnForESig ? "filled" : "outlined",
                            isDisabled: shouldDisabledClearBtnForESig,
                            onClick: handleSignatureClearBtn,
                            size: "small",
                            children: "Clear"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureTnC",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "label",
                            mobile: "h4-d",
                            htmlFor: "Disabled",
                            children: "Terms and Conditions"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureTnCText",
                            children: (0, $a358fc339b0a2079$export$2c2d63fc3ac6387a)
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "ReviewAndSubmitModal-bodyStep2WrapperSignatureTnCCheckBox",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InputField), {
                                name: "Warning",
                                placeholder: "",
                                isDisabled: isSubmittingReviewAndSubmit,
                                label: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                    kind: "simpleText",
                                    isChecked: step2SignatureData.isAgreeChecked,
                                    onChange: handleAgreeCheckBox,
                                    label: "I agree",
                                    size: "small",
                                    textPosition: "after",
                                    showHoverEffect: true
                                }),
                                value: step2SignatureData.isAgreeChecked ? "TnC" : (0, $a358fc339b0a2079$export$8704469cbf3a8b0d),
                                kind: "singleline",
                                isRequired: true,
                                isCritical: shouldShowAlertForTncForSignature,
                                CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                                    kind: "missingRequiredField",
                                    size: "small"
                                })
                            })
                        })
                    ]
                }),
                isCommentEnabled && /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
                    isDisabled: isSubmittingReviewAndSubmit,
                    defaultComments: predefinedComments[0, $7e937afea8da6d42$export$d0f02cc015bd5768] || step2SignatureData?.predefComments,
                    showAlert: shouldShowAlertForCommentForSignature,
                    onChange: handleSignatureComment
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: reviewAndSubmitModalBodyStep2,
        ref: step2BodyWrapperRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                colorTheme: "Critical",
                title: getAlertBoxTitle(),
                description: "",
                isColonVisible: false,
                isVisible: shouldShowStep2ForComment ? step2SignatureData.showAlert && step2SignatureData.alertFields.length > 0 : step2CommentData.showAlert,
                onCancel: handleAlertClose,
                LinkComponent: isESignature ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                    kind: "button",
                    onClick: ()=>{
                    // url='/route' // TODO: @Jacob, @Sagar, May need to scroll to ESignature
                    },
                    text: "View",
                    suffixIconKind: "ArrowDown",
                    color: "neutralInverse"
                }) : null,
                isFloating: true,
                position: isMobileXlargeWidth ? {
                    type: "fixed",
                    top: "0.5rem",
                    left: "0",
                    right: "1rem"
                } // Spacing left not working due to hidden slideing panels
                 : {
                    type: "fixed",
                    top: "0.5rem"
                },
                className: "CertsReviewAndSubmit-alertBanner"
            }),
            shouldShowStep2ForComment ? renderStep2WithSignature() : renderStep2WithOutSignature()
        ]
    });
}
$006ec638c01b2b4e$var$Step2.propTypes = {
    isModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    configData: (0, $hopDi$proptypes).shape((0, $9694675c3ac08467$export$2e2bcd8739ae039)),
    isAlertActive: (0, $hopDi$proptypes).bool.isRequired,
    setIsAlertActive: (0, $hopDi$proptypes).func,
    setDataForSubmitAction: (0, $hopDi$proptypes).func
};
$006ec638c01b2b4e$var$Step2.defaultProps = {
    configData: {},
    setIsAlertActive: ()=>{},
    setDataForSubmitAction: ()=>{}
};
var $006ec638c01b2b4e$export$2e2bcd8739ae039 = $006ec638c01b2b4e$var$Step2;


var $9b03f6fc2c2722e1$export$2e2bcd8739ae039 = (0, $006ec638c01b2b4e$export$2e2bcd8739ae039);



function $03a3cae6b20059c5$var$ReviewAndSubmitBody({ firstStep: firstStep, isModalOpen: isModalOpen, isAlertActive: isAlertActive, setIsAlertActive: setIsAlertActive, setDataForSubmitAction: setDataForSubmitAction, retriggerApisForError: retriggerApisForError, closeReviewAndSubmitModal: closeReviewAndSubmitModal }) {
    const { isLoadingReviewAndSubmit: isLoadingReviewAndSubmit, reviewAndSubmit: reviewAndSubmit, reviewAndSubmitError: reviewAndSubmitError, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const todoTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const doneTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408))?.count;
    const [config, setConfig] = (0, $hopDi$useState)({});
    const hasZeroCountForItems = todoTabCount === 0;
    (0, $hopDi$useEffect)(()=>{
        if (reviewAndSubmit) setConfig({
            primaryCertifier: reviewAndSubmit?.primaryCertifier,
            isComplete: hasZeroCountForItems,
            withESignature: reviewAndSubmit?.withESignature,
            isCommentEnabled: reviewAndSubmit?.isCommentEnabled,
            enableloginSignature: reviewAndSubmit?.enableloginSignature,
            todoTabCount: todoTabCount,
            doneTabCount: doneTabCount,
            step1Data: reviewAndSubmit?.step1Data,
            step2Data: reviewAndSubmit?.step2Data,
            userAttribute: reviewAndSubmit?.userAttribute,
            noOfTries: reviewAndSubmit?.noOfTries
        });
    }, [
        todoTabCount,
        reviewAndSubmit
    ]);
    const reviewAndSubmitModalBody = (0, $hopDi$classnames)("ReviewAndSubmitModal-body");
    const renderFailedApiUi = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ReviewAndSubmitModal-bodyError",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "h2",
                    children: "Couldn't Load"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    children: "The Summary didn't load properly due to a network issue. Please refresh or try again later."
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ReviewAndSubmitModal-bodyErrorButtons",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "filled",
                            onClick: retriggerApisForError,
                            size: "medium",
                            children: "Refresh"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            size: "medium",
                            onClick: closeReviewAndSubmitModal,
                            children: "Close"
                        })
                    ]
                })
            ]
        });
    const renderLoaderAndSteps = ()=>{
        if (isLoadingReviewAndSubmit) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyLoader--loading",
                    children: reviewAndSubmitError ? renderFailedApiUi() : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "dots",
                        format: "inline",
                        color: "info",
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep1--loading",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $328d7b406278ef5b$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2--loading",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9b03f6fc2c2722e1$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config,
                        isAlertActive: isAlertActive,
                        setIsAlertActive: setIsAlertActive,
                        setDataForSubmitAction: setDataForSubmitAction
                    })
                })
            ]
        });
        if (firstStep) return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyLoader--finished",
                    children: reviewAndSubmitError ? renderFailedApiUi() : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "dots",
                        format: "inline",
                        color: "info",
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep1--visible",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $328d7b406278ef5b$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2--hidden",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9b03f6fc2c2722e1$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config,
                        isAlertActive: isAlertActive,
                        setIsAlertActive: setIsAlertActive,
                        setDataForSubmitAction: setDataForSubmitAction
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyLoader--hidden",
                    children: reviewAndSubmitError ? renderFailedApiUi() : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                        kind: "dots",
                        format: "inline",
                        color: "info",
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep1--hidden",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $328d7b406278ef5b$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "ReviewAndSubmitModal-bodyStep2--visible",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9b03f6fc2c2722e1$export$2e2bcd8739ae039), {
                        isModalOpen: isModalOpen,
                        firstStep: firstStep,
                        configData: config,
                        isAlertActive: isAlertActive,
                        setIsAlertActive: setIsAlertActive,
                        setDataForSubmitAction: setDataForSubmitAction
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)("section", {
        className: reviewAndSubmitModalBody,
        children: renderLoaderAndSteps()
    });
}
$03a3cae6b20059c5$var$ReviewAndSubmitBody.propTypes = {
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    isModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    isAlertActive: (0, $hopDi$proptypes).bool.isRequired,
    setIsAlertActive: (0, $hopDi$proptypes).func,
    setDataForSubmitAction: (0, $hopDi$proptypes).func,
    retriggerApisForError: (0, $hopDi$proptypes).func.isRequired,
    closeReviewAndSubmitModal: (0, $hopDi$proptypes).func.isRequired
};
$03a3cae6b20059c5$var$ReviewAndSubmitBody.defaultProps = {
    setIsAlertActive: ()=>{},
    setDataForSubmitAction: ()=>{}
};
var $03a3cae6b20059c5$export$2e2bcd8739ae039 = $03a3cae6b20059c5$var$ReviewAndSubmitBody;


var $935cccc08f9a7d44$export$2e2bcd8739ae039 = (0, $03a3cae6b20059c5$export$2e2bcd8739ae039);










const $3f56701b4fa5d690$export$6941e8c8ff049f2 = 1000;
const $3f56701b4fa5d690$export$84517975127ccafb = 2;



function $1a04842bd1f406bd$var$ReviewAndSubmitFooter({ firstStep: firstStep, isModalOpen: isModalOpen, setFirstStep: setFirstStep, setIsAlertActive: setIsAlertActive, dataForSubmitAction: dataForSubmitAction, closeReviewAndSubmitModal: closeReviewAndSubmitModal }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, isLoadingReviewAndSubmit: isLoadingReviewAndSubmit, isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit, tabs: tabs, reviewAndSubmit: reviewAndSubmit, reviewAndSubmitError: reviewAndSubmitError, campaignKey: campaignKey, objectForRedirectLink: objectForRedirectLink } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { tabData: tabData } = tabs;
    const todoTabCount = tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const consultedTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053))?.count;
    const hasZeroCountForItems = Boolean(todoTabCount === 0 && consultedTabCount === 0);
    const shouldDisableNextAndSubmitBtn = Boolean(isLoadingReviewAndSubmit || reviewAndSubmitError || isSubmittingReviewAndSubmit);
    const [config, setConfig] = (0, $hopDi$useState)();
    const [hasSubmittedCertification, setHasSubmittedCertification] = (0, $hopDi$useState)(false);
    const [alert, setAlert] = (0, $hopDi$useState)({
        theme: "Critical",
        isOpen: false,
        title: "",
        description: "",
        isColonVisible: false,
        autoDismiss: true
    });
    (0, $hopDi$useEffect)(()=>{
        if (tabData && reviewAndSubmit) setConfig({
            primaryCertifier: reviewAndSubmit?.primaryCertifier,
            isCommentEnabled: reviewAndSubmit?.isCommentEnabled,
            isComplete: hasZeroCountForItems,
            withESignature: reviewAndSubmit?.withESignature
        });
    }, [
        tabs,
        todoTabCount,
        reviewAndSubmit
    ]);
    const reviewAndSubmitModalFooter = (0, $hopDi$classnames)("ReviewAndSubmitModal-footer");
    const getStatusForFormSubmition = ()=>{
        if (dataForSubmitAction.isPrimaryCertifier && dataForSubmitAction.isESignature) {
            const { isCommentEnabled: isCommentEnabled, step2SignatureData: { userAttributeValue: userAttributeValue, isAgreeChecked: isAgreeChecked, commentDescription: commentDescription, eSignatureData: eSignatureData } } = dataForSubmitAction;
            return Boolean(userAttributeValue.length > 0 && eSignatureData.length > 0 && isAgreeChecked && (isCommentEnabled && commentDescription.length > 0 || !isCommentEnabled));
        }
        const { isCommentEnabled: isCommentEnabled, step2CommentData: { commentDescription: commentDescription } } = dataForSubmitAction;
        return isCommentEnabled && commentDescription.length > 0 || !isCommentEnabled;
    };
    const lockSummary = (comments)=>{
        dispatch((0, $d623f23401a154f0$export$6bd0ceb6f0238e0a)(certKey, comments)).then(()=>{
            setAlert({
                ...alert,
                isOpen: true,
                theme: "Success",
                title: "Success",
                description: "Certification succesfully submitted",
                isColonVisible: true,
                autoDismiss: false
            });
            setHasSubmittedCertification(true);
            setTimeout(()=>{
                if (objectForRedirectLink?.hasOnlyCertifierLevelAccess || objectForRedirectLink?.consulteeLoggedIn) window.location.replace("/ECM/certification/list");
                window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
            }, (0, $3f56701b4fa5d690$export$6941e8c8ff049f2));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$dadc0bb56f5e8946)(false));
            setAlert({
                ...alert,
                isOpen: true,
                title: error.message
            });
        });
    };
    const handleSubmit = ()=>{
        if (dataForSubmitAction.isPrimaryCertifier && dataForSubmitAction.isESignature) {
            const { isCommentEnabled: isCommentEnabled, step2SignatureData: { userAttribute: userAttribute, enableloginSignature: enableloginSignature, noOfTries: noOfTries, userAttributeValue: userAttributeValue, isAgreeChecked: isAgreeChecked, commentDescription: commentDescription, eSignatureData: eSignatureData } } = dataForSubmitAction;
            const shouldEnableAlert = Boolean(userAttributeValue.length === 0 || eSignatureData.length === 0 || !isAgreeChecked || isCommentEnabled && commentDescription.length === 0);
            if (shouldEnableAlert) {
                setIsAlertActive(true);
                return;
            }
            const payload = {};
            if (Number(enableloginSignature)) {
                payload[userAttribute] = userAttributeValue;
                payload.userPassword = eSignatureData;
            } else {
                payload.fieldToVerify = userAttribute;
                payload.eSignValueToVerify = userAttributeValue;
                payload.signatureSvg = eSignatureData;
            }
            dispatch((0, $d623f23401a154f0$export$776ef17d04a202bf)(certKey, enableloginSignature, noOfTries, payload)).then(()=>{
                lockSummary(isCommentEnabled ? commentDescription : (0, $7e937afea8da6d42$export$3dc46c1eba4a1c65));
            }).catch((error)=>{
                dispatch((0, $d623f23401a154f0$export$dadc0bb56f5e8946)(false));
                setAlert({
                    ...alert,
                    isOpen: true,
                    title: error.message
                });
                setIsAlertActive(true);
            });
        }
        if (!dataForSubmitAction.isESignature) {
            const { isCommentEnabled: isCommentEnabled, step2CommentData: { commentDescription: commentDescription } } = dataForSubmitAction;
            if (isCommentEnabled && commentDescription.length === 0) {
                setIsAlertActive(true);
                return;
            }
            lockSummary(isCommentEnabled ? commentDescription : (0, $7e937afea8da6d42$export$3dc46c1eba4a1c65));
        }
    };
    const handleNextAndSubmitBtn = ()=>{
        if ((config?.withESignature || config?.isCommentEnabled) && firstStep) {
            setFirstStep(false);
            return;
        }
        handleSubmit();
    };
    const handleViewListBtn = ()=>{
        const tabToVisit = todoTabCount === 0 ? (0, $d44c789d5b60f9bf$export$b2766b46106d3053) : (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49);
        const modifiedTabs = tabs.tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === tabToVisit,
                isHighlighted: false
            }));
        dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(modifiedTabs));
        closeReviewAndSubmitModal();
    };
    const handleCompleteForConsultee = ()=>{
        dispatch((0, $d623f23401a154f0$export$f75c1d1e7da3ca60)(certKey)).then(()=>{
            setAlert({
                ...alert,
                isOpen: true,
                theme: "Success",
                title: "Success",
                description: "Certification succesfully submitted",
                isColonVisible: true,
                autoDismiss: false
            });
            setHasSubmittedCertification(true);
            setTimeout(()=>{
                if (objectForRedirectLink?.hasOnlyCertifierLevelAccess || objectForRedirectLink?.consulteeLoggedIn) window.location.replace("/ECM/certification/list");
                window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
            }, (0, $3f56701b4fa5d690$export$6941e8c8ff049f2));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$dadc0bb56f5e8946)(false));
            setAlert({
                ...alert,
                isOpen: true,
                title: error.message
            });
        });
    };
    const handleAlertClose = ()=>{
        setAlert({
            ...alert,
            isOpen: false,
            title: ""
        });
    };
    (0, $hopDi$useEffect)(()=>{
        if (!isModalOpen) handleAlertClose();
    }, [
        isModalOpen
    ]);
    // TODO: @Jacob, @Sagar, Please update this AlertBanner Position.
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
        className: reviewAndSubmitModalFooter,
        size: "large",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "ReviewAndSubmitModal-footerButtonWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                        colorTheme: alert.theme,
                        title: alert.title,
                        description: alert.description,
                        isVisible: alert.isOpen,
                        isColonVisible: alert.isColonVisible,
                        shouldAutoDismiss: alert.autoDismiss,
                        onCancel: handleAlertClose
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        onClick: closeReviewAndSubmitModal,
                        isDisabled: isSubmittingReviewAndSubmit,
                        children: "Cancel"
                    }),
                    config?.isComplete && config?.primaryCertifier && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: firstStep || shouldDisableNextAndSubmitBtn || getStatusForFormSubmition() ? "filled" : "outlined",
                        size: "medium",
                        isDisabled: shouldDisableNextAndSubmitBtn,
                        isLoading: isSubmittingReviewAndSubmit && !hasSubmittedCertification,
                        loaderText: firstStep ? "Next" : "Submit",
                        className: "ReviewAndSubmitModal-footerButtonWrap-primaryAction",
                        onClick: handleNextAndSubmitBtn,
                        children: (config?.withESignature || config?.isCommentEnabled) && firstStep ? "Next" : "Submit"
                    }),
                    config?.isComplete && !config?.primaryCertifier && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: shouldDisableNextAndSubmitBtn ? "filled" : "outlined",
                        size: "medium",
                        isDisabled: shouldDisableNextAndSubmitBtn,
                        isLoading: isSubmittingReviewAndSubmit && !hasSubmittedCertification,
                        loaderText: "Complete",
                        className: "ReviewAndSubmitModal-footerButtonWrap-primaryAction",
                        onClick: handleCompleteForConsultee,
                        children: "Complete"
                    }),
                    !config?.isComplete && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "filled",
                        size: "medium",
                        className: "ReviewAndSubmitModal-footerButtonWrap-primaryAction",
                        onClick: handleViewListBtn,
                        children: todoTabCount === 0 ? "View Consulted List" : "View To-Do List"
                    })
                ]
            })
        ]
    });
}
$1a04842bd1f406bd$var$ReviewAndSubmitFooter.propTypes = {
    isModalOpen: (0, $hopDi$proptypes).bool.isRequired,
    closeReviewAndSubmitModal: (0, $hopDi$proptypes).func.isRequired,
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    setFirstStep: (0, $hopDi$proptypes).func.isRequired,
    setIsAlertActive: (0, $hopDi$proptypes).func,
    dataForSubmitAction: (0, $hopDi$proptypes).shape({
        isPrimaryCertifier: (0, $hopDi$proptypes).bool,
        isESignature: (0, $hopDi$proptypes).bool,
        isCommentEnabled: (0, $hopDi$proptypes).bool,
        step2CommentData: (0, $hopDi$proptypes).shape({
            commentDescription: (0, $hopDi$proptypes).string
        }),
        step2SignatureData: (0, $hopDi$proptypes).shape({
            userAttribute: (0, $hopDi$proptypes).string,
            enableloginSignature: (0, $hopDi$proptypes).string,
            noOfTries: (0, $hopDi$proptypes).string,
            userAttributeValue: (0, $hopDi$proptypes).string,
            isAgreeChecked: (0, $hopDi$proptypes).bool,
            commentDescription: (0, $hopDi$proptypes).string,
            eSignatureData: (0, $hopDi$proptypes).string
        })
    })
};
$1a04842bd1f406bd$var$ReviewAndSubmitFooter.defaultProps = {
    setIsAlertActive: ()=>{},
    dataForSubmitAction: {}
};
var $1a04842bd1f406bd$export$2e2bcd8739ae039 = $1a04842bd1f406bd$var$ReviewAndSubmitFooter;


var $6c1c0736605a4af0$export$2e2bcd8739ae039 = (0, $1a04842bd1f406bd$export$2e2bcd8739ae039);












function $145c8a52f76220e5$var$ReviewAndSubmitHeader({ firstStep: firstStep, setFirstStep: setFirstStep }) {
    const { reviewAndSubmit: reviewAndSubmit, isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const todoTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const [config, setConfig] = (0, $hopDi$useState)();
    const hasZeroCountForItems = todoTabCount === 0;
    (0, $hopDi$useEffect)(()=>{
        if (reviewAndSubmit) setConfig({
            certifier: reviewAndSubmit.primaryCertifier ? (0, $7e937afea8da6d42$export$506d5022cff8f7df) : (0, $7e937afea8da6d42$export$842181aaa7a414ff),
            isComplete: hasZeroCountForItems ? (0, $7e937afea8da6d42$export$e38f3fe6f8e2e1d5) : (0, $7e937afea8da6d42$export$5d9f356b4d4d5628),
            withESignature: reviewAndSubmit.withESignature ? (0, $7e937afea8da6d42$export$4414b99fd5cdebbf) : (0, $7e937afea8da6d42$export$c7ded6134c5259a8),
            step: firstStep ? (0, $7e937afea8da6d42$export$33413024a053a1ca) : (0, $7e937afea8da6d42$export$deab3fee8d04afb5)
        });
    }, [
        todoTabCount,
        reviewAndSubmit,
        firstStep
    ]);
    const reviewAndSubmitModalHeader = (0, $hopDi$classnames)("ReviewAndSubmitModal-header");
    const title = (0, $7e937afea8da6d42$export$f1e53f710478ceb4)[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[config?.step];
    const goBack = ()=>{
        if (!isSubmittingReviewAndSubmit) setFirstStep(true);
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: reviewAndSubmitModalHeader,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: firstStep ? "ReviewAndSubmitModal-headerIcon--hidden" : "ReviewAndSubmitModal-headerIcon--visible",
                onClick: goBack,
                onKeyUp: ()=>{},
                role: "button",
                tabIndex: "0",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "ChevronLeft",
                    color: "neutral-1000"
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "ReviewAndSubmitModal-headerTitle",
                children: title
            })
        ]
    });
}
$145c8a52f76220e5$var$ReviewAndSubmitHeader.propTypes = {
    firstStep: (0, $hopDi$proptypes).bool.isRequired,
    setFirstStep: (0, $hopDi$proptypes).func.isRequired
};
var $145c8a52f76220e5$export$2e2bcd8739ae039 = $145c8a52f76220e5$var$ReviewAndSubmitHeader;






function $377a8b1f118e2516$var$ReviewAndSubmitSubTitle({ firstStep: firstStep }) {
    const { reviewAndSubmit: reviewAndSubmit, tabs: tabs } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const todoTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const consultedTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053))?.count;
    const hasZeroCountForItems = Boolean(todoTabCount === 0 && consultedTabCount === 0);
    const [config, setConfig] = (0, $hopDi$useState)();
    (0, $hopDi$useEffect)(()=>{
        if (reviewAndSubmit) setConfig({
            certifier: reviewAndSubmit?.primaryCertifier ? (0, $7e937afea8da6d42$export$506d5022cff8f7df) : (0, $7e937afea8da6d42$export$842181aaa7a414ff),
            isCommentEnabled: reviewAndSubmit?.isCommentEnabled,
            certifierName: reviewAndSubmit?.primaryCertifierName,
            isComplete: hasZeroCountForItems ? (0, $7e937afea8da6d42$export$e38f3fe6f8e2e1d5) : (0, $7e937afea8da6d42$export$5d9f356b4d4d5628),
            withESignature: reviewAndSubmit?.withESignature ? (0, $7e937afea8da6d42$export$4414b99fd5cdebbf) : (0, $7e937afea8da6d42$export$c7ded6134c5259a8),
            step: firstStep ? (0, $7e937afea8da6d42$export$33413024a053a1ca) : (0, $7e937afea8da6d42$export$deab3fee8d04afb5)
        });
    }, [
        todoTabCount,
        reviewAndSubmit,
        firstStep
    ]);
    if (config?.certifier === (0, $7e937afea8da6d42$export$842181aaa7a414ff)) return (0, $7e937afea8da6d42$export$5895c693c74b9cf4)[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[config?.step]?.replace("$$$", `(${config?.certifierName})`);
    if (hasZeroCountForItems && config?.certifier === (0, $7e937afea8da6d42$export$506d5022cff8f7df) && config?.withESignature === (0, $7e937afea8da6d42$export$c7ded6134c5259a8) && !config?.isCommentEnabled) return "";
    if (hasZeroCountForItems) return (0, $7e937afea8da6d42$export$5895c693c74b9cf4)[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[config?.step];
    const tempMidText = todoTabCount === 0 ? `${consultedTabCount} Consulted items that must be completed` : `${todoTabCount} To-Do items that you must complete`;
    return (0, $7e937afea8da6d42$export$5895c693c74b9cf4)[config?.certifier]?.[config?.isComplete]?.[config?.withESignature]?.[config?.step]?.replace("$$$", tempMidText);
}
$377a8b1f118e2516$var$ReviewAndSubmitSubTitle.propTypes = {
    firstStep: (0, $hopDi$proptypes).bool.isRequired
};
var $377a8b1f118e2516$export$2e2bcd8739ae039 = $377a8b1f118e2516$var$ReviewAndSubmitSubTitle;





function $8aa367b1e45b40ec$var$ReviewAndSubmit({ buttonSize: buttonSize }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { isLoading: isLoading, bulkAction: bulkAction, certKey: certKey, isSubmittingReviewAndSubmit: isSubmittingReviewAndSubmit, reviewAndSubmit: reviewAndSubmit, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton, tabs: tabs, progressBreakdowndetails: progressBreakdowndetails, predefinedComments: predefinedComments, mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { byDecisionDetails: byDecisionDetails } = progressBreakdowndetails;
    const todoTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49))?.count;
    const consultedTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053))?.count;
    const [isModalOpen, setIsModalOpen] = (0, $hopDi$useState)(false);
    const [isDisabled, setIsDisabled] = (0, $hopDi$useState)(true);
    const [firstStep, setFirstStep] = (0, $hopDi$useState)(true);
    const [dataForSubmitAction, setDataForSubmitAction] = (0, $hopDi$useState)({});
    const [isAlertActive, setIsAlertActive] = (0, $hopDi$useState)(false);
    const [config, setConfig] = (0, $hopDi$useState)(null);
    const [percentage, setPercentage] = (0, $hopDi$useState)(0);
    const hasZeroCountForItems = Boolean(todoTabCount === 0 && consultedTabCount === 0);
    (0, $hopDi$useEffect)(()=>{
        if (byDecisionDetails && byDecisionDetails?.Summary) setPercentage((0, $c3fd831cb38d6d24$export$c3e0f520a0aee8fc)(byDecisionDetails.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2], byDecisionDetails.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e]));
    }, [
        progressBreakdowndetails
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (tabs?.tabData && reviewAndSubmit) setConfig({
            primaryCertifier: reviewAndSubmit?.primaryCertifier,
            isComplete: hasZeroCountForItems,
            withESignature: reviewAndSubmit?.withESignature,
            isCommentEnabled: reviewAndSubmit?.isCommentEnabled
        });
    }, [
        tabs,
        todoTabCount,
        reviewAndSubmit
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certKey) setIsDisabled(false);
    }, [
        certKey,
        bulkAction
    ]);
    (0, $hopDi$useEffect)(()=>{
        const allTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615))?.count;
        if (isLoading || bulkAction?.isChecked || bulkAction?.isDisabled || bulkAction?.isIndeterminate || bulkAction?.isSubmittingAction || allTabCount === 0) {
            setIsDisabled(true);
            return;
        }
        setIsDisabled(false);
    }, [
        bulkAction,
        isLoading,
        tabs
    ]);
    const closeReviewAndSubmitModal = ()=>{
        if (!isSubmittingReviewAndSubmit) {
            setIsModalOpen(false);
            setTimeout(()=>{
                setFirstStep(true);
                dispatch((0, $d623f23401a154f0$export$eb61ad48998e2c20)(true));
            }, (0, $7e937afea8da6d42$export$cc844e58ea5510e9));
        }
    };
    const openReviewAndSubmitModal = ()=>{
        const promisesForStep1Data = [];
        // TODO: Disabling tab count api as tab count is getting refreshed after the action
        // promisesForStep1Data.push(dispatch(getTabCounts(certKey)));
        (0, $7e937afea8da6d42$export$df8f064ab2a7c09c).forEach((category)=>{
            promisesForStep1Data.push(dispatch((0, $d623f23401a154f0$export$886e16c80cfe3a1a)(certKey, category)));
        });
        if (!((0, $7e937afea8da6d42$export$d0f02cc015bd5768) in predefinedComments) && config?.isCommentEnabled) promisesForStep1Data.push(dispatch((0, $d623f23401a154f0$export$27dd55286e4e826a)((0, $7e937afea8da6d42$export$d0f02cc015bd5768))));
        Promise.all(promisesForStep1Data).then(()=>{
            dispatch((0, $d623f23401a154f0$export$eb61ad48998e2c20)(false));
            promisesForStep1Data.length = 0;
        }).catch(()=>{
            promisesForStep1Data.length = 0;
        });
        setIsModalOpen(true);
    };
    const reviewAndSubmitModal = (0, $hopDi$classnames)("ReviewAndSubmitModal");
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mediaQueryValue >= mobileXlargeQuery.value;
    const subTitleClassName = (0, $hopDi$classnames)("Certs-reviewAndSubmit-mobileDrawerSubTitle", !firstStep && "Certs-reviewAndSubmit-mobileDrawerSubTitle--secondStep");
    const mobileDrawerClassName = (0, $hopDi$classnames)("Certs-reviewAndSubmit-mobileDrawer", !firstStep && "Certs-reviewAndSubmit-mobileDrawer--step2");
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        children: [
            shouldShowReviewAndSubmitButton && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Button), {
                type: "button",
                className: "Certs-reviewAndSubmit-btn",
                kind: hasZeroCountForItems || isDisabled ? "filled" : "outlined",
                onClick: openReviewAndSubmitModal,
                size: buttonSize,
                isDisabled: isDisabled,
                children: [
                    percentage < (0, $135adfecc1ed8f07$export$f688697617dd0589) && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "ArrowRight",
                        className: "Certs-reviewAndSubmit-icon",
                        color: "indigo-700"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        className: `${percentage === (0, $135adfecc1ed8f07$export$f688697617dd0589) ? "Certs-reviewAndSubmit-showLabel" : "Certs-reviewAndSubmit-label"}`,
                        kind: "body2-bold",
                        children: config?.primaryCertifier ? "Review and Submit" : "Complete"
                    })
                ]
            }),
            isMobileWidth ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                isOpen: isModalOpen,
                setIsOpen: closeReviewAndSubmitModal,
                isCloseButtonEnabled: false,
                headerContent: /*#__PURE__*/ (0, $hopDi$jsxs)("header", {
                    className: "Certs-reviewAndSubmit-mobileDrawerHeader",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "Certs-reviewAndSubmit-mobileDrawerTitleContainer",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "h1",
                                    className: "Certs-reviewAndSubmit-mobileDrawerTitle",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $145c8a52f76220e5$export$2e2bcd8739ae039), {
                                        firstStep: firstStep,
                                        setFirstStep: setFirstStep
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    mobile: "body2-m",
                                    className: subTitleClassName,
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $377a8b1f118e2516$export$2e2bcd8739ae039), {
                                        firstStep: firstStep
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                            size: "medium",
                            kind: "ghost",
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "close",
                                color: "neutral-100",
                                size: "smallMedium"
                            }),
                            onClick: ()=>{
                                setIsModalOpen(false);
                            }
                        })
                    ]
                }),
                content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $935cccc08f9a7d44$export$2e2bcd8739ae039), {
                    firstStep: firstStep,
                    isModalOpen: isModalOpen,
                    isAlertActive: isAlertActive,
                    setIsAlertActive: setIsAlertActive,
                    setDataForSubmitAction: setDataForSubmitAction,
                    retriggerApisForError: openReviewAndSubmitModal,
                    closeReviewAndSubmitModal: closeReviewAndSubmitModal
                }),
                footerActionBar: /*#__PURE__*/ (0, $hopDi$jsx)((0, $6c1c0736605a4af0$export$2e2bcd8739ae039), {
                    firstStep: firstStep,
                    isModalOpen: isModalOpen,
                    setFirstStep: setFirstStep,
                    setIsAlertActive: setIsAlertActive,
                    dataForSubmitAction: dataForSubmitAction,
                    closeReviewAndSubmitModal: closeReviewAndSubmitModal
                }),
                className: mobileDrawerClassName
            }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
                className: reviewAndSubmitModal,
                onClose: closeReviewAndSubmitModal,
                isOpen: isModalOpen,
                title: /*#__PURE__*/ (0, $hopDi$jsx)((0, $145c8a52f76220e5$export$2e2bcd8739ae039), {
                    firstStep: firstStep,
                    setFirstStep: setFirstStep
                }),
                subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $377a8b1f118e2516$export$2e2bcd8739ae039), {
                    firstStep: firstStep
                }),
                contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $935cccc08f9a7d44$export$2e2bcd8739ae039), {
                    firstStep: firstStep,
                    isModalOpen: isModalOpen,
                    isAlertActive: isAlertActive,
                    setIsAlertActive: setIsAlertActive,
                    setDataForSubmitAction: setDataForSubmitAction,
                    retriggerApisForError: openReviewAndSubmitModal,
                    closeReviewAndSubmitModal: closeReviewAndSubmitModal
                }),
                FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $6c1c0736605a4af0$export$2e2bcd8739ae039), {
                    firstStep: firstStep,
                    isModalOpen: isModalOpen,
                    setFirstStep: setFirstStep,
                    setIsAlertActive: setIsAlertActive,
                    dataForSubmitAction: dataForSubmitAction,
                    closeReviewAndSubmitModal: closeReviewAndSubmitModal
                })
            })
        ]
    });
}
$8aa367b1e45b40ec$var$ReviewAndSubmit.propTypes = {
    buttonSize: (0, $hopDi$proptypes).oneOf((0, $7e937afea8da6d42$export$73e83bf2b7e02467))
};
$8aa367b1e45b40ec$var$ReviewAndSubmit.defaultProps = {
    buttonSize: "medium"
};
var $8aa367b1e45b40ec$export$2e2bcd8739ae039 = $8aa367b1e45b40ec$var$ReviewAndSubmit;


var $eb340908ccb18f38$export$2e2bcd8739ae039 = (0, $8aa367b1e45b40ec$export$2e2bcd8739ae039);









function $9dc2b5e278a56721$var$CertsDetailsList({ isMoreDataAvailable: isMoreDataAvailable, setIsMoreDataAvailable: setIsMoreDataAvailable, showFilterBar: showFilterBar, detailsListRef: detailsListRef, setSidePanelData: setSidePanelData, mergedLists: mergedLists, setMergedLists: setMergedLists, currentOffset: currentOffset, setCurrentOffset: setCurrentOffset, mergedListsAfterRowFilter: mergedListsAfterRowFilter, setMergedListsAfterRowFilter: setMergedListsAfterRowFilter, listApiCallCount: listApiCallCount, setListApiCallCount: setListApiCallCount, handleAutoSelectParent: handleAutoSelectParent }) {
    // Data
    const [isScrolling, setIsScrolling] = (0, $hopDi$useState)(false);
    // const [foundAutoSelectTrackers, setFoundAutoSelectTrackers] = useState(null);
    const [actionPopoverOpenId, setActionPopoverOpenId] = (0, $hopDi$useState)(null);
    const [prevActiveTab, setPrevActiveTab] = (0, $hopDi$useState)(null);
    const observerTarget = (0, $hopDi$useRef)(null);
    const dispatch = (0, $hopDi$useDispatch)();
    const { advancedFilters: advancedFilters, certDetailsLists: certDetailsLists, certKey: certKey, tabs: tabs, totalItems: totalItems, searchText: searchText, isTriggeredFromSearchOrFilter: isTriggeredFromSearchOrFilter, isLoading: isLoading, isError: isError, objectForRedirectLink: objectForRedirectLink, campaignKey: campaignKey, columnNames: columnNames, columnPickerList: columnPickerList, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton, isViewApiError: isViewApiError, dynamicSortFilter: dynamicSortFilter, reviewAndSubmit: { primaryCertifier: primaryCertifier }, isSaviApplied: isSaviApplied, isSmartApplied: isSmartApplied, viewRowsList: // isTriggeredFromSaviApplyActions,
    viewRowsList, action: { isAtLeastThreeActions: isAtLeastThreeActions }, mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { isChecked: isBulkSelectChecked, isActionBySelectAll: isBulkActionBySelectAll, isIndeterminate: isBulkSelectIndeterminate, bulkFooterInfo: bulkFooterInfo } = (0, $hopDi$useSelector)((state)=>state?.certifications?.bulkAction);
    const { tabData: tabData } = tabs;
    const activeTab = tabData.find((tab)=>tab.isActive);
    const consultedTab = tabData.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053));
    const allTab = tabData.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615));
    const hasActiveTabDetails = activeTab?.count > 0;
    const { sortDirection: sortDirection, sortByColumn: sortByColumn } = dynamicSortFilter;
    const detailsListClasses = (0, $hopDi$classnames)("CertsDetailsList", showFilterBar && "CertsDetailsList--showFilterBar", isLoading && "CertsDetailsList--isLoading", isMoreDataAvailable && "CertsDetailsList--isMoreDataAvailable");
    const isAnyError = Boolean(isError || isViewApiError);
    const hasNoCertsResultsToDisplay = Boolean(mergedLists && mergedLists?.length === 0);
    const hasNoAdvancedFiltersResults = Boolean(advancedFilters?.length > 0);
    const hasNoSearchResults = Boolean(searchText?.trim().length > 0);
    const maximumResults = 10;
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mediaQueryValue >= mobileXlargeQuery.value;
    (0, $hopDi$useEffect)(()=>{
        if (!mergedListsAfterRowFilter || mergedListsAfterRowFilter?.length === 0 || isAtLeastThreeActions) return;
        const checkActionsInFirstTenNodes = (nodes)=>{
            const flattenedList = (0, $e7628c995f405891$export$8824054d4a42eac8)(nodes);
            const nodesToCheck = flattenedList.slice(0, 10);
            const hasThreeOrMoreActions = nodesToCheck.some((node)=>{
                const actionKeys = Object.keys(node?.availableAction || {});
                return actionKeys.length >= 3;
            });
            if (hasThreeOrMoreActions) dispatch((0, $d623f23401a154f0$export$85696a56c199705e)(true));
        };
        checkActionsInFirstTenNodes(mergedListsAfterRowFilter);
    }, [
        mergedListsAfterRowFilter
    ]);
    // eslint-disable-next-line consistent-return
    (0, $hopDi$useEffect)(()=>{
        const listElement = detailsListRef.current;
        if (listElement) {
            const handleScroll = ()=>{
                /**
         * Handles the scroll event on the list element.
         * Sets the `isScrolling` state to true when scrolling starts.
         * Clears any existing scroll timeout to prevent multiple timeouts from being set.
         * Sets a timeout to reset the `isScrolling` state to false after 1 second of no scrolling.
         */ setIsScrolling(true);
                clearTimeout(window.scrollTimeout);
                window.scrollTimeout = setTimeout(()=>{
                    setIsScrolling(false);
                }, 1000);
            };
            listElement.addEventListener("scroll", handleScroll);
            return ()=>{
                listElement.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        detailsListRef,
        certDetailsLists
    ]);
    // Tell the controls handler that the absolute bottom is attainable
    (0, $hopDi$useEffect)(()=>{
        if (listApiCallCount > 0 && currentOffset > totalItems) return setIsMoreDataAvailable(false);
        return setIsMoreDataAvailable(true);
    }, [
        listApiCallCount,
        currentOffset,
        totalItems
    ]);
    // TODO: Commented out at Umeshes request, add or remove based on user feedback
    // useEffect(() => {
    //   if (verifyParentMap?.length === 0) return;
    //   const trackers = [];
    //   verifyParentMap
    //     .filter((criteria) => !criteria.childname)
    //     .forEach((criteria) => {
    //       const tracker = findTracker(mergedListsAfterRowFilter, criteria);
    //       if (tracker) {
    //         trackers.push({
    //           ...tracker,
    //           type: criteria.type,
    //         });
    //       }
    //     });
    //   // setFoundAutoSelectTrackers(trackers);
    // }, [verifyParentMap]);
    /**
   * Handles the display of the side panel with the provided node data.
   *
   * @param {Object} nodeData - The data of the node to be displayed in the side panel.
   * @param {Object} nodeData.tracker - The tracker object containing the node's tracking information.
   * @param {string} nodeData.tracker.id - The unique identifier (tracker ID) of the node.
   * @param {number} nodeData.tracker.level - The level of the node in the hierarchy.
   * @param {boolean} nodeData.tracker.isConnected - Indicates if the node is connected.
   * @param {boolean} nodeData.tracker.isChecked - Indicates if the node is checked.
   * @param {boolean} nodeData.tracker.isIndeterminate - Indicates if the node is in an indeterminate state.
   * @param {Array} nodeData.children - The children nodes of the current node.
   *
   * @returns {void} - This function does not return a value.
   */ const handleSidePanel = (0, $hopDi$useCallback)((nodeData)=>{
        // Open the sidepanel
        dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(true));
        // Setting the data for the sidepanel
        setSidePanelData(nodeData);
    });
    /**
   * Merges new data into an existing list (merged list) and updates the UI state accordingly.
   *
   * @param {Array} existingList - The current list of items.
   * @param {Array} newList - The new list of items to be merged.
   * @returns {void} This function does not return a value. It updates the state of the merged list.
   */ const mergeResponsesUI = (existingList, newList)=>{
        const mergedResponse = isTriggeredFromSearchOrFilter ? (0, $31eefeb47866cab8$export$efe17290047eb682)([], newList) : (0, $31eefeb47866cab8$export$efe17290047eb682)(existingList, newList);
        const responseAfterTrackerObj = (0, $31eefeb47866cab8$export$89bc22408028ff3d)(mergedResponse);
        const responseAfterActionStatus = (0, $31eefeb47866cab8$export$711a902d2e3a009f)(responseAfterTrackerObj);
        setMergedLists(responseAfterActionStatus);
    };
    (0, $hopDi$useEffect)(()=>{
        setListApiCallCount(Math.ceil(totalItems / maximumResults));
    }, [
        totalItems,
        dispatch,
        activeTab.key
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (columnPickerList) {
            const columnNamesToShow = (0, $31eefeb47866cab8$export$180ffcd95abfdd08)(columnPickerList);
            dispatch((0, $d623f23401a154f0$export$44dea541cc9e89ed)(columnNamesToShow));
        }
    }, [
        columnPickerList,
        dispatch
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certKey) {
            if (columnNames && typeof columnNames === "string") {
                dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(false));
                dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, currentOffset, searchText));
                setCurrentOffset((prevOffset)=>prevOffset + maximumResults);
                setListApiCallCount((prev)=>prev - 1);
            }
        }
    }, [
        certKey,
        columnNames,
        dispatch
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isTriggeredFromSearchOrFilter && isLoading) {
            setCurrentOffset(maximumResults); // Already started from zero in search
            setMergedLists([]);
        }
    }, [
        isTriggeredFromSearchOrFilter,
        isLoading
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (activeTab.key !== prevActiveTab) {
            setCurrentOffset(0);
            setMergedLists([]);
        }
        setPrevActiveTab(activeTab.key);
        // Get the items API response for the current active tab
        if (certKey && columnNames && typeof columnNames === "string") {
            setCurrentOffset(maximumResults);
            dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, 0, searchText));
        }
    }, [
        activeTab?.key
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certDetailsLists) mergeResponsesUI(mergedLists, certDetailsLists);
    }, [
        certDetailsLists
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (sortByColumn && sortDirection) {
            dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(true));
            setListApiCallCount(Math.ceil(totalItems / maximumResults));
            dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, 0, searchText));
        }
    }, [
        sortByColumn,
        sortDirection
    ]);
    (0, $hopDi$useEffect)(()=>{
        const tempMergedListsAfterRowFilter = (0, $31eefeb47866cab8$export$5cf5ab282a6d1471)(mergedLists);
        const flattenedList = (0, $e7628c995f405891$export$8824054d4a42eac8)(tempMergedListsAfterRowFilter);
        const listofCheckStatus = flattenedList.map((node)=>node?.tracker?.isChecked);
        const listStatusCount = listofCheckStatus.length;
        const isEveryItemChecked = !listofCheckStatus.some((value)=>!value) && listStatusCount > 0 && (listStatusCount >= activeTab?.count || bulkFooterInfo?.totalSelectedItems === totalItems);
        const isAtleastOneItemChecked = listofCheckStatus.some((value)=>value) && listStatusCount > 0;
        setMergedListsAfterRowFilter(tempMergedListsAfterRowFilter);
        if (tempMergedListsAfterRowFilter?.length === 0) {
            dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
            return;
        }
        if (isBulkActionBySelectAll) return;
        if (isBulkSelectChecked) {
            if (isEveryItemChecked) {
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
                dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(true));
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(true));
                dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
                return;
            }
            if (isAtleastOneItemChecked) {
                dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(true));
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(true));
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
                return;
            }
            dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
            dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
            return;
        }
        if (!isBulkSelectChecked) {
            if (isEveryItemChecked) {
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(true));
                dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(true));
                dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
                return;
            }
            if (isAtleastOneItemChecked) {
                dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(true));
                dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
                dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(true));
                dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(true));
                return;
            }
            dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
            dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
        }
    }, [
        mergedLists,
        dispatch
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (isLoading) return;
        if (hasActiveTabDetails) {
            const observer = new IntersectionObserver((entries)=>{
                if (entries[0].isIntersecting) {
                    if (listApiCallCount > 0 && currentOffset < totalItems) {
                        dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(false));
                        if (currentOffset !== 0) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, currentOffset, searchText));
                        setCurrentOffset((prevOffset)=>prevOffset + maximumResults);
                        setListApiCallCount((prev)=>prev - 1);
                    }
                }
            }, {
                threshold: 1
            });
            if (observerTarget.current) observer.observe(observerTarget.current);
            // eslint-disable-next-line consistent-return
            return ()=>{
                if (observerTarget.current) observer.unobserve(observerTarget.current);
            };
        }
    }, [
        observerTarget,
        isLoading,
        currentOffset
    ]);
    /**
   * Recursively updates the `isChecked` and `isIndeterminate` properties of the `tracker` object
   * for each item in the list and its children based on the provided flag.
   *
   * @param {Array} prev - The previous list of items to be updated.
   * @param {boolean} flag - The flag indicating whether the items should be checked or not.
   * @returns {Array} The updated list of items with the `isChecked` and `isIndeterminate` properties updated.
   */ const handleBulkActionCheck = (0, $hopDi$useCallback)((prev, flag)=>prev.map((item)=>({
                ...item,
                tracker: {
                    ...item.tracker,
                    isChecked: flag,
                    isIndeterminate: false
                },
                children: item?.children?.length > 0 ? handleBulkActionCheck(item.children, flag) : []
            })), []);
    (0, $hopDi$useEffect)(()=>{
        if (isBulkActionBySelectAll && !isBulkSelectIndeterminate) setMergedLists((prevMergedLists)=>handleBulkActionCheck(prevMergedLists, isBulkSelectChecked));
    }, [
        isBulkSelectChecked,
        isBulkSelectIndeterminate
    ]);
    /**
   * Resets the filters for the "View All" (Removes filter for Hierarchy filter) button and updates the UI accordingly.
   * This function dispatches actions to update the certification filters and sets the active tab to "All".
   *
   * @returns {void} This function does not return a value. It updates the state and UI based on the filter reset.
   */ const resetFilterForViewAllButton = ()=>{
        const promiseToSetRowsFilter = [];
        const rowsFiltersToReset = viewRowsList?.map((viewRow)=>(0, $6d218ab9b83faef2$export$8fb661a8eb99bf9c)[viewRow]);
        rowsFiltersToReset.forEach((row)=>{
            promiseToSetRowsFilter.push(dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)("ROW_TYPE", row, true)));
        });
        Promise.all(promiseToSetRowsFilter).then((responses)=>{
            const combinedResponse = responses.every((response)=>response === true);
            if (combinedResponse) {
                dispatch((0, $d623f23401a154f0$export$aaae2b23f99e1308)(true));
                const makeAllTabActive = tabData.map((tab)=>({
                        ...tab,
                        isActive: tab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615),
                        isHighlighted: false
                    }));
                dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(makeAllTabActive));
            }
        });
    };
    const renderNoDataView = ({ title: title, body: body, buttonText: buttonText, buttonAction: buttonAction, isReadyToSubmit: isReadyToSubmit, buttonIcon: buttonIcon = null })=>{
        const getEmptyButton = ()=>{
            if (buttonText && buttonAction) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: "filled",
                size: isMobileWidth ? "medium" : "large",
                onClick: buttonAction,
                leftIcon: buttonIcon ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: buttonIcon,
                    size: "medium",
                    color: "neutral-100"
                }) : null,
                children: buttonText
            });
            if (isReadyToSubmit) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $eb340908ccb18f38$export$2e2bcd8739ae039), {
                buttonSize: "large"
            });
            return null;
        };
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            tag: "section",
            className: "CertificationDetails-emptyCenter",
            children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: "CertificationDetails-emptyOrError",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h1",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: body
                    }),
                    getEmptyButton()
                ]
            })
        });
    };
    const onCloseClick = ()=>{
        if (objectForRedirectLink?.hasCampaignLevelAccess || objectForRedirectLink?.role_AuditorLoggedIn) window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
        if (objectForRedirectLink?.hasOnlyCertifierLevelAccess || objectForRedirectLink?.consulteeLoggedIn) window.location.replace("/ECM/certification/list");
    };
    const getNoDataContent = ()=>{
        const isZeroToDoItems = !hasActiveTabDetails && activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49);
        const isZeroDoneItems = !hasActiveTabDetails && activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408);
        const isZeroConsultedItems = !hasActiveTabDetails && activeTab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053);
        const hasZeroCountForConsultedItems = consultedTab.count === 0;
        const hasZeroAllTabCount = allTab?.count === 0;
        if (!isLoading && hasZeroAllTabCount) return renderNoDataView({
            title: "You're All Caught Up",
            body: "Your certification is all caught up. Click here to continue!",
            buttonText: "Go Back",
            buttonAction: ()=>onCloseClick(),
            isReadyToSubmit: false
        });
        if (!isLoading && hasNoSearchResults && hasNoCertsResultsToDisplay) return renderNoDataView({
            title: "No Records Match Your Search",
            body: "If you can't see your items, try clearing your search or selecting a different view.",
            buttonText: "Clear Search",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$661e1772dd5a4141)(true)),
            isReadyToSubmit: false
        });
        if (!isLoading && (hasNoAdvancedFiltersResults || isSaviApplied || isSmartApplied) && hasNoCertsResultsToDisplay) {
            const filterTypeText = activeTab?.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) ? `To see your (${activeTab?.count}) remaining to-do items, make sure to clear the filters you applied.` : "If you can't see your items, try clearing your filters or selecting a different view.";
            return renderNoDataView({
                title: "Need to Clear Your Filters?",
                body: filterTypeText,
                buttonText: "Clear Filters",
                buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$86d11b633a5d59e6)(true)),
                isReadyToSubmit: false
            });
        }
        if (!isLoading && isZeroToDoItems && hasZeroCountForConsultedItems && shouldShowReviewAndSubmitButton) return renderNoDataView({
            title: primaryCertifier ? "Your Certification Is Ready to Be Submitted" : "Your Certification Is Ready to Be Completed",
            body: primaryCertifier ? "Now that you've completed your certification, you can review a summary of the items you're certifying and submit your certification review." : "Now that you've taken action on all items in your certification, you can review a summary of the items you're certifying and complete your certification review.",
            buttonText: "",
            buttonAction: ()=>{},
            isReadyToSubmit: true
        });
        const makeConsultedTabActive = tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053),
                isHighlighted: false
            }));
        if (!isLoading && isZeroToDoItems && shouldShowReviewAndSubmitButton) return renderNoDataView({
            title: "Pending Items For Consultation",
            body: "You have pending items that are being consulted with another certifier. Once completed, you can review a summary of the items you're certifying and submit your certification.",
            buttonText: "View Consulted List",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(makeConsultedTabActive)),
            isReadyToSubmit: false
        });
        if (!isLoading && isZeroToDoItems && !shouldShowReviewAndSubmitButton && !objectForRedirectLink?.consulteeLoggedIn) return renderNoDataView({
            title: "You're All Done!",
            body: "Your certification has been submitted. If you want a report of your certification for your records, you can export a summary now.",
            buttonText: "Export",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$bf978479f6cb60e8)(certKey)),
            isReadyToSubmit: false,
            buttonIcon: "Export"
        });
        const makeTodoTabActive = tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                isHighlighted: false
            }));
        if (!isLoading && isZeroDoneItems) return renderNoDataView({
            title: "No Items Certified Yet",
            body: "Once you start approving or rejecting items in your to-do list, they'll get placed here for you to review as you complete your certification. ",
            buttonText: "View To-Do List",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(makeTodoTabActive)),
            isReadyToSubmit: false
        });
        const makeDoneTabActive = tabData.map((tab)=>({
                ...tab,
                isActive: tab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408),
                isHighlighted: false
            }));
        if (consultedTab.isActive && consultedTab.count === 0) dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(makeDoneTabActive));
        if (!isLoading && isZeroConsultedItems) return renderNoDataView({
            title: "No Items Moved To Consult Yet",
            body: "Once you start consulting items from your to-do list, they'll get placed here.",
            buttonText: "View To-Do List",
            buttonAction: ()=>dispatch((0, $d623f23401a154f0$export$e9c5cd8aea0cabc7)(makeTodoTabActive)),
            isReadyToSubmit: false
        });
        if (!isLoading && hasNoCertsResultsToDisplay) return renderNoDataView({
            title: "No Items Available To Show",
            body: "You do not have any items here for action. Go to All tab to view your items.",
            buttonText: "View All List",
            buttonAction: resetFilterForViewAllButton,
            isReadyToSubmit: false
        });
        return null;
    };
    if (isAnyError) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $87d4d732106452cd$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $hopDi$jsxs)("section", {
        id: "certsDetailsList",
        ref: detailsListRef,
        className: detailsListClasses,
        "data-testid": "cert-details",
        children: [
            getNoDataContent() || /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $691dbffebbf06698$export$2e2bcd8739ae039), {
                        data: mergedListsAfterRowFilter,
                        handleSidePanel: handleSidePanel,
                        handleAutoSelectParent: handleAutoSelectParent,
                        setMergedLists: setMergedLists,
                        actionPopoverOpenId: actionPopoverOpenId,
                        setActionPopoverOpenId: setActionPopoverOpenId,
                        isScrolling: isScrolling
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $2b016bbacf604946$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "CertsDetailsList-targetLoader",
                ref: observerTarget
            }),
            isLoading && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsDetailsList-loader",
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                    kind: "loop",
                    format: "main",
                    color: "brand",
                    size: "large"
                })
            })
        ]
    });
}
$9dc2b5e278a56721$var$CertsDetailsList.propTypes = {
    isMoreDataAvailable: (0, $hopDi$proptypes).bool.isRequired,
    setIsMoreDataAvailable: (0, $hopDi$proptypes).func.isRequired,
    showFilterBar: (0, $hopDi$proptypes).bool.isRequired,
    detailsListRef: (0, $hopDi$proptypes).oneOfType([
        (0, $hopDi$proptypes).func,
        (0, $hopDi$proptypes).shape({
            current: (0, $hopDi$proptypes).instanceOf(Element)
        })
    ]),
    setSidePanelData: (0, $hopDi$proptypes).func.isRequired,
    mergedLists: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setMergedLists: (0, $hopDi$proptypes).func.isRequired,
    currentOffset: (0, $hopDi$proptypes).number.isRequired,
    setCurrentOffset: (0, $hopDi$proptypes).func.isRequired,
    mergedListsAfterRowFilter: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).shape({})).isRequired,
    setMergedListsAfterRowFilter: (0, $hopDi$proptypes).func.isRequired,
    listApiCallCount: (0, $hopDi$proptypes).number.isRequired,
    setListApiCallCount: (0, $hopDi$proptypes).func.isRequired,
    handleAutoSelectParent: (0, $hopDi$proptypes).func.isRequired
};
$9dc2b5e278a56721$var$CertsDetailsList.defaultProps = {
    detailsListRef: null
};
var $9dc2b5e278a56721$export$2e2bcd8739ae039 = $9dc2b5e278a56721$var$CertsDetailsList;


var $deb4d0ab4728ac1f$export$2e2bcd8739ae039 = (0, $9dc2b5e278a56721$export$2e2bcd8739ae039);








/* eslint-disable indent */ 









/* eslint-disable indent */ 




const $2bab42430c1fd2c9$export$594cac2c376c32b5 = {
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired
};
const $2bab42430c1fd2c9$export$db8acaaade8984f5 = {
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired
};
const $2bab42430c1fd2c9$export$cd90448fa71b3fdb = {
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired
};
const $2bab42430c1fd2c9$export$1d9c6f295a272fc0 = {
    isOpen: (0, $hopDi$proptypes).bool.isRequired,
    showAlert: (0, $hopDi$proptypes).bool.isRequired,
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired
};









const $f16755d1eb7f7f9c$export$cc844e58ea5510e9 = 500;
const $f16755d1eb7f7f9c$export$b3276df9d1d6ab62 = 1;
const $f16755d1eb7f7f9c$export$273a483dd6b0bbbb = 3;
const $f16755d1eb7f7f9c$export$b8f309dc6c1508c5 = 427;
const $f16755d1eb7f7f9c$export$2d1cfc15057b8a = 600;
const $f16755d1eb7f7f9c$export$abd89ed84e8d9673 = 2;
const $f16755d1eb7f7f9c$export$ae0d84fe956e4aa8 = (0, $d60257e8dc27bf16$export$1cc98074061c90d2);
const $f16755d1eb7f7f9c$export$6700f379dccd757a = (0, $d60257e8dc27bf16$export$7d6712c2cb8377b2);
const $f16755d1eb7f7f9c$export$9abc031b049cea07 = (0, $d60257e8dc27bf16$export$153ab95c08227093);
const $f16755d1eb7f7f9c$export$1cffb1b4d08ae4c4 = (0, $d60257e8dc27bf16$export$be9a3074cb3ae0c7);
const $f16755d1eb7f7f9c$export$299bc9d52534f8e3 = 4;
const $f16755d1eb7f7f9c$export$d15bf6606d7c003f = "totalUsers";
const $f16755d1eb7f7f9c$export$44168e727381e009 = "totalRoles";
const $f16755d1eb7f7f9c$export$e9d3c5780f746027 = "totalAccounts";
const $f16755d1eb7f7f9c$export$f543b652b7d38cdc = "totalEntitlements";
const $f16755d1eb7f7f9c$export$b09b44dc4d37afd9 = "totalSelectedItems";
const $f16755d1eb7f7f9c$export$50919f38e67a3d45 = {
    // COMPLETED
    CLEAR: {
        id: "bulkActionClearBtn",
        icon: "clear",
        status: "-1",
        text: "Clear Selection",
        objectsToTotal: []
    },
    // COMPLETED
    WORKS_FOR_ME: {
        id: "worksForMe",
        icon: "Check",
        status: "2",
        text: "Approve",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f,
            $f16755d1eb7f7f9c$export$e9d3c5780f746027,
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    DOES_NOT_WORK_FOR_ME: {
        id: "doesNotWorksForMe",
        icon: "reassignUser",
        status: "3",
        text: "Reassign",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f
        ]
    },
    // COMPLETED
    TERMINATE: {
        id: "terminated",
        icon: "terminate",
        status: "4",
        text: "Terminate",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f
        ]
    },
    // COMPLETED
    EXTEND_END_DATE: {
        id: "extendEndDate",
        icon: "ExtendEndDate",
        status: "2",
        text: "Extend End Date For User",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f
        ]
    },
    // COMPLETED
    APPROVE: {
        id: "approve",
        icon: "Check",
        status: "2",
        text: "Approve",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f,
            $f16755d1eb7f7f9c$export$e9d3c5780f746027,
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    // COMPLETED
    REJECT: {
        id: "reject",
        icon: "reject",
        status: "3",
        text: "Reject Access",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$e9d3c5780f746027,
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    // COMPLETED
    CONDITIONAL_CERTIFIY: {
        id: "conditionalCertifiy",
        icon: "ExtendEndDate",
        status: "5",
        text: "Change End Date For Access",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$e9d3c5780f746027,
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    REASSIGN: {
        id: "reassign",
        icon: "reassignItem",
        status: "-1",
        text: "Reassign Access",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$e9d3c5780f746027,
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    },
    // COMPLETED
    CONSULT: {
        id: "consult",
        icon: "Consult",
        status: "-1",
        text: "Consult",
        objectsToTotal: [
            $f16755d1eb7f7f9c$export$d15bf6606d7c003f,
            $f16755d1eb7f7f9c$export$e9d3c5780f746027,
            $f16755d1eb7f7f9c$export$44168e727381e009,
            $f16755d1eb7f7f9c$export$f543b652b7d38cdc
        ]
    }
};
const $f16755d1eb7f7f9c$export$c4642c4b1af79efe = {
    worksForMe: "WORKS_FOR_ME",
    doesNotWorksForMe: "DOES_NOT_WORK_FOR_ME",
    terminated: "TERMINATE",
    extendEndDate: "EXTEND_END_DATE",
    approve: "APPROVE",
    reject: "REJECT",
    conditionalCertifiy: "CONDITIONAL_CERTIFIY",
    reassign: "REASSIGN",
    consult: "CONSULT"
};
const $f16755d1eb7f7f9c$export$c9eee0952850eb88 = {
    [$f16755d1eb7f7f9c$export$d15bf6606d7c003f]: "User",
    [$f16755d1eb7f7f9c$export$e9d3c5780f746027]: "Account",
    [$f16755d1eb7f7f9c$export$44168e727381e009]: "Role",
    [$f16755d1eb7f7f9c$export$f543b652b7d38cdc]: "Entitlement"
};
const $f16755d1eb7f7f9c$export$bddfa2559af63e14 = "Users associated with these access items will automatically be approved.";
const $f16755d1eb7f7f9c$export$b40b6afeb65aaac6 = {
    id: "",
    isOpen: false,
    showAlert: false,
    hasAgreed: false,
    isSubmitting: false,
    comment: ""
};
const $f16755d1eb7f7f9c$export$86ece8019817d1d3 = {
    id: "",
    isOpen: false,
    showAlert: false,
    hasAgreed: false,
    isSubmitting: false,
    endDate: null,
    comment: ""
};
const $f16755d1eb7f7f9c$export$41b1dc835ddda629 = {
    id: "",
    isOpen: false,
    showAlert: false,
    hasAgreed: false,
    isSubmitting: false,
    reassignAssociated: false,
    consultWith: "",
    consultWithName: "",
    comment: ""
};
const $f16755d1eb7f7f9c$export$434d0b2252a6f73d = {
    id: "",
    isOpen: false,
    showAlert: false,
    hasAgreed: false,
    isSubmitting: false,
    reassignAssociated: false,
    isSkipCertifier: false,
    reassignTo: "",
    reassignToName: "",
    comment: ""
};



function $a349556b2d13bf94$var$BulkActionCommonBody({ bulkActionCommonAction: bulkActionCommonAction, setBulkActionCommonAction: setBulkActionCommonAction, handleCloseBukActionCommonAlert: handleCloseBukActionCommonAlert, bulkPredefinedComments: bulkPredefinedComments, isMobileXlargeWidth: isMobileXlargeWidth }) {
    const handleCommentDescription = (text)=>{
        setBulkActionCommonAction((prev)=>({
                ...prev,
                comment: text
            }));
    };
    const handleHasAgreedChange = ()=>{
        setBulkActionCommonAction((prev)=>({
                ...prev,
                hasAgreed: !prev.hasAgreed
            }));
    };
    const isAlertVisible = Boolean(bulkActionCommonAction?.showAlert && !bulkActionCommonAction?.isSubmitting);
    const commonBodyClass = (0, $hopDi$classnames)("BulkActionCommonBody", isAlertVisible && !isMobileXlargeWidth && "BulkActionCommonBody-alertBox--1", isAlertVisible && isMobileXlargeWidth && "BulkActionCommonBody-alertBox--2");
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                colorTheme: "Critical",
                title: "Required fields are missing.",
                description: "",
                isColonVisible: false,
                isVisible: isAlertVisible,
                onCancel: handleCloseBukActionCommonAlert,
                isFloating: true,
                position: {
                    type: "absolute",
                    top: isMobileXlargeWidth ? "0" : "-1rem"
                }
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: commonBodyClass,
                children: [
                    bulkActionCommonAction?.id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.id && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        className: "BulkActionCommonBody--rejectMessage",
                        text: "Users associated with these access items will automatically be approved.",
                        colorTheme: "info",
                        leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "AlertCritical"
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
                        defaultComments: bulkPredefinedComments,
                        isDisabled: bulkActionCommonAction?.isSubmitting,
                        showAlert: bulkActionCommonAction?.showAlert && bulkActionCommonAction?.comment?.replace(/^\s+|\s+$/gm, "")?.length <= (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673),
                        onChange: handleCommentDescription,
                        clearModal: bulkActionCommonAction?.isOpen
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "BulkActionsBody-checkBoxDiv",
                        children: [
                            !bulkActionCommonAction?.hasAgreed && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: bulkActionCommonAction?.showAlert ? "Required" : "RequiredInactive",
                                size: "medium",
                                className: "BulkActionsBody-checkBoxDivIcon"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                name: "checkbox-error",
                                kind: "text",
                                isDisabled: bulkActionCommonAction?.isSubmitting,
                                dataTestId: "checkbox-error",
                                isChecked: bulkActionCommonAction?.hasAgreed,
                                onChange: handleHasAgreedChange,
                                label: "I confirm I have reviewed all items",
                                textPosition: "after",
                                error: bulkActionCommonAction?.showAlert && !bulkActionCommonAction?.hasAgreed ? "This required field is incomplete" : ""
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$a349556b2d13bf94$var$BulkActionCommonBody.propTypes = {
    bulkActionCommonAction: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$594cac2c376c32b5)).isRequired,
    setBulkActionCommonAction: (0, $hopDi$proptypes).func.isRequired,
    handleCloseBukActionCommonAlert: (0, $hopDi$proptypes).func.isRequired,
    bulkPredefinedComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool
};
$a349556b2d13bf94$var$BulkActionCommonBody.defaultProps = {
    bulkPredefinedComments: [],
    isMobileXlargeWidth: false
};
var $a349556b2d13bf94$export$2e2bcd8739ae039 = $a349556b2d13bf94$var$BulkActionCommonBody;








const $b33ffb5eff238a21$export$8858cb1685606840 = {
    [(0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.id]: "You are approving",
    [(0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.id]: "You are approving",
    [(0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.id]: "You are rejecting",
    [(0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id]: "You are terminating"
};


function $55d3d64578fae6f0$var$BulkActionCommonFooter({ handleCommonAction: handleCommonAction, bulkActionCommonAction: bulkActionCommonAction, handleCloseBulkActionCommon: handleCloseBulkActionCommon }) {
    const submitBtnKind = bulkActionCommonAction?.isSubmitting || bulkActionCommonAction?.comment?.replace(/^\s+|\s+$/gm, "")?.length > (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673) && bulkActionCommonAction?.hasAgreed ? "filled" : "outlined";
    const getActionButtonText = (key)=>{
        switch(key){
            case (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.id:
                return "Approve All";
            case (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.id:
                return "Approve All";
            case (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id:
                return "Terminate";
            case (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.id:
                return "Reject All";
            default:
                return "Unknown action";
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
        size: "large",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "BulkActionCommonFooter-footerButtonWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        isDisabled: bulkActionCommonAction?.isSubmitting,
                        onClick: handleCloseBulkActionCommon,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: submitBtnKind,
                        size: "medium",
                        onClick: ()=>handleCommonAction(bulkActionCommonAction?.id, bulkActionCommonAction?.status, bulkActionCommonAction?.comment),
                        isDisabled: bulkActionCommonAction?.isSubmitting,
                        isLoading: bulkActionCommonAction?.isSubmitting,
                        loaderText: getActionButtonText(bulkActionCommonAction?.id),
                        className: "BulkActionCommonFooter-submitButton",
                        children: getActionButtonText(bulkActionCommonAction?.id)
                    })
                ]
            })
        ]
    });
}
$55d3d64578fae6f0$var$BulkActionCommonFooter.propTypes = {
    handleCommonAction: (0, $hopDi$proptypes).func.isRequired,
    bulkActionCommonAction: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$594cac2c376c32b5)).isRequired,
    handleCloseBulkActionCommon: (0, $hopDi$proptypes).func.isRequired
};
var $55d3d64578fae6f0$export$2e2bcd8739ae039 = $55d3d64578fae6f0$var$BulkActionCommonFooter;






function $c72bdff3be11a04c$var$BulkActionCommonHeader({ id: id, bulkFooterStats: bulkFooterStats }) {
    const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
    const buttonObjectsForTotal = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal;
    const headerCount = buttonObjectsForTotal?.reduce((total, item)=>{
        if (bulkFooterStats[item]) return total + bulkFooterStats[item];
        return total;
    }, 0);
    const renderHeaderText = ()=>{
        const suffixForCountGreaterThanOne = headerCount > 1 ? "s" : "";
        if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id) return `Terminate User${suffixForCountGreaterThanOne} and Access?`;
        if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.id) return `Reject Access for ${headerCount} Item${suffixForCountGreaterThanOne}?`;
        if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.id || id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.id) return `Approve ${headerCount} Item${suffixForCountGreaterThanOne}?`;
        return `Action on ${headerCount} Item${suffixForCountGreaterThanOne}?`;
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Fragment), {
        children: renderHeaderText()
    });
}
$c72bdff3be11a04c$var$BulkActionCommonHeader.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    bulkFooterStats: (0, $hopDi$proptypes).shape({})
};
$c72bdff3be11a04c$var$BulkActionCommonHeader.defaultProps = {
    bulkFooterStats: {}
};
var $c72bdff3be11a04c$export$2e2bcd8739ae039 = $c72bdff3be11a04c$var$BulkActionCommonHeader;







function $8222170054ee6433$var$BulkActionCommonSubTitle({ id: id, bulkFooterStats: bulkFooterStats }) {
    const { configMap: configMap } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id) {
        if (configMap?.LOCKTASKEXPIRE === "1" || configMap?.LOCKTASKS === "1") return `Do you want to terminate ${bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f] > 1 ? "these users" : "this user"} and revoke all their access? Termination won't be fulfilled right away. It'll take effect after you finish your review and submit.`;
        return "Termination won't be fulfilled right away. It'll take effect after you finish your review and submit.";
    }
    const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
    const buttonObjectsForTotal = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal;
    const tempSubtitleTextEdit1 = buttonObjectsForTotal?.filter((key)=>bulkFooterStats[key] > 0).map((key)=>`${bulkFooterStats[key]} ${(0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)[key]}${bulkFooterStats[key] > 1 ? "s" : ""}`);
    if (!tempSubtitleTextEdit1) return "";
    if (tempSubtitleTextEdit1?.length === 0) return "You've selected nothing.";
    // Handling case only for 1 type of item
    if (tempSubtitleTextEdit1?.length === 1) {
        if (bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f]) return `${(0, $b33ffb5eff238a21$export$8858cb1685606840)?.[id]} ${tempSubtitleTextEdit1[0]}${tempSubtitleTextEdit1[0] > 1 ? "s" : ""}.`;
        return `${(0, $b33ffb5eff238a21$export$8858cb1685606840)?.[id]} ${tempSubtitleTextEdit1[0]}${tempSubtitleTextEdit1[0] > 1 ? "s" : ""}.`;
    }
    // Handling case only for differnet type of items
    const tempSubtitleTextEdit2 = buttonObjectsForTotal // Without userCount
    ?.filter((key)=>bulkFooterStats[key] > 0 && key !== (0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f)).map((key)=>`${bulkFooterStats[key]} ${(0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)[key]}${bulkFooterStats[key] > 1 ? "s" : ""}`);
    if (!bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f]) {
        let tempPreText = tempSubtitleTextEdit2[0];
        if (tempSubtitleTextEdit2?.length > 1) tempPreText = `${tempSubtitleTextEdit2.slice(0, tempSubtitleTextEdit2.length - 1).join(", ")} and ${tempSubtitleTextEdit2[tempSubtitleTextEdit2.length - 1]}.`;
        else tempPreText = `${tempPreText}.`;
        return `${(0, $b33ffb5eff238a21$export$8858cb1685606840)?.[id]} ${tempPreText}`;
    }
    const userObjCount = bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f];
    let tempPreText = tempSubtitleTextEdit2[0];
    if (tempSubtitleTextEdit2?.length > 1) tempPreText = `${tempSubtitleTextEdit2.slice(0, tempSubtitleTextEdit2.length - 1).join(", ")} and ${tempSubtitleTextEdit2[tempSubtitleTextEdit2.length - 1]}.`;
    else tempPreText = `${tempPreText}.`;
    if (id !== (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.id) return /*#__PURE__*/ (0, $hopDi$jsxs)("ul", {
        className: "BulkActionCommonSubTitle",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("li", {
                children: `You are confirming that you are the Certifier for ${userObjCount} User${userObjCount > 1 ? "s" : ""}.`
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("li", {
                children: `${(0, $b33ffb5eff238a21$export$8858cb1685606840)?.[id]} ${tempPreText}`
            })
        ]
    });
    return `${(0, $b33ffb5eff238a21$export$8858cb1685606840)?.[id]} ${tempPreText}`;
}
$8222170054ee6433$var$BulkActionCommonSubTitle.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    bulkFooterStats: (0, $hopDi$proptypes).shape({})
};
$8222170054ee6433$var$BulkActionCommonSubTitle.defaultProps = {
    bulkFooterStats: {}
};
var $8222170054ee6433$export$2e2bcd8739ae039 = $8222170054ee6433$var$BulkActionCommonSubTitle;




function $2dab5b6edb29fb52$var$BulkActionCommon({ bulkFooterStats: bulkFooterStats, bulkActionCommonAction: bulkActionCommonAction, setBulkActionCommonAction: setBulkActionCommonAction, handleCommonAction: handleCommonAction, bulkPredefinedComments: bulkPredefinedComments, isMobileXlargeWidth: isMobileXlargeWidth }) {
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = (0, $hopDi$useState)(false);
    const handleCloseBulkActionCommon = ()=>{
        setBulkActionCommonAction((prev)=>({
                ...prev,
                isOpen: false,
                hasAgreed: false,
                comment: ""
            }));
    };
    const handleCloseBukActionCommonAlert = ()=>{
        setBulkActionCommonAction((prev)=>({
                ...prev,
                showAlert: false
            }));
    };
    (0, $hopDi$useEffect)(()=>{
        if (!isMobileDrawerOpen && isMobileXlargeWidth) handleCloseBulkActionCommon();
    }, [
        isMobileDrawerOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        setIsMobileDrawerOpen(bulkActionCommonAction?.isOpen);
    }, [
        bulkActionCommonAction?.isOpen
    ]);
    if (isMobileXlargeWidth && isMobileDrawerOpen) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
        className: "BulkActionCommon-mobileDrawer",
        isOpen: isMobileDrawerOpen,
        fixedHeight: 32,
        setIsOpen: setIsMobileDrawerOpen,
        headerContent: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ModalIsland-headerWrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ModalIsland-header ModalIsland-header--hasSubtitle ModalIsland-header--hasIcon",
                    children: [
                        bulkActionCommonAction?.id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Terminate",
                            size: "large",
                            color: "critical-700"
                        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "AlertWarningFilledSeparateColors",
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ModalIsland-titleContainer",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    className: "ModalIsland-title",
                                    kind: "h2",
                                    desktop: "h2-d",
                                    mobile: "h2-d",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $c72bdff3be11a04c$export$2e2bcd8739ae039), {
                                        id: bulkActionCommonAction?.id,
                                        bulkFooterStats: bulkFooterStats
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    className: "ModalIsland-subtitle",
                                    kind: "body2",
                                    desktop: "body2-d",
                                    mobile: "body2-d",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8222170054ee6433$export$2e2bcd8739ae039), {
                                        id: bulkActionCommonAction?.id,
                                        bulkFooterStats: bulkFooterStats
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "ModalIsland-closeBtn",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: ()=>setIsMobileDrawerOpen(false)
                    })
                })
            ]
        }),
        content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $a349556b2d13bf94$export$2e2bcd8739ae039), {
            bulkActionCommonAction: bulkActionCommonAction,
            setBulkActionCommonAction: setBulkActionCommonAction,
            handleCloseBukActionCommonAlert: handleCloseBukActionCommonAlert,
            bulkPredefinedComments: bulkPredefinedComments,
            isMobileXlargeWidth: isMobileXlargeWidth
        }),
        footerActionBar: /*#__PURE__*/ (0, $hopDi$jsx)((0, $55d3d64578fae6f0$export$2e2bcd8739ae039), {
            handleCommonAction: handleCommonAction,
            bulkActionCommonAction: bulkActionCommonAction,
            handleCloseBulkActionCommon: handleCloseBulkActionCommon
        })
    });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: "BulkActionCommon-modal",
        onClose: bulkActionCommonAction?.isSubmitting ? ()=>{} : handleCloseBulkActionCommon,
        isOpen: bulkActionCommonAction?.isOpen,
        headerIcon: bulkActionCommonAction?.id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "Terminate",
            size: "large",
            color: "critical-700"
        }) : /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "AlertWarningFilledSeparateColors",
            size: "large"
        }),
        title: /*#__PURE__*/ (0, $hopDi$jsx)((0, $c72bdff3be11a04c$export$2e2bcd8739ae039), {
            id: bulkActionCommonAction?.id,
            bulkFooterStats: bulkFooterStats
        }),
        subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8222170054ee6433$export$2e2bcd8739ae039), {
            id: bulkActionCommonAction?.id,
            bulkFooterStats: bulkFooterStats
        }),
        contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $a349556b2d13bf94$export$2e2bcd8739ae039), {
            bulkActionCommonAction: bulkActionCommonAction,
            setBulkActionCommonAction: setBulkActionCommonAction,
            handleCloseBukActionCommonAlert: handleCloseBukActionCommonAlert,
            bulkPredefinedComments: bulkPredefinedComments
        }),
        FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $55d3d64578fae6f0$export$2e2bcd8739ae039), {
            handleCommonAction: handleCommonAction,
            bulkActionCommonAction: bulkActionCommonAction,
            handleCloseBulkActionCommon: handleCloseBulkActionCommon
        }),
        isOverflowVisible: true
    });
}
$2dab5b6edb29fb52$var$BulkActionCommon.propTypes = {
    bulkFooterStats: (0, $hopDi$proptypes).shape({}),
    bulkActionCommonAction: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$594cac2c376c32b5)).isRequired,
    setBulkActionCommonAction: (0, $hopDi$proptypes).func.isRequired,
    handleCommonAction: (0, $hopDi$proptypes).func.isRequired,
    bulkPredefinedComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool
};
$2dab5b6edb29fb52$var$BulkActionCommon.defaultProps = {
    bulkFooterStats: {},
    bulkPredefinedComments: [],
    isMobileXlargeWidth: false
};
var $2dab5b6edb29fb52$export$2e2bcd8739ae039 = $2dab5b6edb29fb52$var$BulkActionCommon;


var $67922cf867358a9f$export$2e2bcd8739ae039 = (0, $2dab5b6edb29fb52$export$2e2bcd8739ae039);
























function $3dadf9e8b590914b$var$BulkActionConsultList({ isSubmitting: isSubmitting, isCritical: isCritical, consultWith: consultWith, setBulkActionConsult: setBulkActionConsult, certKey: certKey, defaultReassignee: defaultReassignee, defaultAssigneName: defaultAssigneName, certifierUserKey: certifierUserKey }) {
    const handleAssigneeChange = (selectedOption)=>{
        let consultWithName = "";
        if (selectedOption?.username?.trim()?.length !== 0) consultWithName = selectedOption?.username;
        else consultWithName = `${selectedOption?.firstname} ${selectedOption?.lastname}`;
        setBulkActionConsult((prev)=>({
                ...prev,
                consultWith: selectedOption?.value || "",
                consultWithName: consultWithName
            }));
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $2c1f4f91a862faa4$export$2e2bcd8739ae039), {
        defaultReassignee: defaultReassignee,
        defaultAssigneName: defaultAssigneName,
        onSelect: handleAssigneeChange,
        isCritical: isCritical,
        isDisabled: isSubmitting,
        selectedUser: consultWith?.trim()?.length !== 0,
        certKey: certKey,
        placeholder: "Select a known or default reassignee",
        certifierUserKey: certifierUserKey
    });
}
$3dadf9e8b590914b$var$BulkActionConsultList.propTypes = {
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired,
    isCritical: (0, $hopDi$proptypes).bool.isRequired,
    consultWith: (0, $hopDi$proptypes).string.isRequired,
    setBulkActionConsult: (0, $hopDi$proptypes).func.isRequired,
    certKey: (0, $hopDi$proptypes).string.isRequired,
    defaultReassignee: (0, $hopDi$proptypes).string.isRequired,
    defaultAssigneName: (0, $hopDi$proptypes).string.isRequired,
    certifierUserKey: (0, $hopDi$proptypes).string.isRequired
};
var $3dadf9e8b590914b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $hopDi$react).memo($3dadf9e8b590914b$var$BulkActionConsultList);



const $f94247acf3dde6db$export$fafc90b43467ba44 = {
    totalUsers: {
        icon: "UserNoBg",
        title: "User"
    },
    totalAccounts: {
        icon: "Account",
        title: "Account"
    },
    totalRoles: {
        icon: "Role",
        title: "Role"
    },
    totalEntitlements: {
        icon: "Entitlement",
        title: "Entitlement"
    }
};
const $f94247acf3dde6db$export$73582e56970b90af = "";


function $fe6c43a1525e3dd2$var$BulkActionConsultBody({ bulkFooterStats: bulkFooterStats, bulkActionConsult: bulkActionConsult, setBulkActionConsult: setBulkActionConsult, handleCloseBulkActionConsult: handleCloseBulkActionConsult, handleCloseBukActionConsultAlert: handleCloseBukActionConsultAlert, bulkPredefinedComments: bulkPredefinedComments }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, consultActionAssignee: consultActionAssignee, reassignConfigMap: reassignConfigMap } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const isConsultActionAssigneeLoading = Boolean(consultActionAssignee?.isLoading);
    const isConsultActionAssigneeError = Boolean(consultActionAssignee?.errorMessage?.error !== undefined && consultActionAssignee?.errorMessage?.error !== null && consultActionAssignee?.errorMessage?.error?.trim()?.length !== 0);
    (0, $hopDi$useEffect)(()=>{
        if (bulkActionConsult?.isOpen) dispatch((0, $d623f23401a154f0$export$b839edba12a89f4d)(false));
    }, [
        bulkActionConsult?.isOpen
    ]);
    const totalCountOfItems = Object?.values(bulkFooterStats)?.reduce((total, individualCount)=>total + individualCount, 0);
    const handleCommentDescription = (text)=>{
        setBulkActionConsult((prev)=>({
                ...prev,
                comment: text
            }));
    };
    const handleHasAgreedChange = ()=>{
        setBulkActionConsult((prev)=>({
                ...prev,
                hasAgreed: !prev.hasAgreed
            }));
    };
    const consultObjectKeys = Object?.keys(bulkFooterStats);
    const shouldShowInlineMessage = Boolean(consultObjectKeys.length === 1 && consultObjectKeys.includes((0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f)));
    const renderConsultActionBody = ()=>{
        if (isConsultActionAssigneeLoading) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "BulkActionConsultBody-loaderWrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "large",
                className: "BulkActionConsultBody-loader"
            })
        });
        if (isConsultActionAssigneeError) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "AccessRequestHistoryBody-wrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "ReviewAndSubmitModal-bodyError",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h2",
                        children: "Couldn't Load"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: "The Modal didn't load properly due to a network issue. Please refresh or try again later."
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "ReviewAndSubmitModal-bodyErrorButtons",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            size: "medium",
                            onClick: handleCloseBulkActionConsult,
                            children: "Close"
                        })
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "BulkActionConsultBody-stats",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            kind: "label",
                            className: "BulkActionConsultBody-statsHeading",
                            children: [
                                "Items to Consult (",
                                totalCountOfItems,
                                ")",
                                shouldShowInlineMessage && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                    openDelay: 500,
                                    text: `Access items associated with ${bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f] > 1 ? "these users" : "this user"} are included.`,
                                    maxWidth: "20rem",
                                    placement: "right",
                                    offset: 8,
                                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "Info",
                                        color: "info-700",
                                        size: "small",
                                        className: "BulkActionConsultBody-statsHeadingIcon"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "BulkActionConsultBody-statsObjects",
                            children: consultObjectKeys?.map((key)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "BulkActionConsultBody-statsContent",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: (0, $f94247acf3dde6db$export$fafc90b43467ba44)?.[key].icon,
                                            size: "medium"
                                        }),
                                        `${bulkFooterStats?.[key]} ${(0, $f94247acf3dde6db$export$fafc90b43467ba44)?.[key].title}${bulkFooterStats?.[key] > 1 ? "s" : ""}`
                                    ]
                                }, key))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "BulkActionConsultBody-assigneeBox",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            kind: "label",
                            className: "BulkActionConsultBody-statsHeading",
                            children: [
                                bulkActionConsult?.consultWith.length === 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: bulkActionConsult?.showAlert && bulkActionConsult?.consultWith.length === 0 ? "Required" : "RequiredInactive",
                                    size: "medium",
                                    className: "BulkActionConsultBody-assigneeBoxIcon"
                                }),
                                "I want to consult with"
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $3dadf9e8b590914b$export$2e2bcd8739ae039), {
                            isSubmitting: bulkActionConsult?.isSubmitting,
                            consultWith: bulkActionConsult?.consultWith,
                            isCritical: bulkActionConsult?.consultWith === "" && bulkActionConsult?.showAlert,
                            setBulkActionConsult: setBulkActionConsult,
                            certKey: certKey,
                            showDefaultCertifier: false,
                            defaultReassignee: reassignConfigMap?.defaultReassignee,
                            defaultAssigneName: reassignConfigMap?.defaultReassigneeName,
                            certifierUserKey: reassignConfigMap?.certifierUserKey
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
                    defaultComments: bulkPredefinedComments,
                    isDisabled: bulkActionConsult?.isSubmitting,
                    showAlert: bulkActionConsult?.showAlert && bulkActionConsult?.comment?.replace(/^\s+|\s+$/gm, "")?.length <= (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673),
                    onChange: handleCommentDescription,
                    clearModal: bulkActionConsult?.isOpen
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "BulkActionsBody-checkBoxDiv",
                    children: [
                        !bulkActionConsult?.hasAgreed && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: bulkActionConsult?.showAlert ? "Required" : "RequiredInactive",
                            size: "medium",
                            className: "BulkActionsBody-checkBoxDivIcon"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                            name: "checkbox-error",
                            kind: "text",
                            dataTestId: "checkbox-error",
                            isDisabled: bulkActionConsult?.isSubmitting,
                            isChecked: bulkActionConsult?.hasAgreed,
                            onChange: handleHasAgreedChange,
                            label: "I confirm I have reviewed all items",
                            textPosition: "after",
                            error: bulkActionConsult?.showAlert && !bulkActionConsult?.hasAgreed ? "This required field is incomplete" : ""
                        })
                    ]
                })
            ]
        });
    };
    const isAlertVisible = Boolean(bulkActionConsult?.showAlert && !bulkActionConsult?.isSubmitting);
    const commonBodyClass = (0, $hopDi$classnames)("BulkActionConsultBody", isAlertVisible && "BulkActionConsultBody-alertBox--1");
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                colorTheme: "Critical",
                title: "Required fields are missing.",
                description: "",
                isVisible: bulkActionConsult?.showAlert && !bulkActionConsult?.isSubmitting,
                isColonVisible: false,
                onCancel: handleCloseBukActionConsultAlert,
                isFloating: true,
                position: {
                    type: "absolute",
                    top: "0"
                }
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: commonBodyClass,
                children: renderConsultActionBody()
            })
        ]
    });
}
$fe6c43a1525e3dd2$var$BulkActionConsultBody.propTypes = {
    bulkFooterStats: (0, $hopDi$proptypes).shape({}),
    bulkActionConsult: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$cd90448fa71b3fdb)).isRequired,
    setBulkActionConsult: (0, $hopDi$proptypes).func.isRequired,
    handleCloseBulkActionConsult: (0, $hopDi$proptypes).func.isRequired,
    handleCloseBukActionConsultAlert: (0, $hopDi$proptypes).func,
    bulkPredefinedComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string)
};
$fe6c43a1525e3dd2$var$BulkActionConsultBody.defaultProps = {
    bulkFooterStats: {},
    handleCloseBukActionConsultAlert: ()=>{},
    bulkPredefinedComments: []
};
var $fe6c43a1525e3dd2$export$2e2bcd8739ae039 = $fe6c43a1525e3dd2$var$BulkActionConsultBody;








function $c62c8dd5497d883f$var$BulkActionConsultFooter({ handleConsult: handleConsult, bulkActionConsult: bulkActionConsult, handleCloseBulkActionConsult: handleCloseBulkActionConsult }) {
    const submitBtnKind = bulkActionConsult?.isSubmitting || bulkActionConsult?.comment?.replace(/^\s+|\s+$/gm, "")?.length > (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673) && bulkActionConsult?.consultWith?.length > 0 && bulkActionConsult?.hasAgreed ? "filled" : "outlined";
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
        size: "large",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "BulkActionConsultFooter-footerButtonWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        isDisabled: bulkActionConsult?.isSubmitting,
                        onClick: handleCloseBulkActionConsult,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        className: "BulkActionConsultFooter-submitButton",
                        type: "button",
                        kind: submitBtnKind,
                        size: "medium",
                        onClick: ()=>handleConsult(bulkActionConsult?.reassignAssociated, bulkActionConsult?.consultWith, bulkActionConsult?.comment, bulkActionConsult?.consultWithName),
                        isDisabled: bulkActionConsult?.isSubmitting,
                        isLoading: bulkActionConsult?.isSubmitting,
                        loaderText: "Submit",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
}
$c62c8dd5497d883f$var$BulkActionConsultFooter.propTypes = {
    handleConsult: (0, $hopDi$proptypes).func.isRequired,
    bulkActionConsult: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$cd90448fa71b3fdb)).isRequired,
    handleCloseBulkActionConsult: (0, $hopDi$proptypes).func.isRequired
};
var $c62c8dd5497d883f$export$2e2bcd8739ae039 = $c62c8dd5497d883f$var$BulkActionConsultFooter;




function $e03ec98f9c6037d2$var$BulkActionConsult({ bulkFooterStats: bulkFooterStats, bulkActionConsult: bulkActionConsult, setBulkActionConsult: setBulkActionConsult, handleConsult: handleConsult, bulkPredefinedComments: bulkPredefinedComments, isMobileXlargeWidth: isMobileXlargeWidth }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = (0, $hopDi$useState)(false);
    const handleCloseBulkActionConsult = ()=>{
        setTimeout(()=>{
            dispatch((0, $d623f23401a154f0$export$b839edba12a89f4d)(true));
        }, (0, $f16755d1eb7f7f9c$export$cc844e58ea5510e9));
        setBulkActionConsult((prev)=>({
                ...prev,
                isOpen: false,
                hasAgreed: false,
                reassignAssociated: false,
                consultWith: "",
                comment: ""
            }));
    };
    const handleCloseBukActionConsultAlert = ()=>{
        setBulkActionConsult((prev)=>({
                ...prev,
                showAlert: false
            }));
    };
    const bulkActionConsultModal = (0, $hopDi$classnames)("BulkActionConsultModal");
    (0, $hopDi$useEffect)(()=>{
        if (!isMobileDrawerOpen && isMobileXlargeWidth) handleCloseBulkActionConsult();
    }, [
        isMobileDrawerOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        setIsMobileDrawerOpen(bulkActionConsult?.isOpen);
    }, [
        bulkActionConsult?.isOpen
    ]);
    if (isMobileXlargeWidth && isMobileDrawerOpen) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
        className: "BulkActionConsult-mobileDrawer",
        isOpen: isMobileDrawerOpen,
        fixedHeight: 32,
        setIsOpen: setIsMobileDrawerOpen,
        headerContent: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ModalIsland-headerWrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ModalIsland-header ModalIsland-header--hasSubtitle ModalIsland-header--hasIcon",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Consult",
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ModalIsland-titleContainer",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    className: "ModalIsland-title",
                                    kind: "h2",
                                    desktop: "h2-d",
                                    mobile: "h2-d",
                                    children: "Consult with Peers"
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    className: "ModalIsland-subtitle",
                                    kind: "body2",
                                    desktop: "body2-d",
                                    mobile: "body2-d",
                                    children: "Invite another user in your organization to review your certification items and advise on appropriate actions."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "ModalIsland-closeBtn",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: ()=>setIsMobileDrawerOpen(false)
                    })
                })
            ]
        }),
        content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $fe6c43a1525e3dd2$export$2e2bcd8739ae039), {
            bulkFooterStats: bulkFooterStats,
            bulkActionConsult: bulkActionConsult,
            setBulkActionConsult: setBulkActionConsult,
            handleCloseBulkActionConsult: handleCloseBulkActionConsult,
            handleCloseBukActionConsultAlert: handleCloseBukActionConsultAlert,
            bulkPredefinedComments: bulkPredefinedComments
        }),
        footerActionBar: /*#__PURE__*/ (0, $hopDi$jsx)((0, $c62c8dd5497d883f$export$2e2bcd8739ae039), {
            handleConsult: handleConsult,
            bulkActionConsult: bulkActionConsult,
            handleCloseBulkActionConsult: handleCloseBulkActionConsult
        })
    });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: bulkActionConsultModal,
        onClose: bulkActionConsult?.isSubmitting ? ()=>{} : handleCloseBulkActionConsult,
        isOpen: bulkActionConsult?.isOpen,
        headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "Consult",
            size: "large"
        }),
        title: "Consult with Peers",
        subtitle: "Invite another user in your organization to review your certification items and advise on appropriate actions.",
        contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $fe6c43a1525e3dd2$export$2e2bcd8739ae039), {
            bulkFooterStats: bulkFooterStats,
            bulkActionConsult: bulkActionConsult,
            setBulkActionConsult: setBulkActionConsult,
            handleCloseBulkActionConsult: handleCloseBulkActionConsult,
            handleCloseBukActionConsultAlert: handleCloseBukActionConsultAlert,
            bulkPredefinedComments: bulkPredefinedComments
        }),
        FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $c62c8dd5497d883f$export$2e2bcd8739ae039), {
            handleConsult: handleConsult,
            bulkActionConsult: bulkActionConsult,
            handleCloseBulkActionConsult: handleCloseBulkActionConsult
        })
    });
}
$e03ec98f9c6037d2$var$BulkActionConsult.propTypes = {
    bulkFooterStats: (0, $hopDi$proptypes).shape({}),
    bulkActionConsult: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$cd90448fa71b3fdb)).isRequired,
    setBulkActionConsult: (0, $hopDi$proptypes).func.isRequired,
    handleConsult: (0, $hopDi$proptypes).func.isRequired,
    bulkPredefinedComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool
};
$e03ec98f9c6037d2$var$BulkActionConsult.defaultProps = {
    bulkFooterStats: {},
    bulkPredefinedComments: [],
    isMobileXlargeWidth: false
};
var $e03ec98f9c6037d2$export$2e2bcd8739ae039 = $e03ec98f9c6037d2$var$BulkActionConsult;


var $9c5641ad203d7eb5$export$2e2bcd8739ae039 = (0, $e03ec98f9c6037d2$export$2e2bcd8739ae039);

















const $2b140e2c3a1e16f8$export$80bc303d21b948cd = "The end date won't be changed until you finish the review and submit.";


function $cc57f9b16605cf67$var$BulkActionEndDateBody({ bulkActionEndDate: bulkActionEndDate, setBulkActionEndDate: setBulkActionEndDate, handleCloseBukActionEndDateAlert: handleCloseBukActionEndDateAlert, bulkPredefinedComments: bulkPredefinedComments }) {
    const { certificationStartDate: certificationStartDate, configMap: { ConditionallyCertifyInDaysLimit: ConditionallyCertifyInDaysLimit, ExtendEndDateDaysLimit: ExtendEndDateDaysLimit } } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [minAndMaxDateToExtend, setMinAndMaxDateToExtend] = (0, $hopDi$useState)({
        minDate: new Date(),
        maxDate: new Date(new Date().setFullYear(new Date(certificationStartDate).getFullYear() + 1))
    });
    (0, $hopDi$useEffect)(()=>{
        if (bulkActionEndDate?.id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.id && Number(ConditionallyCertifyInDaysLimit) !== 0) {
            const certStartDate = new Date(certificationStartDate);
            let getAllowedMaxDays;
            if (Number(ConditionallyCertifyInDaysLimit) > 1) getAllowedMaxDays = Number(ConditionallyCertifyInDaysLimit) - 1;
            else getAllowedMaxDays = 0;
            const maxDate = new Date(certStartDate.setDate(certStartDate.getDate() + getAllowedMaxDays));
            setMinAndMaxDateToExtend((prevDateConfig)=>({
                    ...prevDateConfig,
                    maxDate: maxDate
                }));
        }
        if (bulkActionEndDate?.id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.id && Number(ExtendEndDateDaysLimit) !== 0) {
            const certStartDate = new Date(certificationStartDate);
            let getAllowedMaxDays;
            if (Number(ExtendEndDateDaysLimit) > 1) getAllowedMaxDays = Number(ExtendEndDateDaysLimit) - 1;
            else getAllowedMaxDays = 0;
            const maxDate = new Date(certStartDate.setDate(certStartDate.getDate() + getAllowedMaxDays));
            setMinAndMaxDateToExtend((prevDateConfig)=>({
                    ...prevDateConfig,
                    maxDate: maxDate
                }));
        }
    }, [
        bulkActionEndDate?.isOpen,
        certificationStartDate,
        ConditionallyCertifyInDaysLimit,
        ExtendEndDateDaysLimit
    ]);
    const handleCommentDescription = (text)=>{
        setBulkActionEndDate((prev)=>({
                ...prev,
                comment: text
            }));
    };
    const handleBulkActionDate = (date)=>{
        setBulkActionEndDate((prev)=>({
                ...prev,
                endDate: date ? new Date(date) : null
            }));
    };
    const handleHasAgreedChange = ()=>{
        setBulkActionEndDate((prev)=>({
                ...prev,
                hasAgreed: !prev.hasAgreed
            }));
    };
    const isAlertVisible = Boolean(bulkActionEndDate?.showAlert && !bulkActionEndDate?.isSubmitting);
    const commonBodyClass = (0, $hopDi$classnames)("BulkActionEndDateBody", isAlertVisible && "BulkActionEndDateBody-alertBox--1");
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                colorTheme: "Critical",
                title: "Required fields are missing.",
                description: "",
                isVisible: bulkActionEndDate?.showAlert && !bulkActionEndDate?.isSubmitting,
                isColonVisible: false,
                onCancel: handleCloseBukActionEndDateAlert,
                isFloating: true,
                position: {
                    type: "absolute",
                    top: "0"
                }
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: commonBodyClass,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$DateAndTimePicker), {
                        label: "New End Date",
                        isRequired: true,
                        isDisabled: bulkActionEndDate?.isSubmitting,
                        isCritical: bulkActionEndDate?.showAlert && !bulkActionEndDate?.endDate,
                        setIsCritical: ()=>{},
                        CriticalHelperText: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                            kind: "missingRequiredField",
                            size: "small"
                        }),
                        isOverflowVisible: true,
                        startDate: bulkActionEndDate?.endDate,
                        setStartDate: handleBulkActionDate,
                        maxDate: minAndMaxDateToExtend?.maxDate,
                        minDate: minAndMaxDateToExtend?.minDate
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
                        defaultComments: bulkPredefinedComments,
                        isDisabled: bulkActionEndDate?.isSubmitting,
                        showAlert: bulkActionEndDate?.showAlert && bulkActionEndDate?.comment?.replace(/^\s+|\s+$/gm, "")?.length <= (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673),
                        onChange: handleCommentDescription,
                        clearModal: bulkActionEndDate?.isOpen
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                        className: "BulkActionsBody-checkBoxDiv",
                        children: [
                            !bulkActionEndDate?.hasAgreed && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: bulkActionEndDate?.showAlert ? "Required" : "RequiredInactive",
                                size: "medium",
                                className: "BulkActionsBody-checkBoxDivIcon"
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                name: "checkbox-error",
                                kind: "text",
                                dataTestId: "checkbox-error",
                                isDisabled: bulkActionEndDate?.isSubmitting,
                                isChecked: bulkActionEndDate?.hasAgreed,
                                onChange: handleHasAgreedChange,
                                label: "I confirm I have reviewed all items",
                                textPosition: "after",
                                error: bulkActionEndDate?.showAlert && !bulkActionEndDate?.hasAgreed ? "This required field is incomplete" : ""
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$cc57f9b16605cf67$var$BulkActionEndDateBody.propTypes = {
    bulkActionEndDate: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$db8acaaade8984f5)).isRequired,
    setBulkActionEndDate: (0, $hopDi$proptypes).func.isRequired,
    handleCloseBukActionEndDateAlert: (0, $hopDi$proptypes).func.isRequired,
    bulkPredefinedComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string)
};
$cc57f9b16605cf67$var$BulkActionEndDateBody.defaultProps = {
    bulkPredefinedComments: []
};
var $cc57f9b16605cf67$export$2e2bcd8739ae039 = $cc57f9b16605cf67$var$BulkActionEndDateBody;








function $9bd3afd823315743$var$BulkActionEndDateFooter({ handleEndDate: handleEndDate, bulkActionEndDate: bulkActionEndDate, handleCloseBulkActionEndDate: handleCloseBulkActionEndDate }) {
    const submitBtnKind = bulkActionEndDate?.isSubmitting || bulkActionEndDate?.comment?.replace(/^\s+|\s+$/gm, "")?.length > (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673) && bulkActionEndDate?.endDate && bulkActionEndDate?.hasAgreed ? "filled" : "outlined";
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
        size: "large",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "BulkActionEndDateFooter-footerButtonWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        isDisabled: bulkActionEndDate?.isSubmitting,
                        onClick: handleCloseBulkActionEndDate,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        className: "BulkActionEndDateFooter-submitButton",
                        type: "button",
                        kind: submitBtnKind,
                        size: "medium",
                        onClick: ()=>handleEndDate(bulkActionEndDate?.id, bulkActionEndDate?.status, bulkActionEndDate?.endDate, bulkActionEndDate?.comment),
                        isDisabled: bulkActionEndDate?.isSubmitting,
                        isLoading: bulkActionEndDate?.isSubmitting,
                        loaderText: "Save",
                        children: "Save"
                    })
                ]
            })
        ]
    });
}
$9bd3afd823315743$var$BulkActionEndDateFooter.propTypes = {
    handleEndDate: (0, $hopDi$proptypes).func.isRequired,
    bulkActionEndDate: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$db8acaaade8984f5)).isRequired,
    handleCloseBulkActionEndDate: (0, $hopDi$proptypes).func.isRequired
};
var $9bd3afd823315743$export$2e2bcd8739ae039 = $9bd3afd823315743$var$BulkActionEndDateFooter;




function $618222aa88ea6d7b$var$BulkActionEndDateHeader({ id: id, bulkFooterStats: bulkFooterStats }) {
    const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
    const buttonObjectsForTotal = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal;
    const headerCount = buttonObjectsForTotal?.reduce((total, item)=>{
        if (bulkFooterStats[item]) return total + bulkFooterStats[item];
        return total;
    }, 0);
    return `Change ${headerCount} Item${headerCount > 1 ? "s'" : "'s"} End Date?`;
}
$618222aa88ea6d7b$var$BulkActionEndDateHeader.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    bulkFooterStats: (0, $hopDi$proptypes).shape({})
};
$618222aa88ea6d7b$var$BulkActionEndDateHeader.defaultProps = {
    bulkFooterStats: {}
};
var $618222aa88ea6d7b$export$2e2bcd8739ae039 = $618222aa88ea6d7b$var$BulkActionEndDateHeader;





function $4fe988978e7de8a4$var$BulkActionEndDateSubTitle({ id: id, bulkFooterStats: bulkFooterStats }) {
    const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
    const buttonObjectsForTotal = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal;
    const tempSubtitleText = buttonObjectsForTotal?.filter((key)=>bulkFooterStats[key] > 0).map((key)=>`${bulkFooterStats[key]} ${(0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)[key]}${bulkFooterStats[key] > 1 ? "s" : ""}`);
    if (!tempSubtitleText) return "";
    if (tempSubtitleText?.length === 0) return "You've selected nothing.";
    if (tempSubtitleText?.length === 1) {
        if (!bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f]) return `You've selected ${tempSubtitleText[0]}. ${0, $2b140e2c3a1e16f8$export$80bc303d21b948cd} ${0, $f16755d1eb7f7f9c$export$bddfa2559af63e14}`;
        return `You've selected ${tempSubtitleText[0]}. ${0, $2b140e2c3a1e16f8$export$80bc303d21b948cd}`;
    }
    const subtitle = tempSubtitleText.slice(0, tempSubtitleText.length - 1).join(", ");
    if (!bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f]) return `You've selected ${subtitle} and ${tempSubtitleText[tempSubtitleText.length - 1]}. ${0, $2b140e2c3a1e16f8$export$80bc303d21b948cd} ${0, $f16755d1eb7f7f9c$export$bddfa2559af63e14}`;
    return `You've selected ${subtitle} and ${tempSubtitleText[tempSubtitleText.length - 1]}. ${0, $2b140e2c3a1e16f8$export$80bc303d21b948cd}`;
}
$4fe988978e7de8a4$var$BulkActionEndDateSubTitle.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    bulkFooterStats: (0, $hopDi$proptypes).shape({})
};
$4fe988978e7de8a4$var$BulkActionEndDateSubTitle.defaultProps = {
    bulkFooterStats: {}
};
var $4fe988978e7de8a4$export$2e2bcd8739ae039 = $4fe988978e7de8a4$var$BulkActionEndDateSubTitle;



function $3b998eb963bb3102$var$BulkActionEndDate({ bulkFooterStats: bulkFooterStats, bulkActionEndDate: bulkActionEndDate, setBulkActionEndDate: setBulkActionEndDate, handleEndDate: handleEndDate, bulkPredefinedComments: bulkPredefinedComments, isMobileXlargeWidth: isMobileXlargeWidth }) {
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = (0, $hopDi$useState)(false);
    const handleCloseBulkActionEndDate = ()=>{
        setBulkActionEndDate((prev)=>({
                ...prev,
                isOpen: false,
                hasAgreed: false,
                endDate: null,
                comment: ""
            }));
    };
    const handleCloseBukActionEndDateAlert = ()=>{
        setBulkActionEndDate((prev)=>({
                ...prev,
                showAlert: false
            }));
    };
    const bulkActionApproveModal = (0, $hopDi$classnames)("BulkActionEndDateModal");
    (0, $hopDi$useEffect)(()=>{
        if (!isMobileDrawerOpen && isMobileXlargeWidth) handleCloseBulkActionEndDate();
    }, [
        isMobileDrawerOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        setIsMobileDrawerOpen(bulkActionEndDate?.isOpen);
    }, [
        bulkActionEndDate?.isOpen
    ]);
    if (isMobileXlargeWidth && isMobileDrawerOpen) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
        className: "BulkActionEndDate-mobileDrawer",
        isOpen: isMobileDrawerOpen,
        fixedHeight: 32,
        setIsOpen: setIsMobileDrawerOpen,
        headerContent: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ModalIsland-headerWrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ModalIsland-header ModalIsland-header--hasSubtitle ModalIsland-header--hasIcon",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "AlertWarningFilledSeparateColors",
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ModalIsland-titleContainer",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    className: "ModalIsland-title",
                                    kind: "h2",
                                    desktop: "h2-d",
                                    mobile: "h2-d",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $618222aa88ea6d7b$export$2e2bcd8739ae039), {
                                        id: bulkActionEndDate?.id,
                                        bulkFooterStats: bulkFooterStats
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    className: "ModalIsland-subtitle",
                                    kind: "body2",
                                    desktop: "body2-d",
                                    mobile: "body2-d",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $4fe988978e7de8a4$export$2e2bcd8739ae039), {
                                        id: bulkActionEndDate?.id,
                                        bulkFooterStats: bulkFooterStats
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "ModalIsland-closeBtn",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: ()=>setIsMobileDrawerOpen(false)
                    })
                })
            ]
        }),
        content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $cc57f9b16605cf67$export$2e2bcd8739ae039), {
            bulkActionEndDate: bulkActionEndDate,
            setBulkActionEndDate: setBulkActionEndDate,
            handleCloseBukActionEndDateAlert: handleCloseBukActionEndDateAlert,
            bulkPredefinedComments: bulkPredefinedComments
        }),
        footerActionBar: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9bd3afd823315743$export$2e2bcd8739ae039), {
            handleEndDate: handleEndDate,
            bulkActionEndDate: bulkActionEndDate,
            handleCloseBulkActionEndDate: handleCloseBulkActionEndDate
        })
    });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: bulkActionApproveModal,
        onClose: bulkActionEndDate?.isSubmitting ? ()=>{} : handleCloseBulkActionEndDate,
        isOverflowVisible: true,
        isOpen: bulkActionEndDate?.isOpen,
        headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "AlertWarningFilledSeparateColors",
            size: "large"
        }),
        title: /*#__PURE__*/ (0, $hopDi$jsx)((0, $618222aa88ea6d7b$export$2e2bcd8739ae039), {
            id: bulkActionEndDate?.id,
            bulkFooterStats: bulkFooterStats
        }),
        subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $4fe988978e7de8a4$export$2e2bcd8739ae039), {
            id: bulkActionEndDate?.id,
            bulkFooterStats: bulkFooterStats
        }),
        contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $cc57f9b16605cf67$export$2e2bcd8739ae039), {
            bulkActionEndDate: bulkActionEndDate,
            setBulkActionEndDate: setBulkActionEndDate,
            handleCloseBukActionEndDateAlert: handleCloseBukActionEndDateAlert,
            bulkPredefinedComments: bulkPredefinedComments
        }),
        FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $9bd3afd823315743$export$2e2bcd8739ae039), {
            handleEndDate: handleEndDate,
            bulkActionEndDate: bulkActionEndDate,
            handleCloseBulkActionEndDate: handleCloseBulkActionEndDate
        })
    });
}
$3b998eb963bb3102$var$BulkActionEndDate.propTypes = {
    bulkFooterStats: (0, $hopDi$proptypes).shape({}),
    bulkActionEndDate: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$db8acaaade8984f5)).isRequired,
    setBulkActionEndDate: (0, $hopDi$proptypes).func.isRequired,
    handleEndDate: (0, $hopDi$proptypes).func.isRequired,
    bulkPredefinedComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool
};
$3b998eb963bb3102$var$BulkActionEndDate.defaultProps = {
    bulkFooterStats: {},
    bulkPredefinedComments: [],
    isMobileXlargeWidth: false
};
var $3b998eb963bb3102$export$2e2bcd8739ae039 = $3b998eb963bb3102$var$BulkActionEndDate;


var $1f495251564d3706$export$2e2bcd8739ae039 = (0, $3b998eb963bb3102$export$2e2bcd8739ae039);










/* eslint-disable indent */ 













function $ab7d664fb3b7e44a$var$BulkActionReassignList({ isSkipCertifier: isSkipCertifier, isSubmitting: isSubmitting, isCritical: isCritical, bulkActionReassign: bulkActionReassign, setBulkActionReassign: setBulkActionReassign, certKey: certKey, showDefaultCertifier: showDefaultCertifier, defaultReassignee: defaultReassignee, defaultAssigneName: defaultAssigneName, certifierUserKey: certifierUserKey }) {
    const handleAssigneeChange = (selectedOption)=>{
        let reassignToName = "";
        if (selectedOption?.username?.trim()?.length !== 0) reassignToName = selectedOption?.username;
        else reassignToName = `${selectedOption?.firstname} ${selectedOption?.lastname}`;
        setBulkActionReassign((prev)=>({
                ...prev,
                reassignTo: selectedOption?.value || "",
                reassignToName: reassignToName
            }));
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $2c1f4f91a862faa4$export$2e2bcd8739ae039), {
        defaultReassignee: defaultReassignee,
        defaultAssigneName: defaultAssigneName,
        onSelect: handleAssigneeChange,
        isCritical: isCritical,
        isDisabled: isSkipCertifier || bulkActionReassign?.isSkipCertifier || isSubmitting,
        selectedUser: bulkActionReassign?.reassignTo?.trim()?.length !== 0,
        certifierUserKey: certifierUserKey,
        certKey: certKey,
        showDefaultCertifier: showDefaultCertifier,
        placeholder: "Select a known or default reassignee"
    });
}
$ab7d664fb3b7e44a$var$BulkActionReassignList.propTypes = {
    isSkipCertifier: (0, $hopDi$proptypes).bool.isRequired,
    isSubmitting: (0, $hopDi$proptypes).bool.isRequired,
    isCritical: (0, $hopDi$proptypes).bool.isRequired,
    bulkActionReassign: (0, $hopDi$proptypes).shape({
        reassignTo: (0, $hopDi$proptypes).string,
        isSkipCertifier: (0, $hopDi$proptypes).bool
    }).isRequired,
    setBulkActionReassign: (0, $hopDi$proptypes).func.isRequired,
    certKey: (0, $hopDi$proptypes).string.isRequired,
    showDefaultCertifier: (0, $hopDi$proptypes).bool.isRequired,
    defaultReassignee: (0, $hopDi$proptypes).string.isRequired,
    defaultAssigneName: (0, $hopDi$proptypes).string.isRequired,
    certifierUserKey: (0, $hopDi$proptypes).string.isRequired
};
var $ab7d664fb3b7e44a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $hopDi$react).memo($ab7d664fb3b7e44a$var$BulkActionReassignList);



const $7d4a5b0679a9a9ce$export$5c8808901c0af416 = {
    totalUsers: {
        icon: "UserNoBg",
        title: "User"
    },
    totalAccounts: {
        icon: "Account",
        title: "Account"
    },
    totalRoles: {
        icon: "Role",
        title: "Role"
    },
    totalEntitlements: {
        icon: "Entitlement",
        title: "Entitlement"
    }
};
const $7d4a5b0679a9a9ce$export$de8ddb069f3c25b1 = "";


function $b6ae4be4af13f3da$var$BulkActionReassignBody({ bulkFooterStats: bulkFooterStats, bulkActionReassign: bulkActionReassign, setBulkActionReassign: setBulkActionReassign, handleCloseBulkActionReassign: handleCloseBulkActionReassign, handleCloseBukActionReassignAlert: handleCloseBukActionReassignAlert, bulkPredefinedComments: bulkPredefinedComments }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const { certKey: certKey, consultActionAssignee: consultActionAssignee, reassignConfigMap: reassignConfigMap, reviewAndSubmit: reviewAndSubmit } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const isReassignActionAssigneeLoading = Boolean(consultActionAssignee?.isLoading);
    const isReassignActionAssigneeError = Boolean(consultActionAssignee?.errorMessage?.error !== undefined && consultActionAssignee?.errorMessage?.error !== null && consultActionAssignee?.errorMessage?.error?.trim()?.length !== 0);
    const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[bulkActionReassign?.id];
    const reassignObjectKeys = Object?.keys(bulkFooterStats).filter((value)=>(0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal.includes(value));
    const shouldConvertToReassign = Boolean(reviewAndSubmit?.primaryCertifier && (reassignConfigMap?.enableReassignUser === "1" || reassignConfigMap?.showReassignPopup === "1"));
    (0, $hopDi$useEffect)(()=>{
        if (bulkActionReassign?.isOpen) dispatch((0, $d623f23401a154f0$export$b839edba12a89f4d)(false));
    }, [
        bulkActionReassign?.isOpen
    ]);
    const handleSkipCertifierChange = ()=>{
        setBulkActionReassign((prev)=>({
                ...prev,
                isSkipCertifier: !prev.isSkipCertifier
            }));
    };
    const handleCommentDescription = (text)=>{
        setBulkActionReassign((prev)=>({
                ...prev,
                comment: text
            }));
    };
    const handleHasAgreedChange = ()=>{
        setBulkActionReassign((prev)=>({
                ...prev,
                hasAgreed: !prev.hasAgreed
            }));
    };
    const renderReassignActionBody = ()=>{
        if (isReassignActionAssigneeLoading) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "BulkActionReassignBody-loaderWrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                kind: "dots",
                format: "inline",
                color: "brand",
                size: "large",
                className: "BulkActionReassignBody-loader"
            })
        });
        if (isReassignActionAssigneeError) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "AccessRequestHistoryBody-wrapper",
            children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "ReviewAndSubmitModal-bodyError",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h2",
                        children: "Couldn't Load"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: "The Modal didn't load properly due to a network issue. Please refresh or try again later."
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "ReviewAndSubmitModal-bodyErrorButtons",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            type: "button",
                            kind: "ghost",
                            size: "medium",
                            onClick: handleCloseBulkActionReassign,
                            children: "Close"
                        })
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "BulkActionReassignBody-stats",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            kind: "label",
                            className: "BulkActionReassignBody-statsHeading",
                            children: [
                                bulkActionReassign?.id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.DOES_NOT_WORK_FOR_ME.id ? "Selected Users" : "Selected Items",
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                    openDelay: 500,
                                    text: bulkActionReassign?.id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.DOES_NOT_WORK_FOR_ME.id ? `Access items associated with ${bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f] > 1 ? "these users" : "this user"} are included.` : "Dependent parent will be approved.",
                                    maxWidth: "20rem",
                                    placement: "right",
                                    offset: 8,
                                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "Info",
                                        color: "info-700",
                                        size: "small",
                                        className: "BulkActionReassignBody-statsHeadingIcon"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "BulkActionReassignBody-statsObjects",
                            children: reassignObjectKeys?.map((key)=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                                    kind: "body2",
                                    className: "BulkActionReassignBody-statsContent",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: (0, $7d4a5b0679a9a9ce$export$5c8808901c0af416)?.[key].icon,
                                            size: "medium"
                                        }),
                                        `${bulkFooterStats?.[key]} ${(0, $7d4a5b0679a9a9ce$export$5c8808901c0af416)?.[key].title}${bulkFooterStats?.[key] > 1 ? "s" : ""}`
                                    ]
                                }, key))
                        })
                    ]
                }),
                shouldConvertToReassign && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    tag: "div",
                    className: "BulkActionReassignBody-assigneeBox",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                            kind: "label",
                            className: "BulkActionReassignBody-statsHeading",
                            children: [
                                bulkActionReassign?.reassignTo.length === 0 && !bulkActionReassign?.isSkipCertifier && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: bulkActionReassign?.showAlert && bulkActionReassign?.reassignTo.length === 0 ? "Required" : "RequiredInactive",
                                    size: "medium",
                                    className: "BulkActionReassignBody-assigneeBoxIcon"
                                }),
                                "Select Certifier"
                            ]
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $ab7d664fb3b7e44a$export$2e2bcd8739ae039), {
                            bulkActionReassign: bulkActionReassign,
                            setBulkActionReassign: setBulkActionReassign,
                            isCritical: !bulkActionReassign?.isSkipCertifier && bulkActionReassign?.reassignTo === "" && bulkActionReassign?.showAlert,
                            certKey: certKey,
                            showDefaultCertifier: reviewAndSubmit?.primaryCertifier,
                            defaultReassignee: reassignConfigMap?.defaultReassignee,
                            defaultAssigneName: reassignConfigMap?.defaultReassigneeName,
                            certifierUserKey: reassignConfigMap?.certifierUserKey
                        }),
                        bulkActionReassign?.id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id && reassignConfigMap?.defaultReassignee?.length === 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                            name: "simpleText",
                            kind: "simpleText",
                            dataTestId: "simpleText",
                            className: "BulkActionReassignBody-assigneeBoxSkipCheckbox",
                            isDisabled: bulkActionReassign?.reassignTo?.length > 0 || bulkActionReassign?.isSubmitting,
                            isChecked: bulkActionReassign?.isSkipCertifier,
                            onChange: handleSkipCertifierChange,
                            label: "Skip selecting certifier",
                            textPosition: "after",
                            showHoverEffect: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $2515ed647c64b6ee$export$2e2bcd8739ae039), {
                    defaultComments: bulkPredefinedComments,
                    isDisabled: bulkActionReassign?.isSubmitting,
                    showAlert: bulkActionReassign?.showAlert && bulkActionReassign?.comment?.replace(/^\s+|\s+$/gm, "")?.length <= (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673),
                    onChange: handleCommentDescription,
                    clearModal: bulkActionReassign?.isOpen
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "BulkActionsBody-checkBoxDiv",
                    children: [
                        !bulkActionReassign?.hasAgreed && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: bulkActionReassign?.showAlert ? "Required" : "RequiredInactive",
                            size: "medium",
                            className: "BulkActionsBody-checkBoxDivIcon"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                            name: "checkbox-error",
                            kind: "text",
                            dataTestId: "checkbox-error",
                            isDisabled: bulkActionReassign?.isSubmitting,
                            isChecked: bulkActionReassign?.hasAgreed,
                            onChange: handleHasAgreedChange,
                            label: "I confirm I have reviewed all items",
                            textPosition: "after",
                            error: bulkActionReassign?.showAlert && !bulkActionReassign?.hasAgreed ? "This required field is incomplete" : ""
                        })
                    ]
                })
            ]
        });
    };
    const isAlertVisible = Boolean(bulkActionReassign?.showAlert && !bulkActionReassign?.isSubmitting);
    const commonBodyClass = (0, $hopDi$classnames)("BulkActionReassignBody", isAlertVisible && "BulkActionReassignBody-alertBox--1");
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBanner), {
                colorTheme: "Critical",
                title: "Required fields are missing.",
                description: "",
                isVisible: bulkActionReassign?.showAlert && !bulkActionReassign?.isSubmitting,
                isColonVisible: false,
                onCancel: handleCloseBukActionReassignAlert,
                isFloating: true,
                position: {
                    type: "absolute",
                    top: "0"
                }
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: commonBodyClass,
                children: renderReassignActionBody()
            })
        ]
    });
}
$b6ae4be4af13f3da$var$BulkActionReassignBody.propTypes = {
    bulkFooterStats: (0, $hopDi$proptypes).shape({}),
    bulkActionReassign: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$1d9c6f295a272fc0)).isRequired,
    setBulkActionReassign: (0, $hopDi$proptypes).func.isRequired,
    handleCloseBulkActionReassign: (0, $hopDi$proptypes).func.isRequired,
    handleCloseBukActionReassignAlert: (0, $hopDi$proptypes).func,
    bulkPredefinedComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string)
};
$b6ae4be4af13f3da$var$BulkActionReassignBody.defaultProps = {
    bulkFooterStats: {},
    handleCloseBukActionReassignAlert: ()=>{},
    bulkPredefinedComments: []
};
var $b6ae4be4af13f3da$export$2e2bcd8739ae039 = $b6ae4be4af13f3da$var$BulkActionReassignBody;








function $b3aa5137eaa9e49b$var$BulkActionReassignFooter({ handleReassign: handleReassign, bulkActionReassign: bulkActionReassign, handleCloseBulkActionReassign: handleCloseBulkActionReassign }) {
    const submitBtnKind = bulkActionReassign?.isSubmitting || bulkActionReassign?.comment?.replace(/^\s+|\s+$/gm, "")?.length > (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673) && bulkActionReassign?.hasAgreed ? "filled" : "outlined";
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$FooterActionBar), {
        size: "large",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {}),
            /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "BulkActionReassignFooter-footerButtonWrap",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "ghost",
                        size: "medium",
                        isDisabled: bulkActionReassign?.isSubmitting,
                        onClick: handleCloseBulkActionReassign,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        className: "BulkActionReassignFooter-submitButton",
                        type: "button",
                        kind: submitBtnKind,
                        size: "medium",
                        onClick: ()=>handleReassign(bulkActionReassign?.id, bulkActionReassign?.reassignTo, bulkActionReassign?.reassignAssociated, bulkActionReassign?.comment, bulkActionReassign?.reassignToName),
                        isDisabled: bulkActionReassign?.isSubmitting,
                        isLoading: bulkActionReassign?.isSubmitting,
                        loaderText: "Submit",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
}
$b3aa5137eaa9e49b$var$BulkActionReassignFooter.propTypes = {
    handleReassign: (0, $hopDi$proptypes).func.isRequired,
    bulkActionReassign: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$1d9c6f295a272fc0)).isRequired,
    handleCloseBulkActionReassign: (0, $hopDi$proptypes).func.isRequired
};
var $b3aa5137eaa9e49b$export$2e2bcd8739ae039 = $b3aa5137eaa9e49b$var$BulkActionReassignFooter;




function $f4d6302e83cf8a1a$var$BulkActionReassignHeader({ id: id, bulkFooterStats: bulkFooterStats }) {
    const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
    const buttonObjectsForTotal = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal;
    const count = buttonObjectsForTotal?.reduce((total, item)=>{
        if (bulkFooterStats[item]) return total + bulkFooterStats[item];
        return total;
    }, 0);
    return `Reassign ${count} ${id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id ? "User" : "Item"}${count > 1 ? "s" : ""}?`;
}
$f4d6302e83cf8a1a$var$BulkActionReassignHeader.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    bulkFooterStats: (0, $hopDi$proptypes).shape({})
};
$f4d6302e83cf8a1a$var$BulkActionReassignHeader.defaultProps = {
    bulkFooterStats: {}
};
var $f4d6302e83cf8a1a$export$2e2bcd8739ae039 = $f4d6302e83cf8a1a$var$BulkActionReassignHeader;




function $931239ba94ac005e$var$BulkActionReassignSubTitle({ id: id, bulkFooterStats: bulkFooterStats }) {
    if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.id) {
        const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
        const buttonObjectsForTotal = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey]?.objectsToTotal;
        const tempSubtitleTextEdit = buttonObjectsForTotal?.filter((key)=>bulkFooterStats[key] > 0).map((key)=>`${bulkFooterStats[key]} ${(0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)[key]}${bulkFooterStats[key] > 1 ? "s" : ""}`);
        if (tempSubtitleTextEdit.length === 0) return "You have selected nothing!";
        if (tempSubtitleTextEdit.length === 1) return `You are confirming that you are NOT the Certifier for ${tempSubtitleTextEdit[0]}.`;
        const firstText = tempSubtitleTextEdit.slice(0, tempSubtitleTextEdit.length - 1).join(", ");
        return `You are confirming that you are NOT the Certifier for ${firstText} and ${tempSubtitleTextEdit[tempSubtitleTextEdit.length - 1]}.`;
    }
    const count = bulkFooterStats?.[0, $f16755d1eb7f7f9c$export$d15bf6606d7c003f];
    return `You are confirming that you are NOT the Certifier for ${count} User${count > 1 ? "s" : ""}.`;
}
$931239ba94ac005e$var$BulkActionReassignSubTitle.propTypes = {
    id: (0, $hopDi$proptypes).string.isRequired,
    bulkFooterStats: (0, $hopDi$proptypes).shape({})
};
$931239ba94ac005e$var$BulkActionReassignSubTitle.defaultProps = {
    bulkFooterStats: {}
};
var $931239ba94ac005e$export$2e2bcd8739ae039 = $931239ba94ac005e$var$BulkActionReassignSubTitle;




function $0238dd1ebca3c9ce$var$BulkActionReassign({ bulkFooterStats: bulkFooterStats, bulkActionReassign: bulkActionReassign, setBulkActionReassign: setBulkActionReassign, handleReassign: handleReassign, bulkPredefinedComments: bulkPredefinedComments, isMobileXlargeWidth: isMobileXlargeWidth }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = (0, $hopDi$useState)(false);
    const handleCloseBulkActionReassign = ()=>{
        setTimeout(()=>{
            dispatch((0, $d623f23401a154f0$export$b839edba12a89f4d)(true));
        }, (0, $f16755d1eb7f7f9c$export$cc844e58ea5510e9));
        setBulkActionReassign((prev)=>({
                ...prev,
                isOpen: false,
                hasAgreed: false,
                reassignAssociated: false,
                reassignTo: "",
                comment: ""
            }));
    };
    const handleCloseBukActionReassignAlert = ()=>{
        setBulkActionReassign((prev)=>({
                ...prev,
                showAlert: false
            }));
    };
    const bulkActionReassignModal = (0, $hopDi$classnames)("BulkActionReassignModal");
    (0, $hopDi$useEffect)(()=>{
        if (!isMobileDrawerOpen && isMobileXlargeWidth) handleCloseBulkActionReassign();
    }, [
        isMobileDrawerOpen
    ]);
    (0, $hopDi$useEffect)(()=>{
        setIsMobileDrawerOpen(bulkActionReassign?.isOpen);
    }, [
        bulkActionReassign?.isOpen
    ]);
    if (isMobileXlargeWidth && isMobileDrawerOpen) return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
        className: "BulkActionReassign-mobileDrawer",
        isOpen: isMobileDrawerOpen,
        fixedHeight: 32,
        setIsOpen: setIsMobileDrawerOpen,
        headerContent: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: "ModalIsland-headerWrapper",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "ModalIsland-header ModalIsland-header--hasSubtitle ModalIsland-header--hasIcon",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "AlertWarningFilledSeparateColors",
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "ModalIsland-titleContainer",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    className: "ModalIsland-title",
                                    kind: "h2",
                                    desktop: "h2-d",
                                    mobile: "h2-d",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $f4d6302e83cf8a1a$export$2e2bcd8739ae039), {
                                        id: bulkActionReassign?.id,
                                        bulkFooterStats: bulkFooterStats
                                    })
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    className: "ModalIsland-subtitle",
                                    kind: "body2",
                                    desktop: "body2-d",
                                    mobile: "body2-d",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $931239ba94ac005e$export$2e2bcd8739ae039), {
                                        id: bulkActionReassign?.id,
                                        bulkFooterStats: bulkFooterStats
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "ModalIsland-closeBtn",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        size: "medium",
                        kind: "ghost",
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "close",
                            color: "neutral-100",
                            size: "smallMedium"
                        }),
                        onClick: ()=>setIsMobileDrawerOpen(false)
                    })
                })
            ]
        }),
        content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $b6ae4be4af13f3da$export$2e2bcd8739ae039), {
            bulkFooterStats: bulkFooterStats,
            bulkActionReassign: bulkActionReassign,
            setBulkActionReassign: setBulkActionReassign,
            handleCloseBulkActionReassign: handleCloseBulkActionReassign,
            handleCloseBukActionReassignAlert: handleCloseBukActionReassignAlert,
            bulkPredefinedComments: bulkPredefinedComments
        }),
        footerActionBar: /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3aa5137eaa9e49b$export$2e2bcd8739ae039), {
            handleReassign: handleReassign,
            bulkActionReassign: bulkActionReassign,
            handleCloseBulkActionReassign: handleCloseBulkActionReassign
        })
    });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        className: bulkActionReassignModal,
        onClose: bulkActionReassign?.isSubmitting ? ()=>{} : handleCloseBulkActionReassign,
        isOpen: bulkActionReassign?.isOpen,
        headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "AlertWarningFilledSeparateColors",
            size: "large"
        }),
        title: /*#__PURE__*/ (0, $hopDi$jsx)((0, $f4d6302e83cf8a1a$export$2e2bcd8739ae039), {
            id: bulkActionReassign?.id,
            bulkFooterStats: bulkFooterStats
        }),
        subtitle: /*#__PURE__*/ (0, $hopDi$jsx)((0, $931239ba94ac005e$export$2e2bcd8739ae039), {
            id: bulkActionReassign?.id,
            bulkFooterStats: bulkFooterStats
        }),
        contentBody: /*#__PURE__*/ (0, $hopDi$jsx)((0, $b6ae4be4af13f3da$export$2e2bcd8739ae039), {
            bulkFooterStats: bulkFooterStats,
            bulkActionReassign: bulkActionReassign,
            setBulkActionReassign: setBulkActionReassign,
            handleCloseBulkActionReassign: handleCloseBulkActionReassign,
            handleCloseBukActionReassignAlert: handleCloseBukActionReassignAlert,
            bulkPredefinedComments: bulkPredefinedComments
        }),
        FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $b3aa5137eaa9e49b$export$2e2bcd8739ae039), {
            handleReassign: handleReassign,
            bulkActionReassign: bulkActionReassign,
            handleCloseBulkActionReassign: handleCloseBulkActionReassign
        })
    });
}
$0238dd1ebca3c9ce$var$BulkActionReassign.propTypes = {
    bulkFooterStats: (0, $hopDi$proptypes).shape({}),
    bulkActionReassign: (0, $hopDi$proptypes).shape((0, $2bab42430c1fd2c9$export$1d9c6f295a272fc0)).isRequired,
    setBulkActionReassign: (0, $hopDi$proptypes).func.isRequired,
    handleReassign: (0, $hopDi$proptypes).func.isRequired,
    bulkPredefinedComments: (0, $hopDi$proptypes).arrayOf((0, $hopDi$proptypes).string),
    isMobileXlargeWidth: (0, $hopDi$proptypes).bool
};
$0238dd1ebca3c9ce$var$BulkActionReassign.defaultProps = {
    bulkFooterStats: {},
    bulkPredefinedComments: [],
    isMobileXlargeWidth: false
};
var $0238dd1ebca3c9ce$export$2e2bcd8739ae039 = $0238dd1ebca3c9ce$var$BulkActionReassign;


var $1942586e97c3ba42$export$2e2bcd8739ae039 = (0, $0238dd1ebca3c9ce$export$2e2bcd8739ae039);



const $4ab0c307926279af$var$bulkFooterBtnOrder = [
    "approve",
    "reject",
    "consult"
];
const $4ab0c307926279af$export$1ea61e82efefb42b = (arr)=>arr.sort((a, b)=>{
        const indexA = $4ab0c307926279af$var$bulkFooterBtnOrder.indexOf(a);
        const indexB = $4ab0c307926279af$var$bulkFooterBtnOrder.indexOf(b);
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        return 0;
    });
var $4ab0c307926279af$export$2e2bcd8739ae039 = $4ab0c307926279af$export$1ea61e82efefb42b;



function $2c59e15aa57e4ffa$var$BulkActionFooter() {
    // Modal Common Actions => Approve, Confirm Manager, Reject, Terminate
    const [showKebabActionBtns, setShowKebabActionBtns] = (0, $hopDi$useState)(false);
    const [bulkActionBtnsMap, setBulkActionBtnsMap] = (0, $hopDi$useState)([]);
    const [bulkFooterStats, setBulkFooterStats] = (0, $hopDi$useState)({});
    const [isMobileMoreChecked, setIsMobileMoreChecked] = (0, $hopDi$useState)(false);
    const [countForActionButtonsAsPerScreen, setCountForActionButtonsAsPerScreen] = (0, $hopDi$useState)((0, $f16755d1eb7f7f9c$export$b3276df9d1d6ab62));
    const [bulkActionCommonAction, setBulkActionCommonAction] = (0, $hopDi$useState)((0, $f16755d1eb7f7f9c$export$b40b6afeb65aaac6));
    const [bulkActionEndDate, setBulkActionEndDate] = (0, $hopDi$useState)((0, $f16755d1eb7f7f9c$export$86ece8019817d1d3));
    const [bulkActionConsult, setBulkActionConsult] = (0, $hopDi$useState)((0, $f16755d1eb7f7f9c$export$41b1dc835ddda629));
    const [bulkActionReassign, setBulkActionReassign] = (0, $hopDi$useState)((0, $f16755d1eb7f7f9c$export$434d0b2252a6f73d));
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, certKey: certKey, bulkAction: bulkAction, globalDateFormat: globalDateFormat, reassignConfigMap: reassignConfigMap, reviewAndSubmit: reviewAndSubmit, isSidePanelVisible: isSidePanelVisible, predefinedComments: predefinedComments, isLoading: isLoading, columnNames: columnNames, searchText: searchText } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const [bulkPredefinedComments, setBulkPredefinedComments] = (0, $hopDi$useState)([]);
    const mobileLargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileLargeQuery.value <= mediaQueryValue;
    const wrapperClass = (0, $hopDi$classnames)("BulkActionFooter-wrapper", isMobileXlargeWidth && !isMobileMoreChecked && bulkAction?.isBulkFooterVisible && bulkActionBtnsMap?.length > 0 && "BulkActionFooter-wrapper--mobileMode1", isMobileXlargeWidth && isMobileMoreChecked && bulkAction?.isBulkFooterVisible && bulkActionBtnsMap?.length < 8 && // We can keep this without constant here as we will not have count of actions more than 8
    "BulkActionFooter-wrapper--mobileMode2", isMobileXlargeWidth && isMobileMoreChecked && bulkAction?.isBulkFooterVisible && bulkActionBtnsMap?.length >= 8 && // We can keep this without constant here as we will not have count of actions more than 8
    "BulkActionFooter-wrapper--mobileMode3");
    (0, $hopDi$useEffect)(()=>{
        const validBulkActions = new Set([]);
        if (bulkAction?.bulkFooterInfo?.enableAccountEntRoleActionList) bulkAction.bulkFooterInfo.enableAccountEntRoleActionList.forEach((action)=>validBulkActions.add(action));
        if (bulkAction?.bulkFooterInfo?.enableUserActionList) bulkAction.bulkFooterInfo.enableUserActionList.forEach((action)=>validBulkActions.add(action));
        setBulkActionBtnsMap(Array.from(validBulkActions));
        if (bulkAction?.bulkFooterInfo) {
            const tempBulkFooterStats = {};
            // eslint-disable-next-line no-restricted-syntax
            for(const key in 0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)if (bulkAction?.bulkFooterInfo[key]) tempBulkFooterStats[key] = bulkAction?.bulkFooterInfo[key];
            setBulkFooterStats(tempBulkFooterStats);
            return;
        }
        setCountForActionButtonsAsPerScreen(1);
    }, [
        bulkAction
    ]);
    (0, $hopDi$useEffect)(()=>{
        setBulkActionCommonAction((prev)=>({
                ...prev,
                isSubmitting: bulkAction?.isSubmittingAction
            }));
        setBulkActionEndDate((prev)=>({
                ...prev,
                isSubmitting: bulkAction?.isSubmittingAction
            }));
        setBulkActionConsult((prev)=>({
                ...prev,
                isSubmitting: bulkAction?.isSubmittingAction
            }));
        setBulkActionReassign((prev)=>({
                ...prev,
                isSubmitting: bulkAction?.isSubmittingAction
            }));
    }, [
        bulkAction?.isSubmittingAction
    ]);
    (0, $hopDi$useEffect)(()=>{
        setBulkPredefinedComments(predefinedComments.BULKACTION || []);
    }, [
        predefinedComments
    ]);
    const dropUpWrapperForBulkActionKebab = (0, $hopDi$useRef)("dropUpWrapperForBulkActionKebab");
    const bulkActionBtnBoxRef = (0, $hopDi$useRef)("bulkActionBtnBoxRef");
    (0, $hopDi$useOutsideClickEffect)(dropUpWrapperForBulkActionKebab, ()=>{
        setShowKebabActionBtns(false);
    });
    (0, $hopDi$useEffect)(()=>{
        const handleResize = ()=>{
            const screenWidth = bulkActionBtnBoxRef?.current?.offsetWidth;
            // TO DO @vishnu remove this code after implementing mobile responsiveness
            if (screenWidth < (0, $f16755d1eb7f7f9c$export$b8f309dc6c1508c5)) setCountForActionButtonsAsPerScreen((0, $f16755d1eb7f7f9c$export$273a483dd6b0bbbb));
            else if (screenWidth > (0, $f16755d1eb7f7f9c$export$2d1cfc15057b8a)) setCountForActionButtonsAsPerScreen((0, $f16755d1eb7f7f9c$export$273a483dd6b0bbbb));
            else setCountForActionButtonsAsPerScreen((0, $f16755d1eb7f7f9c$export$273a483dd6b0bbbb));
        };
        if (!bulkAction?.isBulkFooterVisible) setIsMobileMoreChecked(false);
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        bulkAction?.isBulkFooterVisible,
        isSidePanelVisible
    ]);
    const getAlertMessage = (footerStats, id)=>{
        if (typeof footerStats === "object" || Array.isArray(footerStats) || footerStats === null || footerStats === undefined) return "Not able to perform this action.";
        const alertTextArray = [];
        const buttonKey = (0, $f16755d1eb7f7f9c$export$c4642c4b1af79efe)?.[id];
        const buttonMap = (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45)?.[buttonKey];
        buttonMap?.objectsToTotal.forEach((item)=>{
            if (footerStats[item]) alertTextArray.push(`${footerStats[item]} ${(0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)?.[item]}(s)`);
        });
        let midText = "";
        if (alertTextArray.length === 1) // eslint-disable-next-line prefer-destructuring
        midText = alertTextArray[0];
        if (alertTextArray.length > 1) {
            midText = alertTextArray.slice(0, alertTextArray.length - 1).join(", ");
            midText = `${midText} and ${alertTextArray[alertTextArray.length - 1]}`;
        }
        return `The ${buttonMap.text} for ${midText} wasn't successful.`;
    };
    const resetBulkCheckBoxes = ()=>{
        dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
        dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
        dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
        dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
        dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
        dispatch((0, $d623f23401a154f0$export$bb9465329a3d3cad)(null));
        dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(true));
    };
    const resetTabAndItems = ()=>{
        dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(true));
        dispatch((0, $d623f23401a154f0$export$afd1b438af1720fe)(certKey, true));
        dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, 10, 0, searchText));
        dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef), true));
        dispatch((0, $d623f23401a154f0$export$b839edba12a89f4d)(true)); // For Consult and Reassign loading icon on load
    };
    const handleClear = ()=>{
        dispatch((0, $d623f23401a154f0$export$1a295a970dce82de)(true));
        dispatch((0, $d623f23401a154f0$export$c594ad0cf83b2327)(certKey, true)).then(()=>{
            dispatch((0, $d623f23401a154f0$export$d5c4a54b97b3960a)(false));
            dispatch((0, $d623f23401a154f0$export$889241fc0afda8a9)(false));
            dispatch((0, $d623f23401a154f0$export$ebeb2bd8ecd91be9)(false));
            dispatch((0, $d623f23401a154f0$export$2af49e179df91659)(false));
        }).catch((error)=>{
            dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
        });
    };
    // handleCommonAction for below actions
    // const handleApprove = () => {}
    // const handleWorksForMe = () => {};
    // const handleReject = () => {};
    // const handleTerminate = () => {};
    const handleCommonAction = (id, status, comment)=>{
        if (bulkActionCommonAction?.comment?.replace(/^\s+|\s+$/gm, "")?.length <= (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673) || !bulkActionCommonAction?.hasAgreed) {
            setBulkActionCommonAction((prev)=>({
                    ...prev,
                    showAlert: true
                }));
            return;
        }
        setBulkActionCommonAction((prev)=>({
                ...prev,
                showAlert: false
            }));
        const payload = {
            userAction: "1"
        };
        dispatch((0, $d623f23401a154f0$export$c6b81b3f3f151197)(certKey, status, comment, id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id ? payload : {})).then(()=>{
            resetBulkCheckBoxes();
            resetTabAndItems();
        }).catch((error)=>{
            if (error.message && typeof error.message === "string") dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            else dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, getAlertMessage(error, id)));
        }).finally(()=>{
            setBulkActionCommonAction((0, $f16755d1eb7f7f9c$export$b40b6afeb65aaac6));
        });
    };
    // handleEndDate for below actions
    // const handleExtendEndDate = () => {};
    // const handleConditionalyCertify = () => {};
    const handleEndDate = (id, status, date, comment)=>{
        if (bulkActionEndDate?.comment?.replace(/^\s+|\s+$/gm, "")?.length <= (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673) || !bulkActionEndDate?.endDate || !bulkActionEndDate?.hasAgreed) {
            setBulkActionEndDate((prev)=>({
                    ...prev,
                    showAlert: true
                }));
            return;
        }
        setBulkActionEndDate((prev)=>({
                ...prev,
                showAlert: false
            }));
        const conditionallyCertifyEndDate = (0, $hopDi$moment)(date).format("MM-DD-YYYY");
        const extendEndDate = (0, $hopDi$moment)(date).format(globalDateFormat.toUpperCase());
        dispatch((0, $d623f23401a154f0$export$c6b81b3f3f151197)(certKey, status, comment, id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.id ? {
            enddate: conditionallyCertifyEndDate
        } : {
            extendedDate: extendEndDate
        })).then(()=>{
            resetBulkCheckBoxes();
            resetTabAndItems();
        }).catch((error)=>{
            if (error.message && typeof error.message === "string") dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            else dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, getAlertMessage(error, id)));
        }).finally(()=>{
            setBulkActionEndDate((0, $f16755d1eb7f7f9c$export$86ece8019817d1d3));
        });
    };
    // handle reassign action
    // const handleDoesNotWorkForMe = () => {};
    const handleReassign = (id, reassignTo, reassignAssociated, comment, reassignToName = "")=>{
        const shouldConvertToReassign = Boolean(reviewAndSubmit?.primaryCertifier && (reassignConfigMap?.enableReassignUser === "1" || reassignConfigMap?.showReassignPopup === "1"));
        if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.id && (bulkActionReassign?.comment?.replace(/^\s+|\s+$/gm, "")?.length <= (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673) || bulkActionReassign?.reassignTo?.length === 0 || !bulkActionReassign?.hasAgreed)) {
            setBulkActionReassign((prev)=>({
                    ...prev,
                    showAlert: true
                }));
            return;
        }
        if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id && shouldConvertToReassign && bulkActionReassign?.isSkipCertifier && (bulkActionReassign?.comment?.replace(/^\s+|\s+$/gm, "")?.length === 0 || !bulkActionReassign?.hasAgreed)) {
            setBulkActionReassign((prev)=>({
                    ...prev,
                    showAlert: true
                }));
            return;
        }
        if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id && shouldConvertToReassign && !bulkActionReassign?.isSkipCertifier && (bulkActionReassign?.comment?.replace(/^\s+|\s+$/gm, "")?.length === 0 || bulkActionReassign?.reassignTo?.length === 0 || !bulkActionReassign?.hasAgreed)) {
            setBulkActionReassign((prev)=>({
                    ...prev,
                    showAlert: true
                }));
            return;
        }
        if (id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id && !shouldConvertToReassign && (bulkActionReassign?.comment?.replace(/^\s+|\s+$/gm, "")?.length === 0 || !bulkActionReassign?.hasAgreed)) {
            setBulkActionReassign((prev)=>({
                    ...prev,
                    showAlert: true
                }));
            return;
        }
        setBulkActionReassign((prev)=>({
                ...prev,
                showAlert: false
            }));
        if (reassignConfigMap?.enableReassignUser !== "1" && reassignConfigMap?.showReassignPopup !== "1") {
            dispatch((0, $d623f23401a154f0$export$c6b81b3f3f151197)(certKey, (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.status, comment, {
                userAction: "1"
            })).then(()=>{
                resetBulkCheckBoxes();
                resetTabAndItems();
                dispatch((0, $d623f23401a154f0$export$a80194b4790381a6)({
                    title: "Success",
                    description: `Item(s) reassigned to ${reassignToName}`
                }));
            }).catch((error)=>{
                if (error.message && typeof error.message === "string") dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
                else dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, getAlertMessage(error, (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id)));
            }).finally(()=>{
                setBulkActionReassign((0, $f16755d1eb7f7f9c$export$434d0b2252a6f73d));
            });
            return;
        }
        dispatch((0, $d623f23401a154f0$export$1f381a6abe5abb6c)(certKey, reassignTo, comment, id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.id ? "bulkReassign" : "reassign", id === (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.id ? {
            reassignAssociated: reassignAssociated ? "true" : "false",
            enableReassignStep2: reassignConfigMap?.enableReassignStep2
        } : {
            assigneetype: "1",
            cert_userkey: "0",
            cert_entitlement_valuekey: "-4",
            userAction: "1"
        })).then(()=>{
            resetBulkCheckBoxes();
            resetTabAndItems();
            dispatch((0, $d623f23401a154f0$export$a80194b4790381a6)({
                title: "Success",
                description: `Item(s) reassigned to ${reassignToName?.length === 0 ? "default certifier" : reassignToName}`
            }));
        }).catch((error)=>{
            if (error.message && typeof error.message === "string") dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            else dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, getAlertMessage(error, (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id)));
        }).finally(()=>{
            setBulkActionReassign((0, $f16755d1eb7f7f9c$export$434d0b2252a6f73d));
        });
    };
    // handle consult action
    const handleConsult = (reassignAssociated, consultWith, comment, consultWithName = "")=>{
        if (bulkActionConsult?.comment?.replace(/^\s+|\s+$/gm, "")?.length <= (0, $f16755d1eb7f7f9c$export$abd89ed84e8d9673) || bulkActionConsult?.consultWith?.length === 0 || !bulkActionConsult?.hasAgreed) {
            setBulkActionConsult((prev)=>({
                    ...prev,
                    showAlert: true
                }));
            return;
        }
        setBulkActionConsult((prev)=>({
                ...prev,
                showAlert: false
            }));
        dispatch((0, $d623f23401a154f0$export$327928746d63d77e)(certKey, consultWith, comment, reassignAssociated ? "true" : "false")).then(()=>{
            resetBulkCheckBoxes();
            resetTabAndItems();
            dispatch((0, $d623f23401a154f0$export$a80194b4790381a6)({
                title: "Success",
                description: `Item(s) consulted to ${consultWithName?.length === 0 ? "default certifier" : consultWithName}`
            }));
        }).catch((error)=>{
            if (error.message && typeof error.message === "string") dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
            else dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, getAlertMessage(error, (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.id)));
        }).finally(()=>{
            setBulkActionConsult((0, $f16755d1eb7f7f9c$export$41b1dc835ddda629));
        });
    };
    // Modals open
    const handleCommonModalOpen = (id, status)=>{
        setBulkActionCommonAction((prev)=>({
                ...prev,
                isOpen: !prev.isOpen,
                showAlert: false,
                id: id,
                status: status
            }));
        setShowKebabActionBtns(false);
    };
    const handleEndDateModalOpen = (id, status)=>{
        setBulkActionEndDate((prev)=>({
                ...prev,
                isOpen: !prev.isOpen,
                showAlert: false,
                id: id,
                status: status
            }));
        setShowKebabActionBtns(false);
    };
    const handleConsultModalOpen = (id, status)=>{
        setBulkActionConsult((prev)=>({
                ...prev,
                isOpen: !prev.isOpen,
                showAlert: false,
                id: id,
                status: status
            }));
        setShowKebabActionBtns(false);
    };
    const handleReassignModalOpen = (id, status)=>{
        setBulkActionReassign((prev)=>({
                ...prev,
                isOpen: !prev.isOpen,
                showAlert: false,
                id: id,
                status: status
            }));
        setShowKebabActionBtns(false);
    };
    const bulkActionClearBtn = {
        id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.id,
        icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.icon,
        status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.status,
        text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.text,
        objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CLEAR.objectsToTotal,
        kind: "ghost",
        popOverContent: "",
        onClick: handleClear
    };
    const bulkActionButtons = {
        worksForMe: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).WORKS_FOR_ME.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleCommonModalOpen
        },
        doesNotWorksForMe: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).DOES_NOT_WORK_FOR_ME.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleReassignModalOpen
        },
        terminated: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).TERMINATE.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleCommonModalOpen
        },
        extendEndDate: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).EXTEND_END_DATE.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleEndDateModalOpen
        },
        approve: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).APPROVE.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleCommonModalOpen
        },
        reject: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REJECT.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleCommonModalOpen
        },
        conditionalCertifiy: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONDITIONAL_CERTIFIY.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleEndDateModalOpen
        },
        reassign: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).REASSIGN.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleReassignModalOpen
        },
        consult: {
            id: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.id,
            icon: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.icon,
            status: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.status,
            text: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.text,
            objectsToTotal: (0, $f16755d1eb7f7f9c$export$50919f38e67a3d45).CONSULT.objectsToTotal,
            kind: "outlined",
            popOverContent: "",
            onClick: handleConsultModalOpen
        }
    };
    const renderBulkActionFooterInfoBox = ()=>{
        const bulkFooterStatsKeys = Object.keys(bulkFooterStats);
        const fullSelectedInfo = bulkFooterStatsKeys?.filter((key)=>bulkFooterStats[key] > 0)?.map((key)=>`${(0, $f16755d1eb7f7f9c$export$c9eee0952850eb88)[key]}${bulkFooterStats[key] > 1 ? "s" : ""} (${bulkFooterStats[key]})`).join(", ") || "You've selected nothing.";
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            tag: "div",
            className: "BulkActionFooter-infoBox",
            dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    tag: "div",
                    className: "BulkActionFooter-infoBoxText",
                    children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Typography), {
                        kind: isMobileXlargeWidth ? "body2" : "body1",
                        className: "BulkActionFooter-infoBoxDescription",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)("span", {
                                className: "BulkActionFooter-infoBoxTitle",
                                children: "Selected: "
                            }),
                            `${fullSelectedInfo}`
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                    size: isMobileXlargeWidth ? "small" : "medium",
                    kind: "ghost",
                    className: "BulkActionFooter-closeButton",
                    icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                        kind: "close",
                        color: "gray-000",
                        className: "BulkActionFooter-clearSelectionIcon"
                    }),
                    onClick: ()=>{
                        bulkActionClearBtn.onClick();
                    },
                    dataTheme: "dark"
                })
            ]
        });
    };
    const bulkActionButtonCountForMobile = bulkActionBtnsMap?.length || 0;
    const renderButtonMenuForMobile = ()=>{
        if (bulkActionButtonCountForMobile > (0, $f16755d1eb7f7f9c$export$299bc9d52534f8e3)) {
            if (isMobileMoreChecked) return (0, $4ab0c307926279af$export$1ea61e82efefb42b)(bulkActionBtnsMap).map((key)=>{
                const { id: id, status: status, icon: icon, text: text, objectsToTotal: objectsToTotal, onClick: onClickFunc } = bulkActionButtons[key];
                const btnCount = objectsToTotal.reduce((total, item)=>{
                    if (bulkFooterStats[item]) return total + bulkFooterStats[item];
                    return total;
                }, 0) || "0";
                return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "BulkActionFooter-wrapperHolder--isMobileMode",
                    children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                        id: id,
                        dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                        onClick: ()=>onClickFunc(id, status),
                        className: "BulkActionFooter-buttonWrapper--isMobileMode",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                className: "BulkActionFooter-button--isMobileMode",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: icon,
                                    color: "neutral-000"
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body4",
                                desktop: "body4-d",
                                mobile: "body4-d",
                                className: "BulkActionFooter-buttonText--isMobileMode",
                                children: `${text} (${btnCount})`
                            })
                        ]
                    })
                }, id);
            });
            return (0, $4ab0c307926279af$export$1ea61e82efefb42b)(bulkActionBtnsMap).filter((_, index)=>index < (0, $f16755d1eb7f7f9c$export$299bc9d52534f8e3) - 1).map((key)=>{
                const { id: id, status: status, icon: icon, text: text, objectsToTotal: objectsToTotal, onClick: onClickFunc } = bulkActionButtons[key];
                const btnCount = objectsToTotal.reduce((total, item)=>{
                    if (bulkFooterStats[item]) return total + bulkFooterStats[item];
                    return total;
                }, 0) || "0";
                return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "BulkActionFooter-wrapperHolder--isMobileMode",
                    children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                        id: id,
                        dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                        onClick: ()=>onClickFunc(id, status),
                        className: "BulkActionFooter-buttonWrapper--isMobileMode",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                className: "BulkActionFooter-button--isMobileMode",
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                    kind: icon,
                                    color: "neutral-000"
                                })
                            }),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body4",
                                desktop: "body4-d",
                                mobile: "body4-d",
                                className: "BulkActionFooter-buttonText--isMobileMode",
                                children: `${text} (${btnCount})`
                            })
                        ]
                    })
                }, id);
            });
        }
        return (0, $4ab0c307926279af$export$1ea61e82efefb42b)(bulkActionBtnsMap).map((key)=>{
            const { id: id, status: status, icon: icon, text: text, objectsToTotal: objectsToTotal, onClick: onClickFunc } = bulkActionButtons[key];
            const btnCount = objectsToTotal.reduce((total, item)=>{
                if (bulkFooterStats[item]) return total + bulkFooterStats[item];
                return total;
            }, 0) || "0";
            return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "BulkActionFooter-wrapperHolder--isMobileMode",
                children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                    id: id,
                    dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                    onClick: ()=>onClickFunc(id, status),
                    className: "BulkActionFooter-buttonWrapper--isMobileMode",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                            className: "BulkActionFooter-button--isMobileMode",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: icon,
                                color: "neutral-000"
                            })
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body4",
                            desktop: "body4-d",
                            mobile: "body4-d",
                            className: "BulkActionFooter-buttonText--isMobileMode",
                            children: `${text} (${btnCount})`
                        })
                    ]
                })
            }, id);
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "div",
        className: wrapperClass,
        children: [
            bulkAction?.isBulkFooterVisible && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $67922cf867358a9f$export$2e2bcd8739ae039), {
                        bulkFooterStats: bulkFooterStats,
                        bulkActionCommonAction: bulkActionCommonAction,
                        setBulkActionCommonAction: setBulkActionCommonAction,
                        handleCommonAction: handleCommonAction,
                        bulkPredefinedComments: bulkPredefinedComments,
                        isMobileXlargeWidth: isMobileXlargeWidth
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $1f495251564d3706$export$2e2bcd8739ae039), {
                        bulkFooterStats: bulkFooterStats,
                        bulkActionEndDate: bulkActionEndDate,
                        setBulkActionEndDate: setBulkActionEndDate,
                        handleEndDate: handleEndDate,
                        bulkPredefinedComments: bulkPredefinedComments,
                        isMobileXlargeWidth: isMobileXlargeWidth
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $9c5641ad203d7eb5$export$2e2bcd8739ae039), {
                        bulkFooterStats: bulkFooterStats,
                        bulkActionConsult: bulkActionConsult,
                        setBulkActionConsult: setBulkActionConsult,
                        handleConsult: handleConsult,
                        bulkPredefinedComments: bulkPredefinedComments,
                        isMobileXlargeWidth: isMobileXlargeWidth
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $1942586e97c3ba42$export$2e2bcd8739ae039), {
                        bulkFooterStats: bulkFooterStats,
                        bulkActionReassign: bulkActionReassign,
                        setBulkActionReassign: setBulkActionReassign,
                        handleReassign: handleReassign,
                        bulkPredefinedComments: bulkPredefinedComments,
                        isMobileXlargeWidth: isMobileXlargeWidth
                    })
                ]
            }),
            renderBulkActionFooterInfoBox(),
            isMobileXlargeWidth ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "BulkActionFooter-btnBox",
                ref: bulkActionBtnBoxRef,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                        kind: "button",
                        size: "medium",
                        dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                        onClick: bulkActionClearBtn.onClick,
                        isDisabled: bulkAction?.isDisabled || bulkAction?.isSubmittingAction || isLoading,
                        text: bulkActionClearBtn.text,
                        className: "BulkActionFooter-btnBoxButton BulkActionFooter-btnClearSelection"
                    }, bulkActionClearBtn.id),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "BulkActionFooter-controlsWrapper",
                        children: [
                            renderButtonMenuForMobile(),
                            bulkActionButtonCountForMobile > (0, $f16755d1eb7f7f9c$export$299bc9d52534f8e3) && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                className: "BulkActionFooter-wrapperHolder--isMobileMode",
                                children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ButtonCore), {
                                    id: "BulkActionMobileMoreButton",
                                    dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                                    onClick: ()=>setIsMobileMoreChecked((prev)=>!prev),
                                    className: "BulkActionFooter-buttonWrapper--isMobileMode",
                                    children: [
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                            className: "BulkActionFooter-button--isMobileMode BulkActionFooter-button--isSwitched",
                                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                kind: isMobileMoreChecked ? "ChevronUp" : "ChevronDown",
                                                color: "neutral-000"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                            kind: "body4",
                                            desktop: "body4-d",
                                            mobile: "body4-d",
                                            className: "BulkActionFooter-buttonText--isMobileMode",
                                            children: isMobileMoreChecked ? "Less" : "More"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "BulkActionFooter-btnBox",
                ref: bulkActionBtnBoxRef,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                        kind: "button",
                        size: "medium",
                        dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                        onClick: bulkActionClearBtn.onClick,
                        isDisabled: bulkAction?.isDisabled || bulkAction?.isSubmittingAction || isLoading,
                        text: bulkActionClearBtn.text,
                        className: "BulkActionFooter-btnBoxButton BulkActionFooter-btnClearSelection"
                    }, bulkActionClearBtn.id),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "BulkActionFooter-controlsWrapper",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                tag: "div",
                                className: "BulkActionFooter-btnBoxVariableBtns",
                                children: (0, $4ab0c307926279af$export$1ea61e82efefb42b)(bulkActionBtnsMap).filter((_, index)=>index < countForActionButtonsAsPerScreen).map((key)=>{
                                    const { id: id, status: status, kind: kind, text: text, popOverContent: popOverContent, objectsToTotal: objectsToTotal, onClick: onClickFunc } = bulkActionButtons[key];
                                    const btnCount = objectsToTotal.reduce((total, item)=>{
                                        if (bulkFooterStats[item]) return total + bulkFooterStats[item];
                                        return total;
                                    }, 0) || "0";
                                    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Button), {
                                        type: "button",
                                        kind: kind,
                                        size: "medium",
                                        dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                                        onClick: ()=>onClickFunc(id, status),
                                        rightIcon: popOverContent.trim().length > 0 ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Info",
                                            size: "smallMedium"
                                        }) : null,
                                        className: "BulkActionFooter-btnBoxButton",
                                        children: [
                                            `${text} (${btnCount})`,
                                            popOverContent.trim().length > 0 && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                                tag: "span",
                                                className: "BulkActionFooter-btnBoxButtonPopOver",
                                                children: popOverContent
                                            })
                                        ]
                                    }, id);
                                })
                            }),
                            bulkActionBtnsMap.length > countForActionButtonsAsPerScreen && /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                tag: "div",
                                className: "BulkActionFooter-btnBoxMenu",
                                children: [
                                    showKebabActionBtns && /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                        className: "BulkActionFooter-btnBoxMenuDropUp",
                                        ref: dropUpWrapperForBulkActionKebab,
                                        children: bulkActionBtnsMap.filter((_, index)=>index >= countForActionButtonsAsPerScreen).map((key)=>{
                                            const { id: id, status: status, icon: icon, text: text, objectsToTotal: objectsToTotal, onClick: onClickFunc } = bulkActionButtons[key];
                                            const btnCount = objectsToTotal.reduce((total, item)=>{
                                                if (bulkFooterStats[item]) return total + bulkFooterStats[item];
                                                return total;
                                            }, 0) || "0";
                                            return /*#__PURE__*/ (0, $hopDi$jsxs)("span", {
                                                className: "BulkActionFooter-btnBoxMenuDropUpListItem",
                                                onClick: ()=>onClickFunc(id, status),
                                                onKeyDown: ()=>{},
                                                role: "button",
                                                tabIndex: "0",
                                                children: [
                                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                        kind: icon,
                                                        size: "smallMedium"
                                                    }),
                                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                        kind: "body2",
                                                        className: "BulkActionFooter-btnBoxMenuDropUpListItemText",
                                                        children: `${text} (${btnCount})`
                                                    })
                                                ]
                                            }, id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "medium",
                                        kind: "ghost",
                                        dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                                        onClick: ()=>setShowKebabActionBtns(!showKebabActionBtns),
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "MoreVertical",
                                            color: "gray-000",
                                            size: "smallMedium"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $2c59e15aa57e4ffa$export$2e2bcd8739ae039 = $2c59e15aa57e4ffa$var$BulkActionFooter;



var $8107c65abb1d6a90$export$2e2bcd8739ae039 = (0, $2c59e15aa57e4ffa$export$2e2bcd8739ae039);








function $bf993c45fc2d1cb4$var$CertsFooterActionBar() {
    const [isProgressBarOpen, setIsProgressBarOpen] = (0, $hopDi$useState)(false);
    const [percentage, setPercentage] = (0, $hopDi$useState)(0);
    const dispatch = (0, $hopDi$useDispatch)();
    const popoverRef = (0, $hopDi$useRef)(null);
    const { bulkAction: bulkAction, isSidePanelVisible: isSidePanelVisible, certKey: certKey, objectForRedirectLink: objectForRedirectLink, progressBreakdowndetails: progressBreakdowndetails, shouldShowReviewAndSubmitButton: shouldShowReviewAndSubmitButton, campaignKey: campaignKey, mediaQueryValue: mediaQueryValue } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { isRefreshSuccess: isRefreshSuccess } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { byDecisionDetails: byDecisionDetails, errorMessage: errorMessage, initialLoadError: initialLoadError } = progressBreakdowndetails;
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileWidth = mediaQueryValue >= mobileXlargeQuery.value;
    const footerNotice = "Progress Saved";
    const footerClasses = (0, $hopDi$classnames)("CertsFooterActionBar", isSidePanelVisible && "CertsFooterActionBar--isSidePanelVisible", bulkAction?.isBulkFooterVisible && bulkAction?.bulkFooterInfo && "CertsFooterActionBar--isBulkAction", isProgressBarOpen && "CertsFooterActionBar--isProgressBarOpen");
    const footerPhase1 = (0, $hopDi$classnames)("CertsFooterActionBar-phases", bulkAction?.isBulkFooterVisible && bulkAction?.bulkFooterInfo && "CertsFooterActionBar-phases1--isSidePanelVisible");
    const footerPhase2 = (0, $hopDi$classnames)("CertsFooterActionBar-phases", bulkAction?.isBulkFooterVisible && bulkAction?.bulkFooterInfo && "CertsFooterActionBar-phases2--isSidePanelVisible");
    const progressMessageClasses = (0, $hopDi$classnames)("CertsFooterActionBar-progressMessage", isRefreshSuccess ? "CertsFooterActionBar-progressMessage--isVisible" : "CertsFooterActionBar-progressMessage--isHidden", percentage === (0, $135adfecc1ed8f07$export$f688697617dd0589) && "CertsFooterActionBar-progressMessage-showLabel");
    (0, $hopDi$useOutsideClickEffect)(popoverRef, ()=>{
        if (!isMobileWidth) setIsProgressBarOpen(false);
    });
    const fetchProgessBarData = ()=>{
        dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef), true));
    };
    const refreshProgressData = ()=>{
        if (certKey) fetchProgessBarData();
    };
    (0, $hopDi$useEffect)(()=>{
        if (byDecisionDetails && byDecisionDetails?.Summary) setPercentage((0, $c3fd831cb38d6d24$export$c3e0f520a0aee8fc)(byDecisionDetails.Summary[0, $bf14b63763e2d183$export$71efb3495f6084f2], byDecisionDetails.Summary[0, $bf14b63763e2d183$export$e135c39ae3ebb92e]));
    }, [
        progressBreakdowndetails
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certKey) fetchProgessBarData();
    }, [
        certKey
    ]);
    const onBackClick = ()=>{
        if (objectForRedirectLink?.hasOnlyCertifierLevelAccess || objectForRedirectLink?.consulteeLoggedIn) window.location.replace("/ECM/certification/list");
        window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
    };
    const handlePopOver = ()=>{
        if (!initialLoadError) setIsProgressBarOpen((prev)=>!prev);
    };
    const toggleHoverClass = (isHovered)=>{
        const progressBar = document.querySelector(".CertsFooterActionBar-progressBar");
        if (progressBar) {
            if (isHovered) progressBar.classList.add("CertsFooterActionBar-progressBar--isHovered");
            else progressBar.classList.remove("CertsFooterActionBar-progressBar--isHovered");
        }
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        tag: "footer",
        className: footerClasses,
        dataTestId: "cert-details",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                tag: "div",
                className: footerPhase1,
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "subtle",
                        className: "CertsFooterActionBar-backBtn",
                        size: "medium",
                        onClick: onBackClick,
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                        className: "CertsFooterActionBar-progressBar",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            className: "CertsFooterActionBar-progress-content",
                            ref: popoverRef,
                            children: initialLoadError ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                                className: "CertsFooterActionBar-progressFailure",
                                children: [
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                        kind: "body2-bold",
                                        className: "CertsFooterActionBar-progressErrorMessage",
                                        children: "Error while loading porgress bar breakdown data."
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                                        size: "large",
                                        kind: "ghost",
                                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                            kind: "Refresh",
                                            size: "medium",
                                            color: "navy-900"
                                        }),
                                        onClick: refreshProgressData
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                children: [
                                    isProgressBarOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $aedec3a09ed0c484$export$2e2bcd8739ae039), {
                                        closePopover: handlePopOver,
                                        setIsProgressBarOpen: setIsProgressBarOpen,
                                        isProgressBarOpen: isProgressBarOpen,
                                        isMobileWidth: isMobileWidth
                                    }),
                                    byDecisionDetails?.Summary ? /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                                                kind: "body2",
                                                className: "CertsFooterActionBar-linearProgess",
                                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $f731ea5e88f23f43$export$2e2bcd8739ae039), {
                                                    value: percentage
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                                kind: "body2-bold",
                                                className: "CertsFooterActionBar-progressPercentage",
                                                children: `${byDecisionDetails.Summary[0, $bf14b63763e2d183$export$fbc5ebe2e580bf8b]}%`
                                            }),
                                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                                kind: "ChevronUpSmall",
                                                size: "medium",
                                                rotate: isProgressBarOpen ? "180" : null
                                            })
                                        ]
                                    }) : !errorMessage && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                                        kind: "dots",
                                        format: "inline",
                                        color: "brand",
                                        size: "medium"
                                    }),
                                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonCore), {
                                        onMouseEnter: ()=>toggleHoverClass(true),
                                        onMouseLeave: ()=>toggleHoverClass(false),
                                        onClick: handlePopOver,
                                        className: "CertsFooterActionBar-togglePopover"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                        tag: "div",
                        className: "CertsFooterActionBar-submit",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                className: progressMessageClasses,
                                children: footerNotice
                            }),
                            shouldShowReviewAndSubmitButton && /*#__PURE__*/ (0, $hopDi$jsx)((0, $eb340908ccb18f38$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: footerPhase2,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $8107c65abb1d6a90$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $bf993c45fc2d1cb4$export$2e2bcd8739ae039 = $bf993c45fc2d1cb4$var$CertsFooterActionBar;


var $51ca153ebce16509$export$2e2bcd8739ae039 = (0, $bf993c45fc2d1cb4$export$2e2bcd8739ae039);








/* eslint-disable react/jsx-no-useless-fragment */ 
























function $7b4cc5ca6643e57b$var$AddToExport({ allColumnsData: allColumnsData, setAllColumnsData: setAllColumnsData, selectedTab: selectedTab }) {
    const selectedTabColumns = allColumnsData[selectedTab];
    const notIncludedColumns = selectedTabColumns?.filter((item)=>!item.isChecked);
    const handleChange = (id)=>{
        const updatedColumns = selectedTabColumns?.map((item)=>item.id === id ? {
                ...item,
                isChecked: true
            } : item);
        setAllColumnsData({
            ...allColumnsData,
            [selectedTab]: updatedColumns
        });
    };
    const addAll = ()=>{
        const updatedColumns = selectedTabColumns?.map((item)=>({
                ...item,
                isChecked: true
            }));
        setAllColumnsData({
            ...allColumnsData,
            [selectedTab]: updatedColumns
        });
    };
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                className: "ColumnsHeader",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: "Add to Export"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                        text: "Add All",
                        kind: "button",
                        onClick: ()=>addAll()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                className: "AddToExportContainer",
                children: notIncludedColumns?.map((option)=>// eslint-disable-next-line jsx-a11y/label-has-associated-control
                    /*#__PURE__*/ (0, $hopDi$jsxs)("label", {
                        className: "AddToExportContainer-checkboxes",
                        children: [
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                                name: option?.label,
                                kind: "base",
                                dataTestId: option?.id,
                                isChecked: option?.isChecked,
                                onChange: ()=>handleChange(option?.id),
                                showHoverEffect: true,
                                isDisabled: option?.isDisabled
                            }, option.id),
                            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                kind: "body2",
                                children: option?.label
                            })
                        ]
                    }))
            })
        ]
    });
}
$7b4cc5ca6643e57b$var$AddToExport.propTypes = {
    allColumnsData: (0, $hopDi$proptypes).shape({}).isRequired,
    setAllColumnsData: (0, $hopDi$proptypes).func.isRequired,
    selectedTab: (0, $hopDi$proptypes).string.isRequired
};
var $7b4cc5ca6643e57b$export$2e2bcd8739ae039 = $7b4cc5ca6643e57b$var$AddToExport;





const $3b154ba6b2426f08$export$a337a6fd489a1042 = (filters)=>{
    // Create an empty object to group by keys
    const groupedFilters = {};
    // Iterate over each filter
    filters?.forEach((filter)=>{
        const { key: key, label: label } = filter;
        // If the key doesn't exist in the groupedFilters object, add it
        if (!groupedFilters[key]) groupedFilters[key] = [];
        // Push the label for this key into the array (avoid duplicates)
        if (!groupedFilters[key].includes(label)) groupedFilters[key].push(label);
    });
    // Format the output as a string
    return Object.keys(groupedFilters).map((key)=>`${key}: ${groupedFilters[key].join(", ")}`).join(", ");
};
const $3b154ba6b2426f08$export$c060223acd3503bb = (rows)=>{
    const rowsName = rows?.map((item)=>(0, $6d218ab9b83faef2$export$751b1412348af195)[item]);
    return `ROWS: ${rowsName?.join(", ")}`;
};
const $3b154ba6b2426f08$export$cafd0b95d4064b3d = [
    "User_DISPLAYNAME",
    "Role_DISPLAYNAME",
    "Account_DISPLAYNAME",
    "Ent_DISPLAYNAME"
];
const $3b154ba6b2426f08$export$ba1e983689df32cc = (column, messagesArray, internationalization)=>messagesArray[column] || (0, $hopDi$localize)(internationalization, (0, $e7628c995f405891$export$7cad4c9063025e24)(column?.split(".")[0]));
const $3b154ba6b2426f08$export$3fcb629c26baed68 = (columns, messagesArray, internationalization)=>columns?.map((item)=>{
        const columnKey = item?.split(".")[0];
        return {
            id: item,
            label: $3b154ba6b2426f08$export$ba1e983689df32cc(item, messagesArray, internationalization),
            isChecked: true,
            isDisabled: $3b154ba6b2426f08$export$cafd0b95d4064b3d.includes(columnKey)
        };
    });








function $590bc33fdf308339$var$IncludedInExport({ allColumnsData: allColumnsData, setAllColumnsData: setAllColumnsData, selectedTab: selectedTab }) {
    const selectedTabColumns = allColumnsData[selectedTab];
    const includedColumns = selectedTabColumns?.filter((item)=>item.isChecked);
    const handleChange = (id)=>{
        const updatedColumns = selectedTabColumns?.map((item)=>item.id === id ? {
                ...item,
                isChecked: false
            } : item);
        setAllColumnsData({
            ...allColumnsData,
            [selectedTab]: updatedColumns
        });
    };
    const reorderColumnsData = (sourceIndex, destinationIndex, allColumns, selectedTabValue)=>{
        const reorderList = ()=>{
            const tabSelectedColumns = allColumns[selectedTabValue];
            const removedOption = tabSelectedColumns.splice(sourceIndex, 1);
            const reorderedOptions = [
                ...tabSelectedColumns.slice(0, destinationIndex),
                ...removedOption,
                ...tabSelectedColumns.slice(destinationIndex)
            ];
            const sortedOption = reorderedOptions.sort((a, b)=>b.isChecked - a.isChecked);
            return {
                ...allColumns,
                [selectedTab]: sortedOption
            };
        };
        setAllColumnsData(reorderList());
    };
    const onDragEnd = (result)=>{
        if (!result.destination) return;
        reorderColumnsData(result.source.index, result.destination.index, allColumnsData, selectedTab);
    };
    const removeAll = ()=>{
        const updatedColumns = selectedTabColumns?.map((item)=>({
                ...item,
                isChecked: !!item.isDisabled
            }));
        setAllColumnsData({
            ...allColumnsData,
            [selectedTab]: updatedColumns
        });
    };
    const renderCheckboxes = (option)=>// eslint-disable-next-line jsx-a11y/label-has-associated-control
        /*#__PURE__*/ (0, $hopDi$jsxs)("label", {
            className: "ColumnsContainer-checkboxes",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                    name: option?.label,
                    kind: "base",
                    dataTestId: option?.id,
                    isChecked: option?.isChecked,
                    onChange: ()=>handleChange(option?.id),
                    showHoverEffect: true,
                    isDisabled: option?.isDisabled
                }, option.id),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "body2",
                    children: option?.label
                })
            ]
        });
    const renderMandatoryColumns = (option)=>/*#__PURE__*/ (0, $hopDi$jsx)("div", {
            className: "ColumnsContainer-options",
            children: renderCheckboxes(option)
        }, option?.value);
    const renderRestColumns = (option, index)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Draggable), {
            draggableId: `${option?.id}`,
            index: index,
            children: (draggableProvider)=>/*#__PURE__*/ (0, $hopDi$createElement)("div", {
                    ref: draggableProvider.innerRef,
                    ...draggableProvider.draggableProps,
                    className: "ColumnsContainer-options",
                    key: option?.value,
                    style: {
                        ...draggableProvider.draggableProps.style,
                        left: "auto",
                        top: "auto",
                        position: "relative"
                    },
                    children: [
                        renderCheckboxes(option),
                        /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                            ...draggableProvider.dragHandleProps,
                            className: "ColumnsContainer-drag",
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                                trigger: /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                                    className: "ColumnsContainer-dragIcon",
                                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                        kind: "DragVertical",
                                        color: "neutral-1000",
                                        size: "smallMedium"
                                    })
                                }),
                                text: "Drag to Reorder",
                                placement: "bottom"
                            })
                        })
                    ]
                })
        }, option?.id);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        children: [
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                className: "ColumnsHeader",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: "Included in Export"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Link), {
                        text: "Remove All",
                        kind: "button",
                        onClick: ()=>removeAll()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$DragDropContext), {
                onDragEnd: onDragEnd,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Droppable), {
                    droppableId: selectedTab,
                    children: (droppableProvider, snapshot)=>{
                        const style = {
                            ...snapshot.isDraggingOver ? {
                                pointerEvents: "none"
                            } : {},
                            position: "relative"
                        };
                        return /*#__PURE__*/ (0, $hopDi$createElement)("div", {
                            ...droppableProvider.droppableProps,
                            ref: droppableProvider.innerRef,
                            key: selectedTab,
                            className: "IncludedInExportContainer",
                            style: style,
                            children: [
                                includedColumns?.map((option, index)=>(0, $3b154ba6b2426f08$export$cafd0b95d4064b3d).includes(option?.id?.split(".")[0]) ? renderMandatoryColumns(option) : renderRestColumns(option, index)),
                                droppableProvider.placeholder
                            ]
                        });
                    }
                }, selectedTab)
            })
        ]
    });
}
$590bc33fdf308339$var$IncludedInExport.propTypes = {
    allColumnsData: (0, $hopDi$proptypes).shape({}).isRequired,
    setAllColumnsData: (0, $hopDi$proptypes).func.isRequired,
    selectedTab: (0, $hopDi$proptypes).string.isRequired
};
var $590bc33fdf308339$export$2e2bcd8739ae039 = $590bc33fdf308339$var$IncludedInExport;


function $83651d6a80debbed$var$SelectAndOrganizeYourData() {
    const dispatch = (0, $hopDi$useDispatch)();
    const [selection, setSelection] = (0, $hopDi$useState)(1);
    const [allColumnsData, setAllColumnsData] = (0, $hopDi$useState)([]);
    const { viewRowsList: viewRowsList, columnPickerList: columnPickerList, rowsFilters: rowsFilters, certsExport: certsExport } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { messages: messages } = (0, $hopDi$useSelector)((state)=>state?.user) || {};
    const intl = (0, $hopDi$useIntl)();
    const applyFilter = certsExport?.applyFilter;
    const showUsers = viewRowsList?.includes((0, $6d218ab9b83faef2$export$e99ca72b1ac3fcd6)) && (!applyFilter || rowsFilters?.includes((0, $6d218ab9b83faef2$export$e12a4cadfc09074e)));
    const showRoles = viewRowsList?.includes((0, $6d218ab9b83faef2$export$33e5df6437060fe4)) && (!applyFilter || rowsFilters?.includes((0, $6d218ab9b83faef2$export$addbd3a73cd831b8)));
    const showAccounts = viewRowsList?.includes((0, $6d218ab9b83faef2$export$67904de277d10d08)) && (!applyFilter || rowsFilters?.includes((0, $6d218ab9b83faef2$export$2fdde2b3b0357dd1)));
    const showEntitlements = viewRowsList?.includes((0, $6d218ab9b83faef2$export$28401dcfd55adaaa)) && (!applyFilter || rowsFilters?.includes((0, $6d218ab9b83faef2$export$b5f0f72f5619891f)));
    const availableColumnObject = ()=>{
        const arr = [];
        if (showUsers) arr.push((0, $a23cd229b9113926$export$c2fd574cc3b8c823));
        if (showRoles) arr.push((0, $a23cd229b9113926$export$c97501b522a7bf89));
        if (showAccounts) arr.push((0, $a23cd229b9113926$export$eeb9092565ce426a));
        if (showEntitlements) arr.push((0, $a23cd229b9113926$export$7d1f9b2b2a057886));
        return arr;
    };
    const availableObjects = availableColumnObject();
    const selectedTab = availableObjects.length && availableObjects[selection - 1];
    (0, $hopDi$useEffect)(()=>{
        if (!columnPickerList) return;
        const transformColumns = (columnList)=>Object.entries(columnList).reduce((acc, [key, columns])=>{
                acc[key] = (0, $3b154ba6b2426f08$export$3fcb629c26baed68)(Object.values(columns), messages, intl);
                return acc;
            }, {});
        const allColumnsWithLabels = transformColumns(columnPickerList);
        setAllColumnsData(allColumnsWithLabels);
    }, [
        columnPickerList,
        messages
    ]);
    (0, $hopDi$useEffect)(()=>{
        const columnsToExport = {};
        const addFilteredColumns = (key, shouldShow)=>{
            if (shouldShow && allColumnsData?.[key]) columnsToExport[key] = allColumnsData[key].filter((column)=>column.isChecked).map((column)=>column.id.split(".")[0]);
        };
        addFilteredColumns((0, $a23cd229b9113926$export$c2fd574cc3b8c823), showUsers);
        addFilteredColumns((0, $a23cd229b9113926$export$c97501b522a7bf89), showRoles);
        addFilteredColumns((0, $a23cd229b9113926$export$eeb9092565ce426a), showAccounts);
        addFilteredColumns((0, $a23cd229b9113926$export$7d1f9b2b2a057886), showEntitlements);
        dispatch((0, $d623f23401a154f0$export$c2f798e898b3f9ba)(columnsToExport));
    }, [
        allColumnsData,
        applyFilter
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        className: "SelectAndOrganizeYourData",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h3",
                children: "Select and Organize Your Data"
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                className: "SelectAndOrganizeYourData-tabs",
                children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$ToggleButtonGroup), {
                    selection: selection,
                    setSelection: setSelection,
                    children: [
                        showUsers && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                            label: "User",
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                className: "InputField-suffixButton-icon",
                                kind: "User",
                                size: "smallMedium"
                            })
                        }),
                        showRoles && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                            label: "Role",
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                className: "InputField-suffixButton-icon",
                                kind: "Role",
                                color: "navy-700",
                                size: "smallMedium"
                            })
                        }),
                        showAccounts && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                            label: "Account",
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                className: "InputField-suffixButton-icon",
                                kind: "Account",
                                color: "navy-700",
                                size: "smallMedium"
                            })
                        }),
                        showEntitlements && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ToggleButton), {
                            label: "Entitlement",
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                className: "InputField-suffixButton-icon",
                                kind: "Entitlement",
                                color: "navy-700",
                                size: "smallMedium"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                className: "SelectAndOrganizeYourData-tabsContent",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $590bc33fdf308339$export$2e2bcd8739ae039), {
                        allColumnsData: allColumnsData,
                        setAllColumnsData: setAllColumnsData,
                        selectedTab: selectedTab
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $7b4cc5ca6643e57b$export$2e2bcd8739ae039), {
                        allColumnsData: allColumnsData,
                        setAllColumnsData: setAllColumnsData,
                        selectedTab: selectedTab
                    })
                ]
            })
        ]
    });
}
var $83651d6a80debbed$export$2e2bcd8739ae039 = $83651d6a80debbed$var$SelectAndOrganizeYourData;








function $e74d9079379b4f9f$var$WhatToExport() {
    const dispatch = (0, $hopDi$useDispatch)();
    const { searchText: searchText, advancedFilters: advancedFilters, rowsFilters: rowsFilters, viewRowsList: viewRowsList, appliedSaviFilters: appliedSaviFilters, certsExport: certsExport } = (0, $hopDi$useSelector)((state)=>state.certifications);
    const handleRadioButtonClick = (e, value)=>{
        e.stopPropagation();
        dispatch((0, $d623f23401a154f0$export$c379fcb2cf9e7a46)(value === "onlyFilteredResults"));
    };
    const showRowsText = rowsFilters?.length !== viewRowsList?.length;
    const filtersText = (0, $3b154ba6b2426f08$export$a337a6fd489a1042)(advancedFilters);
    const rowsText = showRowsText ? (0, $3b154ba6b2426f08$export$c060223acd3503bb)(rowsFilters) : "";
    const { smartFilter: smartFilter, actionFilters: actionFilters } = appliedSaviFilters || {};
    const smartFilterText = smartFilter ? `Smart Filter: ${smartFilter}` : "";
    const actionFilterText = actionFilters?.length ? `Action Filters: ${actionFilters.join(", ")}` : "";
    const descriptionText = [
        rowsText,
        filtersText,
        smartFilterText,
        actionFilterText
    ].filter(Boolean).join(", ");
    const showDescription = showRowsText || filtersText || smartFilter?.length || actionFilters?.length;
    const getDescription = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                showDescription ? /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "CertsWhatToExport-radioTextWrapper",
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "body2",
                        children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body2-bold",
                                    children: "Filter applied - "
                                }),
                                descriptionText
                            ]
                        })
                    })
                }) : null,
                searchText?.length ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                    className: "CertsExportModalBody-radioButtons-description-searchText",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2-bold",
                            children: "Search applied - "
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            children: searchText
                        })
                    ]
                }) : null
            ]
        });
    const isOnlyFilteredItemsRadioButtonDisabled = !showRowsText && !filtersText && !searchText && !smartFilter?.length && !actionFilters?.length;
    const radioValue = certsExport?.applyFilter ? "onlyFilteredResults" : "allItems";
    const certsDetailsAllCount = certsExport?.certsDetailsAllCount;
    (0, $hopDi$useEffect)(()=>{
        if (certsDetailsAllCount === 0) dispatch((0, $d623f23401a154f0$export$c379fcb2cf9e7a46)(false));
    }, [
        certsDetailsAllCount
    ]);
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        className: "flexColumn",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                kind: "h3",
                children: "What to Export"
            }),
            /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                className: "CertsExportModalBody-radioButtons",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$RadioButton), {
                        id: "allItems",
                        name: "radioGroup1",
                        title: "All Items",
                        value: "allItems",
                        label: "All Items",
                        radioSelection: radioValue,
                        onClick: handleRadioButtonClick
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$RadioButton), {
                        id: "onlyFilteredItems",
                        name: "radioGroup1",
                        title: "Only Filtered Results",
                        description: getDescription(),
                        value: "onlyFilteredResults",
                        label: "Only Filtered Results",
                        radioSelection: radioValue,
                        onClick: handleRadioButtonClick,
                        isDisabled: isOnlyFilteredItemsRadioButtonDisabled || certsDetailsAllCount === 0
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$InlineMessage), {
                        kind: "background",
                        text: "The selected filters doesn't have any record. Please remove some of them to export.",
                        colorTheme: "info",
                        leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "Info"
                        }),
                        size: "small",
                        isVisible: certsDetailsAllCount === 0
                    })
                ]
            })
        ]
    });
}
var $e74d9079379b4f9f$export$2e2bcd8739ae039 = $e74d9079379b4f9f$var$WhatToExport;



function $e11cc7f918e8239b$var$CertsExportModal({ isOpen: isOpen, setIsOpen: setIsOpen }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const sectionRef = (0, $hopDi$useRef)(null);
    const { isScrolled: sectionRefIsScrolled } = (0, $hopDi$useDetectScroll)(null, sectionRef);
    const { certKey: certKey, certsExport: certsExport } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const handleExportClick = ()=>{
        dispatch((0, $d623f23401a154f0$export$bf978479f6cb60e8)(certKey, certsExport?.columnsToExport));
        setIsOpen(false);
    };
    const certsExportModalBody = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $e74d9079379b4f9f$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $83651d6a80debbed$export$2e2bcd8739ae039), {})
            ]
        });
    const certsExportFooterActionBar = ()=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
            className: "CertsExportModalFooter",
            children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                className: "CertsExportModalFooter-actionButtons",
                children: [
                    /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        kind: "outlined",
                        size: "medium",
                        onClick: ()=>setIsOpen(false),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                        className: "CertsExportModalFooter-actionButtons--primary",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                            kind: "filled",
                            size: "medium",
                            onClick: handleExportClick,
                            children: "Export"
                        })
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
        onClose: ()=>setIsOpen(false),
        isOpen: isOpen,
        className: "CertsExportModal",
        title: "Export Your Certification",
        subtitle: "Select what you want to export and how you want it organized.",
        headerIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
            kind: "Export",
            size: "large"
        }),
        contentBody: certsExportModalBody(),
        sectionRef: sectionRef,
        FooterActionBarComp: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$FooterActionBar), {
            size: "large",
            isScrolled: sectionRefIsScrolled,
            children: certsExportFooterActionBar()
        })
    });
}
$e11cc7f918e8239b$var$CertsExportModal.propTypes = {
    isOpen: (0, $hopDi$proptypes).string.isRequired,
    setIsOpen: (0, $hopDi$proptypes).func.isRequired
};
var $e11cc7f918e8239b$export$2e2bcd8739ae039 = $e11cc7f918e8239b$var$CertsExportModal;


function $4b9580f59600cde7$var$CertsExport() {
    const [isExportModalOpen, setIsExportModalOpen] = (0, $hopDi$useState)(false);
    const [alertStatus, setAlertStatus] = (0, $hopDi$useState)("");
    const dispatch = (0, $hopDi$useDispatch)();
    const { mediaQueryValue: mediaQueryValue, certsExport: certsExport, tabs: tabs, certKey: certKey } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const allTabCount = tabs?.tabData?.find((tab)=>tab.key === (0, $d44c789d5b60f9bf$export$d5eea126dff5a615))?.count;
    const shouldDisableExportBtn = Boolean(allTabCount === 0);
    const tabletSmallQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$6e89092ed3d96394));
    const isTabletWidth = tabletSmallQuery.value > mediaQueryValue;
    (0, $hopDi$useEffect)(()=>{
        const currentExportStatus = certsExport?.certsExportStatus?.exportStatus;
        switch(currentExportStatus){
            case "SUCCESS":
            case "FAILED":
            case "FAILED-412":
                setAlertStatus(currentExportStatus);
                break;
            default:
                setAlertStatus("");
                break;
        }
    }, [
        certsExport?.certsExportStatus
    ]);
    const renderAlertBanner = ()=>{
        const alertConfigs = {
            SUCCESS: {
                colorTheme: "Information",
                title: "Exporting",
                description: "Your export is running in the background and will be available in the 'My Downloads' section once completed."
            },
            FAILED: {
                colorTheme: "Critical",
                title: "Failed",
                description: "Export cannot be done now because of some network failure, Please try again later."
            },
            "FAILED-412": {
                colorTheme: "Information",
                title: "Info",
                description: "An export is already running in the background, please wait for it to complete."
            }
        };
        const config = alertConfigs[alertStatus];
        return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Fragment), {
            children: config && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$StackingAlertBanner), {
                ...config,
                isVisible: config,
                kind: "low",
                onCancel: ()=>setAlertStatus(""),
                shouldAutoDismiss: true
            })
        });
    };
    // TODO : Revert this changes when new export is ready : CR-17779
    const onExportButtonClick = ()=>{
        dispatch((0, $d623f23401a154f0$export$bf978479f6cb60e8)(certKey));
    };
    // const onExportButtonClick = () => {
    //   setIsExportModalOpen(true);
    //   dispatch(getCertDetailsForExport(certKey, columnNames, 10, 0, searchText));
    // };
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "CertsExport",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                type: "button",
                kind: shouldDisableExportBtn ? "filled" : "outlined",
                size: "medium",
                isDisabled: shouldDisableExportBtn,
                onClick: ()=>onExportButtonClick(),
                className: shouldDisableExportBtn ? "" : "CertsHeader-button",
                leftIcon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                    kind: "Export",
                    size: "smallMedium"
                }),
                children: isTabletWidth ? "Export" : ""
            }),
            isExportModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $e11cc7f918e8239b$export$2e2bcd8739ae039), {
                isOpen: isExportModalOpen,
                setIsOpen: setIsExportModalOpen
            }),
            renderAlertBanner()
        ]
    });
}
var $4b9580f59600cde7$export$2e2bcd8739ae039 = $4b9580f59600cde7$var$CertsExport;

















function $4506e6adedc7ef30$var$ViewOptions({ isOpenViewOption: isOpenViewOption, setIsOpenViewOption: setIsOpenViewOption, isOnMobile: isOnMobile }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const selectedViewOption = (0, $hopDi$useSelector)((state)=>state?.certifications?.personalization?.viewOption?.view);
    const viewOptionRef = (0, $hopDi$useRef)("viewOption");
    (0, $hopDi$useOutsideClickEffect)(viewOptionRef, ()=>{
        setIsOpenViewOption(false);
    });
    const handleOnClick = (event)=>{
        const clickedText = isOnMobile ? event.value : event.target.textContent;
        if (clickedText === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW) dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
            view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW,
            applied: true
        }));
        else if (clickedText === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW) {
            dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
                view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                applied: true
            }));
            dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                advancedFilters: false,
                rows: false,
                columns: false
            }));
            dispatch((0, $d623f23401a154f0$export$7d8ceafb9568ec2d)(true));
        }
        setIsOpenViewOption(false);
    };
    const handleClick = ()=>{
        setIsOpenViewOption(!isOpenViewOption);
    };
    if (isOnMobile) {
        const options = [
            {
                label: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                value: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                isChecked: selectedViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                isDisabled: false,
                isRadio: true
            },
            {
                label: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW,
                value: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW,
                isChecked: selectedViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW,
                isDisabled: false,
                isRadio: true
            }
        ];
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertPersonalization--ViewOptionsMobile",
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                    kind: "h4",
                    children: "View Options"
                }),
                options.map((option)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawerItem), {
                        option: option,
                        onClick: ()=>handleOnClick(option)
                    }))
            ]
        });
    }
    return /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
        className: "CertPersonalization--ViewOptionsContainer",
        ref: viewOptionRef,
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonSelect), {
                label: selectedViewOption,
                onClick: handleClick,
                isOpen: isOpenViewOption,
                size: "medium"
            }),
            isOpenViewOption ? /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "CertPersonalization--ViewOptions",
                children: /*#__PURE__*/ (0, $hopDi$jsxs)("ul", {
                    onClick: handleOnClick,
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)("li", {
                            className: selectedViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW ? "selected" : "",
                            children: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).MY_PERSONALIZED_VIEW
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)("li", {
                            className: selectedViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW ? "selected" : "",
                            children: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW
                        })
                    ]
                })
            }) : ""
        ]
    });
}
$4506e6adedc7ef30$var$ViewOptions.defaultProps = {};
$4506e6adedc7ef30$var$ViewOptions.propTypes = {
    isOpenViewOption: (0, $hopDi$proptypes).bool.isRequired,
    setIsOpenViewOption: (0, $hopDi$proptypes).func.isRequired,
    isOnMobile: (0, $hopDi$proptypes).bool.isRequired
};
var $4506e6adedc7ef30$export$2e2bcd8739ae039 = $4506e6adedc7ef30$var$ViewOptions;



function $832734c038344586$var$CertsPersonalization({ isOpenViewOption: isOpenViewOption, setIsOpenViewOption: setIsOpenViewOption, isOnMobile: isOnMobile = false }) {
    const dispatch = (0, $hopDi$useDispatch)();
    const [showLoaderOnSaveView, setShowLoaderOnSaveView] = (0, $hopDi$useState)(false);
    const { personalization: personalization, advancedFilters: advancedFilters, rowsFilters: rowsFilters, colsFilters: colsFilters, bulkAction: bulkAction } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const currentStatus = personalization?.status;
    const currentPersonalizatonApiStatus = personalization?.updatePersonalizatonApiStatus;
    const bulkActionsCompleted = bulkAction?.isBulkActionsCompleted;
    const handleCreatePersonalization = ()=>{
        const payload = {
            defaultView: [
                {
                    colsFilters: colsFilters,
                    rowsFilters: rowsFilters,
                    advancedFilters: advancedFilters
                }
            ]
        };
        dispatch((0, $d623f23401a154f0$export$b8bb943818e6e839)(payload));
    };
    const handleUpdatePersonalization = ()=>{
        const eTag = personalization?.personalizedData?.eTag;
        const payload = {
            defaultView: [
                {
                    colsFilters: colsFilters,
                    rowsFilters: rowsFilters,
                    advancedFilters: advancedFilters
                }
            ]
        };
        dispatch((0, $d623f23401a154f0$export$1ecd851f8e273137)(payload, eTag));
    };
    const handleSaveViewClick = ()=>{
        setShowLoaderOnSaveView(true);
        if (personalization?.personalizedData?.response === "No View Found") handleCreatePersonalization();
        else handleUpdatePersonalization();
    };
    const handleClearButtonClick = ()=>{
        const response = personalization?.personalizedData?.response;
        if (response === "No View Found") dispatch((0, $d623f23401a154f0$export$3afc30d9c2fc6ef)(""));
        else dispatch((0, $d623f23401a154f0$export$3afc30d9c2fc6ef)("EXIST_PERSONALIZATION"));
        dispatch((0, $d623f23401a154f0$export$ff97474e35a46941)(true));
        dispatch((0, $d623f23401a154f0$export$9738ba63bdee8079)(false));
    };
    (0, $hopDi$useEffect)(()=>{
        if (currentStatus === "UPDATE_PERSONALIZATION") dispatch((0, $d623f23401a154f0$export$ff97474e35a46941)(false));
        if (currentStatus === "EXIST_PERSONALIZATION" || currentStatus === "" || currentPersonalizatonApiStatus === "") setShowLoaderOnSaveView(false);
    }, [
        currentStatus,
        currentPersonalizatonApiStatus
    ]);
    if (currentStatus === "UPDATE_PERSONALIZATION" || currentStatus === "UPDATE_PERSONALIZATION_FAILED") {
        if (isOnMobile) {
            const options = [
                {
                    label: "Save View",
                    value: "saveView",
                    isChecked: false,
                    isDisabled: false,
                    prefixIcon: "SaveView",
                    onClick: handleSaveViewClick
                },
                {
                    label: "Clear",
                    value: "clear",
                    isChecked: false,
                    isDisabled: false,
                    prefixIcon: "Reject",
                    onClick: handleClearButtonClick
                }
            ];
            return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Fragment), {
                children: options.map((option)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawerItem), {
                        option: option,
                        onClick: option.onClick,
                        suffixIcon: option.value === "saveView" && showLoaderOnSaveView ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Loader), {
                            kind: "dots",
                            format: "inline",
                            color: "brand"
                        }) : null
                    }))
            });
        }
        return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                    className: "CertPersonalization--clearButton",
                    onClick: handleClearButtonClick,
                    role: "button",
                    children: "Clear"
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                    type: "button",
                    kind: "filled",
                    size: "medium",
                    className: "CertsHeader-button",
                    onClick: handleSaveViewClick,
                    isDisabled: bulkActionsCompleted,
                    isLoading: showLoaderOnSaveView,
                    loaderText: "Save View",
                    children: "Save View"
                })
            ]
        });
    }
    if (currentStatus === "EXIST_PERSONALIZATION") return /*#__PURE__*/ (0, $hopDi$jsx)((0, $4506e6adedc7ef30$export$2e2bcd8739ae039), {
        isOpenViewOption: isOpenViewOption,
        setIsOpenViewOption: setIsOpenViewOption,
        isOnMobile: isOnMobile
    });
    return "";
}
$832734c038344586$var$CertsPersonalization.defaultProps = {
    isOnMobile: false
};
$832734c038344586$var$CertsPersonalization.propTypes = {
    isOpenViewOption: (0, $hopDi$proptypes).bool.isRequired,
    setIsOpenViewOption: (0, $hopDi$proptypes).func.isRequired,
    isOnMobile: (0, $hopDi$proptypes).bool
};
var $832734c038344586$export$2e2bcd8739ae039 = $832734c038344586$var$CertsPersonalization;



const $9c2b6add8bf30d68$var$TOOLTIP_DELAY_IN_MS_TILE = 500;
function $9c2b6add8bf30d68$var$CertsHeader() {
    const [isOpenViewOption, setIsOpenViewOption] = (0, $hopDi$useState)(false);
    const [isCertHeaderTextHovered, setIsCertHeaderTextHovered] = (0, $hopDi$useState)(false);
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = (0, $hopDi$useState)(false);
    const [showKebabMenu, setShowKebabMenu] = (0, $hopDi$useState)(false);
    const [isPopoverOpen, setPopoverOpen] = (0, $hopDi$useState)(true);
    const [isCheckboxChecked, setCheckboxChecked] = (0, $hopDi$useState)(false);
    const LOCAL_STORAGE_KEY = "personalizationCertsKeys";
    const { certKey: certKey, certificationName: certificationName, campaignKey: campaignKey, objectForRedirectLink: objectForRedirectLink, mediaQueryValue: mediaQueryValue, personalization: personalization } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { viewOption: viewOption, clearCurrentPersonalization: clearCurrentPersonalization, status: status } = personalization;
    const mobileXlargeQuery = (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1).find((item)=>item.label === (0, $135adfecc1ed8f07$export$1cc96dc9f9fe057a));
    const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;
    // Close Drawer on breakpoint resize
    (0, $hopDi$useEffect)(()=>{
        if (!isMobileXlargeWidth) setIsMobileDrawerOpen(false);
    }, [
        isMobileXlargeWidth
    ]);
    const certsHeaderClasses = (0, $hopDi$classnames)("CertsHeader", isOpenViewOption && "CertsHeader--isOpenViewOption", isCertHeaderTextHovered && "CertsHeader--isOpenViewOption");
    const onCloseClick = ()=>{
        if (isMobileXlargeWidth) {
            window.location = `${window.location.origin}/ECMv6/request/requestHome`;
            return;
        }
        if (objectForRedirectLink?.hasOnlyCertifierLevelAccess || objectForRedirectLink?.consulteeLoggedIn) window.location.replace("/ECM/certification/list");
        window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
    };
    const handleMouseEnter = ()=>setIsCertHeaderTextHovered(true);
    const handleMouseLeave = ()=>setIsCertHeaderTextHovered(false);
    (0, $hopDi$useEffect)(()=>{
        setIsMobileDrawerOpen(false);
    }, [
        viewOption?.view,
        clearCurrentPersonalization,
        status
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (status === "EXIST_PERSONALIZATION" || status === "UPDATE_PERSONALIZATION") setShowKebabMenu(true);
    }, [
        status
    ]);
    const getCertKeysFromLocalStorage = ()=>{
        const certKeys = localStorage.getItem(LOCAL_STORAGE_KEY);
        return certKeys ? JSON.parse(certKeys) : [];
    };
    const saveCertKeyToLocalStorage = (key)=>{
        const certKeys = getCertKeysFromLocalStorage();
        if (!certKeys.includes(key)) localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify([
            ...certKeys,
            key
        ]));
    };
    const doesCertKeyExist = ()=>getCertKeysFromLocalStorage().includes(certKey);
    (0, $hopDi$useEffect)(()=>{
        if (doesCertKeyExist()) setPopoverOpen(false);
    }, [
        certKey
    ]);
    const handleClose = ()=>{
        if (isCheckboxChecked) saveCertKeyToLocalStorage(certKey);
        setPopoverOpen(false);
    };
    const handleCheckbox = (event)=>{
        setCheckboxChecked(event.target.checked);
    };
    const personalizationPopoverContent = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsHeader-popover",
            dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsHeader-popoverHeader",
                    dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).LIGHT,
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "h3",
                            children: "View Options"
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                            dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).LIGHT,
                            size: "small",
                            kind: "ghost",
                            onClick: ()=>handleClose(),
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "Close",
                                color: "neutral-1000",
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsHeader-popoverBody",
                    dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).LIGHT,
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                            kind: "body2",
                            children: "You can switch between the default and your personalized view here."
                        }),
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Checkbox), {
                            name: "simpleText",
                            kind: "simpleText",
                            dataTestId: "simpleText",
                            isChecked: isCheckboxChecked,
                            onChange: handleCheckbox,
                            label: "Don\u2019t show this again for this certification",
                            textPosition: "after",
                            showHoverEffect: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: "CertsHeader-popoverButton",
                    dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).LIGHT,
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "filled",
                        size: "small",
                        onClick: handleClose,
                        children: "Got it"
                    })
                })
            ]
        });
    const kebabMenuWithPopover = ()=>/*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
            className: "CertsHeader-kebabMenu",
            children: [
                status === "UPDATE_PERSONALIZATION" ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Badge), {
                    size: "small"
                }) : null,
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Popover), {
                    dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).LIGHT,
                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                        dataTheme: (0, $135adfecc1ed8f07$export$49390a4605a2336a).DARK,
                        size: "small",
                        kind: "ghost",
                        onClick: ()=>{
                            setIsMobileDrawerOpen(true);
                        },
                        icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                            kind: "MoreVertical",
                            color: "neutral-000",
                            size: "smallMedium"
                        })
                    }),
                    popoverContent: personalizationPopoverContent(),
                    isOpen: isPopoverOpen,
                    setIsOpen: ()=>{}
                })
            ]
        });
    return /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
        dataTheme: "dark",
        tag: "header",
        className: certsHeaderClasses,
        dataTestId: "certs-header",
        children: [
            /*#__PURE__*/ (0, $hopDi$jsx)("div", {
                className: "CertsHeader-textWrapper",
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Tooltip), {
                    openDelay: $9c2b6add8bf30d68$var$TOOLTIP_DELAY_IN_MS_TILE,
                    text: certificationName,
                    maxWidth: "20rem",
                    placement: "bottom-start",
                    offset: 24,
                    arrowStaticOffset: "16",
                    trigger: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                        kind: "h1",
                        mobile: "h3-m",
                        className: "CertsHeader-text",
                        children: certificationName || ""
                    })
                })
            }),
            /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                tag: "div",
                className: "CertsHeader-functionGroup",
                children: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Box), {
                    className: "CertsHeader-controls",
                    children: [
                        /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "CertsHeader-containerGreaterThan600",
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $832734c038344586$export$2e2bcd8739ae039), {
                                    isOpenViewOption: isOpenViewOption,
                                    setIsOpenViewOption: setIsOpenViewOption
                                }),
                                !objectForRedirectLink?.consulteeLoggedIn ? /*#__PURE__*/ (0, $hopDi$jsx)((0, $4b9580f59600cde7$export$2e2bcd8739ae039), {}) : ""
                            ]
                        }),
                        showKebabMenu ? /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
                            className: "CertsHeader-containerSmallerThan600",
                            children: [
                                kebabMenuWithPopover(),
                                isMobileDrawerOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$MobileDrawer), {
                                    isOpen: isMobileDrawerOpen,
                                    setIsOpen: setIsMobileDrawerOpen,
                                    isSwipeEnabled: true,
                                    isCloseButtonEnabled: false,
                                    content: /*#__PURE__*/ (0, $hopDi$jsx)((0, $832734c038344586$export$2e2bcd8739ae039), {
                                        isOpenViewOption: isOpenViewOption,
                                        setIsOpenViewOption: setIsOpenViewOption,
                                        isOnMobile: isMobileDrawerOpen
                                    })
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ButtonIcon), {
                            size: isMobileXlargeWidth ? "small" : "large",
                            kind: "ghost",
                            icon: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Icon), {
                                kind: "Close"
                            }),
                            onClick: onCloseClick,
                            className: "CertsHeader-closeBtn"
                        })
                    ]
                })
            })
        ]
    });
}
var $9c2b6add8bf30d68$export$2e2bcd8739ae039 = $9c2b6add8bf30d68$var$CertsHeader;


var $6c53f4b34b441c38$export$2e2bcd8739ae039 = (0, $9c2b6add8bf30d68$export$2e2bcd8739ae039);



const $7d04cd0c9db22b5a$var$cookies = new (0, $hopDi$Cookies)();
const $7d04cd0c9db22b5a$var$AUTO_SHOW_SAVI_COMPANION = "auto_show_savi_modal";
const $7d04cd0c9db22b5a$var$PROMISE_REJECTED = "rejected";
function $7d04cd0c9db22b5a$var$CertificationDetails() {
    // Pendo
    (0, $hopDi$usePendo)();
    // Savi
    const showSaviLocalCookie = $7d04cd0c9db22b5a$var$cookies.get($7d04cd0c9db22b5a$var$AUTO_SHOW_SAVI_COMPANION);
    const showSaviLocal = !showSaviLocalCookie || showSaviLocalCookie === "1";
    const [showSavCompanion, setShowSaviCompanion] = (0, $hopDi$useState)(showSaviLocal);
    const [showSaviCompanionButtonPopup, setShowSaviCompanionButtonPopup] = (0, $hopDi$useState)(false);
    const [isMoreDataAvailable, setIsMoreDataAvailable] = (0, $hopDi$useState)(true);
    // View Controls
    const [showFilterBar, setShowFilterBar] = (0, $hopDi$useState)(false);
    const [filters, setFilters] = (0, $hopDi$useState)([]);
    const [isDraggingDndItem, setIsDraggingDndItem] = (0, $hopDi$useState)(false);
    // Sidepanel
    const [sidePanelData, setSidePanelData] = (0, $hopDi$useState)(null);
    const [sidePanelActionsData, setSidePanelActionsData] = (0, $hopDi$useState)(null);
    // Details List
    const [listApiCallCount, setListApiCallCount] = (0, $hopDi$useState)(1);
    const [mergedListsAfterRowFilter, setMergedListsAfterRowFilter] = (0, $hopDi$useState)([]);
    const [mergedLists, setMergedLists] = (0, $hopDi$useState)([]);
    const [currentOffset, setCurrentOffset] = (0, $hopDi$useState)(0);
    const [timeoutIds, setTimeoutIds] = (0, $hopDi$useState)([]);
    // Error
    const [isErrorModalOpen, setIsErrorModalOpen] = (0, $hopDi$useState)(false);
    const maximumResults = 10;
    // Landscape mode and height below 660px
    const isTouchDevice = (0, $hopDi$useIsTouchDevice)();
    const [isPotrait, setIsPotrait] = (0, $hopDi$useState)(true);
    const [isPotraitModalOpen, setIsPotraitModalOpen] = (0, $hopDi$useState)(false);
    const dispatch = (0, $hopDi$useDispatch)();
    const location = (0, $hopDi$useLocation)();
    const detailsListRef = (0, $hopDi$useRef)(null);
    const filterBarRef = (0, $hopDi$useRef)(null);
    const controlsRef = (0, $hopDi$useRef)(null);
    const certPageRef = (0, $hopDi$useRef)(null);
    const { campaignKey: campaignKey, columnNames: columnNames, tabs: tabs, isSidePanelVisible: isSidePanelVisible, objectForRedirectLink: objectForRedirectLink, saviCompanionDetails: { isSaviEnabled: isSaviEnabled }, searchText: searchText, personalization: personalization, viewRowsList: viewRowsList } = (0, $hopDi$useSelector)((state)=>state?.certifications);
    const { tabData: tabData } = tabs;
    const activeTab = tabData.find((tab)=>tab.isActive);
    // Get redux responsive media hook for certs package
    (0, $hopDi$useResponsiveValueRedux)((0, $d623f23401a154f0$export$62e9f0f2fe0d4fcd), (0, $135adfecc1ed8f07$export$12bfde30afe7dcf1));
    const queryParams = new URLSearchParams(location?.search);
    const certKey = queryParams.get("certkey");
    const alertWrapperClasses = (0, $hopDi$classnames)("Certs-AlertBannerProvider", isSidePanelVisible && "Certs-AlertBannerProvider--isSidePanelVisible");
    const pageClasses = (0, $hopDi$classnames)("CertificationDetails", isSidePanelVisible && "CertificationDetails--isSidePanelVisible", isDraggingDndItem && "CertificationDetails--isDraggingDndItem");
    (0, $hopDi$useEffect)(()=>{
        dispatch((0, $d623f23401a154f0$export$c10170f5705ccb4f)(isTouchDevice));
        const windowMatchMediaLandscape = window.matchMedia("(orientation: landscape) and (max-height: 659px)");
        // Check for the landscape mode
        const checkLandscapeMode = (e)=>{
            if (isTouchDevice) {
                setIsPotrait(!e.matches);
                setIsPotraitModalOpen(e.matches);
            }
        };
        windowMatchMediaLandscape.addEventListener("change", checkLandscapeMode);
        return ()=>{
            windowMatchMediaLandscape.removeEventListener("change", checkLandscapeMode);
        };
    }, [
        isTouchDevice
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (certKey) {
            const promiseArrayToCheckEssentialAPIs = [
                dispatch((0, $d623f23401a154f0$export$889bd3e7f249bccd)(certKey)),
                dispatch((0, $d623f23401a154f0$export$d4d469724f632e02)())
            ];
            Promise.allSettled(promiseArrayToCheckEssentialAPIs).then((response)=>{
                const viewApiStatus = response[0].status;
                const esApisStatus = response[1].status;
                if (viewApiStatus !== $7d04cd0c9db22b5a$var$PROMISE_REJECTED && esApisStatus !== $7d04cd0c9db22b5a$var$PROMISE_REJECTED) {
                    dispatch((0, $d623f23401a154f0$export$1a246502936ad896)(certKey));
                    dispatch((0, $d623f23401a154f0$export$5015b7af24ac6daa)());
                    dispatch((0, $d623f23401a154f0$export$352097035a4cf7c6)());
                    // TODO: @Jacob, Remove this, getPredefinedComments
                    Object.keys((0, $135adfecc1ed8f07$export$f9b8d04d2b2b982f)).forEach((key)=>{
                        const commentKey = (0, $135adfecc1ed8f07$export$f9b8d04d2b2b982f)[key];
                        dispatch((0, $d623f23401a154f0$export$27dd55286e4e826a)(commentKey, certKey)).catch((error)=>(0, $hopDi$Logger).log(error));
                    });
                }
                if (viewApiStatus !== $7d04cd0c9db22b5a$var$PROMISE_REJECTED && esApisStatus === $7d04cd0c9db22b5a$var$PROMISE_REJECTED) setIsErrorModalOpen(true);
            });
            const timeZone = (0, $hopDi$momenttimezone).tz.guess();
            const timeZoneOffset = new Date().getTimezoneOffset();
            const timeZoneAbbrevation = (0, $hopDi$momenttimezone).tz.zone(timeZone).abbr(timeZoneOffset);
            dispatch((0, $d623f23401a154f0$export$a38b1f4e8e0cf926)(timeZoneAbbrevation));
        }
    }, [
        certKey
    ]);
    // Get the row filter applied values
    const personalizationViewOption = personalization?.viewOption?.view;
    const personalizedRowsFilters = personalization?.personalizedData?.result?.info?.defaultView?.[0] ? personalization.personalizedData.result.info.defaultView[0].rowsFilters : undefined;
    const clearCurrentPersonalization = personalization?.clearCurrentPersonalization;
    const onRowsUpdate = ()=>{
        const promiseToSetRowsFilter = [];
        const totalRowFiltersToApply = [];
        const rowFiltersToUpdate = Object.values((0, $6d218ab9b83faef2$export$da3f11392f2a7d63))?.filter((value)=>viewRowsList?.includes((0, $6d218ab9b83faef2$export$9e2b4f119567db3)[value]));
        if (personalizationViewOption !== (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW) {
            const shouldApplyRowFilter = (0, $c647e77118d4a3ed$export$9aaeabff13cdbf0d)(viewRowsList, personalizedRowsFilters);
            if (shouldApplyRowFilter) {
                totalRowFiltersToApply.push(...personalizedRowsFilters.map((row)=>(0, $6d218ab9b83faef2$export$da3f11392f2a7d63)?.[row]));
                dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                    rows: true
                }));
            } else {
                dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
                    view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                    applied: false
                }));
                dispatch((0, $d623f23401a154f0$export$5b19fac081290462)({
                    rows: false
                }));
            }
        }
        if (personalization?.isDefaultTriggeredByUser) {
            totalRowFiltersToApply.push(...rowFiltersToUpdate);
            dispatch((0, $d623f23401a154f0$export$7d8ceafb9568ec2d)(false));
        }
        if (totalRowFiltersToApply?.length >= 1) {
            rowFiltersToUpdate.forEach((row)=>{
                promiseToSetRowsFilter.push(dispatch((0, $d623f23401a154f0$export$1f0b8da065fa133a)("ROW_TYPE", row, totalRowFiltersToApply.includes(row))));
            });
            Promise.all(promiseToSetRowsFilter).then((responses)=>{
                const combinedResponse = responses.every((response)=>response === true);
                if (combinedResponse) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, 10, 0, searchText));
                else dispatch((0, $d623f23401a154f0$export$ce1119a9829e80f8)({
                    view: (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW,
                    applied: false
                }));
            });
        }
        totalRowFiltersToApply.length = 0;
    };
    const isPersonalizedAdvancedFilters = personalization?.personalizationAll.advancedFilters;
    const isPersonalizedRows = personalization?.personalizationAll.rows;
    const isPersonalizedColumns = personalization?.personalizationAll.columns;
    (0, $hopDi$useEffect)(()=>{
        if (isPersonalizedAdvancedFilters && isPersonalizedRows && isPersonalizedColumns || personalizationViewOption === (0, $135adfecc1ed8f07$export$ad5ae49be0159af2).DEFAULT_VIEW) onRowsUpdate();
    }, [
        isPersonalizedAdvancedFilters,
        isPersonalizedRows,
        isPersonalizedColumns
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (clearCurrentPersonalization) onRowsUpdate();
    }, [
        clearCurrentPersonalization
    ]);
    (0, $hopDi$useEffect)(()=>{
        if (campaignKey) dispatch((0, $d623f23401a154f0$export$7f8f83f9a8bce93a)(campaignKey));
    }, [
        campaignKey
    ]);
    const onBackClick = ()=>{
        if (objectForRedirectLink?.hasOnlyCertifierLevelAccess || objectForRedirectLink?.consulteeLoggedIn) window.location.replace("/ECM/certification/list");
        window.location.replace(`/ECM/certification/list?campaignKey=${campaignKey}&type=list`);
    };
    const showHideSaviCompanion = (isShow)=>{
        setShowSaviCompanion(isShow);
        if (showSaviLocal) {
            setShowSaviCompanionButtonPopup(true);
            $7d04cd0c9db22b5a$var$cookies.set($7d04cd0c9db22b5a$var$AUTO_SHOW_SAVI_COMPANION, "0");
        }
    };
    const getNodeByDirection = (nodes, currentNodeId, jumpToSameLevel, direction)=>{
        const isDirectionDown = direction === (0, $135adfecc1ed8f07$export$f0065dd01c1d9ed2).DOWN;
        const isDirectionUp = direction === (0, $135adfecc1ed8f07$export$f0065dd01c1d9ed2).UP;
        const flattenedList = (0, $e7628c995f405891$export$8824054d4a42eac8)(nodes);
        const currentNodeIndex = flattenedList.findIndex((node)=>node?.tracker?.id === currentNodeId);
        if (currentNodeIndex === -1) return null;
        if (currentNodeIndex === flattenedList.length - 1 && isDirectionDown) return null;
        // Handle navigation downwards
        if (isDirectionDown) for(let i = currentNodeIndex + 1; i < flattenedList.length; i += 1){
            if (jumpToSameLevel) {
                if (flattenedList[currentNodeIndex]?.tracker?.level >= flattenedList[i]?.tracker?.level) return flattenedList[i];
            } else return flattenedList[i];
        }
        // Handle navigation upwards
        if (isDirectionUp) for(let i = currentNodeIndex - 1; i >= 0; i -= 1){
            if (jumpToSameLevel) {
                if (flattenedList[currentNodeIndex]?.tracker?.level >= flattenedList[i]?.tracker?.level) return flattenedList[i];
            } else return flattenedList[i];
        }
        return null;
    };
    /**
   * Updates the `isConnected` property of nodes in a hierarchical structure.
   *
   * This function recursively traverses the provided list of nodes and updates the `isConnected` property
   * of the node with the specified `nodeToUpdateId` to `true`. All other nodes will have their `isConnected`
   * property set to `false`.
   *
   * @param {Array} prev - The previous list of nodes (merged list) to be updated.
   * @param {string} nodeToUpdateId - The trackerId of the node to be marked as connected.
   * @returns {Array} - The updated list of nodes (merged list) with the `isConnected` property updated accordingly.
   */ const updateIsConnected = (prev, nodeToUpdateId)=>{
        const data = prev.map((node)=>{
            if (node.tracker.id === nodeToUpdateId) return {
                ...node,
                tracker: {
                    ...node.tracker,
                    isConnected: true
                },
                children: node?.children?.length > 0 ? updateIsConnected(node?.children, nodeToUpdateId) : []
            };
            return {
                ...node,
                tracker: {
                    ...node.tracker,
                    isConnected: false
                },
                children: node?.children?.length > 0 ? updateIsConnected(node?.children, nodeToUpdateId) : []
            };
        });
        return data;
    };
    const handleSidePanelBreadCrumbAction = (level)=>{
        if (isSidePanelVisible && sidePanelData?.tracker?.id) {
            const nodes = Array.isArray(mergedListsAfterRowFilter) ? mergedListsAfterRowFilter : [
                mergedListsAfterRowFilter
            ];
            const currentNodeId = sidePanelData?.tracker?.id;
            const currentParentCount = sidePanelData?.tracker?.parents?.length;
            const currentNodeParents = (0, $e7628c995f405891$export$d3bf36f5a7258ab0)(nodes, currentNodeId);
            let nextNode = null;
            if (currentParentCount === 2 && level === 1) nextNode = currentNodeParents[1]?.nodeData;
            if (currentParentCount === 2 && level === 2) nextNode = currentNodeParents[0]?.nodeData;
            if (currentParentCount === 1 && level === 1) nextNode = currentNodeParents[0]?.nodeData;
            if (nextNode) {
                if (sidePanelData?.tracker?.id !== nextNode?.tracker?.id) {
                    setSidePanelData(nextNode);
                    setMergedLists((prev)=>updateIsConnected(prev, nextNode?.tracker?.id));
                }
            }
        }
    };
    const handleSidePanelTileButton = (currentNodeId, direction)=>{
        const nodes = Array.isArray(mergedListsAfterRowFilter) ? mergedListsAfterRowFilter : [
            mergedListsAfterRowFilter
        ];
        const nextNode = getNodeByDirection(nodes, currentNodeId, false, direction);
        if (nextNode) {
            if (sidePanelData?.tracker?.id !== nextNode?.tracker?.id) {
                setSidePanelData(nextNode);
                setMergedLists((prev)=>updateIsConnected(prev, nextNode?.tracker?.id));
            }
        }
    };
    /**
   * Handles the action for the side panel, such as navigating to the next node in the list.
   * It updates the side panel data and the merged lists based on the provided parameters.
   *
   * @param {boolean} jumpToSameLevel - If true, the function will jump to the next node at the same level.
   * @param {function} callback - A callback function to be executed after the side panel action is handled.
   *                              The callback receives an object with the updated lists and the next node.
   *                              If no next node is found, the nextNode property will be false, and sidepanel
   *                              will be closed if open.
   *
   * @returns {void} - This function does not return a value.
   */ const handleSidePanelAction = (0, $hopDi$useCallback)((jumpToSameLevel, callback)=>{
        if (isSidePanelVisible && sidePanelData?.tracker?.id) {
            const nodes = Array.isArray(mergedListsAfterRowFilter) ? mergedListsAfterRowFilter : [
                mergedListsAfterRowFilter
            ];
            const currentNodeId = sidePanelData?.tracker?.id;
            const nextNode = getNodeByDirection(nodes, currentNodeId, jumpToSameLevel, (0, $135adfecc1ed8f07$export$f0065dd01c1d9ed2).DOWN);
            if (nextNode) {
                if (sidePanelData?.tracker?.id !== nextNode?.tracker?.id) {
                    setSidePanelData(nextNode);
                    setMergedLists((prev)=>{
                        const updatedLists = updateIsConnected(prev, nextNode?.tracker?.id);
                        if (callback) callback({
                            updatedLists: updatedLists,
                            nextNode: nextNode
                        });
                        return updatedLists;
                    });
                    return;
                }
            }
            setMergedLists((prev)=>{
                if (callback) callback({
                    updatedLists: prev,
                    nextNode: false
                });
                return prev;
            });
            dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
        }
    }, [
        isSidePanelVisible,
        sidePanelData,
        mergedListsAfterRowFilter
    ]);
    // Disable tab switching while card transition is happening
    (0, $hopDi$useEffect)(()=>{
        if (activeTab.key !== (0, $d44c789d5b60f9bf$export$d5eea126dff5a615)) {
            if (timeoutIds?.length > 0) dispatch((0, $d623f23401a154f0$export$3ac645216ac406ce)(true));
            else dispatch((0, $d623f23401a154f0$export$3ac645216ac406ce)(false));
        }
    }, [
        timeoutIds,
        activeTab
    ]);
    (0, $hopDi$useEffect)(()=>{
        setTimeoutIds([]);
    }, [
        activeTab
    ]);
    /**
   * Updates a list of nodes (merged list) based on changes to associated nodes (line items), and adjusts the state and UI accordingly.
   *
   * This function performs the following steps:
   * 1. Finds and updates a topmost parent node if `topmostParentEid` is provided.
   * 2. Adjusts the offset for pagination based on changes in the updated and original nodes.
   * 3. Updates the merged list of nodes with the changes applied to the original parent node.
   * 4. If `topmostParentEid` is not provided, updates the merged list with changes to a single node.
   *
   * @param {Array} listToUpdate - The list of nodes (merged list) that needs to be updated.
   * @param {Array} updatedNodes - The nodes with updated data.
   * @param {string} actionKind - Type of action to perform (e.g., 'approve', 'reject', 'doesnotworkforme').
   * @param {Object} currentState - The current state of the action (actionKind: Select4ed or unselected).
   * @param {string} trackerId - Identifier used for tracking changes.
   * @param {string} [topmostParentEid] - Optional identifier for the topmost parent node to update.
   * @param {Array} eidsToUpdate - List of EIDs (Entity IDs) that need to be updated.
   * @param {Object} eidsAndKeysMap - Map containing EID and key configurations for node identification.
   */ const updateMergedListsForAssociatedNodes = (listToUpdate, updatedNodes, actionKind, currentState, trackerId, topmostParentEid, eidsToUpdate, eidsAndKeysMap)=>{
        if (topmostParentEid) {
            const originalNodeToUpdate = listToUpdate.find((topLevelNode)=>{
                const topMostNodeEidMap = eidsAndKeysMap[0] || {};
                if (topMostNodeEidMap?.isEidAvailable) return topLevelNode?.id === topmostParentEid;
                if (topMostNodeEidMap?.valueKey === "-4") return topLevelNode?.CERT_USERKEY === topmostParentEid;
                if (topMostNodeEidMap?.valueKey === "0") return topLevelNode?.CERT_ACCOUNTKEY === topmostParentEid;
                return topLevelNode?.id === topmostParentEid;
            });
            const updatedOriginalParentNode = (0, $31eefeb47866cab8$export$7928099a872ca1a9)(originalNodeToUpdate ? [
                originalNodeToUpdate
            ] : [], updatedNodes, actionKind, currentState, trackerId, eidsToUpdate);
            const flattenedListUpdated = (0, $e7628c995f405891$export$8824054d4a42eac8)(updatedOriginalParentNode);
            const flattenedListOriginal = (0, $e7628c995f405891$export$8824054d4a42eac8)(originalNodeToUpdate ? [
                originalNodeToUpdate
            ] : []);
            const updatedCount = flattenedListUpdated.filter((node)=>node?.rowNotToShow && node.rowNotToShow === "0")?.length;
            const originalCount = flattenedListOriginal.filter((node)=>node?.rowNotToShow && node.rowNotToShow === "0")?.length;
            // eslint-disable-next-line no-restricted-globals
            if (!isNaN(Math.abs(originalCount - updatedCount))) {
                const countToUpdate = Math.max(0, currentOffset - Math.abs(originalCount - updatedCount));
                if (countToUpdate === 0) {
                    dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
                    setMergedLists([]);
                    setCurrentOffset(maximumResults);
                    dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, 0, searchText));
                } else setCurrentOffset(countToUpdate || maximumResults);
            }
            const mergedListsChangeTimeOutId = setTimeout(()=>{
                setMergedLists((prev)=>{
                    const isValidUpdatedOriginalParentNode = (0, $31eefeb47866cab8$export$69c0d0b2ab73b812)(updatedOriginalParentNode);
                    if (updatedOriginalParentNode?.length === 0 || !isValidUpdatedOriginalParentNode) return prev?.filter((prevNode)=>{
                        if (prevNode?.id) return prevNode?.id !== topmostParentEid;
                        if (prevNode?.CERT_ENTITLEMENT_VALUEKEY === "-4") return prevNode?.CERT_USERKEY !== topmostParentEid;
                        if (prevNode?.CERT_ENTITLEMENT_VALUEKEY === "0") return prevNode?.CERT_ACCOUNTKEY !== topmostParentEid;
                        return prevNode?.id !== topmostParentEid;
                    });
                    return prev?.map((prevNode)=>{
                        if (prevNode?.id && prevNode?.id === updatedOriginalParentNode[0]?.id) return updatedOriginalParentNode[0];
                        if (!prevNode?.id && prevNode?.CERT_ENTITLEMENT_VALUEKEY === "-4" && prevNode?.CERT_USERKEY === updatedOriginalParentNode[0]?.CERT_USERKEY) return updatedOriginalParentNode[0];
                        if (!prevNode?.id && prevNode?.CERT_ENTITLEMENT_VALUEKEY === "0" && prevNode?.CERT_ROLEKEY === updatedOriginalParentNode[0]?.CERT_ACCOUNTKEY) return updatedOriginalParentNode[0];
                        return prevNode;
                    });
                });
            }, 500);
            setTimeoutIds((prevIds)=>[
                    ...prevIds,
                    mergedListsChangeTimeOutId
                ]);
            return;
        }
        const singleNodeTimeoutId = setTimeout(()=>{
            setMergedLists((prev)=>(0, $31eefeb47866cab8$export$98a1b4835a773956)(prev, actionKind, trackerId, currentState));
        }, 500);
        setTimeoutIds((prevIds)=>[
                ...prevIds,
                singleNodeTimeoutId
            ]);
    };
    /**
   * `useEffect` hook that updates the merged list and side panel actions data
   * when `sidePanelData` changes and the side panel is visible.
   *
   * This effect performs the following actions:
   * 1. Checks if the side panel is visible (`isSidePanelVisible`).
   * 2. If the side panel is visible, it updates the merged list of nodes based on the `trackerId` from `sidePanelData`.
   * 3. Calls `updateNodeWithTrackerId` function to find the node in the merged list that matches the `trackerId`.
   * 4. Sets the actions data for the side panel using `setSidePanelActionsData` with the matching node.
   *
   * Dependencies:
   * - `sidePanelData`: The data associated with the side panel, which includes the tracker ID.
   * - `isSidePanelVisible`: Boolean indicating if the side panel is currently visible.
   *
   * The `useEffect` hook is triggered whenever `sidePanelData` changes.
   */ (0, $hopDi$useEffect)(()=>{
        if (isSidePanelVisible) setMergedLists((prev)=>(0, $31eefeb47866cab8$export$b36e3052e968e5b9)(prev, sidePanelData?.tracker?.id, (matchingNode)=>{
                setSidePanelActionsData(matchingNode);
            }));
    }, [
        sidePanelData
    ]);
    /**
   * Handles the automatic selection of a parent node and updates the side panel and merged lists accordingly.
   *
   * This function performs the following actions:
   * 1. Retrieves tracking and state (selected or unselected action button) information from the `referenceObject`.
   * 2. Determines the hierarchy to search for based on the tracker level.
   * 3. If the side panel is visible and certain conditions are met, it updates the merged list and hierarchy elements.
   * 4. Refreshes merged list based on the updated hierarchy and EIDs.
   * 5. Updates the merged list with new node data and handles various UI updates and side panel actions.
   * 6. Dispatches additional actions based on the current state and action type.
   *
   * @param {Object} referenceObject - Contains tracking information and flags used for processing.
   * @param {Object} nonReferenceObject - Contains additional data for UI updates and actions.
   */ const handleAutoSelectParent = (referenceObject, nonReferenceObject)=>{
        const trackerId = referenceObject?.trackerId;
        const trackerLevel = referenceObject?.trackerLevel;
        const trackerActionKind = referenceObject?.actionKind;
        const trackerCurrentState = referenceObject?.currentState;
        const sidePanelFlags = referenceObject?.flags;
        const hierarchyToFind = (0, $31eefeb47866cab8$export$2bb1953c0044b8fa)(trackerLevel);
        let hierarchyElements;
        let mergedListsForAutoSelect = mergedLists;
        let trackerIdForActions = trackerId;
        // Move to next Tile on action before the data is updated
        if (isSidePanelVisible && sidePanelFlags?.shouldSwitchSidePanel && activeTab.key !== (0, $d44c789d5b60f9bf$export$807a0bc890800408)) handleSidePanelAction(sidePanelFlags?.jumpToSameLevel, ({ updatedLists: updatedLists, nextNode: nextNode })=>{
            mergedListsForAutoSelect = updatedLists;
            trackerIdForActions = nextNode?.tracker?.id;
            hierarchyElements = (0, $e7628c995f405891$export$d3bf36f5a7258ab0)(updatedLists, trackerId, hierarchyToFind);
        });
        else {
            if (activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408)) dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
            hierarchyElements = (0, $e7628c995f405891$export$d3bf36f5a7258ab0)(mergedLists, trackerId, hierarchyToFind);
        }
        const eidsAndKeysMapList = hierarchyElements?.map((flattenedNode)=>{
            const tempObject = {
                isEidAvailable: true,
                valueKey: flattenedNode?.nodeData?.CERT_ENTITLEMENT_VALUEKEY,
                id: flattenedNode?.nodeData?.id
            };
            if (!flattenedNode?.nodeData?.id && flattenedNode?.nodeData?.CERT_ENTITLEMENT_VALUEKEY === "-4") {
                tempObject.isEidAvailable = false;
                tempObject.valueKey = flattenedNode?.nodeData?.CERT_ENTITLEMENT_VALUEKEY;
                tempObject.id = flattenedNode?.nodeData?.CERT_USERKEY;
            }
            if (!flattenedNode?.nodeData?.id && flattenedNode?.nodeData?.CERT_ENTITLEMENT_VALUEKEY === "0") {
                tempObject.isEidAvailable = false;
                tempObject.valueKey = flattenedNode?.nodeData?.CERT_ENTITLEMENT_VALUEKEY;
                tempObject.id = flattenedNode?.nodeData?.CERT_ACCOUNTKEY;
            }
            return tempObject;
        });
        const arrayForEidsToRefresh = eidsAndKeysMapList?.filter((mapObject)=>mapObject?.isEidAvailable)?.map((mapObject)=>mapObject?.id);
        const topmostLevelEid = eidsAndKeysMapList[0]?.id || null;
        dispatch((0, $d623f23401a154f0$export$b6eeabdfc6166e3c)(arrayForEidsToRefresh)).then((responses)=>{
            updateMergedListsForAssociatedNodes(mergedListsForAutoSelect, responses, trackerActionKind, trackerCurrentState, trackerId, topmostLevelEid, arrayForEidsToRefresh, eidsAndKeysMapList);
        }).catch((error)=>{
            setMergedLists((prev)=>(0, $31eefeb47866cab8$export$98a1b4835a773956)(prev, trackerActionKind, trackerId, trackerCurrentState));
            if ((0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN !== trackerActionKind || (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT !== trackerActionKind) dispatch((0, $d623f23401a154f0$export$4012debfa64c5cbf)(true, error.message));
        }).finally(()=>{
            const shouldRunItemsApiFromStart = Boolean(trackerActionKind === (0, $20281fe09bc700a8$export$3f43cf8434698562).TERMINATE && // If it is terminated action then refresh list in DONE tab
            activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) && !trackerCurrentState) || Boolean(trackerCurrentState && trackerActionKind !== (0, $20281fe09bc700a8$export$3f43cf8434698562).EXTEND_END_DATE && // For all the reset actions - refresh the tab
            trackerActionKind !== (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT && (activeTab.key === (0, $d44c789d5b60f9bf$export$807a0bc890800408) || activeTab.key === (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49) || activeTab.key === (0, $d44c789d5b60f9bf$export$b2766b46106d3053)));
            if (shouldRunItemsApiFromStart) {
                dispatch((0, $d623f23401a154f0$export$ebe6b5ce6ed9ef39)(false));
                setMergedLists([]);
                setCurrentOffset(maximumResults);
                dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, 0, searchText));
            }
            const alertBannerPayload = nonReferenceObject?.alertBannerPayload;
            const tabToHighLightPayload = nonReferenceObject?.tabToHighLightPayload;
            const handleSidePanelActionByState = ()=>{
                if (isSidePanelVisible) setMergedLists((prev)=>(0, $31eefeb47866cab8$export$b36e3052e968e5b9)(prev, trackerIdForActions, (matchingNode)=>{
                        setSidePanelActionsData(matchingNode);
                    }));
            };
            if (trackerCurrentState) handleSidePanelActionByState();
            const finalDispatchActionTimeoutId = setTimeout(()=>{
                // All the actions which need to be performed after the action API is successful
                if (!trackerCurrentState) handleSidePanelActionByState();
                dispatch((0, $d623f23401a154f0$export$afd1b438af1720fe)(certKey, (0, $20281fe09bc700a8$export$3f43cf8434698562).DOES_NOT_WORK_FOR_ME === trackerActionKind || (0, $20281fe09bc700a8$export$3f43cf8434698562).REASSIGN === trackerActionKind || (0, $20281fe09bc700a8$export$3f43cf8434698562).CONSULT === trackerActionKind)); // Get All count only for Reassign action
                // Update the total count
                dispatch((0, $d623f23401a154f0$export$1b5df5f4da3e20b8)());
                if (tabToHighLightPayload?.shouldHighLightTab) dispatch((0, $d623f23401a154f0$export$4fcead6ba6a8c371)(tabToHighLightPayload?.tabToHighLight));
            }, 500);
            setTimeoutIds((prevIds)=>[
                    ...prevIds,
                    finalDispatchActionTimeoutId
                ]);
            // No transition timeout needed for these functions
            if (alertBannerPayload?.shouldShowBanner) dispatch((0, $d623f23401a154f0$export$a80194b4790381a6)(alertBannerPayload?.payload));
            dispatch((0, $d623f23401a154f0$export$6e5b0daaf8d927e4)(certKey, (0, $bf14b63763e2d183$export$4767a28fbd1026ef), true));
        });
    };
    const checkNodePosition = (currentNodeId)=>{
        const nodes = Array.isArray(mergedListsAfterRowFilter) ? mergedListsAfterRowFilter : [
            mergedListsAfterRowFilter
        ];
        const flattenedList = (0, $e7628c995f405891$export$8824054d4a42eac8)(nodes);
        const currentNodeIndex = flattenedList.findIndex((node)=>node?.tracker?.id === currentNodeId);
        const isDisabledUp = currentNodeIndex === 0;
        let isDisabledDown = currentNodeIndex === flattenedList.length - 1;
        if (isMoreDataAvailable) {
            if (currentNodeIndex >= flattenedList.length - 2) {
                isDisabledDown = false;
                dispatch((0, $d623f23401a154f0$export$a7b1b02371ce779a)(false));
                if (currentOffset !== 0) dispatch((0, $d623f23401a154f0$export$fad033acbe739b9c)(certKey, columnNames, maximumResults, currentOffset, searchText));
                setCurrentOffset((prevOffset)=>prevOffset + maximumResults);
                setListApiCallCount((prev)=>prev - 1);
            }
        }
        return {
            isDisabledUp: isDisabledUp,
            isDisabledDown: isDisabledDown
        };
    };
    return /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$AlertBannerProvider), {
        className: alertWrapperClasses,
        children: /*#__PURE__*/ (0, $hopDi$jsxs)("div", {
            className: pageClasses,
            "data-testid": "cert-details",
            ref: certPageRef,
            children: [
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
                    className: "CertificationDetails-esCheckFailModal",
                    kind: "critical",
                    alertTitle: "Loading Failed",
                    alertSubtitle: "Sorry, we encountered some troubles loading the data.",
                    onClose: ()=>{},
                    isOpen: isErrorModalOpen,
                    primaryButton: null,
                    secondaryButton: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Button), {
                        type: "button",
                        kind: "outlined",
                        size: "medium",
                        isEnabled: true,
                        onClick: onBackClick,
                        children: "Go Back"
                    })
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $987dc9af54194992$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $6c53f4b34b441c38$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $2c4c83dadce0c268$export$2e2bcd8739ae039), {
                    showFilterBar: showFilterBar,
                    setShowFilterBar: setShowFilterBar,
                    setShowSaviCompanion: setShowSaviCompanion,
                    showSaviCompanionButtonPopup: showSaviCompanionButtonPopup,
                    setShowSaviCompanionButtonPopup: setShowSaviCompanionButtonPopup,
                    filterBarRef: filterBarRef,
                    controlsRef: controlsRef,
                    filters: filters,
                    setFilters: setFilters,
                    setIsDraggingDndItem: setIsDraggingDndItem
                }),
                isSaviEnabled && showSavCompanion && !objectForRedirectLink?.consulteeLoggedIn && /*#__PURE__*/ (0, $hopDi$jsx)((0, $e40ef6d119a5d30a$export$2e2bcd8739ae039), {
                    certKey: certKey,
                    showSavCompanion: showSavCompanion,
                    setShowSaviCompanion: showHideSaviCompanion
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $deb4d0ab4728ac1f$export$2e2bcd8739ae039), {
                    isMoreDataAvailable: isMoreDataAvailable,
                    setIsMoreDataAvailable: setIsMoreDataAvailable,
                    showFilterBar: showFilterBar,
                    detailsListRef: detailsListRef,
                    setSidePanelData: setSidePanelData,
                    mergedLists: mergedLists,
                    setMergedLists: setMergedLists,
                    currentOffset: currentOffset,
                    setCurrentOffset: setCurrentOffset,
                    mergedListsAfterRowFilter: mergedListsAfterRowFilter,
                    setMergedListsAfterRowFilter: setMergedListsAfterRowFilter,
                    listApiCallCount: listApiCallCount,
                    setListApiCallCount: setListApiCallCount,
                    handleAutoSelectParent: handleAutoSelectParent
                }),
                isSidePanelVisible && /*#__PURE__*/ (0, $hopDi$jsx)((0, $37b43aaf389f3f5d$export$2e2bcd8739ae039), {
                    data: sidePanelData,
                    actionsData: sidePanelActionsData,
                    handleAutoSelectParent: handleAutoSelectParent,
                    handleSidePanelTileButton: handleSidePanelTileButton,
                    handleSidePanelBreadCrumbAction: handleSidePanelBreadCrumbAction,
                    checkNodePosition: checkNodePosition,
                    isOpen: isSidePanelVisible,
                    setMergedLists: setMergedLists
                }),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $51ca153ebce16509$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Box), {
                    className: !isPotrait ? "CertificationDetails-whiteOverlay" : "",
                    children: isPotraitModalOpen && /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$ModalIsland), {
                        onClose: ()=>setIsPotraitModalOpen(false),
                        isOpen: isPotraitModalOpen,
                        className: "CertificationDetails-landscapeModal",
                        overlayBackgroundColor: "#8691a4",
                        contentBody: /*#__PURE__*/ (0, $hopDi$jsxs)((0, $hopDi$Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$lottiereact), {
                                    className: "CertificationDetails-landscapeModalIcon",
                                    animationData: (0, (/*@__PURE__*/$parcel$interopDefault($f8655c22d1282573$exports)))
                                }),
                                /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Typography), {
                                    kind: "body1",
                                    desktop: "body1-d",
                                    mobile: "body1-d",
                                    className: "CertificationDetails-landscapeModalText",
                                    children: "For better experience, please switch to portrait mode."
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
var $7d04cd0c9db22b5a$export$2e2bcd8739ae039 = $7d04cd0c9db22b5a$var$CertificationDetails;


function $25630133a83ede0d$var$Routes() {
    const allowedRoutes = {
        staticRoutes: [],
        dynamicRoutes: []
    };
    (0, $hopDi$useEffect)(()=>{
        (0, $8420256091f3759b$export$9bc070677037150b)();
        (0, $8420256091f3759b$export$2e2bcd8739ae039)();
        return ()=>(0, $hopDi$removeClassesForHidingElements)();
    }, []);
    const certGen2Flag = window.localStorage.getItem("certGen2Flag");
    if (certGen2Flag === "0") allowedRoutes.staticRoutes = [];
    else if (certGen2Flag === "1") allowedRoutes.staticRoutes = [
        "/certification/usermanagement"
    ];
    return /*#__PURE__*/ (0, $hopDi$jsx)("div", {
        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $4b5d3b67c109436c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$OverlayProviderWrapper), {
                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Suspense), {
                    fallback: ()=>{},
                    children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$BrowserRouter), {
                        basename: "/ECMv6",
                        children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Route404), {
                            routes: allowedRoutes,
                            render: (path)=>/*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Global404Certs), {
                                    path: path
                                }),
                            children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Switch), {
                                children: /*#__PURE__*/ (0, $hopDi$jsx)((0, $hopDi$Route), {
                                    exact: true,
                                    path: "/certification/usermanagement",
                                    component: (0, $7d04cd0c9db22b5a$export$2e2bcd8739ae039)
                                })
                            })
                        })
                    })
                }, "Certs")
            })
        })
    });
}
var $25630133a83ede0d$export$2e2bcd8739ae039 = $25630133a83ede0d$var$Routes;





const $c7a299b42c530c44$var$INITIAL_STATE = {
    mediaQueryValue: 0,
    isTouchEnabled: false,
    timeZone: "",
    globalDateFormat: "MMM dd, yyyy",
    certKey: null,
    certDetailsLists: null,
    totalItems: 0,
    isLoading: true,
    isRefreshSuccess: false,
    error: null,
    isError: false,
    // TODO: @Vishnu, These default messages are requirment from UX for when the backend does not supply a message. Bring them back after you flag update
    // criticalAlertMessage: {
    //   title: 'Network Error',
    //   description:
    //     'Something went wrong due to a problem with the network. Try refreshing your page.',
    //   colorTheme: 'Critical',
    // },
    criticalAlertMessage: {
        title: null,
        description: null,
        colorTheme: "Critical"
    },
    isViewApiError: false,
    isViewApiLoading: false,
    isTrustScoreEnabled: false,
    objectForRedirectLink: {},
    campaignKey: null,
    isAuditor: true,
    columnPickerList: null,
    columnLabelKeys: null,
    certDetailsView: null,
    certificationName: null,
    isColPickerwApiLoading: false,
    viewColumnsList: null,
    columnNames: null,
    searchText: "",
    customFilters: {},
    certsFilters: null,
    rowsFilters: null,
    viewRowsList: null,
    colsFilters: null,
    advancedFilters: null,
    triggerClearBtnForFilters: false,
    triggerClearBtnForSearch: null,
    triggerClearBtnForHierarchy: null,
    isTriggeredFromSearchOrFilter: false,
    accessRequestHistory: {
        isOpen: false,
        isLoading: true,
        arsTaskPayload: null,
        arsData: null,
        isError: false,
        error: null
    },
    bulkAction: {
        isBulkActionEnabled: false,
        isActionBySelectAll: false,
        isChecked: false,
        isIndeterminate: false,
        isDisabled: true,
        isSelecting: false,
        isAtleastOneSelected: false,
        isBulkFooterVisible: false,
        bulkFooterInfo: null,
        alert: {
            isAlert: false,
            alertText: null
        },
        isSubmittingAction: false,
        isBulkActionsCompleted: false
    },
    tabs: {
        tabData: [
            {
                key: (0, $d44c789d5b60f9bf$export$48ae29ec3f91ef49),
                count: 0,
                label: "To Do",
                isActive: true,
                isHighlighted: false
            },
            {
                key: (0, $d44c789d5b60f9bf$export$807a0bc890800408),
                count: 0,
                label: "Done",
                isActive: false,
                isHighlighted: false
            },
            {
                key: (0, $d44c789d5b60f9bf$export$b2766b46106d3053),
                count: 0,
                label: "Consulted",
                isActive: false,
                isHighlighted: false
            },
            {
                key: (0, $d44c789d5b60f9bf$export$d5eea126dff5a615),
                count: 0,
                label: "All",
                isActive: false,
                isHighlighted: false
            }
        ],
        isDisabled: false,
        isLoading: false,
        isError: false,
        errorMessage: false,
        highlightTabName: null
    },
    shouldShowReviewAndSubmitButton: false,
    reviewAndSubmit: {
        primaryCertifier: true,
        primaryCertifierName: "",
        withESignature: false,
        isCommentEnabled: false,
        enableloginSignature: "",
        noOfTries: "",
        userAttribute: "",
        step1Data: {},
        step2Data: {
            predefComments: []
        }
    },
    isLoadingReviewAndSubmit: true,
    isSubmittingReviewAndSubmit: false,
    reviewAndSubmitError: false,
    isSidePanelVisible: false,
    isSidePanelLoading: false,
    isSidePanelError: false,
    sidePanelUsers: {
        summary: null,
        history: {
            employment: null,
            audit: null
        }
    },
    sidePanelRoles: {
        summary: null,
        history: {
            access: null,
            audit: null
        },
        entitlements: null,
        children: null
    },
    action: {
        isVerifyParentLoading: false,
        isAtLeastThreeActions: false,
        verifyParentMap: [],
        isActionLoading: false,
        isActionSuccess: false,
        isActionModalOpen: false,
        // TODO: @Jacob, Maybe refator or remove this based on current usage
        isActionError: false,
        errorMessage: null,
        // TODO: @Jacob, END
        userKey: null,
        buttonActionType: null
    },
    enableComments: {
        users: [],
        accEntRole: []
    },
    sidePanelAccounts: {
        summary: null,
        history: {
            access: null,
            audit: null
        }
    },
    sidePanelEntitlements: {
        summary: null,
        history: {
            access: null,
            audit: null
        },
        sod: null,
        privileges: null,
        children: null,
        dependents: null
    },
    progressBreakdowndetails: {
        byTypeDetails: null,
        byDecisionDetails: null,
        isLoading: false,
        errorMessage: null,
        initialLoadError: false
    },
    dynamicSortFilter: {
        sortDirection: null,
        sortByColumn: null
    },
    consultActionAssignee: {
        assigneeList: [],
        isLoading: true,
        errorMessage: null
    },
    reassignConfigMap: null,
    isPopoverUserReassignMsgShown: false,
    isWarnModalReassignShown: false,
    certificationStartDate: null,
    certificationEndDate: null,
    autoRevokeWarningList: [],
    isSaviApplied: null,
    saviCompanionDetails: {
        showIntro: false,
        isSaviEnabled: false,
        statusDetails: {
            smartActionDetails: {}
        }
    },
    isSmartApplied: null,
    smartFiltersMeta: {},
    appliedSaviFilters: {
        smartFilter: "",
        actionFilters: []
    },
    personalization: {
        status: "",
        updatePersonalizatonApiStatus: "",
        viewOption: {},
        clearCurrentPersonalization: false,
        isDefaultTriggeredByUser: false,
        personalizationAll: {
            advancedFilters: null,
            rows: null,
            columns: null
        }
    },
    certsExport: {
        applyFilter: false,
        columnsToExport: {},
        certsExportStatus: {
            exportStatus: "",
            timeStamp: 0
        },
        certsDetailsAllCount: null
    },
    isCertificationActionable: false,
    clearSmartFilters: false,
    clearAllFilters: false,
    clearSaviActionsFilter: false,
    isTriggeredFromSaviApplyActions: false,
    predefinedComments: {}
};
// eslint-disable-next-line default-param-last
const $c7a299b42c530c44$var$certificationDetailsReducer = (state = $c7a299b42c530c44$var$INITIAL_STATE, action)=>{
    switch(action?.type){
        case 0, $d6d78fc758ee4148$export$d91439ca0ce56f8:
            return {
                ...state,
                mediaQueryValue: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$e4d3b0aade0c82d6:
            return {
                ...state,
                isTouchEnabled: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$47b2e1637ffaf40d:
            return {
                ...state,
                globalDateFormat: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$40d3ad20c39fea4a:
            return {
                ...state,
                objectForRedirectLink: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$804adfb6022843d9:
            return {
                ...state,
                timeZone: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$12cd07f9e71f98b:
            return {
                ...state,
                triggerClearBtnForSearch: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$8a89d25d4ad8783e:
            return {
                ...state,
                triggerClearBtnForFilters: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$cea4a00589b4b78b:
            return {
                ...state,
                triggerClearBtnForHierarchy: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$8c4d8141d3ba5d38:
            return {
                ...state,
                advancedFilters: action?.payload?.results
            };
        case 0, $d6d78fc758ee4148$export$edbbcf29e994507a:
            return {
                ...state,
                isTrustScoreEnabled: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$e87c818aed68e8cb:
            return {
                ...state,
                accessRequestHistory: {
                    ...state.accessRequestHistory,
                    ...action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$7a8caab59b607807:
            return {
                ...state,
                accessRequestHistory: {
                    ...state.accessRequestHistory,
                    isLoading: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$8671c3354e9690ea:
            return {
                ...state,
                accessRequestHistory: {
                    ...state.accessRequestHistory,
                    ...action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$dcc76e3383a21811:
            return {
                ...state,
                accessRequestHistory: {
                    ...state.accessRequestHistory,
                    arsData: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$afe1eb1cba0072ef:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isActionBySelectAll: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$b0c18ac3058b419e:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isBulkActionEnabled: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$bfbc1bdccfb4abf5:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isChecked: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$768f00e6b30d478:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isBulkFooterVisible: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$2d1f20523798a1b7:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    bulkFooterInfo: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$69729db10395ff90:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isIndeterminate: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$60473f3971dee5df:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isDisabled: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$2890f4c8d2907863:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isSelecting: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$42cd2e4c8af9ab41:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isAtleastOneSelected: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$98054ce8e1cd6185:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    alert: {
                        isAlert: action?.payload?.isAlert,
                        alertText: action?.payload?.alertText
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$c19826a63dd39ec7:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isSubmittingAction: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$a1d03b0ccb874026:
            return {
                ...state,
                bulkAction: {
                    ...state.bulkAction,
                    isBulkActionsCompleted: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$84719c80a3de3402:
            return {
                ...state,
                totalItems: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$f3d779ad78275d3b:
            return {
                ...state,
                certDetailsLists: action?.payload?.results,
                totalItems: action?.payload?.total,
                searchText: action?.payload?.searchText,
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$51750fb5a6bddff5:
            return {
                ...state,
                isAuditor: action?.payload?.isAuditor,
                bulkAction: {
                    ...state.bulkAction,
                    isDisabled: action?.payload?.isAuditor
                }
            };
        case 0, $d6d78fc758ee4148$export$855d326a33362542:
            return {
                ...state,
                viewColumnsList: action?.payload?.columnList
            };
        case 0, $d6d78fc758ee4148$export$f8b68a93cd1396c:
            return {
                ...state,
                viewRowsList: action?.payload?.rowsList
            };
        case 0, $d6d78fc758ee4148$export$9f85bed13d6d6867:
            return {
                ...state,
                columnPickerList: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$2e66e5f4c45faa57:
            return {
                ...state,
                columnLabelKeys: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$7ce0be7ec08b7bd9:
            return {
                ...state,
                campaignKey: action?.payload?.campaignKey
            };
        case 0, $d6d78fc758ee4148$export$dd0462c52301fb4d:
            return {
                ...state,
                certificationName: action?.payload?.certification_name
            };
        case 0, $d6d78fc758ee4148$export$5e310ea02d328fb1:
            return {
                ...state,
                certificationStartDate: action?.payload?.certification_start_date
            };
        case 0, $d6d78fc758ee4148$export$f3fb9edd8ce133a:
            return {
                ...state,
                certificationEndDate: action?.payload?.certification_end_date
            };
        case 0, $d6d78fc758ee4148$export$4bef839f3f67fcf6:
            return {
                ...state,
                autoRevokeWarningList: action?.payload?.certification_auto_revoke_list
            };
        case 0, $d6d78fc758ee4148$export$740ea107ca859e41:
            return {
                ...state,
                certKey: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$f0d808954e0679c6:
            return {
                ...state,
                isLoading: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$3fb13be2b9b8a4c9:
            return {
                ...state,
                isRefreshSuccess: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$e560b62bb0ef76ae:
            return {
                ...state,
                isViewApiLoading: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$3b55c5d9f617705a:
            return {
                ...state,
                isColPickerwApiLoading: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$be9207d1796cf80:
            return {
                ...state,
                isError: action?.payload?.isError,
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$1aaf381820aaad35:
            return {
                ...state,
                isViewApiError: action?.payload?.isError
            };
        case 0, $d6d78fc758ee4148$export$20c37c78e4076fd7:
            return {
                ...state,
                isSidePanelVisible: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$903196cd760f40e2:
            return {
                ...state,
                isTriggeredFromSearchOrFilter: action?.payload
            };
        // Certs Tab Selections (set and get)
        case 0, $d6d78fc758ee4148$export$41e9b850f4b31bd:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    tabData: action?.payload?.results
                }
            };
        case 0, $d6d78fc758ee4148$export$3db41bfbe846115:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    highlightTabName: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$c030357f73041b8:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    isDisabled: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$bcfd799e4df08939:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    isLoading: true,
                    isError: false,
                    errorMessage: null
                }
            };
        case 0, $d6d78fc758ee4148$export$8b461e828675fe2:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    isLoading: false,
                    isError: true,
                    errorMessage: action.payload.error
                }
            };
        case 0, $d6d78fc758ee4148$export$b61e16101d4e3f64:
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    isLoading: false,
                    isError: false,
                    errorMessage: null,
                    tabData: state.tabs.tabData.map((tab)=>tab.key === action.payload.tab ? {
                            ...tab,
                            count: action.payload.count
                        } : tab)
                }
            };
        case 0, $d6d78fc758ee4148$export$1b59f0ddd56aa357:
            return {
                ...state,
                shouldShowReviewAndSubmitButton: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$1d889ec5a0bd35b5:
            return {
                ...state,
                isLoadingReviewAndSubmit: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$8fa9055a97f67430:
            return {
                ...state,
                isSubmittingReviewAndSubmit: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$32524a0d8ac0b191:
            return {
                ...state,
                reviewAndSubmitError: action?.payload?.isError,
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$6375a4b78a6ebe:
            return {
                ...state,
                reviewAndSubmit: {
                    ...state.reviewAndSubmit,
                    ...action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$b1c80b328234b28e:
            return {
                ...state,
                reviewAndSubmit: {
                    ...state.reviewAndSubmit,
                    step1Data: {
                        ...state.reviewAndSubmit.step1Data,
                        ...action?.payload?.results
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$67aafc85739b867b:
            return {
                ...state,
                customFilters: {
                    ...state.customFilters,
                    actionfilter: action?.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$d954cd82d0ab56d0:
            return {
                ...state,
                certsFilters: action?.payload?.results
            };
        case 0, $d6d78fc758ee4148$export$af468c26aae4b8fa:
            return {
                ...state,
                rowsFilters: action?.payload?.results
            };
        case 0, $d6d78fc758ee4148$export$9d483e8c06e94386:
            return {
                ...state,
                colsFilters: action?.payload?.results
            };
        case 0, $d6d78fc758ee4148$export$3f218b7834ef2f49:
            return {
                ...state,
                columnNames: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$1b7cff865d967245:
            return {
                ...state,
                isSidePanelError: action?.payload?.isSidePanelError,
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$9a3ca9b6c1caafdf:
            return {
                ...state,
                isSidePanelLoading: action?.payload
            };
        case 0, $d6d78fc758ee4148$export$44cea83c7eb86289:
            return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    summary: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$a252b37c42fd39c0:
            return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    history: {
                        ...state.sidePanelEntitlements.history,
                        audit: action?.payload?.results
                    }
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$46e200503484c25f:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    sod: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    sod: {
                        ...state.sidePanelEntitlements.sod,
                        risks: [
                            ...state.sidePanelEntitlements.sod.risks,
                            ...action.payload.results
                        ]
                    }
                },
                error: action?.payload?.error
            };
            return state;
        case 0, $d6d78fc758ee4148$export$a71fe6648e4ae608:
            return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    privileges: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$842ba02ccf54b42b:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    children: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    children: {
                        ...state.sidePanelEntitlements.children,
                        childEntList: [
                            ...state.sidePanelEntitlements.children.childEntList,
                            ...action.payload.results
                        ]
                    }
                },
                error: action?.payload?.error
            };
            return state;
        case 0, $d6d78fc758ee4148$export$e5cfbc544f1684eb:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    dependents: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelEntitlements: {
                    ...state.sidePanelEntitlements,
                    dependents: {
                        ...state.sidePanelEntitlements.dependents,
                        mappedEntList: [
                            ...state.sidePanelEntitlements.dependents.mappedEntList,
                            ...action.payload.results
                        ]
                    }
                },
                error: action?.payload?.error
            };
            return state;
        case 0, $d6d78fc758ee4148$export$b98808434921fbb1:
            return {
                ...state,
                sidePanelAccounts: {
                    ...state.sidePanelAccounts,
                    summary: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$7f0539351068ca18:
            return {
                ...state,
                sidePanelAccounts: {
                    ...state.sidePanelAccounts,
                    history: {
                        ...state.sidePanelAccounts.history,
                        audit: action?.payload?.results
                    }
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$a7a89423fc1f2d99:
            return {
                ...state,
                sidePanelUsers: {
                    ...state.sidePanelUsers,
                    summary: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$e6ae9922b78d19ee:
            return {
                ...state,
                sidePanelUsers: {
                    ...state.sidePanelUsers,
                    history: {
                        ...state.sidePanelUsers.history,
                        audit: action?.payload?.results
                    }
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$85fb16097b911:
            return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    summary: action?.payload?.results
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$b0fdc72ce6a50d97:
            return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    history: {
                        ...state.sidePanelRoles.history,
                        audit: action?.payload?.results
                    }
                },
                error: action?.payload?.error
            };
        case 0, $d6d78fc758ee4148$export$940b9d07f90752d:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    entitlements: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    entitlements: {
                        ...state.sidePanelRoles.entitlements,
                        roleEntList: [
                            ...state.sidePanelRoles.entitlements.roleEntList,
                            ...action.payload.results
                        ]
                    }
                }
            };
            return state;
        case 0, $d6d78fc758ee4148$export$d4c8fbbc4fca0999:
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$95aee1eca5275acc)) return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    children: action?.payload?.results
                },
                error: action?.payload?.error
            };
            if (action?.loadMoreStatus === (0, $d6d78fc758ee4148$export$2e6684ed5543ad11)) return {
                ...state,
                sidePanelRoles: {
                    ...state.sidePanelRoles,
                    children: {
                        ...state.sidePanelRoles.children,
                        childRoleList: [
                            ...state.sidePanelRoles.children.childRoleList,
                            ...action.payload.results
                        ]
                    }
                }
            };
            return state;
        case 0, $d6d78fc758ee4148$export$8ca82b86b34f725b:
            return {
                ...state,
                action: {
                    ...state.action,
                    isActionLoading: true,
                    isActionSuccess: false,
                    isActionError: false,
                    errorMessage: null,
                    buttonActionType: action.payload ? action.payload : null
                }
            };
        case 0, $d6d78fc758ee4148$export$b3c7c737b53ea33e:
            return {
                ...state,
                action: {
                    ...state.action,
                    isActionLoading: false,
                    isActionSuccess: true,
                    isActionError: false,
                    errorMessage: null
                }
            };
        case 0, $d6d78fc758ee4148$export$3564fc123aed043c:
            return {
                ...state,
                action: {
                    ...state.action,
                    isActionLoading: false,
                    isActionSuccess: false,
                    isActionError: false,
                    errorMessage: null,
                    buttonActionType: null
                }
            };
        case 0, $d6d78fc758ee4148$export$5755ae8e491f730:
            return {
                ...state,
                // TODO: Make these acti dynamic using payload
                criticalAlertMessage: {
                    title: "Network Error",
                    description: "Something went wrong. Please try again.",
                    colorTheme: "Critical"
                },
                action: {
                    ...state.action,
                    isActionLoading: false,
                    isActionSuccess: false,
                    isActionError: true,
                    errorMessage: action.payload.error,
                    buttonActionType: null
                }
            };
        case 0, $d6d78fc758ee4148$export$e8fdce46a9e3e027:
            return {
                ...state,
                action: {
                    ...state.action,
                    isActionModalOpen: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$9130d79ae651148:
            return {
                ...state,
                action: {
                    ...state.action,
                    isAtLeastThreeActions: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$64fa42aee49aa7c3:
            return {
                ...state,
                action: {
                    ...state.action,
                    isVerifyParentLoading: action.payload.isLoading
                }
            };
        case 0, $d6d78fc758ee4148$export$738bb6c8834cc24b:
            return {
                ...state,
                action: {
                    ...state.action,
                    isVerifyParentLoading: false,
                    verifyParentMap: action.payload.data
                }
            };
        case 0, $d6d78fc758ee4148$export$3c40ab84ee726c27:
            return {
                ...state,
                criticalAlertMessage: {
                    title: "Verification Failed",
                    description: "The parent of this access item could not be verified. Try again.",
                    colorTheme: "Critical"
                },
                action: {
                    ...state.action,
                    isVerifyParentLoading: false,
                    isActionLoading: false,
                    isActionSuccess: false,
                    isActionError: true,
                    errorMessage: action.payload.error,
                    buttonActionType: null
                }
            };
        case 0, $d6d78fc758ee4148$export$f66f20183ec2a996:
            return {
                ...state,
                criticalAlertMessage: {
                    title: action.payload.title,
                    description: action.payload.description,
                    colorTheme: "Success"
                }
            };
        case 0, $d6d78fc758ee4148$export$87218027c7ad9093:
            return {
                ...state,
                enableComments: {
                    users: action.payload.enableIndividualCommentsForUsers,
                    accEntRole: action.payload.enableIndividualCommentsForAccountEntitlementRoles
                }
            };
        case 0, $d6d78fc758ee4148$export$f7b4124f0c0fddd2:
            return {
                ...state,
                configMap: action?.payload?.configMap
            };
        case 0, $d6d78fc758ee4148$export$a8aa77f63d5aad19:
            return {
                ...state,
                enableIndividualCommentsForUsers: action?.payload?.enableIndividualCommentsForUsers
            };
        case 0, $d6d78fc758ee4148$export$b77c91b145bf9647:
            if (action.payload.groupByType === (0, $bf14b63763e2d183$export$4767a28fbd1026ef)) return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    byDecisionDetails: action.payload.data,
                    errorMessage: null
                }
            };
            if (action.payload.groupByType === (0, $bf14b63763e2d183$export$14ae8ea77646ac77)) return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    byTypeDetails: action.payload.data,
                    errorMessage: null
                }
            };
            return state;
        case 0, $d6d78fc758ee4148$export$5296abadcbacb235:
            if (action.payload) return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    isLoading: action.payload,
                    errorMessage: null,
                    initialLoadError: false
                }
            };
            return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    isLoading: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$569cf9037aa74da:
            return {
                ...state,
                progressBreakdowndetails: {
                    ...state.progressBreakdowndetails,
                    errorMessage: action.payload.initialLoad ? null : action.payload.error,
                    initialLoadError: !!action.payload.initialLoad
                }
            };
        case 0, $d6d78fc758ee4148$export$e7b0a9aed86b0918:
            return {
                ...state,
                dynamicSortFilter: {
                    ...state.dynamicSortFilter,
                    sortDirection: action.payload.sortDirection,
                    sortByColumn: action.payload.columnName
                }
            };
        case 0, $d6d78fc758ee4148$export$8810396661da9a69:
            return {
                ...state,
                dynamicSortFilter: {
                    ...state.dynamicSortFilter,
                    sortDirection: null,
                    sortByColumn: null
                }
            };
        case 0, $d6d78fc758ee4148$export$97d842f50b1d9083:
            return {
                ...state,
                consultActionAssignee: {
                    ...state.consultActionAssignee,
                    assigneeList: action.payload.data,
                    errorMessage: null
                }
            };
        case 0, $d6d78fc758ee4148$export$c3fe830879e37a3d:
            return {
                ...state,
                consultActionAssignee: {
                    ...state.consultActionAssignee,
                    isLoading: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$d91200b15b0cd8ec:
            return {
                ...state,
                consultActionAssignee: {
                    ...state.consultActionAssignee,
                    errorMessage: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$dd6b8d2bd42778be:
            return {
                ...state,
                reassignConfigMap: action.payload
            };
        case 0, $d6d78fc758ee4148$export$7fbc63266c535cea:
            return {
                ...state,
                isPopoverUserReassignMsgShown: !state.isPopoverUserReassignMsgShown
            };
        case 0, $d6d78fc758ee4148$export$6eb1d8263e7e2d01:
            return {
                ...state,
                isWarnModalReassignShown: !state.isWarnModalReassignShown
            };
        case 0, $d6d78fc758ee4148$export$df3ba5c051a876de:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    statusDetails: {
                        ...state.saviCompanionDetails.statusDetails,
                        loading: true
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$4009fb2303280d3a:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    statusDetails: {
                        ...state.saviCompanionDetails.statusDetails,
                        loading: false,
                        smartActionDetails: {
                            savi_approve: {
                                ...action.payload.savi_approve
                            },
                            savi_revoke: {
                                ...action.payload.savi_revoke
                            }
                        }
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$1e4b8a34c93a7dd0:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    isSaviEnabled: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$a0f86ea1258b795c:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    isApplyActionLoading: true
                }
            };
        case 0, $d6d78fc758ee4148$export$b021d9c474ee48de:
            return {
                ...state,
                saviCompanionDetails: {
                    ...state.saviCompanionDetails,
                    statusDetails: {},
                    isApplyActionLoading: false
                }
            };
        case 0, $d6d78fc758ee4148$export$58ccb446f68b9f12:
            return {
                ...state,
                smartFiltersMeta: {
                    ...action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$55cfff3090f887bb:
            return {
                ...state,
                appliedSaviFilters: {
                    ...state.appliedSaviFilters,
                    smartFilter: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$ff736dce437d4f45:
            return {
                ...state,
                appliedSaviFilters: {
                    ...state.appliedSaviFilters,
                    actionFilters: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$16e0d1398b26a1e2:
            return {
                ...state,
                personalization: {
                    ...state.personalization,
                    status: action.payload.status
                }
            };
        case 0, $d6d78fc758ee4148$export$878cfd23fc23c300:
            return {
                ...state,
                personalization: {
                    ...state.personalization,
                    personalizedData: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$4907f9a8e1f94d67:
            return {
                ...state,
                personalization: {
                    ...state.personalization,
                    updatePersonalizatonApiStatus: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$24686dd5be2846fd:
            return {
                ...state,
                personalization: {
                    ...state.personalization,
                    isDefaultTriggeredByUser: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$c51bf664ca9c6b15:
            return {
                ...state,
                personalization: {
                    ...state.personalization,
                    viewOption: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$e5f04d968a3f4885:
            return {
                ...state,
                personalization: {
                    ...state.personalization,
                    clearCurrentPersonalization: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$40b13b5dcefcbafd:
            return {
                ...state,
                personalization: {
                    ...state.personalization,
                    personalizationAll: {
                        ...state.personalization.personalizationAll,
                        ...action.payload
                    }
                }
            };
        case 0, $d6d78fc758ee4148$export$334e0072fdfb95ed:
            return {
                ...state,
                isCertificationActionable: action.payload
            };
        case 0, $d6d78fc758ee4148$export$7955a070d3ebcb88:
            return {
                ...state,
                clearSmartFilters: action.payload
            };
        case 0, $d6d78fc758ee4148$export$12b8b0c2680dfdd3:
            return {
                ...state,
                clearAllFilters: action.payload
            };
        case 0, $d6d78fc758ee4148$export$4ab9d0b6e0a2e2b:
            return {
                ...state,
                certsExport: {
                    ...state.certsExport,
                    certsExportStatus: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$9f1b82a3dd944b0e:
            return {
                ...state,
                certsExport: {
                    ...state.certsExport,
                    applyFilter: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$384e10a5fce8f786:
            return {
                ...state,
                certsExport: {
                    ...state.certsExport,
                    columnsToExport: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$4102f51782d2b340:
            return {
                ...state,
                certsExport: {
                    ...state.certsExport,
                    certsDetailsAllCount: action.payload
                }
            };
        case 0, $d6d78fc758ee4148$export$bc0e04975792fb52:
            return {
                ...state,
                clearSaviActionsFilter: action.payload
            };
        case 0, $d6d78fc758ee4148$export$25054d4d5db33a66:
            return {
                ...state,
                isTriggeredFromSaviApplyActions: action.payload
            };
        case 0, $d6d78fc758ee4148$export$6932187838de83d9:
            return {
                ...state,
                isSaviApplied: action.payload
            };
        case 0, $d6d78fc758ee4148$export$8ced494098659b02:
            return {
                ...state,
                isSmartApplied: action.payload
            };
        case 0, $d6d78fc758ee4148$export$550c586b0cc3ded0:
            return {
                ...state,
                predefinedComments: {
                    ...state.predefinedComments,
                    [action.payload.action]: action.payload.comments
                }
            };
        default:
            return state;
    }
};
var $c7a299b42c530c44$export$2e2bcd8739ae039 = $c7a299b42c530c44$var$certificationDetailsReducer;


var $66056242d625951a$export$2e2bcd8739ae039 = (0, $c7a299b42c530c44$export$2e2bcd8739ae039);


var $851643787bf2f777$export$2e2bcd8739ae039 = (0, $66056242d625951a$export$2e2bcd8739ae039);




export {$25630133a83ede0d$export$2e2bcd8739ae039 as CertsRoutes, $851643787bf2f777$export$2e2bcd8739ae039 as certsReducer};
//# sourceMappingURL=module.js.map
